var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const customEvents = {
  cartDrawer: {
    upsell: {
      dropdownChanged: "upsell:variantChange"
    }
  }
};
function hideHeader() {
  if (!!document.querySelectorAll(".page-section")) {
    let pageSections = document.querySelectorAll(".page-section");
    pageSections.forEach((page) => {
      if (!!page.getAttribute("data-hide-header")) {
        let shouldShow = page.getAttribute("data-hide-header");
        console.log(shouldShow);
        if (shouldShow === false || shouldShow === "false") {
          if (!!document.querySelector("store-header")) {
            let headerElement = document.querySelector("store-header");
            headerElement.style.display = "none";
          }
        }
      }
    });
  }
}
function changeIconWidth() {
  if (!!document.querySelectorAll(".text_content--usp")) {
    let calculateWidth = 0;
    let contentUsp = document.querySelectorAll(".text_content--usp");
    if (contentUsp.length == 3) {
      contentUsp.forEach((e) => {
        e.classList.add("text_content--full");
      });
      calculateWidth = 100 / contentUsp.length;
    } else if (contentUsp.length > 3) {
      calculateWidth = 50;
    } else {
      calculateWidth = 100 / contentUsp.length;
    }
    contentUsp.forEach((icon) => {
      icon.style.width = calculateWidth + "%";
    });
  }
}
document.addEventListener("DOMContentLoaded", function(e) {
  hideHeader();
  changeIconWidth();
});
function removeTextReview() {
  document.querySelectorAll(".product-item").forEach(function(el) {
    setTimeout(function() {
      if (!!el && !!el.querySelector(".ruk-rating-snippet-count")) {
        let reviewsCount = el.querySelector(".ruk-rating-snippet-count");
        const matchNumber = reviewsCount.innerHTML.match(/\d+/);
        if (matchNumber) {
          if (el.classList.contains("ds-product-item")) {
            reviewsCount.innerHTML = `${matchNumber[0]}`;
          } else {
            reviewsCount.innerHTML = `(${matchNumber[0]})`;
          }
        } else {
          if (!!matchNumber.input) {
            reviewsCount.innerHTML = matchNumber.input;
          }
        }
      }
    }, 3e3);
  });
}
function setReviewsCounter() {
  setTimeout(function() {
    document.querySelectorAll(".ds-product-item .ruk_rating_snippet").forEach(function(el) {
      const existingSpan = el.nextElementSibling;
      if (existingSpan && existingSpan.classList.contains("ruk-rating-snippet-reviewscouk")) {
        existingSpan.remove();
      }
      let count = el.getAttribute("data-reviewscouk");
      if (!count || count.trim() === "") {
        const ratingCountEl = el.querySelector(".ruk-rating-snippet-count");
        if (ratingCountEl) {
          const matchNumber = ratingCountEl.innerHTML.match(/\d+/);
          if (matchNumber) {
            count = matchNumber[0];
          }
        }
      }
      if (count) {
        let span = document.createElement("span");
        span.className = "ruk-rating-snippet-reviewscouk";
        span.textContent = count;
        el.insertAdjacentElement("afterend", span);
      }
    });
  }, 1e3);
}
function initRatingSnippet() {
  const config = window.ratingSnippetConfig || {
    store: "holy",
    mode: "default",
    color: "#0E1311",
    linebreak: false,
    usePolaris: true,
    showEmptyStars: false
  };
  if (typeof window.ratingSnippet === "function") {
    try {
      window.ratingSnippet("ruk_rating_snippet", config);
    } catch (e) {
      console.error("Error reinitializing ratingSnippet:", e);
    }
  } else {
    if (typeof window.loadScriptOnce === "function") {
      window.loadScriptOnce("https://widget.reviews.io/rating-snippet/dist.js", function() {
        if (typeof window.ratingSnippet === "function") {
          window.ratingSnippet("ruk_rating_snippet", config);
        }
      });
    }
  }
}
function initReviews() {
  setReviewsCounter();
  removeTextReview();
  initRatingSnippet();
}
window.addEventListener("DOMContentLoaded", function(e) {
  initReviews();
});
document.addEventListener("pagination:page-changed", function() {
  setTimeout(function() {
    initReviews();
  }, 1500);
});
async function init$1() {
  var _a;
  const discountCode = (_a = window == null ? void 0 : window.theme) == null ? void 0 : _a.discountApplication;
  const isCookieSet = getCookie("discount_code");
  if (!discountCode || isCookieSet) return;
  setCookie("discount_code", discountCode, 14);
  setDiscountSession(discountCode);
  window.location.reload();
  return;
}
function setDiscountSession(value) {
  sessionStorage.setItem("discount", value ? value : "FALSE");
}
function setCookie(key, value, daysToExpire = 1) {
  const expirationDate = /* @__PURE__ */ new Date();
  expirationDate.setTime(expirationDate.getTime() + daysToExpire * 24 * 60 * 60 * 1e3);
  const expires = "expires=" + expirationDate.toUTCString();
  document.cookie = key + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}
function getCookie(key) {
  const name = key + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    const cookie = cookieArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return "";
}
init$1();
const selectors$8 = {
  itemImages: ".product-item__image-wrapper",
  collectionLinks: ".featured-collections .link-to-collection__featured-collection",
  buttonTabs: ".shopify-section--featured-collections .tabs-nav__item"
};
const buttonTabs = document.querySelectorAll(selectors$8.buttonTabs);
const linksToCollection = document.querySelectorAll(selectors$8.collectionLinks);
function setHeightToLinks() {
  linksToCollection.forEach((link) => {
    const neighboringElement = link.parentNode.childNodes[1].querySelector(selectors$8.itemImages);
    if (neighboringElement) {
      const neighboringElementHeight = neighboringElement.clientHeight;
      link.style.height = `${neighboringElementHeight}px`;
    }
  });
}
if (linksToCollection && buttonTabs) {
  document.addEventListener("DOMContentLoaded", setHeightToLinks);
  window.addEventListener("resize", setHeightToLinks);
  buttonTabs.forEach((button) => {
    button.addEventListener("click", () => {
      setTimeout(() => {
        setHeightToLinks();
      }, 1500);
    });
  });
}
function revealSubCategory(currIdentifier, currIndex) {
  setTimeout(() => {
    if (!!document.querySelectorAll(".category-image")) {
      document.querySelectorAll(".category-image").forEach((img) => {
        img.removeAttribute("reveal");
      });
    }
  }, 500);
  if (!!document.querySelector(".product_categories-content.is-selected")) {
    let selectedIndex = null;
    let selectedCategory = null;
    if (!!currIdentifier) {
      selectedCategory = currIdentifier;
    } else {
      selectedCategory = document.querySelector(".product_categories-content.is-selected").getAttribute("data-selected-category");
    }
    if (!!currIndex) {
      selectedIndex = currIndex;
    } else {
      selectedIndex = document.querySelector(".product_categories-content.is-selected").getAttribute("data-selected-index");
    }
    if (!!document.querySelectorAll(".product-subcategories__wrapper")) {
      let allSubcategories = document.querySelectorAll(".product-subcategories__wrapper");
      allSubcategories.forEach((subcategorie) => {
        if (!!selectedCategory) {
          if (!!subcategorie.getAttribute("data-subcategory-index") && !!subcategorie.getAttribute("data-selected-category")) {
            let subcategorieSelected = subcategorie.getAttribute("data-selected-category");
            let indexSelected = subcategorie.getAttribute("data-subcategory-index");
            if (selectedCategory === subcategorieSelected && selectedIndex == indexSelected) {
              subcategorie.classList.remove("hidden");
            } else {
              subcategorie.classList.add("hidden");
            }
          }
        }
      });
    }
    if (!!document.querySelectorAll(".product_categories-text")) {
      let allCategoriesContent = document.querySelectorAll(".product_categories-text");
      allCategoriesContent.forEach((content) => {
        if (!!selectedCategory) {
          if (!!content.getAttribute("data-selected-category") && !!content.getAttribute("data-selected-index")) {
            let categorieSelected = content.getAttribute("data-selected-category");
            let categorieIndexSelected = content.getAttribute("data-selected-index");
            if (selectedCategory === categorieSelected && selectedIndex == categorieIndexSelected) {
              content.classList.remove("hidden");
            } else {
              content.classList.add("hidden");
            }
          }
        }
      });
    }
    selectedIndex = null;
    selectedCategory = null;
  }
}
document.addEventListener("DOMContentLoaded", function(e) {
  function categoryChange() {
    if (!!document.querySelectorAll(".product-subcategories__wrapper")) {
      let subcategoriesWrapper = document.querySelectorAll(".product-subcategories__wrapper");
      handleElementsLoop(true, subcategoriesWrapper, ".category-buttons-name");
    }
    if (document.querySelectorAll(".category-main-buttons-name")) {
      let categoryMainButtons = document.querySelectorAll(".category-main-buttons-name");
      handleElementsLoop(false, categoryMainButtons);
    }
  }
  function handleElementsLoop(isSub, targetElements, targetClass) {
    if (!!targetElements) {
      targetElements.forEach((targetElement, index) => {
        if (isSub) {
          if (!!targetElement.querySelectorAll(targetClass)) {
            targetElement.querySelectorAll(targetClass).forEach((target) => {
              target.addEventListener("click", function(element) {
                handleElementClick(element, targetElement, index, true);
              });
            });
          }
        } else {
          targetElement.addEventListener("click", function(element) {
            handleElementClick(element, targetElements, index, false);
          });
        }
      });
    }
  }
  let clickedElements = [];
  function handleElementClick(element, category, index, isSub) {
    let currIdentifier = null;
    let prevIdentifier = null;
    let currentTarget = null;
    let previouslyClickedElement = null;
    let currentClickedElement = element.target;
    if (isSub) {
      previouslyClickedElement = currentClickedElement.previousElementSibling ? currentClickedElement.previousElementSibling : currentClickedElement.nextElementSibling;
      if (!!previouslyClickedElement) {
        previouslyClickedElement.classList.remove("is--selected");
        if (!!previouslyClickedElement.getAttribute("data-identifier-button")) {
          prevIdentifier = previouslyClickedElement.getAttribute("data-identifier-button");
        }
      }
      if (!!currentClickedElement) {
        currentClickedElement.classList.add("is--selected");
        if (!!currentClickedElement.getAttribute("data-identifier-button")) {
          currIdentifier = currentClickedElement.getAttribute("data-identifier-button");
        }
      }
      if (!!category && !!prevIdentifier) {
        let prevSubcategoryContent = category.querySelector(`[data-identifier="${prevIdentifier}"]`);
        if (!!prevSubcategoryContent) {
          prevSubcategoryContent.style.opacity = 0;
          prevSubcategoryContent.classList.add("hidden");
        }
      }
      if (!!category && !!currIdentifier) {
        let subcategoryContent = category.querySelector(`[data-identifier="${currIdentifier}"]`);
        if (!!subcategoryContent) {
          subcategoryContent.classList.remove("hidden");
          setTimeout(function() {
            subcategoryContent.style.opacity = 1;
          }, 100);
        }
      }
    } else {
      currentTarget = element.target;
      currentClickedElement = currentTarget;
      let currentIndex = 0;
      if (!!currentClickedElement) {
        currentClickedElement.classList.add("is--selected");
        if (!!currentClickedElement.getAttribute("data-category-name")) {
          currIdentifier = currentClickedElement.getAttribute("data-category-name");
        }
      }
      clickedElements.push(currentClickedElement);
      if (clickedElements.length > 1) {
        previouslyClickedElement = clickedElements[clickedElements.length - 2];
      } else {
        previouslyClickedElement = category[0];
      }
      if (!!previouslyClickedElement) {
        previouslyClickedElement.classList.remove("is--selected");
        if (!!previouslyClickedElement.getAttribute("data-category-name")) {
          prevIdentifier = previouslyClickedElement.getAttribute("data-category-name");
        }
      }
      if (!!prevIdentifier) {
        let prevMainCategoryContent = document.querySelector(`[data-main-category="${prevIdentifier}"]`);
        if (!!prevMainCategoryContent) {
          prevMainCategoryContent.style.opacity = 0;
          setTimeout(function() {
            prevMainCategoryContent.classList.add("hidden");
          }, 100);
        }
      }
      if (!!currIdentifier) {
        let mainCategoryContent = document.querySelector(`[data-main-category="${currIdentifier}"]`);
        if (!!mainCategoryContent) {
          mainCategoryContent.classList.remove("hidden");
          setTimeout(function() {
            mainCategoryContent.style.opacity = 1;
          }, 100);
        }
        if (document.querySelectorAll(".category-main--text").length > 0) {
          document.querySelectorAll(".category-main--text").forEach((el) => {
            el.classList.add("hidden");
            el.classList.remove("category-main-text--selected");
          });
        }
        const textInCurrent = document.querySelector(`.category-main--text[data-selected-category="${currIdentifier}"]`);
        if (textInCurrent) {
          textInCurrent.classList.remove("hidden");
          textInCurrent.classList.add("category-main-text--selected");
        }
      }
      revealSubCategory(currIdentifier, currentIndex);
    }
    currentClickedElement = null;
  }
  categoryChange();
  revealSubCategory();
});
function variantChangePortions(id, available) {
  if (available === false) {
    if (!!document.querySelector(".product-get-it-text")) {
      document.querySelector(".product-get-it-text").style.display = "none";
    }
  } else {
    if (!!document.querySelector(".product-get-it-text")) {
      document.querySelector(".product-get-it-text").style.display = "block";
    }
  }
  if (!!document.querySelector(`.price_label--serving--${id}`)) {
    let dataPortions = document.querySelector(`.price_label--serving--${id}`).getAttribute("data-portions");
    let dataPortionsPrice = document.querySelector(`.price_label--serving--${id}`).getAttribute("data-price-per-serving");
    if (!!document.querySelector(".price_label--serving--portions") && !!dataPortions) {
      document.querySelector(".price_label--serving--portions").innerHTML = dataPortions;
    }
    if (!!document.querySelector(".price_label--serving-price-portions") && !!dataPortionsPrice) {
      document.querySelector(".price_label--serving-price-portions").innerHTML = dataPortionsPrice;
    }
  }
  const variantDataCandidates = document.querySelectorAll(`.portions-price-inline--variant-${id}`);
  const variantData = Array.from(variantDataCandidates).find((el) => !el.closest(".syrup-picker"));
  if (variantData) {
    let dataPortionsLabel = variantData.getAttribute("data-portions-label");
    let dataPricePerServing = variantData.getAttribute("data-price-per-serving");
    let dataOnly = variantData.getAttribute("data-only");
    let dataPerServing = variantData.getAttribute("data-per-serving");
    let portionsElements = Array.from(document.querySelectorAll(".portions-price-inline__portions")).filter((el) => !el.closest(".syrup-picker"));
    let priceElements = Array.from(document.querySelectorAll(".portions-price-inline__price")).filter((el) => !el.closest(".syrup-picker"));
    if (portionsElements.length > 0 && dataPortionsLabel) {
      portionsElements.forEach((el) => {
        el.setAttribute("data-portions-label", dataPortionsLabel);
        el.textContent = dataPortionsLabel;
      });
    }
    if (priceElements.length > 0 && dataPricePerServing) {
      let onlyText = dataOnly || "ONLY";
      let perServingText = dataPerServing || "PER SERVING";
      priceElements.forEach((el) => {
        el.setAttribute("data-only", onlyText);
        el.setAttribute("data-price-per-serving", dataPricePerServing);
        el.setAttribute("data-per-serving", perServingText);
        el.textContent = `${onlyText} ${dataPricePerServing} ${perServingText}`;
      });
    }
  }
}
window.addEventListener("flickity:slide-settled", function(e) {
  if (!!e.target) {
    const computedStyle = window.getComputedStyle(e.target);
    if (computedStyle.opacity != "0") {
      if (!!e.target.getAttribute("data-main-category") && e.target.querySelector(".is-selected")) {
        let mainCategory = e.target.getAttribute("data-main-category");
        let selectedIndex = e.target.querySelector(".is-selected").getAttribute("data-selected-index");
        revealSubCategory(mainCategory, selectedIndex);
      }
    }
  }
});
function changeVariantId(variantId) {
  if (!!document.querySelectorAll(".upsell-main-product")) {
    let upsellMainProduct = document.querySelectorAll(".upsell-main-product");
    upsellMainProduct.forEach((upsell) => {
      upsell.value = variantId;
    });
  }
}
document.addEventListener("variant:changed", function(e) {
  if (!!e.detail) {
    changeVariantId(e.detail.variant.id);
    variantChangePortions(e.detail.variant.id, e.detail.variant.available);
  }
});
document.addEventListener("DOMContentLoaded", function(e) {
  const zoomModal = document.getElementById("zoomModal");
  const modalImg = document.getElementById("zoomImage");
  let subCategorieImage = document.querySelectorAll(".product-subcategories-image__wrapper");
  if (!!subCategorieImage) {
    subCategorieImage.forEach((el) => {
      let imgs = el.querySelectorAll(".product-subcategories-image--zoom");
      imgs.forEach((img) => {
        img.addEventListener("click", function(e2) {
          if (!!zoomModal) {
            zoomModal.style.display = "flex";
          }
          if (!!modalImg) {
            if (!!e2.target.src) {
              modalImg.src = e2.target.src;
            }
            if (!!e2.target.getAttribute("data-src")) {
              modalImg.src = e2.target.getAttribute("data-src");
            }
          }
        });
      });
      if (!!zoomModal) {
        zoomModal.addEventListener("click", function(e2) {
          if (!!modalImg) {
            modalImg.className += " out";
            setTimeout(function() {
              zoomModal.style.display = "none";
              modalImg.className = "modal-content";
            }, 400);
          }
        });
      }
    });
  }
});
window.addEventListener("load", function(e) {
  if (!!document.querySelector(".block-swatch--slider")) {
    setTimeout(() => {
      document.querySelector(".block-swatch--slider").style.opacity = "1";
    }, 500);
  }
});
if (document.getElementById("productCategoriesBtn")) {
  const spoilerBtn = document.getElementById("productCategoriesBtn");
  const categoriesSection = document.querySelector(".shopify-section--product-categories");
  spoilerBtn.addEventListener("click", () => {
    categoriesSection.classList.toggle("reveal-active");
  });
}
const showButton = (el) => {
  if (!el) return;
  setTimeout(() => {
    el.style.display = "block";
    el.classList.remove("hidden");
  }, 150);
};
const hideButton = (el) => {
  if (!el) return;
  el.classList.add("hidden");
  setTimeout(() => {
    el.style.display = "none";
  }, 150);
};
const getHiddenBisVariantIds = () => {
  const ids = /* @__PURE__ */ new Set();
  document.querySelectorAll("[data-hidden-klaviyo]").forEach((input) => {
    if (!input.value) return;
    input.value.split(",").map((v) => v.trim()).filter(Boolean).forEach((id) => ids.add(id));
  });
  return ids;
};
const updateKlaviyoBisText = () => {
  const bisTriggerBtn = document.querySelector(".klaviyo-bis-trigger");
  const bisText = document.querySelector(".pdp-block__klaviyo-bis-text");
  if (!bisText) return;
  if (bisTriggerBtn) {
    const isButtonVisible = !bisTriggerBtn.classList.contains("hidden") && window.getComputedStyle(bisTriggerBtn).display !== "none";
    if (isButtonVisible) {
      bisText.style.display = "block";
      requestAnimationFrame(() => {
        bisText.classList.remove("is-hidden");
        bisText.classList.add("is-visible");
      });
    } else {
      bisText.classList.remove("is-visible");
      bisText.classList.add("is-hidden");
      setTimeout(() => {
        if (bisText.classList.contains("is-hidden")) {
          bisText.style.display = "none";
        }
      }, 300);
    }
  } else {
    bisText.classList.remove("is-visible");
    bisText.classList.add("is-hidden");
    setTimeout(() => {
      bisText.style.display = "none";
    }, 300);
  }
};
const updateButtonsForVariant = (variantId, isAvailable, hiddenIds) => {
  const idStr = String(variantId);
  const isInHiddenList = hiddenIds.has(idStr);
  const bisTriggerBtn = document.querySelector(".klaviyo-bis-trigger");
  const productFormAddButton = document.querySelector(".product-main--button");
  const bisContainer = document.getElementById("Klaviyo_BIS_notify_me");
  const shouldShowBis = !isAvailable && !isInHiddenList;
  if (bisContainer) {
    if (shouldShowBis) {
      bisContainer.classList.remove("bis-trigger-hidden");
    } else {
      bisContainer.classList.add("bis-trigger-hidden");
    }
  }
  if (shouldShowBis) {
    showButton(bisTriggerBtn);
    hideButton(productFormAddButton);
  } else {
    showButton(productFormAddButton);
    hideButton(bisTriggerBtn);
  }
  setTimeout(() => {
    updateKlaviyoBisText();
  }, 200);
};
document.addEventListener("DOMContentLoaded", () => {
  const hiddenIds = getHiddenBisVariantIds();
  setTimeout(() => {
    updateKlaviyoBisText();
  }, 300);
  const currentInput = document.querySelector("[data-hidden-klaviyo][data-current-variant]");
  if (!currentInput) return;
  const currentVariantId = currentInput.dataset.currentVariant;
  const currentVariantAvailable = String(currentInput.dataset.currentVariantAvailable) === "true";
  updateButtonsForVariant(currentVariantId, currentVariantAvailable, hiddenIds);
});
document.addEventListener("variant:changed", function(e) {
  var _a;
  const variant = (_a = e.detail) == null ? void 0 : _a.variant;
  if (!variant) return;
  const hiddenIds = getHiddenBisVariantIds();
  const variantId = variant.id;
  const isAvailable = !!variant.available;
  updateButtonsForVariant(variantId, isAvailable, hiddenIds);
});
(function() {
  const normalize2 = (s) => (s || "").toString().toLowerCase().replace(/[\s-]+/g, "");
  function initCategoryVariantSync() {
    const section = document.querySelector(".shopify-section--product-categories");
    if (!section) return;
    const carousels = section.querySelectorAll("flickity-carousel[data-main-category]");
    if (!carousels.length) return;
    const keyToCarousel = /* @__PURE__ */ new Map();
    carousels.forEach((carousel) => {
      carousel.querySelectorAll(".product_categories-content[data-flavour-key]").forEach((cell2) => {
        const key = cell2.getAttribute("data-flavour-key");
        if (key && !keyToCarousel.has(key)) keyToCarousel.set(key, carousel);
      });
    });
    if (!keyToCarousel.size) return;
    const variantSelect = document.querySelector('select[name="option1"]');
    const variantValues = variantSelect ? [...variantSelect.options].map((o) => o.value) : [];
    const allMatch = variantValues.length > 0 && variantValues.every((v) => keyToCarousel.has(normalize2(v)));
    if (!allMatch) return;
    const selectFlavour = (variant) => {
      if (!variant) return;
      const key = [variant.option1, variant.option2, variant.option3, variant.title].filter(Boolean).map(normalize2).find((k) => keyToCarousel.has(k));
      if (!key) return;
      const carousel = keyToCarousel.get(key);
      const cell2 = carousel.querySelector(`.product_categories-content[data-flavour-key="${key}"]`);
      if (!cell2) return;
      const category = cell2.getAttribute("data-selected-category");
      const index = cell2.getAttribute("data-selected-index");
      section.querySelectorAll(".product_categories-text[data-selected-category]").forEach((el) => {
        const match = el.getAttribute("data-selected-category") === category && el.getAttribute("data-selected-index") == index;
        el.classList.toggle("hidden", !match);
      });
      section.querySelectorAll(".product-subcategories__wrapper[data-subcategory-index]").forEach((el) => {
        const match = el.getAttribute("data-selected-category") === category && el.getAttribute("data-subcategory-index") == index;
        el.classList.toggle("hidden", !match);
      });
      if (typeof carousel.select === "function") {
        carousel.select(`.product_categories-content[data-flavour-key="${key}"]`);
      }
    };
    document.addEventListener("variant:changed", (e) => {
      var _a;
      return selectFlavour((_a = e.detail) == null ? void 0 : _a.variant);
    });
    const syncCurrent = () => {
      if (variantSelect && variantSelect.value) selectFlavour({ option1: variantSelect.value });
    };
    syncCurrent();
    setTimeout(syncCurrent, 500);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCategoryVariantSync);
  } else {
    initCategoryVariantSync();
  }
})();
const selectors$7 = {
  headings: ".product-info__tab-heading",
  bodies: ".product-info__tab-body"
};
const tabHeadings = document.querySelectorAll(selectors$7.headings);
const tabBodies = document.querySelectorAll(selectors$7.bodies);
function tabResize() {
  if (tabBodies.lenght === 0) return;
  const currentTab = document.querySelector('.product-info__tab-body[data-tab-hidden="false"]');
  const contentHeight = document.querySelector('.product-info__tab-body[data-tab-hidden="false"] > :first-child');
  if (contentHeight && currentTab) {
    const currentTabHeight = contentHeight.scrollHeight;
    setTimeout(() => {
      currentTab.style.height = currentTabHeight + "px";
    }, 0);
  }
}
function tabHandler() {
  if (!tabHeadings || !tabBodies) return;
  tabHeadings.forEach(function(tabHeading) {
    tabBodies.forEach((tabBody) => {
      if (tabBody.dataset.tabHidden === "false") {
        tabBody.style.height = tabBody.clientHeight + "px";
      }
    });
    tabHeading.addEventListener("click", function() {
      const tabNumber = this.getAttribute("data-tab");
      tabHeadings.forEach((heading) => {
        heading.dataset.selected = "false";
      });
      this.dataset.selected = "true";
      tabBodies.forEach(function(tabBody) {
        tabBody.dataset.tabHidden = "true";
      });
      const currentTab = document.querySelector('.product-info__tab-body[data-tab="' + tabNumber + '"]');
      currentTab.parentNode.style.backgroundColor = currentTab.dataset.background;
      currentTab.dataset.tabHidden = "false";
      const currentTabHeight = currentTab.scrollHeight;
      setTimeout(() => {
        currentTab.style.height = currentTabHeight + "px";
      }, 0);
    });
  });
}
tabHandler();
window.addEventListener("resize", tabResize);
const ua = navigator.userAgent || "";
const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
const isFirefox = ua.toLowerCase().includes("firefox");
if (isSafari) {
  document.documentElement.classList.add("is-safari");
}
if (isFirefox) {
  document.documentElement.classList.add("is-firefox");
}
const CartSync = (() => {
  const taskQueue = [];
  let queueBusy = false;
  let resolveWhenStable, stableTimer;
  const STABLE_MS = 300;
  function flagCartChanged() {
    if (stableTimer) clearTimeout(stableTimer);
    stableTimer = setTimeout(() => {
      resolveWhenStable == null ? void 0 : resolveWhenStable();
      resolveWhenStable = null;
      stableTimer = null;
    }, STABLE_MS);
  }
  document.addEventListener("cart:updated", flagCartChanged, { passive: true });
  document.addEventListener("cart:refresh", flagCartChanged, { passive: true });
  document.addEventListener("variant:added", flagCartChanged, { passive: true });
  async function waitForStableCart() {
    if (resolveWhenStable) {
      return new Promise((res) => {
        const prev = resolveWhenStable;
        resolveWhenStable = () => {
          prev == null ? void 0 : prev();
          res();
        };
      });
    }
    return new Promise((res) => {
      resolveWhenStable = res;
      flagCartChanged();
    });
  }
  async function runQueued(task) {
    return new Promise((resolve2, reject) => {
      taskQueue.push({ task, resolve: resolve2, reject });
      pumpQueue();
    });
  }
  async function pumpQueue() {
    if (queueBusy) return;
    const next = taskQueue.shift();
    if (!next) return;
    queueBusy = true;
    try {
      const result = await next.task();
      next.resolve(result);
    } catch (e) {
      next.reject(e);
    } finally {
      queueBusy = false;
      if (taskQueue.length) pumpQueue();
    }
  }
  async function withCartLock(task) {
    var _a;
    if ((_a = navigator.locks) == null ? void 0 : _a.request) {
      return navigator.locks.request("cart-lock", task);
    }
    return runQueued(task);
  }
  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return res.json();
  }
  return { withCartLock, waitForStableCart, fetchCart };
})();
function isUpsellGiftLine(item, threshold) {
  const props = item.properties || {};
  const isAov = props._aov_product === true || props._aov_product === "true";
  if (!isAov) return false;
  return String(props._aov_product_threshold ?? "") === String(threshold ?? "");
}
function hasUpsellGiftForTier(cart, threshold, tierIds = []) {
  return (cart.items || []).some((item) => {
    if (!isUpsellGiftLine(item, threshold)) return false;
    if (!tierIds.length) return true;
    const variantId = Number(item.id);
    const productId = Number(item.product_id);
    return tierIds.some((id) => {
      const numId = Number(id);
      return numId === variantId || numId === productId;
    });
  });
}
function upsellProperties(threshold) {
  return {
    _aov_product: "true",
    _aov_product_threshold: String(threshold)
  };
}
let upsellPipelineBusy = false;
async function addToCartOnce(items, idempotencyKey = null) {
  setButtonLoading(true);
  return CartSync.withCartLock(async () => {
    var _a, _b, _c, _d;
    const cart = await CartSync.fetchCart();
    if (idempotencyKey) {
      const alreadyTagged = cart.items.some(
        (it) => it.properties && it.properties._auto_key === idempotencyKey
      );
      if (alreadyTagged) return null;
    }
    const idsInCart = new Set(cart.items.map((it) => Number(it.id)));
    const isUpsellAdd = items.some((i) => {
      const props = i.properties || {};
      return props._aov_product === true || props._aov_product === "true";
    });
    if (isUpsellAdd) {
      const threshold = (_b = (_a = items[0]) == null ? void 0 : _a.properties) == null ? void 0 : _b._aov_product_threshold;
      if (hasUpsellGiftForTier(cart, threshold)) return null;
    } else {
      const allPresent = items.every((i) => idsInCart.has(Number(i.id)));
      if (allPresent) return null;
    }
    const payload = {
      items: items.map((i) => ({
        ...i,
        properties: {
          ...i.properties || {},
          ...idempotencyKey ? { _auto_key: idempotencyKey } : {}
        }
      }))
    };
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      credentials: "same-origin"
    });
    const json = await res.json();
    (_c = document.querySelector("cart-drawer")) == null ? void 0 : _c.classList.remove("popup-opened");
    document.documentElement.dispatchEvent(
      new CustomEvent("variant:added", {
        bubbles: true,
        detail: { variant: ((_d = json == null ? void 0 : json.items) == null ? void 0 : _d[0]) || json }
      })
    );
    const freshCart = await CartSync.fetchCart();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", { bubbles: true, detail: { cart: freshCart } })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: freshCart } })
    );
    const dismissed = new Set(JSON.parse(sessionStorage.getItem("dismissedUpsellProducts")) || []);
    freshCart.items.forEach((item) => {
      var _a2;
      if ((_a2 = item.properties) == null ? void 0 : _a2._aov_product) dismissed.add(Number(item.id));
    });
    sessionStorage.setItem("dismissedUpsellProducts", JSON.stringify([...dismissed]));
    setButtonLoading(false);
    return json;
  });
}
async function runUpsellPipeline() {
  if (upsellPipelineBusy) return;
  upsellPipelineBusy = true;
  try {
    await CartSync.waitForStableCart();
    const cart = await CartSync.fetchCart();
    const nonGiftTotalCents = (cart.items || []).filter((i) => {
      var _a;
      return !i.gift_card && !(((_a = i.product) == null ? void 0 : _a.tags) || []).includes("__gift_card");
    }).reduce((sum, i) => sum + (i.final_line_price || 0), 0);
    const cartTotal = nonGiftTotalCents / 100;
    const variantIdsInCart = new Set(cart.items.map((i) => Number(i.id)));
    const nodes = Array.from(document.querySelectorAll(".productUpsell"));
    if (nodes.length === 0) return;
    let tiers = nodes.map((wrapper) => {
      const threshold = parseFloat(wrapper.getAttribute("data-threshold")) || 0;
      const isPopup = wrapper.getAttribute("data-is-popup") === "true";
      const isAuto = wrapper.getAttribute("data-auto-product") === "true";
      const productIDs = (wrapper.getAttribute("data-products") || "").split(",").filter(Boolean);
      const variantIDs = (wrapper.getAttribute("data-variants") || "").split(",").filter(Boolean);
      const concreteIds = [
        ...productIDs.map(Number).filter(Boolean),
        ...variantIDs.map(Number).filter(Boolean)
      ];
      return {
        wrapper,
        threshold,
        isPopup,
        isAuto,
        productIDs,
        variantIDs,
        concreteIds
      };
    });
    tiers.sort((a, b3) => a.threshold - b3.threshold);
    const dismissed = new Set(JSON.parse(sessionStorage.getItem("dismissedUpsellProducts")) || []);
    const wasDismissed = (tier) => tier.concreteIds.some((id) => dismissed.has(Number(id)));
    for (const tier of tiers) {
      if (tier.threshold <= 0) continue;
      if (cartTotal < tier.threshold) continue;
      if (wasDismissed(tier)) continue;
      if (hasUpsellGiftForTier(cart, tier.threshold, tier.concreteIds)) continue;
      if (tier.isPopup) {
        renderUpsellPopup(tier);
        break;
      } else if (tier.isAuto) {
        const targetId = (tier.variantIDs[0] || tier.productIDs[0] || "").trim();
        if (!targetId) continue;
        const oneItem = [
          {
            id: targetId,
            quantity: 1,
            properties: upsellProperties(tier.threshold)
          }
        ];
        await addToCartOnce(oneItem, `auto:${targetId}:${tier.threshold}`);
        await CartSync.waitForStableCart();
        const cart2 = await CartSync.fetchCart();
        cart2.items.forEach((i) => variantIdsInCart.add(Number(i.id)));
      }
    }
  } catch (err) {
    console.error("runUpsellPipeline error:", err);
  } finally {
    upsellPipelineBusy = false;
  }
}
function setButtonLoading(loading) {
  let btns = document.querySelectorAll(".free_btn");
  if (!btns.length) return;
  btns.forEach((btn) => {
    btn.toggleAttribute("disabled", loading);
    btn.setAttribute("aria-busy", loading ? "true" : "false");
    const text = btn.querySelector(".loader-button__text");
    const spinner = btn.querySelector(".loader-button__loader");
    if (text) text.hidden = loading;
    if (spinner) spinner.hidden = !loading;
  });
}
const autoAddOnVariantSelect = /* @__PURE__ */ (() => {
  let t = null;
  return ({ id, threshold }) => {
    clearTimeout(t);
    t = setTimeout(async () => {
      var _a;
      const drawer = document.querySelector(".popover--quick-buy--upsell");
      const addBtn = drawer == null ? void 0 : drawer.querySelector(".add-free-product");
      if (!drawer || drawer.classList.contains("hidden")) return;
      if (!addBtn) return;
      if (addBtn.dataset.busy === "true") return;
      if (!id || !threshold) return;
      addBtn.dataset.busy = "true";
      try {
        const items = [
          {
            id,
            quantity: 1,
            properties: upsellProperties(threshold)
          }
        ];
        await addToCartOnce(items, `popup:${id}:${threshold}`);
        await CartSync.waitForStableCart();
        (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.classList.remove("popup-opened");
        drawer.classList.add("hidden");
        runUpsellPipeline();
      } catch (e) {
        console.error("autoAddOnVariantSelect error:", e);
      } finally {
        addBtn.dataset.busy = "false";
      }
    }, 200);
  };
})();
function renderUpsellPopup(tier) {
  var _a, _b, _c, _d;
  const drawer = document.querySelector(".popover--quick-buy--upsell");
  if (!drawer) return;
  drawer.innerHTML = "";
  const { wrapper, threshold } = tier;
  const variantOptions = wrapper.querySelectorAll("select option");
  const productTitle = ((_a = wrapper.querySelector(".free-product_title")) == null ? void 0 : _a.getAttribute("data-title")) || "";
  const el = document.createElement("div");
  el.classList.add("upsell-product");
  el.innerHTML = `
    <div class="free_info">
      <div class="free-popup-close free-popup-close-header" data-selected="${((_b = variantOptions[0]) == null ? void 0 : _b.value) || ""}">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
          <g id="close"><path id="Vector" d="M15.2649 5.73532L5.73547 15.2647M5.73547 5.73532L15.2649 15.2647" stroke="black" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/></g>
        </svg>
      </div>
      <div class="free-info--header">${window.theme.giftsHeading}</div>
      <div class="img_wrap">
        ${variantOptions.length > 0 ? [...variantOptions].map(
    (opt) => `
            <div class="upsell-variant-images" main-product="${opt.getAttribute("main-product")}" data-variant-id="${opt.value}" style="display:none;">
              <img loading="lazy" width="200" height="200" src="${opt.getAttribute("variant-image")}"/>
            </div>`
  ).join("") : ""}
      </div>
      <div class="item_right">
        <div class="title_wrap">
          <h4 class="product_title">${productTitle}</h4>
        </div>
        <div class="button_wrap">
          ${variantOptions.length > 0 ? `
            <select class="free-product__upsell-select" onchange="document.dispatchEvent(new CustomEvent('upsell:variantChange', {detail: {target: event.target}}))">
              ${[...variantOptions].map(
    (opt) => `<option value="${opt.value}" main-product="${opt.getAttribute("main-product")}" ${opt.disabled ? "disabled" : ""}>${opt.textContent}</option>`
  ).join("")}
            </select>` : ""}
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g id="dropdown"><path id="Vector" d="M6 9L12 15L18 9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>
          <button type="button"  class="add-free-product free_btn button button--secondary" is="loader-button" data-selected="${((_c = variantOptions[0]) == null ? void 0 : _c.value) || ""}" data-selected-threshold="${threshold}" >
            <span class="loader-button__text">${window.theme.addToCart}</span>

            <span class="loader-button__loader" hidden>
              <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                  <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
              </div>
            </span>
          </button>
          <span class="button-separator">${window.theme.chooseOr}</span>
          <button type="button" class="free-popup-close button-continue--shopping button" data-selected="${((_d = variantOptions[0]) == null ? void 0 : _d.value) || ""}">${window.theme.continueShopping}</button>
        </div>
      </div>
    </div>
  `;
  drawer.appendChild(el);
  const first = variantOptions[0];
  if (first) {
    const imgs = drawer.querySelectorAll(".upsell-variant-images");
    imgs.forEach((img) => {
      img.style.display = Number(img.getAttribute("data-variant-id")) === Number(first.value) ? "block" : "none";
    });
  }
  setTimeout(() => {
    var _a2;
    drawer.classList.remove("hidden");
    (_a2 = document.querySelector("cart-drawer")) == null ? void 0 : _a2.classList.remove("popup-opened");
  }, 100);
  setTimeout(() => {
    var _a2;
    (_a2 = document.querySelector("cart-drawer")) == null ? void 0 : _a2.classList.add("popup-opened");
  }, 180);
  wireUpsellPopup(drawer);
}
function wireUpsellPopup(drawer) {
  const addBtn = drawer.querySelector(".add-free-product");
  if (addBtn) {
    addBtn.addEventListener("click", async (ev) => {
      var _a;
      const btn = ev.target.closest(".add-free-product");
      if (!btn || btn.dataset.busy === "true") return;
      const id = btn.getAttribute("data-selected");
      const th = btn.getAttribute("data-selected-threshold");
      if (!id || !th) return;
      btn.dataset.busy = "true";
      try {
        const items = [{ id, quantity: 1, properties: upsellProperties(th) }];
        await addToCartOnce(items, `popup:${id}:${th}`);
        await CartSync.waitForStableCart();
        (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.classList.remove("popup-opened");
        drawer.classList.add("hidden");
        runUpsellPipeline();
      } finally {
        btn.dataset.busy = "false";
      }
    });
  }
  const closeBtns = drawer.querySelectorAll(".free-popup-close");
  if (closeBtns.length) {
    closeBtns.forEach((button) => {
      button.addEventListener("click", (e) => {
        var _a;
        const btn = e.target.closest(".free-popup-close");
        const selected = btn == null ? void 0 : btn.getAttribute("data-selected");
        if (selected) {
          const dismissed = new Set(JSON.parse(sessionStorage.getItem("dismissedUpsellProducts")) || []);
          dismissed.add(Number(selected));
          sessionStorage.setItem("dismissedUpsellProducts", JSON.stringify([...dismissed]));
        }
        (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.classList.remove("popup-opened");
        if (drawer) drawer.classList.add("hidden");
      });
    });
  }
}
document.addEventListener("upsell:variantChange", (event) => {
  const sel = event.detail.target.options[event.detail.target.selectedIndex];
  if (sel == null ? void 0 : sel.value) {
    if (event.detail.target.nextElementSibling) {
      event.detail.target.nextElementSibling.value = sel.value;
      event.detail.target.nextElementSibling.id = `variant_${sel.id}`;
    }
    const imgs = document.querySelectorAll(".upsell-variant-images");
    if (imgs.length) {
      imgs.forEach((img) => {
        if (Number(img.getAttribute("main-product")) === Number(sel.getAttribute("main-product"))) {
          img.style.display = "none";
          if (Number(img.getAttribute("data-variant-id")) === Number(sel.value)) {
            img.style.display = "block";
          }
        }
      });
    }
  }
  const addBtn = document.querySelector(".add-free-product");
  if (addBtn) addBtn.setAttribute("data-selected", (sel == null ? void 0 : sel.value) || "");
  if ((sel == null ? void 0 : sel.value) && addBtn) {
    const threshold = addBtn.getAttribute("data-selected-threshold");
    autoAddOnVariantSelect({ id: sel.value, threshold });
  }
});
const scheduleUpsellCheck = /* @__PURE__ */ (() => {
  let t;
  return () => {
    clearTimeout(t);
    t = setTimeout(() => runUpsellPipeline(), 50);
  };
})();
document.addEventListener("cart:refresh", async () => {
  await CartSync.waitForStableCart();
  scheduleUpsellCheck();
});
document.addEventListener("openable-element:open", async (e) => {
  var _a;
  if (((_a = e.target) == null ? void 0 : _a.id) === "mini-cart") {
    await CartSync.waitForStableCart();
    scheduleUpsellCheck();
  }
});
document.addEventListener("DOMContentLoaded", async function() {
  var _a;
  try {
    const cart = await (await fetch("/cart.js")).json();
    if (((_a = cart.items) == null ? void 0 : _a.length) > 0) {
      const dismissed = new Set(JSON.parse(sessionStorage.getItem("dismissedUpsellProducts")) || []);
      cart.items.forEach((item) => {
        if (item.properties && item.properties["_aov_product"]) {
          dismissed.add(Number(item.id));
        }
      });
      sessionStorage.setItem("dismissedUpsellProducts", JSON.stringify([...dismissed]));
    }
  } catch (e) {
    console.error("Error fetching cart on load:", e);
  }
});
const selectors$6 = {
  carouselContainer: ".product-carousel__redesign--body",
  carouselProducts: ".product-carousel__redesign--product",
  featuredProducts: ".product.product-carousel-redesign__product",
  prevButton: '.product-carousel__redesign--button[data-action="prev"]',
  nextButton: '.product-carousel__redesign--button[data-action="next"]'
};
const carouselProducts$1 = document.querySelectorAll(selectors$6.carouselProducts);
const featuredProducts$1 = document.querySelectorAll(selectors$6.featuredProducts);
const prevButton$1 = document.querySelector(selectors$6.prevButton);
const nextButton$1 = document.querySelector(selectors$6.nextButton);
let carouselContainer$1 = document.querySelector(selectors$6.carouselContainer);
let isScrollCarouselEnabled$1 = null;
function goToNextProduct$1() {
  let currentIndex = Array.from(carouselProducts$1).findIndex((prod) => prod.getAttribute("data-selected") === "true");
  let nextIndex = (currentIndex + 1) % carouselProducts$1.length;
  updateSelection$1(nextIndex);
}
function goToPrevProduct$1() {
  let currentIndex = Array.from(carouselProducts$1).findIndex((prod) => prod.getAttribute("data-selected") === "true");
  let prevIndex = (currentIndex - 1 + carouselProducts$1.length) % carouselProducts$1.length;
  updateSelection$1(prevIndex);
}
function updateSelection$1(newIndex) {
  carouselProducts$1.forEach((prod, index) => {
    prod.setAttribute("data-selected", "false");
    featuredProducts$1[index].setAttribute("data-selected", "false");
  });
  carouselProducts$1[newIndex].setAttribute("data-selected", "true");
  featuredProducts$1[newIndex].setAttribute("data-selected", "true");
  const container = carouselProducts$1[newIndex].parentElement;
  const containerWidth = container.offsetWidth;
  const itemLeft = carouselProducts$1[newIndex].offsetLeft;
  const itemRight = itemLeft + carouselProducts$1[newIndex].offsetWidth;
  if (itemLeft < container.scrollLeft) {
    container.scrollLeft = itemLeft - 40;
  } else if (itemRight > container.scrollLeft + containerWidth) {
    container.scrollLeft = itemRight - containerWidth + 40;
  }
  window.dispatchEvent(new Event("resize", { bubbles: true }));
}
function isScrollEnabled$1(container) {
  if (container) {
    return container.scrollWidth > container.clientWidth;
  }
}
if (carouselContainer$1) {
  isScrollCarouselEnabled$1 = isScrollEnabled$1(carouselContainer$1);
  carouselContainer$1 == null ? void 0 : carouselContainer$1.setAttribute("data-scroll", isScrollCarouselEnabled$1);
}
window.addEventListener("resize", () => {
  carouselContainer$1 = document.querySelector(selectors$6.carouselContainer);
  if (carouselContainer$1) {
    isScrollCarouselEnabled$1 = isScrollEnabled$1(carouselContainer$1);
    carouselContainer$1 == null ? void 0 : carouselContainer$1.setAttribute("data-scroll", isScrollCarouselEnabled$1);
  }
});
if (carouselProducts$1 && featuredProducts$1) {
  carouselProducts$1.forEach((product, index) => {
    product.addEventListener("click", () => updateSelection$1(index));
  });
}
if (prevButton$1 && nextButton$1) {
  prevButton$1.addEventListener("click", goToPrevProduct$1);
  nextButton$1.addEventListener("click", goToNextProduct$1);
}
function changeIngredients() {
  let selectedIngredients = null;
  if (!!document.querySelectorAll(".section-ingredients-slider")) {
    document.querySelectorAll(".section-ingredients-slider").forEach((slide2) => {
      if (slide2.classList.contains("is-selected")) {
        selectedIngredients = slide2;
      }
    });
  }
  if (!!selectedIngredients) {
    if (!!selectedIngredients.getAttribute("data-identifier")) {
      let ingredientIdentifier = selectedIngredients.getAttribute("data-identifier");
      if (!!document.querySelectorAll(".ingredients--heading")) {
        let ingredientsHeadings = document.querySelectorAll(".ingredients--heading");
        ingredientsHeadings.forEach((heading) => {
          if (heading.getAttribute("data-identifier") == ingredientIdentifier) {
            heading.classList.remove("hidden");
          } else {
            heading.classList.add("hidden");
          }
        });
      }
      if (!!document.querySelectorAll(".product-ingridients__wrapper")) {
        let ingredientsColaps = document.querySelectorAll(".product-ingridients__wrapper");
        ingredientsColaps.forEach((ingredient) => {
          if (ingredient.getAttribute("data-identifier") == ingredientIdentifier) {
            ingredient.classList.remove("hidden");
          } else {
            ingredient.classList.add("hidden");
          }
        });
      }
    }
  }
}
window.addEventListener("flickity:slide-changed", (e) => {
  setTimeout(() => {
    changeIngredients();
  }, 1500);
});
function changeProgressBar(currentSlide, index) {
  if (!!currentSlide) {
    if (!!currentSlide.querySelector(`.multi-column__item-${currentSlide.getAttribute("section-id")}.is-selected`)) {
      let slideSelected = currentSlide.querySelector(`.multi-column__item-${currentSlide.getAttribute("section-id")}.is-selected`);
      if (!!slideSelected.getAttribute("data-blocks-size")) {
        let blocksSize = slideSelected.getAttribute("data-blocks-size");
        let progress = 100 / Number(blocksSize);
        let currentindex = index + 1;
        if (currentindex === Number(blocksSize)) {
          progress = 100;
        } else {
          progress = progress * currentindex;
        }
        if (!!document.querySelector(`.progress-bar-${currentSlide.getAttribute("section-id")}`)) {
          let progressBar = document.querySelector(`.progress-bar-${currentSlide.getAttribute("section-id")}`);
          progressBar.style.width = progress + "%";
        }
      }
    }
  }
}
window.addEventListener("flickity:slide-changed", function(e) {
  if (!!e.target) {
    changeProgressBar(e.target, e.detail);
  }
});
const productsInCartText = document.getElementById("productsInCart") ? document.getElementById("productsInCart").textContent : null;
let productsInCart, productFromPromo;
let isProductPromoRemoved = false;
if (!!productsInCartText) {
  try {
    productsInCart = JSON.parse(productsInCartText);
    productFromPromo = findPromoProduct(productsInCart.items, "original");
    subscribeToEvent();
  } catch (error2) {
    console.error("❌ Error parsing JSON", error2);
  }
}
async function subscribeToEvent() {
  document.addEventListener("cart:updated", async (event) => {
    var _a;
    if ((_a = event.detail) == null ? void 0 : _a.updateFromPromo) return;
    productsInCart.items = event.detail.cart.items;
    if (!productFromPromo) {
      productFromPromo = findPromoProduct(productsInCart.items, "event");
    }
    if (!productFromPromo) return;
    if (event.detail.cart.items_removed && event.detail.cart.items_removed.length > 0) {
      isProductPromoRemoved = checkForRemovedProducts(event.detail.cart.items_removed);
    }
    if (isProductPromoRemoved) {
      deleteAllCookiesWithName("cart");
      isProductPromoRemoved = false;
      await addProductsAndAttributes(event.detail.cart);
    }
  });
}
function findPromoProduct(products, typeOfArray) {
  if (typeOfArray === "original") {
    return products.find((product) => {
      return product.properties.some((property) => property[0] === "_addedByCode");
    });
  } else if (typeOfArray === "event") {
    return products.find((product) => {
      return product.properties && product.properties._addedByCode;
    });
  }
  return null;
}
function checkForRemovedProducts(removedItems) {
  return removedItems.some((item) => item.variant_id === productFromPromo.variant_id);
}
function deleteAllCookiesWithName(name) {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const cookieParts = cookie.split("=");
    const cookieName = cookieParts[0].trim();
    if (cookieName === name) {
      document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  }
}
async function addProductsAndAttributes(cart) {
  const formData = {
    items: cart.items,
    attributes: cart.attributes
  };
  try {
    const result = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });
    if (result.ok) {
      delete cart.sections;
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart,
          updateFromPromo: true
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart
        }
      }));
    }
  } catch (error2) {
    console.error("❌ Error updating cart", error2);
  }
}
function getDefaultExportFromCjs(x3) {
  return x3 && x3.__esModule && Object.prototype.hasOwnProperty.call(x3, "default") ? x3["default"] : x3;
}
var js = { exports: {} };
var core$1 = { exports: {} };
var evEmitter$1 = { exports: {} };
var evEmitter = evEmitter$1.exports;
var hasRequiredEvEmitter;
function requireEvEmitter() {
  if (hasRequiredEvEmitter) return evEmitter$1.exports;
  hasRequiredEvEmitter = 1;
  (function(module) {
    (function(global2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        global2.EvEmitter = factory();
      }
    })(typeof window != "undefined" ? window : evEmitter, function() {
      function EvEmitter() {
      }
      let proto = EvEmitter.prototype;
      proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        let events2 = this._events = this._events || {};
        let listeners = events2[eventName] = events2[eventName] || [];
        if (!listeners.includes(listener)) {
          listeners.push(listener);
        }
        return this;
      };
      proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        this.on(eventName, listener);
        let onceEvents = this._onceEvents = this._onceEvents || {};
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        onceListeners[listener] = true;
        return this;
      };
      proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) {
          listeners.splice(index, 1);
        }
        return this;
      };
      proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        listeners = listeners.slice(0);
        args = args || [];
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners) {
          let isOnce = onceListeners && onceListeners[listener];
          if (isOnce) {
            this.off(eventName, listener);
            delete onceListeners[listener];
          }
          listener.apply(this, args);
        }
        return this;
      };
      proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
      };
      return EvEmitter;
    });
  })(evEmitter$1);
  return evEmitter$1.exports;
}
var getSize = { exports: {} };
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */
var hasRequiredGetSize;
function requireGetSize() {
  if (hasRequiredGetSize) return getSize.exports;
  hasRequiredGetSize = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        window2.getSize = factory();
      }
    })(window, function factory() {
      function getStyleSize(value) {
        let num = parseFloat(value);
        let isValid = value.indexOf("%") == -1 && !isNaN(num);
        return isValid && num;
      }
      let measurements = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth"
      ];
      function getZeroSize() {
        let size = {
          width: 0,
          height: 0,
          innerWidth: 0,
          innerHeight: 0,
          outerWidth: 0,
          outerHeight: 0
        };
        measurements.forEach((measurement) => {
          size[measurement] = 0;
        });
        return size;
      }
      function getSize2(elem) {
        if (typeof elem == "string") elem = document.querySelector(elem);
        let isElement2 = elem && typeof elem == "object" && elem.nodeType;
        if (!isElement2) return;
        let style = getComputedStyle(elem);
        if (style.display == "none") return getZeroSize();
        let size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        let isBorderBox = size.isBorderBox = style.boxSizing == "border-box";
        measurements.forEach((measurement) => {
          let value = style[measurement];
          let num = parseFloat(value);
          size[measurement] = !isNaN(num) ? num : 0;
        });
        let paddingWidth = size.paddingLeft + size.paddingRight;
        let paddingHeight = size.paddingTop + size.paddingBottom;
        let marginWidth = size.marginLeft + size.marginRight;
        let marginHeight = size.marginTop + size.marginBottom;
        let borderWidth = size.borderLeftWidth + size.borderRightWidth;
        let borderHeight = size.borderTopWidth + size.borderBottomWidth;
        let styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) {
          size.width = styleWidth + // add padding and border unless it's already including it
          (isBorderBox ? 0 : paddingWidth + borderWidth);
        }
        let styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) {
          size.height = styleHeight + // add padding and border unless it's already including it
          (isBorderBox ? 0 : paddingHeight + borderHeight);
        }
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
      }
      return getSize2;
    });
  })(getSize);
  return getSize.exports;
}
var utils$1 = { exports: {} };
var utils = utils$1.exports;
var hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils) return utils$1.exports;
  hasRequiredUtils = 1;
  (function(module) {
    (function(global2, factory) {
      if (module.exports) {
        module.exports = factory(global2);
      } else {
        global2.fizzyUIUtils = factory(global2);
      }
    })(utils, function factory(global2) {
      let utils2 = {};
      utils2.extend = function(a, b3) {
        return Object.assign(a, b3);
      };
      utils2.modulo = function(num, div) {
        return (num % div + div) % div;
      };
      utils2.makeArray = function(obj) {
        if (Array.isArray(obj)) return obj;
        if (obj === null || obj === void 0) return [];
        let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike) return [...obj];
        return [obj];
      };
      utils2.removeFrom = function(ary, obj) {
        let index = ary.indexOf(obj);
        if (index != -1) {
          ary.splice(index, 1);
        }
      };
      utils2.getParent = function(elem, selector) {
        while (elem.parentNode && elem != document.body) {
          elem = elem.parentNode;
          if (elem.matches(selector)) return elem;
        }
      };
      utils2.getQueryElement = function(elem) {
        if (typeof elem == "string") {
          return document.querySelector(elem);
        }
        return elem;
      };
      utils2.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) {
          this[method](event);
        }
      };
      utils2.filterFindElements = function(elems, selector) {
        elems = utils2.makeArray(elems);
        return elems.filter((elem) => elem instanceof HTMLElement).reduce((ffElems, elem) => {
          if (!selector) {
            ffElems.push(elem);
            return ffElems;
          }
          if (elem.matches(selector)) {
            ffElems.push(elem);
          }
          let childElems = elem.querySelectorAll(selector);
          ffElems = ffElems.concat(...childElems);
          return ffElems;
        }, []);
      };
      utils2.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        let method = _class.prototype[methodName];
        let timeoutName = methodName + "Timeout";
        _class.prototype[methodName] = function() {
          clearTimeout(this[timeoutName]);
          let args = arguments;
          this[timeoutName] = setTimeout(() => {
            method.apply(this, args);
            delete this[timeoutName];
          }, threshold);
        };
      };
      utils2.docReady = function(onDocReady) {
        let readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") {
          setTimeout(onDocReady);
        } else {
          document.addEventListener("DOMContentLoaded", onDocReady);
        }
      };
      utils2.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
          return $1 + "-" + $2;
        }).toLowerCase();
      };
      let console2 = global2.console;
      utils2.htmlInit = function(WidgetClass, namespace) {
        utils2.docReady(function() {
          let dashedNamespace = utils2.toDashed(namespace);
          let dataAttr = "data-" + dashedNamespace;
          let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
          let jQuery = global2.jQuery;
          [...dataAttrElems].forEach((elem) => {
            let attr = elem.getAttribute(dataAttr);
            let options;
            try {
              options = attr && JSON.parse(attr);
            } catch (error2) {
              if (console2) {
                console2.error(`Error parsing ${dataAttr} on ${elem.className}: ${error2}`);
              }
              return;
            }
            let instance = new WidgetClass(elem, options);
            if (jQuery) {
              jQuery.data(elem, namespace, instance);
            }
          });
        });
      };
      return utils2;
    });
  })(utils$1);
  return utils$1.exports;
}
var cell$1 = { exports: {} };
var cell = cell$1.exports;
var hasRequiredCell;
function requireCell() {
  if (hasRequiredCell) return cell$1.exports;
  hasRequiredCell = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(requireGetSize());
      } else {
        window2.Flickity = window2.Flickity || {};
        window2.Flickity.Cell = factory(window2.getSize);
      }
    })(typeof window != "undefined" ? window : cell, function factory(getSize2) {
      const cellClassName = "flickity-cell";
      function Cell(elem) {
        this.element = elem;
        this.element.classList.add(cellClassName);
        this.x = 0;
        this.unselect();
      }
      let proto = Cell.prototype;
      proto.destroy = function() {
        this.unselect();
        this.element.classList.remove(cellClassName);
        this.element.style.transform = "";
        this.element.removeAttribute("aria-hidden");
      };
      proto.getSize = function() {
        this.size = getSize2(this.element);
      };
      proto.select = function() {
        this.element.classList.add("is-selected");
        this.element.removeAttribute("aria-hidden");
      };
      proto.unselect = function() {
        this.element.classList.remove("is-selected");
        this.element.setAttribute("aria-hidden", "true");
      };
      proto.remove = function() {
        this.element.remove();
      };
      return Cell;
    });
  })(cell$1);
  return cell$1.exports;
}
var slide$2 = { exports: {} };
var slide$1 = slide$2.exports;
var hasRequiredSlide;
function requireSlide() {
  if (hasRequiredSlide) return slide$2.exports;
  hasRequiredSlide = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        window2.Flickity = window2.Flickity || {};
        window2.Flickity.Slide = factory();
      }
    })(typeof window != "undefined" ? window : slide$1, function factory() {
      function Slide2(beginMargin, endMargin, cellAlign) {
        this.beginMargin = beginMargin;
        this.endMargin = endMargin;
        this.cellAlign = cellAlign;
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
      }
      let proto = Slide2.prototype;
      proto.addCell = function(cell2) {
        this.cells.push(cell2);
        this.outerWidth += cell2.size.outerWidth;
        this.height = Math.max(cell2.size.outerHeight, this.height);
        if (this.cells.length === 1) {
          this.x = cell2.x;
          this.firstMargin = cell2.size[this.beginMargin];
        }
      };
      proto.updateTarget = function() {
        let lastCell = this.getLastCell();
        let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
        let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
      };
      proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
      };
      proto.select = function() {
        this.cells.forEach((cell2) => cell2.select());
      };
      proto.unselect = function() {
        this.cells.forEach((cell2) => cell2.unselect());
      };
      proto.getCellElements = function() {
        return this.cells.map((cell2) => cell2.element);
      };
      return Slide2;
    });
  })(slide$2);
  return slide$2.exports;
}
var animate$1 = { exports: {} };
var animate = animate$1.exports;
var hasRequiredAnimate;
function requireAnimate() {
  if (hasRequiredAnimate) return animate$1.exports;
  hasRequiredAnimate = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(requireUtils());
      } else {
        window2.Flickity = window2.Flickity || {};
        window2.Flickity.animatePrototype = factory(window2.fizzyUIUtils);
      }
    })(typeof window != "undefined" ? window : animate, function factory(utils2) {
      let proto = {};
      proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
      };
      proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        let previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        if (this.isAnimating) requestAnimationFrame(() => this.animate());
      };
      proto.positionSlider = function() {
        let x3 = this.x;
        if (this.isWrapping) {
          x3 = utils2.modulo(x3, this.slideableWidth) - this.slideableWidth;
          this.shiftWrapCells(x3);
        }
        this.setTranslateX(x3, this.isAnimating);
        this.dispatchScrollEvent();
      };
      proto.setTranslateX = function(x3, is3d) {
        x3 += this.cursorPosition;
        if (this.options.rightToLeft) x3 = -x3;
        let translateX = this.getPositionValue(x3);
        this.slider.style.transform = is3d ? `translate3d(${translateX},0,0)` : `translateX(${translateX})`;
      };
      proto.dispatchScrollEvent = function() {
        let firstSlide = this.slides[0];
        if (!firstSlide) return;
        let positionX = -this.x - firstSlide.target;
        let progress = positionX / this.slidesWidth;
        this.dispatchEvent("scroll", null, [progress, positionX]);
      };
      proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0;
        this.positionSlider();
      };
      proto.getPositionValue = function(position) {
        if (this.options.percentPosition) {
          return Math.round(position / this.size.innerWidth * 1e4) * 0.01 + "%";
        } else {
          return Math.round(position) + "px";
        }
      };
      proto.settle = function(previousX) {
        let isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        if (this.restingFrames > 2) {
          this.isAnimating = false;
          delete this.isFreeScrolling;
          this.positionSlider();
          this.dispatchEvent("settle", null, [this.selectedIndex]);
        }
      };
      proto.shiftWrapCells = function(x3) {
        let beforeGap = this.cursorPosition + x3;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        let afterGap = this.size.innerWidth - (x3 + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
      };
      proto._shiftCells = function(cells, gap, shift) {
        cells.forEach((cell2) => {
          let cellShift = gap > 0 ? shift : 0;
          this._wrapShiftCell(cell2, cellShift);
          gap -= cell2.size.outerWidth;
        });
      };
      proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        cells.forEach((cell2) => this._wrapShiftCell(cell2, 0));
      };
      proto._wrapShiftCell = function(cell2, shift) {
        this._renderCellPosition(cell2, cell2.x + this.slideableWidth * shift);
      };
      proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
      };
      proto.applyForce = function(force) {
        this.velocity += force;
      };
      proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
      };
      proto.getRestingPosition = function() {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
      };
      proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        let dragVelocity = this.dragX - this.x;
        let dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
      };
      proto.applySelectedAttraction = function() {
        let dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        let distance = this.selectedSlide.target * -1 - this.x;
        let force = distance * this.options.selectedAttraction;
        this.applyForce(force);
      };
      return proto;
    });
  })(animate$1);
  return animate$1.exports;
}
var core = core$1.exports;
var hasRequiredCore;
function requireCore() {
  if (hasRequiredCore) return core$1.exports;
  hasRequiredCore = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          window2,
          requireEvEmitter(),
          requireGetSize(),
          requireUtils(),
          requireCell(),
          requireSlide(),
          requireAnimate()
        );
      } else {
        let _Flickity = window2.Flickity;
        window2.Flickity = factory(
          window2,
          window2.EvEmitter,
          window2.getSize,
          window2.fizzyUIUtils,
          _Flickity.Cell,
          _Flickity.Slide,
          _Flickity.animatePrototype
        );
      }
    })(
      typeof window != "undefined" ? window : core,
      function factory(window2, EvEmitter, getSize2, utils2, Cell, Slide2, animatePrototype) {
        const { getComputedStyle: getComputedStyle2, console: console2 } = window2;
        let { jQuery } = window2;
        let GUID = 0;
        let instances = {};
        function Flickity2(element, options) {
          let queryElement = utils2.getQueryElement(element);
          if (!queryElement) {
            if (console2) console2.error(`Bad element for Flickity: ${queryElement || element}`);
            return;
          }
          this.element = queryElement;
          if (this.element.flickityGUID) {
            let instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
          }
          if (jQuery) {
            this.$element = jQuery(this.element);
          }
          this.options = { ...this.constructor.defaults };
          this.option(options);
          this._create();
        }
        Flickity2.defaults = {
          accessibility: true,
          // adaptiveHeight: false,
          cellAlign: "center",
          // cellSelector: undefined,
          // contain: false,
          freeScrollFriction: 0.075,
          // friction when free-scrolling
          friction: 0.28,
          // friction when selecting
          namespaceJQueryEvents: true,
          // initialIndex: 0,
          percentPosition: true,
          resize: true,
          selectedAttraction: 0.025,
          setGallerySize: true
          // watchCSS: false,
          // wrapAround: false
        };
        Flickity2.create = {};
        let proto = Flickity2.prototype;
        Object.assign(proto, EvEmitter.prototype);
        proto._create = function() {
          let { resize, watchCSS, rightToLeft } = this.options;
          let id = this.guid = ++GUID;
          this.element.flickityGUID = id;
          instances[id] = this;
          this.selectedIndex = 0;
          this.restingFrames = 0;
          this.x = 0;
          this.velocity = 0;
          this.beginMargin = rightToLeft ? "marginRight" : "marginLeft";
          this.endMargin = rightToLeft ? "marginLeft" : "marginRight";
          this.viewport = document.createElement("div");
          this.viewport.className = "flickity-viewport";
          this._createSlider();
          this.focusableElems = [this.element];
          if (resize || watchCSS) {
            window2.addEventListener("resize", this);
          }
          for (let eventName in this.options.on) {
            let listener = this.options.on[eventName];
            this.on(eventName, listener);
          }
          for (let method in Flickity2.create) {
            Flickity2.create[method].call(this);
          }
          if (watchCSS) {
            this.watchCSS();
          } else {
            this.activate();
          }
        };
        proto.option = function(opts) {
          Object.assign(this.options, opts);
        };
        proto.activate = function() {
          if (this.isActive) return;
          this.isActive = true;
          this.element.classList.add("flickity-enabled");
          if (this.options.rightToLeft) {
            this.element.classList.add("flickity-rtl");
          }
          this.getSize();
          let cellElems = this._filterFindCellElements(this.element.children);
          this.slider.append(...cellElems);
          this.viewport.append(this.slider);
          this.element.append(this.viewport);
          this.reloadCells();
          if (this.options.accessibility) {
            this.element.tabIndex = 0;
            this.element.addEventListener("keydown", this);
          }
          this.emitEvent("activate");
          this.selectInitialIndex();
          this.isInitActivated = true;
          this.dispatchEvent("ready");
        };
        proto._createSlider = function() {
          let slider = document.createElement("div");
          slider.className = "flickity-slider";
          this.slider = slider;
        };
        proto._filterFindCellElements = function(elems) {
          return utils2.filterFindElements(elems, this.options.cellSelector);
        };
        proto.reloadCells = function() {
          this.cells = this._makeCells(this.slider.children);
          this.positionCells();
          this._updateWrapShiftCells();
          this.setGallerySize();
        };
        proto._makeCells = function(elems) {
          let cellElems = this._filterFindCellElements(elems);
          return cellElems.map((cellElem) => new Cell(cellElem));
        };
        proto.getLastCell = function() {
          return this.cells[this.cells.length - 1];
        };
        proto.getLastSlide = function() {
          return this.slides[this.slides.length - 1];
        };
        proto.positionCells = function() {
          this._sizeCells(this.cells);
          this._positionCells(0);
        };
        proto._positionCells = function(index) {
          index = index || 0;
          this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
          let cellX = 0;
          if (index > 0) {
            let startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
          }
          this.cells.slice(index).forEach((cell2) => {
            cell2.x = cellX;
            this._renderCellPosition(cell2, cellX);
            cellX += cell2.size.outerWidth;
            this.maxCellHeight = Math.max(cell2.size.outerHeight, this.maxCellHeight);
          });
          this.slideableWidth = cellX;
          this.updateSlides();
          this._containSlides();
          this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
        };
        proto._renderCellPosition = function(cell2, x3) {
          let sideOffset = this.options.rightToLeft ? -1 : 1;
          let renderX = x3 * sideOffset;
          if (this.options.percentPosition) renderX *= this.size.innerWidth / cell2.size.width;
          let positionValue = this.getPositionValue(renderX);
          cell2.element.style.transform = `translateX( ${positionValue} )`;
        };
        proto._sizeCells = function(cells) {
          cells.forEach((cell2) => cell2.getSize());
        };
        proto.updateSlides = function() {
          this.slides = [];
          if (!this.cells.length) return;
          let { beginMargin, endMargin } = this;
          let slide2 = new Slide2(beginMargin, endMargin, this.cellAlign);
          this.slides.push(slide2);
          let canCellFit = this._getCanCellFit();
          this.cells.forEach((cell2, i) => {
            if (!slide2.cells.length) {
              slide2.addCell(cell2);
              return;
            }
            let slideWidth = slide2.outerWidth - slide2.firstMargin + (cell2.size.outerWidth - cell2.size[endMargin]);
            if (canCellFit(i, slideWidth)) {
              slide2.addCell(cell2);
            } else {
              slide2.updateTarget();
              slide2 = new Slide2(beginMargin, endMargin, this.cellAlign);
              this.slides.push(slide2);
              slide2.addCell(cell2);
            }
          });
          slide2.updateTarget();
          this.updateSelectedSlide();
        };
        proto._getCanCellFit = function() {
          let { groupCells } = this.options;
          if (!groupCells) return () => false;
          if (typeof groupCells == "number") {
            let number = parseInt(groupCells, 10);
            return (i) => i % number !== 0;
          }
          let percent = 1;
          let percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
          if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
          let groupWidth = (this.size.innerWidth + 1) * percent;
          return (i, slideWidth) => slideWidth <= groupWidth;
        };
        proto._init = proto.reposition = function() {
          this.positionCells();
          this.positionSliderAtSelected();
        };
        proto.getSize = function() {
          this.size = getSize2(this.element);
          this.setCellAlign();
          this.cursorPosition = this.size.innerWidth * this.cellAlign;
        };
        let cellAlignShorthands = {
          left: 0,
          center: 0.5,
          right: 1
        };
        proto.setCellAlign = function() {
          let { cellAlign, rightToLeft } = this.options;
          let shorthand = cellAlignShorthands[cellAlign];
          this.cellAlign = shorthand !== void 0 ? shorthand : cellAlign;
          if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
        };
        proto.setGallerySize = function() {
          if (!this.options.setGallerySize) return;
          let height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
          this.viewport.style.height = `${height}px`;
        };
        proto._updateWrapShiftCells = function() {
          this.isWrapping = this.getIsWrapping();
          if (!this.isWrapping) return;
          this._unshiftCells(this.beforeShiftCells);
          this._unshiftCells(this.afterShiftCells);
          let beforeGapX = this.cursorPosition;
          let lastIndex = this.cells.length - 1;
          this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
          let afterGapX = this.size.innerWidth - this.cursorPosition;
          this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
        };
        proto.getIsWrapping = function() {
          let { wrapAround } = this.options;
          if (!wrapAround || this.slides.length < 2) return false;
          if (wrapAround !== "fill") return true;
          let gapWidth = this.slideableWidth - this.size.innerWidth;
          if (gapWidth > this.size.innerWidth) return true;
          for (let cell2 of this.cells) {
            if (cell2.size.outerWidth > gapWidth) return false;
          }
          return true;
        };
        proto._getGapCells = function(gapX, cellIndex, increment) {
          let cells = [];
          while (gapX > 0) {
            let cell2 = this.cells[cellIndex];
            if (!cell2) break;
            cells.push(cell2);
            cellIndex += increment;
            gapX -= cell2.size.outerWidth;
          }
          return cells;
        };
        proto._containSlides = function() {
          let isContaining = this.options.contain && !this.isWrapping && this.cells.length;
          if (!isContaining) return;
          let contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
          let isContentSmaller = contentWidth < this.size.innerWidth;
          if (isContentSmaller) {
            this.slides.forEach((slide2) => {
              slide2.target = contentWidth * this.cellAlign;
            });
          } else {
            let beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
            let endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((slide2) => {
              slide2.target = Math.max(slide2.target, beginBound);
              slide2.target = Math.min(slide2.target, endBound);
            });
          }
        };
        proto.dispatchEvent = function(type, event, args) {
          let emitArgs = event ? [event].concat(args) : args;
          this.emitEvent(type, emitArgs);
          if (jQuery && this.$element) {
            type += this.options.namespaceJQueryEvents ? ".flickity" : "";
            let $event = type;
            if (event) {
              let jQEvent = new jQuery.Event(event);
              jQEvent.type = type;
              $event = jQEvent;
            }
            this.$element.trigger($event, args);
          }
        };
        const unidraggerEvents = [
          "dragStart",
          "dragMove",
          "dragEnd",
          "pointerDown",
          "pointerMove",
          "pointerEnd",
          "staticClick"
        ];
        let _emitEvent = proto.emitEvent;
        proto.emitEvent = function(eventName, args) {
          if (eventName === "staticClick") {
            let clickedCell = this.getParentCell(args[0].target);
            let cellElem = clickedCell && clickedCell.element;
            let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
            args = args.concat(cellElem, cellIndex);
          }
          _emitEvent.call(this, eventName, args);
          let isUnidraggerEvent = unidraggerEvents.includes(eventName);
          if (!isUnidraggerEvent || !jQuery || !this.$element) return;
          eventName += this.options.namespaceJQueryEvents ? ".flickity" : "";
          let event = args.shift(0);
          let jQEvent = new jQuery.Event(event);
          jQEvent.type = eventName;
          this.$element.trigger(jQEvent, args);
        };
        proto.select = function(index, isWrap, isInstant) {
          if (!this.isActive) return;
          index = parseInt(index, 10);
          this._wrapSelect(index);
          if (this.isWrapping || isWrap) {
            index = utils2.modulo(index, this.slides.length);
          }
          if (!this.slides[index]) return;
          let prevIndex = this.selectedIndex;
          this.selectedIndex = index;
          this.updateSelectedSlide();
          if (isInstant) {
            this.positionSliderAtSelected();
          } else {
            this.startAnimation();
          }
          if (this.options.adaptiveHeight) {
            this.setGallerySize();
          }
          this.dispatchEvent("select", null, [index]);
          if (index !== prevIndex) {
            this.dispatchEvent("change", null, [index]);
          }
        };
        proto._wrapSelect = function(index) {
          if (!this.isWrapping) return;
          const { selectedIndex, slideableWidth, slides: { length } } = this;
          if (!this.isDragSelect) {
            let wrapIndex = utils2.modulo(index, length);
            let delta = Math.abs(wrapIndex - selectedIndex);
            let backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
            let forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
            if (backWrapDelta < delta) {
              index += length;
            } else if (forewardWrapDelta < delta) {
              index -= length;
            }
          }
          if (index < 0) {
            this.x -= slideableWidth;
          } else if (index >= length) {
            this.x += slideableWidth;
          }
        };
        proto.previous = function(isWrap, isInstant) {
          this.select(this.selectedIndex - 1, isWrap, isInstant);
        };
        proto.next = function(isWrap, isInstant) {
          this.select(this.selectedIndex + 1, isWrap, isInstant);
        };
        proto.updateSelectedSlide = function() {
          let slide2 = this.slides[this.selectedIndex];
          if (!slide2) return;
          this.unselectSelectedSlide();
          this.selectedSlide = slide2;
          slide2.select();
          this.selectedCells = slide2.cells;
          this.selectedElements = slide2.getCellElements();
          this.selectedCell = slide2.cells[0];
          this.selectedElement = this.selectedElements[0];
        };
        proto.unselectSelectedSlide = function() {
          if (this.selectedSlide) this.selectedSlide.unselect();
        };
        proto.selectInitialIndex = function() {
          let initialIndex = this.options.initialIndex;
          if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
          }
          if (initialIndex && typeof initialIndex == "string") {
            let cell2 = this.queryCell(initialIndex);
            if (cell2) {
              this.selectCell(initialIndex, false, true);
              return;
            }
          }
          let index = 0;
          if (initialIndex && this.slides[initialIndex]) {
            index = initialIndex;
          }
          this.select(index, false, true);
        };
        proto.selectCell = function(value, isWrap, isInstant) {
          let cell2 = this.queryCell(value);
          if (!cell2) return;
          let index = this.getCellSlideIndex(cell2);
          this.select(index, isWrap, isInstant);
        };
        proto.getCellSlideIndex = function(cell2) {
          let cellSlide = this.slides.find((slide2) => slide2.cells.includes(cell2));
          return this.slides.indexOf(cellSlide);
        };
        proto.getCell = function(elem) {
          for (let cell2 of this.cells) {
            if (cell2.element === elem) return cell2;
          }
        };
        proto.getCells = function(elems) {
          elems = utils2.makeArray(elems);
          return elems.map((elem) => this.getCell(elem)).filter(Boolean);
        };
        proto.getCellElements = function() {
          return this.cells.map((cell2) => cell2.element);
        };
        proto.getParentCell = function(elem) {
          let cell2 = this.getCell(elem);
          if (cell2) return cell2;
          let closest = elem.closest(".flickity-slider > *");
          return this.getCell(closest);
        };
        proto.getAdjacentCellElements = function(adjCount, index) {
          if (!adjCount) return this.selectedSlide.getCellElements();
          index = index === void 0 ? this.selectedIndex : index;
          let len = this.slides.length;
          if (1 + adjCount * 2 >= len) {
            return this.getCellElements();
          }
          let cellElems = [];
          for (let i = index - adjCount; i <= index + adjCount; i++) {
            let slideIndex = this.isWrapping ? utils2.modulo(i, len) : i;
            let slide2 = this.slides[slideIndex];
            if (slide2) {
              cellElems = cellElems.concat(slide2.getCellElements());
            }
          }
          return cellElems;
        };
        proto.queryCell = function(selector) {
          if (typeof selector == "number") {
            return this.cells[selector];
          }
          let isSelectorString = typeof selector == "string" && !selector.match(/^[#.]?[\d/]/);
          if (isSelectorString) {
            selector = this.element.querySelector(selector);
          }
          return this.getCell(selector);
        };
        proto.uiChange = function() {
          this.emitEvent("uiChange");
        };
        proto.onresize = function() {
          this.watchCSS();
          this.resize();
        };
        utils2.debounceMethod(Flickity2, "onresize", 150);
        proto.resize = function() {
          if (!this.isActive || this.isAnimating || this.isDragging) return;
          this.getSize();
          if (this.isWrapping) {
            this.x = utils2.modulo(this.x, this.slideableWidth);
          }
          this.positionCells();
          this._updateWrapShiftCells();
          this.setGallerySize();
          this.emitEvent("resize");
          let selectedElement = this.selectedElements && this.selectedElements[0];
          this.selectCell(selectedElement, false, true);
        };
        proto.watchCSS = function() {
          if (!this.options.watchCSS) return;
          let afterContent = getComputedStyle2(this.element, ":after").content;
          if (afterContent.includes("flickity")) {
            this.activate();
          } else {
            this.deactivate();
          }
        };
        proto.onkeydown = function(event) {
          let { activeElement } = document;
          let handler = Flickity2.keyboardHandlers[event.key];
          if (!this.options.accessibility || !activeElement || !handler) return;
          let isFocused = this.focusableElems.some((elem) => activeElement === elem);
          if (isFocused) handler.call(this);
        };
        Flickity2.keyboardHandlers = {
          ArrowLeft: function() {
            this.uiChange();
            let leftMethod = this.options.rightToLeft ? "next" : "previous";
            this[leftMethod]();
          },
          ArrowRight: function() {
            this.uiChange();
            let rightMethod = this.options.rightToLeft ? "previous" : "next";
            this[rightMethod]();
          }
        };
        proto.focus = function() {
          this.element.focus({ preventScroll: true });
        };
        proto.deactivate = function() {
          if (!this.isActive) return;
          this.element.classList.remove("flickity-enabled");
          this.element.classList.remove("flickity-rtl");
          this.unselectSelectedSlide();
          this.cells.forEach((cell2) => cell2.destroy());
          this.viewport.remove();
          this.element.append(...this.slider.children);
          if (this.options.accessibility) {
            this.element.removeAttribute("tabIndex");
            this.element.removeEventListener("keydown", this);
          }
          this.isActive = false;
          this.emitEvent("deactivate");
        };
        proto.destroy = function() {
          this.deactivate();
          window2.removeEventListener("resize", this);
          this.allOff();
          this.emitEvent("destroy");
          if (jQuery && this.$element) {
            jQuery.removeData(this.element, "flickity");
          }
          delete this.element.flickityGUID;
          delete instances[this.guid];
        };
        Object.assign(proto, animatePrototype);
        Flickity2.data = function(elem) {
          elem = utils2.getQueryElement(elem);
          if (elem) return instances[elem.flickityGUID];
        };
        utils2.htmlInit(Flickity2, "flickity");
        let { jQueryBridget } = window2;
        if (jQuery && jQueryBridget) {
          jQueryBridget("flickity", Flickity2, jQuery);
        }
        Flickity2.setJQuery = function(jq) {
          jQuery = jq;
        };
        Flickity2.Cell = Cell;
        Flickity2.Slide = Slide2;
        return Flickity2;
      }
    );
  })(core$1);
  return core$1.exports;
}
var drag$1 = { exports: {} };
var unidragger$1 = { exports: {} };
/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */
var unidragger = unidragger$1.exports;
var hasRequiredUnidragger;
function requireUnidragger() {
  if (hasRequiredUnidragger) return unidragger$1.exports;
  hasRequiredUnidragger = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          window2,
          requireEvEmitter()
        );
      } else {
        window2.Unidragger = factory(
          window2,
          window2.EvEmitter
        );
      }
    })(typeof window != "undefined" ? window : unidragger, function factory(window2, EvEmitter) {
      function Unidragger() {
      }
      let proto = Unidragger.prototype = Object.create(EvEmitter.prototype);
      proto.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) {
          this[method](event);
        }
      };
      let startEvent, activeEvents;
      if ("ontouchstart" in window2) {
        startEvent = "touchstart";
        activeEvents = ["touchmove", "touchend", "touchcancel"];
      } else if (window2.PointerEvent) {
        startEvent = "pointerdown";
        activeEvents = ["pointermove", "pointerup", "pointercancel"];
      } else {
        startEvent = "mousedown";
        activeEvents = ["mousemove", "mouseup"];
      }
      proto.touchActionValue = "none";
      proto.bindHandles = function() {
        this._bindHandles("addEventListener", this.touchActionValue);
      };
      proto.unbindHandles = function() {
        this._bindHandles("removeEventListener", "");
      };
      proto._bindHandles = function(bindMethod, touchAction) {
        this.handles.forEach((handle) => {
          handle[bindMethod](startEvent, this);
          handle[bindMethod]("click", this);
          if (window2.PointerEvent) handle.style.touchAction = touchAction;
        });
      };
      proto.bindActivePointerEvents = function() {
        activeEvents.forEach((eventName) => {
          window2.addEventListener(eventName, this);
        });
      };
      proto.unbindActivePointerEvents = function() {
        activeEvents.forEach((eventName) => {
          window2.removeEventListener(eventName, this);
        });
      };
      proto.withPointer = function(methodName, event) {
        if (event.pointerId === this.pointerIdentifier) {
          this[methodName](event, event);
        }
      };
      proto.withTouch = function(methodName, event) {
        let touch;
        for (let changedTouch of event.changedTouches) {
          if (changedTouch.identifier === this.pointerIdentifier) {
            touch = changedTouch;
          }
        }
        if (touch) this[methodName](event, touch);
      };
      proto.onmousedown = function(event) {
        this.pointerDown(event, event);
      };
      proto.ontouchstart = function(event) {
        this.pointerDown(event, event.changedTouches[0]);
      };
      proto.onpointerdown = function(event) {
        this.pointerDown(event, event);
      };
      const cursorNodes = ["TEXTAREA", "INPUT", "SELECT", "OPTION"];
      const clickTypes = ["radio", "checkbox", "button", "submit", "image", "file"];
      proto.pointerDown = function(event, pointer) {
        let isCursorNode = cursorNodes.includes(event.target.nodeName);
        let isClickType = clickTypes.includes(event.target.type);
        let isOkayElement = !isCursorNode || isClickType;
        let isOkay = !this.isPointerDown && !event.button && isOkayElement;
        if (!isOkay) return;
        this.isPointerDown = true;
        this.pointerIdentifier = pointer.pointerId !== void 0 ? (
          // pointerId for pointer events, touch.indentifier for touch events
          pointer.pointerId
        ) : pointer.identifier;
        this.pointerDownPointer = {
          pageX: pointer.pageX,
          pageY: pointer.pageY
        };
        this.bindActivePointerEvents();
        this.emitEvent("pointerDown", [event, pointer]);
      };
      proto.onmousemove = function(event) {
        this.pointerMove(event, event);
      };
      proto.onpointermove = function(event) {
        this.withPointer("pointerMove", event);
      };
      proto.ontouchmove = function(event) {
        this.withTouch("pointerMove", event);
      };
      proto.pointerMove = function(event, pointer) {
        let moveVector = {
          x: pointer.pageX - this.pointerDownPointer.pageX,
          y: pointer.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent("pointerMove", [event, pointer, moveVector]);
        let isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
        if (isDragStarting) this.dragStart(event, pointer);
        if (this.isDragging) this.dragMove(event, pointer, moveVector);
      };
      proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
      };
      proto.dragStart = function(event, pointer) {
        this.isDragging = true;
        this.isPreventingClicks = true;
        this.emitEvent("dragStart", [event, pointer]);
      };
      proto.dragMove = function(event, pointer, moveVector) {
        this.emitEvent("dragMove", [event, pointer, moveVector]);
      };
      proto.onmouseup = function(event) {
        this.pointerUp(event, event);
      };
      proto.onpointerup = function(event) {
        this.withPointer("pointerUp", event);
      };
      proto.ontouchend = function(event) {
        this.withTouch("pointerUp", event);
      };
      proto.pointerUp = function(event, pointer) {
        this.pointerDone();
        this.emitEvent("pointerUp", [event, pointer]);
        if (this.isDragging) {
          this.dragEnd(event, pointer);
        } else {
          this.staticClick(event, pointer);
        }
      };
      proto.dragEnd = function(event, pointer) {
        this.isDragging = false;
        setTimeout(() => delete this.isPreventingClicks);
        this.emitEvent("dragEnd", [event, pointer]);
      };
      proto.pointerDone = function() {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
        this.unbindActivePointerEvents();
        this.emitEvent("pointerDone");
      };
      proto.onpointercancel = function(event) {
        this.withPointer("pointerCancel", event);
      };
      proto.ontouchcancel = function(event) {
        this.withTouch("pointerCancel", event);
      };
      proto.pointerCancel = function(event, pointer) {
        this.pointerDone();
        this.emitEvent("pointerCancel", [event, pointer]);
      };
      proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
      };
      proto.staticClick = function(event, pointer) {
        let isMouseup = event.type === "mouseup";
        if (isMouseup && this.isIgnoringMouseUp) return;
        this.emitEvent("staticClick", [event, pointer]);
        if (isMouseup) {
          this.isIgnoringMouseUp = true;
          setTimeout(() => {
            delete this.isIgnoringMouseUp;
          }, 400);
        }
      };
      return Unidragger;
    });
  })(unidragger$1);
  return unidragger$1.exports;
}
var drag = drag$1.exports;
var hasRequiredDrag;
function requireDrag() {
  if (hasRequiredDrag) return drag$1.exports;
  hasRequiredDrag = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          window2,
          requireCore(),
          requireUnidragger(),
          requireUtils()
        );
      } else {
        window2.Flickity = factory(
          window2,
          window2.Flickity,
          window2.Unidragger,
          window2.fizzyUIUtils
        );
      }
    })(
      typeof window != "undefined" ? window : drag,
      function factory(window2, Flickity2, Unidragger, utils2) {
        Object.assign(Flickity2.defaults, {
          draggable: ">1",
          dragThreshold: 3
        });
        let proto = Flickity2.prototype;
        Object.assign(proto, Unidragger.prototype);
        proto.touchActionValue = "";
        Flickity2.create.drag = function() {
          this.on("activate", this.onActivateDrag);
          this.on("uiChange", this._uiChangeDrag);
          this.on("deactivate", this.onDeactivateDrag);
          this.on("cellChange", this.updateDraggable);
          this.on("pointerDown", this.handlePointerDown);
          this.on("pointerUp", this.handlePointerUp);
          this.on("pointerDown", this.handlePointerDone);
          this.on("dragStart", this.handleDragStart);
          this.on("dragMove", this.handleDragMove);
          this.on("dragEnd", this.handleDragEnd);
          this.on("staticClick", this.handleStaticClick);
        };
        proto.onActivateDrag = function() {
          this.handles = [this.viewport];
          this.bindHandles();
          this.updateDraggable();
        };
        proto.onDeactivateDrag = function() {
          this.unbindHandles();
          this.element.classList.remove("is-draggable");
        };
        proto.updateDraggable = function() {
          if (this.options.draggable === ">1") {
            this.isDraggable = this.slides.length > 1;
          } else {
            this.isDraggable = this.options.draggable;
          }
          this.element.classList.toggle("is-draggable", this.isDraggable);
        };
        proto._uiChangeDrag = function() {
          delete this.isFreeScrolling;
        };
        proto.handlePointerDown = function(event) {
          if (!this.isDraggable) {
            this.bindActivePointerEvents(event);
            return;
          }
          let isTouchStart = event.type === "touchstart";
          let isTouchPointer = event.pointerType === "touch";
          let isFocusNode = event.target.matches("input, textarea, select");
          if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
          if (!isFocusNode) this.focus();
          if (document.activeElement !== this.element) document.activeElement.blur();
          this.dragX = this.x;
          this.viewport.classList.add("is-pointer-down");
          this.pointerDownScroll = getScrollPosition();
          window2.addEventListener("scroll", this);
          this.bindActivePointerEvents(event);
        };
        proto.hasDragStarted = function(moveVector) {
          return Math.abs(moveVector.x) > this.options.dragThreshold;
        };
        proto.handlePointerUp = function() {
          delete this.isTouchScrolling;
          this.viewport.classList.remove("is-pointer-down");
        };
        proto.handlePointerDone = function() {
          window2.removeEventListener("scroll", this);
          delete this.pointerDownScroll;
        };
        proto.handleDragStart = function() {
          if (!this.isDraggable) return;
          this.dragStartPosition = this.x;
          this.startAnimation();
          window2.removeEventListener("scroll", this);
        };
        proto.handleDragMove = function(event, pointer, moveVector) {
          if (!this.isDraggable) return;
          event.preventDefault();
          this.previousDragX = this.dragX;
          let direction = this.options.rightToLeft ? -1 : 1;
          if (this.isWrapping) moveVector.x %= this.slideableWidth;
          let dragX = this.dragStartPosition + moveVector.x * direction;
          if (!this.isWrapping) {
            let originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            let endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
          }
          this.dragX = dragX;
          this.dragMoveTime = /* @__PURE__ */ new Date();
        };
        proto.handleDragEnd = function() {
          if (!this.isDraggable) return;
          let { freeScroll } = this.options;
          if (freeScroll) this.isFreeScrolling = true;
          let index = this.dragEndRestingSelect();
          if (freeScroll && !this.isWrapping) {
            let restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
          } else if (!freeScroll && index === this.selectedIndex) {
            index += this.dragEndBoostSelect();
          }
          delete this.previousDragX;
          this.isDragSelect = this.isWrapping;
          this.select(index);
          delete this.isDragSelect;
        };
        proto.dragEndRestingSelect = function() {
          let restingX = this.getRestingPosition();
          let distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
          let positiveResting = this._getClosestResting(restingX, distance, 1);
          let negativeResting = this._getClosestResting(restingX, distance, -1);
          return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
        };
        proto._getClosestResting = function(restingX, distance, increment) {
          let index = this.selectedIndex;
          let minDistance = Infinity;
          let condition = this.options.contain && !this.isWrapping ? (
            // if containing, keep going if distance is equal to minDistance
            (dist, minDist) => dist <= minDist
          ) : (dist, minDist) => dist < minDist;
          while (condition(distance, minDistance)) {
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
          }
          return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
          };
        };
        proto.getSlideDistance = function(x3, index) {
          let len = this.slides.length;
          let isWrapAround = this.options.wrapAround && len > 1;
          let slideIndex = isWrapAround ? utils2.modulo(index, len) : index;
          let slide2 = this.slides[slideIndex];
          if (!slide2) return null;
          let wrap2 = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
          return x3 - (slide2.target + wrap2);
        };
        proto.dragEndBoostSelect = function() {
          if (this.previousDragX === void 0 || !this.dragMoveTime || // or if drag was held for 100 ms
          /* @__PURE__ */ new Date() - this.dragMoveTime > 100) {
            return 0;
          }
          let distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
          let delta = this.previousDragX - this.dragX;
          if (distance > 0 && delta > 0) {
            return 1;
          } else if (distance < 0 && delta < 0) {
            return -1;
          }
          return 0;
        };
        proto.onscroll = function() {
          let scroll = getScrollPosition();
          let scrollMoveX = this.pointerDownScroll.x - scroll.x;
          let scrollMoveY = this.pointerDownScroll.y - scroll.y;
          if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
            this.pointerDone();
          }
        };
        function getScrollPosition() {
          return {
            x: window2.pageXOffset,
            y: window2.pageYOffset
          };
        }
        return Flickity2;
      }
    );
  })(drag$1);
  return drag$1.exports;
}
var prevNextButton$1 = { exports: {} };
var prevNextButton = prevNextButton$1.exports;
var hasRequiredPrevNextButton;
function requirePrevNextButton() {
  if (hasRequiredPrevNextButton) return prevNextButton$1.exports;
  hasRequiredPrevNextButton = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(requireCore());
      } else {
        factory(window2.Flickity);
      }
    })(typeof window != "undefined" ? window : prevNextButton, function factory(Flickity2) {
      const svgURI = "http://www.w3.org/2000/svg";
      function PrevNextButton(increment, direction, arrowShape) {
        this.increment = increment;
        this.direction = direction;
        this.isPrevious = increment === "previous";
        this.isLeft = direction === "left";
        this._create(arrowShape);
      }
      PrevNextButton.prototype._create = function(arrowShape) {
        let element = this.element = document.createElement("button");
        element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
        let label = this.isPrevious ? "Previous" : "Next";
        element.setAttribute("type", "button");
        element.setAttribute("aria-label", label);
        this.disable();
        let svg = this.createSVG(label, arrowShape);
        element.append(svg);
      };
      PrevNextButton.prototype.createSVG = function(label, arrowShape) {
        let svg = document.createElementNS(svgURI, "svg");
        svg.setAttribute("class", "flickity-button-icon");
        svg.setAttribute("viewBox", "0 0 100 100");
        let title = document.createElementNS(svgURI, "title");
        title.append(label);
        let path = document.createElementNS(svgURI, "path");
        let pathMovements = getArrowMovements(arrowShape);
        path.setAttribute("d", pathMovements);
        path.setAttribute("class", "arrow");
        if (!this.isLeft) {
          path.setAttribute("transform", "translate(100, 100) rotate(180)");
        }
        svg.append(title, path);
        return svg;
      };
      function getArrowMovements(shape) {
        if (typeof shape == "string") return shape;
        let { x0, x1, x2: x22, x3, y1, y2: y22 } = shape;
        return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x22}, ${y22 + 50}
    L ${x3}, 50
    L ${x22}, ${50 - y22}
    L ${x1}, ${50 - y1}
    Z`;
      }
      PrevNextButton.prototype.enable = function() {
        this.element.removeAttribute("disabled");
      };
      PrevNextButton.prototype.disable = function() {
        this.element.setAttribute("disabled", true);
      };
      Object.assign(Flickity2.defaults, {
        prevNextButtons: true,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 70,
          y2: 40,
          x3: 30
        }
      });
      Flickity2.create.prevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        let { rightToLeft, arrowShape } = this.options;
        let prevDirection = rightToLeft ? "right" : "left";
        let nextDirection = rightToLeft ? "left" : "right";
        this.prevButton = new PrevNextButton("previous", prevDirection, arrowShape);
        this.nextButton = new PrevNextButton("next", nextDirection, arrowShape);
        this.focusableElems.push(this.prevButton.element);
        this.focusableElems.push(this.nextButton.element);
        this.handlePrevButtonClick = () => {
          this.uiChange();
          this.previous();
        };
        this.handleNextButtonClick = () => {
          this.uiChange();
          this.next();
        };
        this.on("activate", this.activatePrevNextButtons);
        this.on("select", this.updatePrevNextButtons);
      };
      let proto = Flickity2.prototype;
      proto.updatePrevNextButtons = function() {
        let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0);
        this.updatePrevNextButton(this.nextButton, lastIndex);
      };
      proto.updatePrevNextButton = function(button, disabledIndex) {
        if (this.isWrapping && this.slides.length > 1) {
          button.enable();
          return;
        }
        let isEnabled2 = this.selectedIndex !== disabledIndex;
        button[isEnabled2 ? "enable" : "disable"]();
        let isDisabledFocused = !isEnabled2 && document.activeElement === button.element;
        if (isDisabledFocused) this.focus();
      };
      proto.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener("click", this.handlePrevButtonClick);
        this.nextButton.element.addEventListener("click", this.handleNextButtonClick);
        this.element.append(this.prevButton.element, this.nextButton.element);
        this.on("deactivate", this.deactivatePrevNextButtons);
      };
      proto.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove();
        this.nextButton.element.remove();
        this.prevButton.element.removeEventListener("click", this.handlePrevButtonClick);
        this.nextButton.element.removeEventListener("click", this.handleNextButtonClick);
        this.off("deactivate", this.deactivatePrevNextButtons);
      };
      Flickity2.PrevNextButton = PrevNextButton;
      return Flickity2;
    });
  })(prevNextButton$1);
  return prevNextButton$1.exports;
}
var pageDots$1 = { exports: {} };
var pageDots = pageDots$1.exports;
var hasRequiredPageDots;
function requirePageDots() {
  if (hasRequiredPageDots) return pageDots$1.exports;
  hasRequiredPageDots = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireCore(),
          requireUtils()
        );
      } else {
        factory(
          window2.Flickity,
          window2.fizzyUIUtils
        );
      }
    })(typeof window != "undefined" ? window : pageDots, function factory(Flickity2, utils2) {
      function PageDots() {
        this.holder = document.createElement("div");
        this.holder.className = "flickity-page-dots";
        this.dots = [];
      }
      PageDots.prototype.setDots = function(slidesLength) {
        let delta = slidesLength - this.dots.length;
        if (delta > 0) {
          this.addDots(delta);
        } else if (delta < 0) {
          this.removeDots(-delta);
        }
      };
      PageDots.prototype.addDots = function(count) {
        let newDots = new Array(count).fill().map((item, i) => {
          let dot = document.createElement("button");
          dot.setAttribute("type", "button");
          let num = i + 1 + this.dots.length;
          dot.className = "flickity-page-dot";
          dot.textContent = `View slide ${num}`;
          return dot;
        });
        this.holder.append(...newDots);
        this.dots = this.dots.concat(newDots);
      };
      PageDots.prototype.removeDots = function(count) {
        let removeDots = this.dots.splice(this.dots.length - count, count);
        removeDots.forEach((dot) => dot.remove());
      };
      PageDots.prototype.updateSelected = function(index) {
        if (this.selectedDot) {
          this.selectedDot.classList.remove("is-selected");
          this.selectedDot.removeAttribute("aria-current");
        }
        if (!this.dots.length) return;
        this.selectedDot = this.dots[index];
        this.selectedDot.classList.add("is-selected");
        this.selectedDot.setAttribute("aria-current", "step");
      };
      Flickity2.PageDots = PageDots;
      Object.assign(Flickity2.defaults, {
        pageDots: true
      });
      Flickity2.create.pageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots();
        this.handlePageDotsClick = this.onPageDotsClick.bind(this);
        this.on("activate", this.activatePageDots);
        this.on("select", this.updateSelectedPageDots);
        this.on("cellChange", this.updatePageDots);
        this.on("resize", this.updatePageDots);
        this.on("deactivate", this.deactivatePageDots);
      };
      let proto = Flickity2.prototype;
      proto.activatePageDots = function() {
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
        this.pageDots.holder.addEventListener("click", this.handlePageDotsClick);
        this.element.append(this.pageDots.holder);
      };
      proto.onPageDotsClick = function(event) {
        let index = this.pageDots.dots.indexOf(event.target);
        if (index === -1) return;
        this.uiChange();
        this.select(index);
      };
      proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex);
      };
      proto.updatePageDots = function() {
        this.pageDots.dots.forEach((dot) => {
          utils2.removeFrom(this.focusableElems, dot);
        });
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
      };
      proto.deactivatePageDots = function() {
        this.pageDots.holder.remove();
        this.pageDots.holder.removeEventListener("click", this.handlePageDotsClick);
      };
      Flickity2.PageDots = PageDots;
      return Flickity2;
    });
  })(pageDots$1);
  return pageDots$1.exports;
}
var player$1 = { exports: {} };
var player = player$1.exports;
var hasRequiredPlayer;
function requirePlayer() {
  if (hasRequiredPlayer) return player$1.exports;
  hasRequiredPlayer = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(requireCore());
      } else {
        factory(window2.Flickity);
      }
    })(typeof window != "undefined" ? window : player, function factory(Flickity2) {
      function Player(autoPlay, onTick) {
        this.autoPlay = autoPlay;
        this.onTick = onTick;
        this.state = "stopped";
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
      }
      Player.prototype.play = function() {
        if (this.state === "playing") return;
        let isPageHidden = document.hidden;
        if (isPageHidden) {
          document.addEventListener("visibilitychange", this.onVisibilityPlay);
          return;
        }
        this.state = "playing";
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        this.tick();
      };
      Player.prototype.tick = function() {
        if (this.state !== "playing") return;
        let time = typeof this.autoPlay == "number" ? this.autoPlay : 3e3;
        this.clear();
        this.timeout = setTimeout(() => {
          this.onTick();
          this.tick();
        }, time);
      };
      Player.prototype.stop = function() {
        this.state = "stopped";
        this.clear();
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
      };
      Player.prototype.clear = function() {
        clearTimeout(this.timeout);
      };
      Player.prototype.pause = function() {
        if (this.state === "playing") {
          this.state = "paused";
          this.clear();
        }
      };
      Player.prototype.unpause = function() {
        if (this.state === "paused") this.play();
      };
      Player.prototype.visibilityChange = function() {
        let isPageHidden = document.hidden;
        this[isPageHidden ? "pause" : "unpause"]();
      };
      Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener("visibilitychange", this.onVisibilityPlay);
      };
      Object.assign(Flickity2.defaults, {
        pauseAutoPlayOnHover: true
      });
      Flickity2.create.player = function() {
        this.player = new Player(this.options.autoPlay, () => {
          this.next(true);
        });
        this.on("activate", this.activatePlayer);
        this.on("uiChange", this.stopPlayer);
        this.on("pointerDown", this.stopPlayer);
        this.on("deactivate", this.deactivatePlayer);
      };
      let proto = Flickity2.prototype;
      proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener("mouseenter", this);
      };
      proto.playPlayer = function() {
        this.player.play();
      };
      proto.stopPlayer = function() {
        this.player.stop();
      };
      proto.pausePlayer = function() {
        this.player.pause();
      };
      proto.unpausePlayer = function() {
        this.player.unpause();
      };
      proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener("mouseenter", this);
      };
      proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener("mouseleave", this);
      };
      proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener("mouseleave", this);
      };
      Flickity2.Player = Player;
      return Flickity2;
    });
  })(player$1);
  return player$1.exports;
}
var addRemoveCell$1 = { exports: {} };
var addRemoveCell = addRemoveCell$1.exports;
var hasRequiredAddRemoveCell;
function requireAddRemoveCell() {
  if (hasRequiredAddRemoveCell) return addRemoveCell$1.exports;
  hasRequiredAddRemoveCell = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireCore(),
          requireUtils()
        );
      } else {
        factory(
          window2.Flickity,
          window2.fizzyUIUtils
        );
      }
    })(typeof window != "undefined" ? window : addRemoveCell, function factory(Flickity2, utils2) {
      function getCellsFragment(cells) {
        let fragment = document.createDocumentFragment();
        cells.forEach((cell2) => fragment.appendChild(cell2.element));
        return fragment;
      }
      let proto = Flickity2.prototype;
      proto.insert = function(elems, index) {
        let cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        let len = this.cells.length;
        index = index === void 0 ? len : index;
        let fragment = getCellsFragment(cells);
        let isAppend = index === len;
        if (isAppend) {
          this.slider.appendChild(fragment);
        } else {
          let insertCellElement = this.cells[index].element;
          this.slider.insertBefore(fragment, insertCellElement);
        }
        if (index === 0) {
          this.cells = cells.concat(this.cells);
        } else if (isAppend) {
          this.cells = this.cells.concat(cells);
        } else {
          let endCells = this.cells.splice(index, len - index);
          this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index);
        this.positionSliderAtSelected();
      };
      proto.append = function(elems) {
        this.insert(elems, this.cells.length);
      };
      proto.prepend = function(elems) {
        this.insert(elems, 0);
      };
      proto.remove = function(elems) {
        let cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        let minCellIndex = this.cells.length - 1;
        cells.forEach((cell2) => {
          cell2.remove();
          let index = this.cells.indexOf(cell2);
          minCellIndex = Math.min(index, minCellIndex);
          utils2.removeFrom(this.cells, cell2);
        });
        this.cellChange(minCellIndex);
        this.positionSliderAtSelected();
      };
      proto.cellSizeChange = function(elem) {
        let cell2 = this.getCell(elem);
        if (!cell2) return;
        cell2.getSize();
        let index = this.cells.indexOf(cell2);
        this.cellChange(index);
      };
      proto.cellChange = function(changedCellIndex) {
        let prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._updateWrapShiftCells();
        this.setGallerySize();
        let cell2 = this.getCell(prevSelectedElem);
        if (cell2) this.selectedIndex = this.getCellSlideIndex(cell2);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent("cellChange", [changedCellIndex]);
        this.select(this.selectedIndex);
      };
      return Flickity2;
    });
  })(addRemoveCell$1);
  return addRemoveCell$1.exports;
}
var lazyload$1 = { exports: {} };
var lazyload = lazyload$1.exports;
var hasRequiredLazyload;
function requireLazyload() {
  if (hasRequiredLazyload) return lazyload$1.exports;
  hasRequiredLazyload = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireCore(),
          requireUtils()
        );
      } else {
        factory(
          window2.Flickity,
          window2.fizzyUIUtils
        );
      }
    })(typeof window != "undefined" ? window : lazyload, function factory(Flickity2, utils2) {
      const lazyAttr = "data-flickity-lazyload";
      const lazySrcAttr = `${lazyAttr}-src`;
      const lazySrcsetAttr = `${lazyAttr}-srcset`;
      const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;
      Flickity2.create.lazyLoad = function() {
        this.on("select", this.lazyLoad);
        this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
      };
      let proto = Flickity2.prototype;
      proto.lazyLoad = function() {
        let { lazyLoad } = this.options;
        if (!lazyLoad) return;
        let adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
        this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach((img) => new LazyLoader(img, this.handleLazyLoadComplete));
      };
      function getCellLazyImages(cellElem) {
        if (cellElem.matches("img")) {
          let cellAttr = cellElem.getAttribute(lazyAttr);
          let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
          let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
          if (cellAttr || cellSrcAttr || cellSrcsetAttr) {
            return cellElem;
          }
        }
        return [...cellElem.querySelectorAll(imgSelector)];
      }
      proto.onLazyLoadComplete = function(img, event) {
        let cell2 = this.getParentCell(img);
        let cellElem = cell2 && cell2.element;
        this.cellSizeChange(cellElem);
        this.dispatchEvent("lazyLoad", event, cellElem);
      };
      function LazyLoader(img, onComplete) {
        this.img = img;
        this.onComplete = onComplete;
        this.load();
      }
      LazyLoader.prototype.handleEvent = utils2.handleEvent;
      LazyLoader.prototype.load = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        let src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
        let srcset = this.img.getAttribute(lazySrcsetAttr);
        this.img.src = src;
        if (srcset) this.img.setAttribute("srcset", srcset);
        this.img.removeAttribute(lazyAttr);
        this.img.removeAttribute(lazySrcAttr);
        this.img.removeAttribute(lazySrcsetAttr);
      };
      LazyLoader.prototype.onload = function(event) {
        this.complete(event, "flickity-lazyloaded");
      };
      LazyLoader.prototype.onerror = function(event) {
        this.complete(event, "flickity-lazyerror");
      };
      LazyLoader.prototype.complete = function(event, className) {
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
        let mediaElem = this.img.parentNode.matches("picture") ? this.img.parentNode : this.img;
        mediaElem.classList.add(className);
        this.onComplete(this.img, event);
      };
      Flickity2.LazyLoader = LazyLoader;
      return Flickity2;
    });
  })(lazyload$1);
  return lazyload$1.exports;
}
var imagesloaded$3 = { exports: {} };
var imagesloaded$2 = { exports: {} };
/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
var imagesloaded$1 = imagesloaded$2.exports;
var hasRequiredImagesloaded$1;
function requireImagesloaded$1() {
  if (hasRequiredImagesloaded$1) return imagesloaded$2.exports;
  hasRequiredImagesloaded$1 = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(window2, requireEvEmitter());
      } else {
        window2.imagesLoaded = factory(window2, window2.EvEmitter);
      }
    })(
      typeof window !== "undefined" ? window : imagesloaded$1,
      function factory(window2, EvEmitter) {
        let $ = window2.jQuery;
        let console2 = window2.console;
        function makeArray(obj) {
          if (Array.isArray(obj)) return obj;
          let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
          if (isArrayLike) return [...obj];
          return [obj];
        }
        function ImagesLoaded(elem, options, onAlways) {
          if (!(this instanceof ImagesLoaded)) {
            return new ImagesLoaded(elem, options, onAlways);
          }
          let queryElem = elem;
          if (typeof elem == "string") {
            queryElem = document.querySelectorAll(elem);
          }
          if (!queryElem) {
            console2.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
          }
          this.elements = makeArray(queryElem);
          this.options = {};
          if (typeof options == "function") {
            onAlways = options;
          } else {
            Object.assign(this.options, options);
          }
          if (onAlways) this.on("always", onAlways);
          this.getImages();
          if ($) this.jqDeferred = new $.Deferred();
          setTimeout(this.check.bind(this));
        }
        ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
        ImagesLoaded.prototype.getImages = function() {
          this.images = [];
          this.elements.forEach(this.addElementImages, this);
        };
        const elementNodeTypes = [1, 9, 11];
        ImagesLoaded.prototype.addElementImages = function(elem) {
          if (elem.nodeName === "IMG") {
            this.addImage(elem);
          }
          if (this.options.background === true) {
            this.addElementBackgroundImages(elem);
          }
          let { nodeType } = elem;
          if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
          let childImgs = elem.querySelectorAll("img");
          for (let img of childImgs) {
            this.addImage(img);
          }
          if (typeof this.options.background == "string") {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children) {
              this.addElementBackgroundImages(child);
            }
          }
        };
        const reURL = /url\((['"])?(.*?)\1\)/gi;
        ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
          let style = getComputedStyle(elem);
          if (!style) return;
          let matches = reURL.exec(style.backgroundImage);
          while (matches !== null) {
            let url = matches && matches[2];
            if (url) {
              this.addBackground(url, elem);
            }
            matches = reURL.exec(style.backgroundImage);
          }
        };
        ImagesLoaded.prototype.addImage = function(img) {
          let loadingImage = new LoadingImage(img);
          this.images.push(loadingImage);
        };
        ImagesLoaded.prototype.addBackground = function(url, elem) {
          let background = new Background(url, elem);
          this.images.push(background);
        };
        ImagesLoaded.prototype.check = function() {
          this.progressedCount = 0;
          this.hasAnyBroken = false;
          if (!this.images.length) {
            this.complete();
            return;
          }
          let onProgress = (image, elem, message) => {
            setTimeout(() => {
              this.progress(image, elem, message);
            });
          };
          this.images.forEach(function(loadingImage) {
            loadingImage.once("progress", onProgress);
            loadingImage.check();
          });
        };
        ImagesLoaded.prototype.progress = function(image, elem, message) {
          this.progressedCount++;
          this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
          this.emitEvent("progress", [this, image, elem]);
          if (this.jqDeferred && this.jqDeferred.notify) {
            this.jqDeferred.notify(this, image);
          }
          if (this.progressedCount === this.images.length) {
            this.complete();
          }
          if (this.options.debug && console2) {
            console2.log(`progress: ${message}`, image, elem);
          }
        };
        ImagesLoaded.prototype.complete = function() {
          let eventName = this.hasAnyBroken ? "fail" : "done";
          this.isComplete = true;
          this.emitEvent(eventName, [this]);
          this.emitEvent("always", [this]);
          if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[jqMethod](this);
          }
        };
        function LoadingImage(img) {
          this.img = img;
        }
        LoadingImage.prototype = Object.create(EvEmitter.prototype);
        LoadingImage.prototype.check = function() {
          let isComplete = this.getIsImageComplete();
          if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            return;
          }
          this.proxyImage = new Image();
          if (this.img.crossOrigin) {
            this.proxyImage.crossOrigin = this.img.crossOrigin;
          }
          this.proxyImage.addEventListener("load", this);
          this.proxyImage.addEventListener("error", this);
          this.img.addEventListener("load", this);
          this.img.addEventListener("error", this);
          this.proxyImage.src = this.img.currentSrc || this.img.src;
        };
        LoadingImage.prototype.getIsImageComplete = function() {
          return this.img.complete && this.img.naturalWidth;
        };
        LoadingImage.prototype.confirm = function(isLoaded, message) {
          this.isLoaded = isLoaded;
          let { parentNode } = this.img;
          let elem = parentNode.nodeName === "PICTURE" ? parentNode : this.img;
          this.emitEvent("progress", [this, elem, message]);
        };
        LoadingImage.prototype.handleEvent = function(event) {
          let method = "on" + event.type;
          if (this[method]) {
            this[method](event);
          }
        };
        LoadingImage.prototype.onload = function() {
          this.confirm(true, "onload");
          this.unbindEvents();
        };
        LoadingImage.prototype.onerror = function() {
          this.confirm(false, "onerror");
          this.unbindEvents();
        };
        LoadingImage.prototype.unbindEvents = function() {
          this.proxyImage.removeEventListener("load", this);
          this.proxyImage.removeEventListener("error", this);
          this.img.removeEventListener("load", this);
          this.img.removeEventListener("error", this);
        };
        function Background(url, element) {
          this.url = url;
          this.element = element;
          this.img = new Image();
        }
        Background.prototype = Object.create(LoadingImage.prototype);
        Background.prototype.check = function() {
          this.img.addEventListener("load", this);
          this.img.addEventListener("error", this);
          this.img.src = this.url;
          let isComplete = this.getIsImageComplete();
          if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            this.unbindEvents();
          }
        };
        Background.prototype.unbindEvents = function() {
          this.img.removeEventListener("load", this);
          this.img.removeEventListener("error", this);
        };
        Background.prototype.confirm = function(isLoaded, message) {
          this.isLoaded = isLoaded;
          this.emitEvent("progress", [this, this.element, message]);
        };
        ImagesLoaded.makeJQueryPlugin = function(jQuery) {
          jQuery = jQuery || window2.jQuery;
          if (!jQuery) return;
          $ = jQuery;
          $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
          };
        };
        ImagesLoaded.makeJQueryPlugin();
        return ImagesLoaded;
      }
    );
  })(imagesloaded$2);
  return imagesloaded$2.exports;
}
var imagesloaded = imagesloaded$3.exports;
var hasRequiredImagesloaded;
function requireImagesloaded() {
  if (hasRequiredImagesloaded) return imagesloaded$3.exports;
  hasRequiredImagesloaded = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireCore(),
          requireImagesloaded$1()
        );
      } else {
        factory(
          window2.Flickity,
          window2.imagesLoaded
        );
      }
    })(
      typeof window != "undefined" ? window : imagesloaded,
      function factory(Flickity2, imagesLoaded) {
        Flickity2.create.imagesLoaded = function() {
          this.on("activate", this.imagesLoaded);
        };
        Flickity2.prototype.imagesLoaded = function() {
          if (!this.options.imagesLoaded) return;
          let onImagesLoadedProgress = (instance, image) => {
            let cell2 = this.getParentCell(image.img);
            this.cellSizeChange(cell2 && cell2.element);
            if (!this.options.freeScroll) this.positionSliderAtSelected();
          };
          imagesLoaded(this.slider).on("progress", onImagesLoadedProgress);
        };
        return Flickity2;
      }
    );
  })(imagesloaded$3);
  return imagesloaded$3.exports;
}
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */
var hasRequiredJs;
function requireJs() {
  if (hasRequiredJs) return js.exports;
  hasRequiredJs = 1;
  (function(module) {
    if (module.exports) {
      const Flickity2 = requireCore();
      requireDrag();
      requirePrevNextButton();
      requirePageDots();
      requirePlayer();
      requireAddRemoveCell();
      requireLazyload();
      requireImagesloaded();
      module.exports = Flickity2;
    }
  })(js);
  return js.exports;
}
var jsExports = requireJs();
const Flickity = /* @__PURE__ */ getDefaultExportFromCjs(jsExports);
const selectors$5 = {
  tabsSection: ".tabs-section",
  tabsCarousel: ".tabs-section__block",
  blockSlider: ".tabs-section__block-slider",
  prevButton: ".tabs-section-prev-btn",
  nextButton: ".tabs-section-next-btn",
  firstTabBtn: "#tabBtnFirst",
  secondTabBtn: "#tabBtnSecond",
  tabFirst: ".tabs-section__block-first",
  tabSecond: ".tabs-section__block-second"
};
document.addEventListener("DOMContentLoaded", function() {
  const tabsSection = document.querySelector(selectors$5.tabsSection);
  if (tabsSection) {
    let toggleTab2 = function(activeBtn, inactiveBtn, activeTab, inactiveTab) {
      if (activeBtn.classList.contains("active")) {
        activeBtn.classList.remove("active");
        activeTab.classList.add("tab-hidden");
      } else {
        inactiveBtn.classList.remove("active");
        inactiveTab.classList.add("tab-hidden");
        activeBtn.classList.add("active");
        activeTab.classList.remove("tab-hidden");
      }
    }, initializeSliders2 = function() {
      if (window.innerWidth < 1e3 && flktyInstances.length === 0) {
        const tabsCarousel = tabsSection == null ? void 0 : tabsSection.querySelectorAll(selectors$5.tabsCarousel);
        tabsCarousel.forEach((tab, index) => {
          const sliderBlock = tab.querySelector(selectors$5.blockSlider);
          const prevButton2 = tab.querySelector(selectors$5.prevButton);
          const nextButton2 = tab.querySelector(selectors$5.nextButton);
          if (sliderBlock) {
            let updateButtonState2 = function() {
              prevButton2.disabled = flkty.selectedIndex === 0;
              nextButton2.disabled = flkty.selectedIndex === flkty.slides.length - 1;
            };
            var updateButtonState = updateButtonState2;
            const flkty = new Flickity(sliderBlock, {
              cellAlign: "left",
              contain: true,
              prevNextButtons: false,
              pageDots: false
            });
            updateButtonState2();
            prevButton2.addEventListener("click", function() {
              flkty.previous();
            });
            nextButton2.addEventListener("click", function() {
              flkty.next();
            });
            flkty.on("change", updateButtonState2);
            flktyInstances[index] = flkty;
          }
        });
      }
    }, destroySliders2 = function() {
      if (window.innerWidth >= 1e3 && flktyInstances.length > 0) {
        flktyInstances.forEach((flkty) => {
          if (flkty) {
            flkty.destroy();
          }
        });
        flktyInstances = [];
      }
    };
    var toggleTab = toggleTab2, initializeSliders = initializeSliders2, destroySliders = destroySliders2;
    const firstTabBtn = document.querySelector(selectors$5.firstTabBtn);
    const tabFirst = document.querySelector(selectors$5.tabFirst);
    const secondTabBtn = document.querySelector(selectors$5.secondTabBtn);
    const tabSecond = document.querySelector(selectors$5.tabSecond);
    firstTabBtn == null ? void 0 : firstTabBtn.addEventListener("click", () => {
      toggleTab2(firstTabBtn, secondTabBtn, tabFirst, tabSecond);
    });
    secondTabBtn == null ? void 0 : secondTabBtn.addEventListener("click", () => {
      toggleTab2(secondTabBtn, firstTabBtn, tabSecond, tabFirst);
    });
    let flktyInstances = [];
    initializeSliders2();
    window.addEventListener("resize", function() {
      if (window.innerWidth < 1e3) {
        initializeSliders2();
      } else {
        destroySliders2();
      }
    });
  }
});
const selectors$4 = {
  carouselContainer: ".product-carousel__body",
  carouselProducts: ".product-carousel__product",
  featuredProducts: ".product.product-carousel__product-wrapper",
  prevButton: '.product-carousel__button[data-action="prev"]',
  nextButton: '.product-carousel__button[data-action="next"]'
};
const carouselProducts = document.querySelectorAll(selectors$4.carouselProducts);
const featuredProducts = document.querySelectorAll(selectors$4.featuredProducts);
const prevButton = document.querySelector(selectors$4.prevButton);
const nextButton = document.querySelector(selectors$4.nextButton);
let carouselContainer = document.querySelector(selectors$4.carouselContainer);
let isScrollCarouselEnabled = null;
function goToNextProduct() {
  let currentIndex = Array.from(carouselProducts).findIndex((prod) => prod.getAttribute("data-selected") === "true");
  let nextIndex = (currentIndex + 1) % carouselProducts.length;
  updateSelection(nextIndex);
}
function goToPrevProduct() {
  let currentIndex = Array.from(carouselProducts).findIndex((prod) => prod.getAttribute("data-selected") === "true");
  let prevIndex = (currentIndex - 1 + carouselProducts.length) % carouselProducts.length;
  updateSelection(prevIndex);
}
function updateSelection(newIndex) {
  carouselProducts.forEach((prod, index) => {
    prod.setAttribute("data-selected", "false");
    featuredProducts[index].setAttribute("data-selected", "false");
  });
  carouselProducts[newIndex].setAttribute("data-selected", "true");
  featuredProducts[newIndex].setAttribute("data-selected", "true");
  const container = carouselProducts[newIndex].parentElement;
  const containerWidth = container.offsetWidth;
  const itemLeft = carouselProducts[newIndex].offsetLeft;
  const itemRight = itemLeft + carouselProducts[newIndex].offsetWidth;
  if (itemLeft < container.scrollLeft) {
    container.scrollLeft = itemLeft - 40;
  } else if (itemRight > container.scrollLeft + containerWidth) {
    container.scrollLeft = itemRight - containerWidth + 40;
  }
  window.dispatchEvent(new Event("resize", { bubbles: true }));
}
function isScrollEnabled(container) {
  if (container) {
    return container.scrollWidth > container.clientWidth;
  }
}
if (carouselContainer) {
  isScrollCarouselEnabled = isScrollEnabled(carouselContainer);
  carouselContainer == null ? void 0 : carouselContainer.setAttribute("data-scroll", isScrollCarouselEnabled);
}
window.addEventListener("resize", () => {
  carouselContainer = document.querySelector(selectors$4.carouselContainer);
  if (carouselContainer) {
    isScrollCarouselEnabled = isScrollEnabled(carouselContainer);
    carouselContainer.setAttribute("data-scroll", isScrollCarouselEnabled);
  }
});
if (carouselProducts && featuredProducts) {
  carouselProducts.forEach((product, index) => {
    product.addEventListener("click", () => updateSelection(index));
  });
}
if (prevButton && nextButton) {
  prevButton.addEventListener("click", goToPrevProduct);
  nextButton.addEventListener("click", goToNextProduct);
}
function updateFlickityConfig(carousel) {
  if (!carousel) return;
  carousel.flickityInstance.then((instance) => {
    if (!instance) return;
    const isMobile = window.innerWidth < 1e3;
    instance.options.contain = !isMobile;
    instance.options.cellAlign = isMobile ? "left" : "center";
    instance.reposition();
    updateButtonStates(carousel, instance);
  }).catch(() => {
  });
}
function refreshFlickityLayout(carousel) {
  if (!carousel) return;
  carousel.flickityInstance.then((instance) => {
    if (!instance) return;
    instance.reloadCells();
    instance.resize();
    instance.reposition();
    updateButtonStates(carousel, instance);
  }).catch(() => {
  });
}
function updateButtonStates(carousel, instance) {
  if (!instance || !carousel) return;
  const carouselId = carousel.id;
  const controls = document.querySelector(`flickity-controls[controls="${carouselId}"]`);
  if (!controls) return;
  const prevButton2 = controls.querySelector('[data-action="prev"]');
  const nextButton2 = controls.querySelector('[data-action="next"]');
  if (!prevButton2 || !nextButton2) return;
  const currentIndex = instance.selectedIndex;
  const totalSlides = instance.slides ? instance.slides.length : instance.cells.length;
  prevButton2.disabled = currentIndex === 0;
  nextButton2.disabled = currentIndex >= totalSlides - 1;
}
function initProductMediaFlickity() {
  const carousels = document.querySelectorAll(".product__media-list");
  carousels.forEach((carousel) => {
    if (carousel.hasAttribute("data-flickity-initialized")) return;
    carousel.setAttribute("data-flickity-initialized", "true");
    setTimeout(() => updateFlickityConfig(carousel), 100);
    setTimeout(() => refreshFlickityLayout(carousel), 220);
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateFlickityConfig(carousel);
      }, 150);
    });
    carousel.addEventListener("flickity:ready", () => {
      updateFlickityConfig(carousel);
    });
    carousel.addEventListener("flickity:slide-changed", () => {
      carousel.flickityInstance.then((instance) => {
        updateButtonStates(carousel, instance);
      }).catch(() => {
      });
    });
    const images = carousel.querySelectorAll("img");
    images.forEach((img) => {
      if (img.complete) {
        setTimeout(() => refreshFlickityLayout(carousel), 0);
        return;
      }
      img.addEventListener("load", () => refreshFlickityLayout(carousel), { once: true });
      img.addEventListener("error", () => refreshFlickityLayout(carousel), { once: true });
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductMediaFlickity);
} else {
  initProductMediaFlickity();
}
function initPdpVideoControls() {
  const wrappers = document.querySelectorAll("[data-pdp-video]");
  if (!wrappers.length) return;
  wrappers.forEach(function(wrapper) {
    if (wrapper.dataset.pdpVideoControlsInit === "true") return;
    wrapper.dataset.pdpVideoControlsInit = "true";
    const item = wrapper.closest(".product__media-item") || wrapper.parentElement;
    const controls = item ? item.querySelector("[data-pdp-video-controls]") : null;
    if (!controls) return;
    if (!wrapper.querySelector("video") && typeof wrapper._replaceContent === "function") {
      try {
        wrapper._replaceContent();
      } catch (e) {
      }
    }
    const preloadVideo = wrapper.querySelector("video");
    if (preloadVideo) {
      const warmup = preloadVideo.play();
      if (warmup && typeof warmup.then === "function") {
        warmup.then(function() {
          preloadVideo.pause();
          preloadVideo.currentTime = 0;
        }).catch(function() {
        });
      }
    }
    const playBtn = controls.querySelector("[data-pdp-video-play]");
    const muteBtn = controls.querySelector("[data-pdp-video-mute]");
    let videoEl = null;
    function syncPlayState() {
      if (!videoEl) return;
      const isPlaying = !videoEl.paused && !videoEl.ended;
      controls.classList.toggle("is-playing", isPlaying);
      if (playBtn) {
        playBtn.setAttribute("aria-pressed", String(isPlaying));
      }
    }
    function syncMuteState() {
      if (!videoEl) return;
      controls.classList.toggle("is-muted", videoEl.muted);
      if (muteBtn) {
        muteBtn.setAttribute("aria-pressed", String(videoEl.muted));
      }
    }
    function attachVideo(el) {
      if (!el || videoEl === el) return;
      videoEl = el;
      videoEl.addEventListener("play", syncPlayState);
      videoEl.addEventListener("playing", syncPlayState);
      videoEl.addEventListener("pause", syncPlayState);
      videoEl.addEventListener("ended", syncPlayState);
      videoEl.addEventListener("volumechange", syncMuteState);
      syncPlayState();
      syncMuteState();
    }
    const existing = wrapper.querySelector("video");
    if (existing) attachVideo(existing);
    if (!videoEl) {
      const observer = new MutationObserver(function() {
        const el = wrapper.querySelector("video");
        if (el) {
          attachVideo(el);
          observer.disconnect();
        }
      });
      observer.observe(wrapper, { childList: true, subtree: true });
    }
    if (playBtn) {
      playBtn.addEventListener("click", function(e) {
        e.stopPropagation();
        if (!videoEl) {
          if (typeof wrapper.play === "function") wrapper.play();
          videoEl = wrapper.querySelector("video");
          if (videoEl) attachVideo(videoEl);
          return;
        }
        if (videoEl.paused || videoEl.ended) {
          const p2 = videoEl.play();
          if (p2 && typeof p2.catch === "function") p2.catch(function() {
          });
        } else {
          videoEl.pause();
        }
        syncPlayState();
      });
    }
    if (muteBtn) {
      muteBtn.addEventListener("click", function(e) {
        e.stopPropagation();
        if (!videoEl) return;
        videoEl.muted = !videoEl.muted;
        syncMuteState();
      });
    }
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPdpVideoControls);
} else {
  initPdpVideoControls();
}
document.addEventListener("shopify:section:load", initPdpVideoControls);
const boxBuilder = document.querySelector(".box-builder-banner");
const getStartedBtn = document.querySelectorAll(".getStartedBtn");
if (getStartedBtn.length > 0 && boxBuilder) {
  const boxBuilderHeight = boxBuilder.offsetHeight;
  getStartedBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      window.scrollTo({
        top: boxBuilderHeight + 1,
        behavior: "smooth"
      });
    });
  });
}
(() => {
  function waitFor(t, i, o = false, a = 1e4, e = 25) {
    a < 0 || (t() ? i() : setTimeout(() => {
      o && waitFor(t, i, o, a, e);
      o || waitFor(t, i, o, a - e, e);
    }, e));
  }
  function q(s, o) {
    return document.querySelector(s);
  }
  function insert(target, position, element, exists) {
    if (!exists) {
      typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
    }
  }
  var VAR = "1";
  var EXPID = "HLY-7";
  function testInfo() {
    window.runningExperiments = window.runningExperiments || {};
    window.runningExperiments[EXPID] = {
      name: "Add paypal badge to USP section on PDP",
      variation: `${VAR}`,
      logs: []
    };
    waitFor(
      () => q("body"),
      () => {
        q("body").classList.add(`${EXPID}`);
      }
    );
  }
  function insertPaypalSection() {
    const paypalSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
    <path d="M15.1658 9.84595C14.9826 9.8461 14.8055 9.91158 14.6662 10.0306C14.5269 10.1497 14.4347 10.3145 14.406 10.4955L13.1436 18.5026C13.2024 18.1287 13.5246 17.8531 13.9034 17.8531H17.6028C21.3261 17.8531 24.4854 15.137 25.0627 11.4562C25.1057 11.1814 25.13 10.9041 25.1356 10.626C24.1894 10.1298 23.0779 9.84595 21.86 9.84595H15.1658Z" fill="#001C64"/>
    <path d="M25.1358 10.6265C25.1302 10.9045 25.1059 11.1819 25.0629 11.4567C24.4856 15.1375 21.326 17.8536 17.603 17.8536H13.9035C13.5251 17.8536 13.2026 18.1289 13.1437 18.5031L11.9829 25.861L11.2558 30.477C11.2416 30.5662 11.2469 30.6574 11.2714 30.7443C11.2959 30.8312 11.3389 30.9118 11.3976 30.9805C11.4562 31.0491 11.5291 31.1043 11.6111 31.1421C11.6931 31.1798 11.7823 31.1994 11.8726 31.1994H15.8881C16.0713 31.1992 16.2485 31.1337 16.3877 31.0147C16.527 30.8956 16.6193 30.7308 16.6479 30.5498L17.7056 23.8414C17.7342 23.6604 17.8266 23.4955 17.966 23.3764C18.1054 23.2573 18.2827 23.1919 18.466 23.1919H20.8301C24.5534 23.1919 27.7127 20.4758 28.29 16.795C28.7 14.1827 27.3843 11.8054 25.1358 10.6265Z" fill="#0070E0"/>
    <path d="M10.6041 4.50854C10.2257 4.50854 9.90319 4.78381 9.84433 5.15748L6.6933 25.1385C6.63355 25.5178 6.92666 25.8609 7.31073 25.8609H11.9835L13.1437 18.5029L14.4062 10.4958C14.4348 10.3148 14.5271 10.15 14.6663 10.0309C14.8056 9.91189 14.9828 9.8464 15.166 9.84625H21.8601C23.0783 9.84625 24.1895 10.1304 25.1357 10.6263C25.2005 7.2752 22.4353 4.50854 18.6336 4.50854H10.6041Z" fill="#003087"/>
  </svg>
    `;
    const paypalSection = `<div class="${EXPID}__paypal-container text_content text_content--usp text_content--full">
    <div class="${EXPID}__paypal-visible-section" style="display: flex;">
      <div class="${EXPID}__svg">${paypalSVG}</div>
      <div class="${EXPID}__paypal-text">Bezahle nach <br> 30 Tagen</div>
    </div>
    <div id="${EXPID}__paypal-section" >
      <div style="text-align:center" 
          data-pp-message
          data-pp-buyerCountry="DE"
          data-pp-amount="10.99"
          data-pp-placement="cart"
          data-pp-style-layout="text"
          data-pp-style-logo-type="alternative"
          data-pp-style-text-color="black"
          data-pp-style-text-size="9"
          data-pp-style-text-align="right">
      </div>
    </div>
  </div>`;
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://www.paypal.com/sdk/js?client-id=AQMcCMPtGI5E_PtXfx-geaeFabK2E9Bd87VHtWjV4ryNgh8ZGvQ2B5_4DD0PZYsJAlQgrE-RBmE_tp2v&locale=de_DE&components=messages&enable-funding=paylater"
    );
    script.setAttribute("data-namespace", "paypal_sdk");
    waitFor(
      () => q("head") && q(".product-form .delivery_text"),
      () => {
        insert(q("head"), "beforeend", script, q('script[src*="paypal.com/sdk/js"]'));
        insert(q(".product-form .delivery_text"), "afterbegin", paypalSection, q(`.${EXPID}__paypal-container`));
      }
    );
  }
  const showPayPal = document.querySelector("[data-pay-pal-badge]");
  if (showPayPal && showPayPal.getAttribute("data-pay-pal-badge") === "true") {
    testInfo();
    insertPaypalSection();
  }
})();
window.openVideoModal = (videoUrl, productId) => {
  const modal = document.getElementById("dsVideoModal--" + productId);
  const video = document.getElementById("dsModalVideo--" + productId);
  const source = video.querySelector("source");
  source.src = videoUrl;
  video.load();
  modal.style.display = "flex";
  const openFullscreen = (el) => {
    if (el.requestFullscreen) return el.requestFullscreen();
    if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
    if (el.msRequestFullscreen) return el.msRequestFullscreen();
    return Promise.reject("Fullscreen API is not supported");
  };
  const isFullscreen = () => document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
  const onFullscreenChange = () => {
    if (!isFullscreen()) {
      window.closeVideoModal(productId);
    }
  };
  if (window.innerWidth <= 768) {
    setTimeout(() => {
      openFullscreen(video).catch((err) => {
        console.warn("Fullscreen denied:", err);
      });
    }, 100);
  }
  modal.onclick = function(event) {
    if (event.target === modal && !isFullscreen()) {
      window.closeVideoModal(productId);
    }
  };
  document.addEventListener("fullscreenchange", onFullscreenChange);
  document.addEventListener("webkitfullscreenchange", onFullscreenChange);
  video.addEventListener("webkitendfullscreen", onFullscreenChange);
  video._onFullscreenChange = onFullscreenChange;
};
window.closeVideoModal = (productId) => {
  const modal = document.getElementById("dsVideoModal--" + productId);
  const video = document.getElementById("dsModalVideo--" + productId);
  video.pause();
  modal.style.display = "none";
  const exitFullscreen = () => {
    if (document.exitFullscreen) return document.exitFullscreen();
    if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
    if (document.msExitFullscreen) return document.msExitFullscreen();
    return Promise.resolve();
  };
  if (document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
    exitFullscreen().catch((err) => {
      console.warn("Failed to exit fullscreen:", err);
    });
  }
  document.removeEventListener("fullscreenchange", video._onFullscreenChange);
  document.removeEventListener("webkitfullscreenchange", video._onFullscreenChange);
  video.removeEventListener("webkitendfullscreen", video._onFullscreenChange);
};
document.addEventListener("DOMContentLoaded", function() {
  const wrappers = document.querySelectorAll(".video-thumbnail-wrapper");
  wrappers.forEach((wrapper) => {
    const video = wrapper.querySelector("video");
    const pauseBtn = wrapper.querySelector(".button-pause");
    const muteBtn = wrapper.querySelector(".button-mute");
    pauseBtn.addEventListener("click", function() {
      if (video.paused) {
        video.play();
        pauseBtn.classList.remove("active");
      } else {
        video.pause();
        pauseBtn.classList.add("active");
      }
    });
    muteBtn.addEventListener("click", function() {
      if (video.muted) {
        video.muted = false;
        video.removeAttribute("muted");
        muteBtn.classList.remove("active");
      } else {
        video.muted = true;
        video.setAttribute("muted", "");
        muteBtn.classList.add("active");
      }
    });
  });
});
window.openFlavourPopup = (productId) => {
  const popup = document.getElementById("dsFlavourPopup--" + productId);
  if (!popup) {
    console.warn("Flavour popup not found for product:", productId);
    return;
  }
  const content = popup.querySelector(".ds-flavour-popup__content");
  if (content && !content.hasAttribute("data-swipe-initialized")) {
    content.setAttribute("data-swipe-initialized", "true");
    let startY = 0;
    let startX = 0;
    let isDragging = false;
    const SWIPE_THRESHOLD = 80;
    const onTouchStart2 = (event) => {
      if (event.touches.length !== 1) return;
      const touch = event.touches[0];
      startY = touch.clientY;
      startX = touch.clientX;
      isDragging = true;
    };
    const onTouchEnd2 = (event) => {
      if (!isDragging) return;
      isDragging = false;
      if (!event.changedTouches || event.changedTouches.length === 0) return;
      const touch = event.changedTouches[0];
      const deltaY = touch.clientY - startY;
      const deltaX = Math.abs(touch.clientX - startX);
      if (deltaY > SWIPE_THRESHOLD && deltaY > deltaX && window.closeFlavourPopup) {
        window.closeFlavourPopup(productId);
      }
    };
    const onTouchCancel = () => {
      isDragging = false;
    };
    content.addEventListener("touchstart", onTouchStart2, { passive: true });
    content.addEventListener("touchend", onTouchEnd2);
    content.addEventListener("touchcancel", onTouchCancel);
  }
  popup.classList.remove("is-closing");
  document.documentElement.classList.add("ds-flavour-popup-open");
  requestAnimationFrame(() => {
    popup.classList.add("is-open");
  });
  const handleEscape = (event) => {
    if (event.key === "Escape") {
      window.closeFlavourPopup(productId);
      document.removeEventListener("keydown", handleEscape);
    }
  };
  document.addEventListener("keydown", handleEscape);
  popup._handleEscape = handleEscape;
};
window.closeFlavourPopup = (productId) => {
  const popup = document.getElementById("dsFlavourPopup--" + productId);
  if (!popup) {
    return;
  }
  const isMobile = window.matchMedia("(max-width: 740px)").matches;
  popup.classList.remove("is-open");
  popup.classList.add("is-closing");
  const animationDuration = isMobile ? 500 : 200;
  setTimeout(() => {
    popup.classList.remove("is-closing");
    document.documentElement.classList.remove("ds-flavour-popup-open");
  }, animationDuration);
  if (popup._handleEscape) {
    document.removeEventListener("keydown", popup._handleEscape);
    delete popup._handleEscape;
  }
};
function initFlavourSelectionBlocks() {
  const flavourSelectionBlocks = document.querySelectorAll(".ds-flavour-selection-block");
  flavourSelectionBlocks.forEach((block) => {
    var _a;
    if (block.hasAttribute("data-initialized")) return;
    block.setAttribute("data-initialized", "true");
    let productId = block.dataset.productId;
    if (!productId) {
      const popup = (_a = block.closest(".product__info-redesign")) == null ? void 0 : _a.querySelector(".ds-flavour-popup");
      if (popup) {
        productId = popup.dataset.productId;
      } else {
        const allPopups = document.querySelectorAll(".ds-flavour-popup[data-product-id]");
        if (allPopups.length > 0) {
          productId = allPopups[0].dataset.productId;
        }
      }
    }
    if (productId) {
      block.addEventListener("click", (event) => {
        event.preventDefault();
        window.openFlavourPopup(productId);
      });
      block.setAttribute("role", "button");
      block.setAttribute("tabindex", "0");
      block.setAttribute("aria-label", "Open flavour selection");
      block.style.cursor = "pointer";
      block.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          window.openFlavourPopup(productId);
        }
      });
    }
  });
}
document.addEventListener("DOMContentLoaded", initFlavourSelectionBlocks);
if (document.readyState !== "loading") {
  initFlavourSelectionBlocks();
}
document.addEventListener("click", (event) => {
  const productLink = event.target.closest(".ds-flavour-popup__link");
  if (!productLink) return;
});
document.addEventListener("click", (event) => {
  const dropdownTrigger = event.target.closest("[data-open-flavour-popup]");
  if (dropdownTrigger) {
    const productId = dropdownTrigger.getAttribute("data-open-flavour-popup");
    if (productId) {
      event.preventDefault();
      window.openFlavourPopup(productId);
    }
  }
});
const POPUP_CLOSE_MS = { desktop: 200, mobile: 500 };
const getPopups = () => document.querySelectorAll(".ds-flavour-popup--variant");
const getOpenPopupId = () => document.documentElement.getAttribute("data-ds-open-popup");
window.openVariantPopup = (optionId) => {
  const popup = document.getElementById("dsVariantPopup--" + optionId);
  if (!popup) return;
  popup.classList.remove("is-closing");
  document.documentElement.classList.add("ds-flavour-popup-open");
  document.documentElement.setAttribute("data-ds-open-popup", optionId);
  requestAnimationFrame(() => popup.classList.add("is-open"));
  const content = popup.querySelector(".ds-flavour-popup__content");
  if (content && !content.hasAttribute("data-swipe-initialized")) {
    content.setAttribute("data-swipe-initialized", "true");
    let startY = 0;
    let startX = 0;
    let isDragging = false;
    const SWIPE_THRESHOLD = 80;
    const onTouchStart2 = (event) => {
      if (event.touches.length !== 1) return;
      const touch = event.touches[0];
      startY = touch.clientY;
      startX = touch.clientX;
      isDragging = true;
    };
    const onTouchEnd2 = (event) => {
      if (!isDragging) return;
      isDragging = false;
      if (!event.changedTouches || event.changedTouches.length === 0) return;
      const touch = event.changedTouches[0];
      const deltaY = touch.clientY - startY;
      const deltaX = Math.abs(touch.clientX - startX);
      if (deltaY > SWIPE_THRESHOLD && deltaY > deltaX && window.closeVariantPopup) {
        window.closeVariantPopup(optionId);
      }
    };
    const onTouchCancel = () => {
      isDragging = false;
    };
    content.addEventListener("touchstart", onTouchStart2, { passive: true });
    content.addEventListener("touchend", onTouchEnd2);
    content.addEventListener("touchcancel", onTouchCancel);
  }
};
window.closeVariantPopup = (optionId) => {
  const popup = document.getElementById("dsVariantPopup--" + optionId);
  if (!popup) return;
  const ms = window.matchMedia("(max-width: 740px)").matches ? POPUP_CLOSE_MS.mobile : POPUP_CLOSE_MS.desktop;
  popup.classList.remove("is-open");
  popup.classList.add("is-closing");
  setTimeout(() => {
    popup.classList.remove("is-closing");
    document.documentElement.classList.remove("ds-flavour-popup-open");
    document.documentElement.removeAttribute("data-ds-open-popup");
  }, ms);
};
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && getOpenPopupId()) window.closeVariantPopup(getOpenPopupId());
});
function setVariantPopupActive(variantId) {
  const id = String(variantId);
  getPopups().forEach((popup) => {
    popup.querySelectorAll(".ds-flavour-popup__item").forEach((item) => {
      var _a;
      const isActive = item.getAttribute("data-variant-id") === id;
      item.classList.toggle("ds-flavour-popup__item--active", isActive);
      (_a = item.querySelector(".ds-variant-popup__select")) == null ? void 0 : _a.classList.toggle("current", isActive);
    });
  });
}
function getVariantIdFromForm(formId) {
  const form = document.getElementById(formId);
  const idEl = (form == null ? void 0 : form.querySelector('[name="id"]')) || document.querySelector('[name="id"][form="' + formId + '"]');
  return (idEl == null ? void 0 : idEl.value) || null;
}
function getFormIdForVariant(variantId) {
  var _a;
  const el = [...document.querySelectorAll('select[name="id"], input[name="id"]')].find((e) => e.value === String(variantId));
  return ((_a = el == null ? void 0 : el.form) == null ? void 0 : _a.id) || (el == null ? void 0 : el.getAttribute("form")) || null;
}
function updateDropdownCards(formId, variantId, optionValue) {
  const selector = formId ? '.product-variant-selector__dropdown-cards[data-form-id="' + formId + '"]' : ".product-variant-selector__dropdown-cards";
  const match = variantId != null ? (card) => card.getAttribute("data-variant-id") === String(variantId) : optionValue != null ? (card) => card.getAttribute("data-option-value") === optionValue : () => false;
  document.querySelectorAll(selector).forEach((container) => {
    container.querySelectorAll(".dropdown-variant-card").forEach((card) => card.classList.toggle("is-selected", match(card)));
  });
}
function syncBlockSwatchDisabled() {
  document.querySelectorAll(".product-variant-selector .block-swatch").forEach((el) => {
    const input = el.querySelector("input[data-variant-available]");
    if (input) el.classList.toggle("is-disabled", input.getAttribute("data-variant-available") === "false");
  });
  document.querySelectorAll(".dropdown-variant-card[data-variant-available]").forEach((card) => {
    card.classList.toggle("is-disabled", card.getAttribute("data-variant-available") === "false");
  });
}
document.addEventListener("click", (e) => {
  const open = e.target.closest("[data-open-variant-popup]");
  if (open) {
    e.preventDefault();
    window.openVariantPopup(open.getAttribute("data-open-variant-popup"));
    return;
  }
  const close = e.target.closest("[data-close-variant-popup]");
  if (close) {
    e.preventDefault();
    window.closeVariantPopup(close.getAttribute("data-close-variant-popup"));
    return;
  }
  const btn = e.target.closest(".ds-variant-popup__select");
  if (!btn) return;
  const popup = btn.closest(".ds-flavour-popup--variant");
  if (!(popup == null ? void 0 : popup.classList.contains("is-open"))) return;
  e.preventDefault();
  e.stopPropagation();
  const variantId = btn.getAttribute("data-variant-id");
  const formId = popup.getAttribute("data-form-id");
  const optionId = popup.getAttribute("data-option-id");
  if (!variantId) return;
  const pv = document.querySelector('product-variants[form-id="' + formId + '"]');
  if (pv == null ? void 0 : pv.selectVariant) pv.selectVariant(parseInt(variantId, 10));
  else {
    const form = document.getElementById(formId);
    const pos = popup.getAttribute("data-option-position");
    const select = document.getElementById(optionId + "-select") || (form == null ? void 0 : form.querySelector('select[name="option' + pos + '"]'));
    const idEl = (form == null ? void 0 : form.querySelector('[name="id"]')) || document.querySelector('[name="id"][form="' + formId + '"]');
    const val = btn.getAttribute("data-option-value");
    if (select) {
      select.value = val;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (idEl) idEl.value = variantId;
  }
  const span = document.getElementById(optionId + "-value");
  if (span) {
    span.textContent = btn.getAttribute("data-option-value");
    span.setAttribute("variant-title", span.textContent);
  }
  window.closeVariantPopup(optionId);
  updateDropdownCards(formId, variantId);
});
document.addEventListener("change", (e) => {
  var _a, _b, _c;
  const el = e.target;
  if (!((_b = (_a = el == null ? void 0 : el.getAttribute) == null ? void 0 : _a.call(el, "name")) == null ? void 0 : _b.startsWith("option"))) return;
  const formId = ((_c = el.form) == null ? void 0 : _c.id) || el.getAttribute("form");
  if (!formId) return;
  setTimeout(() => {
    const variantId = getVariantIdFromForm(formId);
    updateDropdownCards(formId, variantId || void 0, variantId ? void 0 : el.value);
  }, 50);
});
document.addEventListener("variant:changed", onVariantChanged);
document.addEventListener("variant:changed:cdp", onVariantChanged);
window.addEventListener("flickity:slide-changed-element-selected", (e) => {
  var _a, _b, _c, _d, _e, _f;
  const id = ((_c = (_b = (_a = e.detail) == null ? void 0 : _a.selectedElement) == null ? void 0 : _b.getAttribute) == null ? void 0 : _c.call(_b, "variant_id")) || ((_f = (_e = (_d = e.detail) == null ? void 0 : _d.selectedElement) == null ? void 0 : _e.getAttribute) == null ? void 0 : _f.call(_e, "variant_Id"));
  if (id) {
    setVariantPopupActive(id);
    updateDropdownCards(null, id);
    syncBlockSwatchDisabled();
  }
});
function onVariantChanged(e) {
  var _a, _b, _c, _d, _e, _f;
  const variant = (_a = e.detail) == null ? void 0 : _a.variant;
  if (!variant) return;
  setVariantPopupActive(variant.id);
  const formId = ((_b = e.target) == null ? void 0 : _b.id) || ((_f = (_e = (_d = (_c = e.target) == null ? void 0 : _c.closest) == null ? void 0 : _d.call(_c, "product-variants")) == null ? void 0 : _e.getAttribute) == null ? void 0 : _f.call(_e, "form-id")) || getFormIdForVariant(variant.id);
  updateDropdownCards(formId, variant.id);
  const options = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
  const popups = formId ? document.querySelectorAll('.ds-flavour-popup--variant[data-form-id="' + formId + '"]') : getPopups();
  popups.forEach((popup) => {
    const pos = parseInt(popup.getAttribute("data-option-position"), 10);
    const val = options[pos - 1];
    const optId = popup.getAttribute("data-option-id");
    const select = document.getElementById(optId + "-select");
    if (select && val != null) select.value = val;
    const span = document.getElementById(optId + "-value");
    if (span && val != null) {
      span.textContent = val;
      span.setAttribute("variant-title", val);
    }
  });
}
function initDropdownCards() {
  syncBlockSwatchDisabled();
  document.querySelectorAll(".product-variant-selector__dropdown-cards[data-form-id]").forEach((container) => {
    const formId = container.getAttribute("data-form-id");
    const variantId = getVariantIdFromForm(formId);
    if (variantId) updateDropdownCards(formId, variantId);
  });
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initDropdownCards);
else initDropdownCards();
function initMMBannerModals() {
  const openButtons = document.querySelectorAll(".js-ds-m-m-open-modal");
  openButtons.forEach((openBtn) => {
    const modalId = openBtn.getAttribute("aria-controls");
    if (!modalId) return;
    const modal = document.getElementById(modalId);
    if (!modal) return;
    const closeBtns = modal.querySelectorAll(".js-ds-m-m-close-modal");
    function closeModal() {
      modal.hidden = true;
      modal.classList.remove("ds-m-m-modal--open");
      openBtn.setAttribute("aria-expanded", "false");
      document.documentElement.style.overflow = "";
      document.removeEventListener("keydown", handleEscape);
    }
    function handleEscape(e) {
      if (e.key === "Escape") closeModal();
    }
    function openModal() {
      modal.hidden = false;
      modal.classList.add("ds-m-m-modal--open");
      openBtn.setAttribute("aria-expanded", "true");
      document.documentElement.style.overflow = "hidden";
      document.addEventListener("keydown", handleEscape);
    }
    openBtn.addEventListener("click", openModal);
    closeBtns.forEach((btn) => btn.addEventListener("click", closeModal));
  });
}
document.addEventListener("DOMContentLoaded", initMMBannerModals);
const mobileDrawer = document.getElementById("mobile-menu-drawer");
function observeSelector() {
  const detailsEl = mobileDrawer.querySelector("details");
  if (detailsEl) {
    detailsEl.addEventListener("toggle", () => {
      if (detailsEl.open) {
        mobileDrawer.classList.add("overlay");
      } else {
        mobileDrawer.classList.remove("overlay");
      }
    });
  }
}
if (mobileDrawer) {
  observeSelector();
}
document.addEventListener("DOMContentLoaded", () => {
  let header = document.querySelector(".ds-header");
  let dsNavigation = document.querySelector(".dsStickyNavigation");
  if (header && dsNavigation) {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio === 0) {
          dsNavigation.classList.add("is-sticky");
        } else {
          dsNavigation.classList.remove("is-sticky");
        }
      });
    }, { threshold: [0] });
    observer.observe(header);
  }
});
function initMegaMenuCampaignSlider() {
  if (window.innerWidth <= 1199) return;
  const campaignSliders = document.querySelectorAll(".mega-menu__campaign");
  if (!campaignSliders.length) return;
  campaignSliders.forEach((campaignContainer) => {
    const wrapper = campaignContainer.querySelector(".mega-menu__campaign-wrapper");
    const prevButton2 = campaignContainer.querySelector(".mega-menu__campaign-nav--prev");
    const nextButton2 = campaignContainer.querySelector(".mega-menu__campaign-nav--next");
    const cards = campaignContainer.querySelectorAll(".mega-menu__campaign-card");
    if (!wrapper || !prevButton2 || !nextButton2 || !cards.length) return;
    const cardWidth = cards[0].offsetWidth;
    const gap = 12;
    const scrollAmount = cardWidth + gap;
    function updateButtonState() {
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      const currentScroll = wrapper.scrollLeft;
      const eps = 2;
      prevButton2.disabled = currentScroll <= eps;
      nextButton2.disabled = currentScroll >= maxScroll - eps;
    }
    function scrollToNext() {
      const currentScroll = wrapper.scrollLeft;
      const targetScroll = currentScroll + scrollAmount;
      wrapper.scrollTo({
        left: targetScroll,
        behavior: "smooth"
      });
    }
    function scrollToPrev() {
      const currentScroll = wrapper.scrollLeft;
      const targetScroll = currentScroll - scrollAmount;
      wrapper.scrollTo({
        left: targetScroll,
        behavior: "smooth"
      });
    }
    prevButton2.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      scrollToPrev();
    });
    nextButton2.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      scrollToNext();
    });
    function updateCardOpacity() {
      if (window.innerWidth <= 1199) return;
      cards.forEach((card) => {
        const cardRect = card.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();
        const visibleLeft = Math.max(cardRect.left, wrapperRect.left);
        const visibleRight = Math.min(cardRect.right, wrapperRect.right);
        const visibleWidth = Math.max(0, visibleRight - visibleLeft);
        const cardWidth2 = cardRect.width;
        const visibilityPercentage = cardWidth2 > 0 ? visibleWidth / cardWidth2 * 100 : 0;
        if (visibilityPercentage < 50) {
          card.style.opacity = "0.2";
        } else {
          card.style.opacity = "1";
        }
      });
    }
    wrapper.addEventListener("scroll", () => {
      updateButtonState();
      updateCardOpacity();
    }, { passive: true });
    const resizeObserver = new ResizeObserver(() => {
      updateButtonState();
      updateCardOpacity();
    });
    resizeObserver.observe(wrapper);
    updateButtonState();
    updateCardOpacity();
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMegaMenuCampaignSlider);
} else {
  initMegaMenuCampaignSlider();
}
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "hidden") {
        const megaMenu = mutation.target;
        if (megaMenu.classList.contains("mega-menu") && !megaMenu.hasAttribute("hidden")) {
          setTimeout(initMegaMenuCampaignSlider, 100);
        }
      }
    });
  });
  document.querySelectorAll(".mega-menu").forEach((megaMenu) => {
    observer.observe(megaMenu, { attributes: true });
  });
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initMegaMenuCampaignSlider();
    }, 100);
  });
});
(function() {
  const selectors2 = {
    menuItem: ".header__linklist-item.has-dropdown",
    menuTrigger: "[aria-controls]",
    menuItemLink: ".header__linklist-item-link",
    megaMenuClass: "mega-menu",
    megaMenu: ".mega-menu",
    megaMenuInner: ".mega-menu__inner",
    desktopNavigation: "desktop-navigation",
    trianglePositionVar: "--triangle-position",
    panelShiftVar: "--panel-shift"
  };
  function centerTriangle(menuItem, megaMenuInner) {
    if (!menuItem || !megaMenuInner) return;
    const menuItemLink = menuItem.querySelector(selectors2.menuItemLink) || menuItem.querySelector(selectors2.menuTrigger);
    if (!menuItemLink) return;
    const menuItemRect = menuItemLink.getBoundingClientRect();
    const megaMenuInnerRect = megaMenuInner.getBoundingClientRect();
    const menuItemCenter = menuItemRect.left + menuItemRect.width / 2;
    const isPanelCentered = megaMenuInner.getAttribute("data-panel-centered") === "true";
    if (isPanelCentered) {
      megaMenuInner.style.setProperty(selectors2.trianglePositionVar, "50%");
      const container = megaMenuInner.parentElement;
      if (container) {
        const containerRect = container.getBoundingClientRect();
        const containerStyle = window.getComputedStyle(container);
        const paddingLeft = parseFloat(containerStyle.paddingLeft) || 0;
        const contentLeft = containerRect.left + paddingLeft;
        const panelCenterOffset = menuItemCenter - contentLeft - megaMenuInnerRect.width / 2;
        megaMenuInner.style.setProperty(selectors2.panelShiftVar, `${panelCenterOffset}px`);
      }
    } else {
      const megaMenuInnerLeft = megaMenuInnerRect.left;
      const trianglePosition = (menuItemCenter - megaMenuInnerLeft) / megaMenuInnerRect.width * 100;
      const clampedPosition = Math.max(5, Math.min(95, trianglePosition));
      megaMenuInner.style.setProperty(selectors2.trianglePositionVar, `${clampedPosition}%`);
      megaMenuInner.style.setProperty(selectors2.panelShiftVar, "0px");
    }
  }
  function initTriangleCentering() {
    const menuItems = document.querySelectorAll(selectors2.menuItem);
    menuItems.forEach((menuItem) => {
      const menuLink = menuItem.querySelector(selectors2.menuTrigger);
      if (!menuLink) return;
      const megaMenuId = menuLink.getAttribute("aria-controls");
      if (!megaMenuId) return;
      const megaMenu = document.getElementById(megaMenuId);
      if (!megaMenu) return;
      if (!megaMenu.classList.contains(selectors2.megaMenuClass)) return;
      const megaMenuInner = megaMenu.querySelector(selectors2.megaMenuInner);
      if (!megaMenuInner) return;
      centerTriangle(menuItem, megaMenuInner);
    });
    document.addEventListener("desktop-nav:dropdown:open", (event) => {
      var _a, _b;
      const desktopNav = ((_b = (_a = event.target).closest) == null ? void 0 : _b.call(_a, selectors2.desktopNavigation)) || document.querySelector(selectors2.desktopNavigation);
      if (!desktopNav) return;
      const openMegaMenus = desktopNav.querySelectorAll(`${selectors2.megaMenu}:not([hidden])`);
      openMegaMenus.forEach((megaMenu) => {
        var _a2;
        const menuId = megaMenu.id;
        const menuItem = (_a2 = desktopNav.querySelector(`[aria-controls="${menuId}"]`)) == null ? void 0 : _a2.closest(selectors2.menuItem);
        if (!menuItem) return;
        const megaMenuInner = megaMenu.querySelector(selectors2.megaMenuInner);
        if (!megaMenuInner) return;
        setTimeout(() => {
          centerTriangle(menuItem, megaMenuInner);
        }, 100);
      });
    });
  }
  function updateAllTriangles() {
    const menuItems = document.querySelectorAll(selectors2.menuItem);
    menuItems.forEach((menuItem) => {
      const menuLink = menuItem.querySelector(selectors2.menuTrigger);
      if (!menuLink) return;
      const megaMenuId = menuLink.getAttribute("aria-controls");
      if (!megaMenuId) return;
      const megaMenu = document.getElementById(megaMenuId);
      if (!megaMenu || !megaMenu.classList.contains(selectors2.megaMenuClass)) return;
      const megaMenuInner = megaMenu.querySelector(selectors2.megaMenuInner);
      if (!megaMenuInner) return;
      if (!megaMenu.hasAttribute("hidden")) {
        centerTriangle(menuItem, megaMenuInner);
      }
    });
  }
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTriangleCentering);
  } else {
    initTriangleCentering();
  }
  const debouncedResize = debounce(updateAllTriangles, 150);
  window.addEventListener("resize", debouncedResize);
  window.addEventListener("orientationchange", () => {
    setTimeout(updateAllTriangles, 300);
  });
})();
function initMegaMenuHoverImages() {
  if (window.innerWidth <= 1199) return;
  document.querySelectorAll(".mega-menu").forEach((megaMenu) => {
    const links = megaMenu.querySelectorAll(".mega-menu__title[data-hover-key]");
    const container = megaMenu.querySelector("[data-hover-image-container]");
    if (!links.length || !container) return;
    const defaultImage = container.querySelector(".mega-menu__image--default");
    const hoverImages = container.querySelectorAll(".mega-menu__image--hover");
    links.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        const key = link.dataset.hoverKey;
        let matched = false;
        hoverImages.forEach((img) => {
          if (img.dataset.hoverFor === key) {
            img.classList.add("is-active");
            matched = true;
          } else {
            img.classList.remove("is-active");
          }
        });
        if (defaultImage) {
          defaultImage.classList.toggle("is-hidden", matched);
        }
      });
      link.addEventListener("mouseleave", () => {
        hoverImages.forEach((img) => img.classList.remove("is-active"));
        if (defaultImage) defaultImage.classList.remove("is-hidden");
      });
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMegaMenuHoverImages);
} else {
  initMegaMenuHoverImages();
}
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "hidden") {
        const megaMenu = mutation.target;
        if (megaMenu.classList.contains("mega-menu") && !megaMenu.hasAttribute("hidden")) {
          initMegaMenuHoverImages();
        }
      }
    });
  });
  document.querySelectorAll(".mega-menu").forEach((menu) => {
    observer.observe(menu, { attributes: true });
  });
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initMegaMenuHoverImages, 100);
  });
});
const selectors$3 = {
  ratingStars: ".R-RatingStars-js",
  reviewStatistics: ".reviewStatistics-js"
};
const API_URL = "https://api.reviews.io/merchant/reviews?store=holyenergy.myshopify.com";
document.addEventListener("DOMContentLoaded", () => {
  fetch(API_URL).then((response) => response.json()).then((data) => {
    const { total_reviews, average_rating } = data.stats;
    const ratingStarsElements = document.querySelectorAll(selectors$3.ratingStars);
    if (ratingStarsElements && ratingStarsElements.length > 0) {
      ratingStarsElements.forEach((ratingStarsElement) => {
        const reviewStatisticsElement = ratingStarsElement.querySelector(selectors$3.reviewStatistics);
        if (reviewStatisticsElement) {
          const originalText = reviewStatisticsElement.textContent || reviewStatisticsElement.innerText;
          const updatedText = originalText.replace("{average_rating}", Number(average_rating).toFixed(1)).replace("{total_reviews}", total_reviews.toLocaleString());
          reviewStatisticsElement.textContent = updatedText;
        }
        ratingStarsElement.style.display = "flex";
      });
    }
  }).catch((error2) => {
    console.error("Error fetching reviews data:", error2);
  });
});
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function makeMap(str) {
  const map = /* @__PURE__ */ Object.create(null);
  for (const key of str.split(",")) map[key] = 1;
  return (val) => val in map;
}
const EMPTY_OBJ = {};
const EMPTY_ARR = [];
const NOOP = () => {
};
const NO = () => false;
const isOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
(key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const isModelListener = (key) => key.startsWith("onUpdate:");
const extend$2 = Object.assign;
const remove = (arr, el) => {
  const i = arr.indexOf(el);
  if (i > -1) {
    arr.splice(i, 1);
  }
};
const hasOwnProperty$1 = Object.prototype.hasOwnProperty;
const hasOwn = (val, key) => hasOwnProperty$1.call(val, key);
const isArray = Array.isArray;
const isMap = (val) => toTypeString(val) === "[object Map]";
const isSet = (val) => toTypeString(val) === "[object Set]";
const isFunction = (val) => typeof val === "function";
const isString$1 = (val) => typeof val === "string";
const isSymbol = (val) => typeof val === "symbol";
const isObject$3 = (val) => val !== null && typeof val === "object";
const isPromise$1 = (val) => {
  return (isObject$3(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
};
const objectToString$1 = Object.prototype.toString;
const toTypeString = (value) => objectToString$1.call(value);
const toRawType = (value) => {
  return toTypeString(value).slice(8, -1);
};
const isPlainObject$1 = (val) => toTypeString(val) === "[object Object]";
const isIntegerKey = (key) => isString$1(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const isReservedProp = /* @__PURE__ */ makeMap(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
);
const cacheStringFunction = (fn) => {
  const cache = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
};
const camelizeRE = /-(\w)/g;
const camelize = cacheStringFunction(
  (str) => {
    return str.replace(camelizeRE, (_, c) => c ? c.toUpperCase() : "");
  }
);
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction(
  (str) => str.replace(hyphenateRE, "-$1").toLowerCase()
);
const capitalize = cacheStringFunction((str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
});
const toHandlerKey = cacheStringFunction(
  (str) => {
    const s = str ? `on${capitalize(str)}` : ``;
    return s;
  }
);
const hasChanged = (value, oldValue) => !Object.is(value, oldValue);
const invokeArrayFns = (fns, ...arg) => {
  for (let i = 0; i < fns.length; i++) {
    fns[i](...arg);
  }
};
const def = (obj, key, value, writable = false) => {
  Object.defineProperty(obj, key, {
    configurable: true,
    enumerable: false,
    writable,
    value
  });
};
const looseToNumber = (val) => {
  const n = parseFloat(val);
  return isNaN(n) ? val : n;
};
let _globalThis;
const getGlobalThis = () => {
  return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
function normalizeStyle(value) {
  if (isArray(value)) {
    const res = {};
    for (let i = 0; i < value.length; i++) {
      const item = value[i];
      const normalized = isString$1(item) ? parseStringStyle(item) : normalizeStyle(item);
      if (normalized) {
        for (const key in normalized) {
          res[key] = normalized[key];
        }
      }
    }
    return res;
  } else if (isString$1(value) || isObject$3(value)) {
    return value;
  }
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:([^]+)/;
const styleCommentRE = /\/\*[^]*?\*\//g;
function parseStringStyle(cssText) {
  const ret = {};
  cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item) => {
    if (item) {
      const tmp = item.split(propertyDelimiterRE);
      tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return ret;
}
function normalizeClass(value) {
  let res = "";
  if (isString$1(value)) {
    res = value;
  } else if (isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      const normalized = normalizeClass(value[i]);
      if (normalized) {
        res += normalized + " ";
      }
    }
  } else if (isObject$3(value)) {
    for (const name in value) {
      if (value[name]) {
        res += name + " ";
      }
    }
  }
  return res.trim();
}
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
function includeBooleanAttr(value) {
  return !!value || value === "";
}
const isRef$1 = (val) => {
  return !!(val && val["__v_isRef"] === true);
};
const toDisplayString = (val) => {
  return isString$1(val) ? val : val == null ? "" : isArray(val) || isObject$3(val) && (val.toString === objectToString$1 || !isFunction(val.toString)) ? isRef$1(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val) => {
  if (isRef$1(val)) {
    return replacer(_key, val.value);
  } else if (isMap(val)) {
    return {
      [`Map(${val.size})`]: [...val.entries()].reduce(
        (entries, [key, val2], i) => {
          entries[stringifySymbol(key, i) + " =>"] = val2;
          return entries;
        },
        {}
      )
    };
  } else if (isSet(val)) {
    return {
      [`Set(${val.size})`]: [...val.values()].map((v) => stringifySymbol(v))
    };
  } else if (isSymbol(val)) {
    return stringifySymbol(val);
  } else if (isObject$3(val) && !isArray(val) && !isPlainObject$1(val)) {
    return String(val);
  }
  return val;
};
const stringifySymbol = (v, i = "") => {
  var _a;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v
  );
};
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let activeEffectScope;
class EffectScope {
  constructor(detached = false) {
    this.detached = detached;
    this._active = true;
    this.effects = [];
    this.cleanups = [];
    this._isPaused = false;
    this.parent = activeEffectScope;
    if (!detached && activeEffectScope) {
      this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(
        this
      ) - 1;
    }
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = true;
      let i, l;
      if (this.scopes) {
        for (i = 0, l = this.scopes.length; i < l; i++) {
          this.scopes[i].pause();
        }
      }
      for (i = 0, l = this.effects.length; i < l; i++) {
        this.effects[i].pause();
      }
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active) {
      if (this._isPaused) {
        this._isPaused = false;
        let i, l;
        if (this.scopes) {
          for (i = 0, l = this.scopes.length; i < l; i++) {
            this.scopes[i].resume();
          }
        }
        for (i = 0, l = this.effects.length; i < l; i++) {
          this.effects[i].resume();
        }
      }
    }
  }
  run(fn) {
    if (this._active) {
      const currentEffectScope = activeEffectScope;
      try {
        activeEffectScope = this;
        return fn();
      } finally {
        activeEffectScope = currentEffectScope;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    activeEffectScope = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    activeEffectScope = this.parent;
  }
  stop(fromParent) {
    if (this._active) {
      this._active = false;
      let i, l;
      for (i = 0, l = this.effects.length; i < l; i++) {
        this.effects[i].stop();
      }
      this.effects.length = 0;
      for (i = 0, l = this.cleanups.length; i < l; i++) {
        this.cleanups[i]();
      }
      this.cleanups.length = 0;
      if (this.scopes) {
        for (i = 0, l = this.scopes.length; i < l; i++) {
          this.scopes[i].stop(true);
        }
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !fromParent) {
        const last = this.parent.scopes.pop();
        if (last && last !== this) {
          this.parent.scopes[this.index] = last;
          last.index = this.index;
        }
      }
      this.parent = void 0;
    }
  }
}
function effectScope(detached) {
  return new EffectScope(detached);
}
function getCurrentScope$1() {
  return activeEffectScope;
}
let activeSub;
const pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class ReactiveEffect {
  constructor(fn) {
    this.fn = fn;
    this.deps = void 0;
    this.depsTail = void 0;
    this.flags = 1 | 4;
    this.next = void 0;
    this.cleanup = void 0;
    this.scheduler = void 0;
    if (activeEffectScope && activeEffectScope.active) {
      activeEffectScope.effects.push(this);
    }
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    if (this.flags & 64) {
      this.flags &= -65;
      if (pausedQueueEffects.has(this)) {
        pausedQueueEffects.delete(this);
        this.trigger();
      }
    }
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags & 2 && !(this.flags & 32)) {
      return;
    }
    if (!(this.flags & 8)) {
      batch(this);
    }
  }
  run() {
    if (!(this.flags & 1)) {
      return this.fn();
    }
    this.flags |= 2;
    cleanupEffect(this);
    prepareDeps(this);
    const prevEffect = activeSub;
    const prevShouldTrack = shouldTrack;
    activeSub = this;
    shouldTrack = true;
    try {
      return this.fn();
    } finally {
      cleanupDeps(this);
      activeSub = prevEffect;
      shouldTrack = prevShouldTrack;
      this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let link = this.deps; link; link = link.nextDep) {
        removeSub(link);
      }
      this.deps = this.depsTail = void 0;
      cleanupEffect(this);
      this.onStop && this.onStop();
      this.flags &= -2;
    }
  }
  trigger() {
    if (this.flags & 64) {
      pausedQueueEffects.add(this);
    } else if (this.scheduler) {
      this.scheduler();
    } else {
      this.runIfDirty();
    }
  }
  /**
   * @internal
   */
  runIfDirty() {
    if (isDirty(this)) {
      this.run();
    }
  }
  get dirty() {
    return isDirty(this);
  }
}
let batchDepth = 0;
let batchedSub;
let batchedComputed;
function batch(sub, isComputed = false) {
  sub.flags |= 8;
  if (isComputed) {
    sub.next = batchedComputed;
    batchedComputed = sub;
    return;
  }
  sub.next = batchedSub;
  batchedSub = sub;
}
function startBatch() {
  batchDepth++;
}
function endBatch() {
  if (--batchDepth > 0) {
    return;
  }
  if (batchedComputed) {
    let e = batchedComputed;
    batchedComputed = void 0;
    while (e) {
      const next = e.next;
      e.next = void 0;
      e.flags &= -9;
      e = next;
    }
  }
  let error2;
  while (batchedSub) {
    let e = batchedSub;
    batchedSub = void 0;
    while (e) {
      const next = e.next;
      e.next = void 0;
      e.flags &= -9;
      if (e.flags & 1) {
        try {
          ;
          e.trigger();
        } catch (err) {
          if (!error2) error2 = err;
        }
      }
      e = next;
    }
  }
  if (error2) throw error2;
}
function prepareDeps(sub) {
  for (let link = sub.deps; link; link = link.nextDep) {
    link.version = -1;
    link.prevActiveLink = link.dep.activeLink;
    link.dep.activeLink = link;
  }
}
function cleanupDeps(sub) {
  let head;
  let tail = sub.depsTail;
  let link = tail;
  while (link) {
    const prev = link.prevDep;
    if (link.version === -1) {
      if (link === tail) tail = prev;
      removeSub(link);
      removeDep(link);
    } else {
      head = link;
    }
    link.dep.activeLink = link.prevActiveLink;
    link.prevActiveLink = void 0;
    link = prev;
  }
  sub.deps = head;
  sub.depsTail = tail;
}
function isDirty(sub) {
  for (let link = sub.deps; link; link = link.nextDep) {
    if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) {
      return true;
    }
  }
  if (sub._dirty) {
    return true;
  }
  return false;
}
function refreshComputed(computed2) {
  if (computed2.flags & 4 && !(computed2.flags & 16)) {
    return;
  }
  computed2.flags &= -17;
  if (computed2.globalVersion === globalVersion) {
    return;
  }
  computed2.globalVersion = globalVersion;
  const dep = computed2.dep;
  computed2.flags |= 2;
  if (dep.version > 0 && !computed2.isSSR && computed2.deps && !isDirty(computed2)) {
    computed2.flags &= -3;
    return;
  }
  const prevSub = activeSub;
  const prevShouldTrack = shouldTrack;
  activeSub = computed2;
  shouldTrack = true;
  try {
    prepareDeps(computed2);
    const value = computed2.fn(computed2._value);
    if (dep.version === 0 || hasChanged(value, computed2._value)) {
      computed2._value = value;
      dep.version++;
    }
  } catch (err) {
    dep.version++;
    throw err;
  } finally {
    activeSub = prevSub;
    shouldTrack = prevShouldTrack;
    cleanupDeps(computed2);
    computed2.flags &= -3;
  }
}
function removeSub(link, soft = false) {
  const { dep, prevSub, nextSub } = link;
  if (prevSub) {
    prevSub.nextSub = nextSub;
    link.prevSub = void 0;
  }
  if (nextSub) {
    nextSub.prevSub = prevSub;
    link.nextSub = void 0;
  }
  if (dep.subs === link) {
    dep.subs = prevSub;
    if (!prevSub && dep.computed) {
      dep.computed.flags &= -5;
      for (let l = dep.computed.deps; l; l = l.nextDep) {
        removeSub(l, true);
      }
    }
  }
  if (!soft && !--dep.sc && dep.map) {
    dep.map.delete(dep.key);
  }
}
function removeDep(link) {
  const { prevDep, nextDep } = link;
  if (prevDep) {
    prevDep.nextDep = nextDep;
    link.prevDep = void 0;
  }
  if (nextDep) {
    nextDep.prevDep = prevDep;
    link.nextDep = void 0;
  }
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = false;
}
function resetTracking() {
  const last = trackStack.pop();
  shouldTrack = last === void 0 ? true : last;
}
function cleanupEffect(e) {
  const { cleanup } = e;
  e.cleanup = void 0;
  if (cleanup) {
    const prevSub = activeSub;
    activeSub = void 0;
    try {
      cleanup();
    } finally {
      activeSub = prevSub;
    }
  }
}
let globalVersion = 0;
class Link {
  constructor(sub, dep) {
    this.sub = sub;
    this.dep = dep;
    this.version = dep.version;
    this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class Dep {
  constructor(computed2) {
    this.computed = computed2;
    this.version = 0;
    this.activeLink = void 0;
    this.subs = void 0;
    this.map = void 0;
    this.key = void 0;
    this.sc = 0;
  }
  track(debugInfo) {
    if (!activeSub || !shouldTrack || activeSub === this.computed) {
      return;
    }
    let link = this.activeLink;
    if (link === void 0 || link.sub !== activeSub) {
      link = this.activeLink = new Link(activeSub, this);
      if (!activeSub.deps) {
        activeSub.deps = activeSub.depsTail = link;
      } else {
        link.prevDep = activeSub.depsTail;
        activeSub.depsTail.nextDep = link;
        activeSub.depsTail = link;
      }
      addSub(link);
    } else if (link.version === -1) {
      link.version = this.version;
      if (link.nextDep) {
        const next = link.nextDep;
        next.prevDep = link.prevDep;
        if (link.prevDep) {
          link.prevDep.nextDep = next;
        }
        link.prevDep = activeSub.depsTail;
        link.nextDep = void 0;
        activeSub.depsTail.nextDep = link;
        activeSub.depsTail = link;
        if (activeSub.deps === link) {
          activeSub.deps = next;
        }
      }
    }
    return link;
  }
  trigger(debugInfo) {
    this.version++;
    globalVersion++;
    this.notify(debugInfo);
  }
  notify(debugInfo) {
    startBatch();
    try {
      if (false) ;
      for (let link = this.subs; link; link = link.prevSub) {
        if (link.sub.notify()) {
          ;
          link.sub.dep.notify();
        }
      }
    } finally {
      endBatch();
    }
  }
}
function addSub(link) {
  link.dep.sc++;
  if (link.sub.flags & 4) {
    const computed2 = link.dep.computed;
    if (computed2 && !link.dep.subs) {
      computed2.flags |= 4 | 16;
      for (let l = computed2.deps; l; l = l.nextDep) {
        addSub(l);
      }
    }
    const currentTail = link.dep.subs;
    if (currentTail !== link) {
      link.prevSub = currentTail;
      if (currentTail) currentTail.nextSub = link;
    }
    link.dep.subs = link;
  }
}
const targetMap = /* @__PURE__ */ new WeakMap();
const ITERATE_KEY = Symbol(
  ""
);
const MAP_KEY_ITERATE_KEY = Symbol(
  ""
);
const ARRAY_ITERATE_KEY = Symbol(
  ""
);
function track(target, type, key) {
  if (shouldTrack && activeSub) {
    let depsMap = targetMap.get(target);
    if (!depsMap) {
      targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    }
    let dep = depsMap.get(key);
    if (!dep) {
      depsMap.set(key, dep = new Dep());
      dep.map = depsMap;
      dep.key = key;
    }
    {
      dep.track();
    }
  }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    globalVersion++;
    return;
  }
  const run = (dep) => {
    if (dep) {
      {
        dep.trigger();
      }
    }
  };
  startBatch();
  if (type === "clear") {
    depsMap.forEach(run);
  } else {
    const targetIsArray = isArray(target);
    const isArrayIndex = targetIsArray && isIntegerKey(key);
    if (targetIsArray && key === "length") {
      const newLength = Number(newValue);
      depsMap.forEach((dep, key2) => {
        if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !isSymbol(key2) && key2 >= newLength) {
          run(dep);
        }
      });
    } else {
      if (key !== void 0 || depsMap.has(void 0)) {
        run(depsMap.get(key));
      }
      if (isArrayIndex) {
        run(depsMap.get(ARRAY_ITERATE_KEY));
      }
      switch (type) {
        case "add":
          if (!targetIsArray) {
            run(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              run(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          } else if (isArrayIndex) {
            run(depsMap.get("length"));
          }
          break;
        case "delete":
          if (!targetIsArray) {
            run(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              run(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          }
          break;
        case "set":
          if (isMap(target)) {
            run(depsMap.get(ITERATE_KEY));
          }
          break;
      }
    }
  }
  endBatch();
}
function getDepFromReactive(object, key) {
  const depMap = targetMap.get(object);
  return depMap && depMap.get(key);
}
function reactiveReadArray(array) {
  const raw = toRaw(array);
  if (raw === array) return raw;
  track(raw, "iterate", ARRAY_ITERATE_KEY);
  return isShallow(array) ? raw : raw.map(toReactive);
}
function shallowReadArray(arr) {
  track(arr = toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
  return arr;
}
const arrayInstrumentations = {
  __proto__: null,
  [Symbol.iterator]() {
    return iterator(this, Symbol.iterator, toReactive);
  },
  concat(...args) {
    return reactiveReadArray(this).concat(
      ...args.map((x3) => isArray(x3) ? reactiveReadArray(x3) : x3)
    );
  },
  entries() {
    return iterator(this, "entries", (value) => {
      value[1] = toReactive(value[1]);
      return value;
    });
  },
  every(fn, thisArg) {
    return apply(this, "every", fn, thisArg, void 0, arguments);
  },
  filter(fn, thisArg) {
    return apply(this, "filter", fn, thisArg, (v) => v.map(toReactive), arguments);
  },
  find(fn, thisArg) {
    return apply(this, "find", fn, thisArg, toReactive, arguments);
  },
  findIndex(fn, thisArg) {
    return apply(this, "findIndex", fn, thisArg, void 0, arguments);
  },
  findLast(fn, thisArg) {
    return apply(this, "findLast", fn, thisArg, toReactive, arguments);
  },
  findLastIndex(fn, thisArg) {
    return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(fn, thisArg) {
    return apply(this, "forEach", fn, thisArg, void 0, arguments);
  },
  includes(...args) {
    return searchProxy(this, "includes", args);
  },
  indexOf(...args) {
    return searchProxy(this, "indexOf", args);
  },
  join(separator) {
    return reactiveReadArray(this).join(separator);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...args) {
    return searchProxy(this, "lastIndexOf", args);
  },
  map(fn, thisArg) {
    return apply(this, "map", fn, thisArg, void 0, arguments);
  },
  pop() {
    return noTracking(this, "pop");
  },
  push(...args) {
    return noTracking(this, "push", args);
  },
  reduce(fn, ...args) {
    return reduce(this, "reduce", fn, args);
  },
  reduceRight(fn, ...args) {
    return reduce(this, "reduceRight", fn, args);
  },
  shift() {
    return noTracking(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(fn, thisArg) {
    return apply(this, "some", fn, thisArg, void 0, arguments);
  },
  splice(...args) {
    return noTracking(this, "splice", args);
  },
  toReversed() {
    return reactiveReadArray(this).toReversed();
  },
  toSorted(comparer) {
    return reactiveReadArray(this).toSorted(comparer);
  },
  toSpliced(...args) {
    return reactiveReadArray(this).toSpliced(...args);
  },
  unshift(...args) {
    return noTracking(this, "unshift", args);
  },
  values() {
    return iterator(this, "values", toReactive);
  }
};
function iterator(self2, method, wrapValue) {
  const arr = shallowReadArray(self2);
  const iter = arr[method]();
  if (arr !== self2 && !isShallow(self2)) {
    iter._next = iter.next;
    iter.next = () => {
      const result = iter._next();
      if (result.value) {
        result.value = wrapValue(result.value);
      }
      return result;
    };
  }
  return iter;
}
const arrayProto = Array.prototype;
function apply(self2, method, fn, thisArg, wrappedRetFn, args) {
  const arr = shallowReadArray(self2);
  const needsWrap = arr !== self2 && !isShallow(self2);
  const methodFn = arr[method];
  if (methodFn !== arrayProto[method]) {
    const result2 = methodFn.apply(self2, args);
    return needsWrap ? toReactive(result2) : result2;
  }
  let wrappedFn = fn;
  if (arr !== self2) {
    if (needsWrap) {
      wrappedFn = function(item, index) {
        return fn.call(this, toReactive(item), index, self2);
      };
    } else if (fn.length > 2) {
      wrappedFn = function(item, index) {
        return fn.call(this, item, index, self2);
      };
    }
  }
  const result = methodFn.call(arr, wrappedFn, thisArg);
  return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function reduce(self2, method, fn, args) {
  const arr = shallowReadArray(self2);
  let wrappedFn = fn;
  if (arr !== self2) {
    if (!isShallow(self2)) {
      wrappedFn = function(acc, item, index) {
        return fn.call(this, acc, toReactive(item), index, self2);
      };
    } else if (fn.length > 3) {
      wrappedFn = function(acc, item, index) {
        return fn.call(this, acc, item, index, self2);
      };
    }
  }
  return arr[method](wrappedFn, ...args);
}
function searchProxy(self2, method, args) {
  const arr = toRaw(self2);
  track(arr, "iterate", ARRAY_ITERATE_KEY);
  const res = arr[method](...args);
  if ((res === -1 || res === false) && isProxy(args[0])) {
    args[0] = toRaw(args[0]);
    return arr[method](...args);
  }
  return res;
}
function noTracking(self2, method, args = []) {
  pauseTracking();
  startBatch();
  const res = toRaw(self2)[method].apply(self2, args);
  endBatch();
  resetTracking();
  return res;
}
const isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key) => key !== "arguments" && key !== "caller").map((key) => Symbol[key]).filter(isSymbol)
);
function hasOwnProperty(key) {
  if (!isSymbol(key)) key = String(key);
  const obj = toRaw(this);
  track(obj, "has", key);
  return obj.hasOwnProperty(key);
}
class BaseReactiveHandler {
  constructor(_isReadonly = false, _isShallow = false) {
    this._isReadonly = _isReadonly;
    this._isShallow = _isShallow;
  }
  get(target, key, receiver) {
    if (key === "__v_skip") return target["__v_skip"];
    const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_isShallow") {
      return isShallow2;
    } else if (key === "__v_raw") {
      if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) {
        return target;
      }
      return;
    }
    const targetIsArray = isArray(target);
    if (!isReadonly2) {
      let fn;
      if (targetIsArray && (fn = arrayInstrumentations[key])) {
        return fn;
      }
      if (key === "hasOwnProperty") {
        return hasOwnProperty;
      }
    }
    const res = Reflect.get(
      target,
      key,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      isRef(target) ? target : receiver
    );
    if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
      return res;
    }
    if (!isReadonly2) {
      track(target, "get", key);
    }
    if (isShallow2) {
      return res;
    }
    if (isRef(res)) {
      return targetIsArray && isIntegerKey(key) ? res : res.value;
    }
    if (isObject$3(res)) {
      return isReadonly2 ? readonly(res) : reactive(res);
    }
    return res;
  }
}
class MutableReactiveHandler extends BaseReactiveHandler {
  constructor(isShallow2 = false) {
    super(false, isShallow2);
  }
  set(target, key, value, receiver) {
    let oldValue = target[key];
    if (!this._isShallow) {
      const isOldValueReadonly = isReadonly(oldValue);
      if (!isShallow(value) && !isReadonly(value)) {
        oldValue = toRaw(oldValue);
        value = toRaw(value);
      }
      if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
        if (isOldValueReadonly) {
          return false;
        } else {
          oldValue.value = value;
          return true;
        }
      }
    }
    const hadKey = isArray(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn(target, key);
    const result = Reflect.set(
      target,
      key,
      value,
      isRef(target) ? target : receiver
    );
    if (target === toRaw(receiver)) {
      if (!hadKey) {
        trigger(target, "add", key, value);
      } else if (hasChanged(value, oldValue)) {
        trigger(target, "set", key, value);
      }
    }
    return result;
  }
  deleteProperty(target, key) {
    const hadKey = hasOwn(target, key);
    target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) {
      trigger(target, "delete", key, void 0);
    }
    return result;
  }
  has(target, key) {
    const result = Reflect.has(target, key);
    if (!isSymbol(key) || !builtInSymbols.has(key)) {
      track(target, "has", key);
    }
    return result;
  }
  ownKeys(target) {
    track(
      target,
      "iterate",
      isArray(target) ? "length" : ITERATE_KEY
    );
    return Reflect.ownKeys(target);
  }
}
class ReadonlyReactiveHandler extends BaseReactiveHandler {
  constructor(isShallow2 = false) {
    super(true, isShallow2);
  }
  set(target, key) {
    return true;
  }
  deleteProperty(target, key) {
    return true;
  }
}
const mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
const readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
const shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
const shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
const toShallow = (value) => value;
const getProto = (v) => Reflect.getPrototypeOf(v);
function createIterableMethod(method, isReadonly2, isShallow2) {
  return function(...args) {
    const target = this["__v_raw"];
    const rawTarget = toRaw(target);
    const targetIsMap = isMap(rawTarget);
    const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
    const isKeyOnly = method === "keys" && targetIsMap;
    const innerIterator = target[method](...args);
    const wrap2 = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
    !isReadonly2 && track(
      rawTarget,
      "iterate",
      isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
    );
    return {
      // iterator protocol
      next() {
        const { value, done } = innerIterator.next();
        return done ? { value, done } : {
          value: isPair ? [wrap2(value[0]), wrap2(value[1])] : wrap2(value),
          done
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function createReadonlyMethod(type) {
  return function(...args) {
    return type === "delete" ? false : type === "clear" ? void 0 : this;
  };
}
function createInstrumentations(readonly2, shallow) {
  const instrumentations = {
    get(key) {
      const target = this["__v_raw"];
      const rawTarget = toRaw(target);
      const rawKey = toRaw(key);
      if (!readonly2) {
        if (hasChanged(key, rawKey)) {
          track(rawTarget, "get", key);
        }
        track(rawTarget, "get", rawKey);
      }
      const { has } = getProto(rawTarget);
      const wrap2 = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
      if (has.call(rawTarget, key)) {
        return wrap2(target.get(key));
      } else if (has.call(rawTarget, rawKey)) {
        return wrap2(target.get(rawKey));
      } else if (target !== rawTarget) {
        target.get(key);
      }
    },
    get size() {
      const target = this["__v_raw"];
      !readonly2 && track(toRaw(target), "iterate", ITERATE_KEY);
      return Reflect.get(target, "size", target);
    },
    has(key) {
      const target = this["__v_raw"];
      const rawTarget = toRaw(target);
      const rawKey = toRaw(key);
      if (!readonly2) {
        if (hasChanged(key, rawKey)) {
          track(rawTarget, "has", key);
        }
        track(rawTarget, "has", rawKey);
      }
      return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
    },
    forEach(callback, thisArg) {
      const observed = this;
      const target = observed["__v_raw"];
      const rawTarget = toRaw(target);
      const wrap2 = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
      !readonly2 && track(rawTarget, "iterate", ITERATE_KEY);
      return target.forEach((value, key) => {
        return callback.call(thisArg, wrap2(value), wrap2(key), observed);
      });
    }
  };
  extend$2(
    instrumentations,
    readonly2 ? {
      add: createReadonlyMethod("add"),
      set: createReadonlyMethod("set"),
      delete: createReadonlyMethod("delete"),
      clear: createReadonlyMethod("clear")
    } : {
      add(value) {
        if (!shallow && !isShallow(value) && !isReadonly(value)) {
          value = toRaw(value);
        }
        const target = toRaw(this);
        const proto = getProto(target);
        const hadKey = proto.has.call(target, value);
        if (!hadKey) {
          target.add(value);
          trigger(target, "add", value, value);
        }
        return this;
      },
      set(key, value) {
        if (!shallow && !isShallow(value) && !isReadonly(value)) {
          value = toRaw(value);
        }
        const target = toRaw(this);
        const { has, get: get2 } = getProto(target);
        let hadKey = has.call(target, key);
        if (!hadKey) {
          key = toRaw(key);
          hadKey = has.call(target, key);
        }
        const oldValue = get2.call(target, key);
        target.set(key, value);
        if (!hadKey) {
          trigger(target, "add", key, value);
        } else if (hasChanged(value, oldValue)) {
          trigger(target, "set", key, value);
        }
        return this;
      },
      delete(key) {
        const target = toRaw(this);
        const { has, get: get2 } = getProto(target);
        let hadKey = has.call(target, key);
        if (!hadKey) {
          key = toRaw(key);
          hadKey = has.call(target, key);
        }
        get2 ? get2.call(target, key) : void 0;
        const result = target.delete(key);
        if (hadKey) {
          trigger(target, "delete", key, void 0);
        }
        return result;
      },
      clear() {
        const target = toRaw(this);
        const hadItems = target.size !== 0;
        const result = target.clear();
        if (hadItems) {
          trigger(
            target,
            "clear",
            void 0,
            void 0
          );
        }
        return result;
      }
    }
  );
  const iteratorMethods = [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ];
  iteratorMethods.forEach((method) => {
    instrumentations[method] = createIterableMethod(method, readonly2, shallow);
  });
  return instrumentations;
}
function createInstrumentationGetter(isReadonly2, shallow) {
  const instrumentations = createInstrumentations(isReadonly2, shallow);
  return (target, key, receiver) => {
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_raw") {
      return target;
    }
    return Reflect.get(
      hasOwn(instrumentations, key) && key in target ? instrumentations : target,
      key,
      receiver
    );
  };
}
const mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const shallowReadonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function getTargetType(value) {
  return value["__v_skip"] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
}
function reactive(target) {
  if (isReadonly(target)) {
    return target;
  }
  return createReactiveObject(
    target,
    false,
    mutableHandlers,
    mutableCollectionHandlers,
    reactiveMap
  );
}
function shallowReactive(target) {
  return createReactiveObject(
    target,
    false,
    shallowReactiveHandlers,
    shallowCollectionHandlers,
    shallowReactiveMap
  );
}
function readonly(target) {
  return createReactiveObject(
    target,
    true,
    readonlyHandlers,
    readonlyCollectionHandlers,
    readonlyMap
  );
}
function shallowReadonly(target) {
  return createReactiveObject(
    target,
    true,
    shallowReadonlyHandlers,
    shallowReadonlyCollectionHandlers,
    shallowReadonlyMap
  );
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject$3(target)) {
    return target;
  }
  if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) {
    return target;
  }
  const existingProxy = proxyMap.get(target);
  if (existingProxy) {
    return existingProxy;
  }
  const targetType = getTargetType(target);
  if (targetType === 0) {
    return target;
  }
  const proxy = new Proxy(
    target,
    targetType === 2 ? collectionHandlers : baseHandlers
  );
  proxyMap.set(target, proxy);
  return proxy;
}
function isReactive(value) {
  if (isReadonly(value)) {
    return isReactive(value["__v_raw"]);
  }
  return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
  return !!(value && value["__v_isReadonly"]);
}
function isShallow(value) {
  return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
  return value ? !!value["__v_raw"] : false;
}
function toRaw(observed) {
  const raw = observed && observed["__v_raw"];
  return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
  if (!hasOwn(value, "__v_skip") && Object.isExtensible(value)) {
    def(value, "__v_skip", true);
  }
  return value;
}
const toReactive = (value) => isObject$3(value) ? reactive(value) : value;
const toReadonly = (value) => isObject$3(value) ? readonly(value) : value;
function isRef(r) {
  return r ? r["__v_isRef"] === true : false;
}
function ref(value) {
  return createRef(value, false);
}
function createRef(rawValue, shallow) {
  if (isRef(rawValue)) {
    return rawValue;
  }
  return new RefImpl(rawValue, shallow);
}
class RefImpl {
  constructor(value, isShallow2) {
    this.dep = new Dep();
    this["__v_isRef"] = true;
    this["__v_isShallow"] = false;
    this._rawValue = isShallow2 ? value : toRaw(value);
    this._value = isShallow2 ? value : toReactive(value);
    this["__v_isShallow"] = isShallow2;
  }
  get value() {
    {
      this.dep.track();
    }
    return this._value;
  }
  set value(newValue) {
    const oldValue = this._rawValue;
    const useDirectValue = this["__v_isShallow"] || isShallow(newValue) || isReadonly(newValue);
    newValue = useDirectValue ? newValue : toRaw(newValue);
    if (hasChanged(newValue, oldValue)) {
      this._rawValue = newValue;
      this._value = useDirectValue ? newValue : toReactive(newValue);
      {
        this.dep.trigger();
      }
    }
  }
}
function unref(ref2) {
  return isRef(ref2) ? ref2.value : ref2;
}
const shallowUnwrapHandlers = {
  get: (target, key, receiver) => key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver)),
  set: (target, key, value, receiver) => {
    const oldValue = target[key];
    if (isRef(oldValue) && !isRef(value)) {
      oldValue.value = value;
      return true;
    } else {
      return Reflect.set(target, key, value, receiver);
    }
  }
};
function proxyRefs(objectWithRefs) {
  return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
function toRefs(object) {
  const ret = isArray(object) ? new Array(object.length) : {};
  for (const key in object) {
    ret[key] = propertyToRef(object, key);
  }
  return ret;
}
class ObjectRefImpl {
  constructor(_object, _key, _defaultValue) {
    this._object = _object;
    this._key = _key;
    this._defaultValue = _defaultValue;
    this["__v_isRef"] = true;
    this._value = void 0;
  }
  get value() {
    const val = this._object[this._key];
    return this._value = val === void 0 ? this._defaultValue : val;
  }
  set value(newVal) {
    this._object[this._key] = newVal;
  }
  get dep() {
    return getDepFromReactive(toRaw(this._object), this._key);
  }
}
function propertyToRef(source, key, defaultValue) {
  const val = source[key];
  return isRef(val) ? val : new ObjectRefImpl(source, key, defaultValue);
}
class ComputedRefImpl {
  constructor(fn, setter, isSSR) {
    this.fn = fn;
    this.setter = setter;
    this._value = void 0;
    this.dep = new Dep(this);
    this.__v_isRef = true;
    this.deps = void 0;
    this.depsTail = void 0;
    this.flags = 16;
    this.globalVersion = globalVersion - 1;
    this.next = void 0;
    this.effect = this;
    this["__v_isReadonly"] = !setter;
    this.isSSR = isSSR;
  }
  /**
   * @internal
   */
  notify() {
    this.flags |= 16;
    if (!(this.flags & 8) && // avoid infinite self recursion
    activeSub !== this) {
      batch(this, true);
      return true;
    }
  }
  get value() {
    const link = this.dep.track();
    refreshComputed(this);
    if (link) {
      link.version = this.dep.version;
    }
    return this._value;
  }
  set value(newValue) {
    if (this.setter) {
      this.setter(newValue);
    }
  }
}
function computed$1(getterOrOptions, debugOptions, isSSR = false) {
  let getter;
  let setter;
  if (isFunction(getterOrOptions)) {
    getter = getterOrOptions;
  } else {
    getter = getterOrOptions.get;
    setter = getterOrOptions.set;
  }
  const cRef = new ComputedRefImpl(getter, setter, isSSR);
  return cRef;
}
const INITIAL_WATCHER_VALUE = {};
const cleanupMap = /* @__PURE__ */ new WeakMap();
let activeWatcher = void 0;
function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
  if (owner) {
    let cleanups = cleanupMap.get(owner);
    if (!cleanups) cleanupMap.set(owner, cleanups = []);
    cleanups.push(cleanupFn);
  }
}
function watch$1(source, cb, options = EMPTY_OBJ) {
  const { immediate, deep, once, scheduler, augmentJob, call } = options;
  const reactiveGetter = (source2) => {
    if (deep) return source2;
    if (isShallow(source2) || deep === false || deep === 0)
      return traverse(source2, 1);
    return traverse(source2);
  };
  let effect2;
  let getter;
  let cleanup;
  let boundCleanup;
  let forceTrigger = false;
  let isMultiSource = false;
  if (isRef(source)) {
    getter = () => source.value;
    forceTrigger = isShallow(source);
  } else if (isReactive(source)) {
    getter = () => reactiveGetter(source);
    forceTrigger = true;
  } else if (isArray(source)) {
    isMultiSource = true;
    forceTrigger = source.some((s) => isReactive(s) || isShallow(s));
    getter = () => source.map((s) => {
      if (isRef(s)) {
        return s.value;
      } else if (isReactive(s)) {
        return reactiveGetter(s);
      } else if (isFunction(s)) {
        return call ? call(s, 2) : s();
      } else ;
    });
  } else if (isFunction(source)) {
    if (cb) {
      getter = call ? () => call(source, 2) : source;
    } else {
      getter = () => {
        if (cleanup) {
          pauseTracking();
          try {
            cleanup();
          } finally {
            resetTracking();
          }
        }
        const currentEffect = activeWatcher;
        activeWatcher = effect2;
        try {
          return call ? call(source, 3, [boundCleanup]) : source(boundCleanup);
        } finally {
          activeWatcher = currentEffect;
        }
      };
    }
  } else {
    getter = NOOP;
  }
  if (cb && deep) {
    const baseGetter = getter;
    const depth = deep === true ? Infinity : deep;
    getter = () => traverse(baseGetter(), depth);
  }
  const scope = getCurrentScope$1();
  const watchHandle = () => {
    effect2.stop();
    if (scope && scope.active) {
      remove(scope.effects, effect2);
    }
  };
  if (once && cb) {
    const _cb = cb;
    cb = (...args) => {
      _cb(...args);
      watchHandle();
    };
  }
  let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
  const job = (immediateFirstRun) => {
    if (!(effect2.flags & 1) || !effect2.dirty && !immediateFirstRun) {
      return;
    }
    if (cb) {
      const newValue = effect2.run();
      if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i) => hasChanged(v, oldValue[i])) : hasChanged(newValue, oldValue))) {
        if (cleanup) {
          cleanup();
        }
        const currentWatcher = activeWatcher;
        activeWatcher = effect2;
        try {
          const args = [
            newValue,
            // pass undefined as the old value when it's changed for the first time
            oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
            boundCleanup
          ];
          call ? call(cb, 3, args) : (
            // @ts-expect-error
            cb(...args)
          );
          oldValue = newValue;
        } finally {
          activeWatcher = currentWatcher;
        }
      }
    } else {
      effect2.run();
    }
  };
  if (augmentJob) {
    augmentJob(job);
  }
  effect2 = new ReactiveEffect(getter);
  effect2.scheduler = scheduler ? () => scheduler(job, false) : job;
  boundCleanup = (fn) => onWatcherCleanup(fn, false, effect2);
  cleanup = effect2.onStop = () => {
    const cleanups = cleanupMap.get(effect2);
    if (cleanups) {
      if (call) {
        call(cleanups, 4);
      } else {
        for (const cleanup2 of cleanups) cleanup2();
      }
      cleanupMap.delete(effect2);
    }
  };
  if (cb) {
    if (immediate) {
      job(true);
    } else {
      oldValue = effect2.run();
    }
  } else if (scheduler) {
    scheduler(job.bind(null, true), true);
  } else {
    effect2.run();
  }
  watchHandle.pause = effect2.pause.bind(effect2);
  watchHandle.resume = effect2.resume.bind(effect2);
  watchHandle.stop = watchHandle;
  return watchHandle;
}
function traverse(value, depth = Infinity, seen) {
  if (depth <= 0 || !isObject$3(value) || value["__v_skip"]) {
    return value;
  }
  seen = seen || /* @__PURE__ */ new Set();
  if (seen.has(value)) {
    return value;
  }
  seen.add(value);
  depth--;
  if (isRef(value)) {
    traverse(value.value, depth, seen);
  } else if (isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      traverse(value[i], depth, seen);
    }
  } else if (isSet(value) || isMap(value)) {
    value.forEach((v) => {
      traverse(v, depth, seen);
    });
  } else if (isPlainObject$1(value)) {
    for (const key in value) {
      traverse(value[key], depth, seen);
    }
    for (const key of Object.getOwnPropertySymbols(value)) {
      if (Object.prototype.propertyIsEnumerable.call(value, key)) {
        traverse(value[key], depth, seen);
      }
    }
  }
  return value;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const stack = [];
let isWarning = false;
function warn$1(msg, ...args) {
  if (isWarning) return;
  isWarning = true;
  pauseTracking();
  const instance = stack.length ? stack[stack.length - 1].component : null;
  const appWarnHandler = instance && instance.appContext.config.warnHandler;
  const trace = getComponentTrace();
  if (appWarnHandler) {
    callWithErrorHandling(
      appWarnHandler,
      instance,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a) => {
          var _a, _b;
          return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(
          ({ vnode }) => `at <${formatComponentName(instance, vnode.type)}>`
        ).join("\n"),
        trace
      ]
    );
  } else {
    const warnArgs = [`[Vue warn]: ${msg}`, ...args];
    if (trace.length && // avoid spamming console during tests
    true) {
      warnArgs.push(`
`, ...formatTrace(trace));
    }
    console.warn(...warnArgs);
  }
  resetTracking();
  isWarning = false;
}
function getComponentTrace() {
  let currentVNode = stack[stack.length - 1];
  if (!currentVNode) {
    return [];
  }
  const normalizedStack = [];
  while (currentVNode) {
    const last = normalizedStack[0];
    if (last && last.vnode === currentVNode) {
      last.recurseCount++;
    } else {
      normalizedStack.push({
        vnode: currentVNode,
        recurseCount: 0
      });
    }
    const parentInstance = currentVNode.component && currentVNode.component.parent;
    currentVNode = parentInstance && parentInstance.vnode;
  }
  return normalizedStack;
}
function formatTrace(trace) {
  const logs = [];
  trace.forEach((entry, i) => {
    logs.push(...i === 0 ? [] : [`
`], ...formatTraceEntry(entry));
  });
  return logs;
}
function formatTraceEntry({ vnode, recurseCount }) {
  const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
  const isRoot = vnode.component ? vnode.component.parent == null : false;
  const open = ` at <${formatComponentName(
    vnode.component,
    vnode.type,
    isRoot
  )}`;
  const close = `>` + postfix;
  return vnode.props ? [open, ...formatProps(vnode.props), close] : [open + close];
}
function formatProps(props) {
  const res = [];
  const keys = Object.keys(props);
  keys.slice(0, 3).forEach((key) => {
    res.push(...formatProp(key, props[key]));
  });
  if (keys.length > 3) {
    res.push(` ...`);
  }
  return res;
}
function formatProp(key, value, raw) {
  if (isString$1(value)) {
    value = JSON.stringify(value);
    return raw ? value : [`${key}=${value}`];
  } else if (typeof value === "number" || typeof value === "boolean" || value == null) {
    return raw ? value : [`${key}=${value}`];
  } else if (isRef(value)) {
    value = formatProp(key, toRaw(value.value), true);
    return raw ? value : [`${key}=Ref<`, value, `>`];
  } else if (isFunction(value)) {
    return [`${key}=fn${value.name ? `<${value.name}>` : ``}`];
  } else {
    value = toRaw(value);
    return raw ? value : [`${key}=`, value];
  }
}
function callWithErrorHandling(fn, instance, type, args) {
  try {
    return args ? fn(...args) : fn();
  } catch (err) {
    handleError(err, instance, type);
  }
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
  if (isFunction(fn)) {
    const res = callWithErrorHandling(fn, instance, type, args);
    if (res && isPromise$1(res)) {
      res.catch((err) => {
        handleError(err, instance, type);
      });
    }
    return res;
  }
  if (isArray(fn)) {
    const values = [];
    for (let i = 0; i < fn.length; i++) {
      values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
    }
    return values;
  }
}
function handleError(err, instance, type, throwInDev = true) {
  const contextVNode = instance ? instance.vnode : null;
  const { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || EMPTY_OBJ;
  if (instance) {
    let cur = instance.parent;
    const exposedInstance = instance.proxy;
    const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
    while (cur) {
      const errorCapturedHooks = cur.ec;
      if (errorCapturedHooks) {
        for (let i = 0; i < errorCapturedHooks.length; i++) {
          if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) {
            return;
          }
        }
      }
      cur = cur.parent;
    }
    if (errorHandler) {
      pauseTracking();
      callWithErrorHandling(errorHandler, null, 10, [
        err,
        exposedInstance,
        errorInfo
      ]);
      resetTracking();
      return;
    }
  }
  logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
  if (throwInProd) {
    throw err;
  } else {
    console.error(err);
  }
}
const queue = [];
let flushIndex = -1;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
function nextTick$1(fn) {
  const p2 = currentFlushPromise || resolvedPromise;
  return fn ? p2.then(this ? fn.bind(this) : fn) : p2;
}
function findInsertionIndex(id) {
  let start = flushIndex + 1;
  let end = queue.length;
  while (start < end) {
    const middle = start + end >>> 1;
    const middleJob = queue[middle];
    const middleJobId = getId(middleJob);
    if (middleJobId < id || middleJobId === id && middleJob.flags & 2) {
      start = middle + 1;
    } else {
      end = middle;
    }
  }
  return start;
}
function queueJob(job) {
  if (!(job.flags & 1)) {
    const jobId = getId(job);
    const lastJob = queue[queue.length - 1];
    if (!lastJob || // fast path when the job id is larger than the tail
    !(job.flags & 2) && jobId >= getId(lastJob)) {
      queue.push(job);
    } else {
      queue.splice(findInsertionIndex(jobId), 0, job);
    }
    job.flags |= 1;
    queueFlush();
  }
}
function queueFlush() {
  if (!currentFlushPromise) {
    currentFlushPromise = resolvedPromise.then(flushJobs);
  }
}
function queuePostFlushCb(cb) {
  if (!isArray(cb)) {
    if (activePostFlushCbs && cb.id === -1) {
      activePostFlushCbs.splice(postFlushIndex + 1, 0, cb);
    } else if (!(cb.flags & 1)) {
      pendingPostFlushCbs.push(cb);
      cb.flags |= 1;
    }
  } else {
    pendingPostFlushCbs.push(...cb);
  }
  queueFlush();
}
function flushPreFlushCbs(instance, seen, i = flushIndex + 1) {
  for (; i < queue.length; i++) {
    const cb = queue[i];
    if (cb && cb.flags & 2) {
      if (instance && cb.id !== instance.uid) {
        continue;
      }
      queue.splice(i, 1);
      i--;
      if (cb.flags & 4) {
        cb.flags &= -2;
      }
      cb();
      if (!(cb.flags & 4)) {
        cb.flags &= -2;
      }
    }
  }
}
function flushPostFlushCbs(seen) {
  if (pendingPostFlushCbs.length) {
    const deduped = [...new Set(pendingPostFlushCbs)].sort(
      (a, b3) => getId(a) - getId(b3)
    );
    pendingPostFlushCbs.length = 0;
    if (activePostFlushCbs) {
      activePostFlushCbs.push(...deduped);
      return;
    }
    activePostFlushCbs = deduped;
    for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
      const cb = activePostFlushCbs[postFlushIndex];
      if (cb.flags & 4) {
        cb.flags &= -2;
      }
      if (!(cb.flags & 8)) cb();
      cb.flags &= -2;
    }
    activePostFlushCbs = null;
    postFlushIndex = 0;
  }
}
const getId = (job) => job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function flushJobs(seen) {
  try {
    for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      if (job && !(job.flags & 8)) {
        if (false) ;
        if (job.flags & 4) {
          job.flags &= ~1;
        }
        callWithErrorHandling(
          job,
          job.i,
          job.i ? 15 : 14
        );
        if (!(job.flags & 4)) {
          job.flags &= ~1;
        }
      }
    }
  } finally {
    for (; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      if (job) {
        job.flags &= -2;
      }
    }
    flushIndex = -1;
    queue.length = 0;
    flushPostFlushCbs();
    currentFlushPromise = null;
    if (queue.length || pendingPostFlushCbs.length) {
      flushJobs();
    }
  }
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance) {
  const prev = currentRenderingInstance;
  currentRenderingInstance = instance;
  currentScopeId = instance && instance.type.__scopeId || null;
  return prev;
}
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
  if (!ctx) return fn;
  if (fn._n) {
    return fn;
  }
  const renderFnWithContext = (...args) => {
    if (renderFnWithContext._d) {
      setBlockTracking(-1);
    }
    const prevInstance = setCurrentRenderingInstance(ctx);
    let res;
    try {
      res = fn(...args);
    } finally {
      setCurrentRenderingInstance(prevInstance);
      if (renderFnWithContext._d) {
        setBlockTracking(1);
      }
    }
    return res;
  };
  renderFnWithContext._n = true;
  renderFnWithContext._c = true;
  renderFnWithContext._d = true;
  return renderFnWithContext;
}
function withDirectives(vnode, directives) {
  if (currentRenderingInstance === null) {
    return vnode;
  }
  const instance = getComponentPublicInstance(currentRenderingInstance);
  const bindings = vnode.dirs || (vnode.dirs = []);
  for (let i = 0; i < directives.length; i++) {
    let [dir, value, arg, modifiers = EMPTY_OBJ] = directives[i];
    if (dir) {
      if (isFunction(dir)) {
        dir = {
          mounted: dir,
          updated: dir
        };
      }
      if (dir.deep) {
        traverse(value);
      }
      bindings.push({
        dir,
        instance,
        value,
        oldValue: void 0,
        arg,
        modifiers
      });
    }
  }
  return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
  const bindings = vnode.dirs;
  const oldBindings = prevVNode && prevVNode.dirs;
  for (let i = 0; i < bindings.length; i++) {
    const binding = bindings[i];
    if (oldBindings) {
      binding.oldValue = oldBindings[i].value;
    }
    let hook = binding.dir[name];
    if (hook) {
      pauseTracking();
      callWithAsyncErrorHandling(hook, instance, 8, [
        vnode.el,
        binding,
        vnode,
        prevVNode
      ]);
      resetTracking();
    }
  }
}
const TeleportEndKey = Symbol("_vte");
const isTeleport = (type) => type.__isTeleport;
function setTransitionHooks(vnode, hooks) {
  if (vnode.shapeFlag & 6 && vnode.component) {
    vnode.transition = hooks;
    setTransitionHooks(vnode.component.subTree, hooks);
  } else if (vnode.shapeFlag & 128) {
    vnode.ssContent.transition = hooks.clone(vnode.ssContent);
    vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
  } else {
    vnode.transition = hooks;
  }
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function defineComponent(options, extraOptions) {
  return isFunction(options) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (() => extend$2({ name: options.name }, extraOptions, { setup: options }))()
  ) : options;
}
function useId() {
  const i = getCurrentInstance();
  if (i) {
    return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
  }
  return "";
}
function markAsyncBoundary(instance) {
  instance.ids = [instance.ids[0] + instance.ids[2]++ + "-", 0, 0];
}
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
  if (isArray(rawRef)) {
    rawRef.forEach(
      (r, i) => setRef(
        r,
        oldRawRef && (isArray(oldRawRef) ? oldRawRef[i] : oldRawRef),
        parentSuspense,
        vnode,
        isUnmount
      )
    );
    return;
  }
  if (isAsyncWrapper(vnode) && !isUnmount) {
    if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) {
      setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
    }
    return;
  }
  const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
  const value = isUnmount ? null : refValue;
  const { i: owner, r: ref3 } = rawRef;
  const oldRef = oldRawRef && oldRawRef.r;
  const refs = owner.refs === EMPTY_OBJ ? owner.refs = {} : owner.refs;
  const setupState = owner.setupState;
  const rawSetupState = toRaw(setupState);
  const canSetSetupRef = setupState === EMPTY_OBJ ? () => false : (key) => {
    return hasOwn(rawSetupState, key);
  };
  if (oldRef != null && oldRef !== ref3) {
    if (isString$1(oldRef)) {
      refs[oldRef] = null;
      if (canSetSetupRef(oldRef)) {
        setupState[oldRef] = null;
      }
    } else if (isRef(oldRef)) {
      oldRef.value = null;
    }
  }
  if (isFunction(ref3)) {
    callWithErrorHandling(ref3, owner, 12, [value, refs]);
  } else {
    const _isString = isString$1(ref3);
    const _isRef = isRef(ref3);
    if (_isString || _isRef) {
      const doSet = () => {
        if (rawRef.f) {
          const existing = _isString ? canSetSetupRef(ref3) ? setupState[ref3] : refs[ref3] : ref3.value;
          if (isUnmount) {
            isArray(existing) && remove(existing, refValue);
          } else {
            if (!isArray(existing)) {
              if (_isString) {
                refs[ref3] = [refValue];
                if (canSetSetupRef(ref3)) {
                  setupState[ref3] = refs[ref3];
                }
              } else {
                ref3.value = [refValue];
                if (rawRef.k) refs[rawRef.k] = ref3.value;
              }
            } else if (!existing.includes(refValue)) {
              existing.push(refValue);
            }
          }
        } else if (_isString) {
          refs[ref3] = value;
          if (canSetSetupRef(ref3)) {
            setupState[ref3] = value;
          }
        } else if (_isRef) {
          ref3.value = value;
          if (rawRef.k) refs[rawRef.k] = value;
        } else ;
      };
      if (value) {
        doSet.id = -1;
        queuePostRenderEffect(doSet, parentSuspense);
      } else {
        doSet();
      }
    }
  }
}
getGlobalThis().requestIdleCallback || ((cb) => setTimeout(cb, 1));
getGlobalThis().cancelIdleCallback || ((id) => clearTimeout(id));
const isAsyncWrapper = (i) => !!i.type.__asyncLoader;
const isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
function onActivated(hook, target) {
  registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
  registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
  const wrappedHook = hook.__wdc || (hook.__wdc = () => {
    let current = target;
    while (current) {
      if (current.isDeactivated) {
        return;
      }
      current = current.parent;
    }
    return hook();
  });
  injectHook(type, wrappedHook, target);
  if (target) {
    let current = target.parent;
    while (current && current.parent) {
      if (isKeepAlive(current.parent.vnode)) {
        injectToKeepAliveRoot(wrappedHook, type, target, current);
      }
      current = current.parent;
    }
  }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
  const injected = injectHook(
    type,
    hook,
    keepAliveRoot,
    true
    /* prepend */
  );
  onUnmounted(() => {
    remove(keepAliveRoot[type], injected);
  }, target);
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
  if (target) {
    const hooks = target[type] || (target[type] = []);
    const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
      pauseTracking();
      const reset = setCurrentInstance(target);
      const res = callWithAsyncErrorHandling(hook, target, type, args);
      reset();
      resetTracking();
      return res;
    });
    if (prepend) {
      hooks.unshift(wrappedHook);
    } else {
      hooks.push(wrappedHook);
    }
    return wrappedHook;
  }
}
const createHook = (lifecycle) => (hook, target = currentInstance) => {
  if (!isInSSRComponentSetup || lifecycle === "sp") {
    injectHook(lifecycle, (...args) => hook(...args), target);
  }
};
const onBeforeMount = createHook("bm");
const onMounted = createHook("m");
const onBeforeUpdate = createHook(
  "bu"
);
const onUpdated = createHook("u");
const onBeforeUnmount = createHook(
  "bum"
);
const onUnmounted = createHook("um");
const onServerPrefetch = createHook(
  "sp"
);
const onRenderTriggered = createHook("rtg");
const onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
  injectHook("ec", hook, target);
}
const COMPONENTS = "components";
function resolveComponent(name, maybeSelfReference) {
  return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
}
const NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
  const instance = currentRenderingInstance || currentInstance;
  if (instance) {
    const Component = instance.type;
    {
      const selfName = getComponentName$1(
        Component,
        false
      );
      if (selfName && (selfName === name || selfName === camelize(name) || selfName === capitalize(camelize(name)))) {
        return Component;
      }
    }
    const res = (
      // local registration
      // check instance[type] first which is resolved for options API
      resolve(instance[type] || Component[type], name) || // global registration
      resolve(instance.appContext[type], name)
    );
    if (!res && maybeSelfReference) {
      return Component;
    }
    return res;
  }
}
function resolve(registry, name) {
  return registry && (registry[name] || registry[camelize(name)] || registry[capitalize(camelize(name))]);
}
function renderList(source, renderItem, cache, index) {
  let ret;
  const cached = cache;
  const sourceIsArray = isArray(source);
  if (sourceIsArray || isString$1(source)) {
    const sourceIsReactiveArray = sourceIsArray && isReactive(source);
    let needsWrap = false;
    if (sourceIsReactiveArray) {
      needsWrap = !isShallow(source);
      source = shallowReadArray(source);
    }
    ret = new Array(source.length);
    for (let i = 0, l = source.length; i < l; i++) {
      ret[i] = renderItem(
        needsWrap ? toReactive(source[i]) : source[i],
        i,
        void 0,
        cached
      );
    }
  } else if (typeof source === "number") {
    ret = new Array(source);
    for (let i = 0; i < source; i++) {
      ret[i] = renderItem(i + 1, i, void 0, cached);
    }
  } else if (isObject$3(source)) {
    if (source[Symbol.iterator]) {
      ret = Array.from(
        source,
        (item, i) => renderItem(item, i, void 0, cached)
      );
    } else {
      const keys = Object.keys(source);
      ret = new Array(keys.length);
      for (let i = 0, l = keys.length; i < l; i++) {
        const key = keys[i];
        ret[i] = renderItem(source[key], key, i, cached);
      }
    }
  } else {
    ret = [];
  }
  return ret;
}
function renderSlot(slots, name, props = {}, fallback, noSlotted) {
  if (currentRenderingInstance.ce || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.ce) {
    return openBlock(), createBlock(
      Fragment,
      null,
      [createVNode("slot", props, fallback)],
      64
    );
  }
  let slot = slots[name];
  if (slot && slot._c) {
    slot._d = false;
  }
  openBlock();
  const validSlotContent = slot && ensureValidVNode(slot(props));
  const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  validSlotContent && validSlotContent.key;
  const rendered = createBlock(
    Fragment,
    {
      key: (slotKey && !isSymbol(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
      (!validSlotContent && fallback ? "_fb" : "")
    },
    validSlotContent || [],
    validSlotContent && slots._ === 1 ? 64 : -2
  );
  if (rendered.scopeId) {
    rendered.slotScopeIds = [rendered.scopeId + "-s"];
  }
  if (slot && slot._c) {
    slot._d = true;
  }
  return rendered;
}
function ensureValidVNode(vnodes) {
  return vnodes.some((child) => {
    if (!isVNode(child)) return true;
    if (child.type === Comment) return false;
    if (child.type === Fragment && !ensureValidVNode(child.children))
      return false;
    return true;
  }) ? vnodes : null;
}
const getPublicInstance = (i) => {
  if (!i) return null;
  if (isStatefulComponent(i)) return getComponentPublicInstance(i);
  return getPublicInstance(i.parent);
};
const publicPropertiesMap = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ extend$2(/* @__PURE__ */ Object.create(null), {
    $: (i) => i,
    $el: (i) => i.vnode.el,
    $data: (i) => i.data,
    $props: (i) => i.props,
    $attrs: (i) => i.attrs,
    $slots: (i) => i.slots,
    $refs: (i) => i.refs,
    $parent: (i) => getPublicInstance(i.parent),
    $root: (i) => getPublicInstance(i.root),
    $host: (i) => i.ce,
    $emit: (i) => i.emit,
    $options: (i) => resolveMergedOptions(i),
    $forceUpdate: (i) => i.f || (i.f = () => {
      queueJob(i.update);
    }),
    $nextTick: (i) => i.n || (i.n = nextTick$1.bind(i.proxy)),
    $watch: (i) => instanceWatch.bind(i)
  })
);
const hasSetupBinding = (state, key) => state !== EMPTY_OBJ && !state.__isScriptSetup && hasOwn(state, key);
const PublicInstanceProxyHandlers = {
  get({ _: instance }, key) {
    if (key === "__v_skip") {
      return true;
    }
    const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
    let normalizedProps;
    if (key[0] !== "$") {
      const n = accessCache[key];
      if (n !== void 0) {
        switch (n) {
          case 1:
            return setupState[key];
          case 2:
            return data[key];
          case 4:
            return ctx[key];
          case 3:
            return props[key];
        }
      } else if (hasSetupBinding(setupState, key)) {
        accessCache[key] = 1;
        return setupState[key];
      } else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
        accessCache[key] = 2;
        return data[key];
      } else if (
        // only cache other properties when instance has declared (thus stable)
        // props
        (normalizedProps = instance.propsOptions[0]) && hasOwn(normalizedProps, key)
      ) {
        accessCache[key] = 3;
        return props[key];
      } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
        accessCache[key] = 4;
        return ctx[key];
      } else if (shouldCacheAccess) {
        accessCache[key] = 0;
      }
    }
    const publicGetter = publicPropertiesMap[key];
    let cssModule, globalProperties;
    if (publicGetter) {
      if (key === "$attrs") {
        track(instance.attrs, "get", "");
      }
      return publicGetter(instance);
    } else if (
      // css module (injected by vue-loader)
      (cssModule = type.__cssModules) && (cssModule = cssModule[key])
    ) {
      return cssModule;
    } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
      accessCache[key] = 4;
      return ctx[key];
    } else if (
      // global properties
      globalProperties = appContext.config.globalProperties, hasOwn(globalProperties, key)
    ) {
      {
        return globalProperties[key];
      }
    } else ;
  },
  set({ _: instance }, key, value) {
    const { data, setupState, ctx } = instance;
    if (hasSetupBinding(setupState, key)) {
      setupState[key] = value;
      return true;
    } else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
      data[key] = value;
      return true;
    } else if (hasOwn(instance.props, key)) {
      return false;
    }
    if (key[0] === "$" && key.slice(1) in instance) {
      return false;
    } else {
      {
        ctx[key] = value;
      }
    }
    return true;
  },
  has({
    _: { data, setupState, accessCache, ctx, appContext, propsOptions }
  }, key) {
    let normalizedProps;
    return !!accessCache[key] || data !== EMPTY_OBJ && hasOwn(data, key) || hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && hasOwn(normalizedProps, key) || hasOwn(ctx, key) || hasOwn(publicPropertiesMap, key) || hasOwn(appContext.config.globalProperties, key);
  },
  defineProperty(target, key, descriptor) {
    if (descriptor.get != null) {
      target._.accessCache[key] = 0;
    } else if (hasOwn(descriptor, "value")) {
      this.set(target, key, descriptor.value, null);
    }
    return Reflect.defineProperty(target, key, descriptor);
  }
};
function normalizePropsOrEmits(props) {
  return isArray(props) ? props.reduce(
    (normalized, p2) => (normalized[p2] = null, normalized),
    {}
  ) : props;
}
let shouldCacheAccess = true;
function applyOptions(instance) {
  const options = resolveMergedOptions(instance);
  const publicThis = instance.proxy;
  const ctx = instance.ctx;
  shouldCacheAccess = false;
  if (options.beforeCreate) {
    callHook(options.beforeCreate, instance, "bc");
  }
  const {
    // state
    data: dataOptions,
    computed: computedOptions,
    methods,
    watch: watchOptions,
    provide: provideOptions,
    inject: injectOptions,
    // lifecycle
    created,
    beforeMount,
    mounted,
    beforeUpdate,
    updated,
    activated,
    deactivated,
    beforeDestroy,
    beforeUnmount,
    destroyed,
    unmounted,
    render,
    renderTracked,
    renderTriggered,
    errorCaptured,
    serverPrefetch,
    // public API
    expose,
    inheritAttrs,
    // assets
    components,
    directives,
    filters
  } = options;
  const checkDuplicateProperties = null;
  if (injectOptions) {
    resolveInjections(injectOptions, ctx, checkDuplicateProperties);
  }
  if (methods) {
    for (const key in methods) {
      const methodHandler = methods[key];
      if (isFunction(methodHandler)) {
        {
          ctx[key] = methodHandler.bind(publicThis);
        }
      }
    }
  }
  if (dataOptions) {
    const data = dataOptions.call(publicThis, publicThis);
    if (!isObject$3(data)) ;
    else {
      instance.data = reactive(data);
    }
  }
  shouldCacheAccess = true;
  if (computedOptions) {
    for (const key in computedOptions) {
      const opt = computedOptions[key];
      const get2 = isFunction(opt) ? opt.bind(publicThis, publicThis) : isFunction(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP;
      const set = !isFunction(opt) && isFunction(opt.set) ? opt.set.bind(publicThis) : NOOP;
      const c = computed({
        get: get2,
        set
      });
      Object.defineProperty(ctx, key, {
        enumerable: true,
        configurable: true,
        get: () => c.value,
        set: (v) => c.value = v
      });
    }
  }
  if (watchOptions) {
    for (const key in watchOptions) {
      createWatcher(watchOptions[key], ctx, publicThis, key);
    }
  }
  if (provideOptions) {
    const provides = isFunction(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
    Reflect.ownKeys(provides).forEach((key) => {
      provide(key, provides[key]);
    });
  }
  if (created) {
    callHook(created, instance, "c");
  }
  function registerLifecycleHook(register2, hook) {
    if (isArray(hook)) {
      hook.forEach((_hook) => register2(_hook.bind(publicThis)));
    } else if (hook) {
      register2(hook.bind(publicThis));
    }
  }
  registerLifecycleHook(onBeforeMount, beforeMount);
  registerLifecycleHook(onMounted, mounted);
  registerLifecycleHook(onBeforeUpdate, beforeUpdate);
  registerLifecycleHook(onUpdated, updated);
  registerLifecycleHook(onActivated, activated);
  registerLifecycleHook(onDeactivated, deactivated);
  registerLifecycleHook(onErrorCaptured, errorCaptured);
  registerLifecycleHook(onRenderTracked, renderTracked);
  registerLifecycleHook(onRenderTriggered, renderTriggered);
  registerLifecycleHook(onBeforeUnmount, beforeUnmount);
  registerLifecycleHook(onUnmounted, unmounted);
  registerLifecycleHook(onServerPrefetch, serverPrefetch);
  if (isArray(expose)) {
    if (expose.length) {
      const exposed = instance.exposed || (instance.exposed = {});
      expose.forEach((key) => {
        Object.defineProperty(exposed, key, {
          get: () => publicThis[key],
          set: (val) => publicThis[key] = val
        });
      });
    } else if (!instance.exposed) {
      instance.exposed = {};
    }
  }
  if (render && instance.render === NOOP) {
    instance.render = render;
  }
  if (inheritAttrs != null) {
    instance.inheritAttrs = inheritAttrs;
  }
  if (components) instance.components = components;
  if (directives) instance.directives = directives;
  if (serverPrefetch) {
    markAsyncBoundary(instance);
  }
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = NOOP) {
  if (isArray(injectOptions)) {
    injectOptions = normalizeInject(injectOptions);
  }
  for (const key in injectOptions) {
    const opt = injectOptions[key];
    let injected;
    if (isObject$3(opt)) {
      if ("default" in opt) {
        injected = inject(
          opt.from || key,
          opt.default,
          true
        );
      } else {
        injected = inject(opt.from || key);
      }
    } else {
      injected = inject(opt);
    }
    if (isRef(injected)) {
      Object.defineProperty(ctx, key, {
        enumerable: true,
        configurable: true,
        get: () => injected.value,
        set: (v) => injected.value = v
      });
    } else {
      ctx[key] = injected;
    }
  }
}
function callHook(hook, instance, type) {
  callWithAsyncErrorHandling(
    isArray(hook) ? hook.map((h2) => h2.bind(instance.proxy)) : hook.bind(instance.proxy),
    instance,
    type
  );
}
function createWatcher(raw, ctx, publicThis, key) {
  let getter = key.includes(".") ? createPathGetter(publicThis, key) : () => publicThis[key];
  if (isString$1(raw)) {
    const handler = ctx[raw];
    if (isFunction(handler)) {
      {
        watch(getter, handler);
      }
    }
  } else if (isFunction(raw)) {
    {
      watch(getter, raw.bind(publicThis));
    }
  } else if (isObject$3(raw)) {
    if (isArray(raw)) {
      raw.forEach((r) => createWatcher(r, ctx, publicThis, key));
    } else {
      const handler = isFunction(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
      if (isFunction(handler)) {
        watch(getter, handler, raw);
      }
    }
  } else ;
}
function resolveMergedOptions(instance) {
  const base = instance.type;
  const { mixins, extends: extendsOptions } = base;
  const {
    mixins: globalMixins,
    optionsCache: cache,
    config: { optionMergeStrategies }
  } = instance.appContext;
  const cached = cache.get(base);
  let resolved;
  if (cached) {
    resolved = cached;
  } else if (!globalMixins.length && !mixins && !extendsOptions) {
    {
      resolved = base;
    }
  } else {
    resolved = {};
    if (globalMixins.length) {
      globalMixins.forEach(
        (m) => mergeOptions(resolved, m, optionMergeStrategies, true)
      );
    }
    mergeOptions(resolved, base, optionMergeStrategies);
  }
  if (isObject$3(base)) {
    cache.set(base, resolved);
  }
  return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
  const { mixins, extends: extendsOptions } = from;
  if (extendsOptions) {
    mergeOptions(to, extendsOptions, strats, true);
  }
  if (mixins) {
    mixins.forEach(
      (m) => mergeOptions(to, m, strats, true)
    );
  }
  for (const key in from) {
    if (asMixin && key === "expose") ;
    else {
      const strat = internalOptionMergeStrats[key] || strats && strats[key];
      to[key] = strat ? strat(to[key], from[key]) : from[key];
    }
  }
  return to;
}
const internalOptionMergeStrats = {
  data: mergeDataFn,
  props: mergeEmitsOrPropsOptions,
  emits: mergeEmitsOrPropsOptions,
  // objects
  methods: mergeObjectOptions,
  computed: mergeObjectOptions,
  // lifecycle
  beforeCreate: mergeAsArray,
  created: mergeAsArray,
  beforeMount: mergeAsArray,
  mounted: mergeAsArray,
  beforeUpdate: mergeAsArray,
  updated: mergeAsArray,
  beforeDestroy: mergeAsArray,
  beforeUnmount: mergeAsArray,
  destroyed: mergeAsArray,
  unmounted: mergeAsArray,
  activated: mergeAsArray,
  deactivated: mergeAsArray,
  errorCaptured: mergeAsArray,
  serverPrefetch: mergeAsArray,
  // assets
  components: mergeObjectOptions,
  directives: mergeObjectOptions,
  // watch
  watch: mergeWatchOptions,
  // provide / inject
  provide: mergeDataFn,
  inject: mergeInject
};
function mergeDataFn(to, from) {
  if (!from) {
    return to;
  }
  if (!to) {
    return from;
  }
  return function mergedDataFn() {
    return extend$2(
      isFunction(to) ? to.call(this, this) : to,
      isFunction(from) ? from.call(this, this) : from
    );
  };
}
function mergeInject(to, from) {
  return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
  if (isArray(raw)) {
    const res = {};
    for (let i = 0; i < raw.length; i++) {
      res[raw[i]] = raw[i];
    }
    return res;
  }
  return raw;
}
function mergeAsArray(to, from) {
  return to ? [...new Set([].concat(to, from))] : from;
}
function mergeObjectOptions(to, from) {
  return to ? extend$2(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function mergeEmitsOrPropsOptions(to, from) {
  if (to) {
    if (isArray(to) && isArray(from)) {
      return [.../* @__PURE__ */ new Set([...to, ...from])];
    }
    return extend$2(
      /* @__PURE__ */ Object.create(null),
      normalizePropsOrEmits(to),
      normalizePropsOrEmits(from != null ? from : {})
    );
  } else {
    return from;
  }
}
function mergeWatchOptions(to, from) {
  if (!to) return from;
  if (!from) return to;
  const merged = extend$2(/* @__PURE__ */ Object.create(null), to);
  for (const key in from) {
    merged[key] = mergeAsArray(to[key], from[key]);
  }
  return merged;
}
function createAppContext() {
  return {
    app: null,
    config: {
      isNativeTag: NO,
      performance: false,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let uid$1 = 0;
function createAppAPI(render, hydrate) {
  return function createApp2(rootComponent, rootProps = null) {
    if (!isFunction(rootComponent)) {
      rootComponent = extend$2({}, rootComponent);
    }
    if (rootProps != null && !isObject$3(rootProps)) {
      rootProps = null;
    }
    const context = createAppContext();
    const installedPlugins = /* @__PURE__ */ new WeakSet();
    const pluginCleanupFns = [];
    let isMounted = false;
    const app = context.app = {
      _uid: uid$1++,
      _component: rootComponent,
      _props: rootProps,
      _container: null,
      _context: context,
      _instance: null,
      version,
      get config() {
        return context.config;
      },
      set config(v) {
      },
      use(plugin, ...options) {
        if (installedPlugins.has(plugin)) ;
        else if (plugin && isFunction(plugin.install)) {
          installedPlugins.add(plugin);
          plugin.install(app, ...options);
        } else if (isFunction(plugin)) {
          installedPlugins.add(plugin);
          plugin(app, ...options);
        } else ;
        return app;
      },
      mixin(mixin) {
        {
          if (!context.mixins.includes(mixin)) {
            context.mixins.push(mixin);
          }
        }
        return app;
      },
      component(name, component) {
        if (!component) {
          return context.components[name];
        }
        context.components[name] = component;
        return app;
      },
      directive(name, directive) {
        if (!directive) {
          return context.directives[name];
        }
        context.directives[name] = directive;
        return app;
      },
      mount(rootContainer, isHydrate, namespace) {
        if (!isMounted) {
          const vnode = app._ceVNode || createVNode(rootComponent, rootProps);
          vnode.appContext = context;
          if (namespace === true) {
            namespace = "svg";
          } else if (namespace === false) {
            namespace = void 0;
          }
          {
            render(vnode, rootContainer, namespace);
          }
          isMounted = true;
          app._container = rootContainer;
          rootContainer.__vue_app__ = app;
          return getComponentPublicInstance(vnode.component);
        }
      },
      onUnmount(cleanupFn) {
        pluginCleanupFns.push(cleanupFn);
      },
      unmount() {
        if (isMounted) {
          callWithAsyncErrorHandling(
            pluginCleanupFns,
            app._instance,
            16
          );
          render(null, app._container);
          delete app._container.__vue_app__;
        }
      },
      provide(key, value) {
        context.provides[key] = value;
        return app;
      },
      runWithContext(fn) {
        const lastApp = currentApp;
        currentApp = app;
        try {
          return fn();
        } finally {
          currentApp = lastApp;
        }
      }
    };
    return app;
  };
}
let currentApp = null;
function provide(key, value) {
  if (!currentInstance) ;
  else {
    let provides = currentInstance.provides;
    const parentProvides = currentInstance.parent && currentInstance.parent.provides;
    if (parentProvides === provides) {
      provides = currentInstance.provides = Object.create(parentProvides);
    }
    provides[key] = value;
  }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
  const instance = currentInstance || currentRenderingInstance;
  if (instance || currentApp) {
    const provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
    if (provides && key in provides) {
      return provides[key];
    } else if (arguments.length > 1) {
      return treatDefaultAsFactory && isFunction(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    } else ;
  }
}
const internalObjectProto = {};
const createInternalObject = () => Object.create(internalObjectProto);
const isInternalObject = (obj) => Object.getPrototypeOf(obj) === internalObjectProto;
function initProps(instance, rawProps, isStateful, isSSR = false) {
  const props = {};
  const attrs = createInternalObject();
  instance.propsDefaults = /* @__PURE__ */ Object.create(null);
  setFullProps(instance, rawProps, props, attrs);
  for (const key in instance.propsOptions[0]) {
    if (!(key in props)) {
      props[key] = void 0;
    }
  }
  if (isStateful) {
    instance.props = isSSR ? props : shallowReactive(props);
  } else {
    if (!instance.type.props) {
      instance.props = attrs;
    } else {
      instance.props = props;
    }
  }
  instance.attrs = attrs;
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
  const {
    props,
    attrs,
    vnode: { patchFlag }
  } = instance;
  const rawCurrentProps = toRaw(props);
  const [options] = instance.propsOptions;
  let hasAttrsChanged = false;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)
  ) {
    if (patchFlag & 8) {
      const propsToUpdate = instance.vnode.dynamicProps;
      for (let i = 0; i < propsToUpdate.length; i++) {
        let key = propsToUpdate[i];
        if (isEmitListener(instance.emitsOptions, key)) {
          continue;
        }
        const value = rawProps[key];
        if (options) {
          if (hasOwn(attrs, key)) {
            if (value !== attrs[key]) {
              attrs[key] = value;
              hasAttrsChanged = true;
            }
          } else {
            const camelizedKey = camelize(key);
            props[camelizedKey] = resolvePropValue(
              options,
              rawCurrentProps,
              camelizedKey,
              value,
              instance,
              false
            );
          }
        } else {
          if (value !== attrs[key]) {
            attrs[key] = value;
            hasAttrsChanged = true;
          }
        }
      }
    }
  } else {
    if (setFullProps(instance, rawProps, props, attrs)) {
      hasAttrsChanged = true;
    }
    let kebabKey;
    for (const key in rawCurrentProps) {
      if (!rawProps || // for camelCase
      !hasOwn(rawProps, key) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((kebabKey = hyphenate(key)) === key || !hasOwn(rawProps, kebabKey))) {
        if (options) {
          if (rawPrevProps && // for camelCase
          (rawPrevProps[key] !== void 0 || // for kebab-case
          rawPrevProps[kebabKey] !== void 0)) {
            props[key] = resolvePropValue(
              options,
              rawCurrentProps,
              key,
              void 0,
              instance,
              true
            );
          }
        } else {
          delete props[key];
        }
      }
    }
    if (attrs !== rawCurrentProps) {
      for (const key in attrs) {
        if (!rawProps || !hasOwn(rawProps, key) && true) {
          delete attrs[key];
          hasAttrsChanged = true;
        }
      }
    }
  }
  if (hasAttrsChanged) {
    trigger(instance.attrs, "set", "");
  }
}
function setFullProps(instance, rawProps, props, attrs) {
  const [options, needCastKeys] = instance.propsOptions;
  let hasAttrsChanged = false;
  let rawCastValues;
  if (rawProps) {
    for (let key in rawProps) {
      if (isReservedProp(key)) {
        continue;
      }
      const value = rawProps[key];
      let camelKey;
      if (options && hasOwn(options, camelKey = camelize(key))) {
        if (!needCastKeys || !needCastKeys.includes(camelKey)) {
          props[camelKey] = value;
        } else {
          (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        }
      } else if (!isEmitListener(instance.emitsOptions, key)) {
        if (!(key in attrs) || value !== attrs[key]) {
          attrs[key] = value;
          hasAttrsChanged = true;
        }
      }
    }
  }
  if (needCastKeys) {
    const rawCurrentProps = toRaw(props);
    const castValues = rawCastValues || EMPTY_OBJ;
    for (let i = 0; i < needCastKeys.length; i++) {
      const key = needCastKeys[i];
      props[key] = resolvePropValue(
        options,
        rawCurrentProps,
        key,
        castValues[key],
        instance,
        !hasOwn(castValues, key)
      );
    }
  }
  return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
  const opt = options[key];
  if (opt != null) {
    const hasDefault = hasOwn(opt, "default");
    if (hasDefault && value === void 0) {
      const defaultValue = opt.default;
      if (opt.type !== Function && !opt.skipFactory && isFunction(defaultValue)) {
        const { propsDefaults } = instance;
        if (key in propsDefaults) {
          value = propsDefaults[key];
        } else {
          const reset = setCurrentInstance(instance);
          value = propsDefaults[key] = defaultValue.call(
            null,
            props
          );
          reset();
        }
      } else {
        value = defaultValue;
      }
      if (instance.ce) {
        instance.ce._setProp(key, value);
      }
    }
    if (opt[
      0
      /* shouldCast */
    ]) {
      if (isAbsent && !hasDefault) {
        value = false;
      } else if (opt[
        1
        /* shouldCastTrue */
      ] && (value === "" || value === hyphenate(key))) {
        value = true;
      }
    }
  }
  return value;
}
const mixinPropsCache = /* @__PURE__ */ new WeakMap();
function normalizePropsOptions(comp, appContext, asMixin = false) {
  const cache = asMixin ? mixinPropsCache : appContext.propsCache;
  const cached = cache.get(comp);
  if (cached) {
    return cached;
  }
  const raw = comp.props;
  const normalized = {};
  const needCastKeys = [];
  let hasExtends = false;
  if (!isFunction(comp)) {
    const extendProps = (raw2) => {
      hasExtends = true;
      const [props, keys] = normalizePropsOptions(raw2, appContext, true);
      extend$2(normalized, props);
      if (keys) needCastKeys.push(...keys);
    };
    if (!asMixin && appContext.mixins.length) {
      appContext.mixins.forEach(extendProps);
    }
    if (comp.extends) {
      extendProps(comp.extends);
    }
    if (comp.mixins) {
      comp.mixins.forEach(extendProps);
    }
  }
  if (!raw && !hasExtends) {
    if (isObject$3(comp)) {
      cache.set(comp, EMPTY_ARR);
    }
    return EMPTY_ARR;
  }
  if (isArray(raw)) {
    for (let i = 0; i < raw.length; i++) {
      const normalizedKey = camelize(raw[i]);
      if (validatePropName(normalizedKey)) {
        normalized[normalizedKey] = EMPTY_OBJ;
      }
    }
  } else if (raw) {
    for (const key in raw) {
      const normalizedKey = camelize(key);
      if (validatePropName(normalizedKey)) {
        const opt = raw[key];
        const prop = normalized[normalizedKey] = isArray(opt) || isFunction(opt) ? { type: opt } : extend$2({}, opt);
        const propType = prop.type;
        let shouldCast = false;
        let shouldCastTrue = true;
        if (isArray(propType)) {
          for (let index = 0; index < propType.length; ++index) {
            const type = propType[index];
            const typeName = isFunction(type) && type.name;
            if (typeName === "Boolean") {
              shouldCast = true;
              break;
            } else if (typeName === "String") {
              shouldCastTrue = false;
            }
          }
        } else {
          shouldCast = isFunction(propType) && propType.name === "Boolean";
        }
        prop[
          0
          /* shouldCast */
        ] = shouldCast;
        prop[
          1
          /* shouldCastTrue */
        ] = shouldCastTrue;
        if (shouldCast || hasOwn(prop, "default")) {
          needCastKeys.push(normalizedKey);
        }
      }
    }
  }
  const res = [normalized, needCastKeys];
  if (isObject$3(comp)) {
    cache.set(comp, res);
  }
  return res;
}
function validatePropName(key) {
  if (key[0] !== "$" && !isReservedProp(key)) {
    return true;
  }
  return false;
}
const isInternalKey = (key) => key[0] === "_" || key === "$stable";
const normalizeSlotValue = (value) => isArray(value) ? value.map(normalizeVNode) : [normalizeVNode(value)];
const normalizeSlot = (key, rawSlot, ctx) => {
  if (rawSlot._n) {
    return rawSlot;
  }
  const normalized = withCtx((...args) => {
    if (false) ;
    return normalizeSlotValue(rawSlot(...args));
  }, ctx);
  normalized._c = false;
  return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance) => {
  const ctx = rawSlots._ctx;
  for (const key in rawSlots) {
    if (isInternalKey(key)) continue;
    const value = rawSlots[key];
    if (isFunction(value)) {
      slots[key] = normalizeSlot(key, value, ctx);
    } else if (value != null) {
      const normalized = normalizeSlotValue(value);
      slots[key] = () => normalized;
    }
  }
};
const normalizeVNodeSlots = (instance, children) => {
  const normalized = normalizeSlotValue(children);
  instance.slots.default = () => normalized;
};
const assignSlots = (slots, children, optimized) => {
  for (const key in children) {
    if (optimized || key !== "_") {
      slots[key] = children[key];
    }
  }
};
const initSlots = (instance, children, optimized) => {
  const slots = instance.slots = createInternalObject();
  if (instance.vnode.shapeFlag & 32) {
    const type = children._;
    if (type) {
      assignSlots(slots, children, optimized);
      if (optimized) {
        def(slots, "_", type, true);
      }
    } else {
      normalizeObjectSlots(children, slots);
    }
  } else if (children) {
    normalizeVNodeSlots(instance, children);
  }
};
const updateSlots = (instance, children, optimized) => {
  const { vnode, slots } = instance;
  let needDeletionCheck = true;
  let deletionComparisonTarget = EMPTY_OBJ;
  if (vnode.shapeFlag & 32) {
    const type = children._;
    if (type) {
      if (optimized && type === 1) {
        needDeletionCheck = false;
      } else {
        assignSlots(slots, children, optimized);
      }
    } else {
      needDeletionCheck = !children.$stable;
      normalizeObjectSlots(children, slots);
    }
    deletionComparisonTarget = children;
  } else if (children) {
    normalizeVNodeSlots(instance, children);
    deletionComparisonTarget = { default: 1 };
  }
  if (needDeletionCheck) {
    for (const key in slots) {
      if (!isInternalKey(key) && deletionComparisonTarget[key] == null) {
        delete slots[key];
      }
    }
  }
};
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
  return baseCreateRenderer(options);
}
function baseCreateRenderer(options, createHydrationFns) {
  const target = getGlobalThis();
  target.__VUE__ = true;
  const {
    insert: hostInsert,
    remove: hostRemove,
    patchProp: hostPatchProp,
    createElement: hostCreateElement,
    createText: hostCreateText,
    createComment: hostCreateComment,
    setText: hostSetText,
    setElementText: hostSetElementText,
    parentNode: hostParentNode,
    nextSibling: hostNextSibling,
    setScopeId: hostSetScopeId = NOOP,
    insertStaticContent: hostInsertStaticContent
  } = options;
  const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace = void 0, slotScopeIds = null, optimized = !!n2.dynamicChildren) => {
    if (n1 === n2) {
      return;
    }
    if (n1 && !isSameVNodeType(n1, n2)) {
      anchor = getNextHostNode(n1);
      unmount(n1, parentComponent, parentSuspense, true);
      n1 = null;
    }
    if (n2.patchFlag === -2) {
      optimized = false;
      n2.dynamicChildren = null;
    }
    const { type, ref: ref3, shapeFlag } = n2;
    switch (type) {
      case Text:
        processText(n1, n2, container, anchor);
        break;
      case Comment:
        processCommentNode(n1, n2, container, anchor);
        break;
      case Static:
        if (n1 == null) {
          mountStaticNode(n2, container, anchor, namespace);
        }
        break;
      case Fragment:
        processFragment(
          n1,
          n2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
        break;
      default:
        if (shapeFlag & 1) {
          processElement(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else if (shapeFlag & 6) {
          processComponent(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else if (shapeFlag & 64) {
          type.process(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized,
            internals
          );
        } else if (shapeFlag & 128) {
          type.process(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized,
            internals
          );
        } else ;
    }
    if (ref3 != null && parentComponent) {
      setRef(ref3, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    }
  };
  const processText = (n1, n2, container, anchor) => {
    if (n1 == null) {
      hostInsert(
        n2.el = hostCreateText(n2.children),
        container,
        anchor
      );
    } else {
      const el = n2.el = n1.el;
      if (n2.children !== n1.children) {
        hostSetText(el, n2.children);
      }
    }
  };
  const processCommentNode = (n1, n2, container, anchor) => {
    if (n1 == null) {
      hostInsert(
        n2.el = hostCreateComment(n2.children || ""),
        container,
        anchor
      );
    } else {
      n2.el = n1.el;
    }
  };
  const mountStaticNode = (n2, container, anchor, namespace) => {
    [n2.el, n2.anchor] = hostInsertStaticContent(
      n2.children,
      container,
      anchor,
      namespace,
      n2.el,
      n2.anchor
    );
  };
  const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
    let next;
    while (el && el !== anchor) {
      next = hostNextSibling(el);
      hostInsert(el, container, nextSibling);
      el = next;
    }
    hostInsert(anchor, container, nextSibling);
  };
  const removeStaticNode = ({ el, anchor }) => {
    let next;
    while (el && el !== anchor) {
      next = hostNextSibling(el);
      hostRemove(el);
      el = next;
    }
    hostRemove(anchor);
  };
  const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    if (n2.type === "svg") {
      namespace = "svg";
    } else if (n2.type === "math") {
      namespace = "mathml";
    }
    if (n1 == null) {
      mountElement(
        n2,
        container,
        anchor,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized
      );
    } else {
      patchElement(
        n1,
        n2,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized
      );
    }
  };
  const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    let el;
    let vnodeHook;
    const { props, shapeFlag, transition: transition2, dirs } = vnode;
    el = vnode.el = hostCreateElement(
      vnode.type,
      namespace,
      props && props.is,
      props
    );
    if (shapeFlag & 8) {
      hostSetElementText(el, vnode.children);
    } else if (shapeFlag & 16) {
      mountChildren(
        vnode.children,
        el,
        null,
        parentComponent,
        parentSuspense,
        resolveChildrenNamespace(vnode, namespace),
        slotScopeIds,
        optimized
      );
    }
    if (dirs) {
      invokeDirectiveHook(vnode, null, parentComponent, "created");
    }
    setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
    if (props) {
      for (const key in props) {
        if (key !== "value" && !isReservedProp(key)) {
          hostPatchProp(el, key, null, props[key], namespace, parentComponent);
        }
      }
      if ("value" in props) {
        hostPatchProp(el, "value", null, props.value, namespace);
      }
      if (vnodeHook = props.onVnodeBeforeMount) {
        invokeVNodeHook(vnodeHook, parentComponent, vnode);
      }
    }
    if (dirs) {
      invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
    }
    const needCallTransitionHooks = needTransition(parentSuspense, transition2);
    if (needCallTransitionHooks) {
      transition2.beforeEnter(el);
    }
    hostInsert(el, container, anchor);
    if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
        needCallTransitionHooks && transition2.enter(el);
        dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
      }, parentSuspense);
    }
  };
  const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
    if (scopeId) {
      hostSetScopeId(el, scopeId);
    }
    if (slotScopeIds) {
      for (let i = 0; i < slotScopeIds.length; i++) {
        hostSetScopeId(el, slotScopeIds[i]);
      }
    }
    if (parentComponent) {
      let subTree = parentComponent.subTree;
      if (vnode === subTree || isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
        const parentVNode = parentComponent.vnode;
        setScopeId(
          el,
          parentVNode,
          parentVNode.scopeId,
          parentVNode.slotScopeIds,
          parentComponent.parent
        );
      }
    }
  };
  const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0) => {
    for (let i = start; i < children.length; i++) {
      const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
      patch(
        null,
        child,
        container,
        anchor,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized
      );
    }
  };
  const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    const el = n2.el = n1.el;
    let { patchFlag, dynamicChildren, dirs } = n2;
    patchFlag |= n1.patchFlag & 16;
    const oldProps = n1.props || EMPTY_OBJ;
    const newProps = n2.props || EMPTY_OBJ;
    let vnodeHook;
    parentComponent && toggleRecurse(parentComponent, false);
    if (vnodeHook = newProps.onVnodeBeforeUpdate) {
      invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
    }
    if (dirs) {
      invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
    }
    parentComponent && toggleRecurse(parentComponent, true);
    if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) {
      hostSetElementText(el, "");
    }
    if (dynamicChildren) {
      patchBlockChildren(
        n1.dynamicChildren,
        dynamicChildren,
        el,
        parentComponent,
        parentSuspense,
        resolveChildrenNamespace(n2, namespace),
        slotScopeIds
      );
    } else if (!optimized) {
      patchChildren(
        n1,
        n2,
        el,
        null,
        parentComponent,
        parentSuspense,
        resolveChildrenNamespace(n2, namespace),
        slotScopeIds,
        false
      );
    }
    if (patchFlag > 0) {
      if (patchFlag & 16) {
        patchProps(el, oldProps, newProps, parentComponent, namespace);
      } else {
        if (patchFlag & 2) {
          if (oldProps.class !== newProps.class) {
            hostPatchProp(el, "class", null, newProps.class, namespace);
          }
        }
        if (patchFlag & 4) {
          hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
        }
        if (patchFlag & 8) {
          const propsToUpdate = n2.dynamicProps;
          for (let i = 0; i < propsToUpdate.length; i++) {
            const key = propsToUpdate[i];
            const prev = oldProps[key];
            const next = newProps[key];
            if (next !== prev || key === "value") {
              hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
          }
        }
      }
      if (patchFlag & 1) {
        if (n1.children !== n2.children) {
          hostSetElementText(el, n2.children);
        }
      }
    } else if (!optimized && dynamicChildren == null) {
      patchProps(el, oldProps, newProps, parentComponent, namespace);
    }
    if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
      }, parentSuspense);
    }
  };
  const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) => {
    for (let i = 0; i < newChildren.length; i++) {
      const oldVNode = oldChildren[i];
      const newVNode = newChildren[i];
      const container = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
        oldVNode.shapeFlag & (6 | 64)) ? hostParentNode(oldVNode.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          fallbackContainer
        )
      );
      patch(
        oldVNode,
        newVNode,
        container,
        null,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        true
      );
    }
  };
  const patchProps = (el, oldProps, newProps, parentComponent, namespace) => {
    if (oldProps !== newProps) {
      if (oldProps !== EMPTY_OBJ) {
        for (const key in oldProps) {
          if (!isReservedProp(key) && !(key in newProps)) {
            hostPatchProp(
              el,
              key,
              oldProps[key],
              null,
              namespace,
              parentComponent
            );
          }
        }
      }
      for (const key in newProps) {
        if (isReservedProp(key)) continue;
        const next = newProps[key];
        const prev = oldProps[key];
        if (next !== prev && key !== "value") {
          hostPatchProp(el, key, prev, next, namespace, parentComponent);
        }
      }
      if ("value" in newProps) {
        hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
      }
    }
  };
  const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
    const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
    let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
    if (fragmentSlotScopeIds) {
      slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
    }
    if (n1 == null) {
      hostInsert(fragmentStartAnchor, container, anchor);
      hostInsert(fragmentEndAnchor, container, anchor);
      mountChildren(
        // #10007
        // such fragment like `<></>` will be compiled into
        // a fragment which doesn't have a children.
        // In this case fallback to an empty array
        n2.children || [],
        container,
        fragmentEndAnchor,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized
      );
    } else {
      if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
      // of renderSlot() with no valid children
      n1.dynamicChildren) {
        patchBlockChildren(
          n1.dynamicChildren,
          dynamicChildren,
          container,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds
        );
        if (
          // #2080 if the stable fragment has a key, it's a <template v-for> that may
          //  get moved around. Make sure all root level vnodes inherit el.
          // #2134 or if it's a component root, it may also get moved around
          // as the component is being moved.
          n2.key != null || parentComponent && n2 === parentComponent.subTree
        ) {
          traverseStaticChildren(
            n1,
            n2,
            true
            /* shallow */
          );
        }
      } else {
        patchChildren(
          n1,
          n2,
          container,
          fragmentEndAnchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      }
    }
  };
  const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    n2.slotScopeIds = slotScopeIds;
    if (n1 == null) {
      if (n2.shapeFlag & 512) {
        parentComponent.ctx.activate(
          n2,
          container,
          anchor,
          namespace,
          optimized
        );
      } else {
        mountComponent(
          n2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          optimized
        );
      }
    } else {
      updateComponent(n1, n2, optimized);
    }
  };
  const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) => {
    const instance = initialVNode.component = createComponentInstance(
      initialVNode,
      parentComponent,
      parentSuspense
    );
    if (isKeepAlive(initialVNode)) {
      instance.ctx.renderer = internals;
    }
    {
      setupComponent(instance, false, optimized);
    }
    if (instance.asyncDep) {
      parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
      if (!initialVNode.el) {
        const placeholder = instance.subTree = createVNode(Comment);
        processCommentNode(null, placeholder, container, anchor);
      }
    } else {
      setupRenderEffect(
        instance,
        initialVNode,
        container,
        anchor,
        parentSuspense,
        namespace,
        optimized
      );
    }
  };
  const updateComponent = (n1, n2, optimized) => {
    const instance = n2.component = n1.component;
    if (shouldUpdateComponent(n1, n2, optimized)) {
      if (instance.asyncDep && !instance.asyncResolved) {
        updateComponentPreRender(instance, n2, optimized);
        return;
      } else {
        instance.next = n2;
        instance.update();
      }
    } else {
      n2.el = n1.el;
      instance.vnode = n2;
    }
  };
  const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) => {
    const componentUpdateFn = () => {
      if (!instance.isMounted) {
        let vnodeHook;
        const { el, props } = initialVNode;
        const { bm, m, parent, root, type } = instance;
        const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
        toggleRecurse(instance, false);
        if (bm) {
          invokeArrayFns(bm);
        }
        if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) {
          invokeVNodeHook(vnodeHook, parent, initialVNode);
        }
        toggleRecurse(instance, true);
        {
          if (root.ce) {
            root.ce._injectChildStyle(type);
          }
          const subTree = instance.subTree = renderComponentRoot(instance);
          patch(
            null,
            subTree,
            container,
            anchor,
            instance,
            parentSuspense,
            namespace
          );
          initialVNode.el = subTree.el;
        }
        if (m) {
          queuePostRenderEffect(m, parentSuspense);
        }
        if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
          const scopedInitialVNode = initialVNode;
          queuePostRenderEffect(
            () => invokeVNodeHook(vnodeHook, parent, scopedInitialVNode),
            parentSuspense
          );
        }
        if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) {
          instance.a && queuePostRenderEffect(instance.a, parentSuspense);
        }
        instance.isMounted = true;
        initialVNode = container = anchor = null;
      } else {
        let { next, bu, u, parent, vnode } = instance;
        {
          const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
          if (nonHydratedAsyncRoot) {
            if (next) {
              next.el = vnode.el;
              updateComponentPreRender(instance, next, optimized);
            }
            nonHydratedAsyncRoot.asyncDep.then(() => {
              if (!instance.isUnmounted) {
                componentUpdateFn();
              }
            });
            return;
          }
        }
        let originNext = next;
        let vnodeHook;
        toggleRecurse(instance, false);
        if (next) {
          next.el = vnode.el;
          updateComponentPreRender(instance, next, optimized);
        } else {
          next = vnode;
        }
        if (bu) {
          invokeArrayFns(bu);
        }
        if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) {
          invokeVNodeHook(vnodeHook, parent, next, vnode);
        }
        toggleRecurse(instance, true);
        const nextTree = renderComponentRoot(instance);
        const prevTree = instance.subTree;
        instance.subTree = nextTree;
        patch(
          prevTree,
          nextTree,
          // parent may have changed if it's in a teleport
          hostParentNode(prevTree.el),
          // anchor may have changed if it's in a fragment
          getNextHostNode(prevTree),
          instance,
          parentSuspense,
          namespace
        );
        next.el = nextTree.el;
        if (originNext === null) {
          updateHOCHostEl(instance, nextTree.el);
        }
        if (u) {
          queuePostRenderEffect(u, parentSuspense);
        }
        if (vnodeHook = next.props && next.props.onVnodeUpdated) {
          queuePostRenderEffect(
            () => invokeVNodeHook(vnodeHook, parent, next, vnode),
            parentSuspense
          );
        }
      }
    };
    instance.scope.on();
    const effect2 = instance.effect = new ReactiveEffect(componentUpdateFn);
    instance.scope.off();
    const update4 = instance.update = effect2.run.bind(effect2);
    const job = instance.job = effect2.runIfDirty.bind(effect2);
    job.i = instance;
    job.id = instance.uid;
    effect2.scheduler = () => queueJob(job);
    toggleRecurse(instance, true);
    update4();
  };
  const updateComponentPreRender = (instance, nextVNode, optimized) => {
    nextVNode.component = instance;
    const prevProps = instance.vnode.props;
    instance.vnode = nextVNode;
    instance.next = null;
    updateProps(instance, nextVNode.props, prevProps, optimized);
    updateSlots(instance, nextVNode.children, optimized);
    pauseTracking();
    flushPreFlushCbs(instance);
    resetTracking();
  };
  const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false) => {
    const c1 = n1 && n1.children;
    const prevShapeFlag = n1 ? n1.shapeFlag : 0;
    const c2 = n2.children;
    const { patchFlag, shapeFlag } = n2;
    if (patchFlag > 0) {
      if (patchFlag & 128) {
        patchKeyedChildren(
          c1,
          c2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
        return;
      } else if (patchFlag & 256) {
        patchUnkeyedChildren(
          c1,
          c2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
        return;
      }
    }
    if (shapeFlag & 8) {
      if (prevShapeFlag & 16) {
        unmountChildren(c1, parentComponent, parentSuspense);
      }
      if (c2 !== c1) {
        hostSetElementText(container, c2);
      }
    } else {
      if (prevShapeFlag & 16) {
        if (shapeFlag & 16) {
          patchKeyedChildren(
            c1,
            c2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else {
          unmountChildren(c1, parentComponent, parentSuspense, true);
        }
      } else {
        if (prevShapeFlag & 8) {
          hostSetElementText(container, "");
        }
        if (shapeFlag & 16) {
          mountChildren(
            c2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        }
      }
    }
  };
  const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    c1 = c1 || EMPTY_ARR;
    c2 = c2 || EMPTY_ARR;
    const oldLength = c1.length;
    const newLength = c2.length;
    const commonLength = Math.min(oldLength, newLength);
    let i;
    for (i = 0; i < commonLength; i++) {
      const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
      patch(
        c1[i],
        nextChild,
        container,
        null,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized
      );
    }
    if (oldLength > newLength) {
      unmountChildren(
        c1,
        parentComponent,
        parentSuspense,
        true,
        false,
        commonLength
      );
    } else {
      mountChildren(
        c2,
        container,
        anchor,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized,
        commonLength
      );
    }
  };
  const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    let i = 0;
    const l2 = c2.length;
    let e12 = c1.length - 1;
    let e2 = l2 - 1;
    while (i <= e12 && i <= e2) {
      const n1 = c1[i];
      const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
      if (isSameVNodeType(n1, n2)) {
        patch(
          n1,
          n2,
          container,
          null,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      } else {
        break;
      }
      i++;
    }
    while (i <= e12 && i <= e2) {
      const n1 = c1[e12];
      const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
      if (isSameVNodeType(n1, n2)) {
        patch(
          n1,
          n2,
          container,
          null,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      } else {
        break;
      }
      e12--;
      e2--;
    }
    if (i > e12) {
      if (i <= e2) {
        const nextPos = e2 + 1;
        const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
        while (i <= e2) {
          patch(
            null,
            c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]),
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          i++;
        }
      }
    } else if (i > e2) {
      while (i <= e12) {
        unmount(c1[i], parentComponent, parentSuspense, true);
        i++;
      }
    } else {
      const s1 = i;
      const s2 = i;
      const keyToNewIndexMap = /* @__PURE__ */ new Map();
      for (i = s2; i <= e2; i++) {
        const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
        if (nextChild.key != null) {
          keyToNewIndexMap.set(nextChild.key, i);
        }
      }
      let j;
      let patched = 0;
      const toBePatched = e2 - s2 + 1;
      let moved = false;
      let maxNewIndexSoFar = 0;
      const newIndexToOldIndexMap = new Array(toBePatched);
      for (i = 0; i < toBePatched; i++) newIndexToOldIndexMap[i] = 0;
      for (i = s1; i <= e12; i++) {
        const prevChild = c1[i];
        if (patched >= toBePatched) {
          unmount(prevChild, parentComponent, parentSuspense, true);
          continue;
        }
        let newIndex;
        if (prevChild.key != null) {
          newIndex = keyToNewIndexMap.get(prevChild.key);
        } else {
          for (j = s2; j <= e2; j++) {
            if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
              newIndex = j;
              break;
            }
          }
        }
        if (newIndex === void 0) {
          unmount(prevChild, parentComponent, parentSuspense, true);
        } else {
          newIndexToOldIndexMap[newIndex - s2] = i + 1;
          if (newIndex >= maxNewIndexSoFar) {
            maxNewIndexSoFar = newIndex;
          } else {
            moved = true;
          }
          patch(
            prevChild,
            c2[newIndex],
            container,
            null,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          patched++;
        }
      }
      const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR;
      j = increasingNewIndexSequence.length - 1;
      for (i = toBePatched - 1; i >= 0; i--) {
        const nextIndex = s2 + i;
        const nextChild = c2[nextIndex];
        const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
        if (newIndexToOldIndexMap[i] === 0) {
          patch(
            null,
            nextChild,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else if (moved) {
          if (j < 0 || i !== increasingNewIndexSequence[j]) {
            move(nextChild, container, anchor, 2);
          } else {
            j--;
          }
        }
      }
    }
  };
  const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
    const { el, type, transition: transition2, children, shapeFlag } = vnode;
    if (shapeFlag & 6) {
      move(vnode.component.subTree, container, anchor, moveType);
      return;
    }
    if (shapeFlag & 128) {
      vnode.suspense.move(container, anchor, moveType);
      return;
    }
    if (shapeFlag & 64) {
      type.move(vnode, container, anchor, internals);
      return;
    }
    if (type === Fragment) {
      hostInsert(el, container, anchor);
      for (let i = 0; i < children.length; i++) {
        move(children[i], container, anchor, moveType);
      }
      hostInsert(vnode.anchor, container, anchor);
      return;
    }
    if (type === Static) {
      moveStaticNode(vnode, container, anchor);
      return;
    }
    const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition2;
    if (needTransition2) {
      if (moveType === 0) {
        transition2.beforeEnter(el);
        hostInsert(el, container, anchor);
        queuePostRenderEffect(() => transition2.enter(el), parentSuspense);
      } else {
        const { leave, delayLeave, afterLeave } = transition2;
        const remove22 = () => hostInsert(el, container, anchor);
        const performLeave = () => {
          leave(el, () => {
            remove22();
            afterLeave && afterLeave();
          });
        };
        if (delayLeave) {
          delayLeave(el, remove22, performLeave);
        } else {
          performLeave();
        }
      }
    } else {
      hostInsert(el, container, anchor);
    }
  };
  const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
    const {
      type,
      props,
      ref: ref3,
      children,
      dynamicChildren,
      shapeFlag,
      patchFlag,
      dirs,
      cacheIndex
    } = vnode;
    if (patchFlag === -2) {
      optimized = false;
    }
    if (ref3 != null) {
      setRef(ref3, null, parentSuspense, vnode, true);
    }
    if (cacheIndex != null) {
      parentComponent.renderCache[cacheIndex] = void 0;
    }
    if (shapeFlag & 256) {
      parentComponent.ctx.deactivate(vnode);
      return;
    }
    const shouldInvokeDirs = shapeFlag & 1 && dirs;
    const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
    let vnodeHook;
    if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) {
      invokeVNodeHook(vnodeHook, parentComponent, vnode);
    }
    if (shapeFlag & 6) {
      unmountComponent(vnode.component, parentSuspense, doRemove);
    } else {
      if (shapeFlag & 128) {
        vnode.suspense.unmount(parentSuspense, doRemove);
        return;
      }
      if (shouldInvokeDirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
      }
      if (shapeFlag & 64) {
        vnode.type.remove(
          vnode,
          parentComponent,
          parentSuspense,
          internals,
          doRemove
        );
      } else if (dynamicChildren && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (type !== Fragment || patchFlag > 0 && patchFlag & 64)) {
        unmountChildren(
          dynamicChildren,
          parentComponent,
          parentSuspense,
          false,
          true
        );
      } else if (type === Fragment && patchFlag & (128 | 256) || !optimized && shapeFlag & 16) {
        unmountChildren(children, parentComponent, parentSuspense);
      }
      if (doRemove) {
        remove2(vnode);
      }
    }
    if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
        shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
      }, parentSuspense);
    }
  };
  const remove2 = (vnode) => {
    const { type, el, anchor, transition: transition2 } = vnode;
    if (type === Fragment) {
      {
        removeFragment(el, anchor);
      }
      return;
    }
    if (type === Static) {
      removeStaticNode(vnode);
      return;
    }
    const performRemove = () => {
      hostRemove(el);
      if (transition2 && !transition2.persisted && transition2.afterLeave) {
        transition2.afterLeave();
      }
    };
    if (vnode.shapeFlag & 1 && transition2 && !transition2.persisted) {
      const { leave, delayLeave } = transition2;
      const performLeave = () => leave(el, performRemove);
      if (delayLeave) {
        delayLeave(vnode.el, performRemove, performLeave);
      } else {
        performLeave();
      }
    } else {
      performRemove();
    }
  };
  const removeFragment = (cur, end) => {
    let next;
    while (cur !== end) {
      next = hostNextSibling(cur);
      hostRemove(cur);
      cur = next;
    }
    hostRemove(end);
  };
  const unmountComponent = (instance, parentSuspense, doRemove) => {
    const { bum, scope, job, subTree, um, m, a } = instance;
    invalidateMount(m);
    invalidateMount(a);
    if (bum) {
      invokeArrayFns(bum);
    }
    scope.stop();
    if (job) {
      job.flags |= 8;
      unmount(subTree, instance, parentSuspense, doRemove);
    }
    if (um) {
      queuePostRenderEffect(um, parentSuspense);
    }
    queuePostRenderEffect(() => {
      instance.isUnmounted = true;
    }, parentSuspense);
    if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
      parentSuspense.deps--;
      if (parentSuspense.deps === 0) {
        parentSuspense.resolve();
      }
    }
  };
  const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0) => {
    for (let i = start; i < children.length; i++) {
      unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    }
  };
  const getNextHostNode = (vnode) => {
    if (vnode.shapeFlag & 6) {
      return getNextHostNode(vnode.component.subTree);
    }
    if (vnode.shapeFlag & 128) {
      return vnode.suspense.next();
    }
    const el = hostNextSibling(vnode.anchor || vnode.el);
    const teleportEnd = el && el[TeleportEndKey];
    return teleportEnd ? hostNextSibling(teleportEnd) : el;
  };
  let isFlushing = false;
  const render = (vnode, container, namespace) => {
    if (vnode == null) {
      if (container._vnode) {
        unmount(container._vnode, null, null, true);
      }
    } else {
      patch(
        container._vnode || null,
        vnode,
        container,
        null,
        null,
        null,
        namespace
      );
    }
    container._vnode = vnode;
    if (!isFlushing) {
      isFlushing = true;
      flushPreFlushCbs();
      flushPostFlushCbs();
      isFlushing = false;
    }
  };
  const internals = {
    p: patch,
    um: unmount,
    m: move,
    r: remove2,
    mt: mountComponent,
    mc: mountChildren,
    pc: patchChildren,
    pbc: patchBlockChildren,
    n: getNextHostNode,
    o: options
  };
  let hydrate;
  return {
    render,
    hydrate,
    createApp: createAppAPI(render)
  };
}
function resolveChildrenNamespace({ type, props }, currentNamespace) {
  return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function toggleRecurse({ effect: effect2, job }, allowed) {
  if (allowed) {
    effect2.flags |= 32;
    job.flags |= 4;
  } else {
    effect2.flags &= -33;
    job.flags &= -5;
  }
}
function needTransition(parentSuspense, transition2) {
  return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition2 && !transition2.persisted;
}
function traverseStaticChildren(n1, n2, shallow = false) {
  const ch1 = n1.children;
  const ch2 = n2.children;
  if (isArray(ch1) && isArray(ch2)) {
    for (let i = 0; i < ch1.length; i++) {
      const c1 = ch1[i];
      let c2 = ch2[i];
      if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
        if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
          c2 = ch2[i] = cloneIfMounted(ch2[i]);
          c2.el = c1.el;
        }
        if (!shallow && c2.patchFlag !== -2)
          traverseStaticChildren(c1, c2);
      }
      if (c2.type === Text) {
        c2.el = c1.el;
      }
    }
  }
}
function getSequence(arr) {
  const p2 = arr.slice();
  const result = [0];
  let i, j, u, v, c;
  const len = arr.length;
  for (i = 0; i < len; i++) {
    const arrI = arr[i];
    if (arrI !== 0) {
      j = result[result.length - 1];
      if (arr[j] < arrI) {
        p2[i] = j;
        result.push(i);
        continue;
      }
      u = 0;
      v = result.length - 1;
      while (u < v) {
        c = u + v >> 1;
        if (arr[result[c]] < arrI) {
          u = c + 1;
        } else {
          v = c;
        }
      }
      if (arrI < arr[result[u]]) {
        if (u > 0) {
          p2[i] = result[u - 1];
        }
        result[u] = i;
      }
    }
  }
  u = result.length;
  v = result[u - 1];
  while (u-- > 0) {
    result[u] = v;
    v = p2[v];
  }
  return result;
}
function locateNonHydratedAsyncRoot(instance) {
  const subComponent = instance.subTree.component;
  if (subComponent) {
    if (subComponent.asyncDep && !subComponent.asyncResolved) {
      return subComponent;
    } else {
      return locateNonHydratedAsyncRoot(subComponent);
    }
  }
}
function invalidateMount(hooks) {
  if (hooks) {
    for (let i = 0; i < hooks.length; i++)
      hooks[i].flags |= 8;
  }
}
const ssrContextKey = Symbol.for("v-scx");
const useSSRContext = () => {
  {
    const ctx = inject(ssrContextKey);
    return ctx;
  }
};
function watchEffect(effect2, options) {
  return doWatch(effect2, null, options);
}
function watch(source, cb, options) {
  return doWatch(source, cb, options);
}
function doWatch(source, cb, options = EMPTY_OBJ) {
  const { immediate, deep, flush, once } = options;
  const baseWatchOptions = extend$2({}, options);
  const runsImmediately = cb && immediate || !cb && flush !== "post";
  let ssrCleanup;
  if (isInSSRComponentSetup) {
    if (flush === "sync") {
      const ctx = useSSRContext();
      ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
    } else if (!runsImmediately) {
      const watchStopHandle = () => {
      };
      watchStopHandle.stop = NOOP;
      watchStopHandle.resume = NOOP;
      watchStopHandle.pause = NOOP;
      return watchStopHandle;
    }
  }
  const instance = currentInstance;
  baseWatchOptions.call = (fn, type, args) => callWithAsyncErrorHandling(fn, instance, type, args);
  let isPre = false;
  if (flush === "post") {
    baseWatchOptions.scheduler = (job) => {
      queuePostRenderEffect(job, instance && instance.suspense);
    };
  } else if (flush !== "sync") {
    isPre = true;
    baseWatchOptions.scheduler = (job, isFirstRun) => {
      if (isFirstRun) {
        job();
      } else {
        queueJob(job);
      }
    };
  }
  baseWatchOptions.augmentJob = (job) => {
    if (cb) {
      job.flags |= 4;
    }
    if (isPre) {
      job.flags |= 2;
      if (instance) {
        job.id = instance.uid;
        job.i = instance;
      }
    }
  };
  const watchHandle = watch$1(source, cb, baseWatchOptions);
  if (isInSSRComponentSetup) {
    if (ssrCleanup) {
      ssrCleanup.push(watchHandle);
    } else if (runsImmediately) {
      watchHandle();
    }
  }
  return watchHandle;
}
function instanceWatch(source, value, options) {
  const publicThis = this.proxy;
  const getter = isString$1(source) ? source.includes(".") ? createPathGetter(publicThis, source) : () => publicThis[source] : source.bind(publicThis, publicThis);
  let cb;
  if (isFunction(value)) {
    cb = value;
  } else {
    cb = value.handler;
    options = value;
  }
  const reset = setCurrentInstance(this);
  const res = doWatch(getter, cb.bind(publicThis), options);
  reset();
  return res;
}
function createPathGetter(ctx, path) {
  const segments = path.split(".");
  return () => {
    let cur = ctx;
    for (let i = 0; i < segments.length && cur; i++) {
      cur = cur[segments[i]];
    }
    return cur;
  };
}
const getModelModifiers = (props, modelName) => {
  return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${camelize(modelName)}Modifiers`] || props[`${hyphenate(modelName)}Modifiers`];
};
function emit(instance, event, ...rawArgs) {
  if (instance.isUnmounted) return;
  const props = instance.vnode.props || EMPTY_OBJ;
  let args = rawArgs;
  const isModelListener2 = event.startsWith("update:");
  const modifiers = isModelListener2 && getModelModifiers(props, event.slice(7));
  if (modifiers) {
    if (modifiers.trim) {
      args = rawArgs.map((a) => isString$1(a) ? a.trim() : a);
    }
    if (modifiers.number) {
      args = rawArgs.map(looseToNumber);
    }
  }
  let handlerName;
  let handler = props[handlerName = toHandlerKey(event)] || // also try camelCase event handler (#2249)
  props[handlerName = toHandlerKey(camelize(event))];
  if (!handler && isModelListener2) {
    handler = props[handlerName = toHandlerKey(hyphenate(event))];
  }
  if (handler) {
    callWithAsyncErrorHandling(
      handler,
      instance,
      6,
      args
    );
  }
  const onceHandler = props[handlerName + `Once`];
  if (onceHandler) {
    if (!instance.emitted) {
      instance.emitted = {};
    } else if (instance.emitted[handlerName]) {
      return;
    }
    instance.emitted[handlerName] = true;
    callWithAsyncErrorHandling(
      onceHandler,
      instance,
      6,
      args
    );
  }
}
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
  const cache = appContext.emitsCache;
  const cached = cache.get(comp);
  if (cached !== void 0) {
    return cached;
  }
  const raw = comp.emits;
  let normalized = {};
  let hasExtends = false;
  if (!isFunction(comp)) {
    const extendEmits = (raw2) => {
      const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
      if (normalizedFromExtend) {
        hasExtends = true;
        extend$2(normalized, normalizedFromExtend);
      }
    };
    if (!asMixin && appContext.mixins.length) {
      appContext.mixins.forEach(extendEmits);
    }
    if (comp.extends) {
      extendEmits(comp.extends);
    }
    if (comp.mixins) {
      comp.mixins.forEach(extendEmits);
    }
  }
  if (!raw && !hasExtends) {
    if (isObject$3(comp)) {
      cache.set(comp, null);
    }
    return null;
  }
  if (isArray(raw)) {
    raw.forEach((key) => normalized[key] = null);
  } else {
    extend$2(normalized, raw);
  }
  if (isObject$3(comp)) {
    cache.set(comp, normalized);
  }
  return normalized;
}
function isEmitListener(options, key) {
  if (!options || !isOn(key)) {
    return false;
  }
  key = key.slice(2).replace(/Once$/, "");
  return hasOwn(options, key[0].toLowerCase() + key.slice(1)) || hasOwn(options, hyphenate(key)) || hasOwn(options, key);
}
function markAttrsAccessed() {
}
function renderComponentRoot(instance) {
  const {
    type: Component,
    vnode,
    proxy,
    withProxy,
    propsOptions: [propsOptions],
    slots,
    attrs,
    emit: emit2,
    render,
    renderCache,
    props,
    data,
    setupState,
    ctx,
    inheritAttrs
  } = instance;
  const prev = setCurrentRenderingInstance(instance);
  let result;
  let fallthroughAttrs;
  try {
    if (vnode.shapeFlag & 4) {
      const proxyToUse = withProxy || proxy;
      const thisProxy = false ? new Proxy(proxyToUse, {
        get(target, key, receiver) {
          warn$1(
            `Property '${String(
              key
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          );
          return Reflect.get(target, key, receiver);
        }
      }) : proxyToUse;
      result = normalizeVNode(
        render.call(
          thisProxy,
          proxyToUse,
          renderCache,
          false ? shallowReadonly(props) : props,
          setupState,
          data,
          ctx
        )
      );
      fallthroughAttrs = attrs;
    } else {
      const render2 = Component;
      if (false) ;
      result = normalizeVNode(
        render2.length > 1 ? render2(
          false ? shallowReadonly(props) : props,
          false ? {
            get attrs() {
              markAttrsAccessed();
              return shallowReadonly(attrs);
            },
            slots,
            emit: emit2
          } : { attrs, slots, emit: emit2 }
        ) : render2(
          false ? shallowReadonly(props) : props,
          null
        )
      );
      fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
    }
  } catch (err) {
    blockStack.length = 0;
    handleError(err, instance, 1);
    result = createVNode(Comment);
  }
  let root = result;
  if (fallthroughAttrs && inheritAttrs !== false) {
    const keys = Object.keys(fallthroughAttrs);
    const { shapeFlag } = root;
    if (keys.length) {
      if (shapeFlag & (1 | 6)) {
        if (propsOptions && keys.some(isModelListener)) {
          fallthroughAttrs = filterModelListeners(
            fallthroughAttrs,
            propsOptions
          );
        }
        root = cloneVNode(root, fallthroughAttrs, false, true);
      }
    }
  }
  if (vnode.dirs) {
    root = cloneVNode(root, null, false, true);
    root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
  }
  if (vnode.transition) {
    setTransitionHooks(root, vnode.transition);
  }
  {
    result = root;
  }
  setCurrentRenderingInstance(prev);
  return result;
}
const getFunctionalFallthrough = (attrs) => {
  let res;
  for (const key in attrs) {
    if (key === "class" || key === "style" || isOn(key)) {
      (res || (res = {}))[key] = attrs[key];
    }
  }
  return res;
};
const filterModelListeners = (attrs, props) => {
  const res = {};
  for (const key in attrs) {
    if (!isModelListener(key) || !(key.slice(9) in props)) {
      res[key] = attrs[key];
    }
  }
  return res;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
  const { props: prevProps, children: prevChildren, component } = prevVNode;
  const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
  const emits = component.emitsOptions;
  if (nextVNode.dirs || nextVNode.transition) {
    return true;
  }
  if (optimized && patchFlag >= 0) {
    if (patchFlag & 1024) {
      return true;
    }
    if (patchFlag & 16) {
      if (!prevProps) {
        return !!nextProps;
      }
      return hasPropsChanged(prevProps, nextProps, emits);
    } else if (patchFlag & 8) {
      const dynamicProps = nextVNode.dynamicProps;
      for (let i = 0; i < dynamicProps.length; i++) {
        const key = dynamicProps[i];
        if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) {
          return true;
        }
      }
    }
  } else {
    if (prevChildren || nextChildren) {
      if (!nextChildren || !nextChildren.$stable) {
        return true;
      }
    }
    if (prevProps === nextProps) {
      return false;
    }
    if (!prevProps) {
      return !!nextProps;
    }
    if (!nextProps) {
      return true;
    }
    return hasPropsChanged(prevProps, nextProps, emits);
  }
  return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
  const nextKeys = Object.keys(nextProps);
  if (nextKeys.length !== Object.keys(prevProps).length) {
    return true;
  }
  for (let i = 0; i < nextKeys.length; i++) {
    const key = nextKeys[i];
    if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) {
      return true;
    }
  }
  return false;
}
function updateHOCHostEl({ vnode, parent }, el) {
  while (parent) {
    const root = parent.subTree;
    if (root.suspense && root.suspense.activeBranch === vnode) {
      root.el = vnode.el;
    }
    if (root === vnode) {
      (vnode = parent.vnode).el = el;
      parent = parent.parent;
    } else {
      break;
    }
  }
}
const isSuspense = (type) => type.__isSuspense;
function queueEffectWithSuspense(fn, suspense) {
  if (suspense && suspense.pendingBranch) {
    if (isArray(fn)) {
      suspense.effects.push(...fn);
    } else {
      suspense.effects.push(fn);
    }
  } else {
    queuePostFlushCb(fn);
  }
}
const Fragment = Symbol.for("v-fgt");
const Text = Symbol.for("v-txt");
const Comment = Symbol.for("v-cmt");
const Static = Symbol.for("v-stc");
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
  blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
  blockStack.pop();
  currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value, inVOnce = false) {
  isBlockTreeEnabled += value;
  if (value < 0 && currentBlock && inVOnce) {
    currentBlock.hasOnce = true;
  }
}
function setupBlock(vnode) {
  vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
  closeBlock();
  if (isBlockTreeEnabled > 0 && currentBlock) {
    currentBlock.push(vnode);
  }
  return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
  return setupBlock(
    createBaseVNode(
      type,
      props,
      children,
      patchFlag,
      dynamicProps,
      shapeFlag,
      true
    )
  );
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
  return setupBlock(
    createVNode(
      type,
      props,
      children,
      patchFlag,
      dynamicProps,
      true
    )
  );
}
function isVNode(value) {
  return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
  return n1.type === n2.type && n1.key === n2.key;
}
const normalizeKey = ({ key }) => key != null ? key : null;
const normalizeRef = ({
  ref: ref3,
  ref_key,
  ref_for
}) => {
  if (typeof ref3 === "number") {
    ref3 = "" + ref3;
  }
  return ref3 != null ? isString$1(ref3) || isRef(ref3) || isFunction(ref3) ? { i: currentRenderingInstance, r: ref3, k: ref_key, f: !!ref_for } : ref3 : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
  const vnode = {
    __v_isVNode: true,
    __v_skip: true,
    type,
    props,
    key: props && normalizeKey(props),
    ref: props && normalizeRef(props),
    scopeId: currentScopeId,
    slotScopeIds: null,
    children,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag,
    patchFlag,
    dynamicProps,
    dynamicChildren: null,
    appContext: null,
    ctx: currentRenderingInstance
  };
  if (needFullChildrenNormalization) {
    normalizeChildren(vnode, children);
    if (shapeFlag & 128) {
      type.normalize(vnode);
    }
  } else if (children) {
    vnode.shapeFlag |= isString$1(children) ? 8 : 16;
  }
  if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
  !isBlockNode && // has current parent block
  currentBlock && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  vnode.patchFlag !== 32) {
    currentBlock.push(vnode);
  }
  return vnode;
}
const createVNode = _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
  if (!type || type === NULL_DYNAMIC_COMPONENT) {
    type = Comment;
  }
  if (isVNode(type)) {
    const cloned = cloneVNode(
      type,
      props,
      true
      /* mergeRef: true */
    );
    if (children) {
      normalizeChildren(cloned, children);
    }
    if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
      if (cloned.shapeFlag & 6) {
        currentBlock[currentBlock.indexOf(type)] = cloned;
      } else {
        currentBlock.push(cloned);
      }
    }
    cloned.patchFlag = -2;
    return cloned;
  }
  if (isClassComponent(type)) {
    type = type.__vccOpts;
  }
  if (props) {
    props = guardReactiveProps(props);
    let { class: klass, style } = props;
    if (klass && !isString$1(klass)) {
      props.class = normalizeClass(klass);
    }
    if (isObject$3(style)) {
      if (isProxy(style) && !isArray(style)) {
        style = extend$2({}, style);
      }
      props.style = normalizeStyle(style);
    }
  }
  const shapeFlag = isString$1(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject$3(type) ? 4 : isFunction(type) ? 2 : 0;
  return createBaseVNode(
    type,
    props,
    children,
    patchFlag,
    dynamicProps,
    shapeFlag,
    isBlockNode,
    true
  );
}
function guardReactiveProps(props) {
  if (!props) return null;
  return isProxy(props) || isInternalObject(props) ? extend$2({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
  const { props, ref: ref3, patchFlag, children, transition: transition2 } = vnode;
  const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
  const cloned = {
    __v_isVNode: true,
    __v_skip: true,
    type: vnode.type,
    props: mergedProps,
    key: mergedProps && normalizeKey(mergedProps),
    ref: extraProps && extraProps.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      mergeRef && ref3 ? isArray(ref3) ? ref3.concat(normalizeRef(extraProps)) : [ref3, normalizeRef(extraProps)] : normalizeRef(extraProps)
    ) : ref3,
    scopeId: vnode.scopeId,
    slotScopeIds: vnode.slotScopeIds,
    children,
    target: vnode.target,
    targetStart: vnode.targetStart,
    targetAnchor: vnode.targetAnchor,
    staticCount: vnode.staticCount,
    shapeFlag: vnode.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
    dynamicProps: vnode.dynamicProps,
    dynamicChildren: vnode.dynamicChildren,
    appContext: vnode.appContext,
    dirs: vnode.dirs,
    transition: transition2,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: vnode.component,
    suspense: vnode.suspense,
    ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
    ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
    el: vnode.el,
    anchor: vnode.anchor,
    ctx: vnode.ctx,
    ce: vnode.ce
  };
  if (transition2 && cloneTransition) {
    setTransitionHooks(
      cloned,
      transition2.clone(cloned)
    );
  }
  return cloned;
}
function createTextVNode(text = " ", flag = 0) {
  return createVNode(Text, null, text, flag);
}
function createCommentVNode(text = "", asBlock = false) {
  return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
  if (child == null || typeof child === "boolean") {
    return createVNode(Comment);
  } else if (isArray(child)) {
    return createVNode(
      Fragment,
      null,
      // #3666, avoid reference pollution when reusing vnode
      child.slice()
    );
  } else if (isVNode(child)) {
    return cloneIfMounted(child);
  } else {
    return createVNode(Text, null, String(child));
  }
}
function cloneIfMounted(child) {
  return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
  let type = 0;
  const { shapeFlag } = vnode;
  if (children == null) {
    children = null;
  } else if (isArray(children)) {
    type = 16;
  } else if (typeof children === "object") {
    if (shapeFlag & (1 | 64)) {
      const slot = children.default;
      if (slot) {
        slot._c && (slot._d = false);
        normalizeChildren(vnode, slot());
        slot._c && (slot._d = true);
      }
      return;
    } else {
      type = 32;
      const slotFlag = children._;
      if (!slotFlag && !isInternalObject(children)) {
        children._ctx = currentRenderingInstance;
      } else if (slotFlag === 3 && currentRenderingInstance) {
        if (currentRenderingInstance.slots._ === 1) {
          children._ = 1;
        } else {
          children._ = 2;
          vnode.patchFlag |= 1024;
        }
      }
    }
  } else if (isFunction(children)) {
    children = { default: children, _ctx: currentRenderingInstance };
    type = 32;
  } else {
    children = String(children);
    if (shapeFlag & 64) {
      type = 16;
      children = [createTextVNode(children)];
    } else {
      type = 8;
    }
  }
  vnode.children = children;
  vnode.shapeFlag |= type;
}
function mergeProps(...args) {
  const ret = {};
  for (let i = 0; i < args.length; i++) {
    const toMerge = args[i];
    for (const key in toMerge) {
      if (key === "class") {
        if (ret.class !== toMerge.class) {
          ret.class = normalizeClass([ret.class, toMerge.class]);
        }
      } else if (key === "style") {
        ret.style = normalizeStyle([ret.style, toMerge.style]);
      } else if (isOn(key)) {
        const existing = ret[key];
        const incoming = toMerge[key];
        if (incoming && existing !== incoming && !(isArray(existing) && existing.includes(incoming))) {
          ret[key] = existing ? [].concat(existing, incoming) : incoming;
        }
      } else if (key !== "") {
        ret[key] = toMerge[key];
      }
    }
  }
  return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
  callWithAsyncErrorHandling(hook, instance, 7, [
    vnode,
    prevVNode
  ]);
}
const emptyAppContext = createAppContext();
let uid = 0;
function createComponentInstance(vnode, parent, suspense) {
  const type = vnode.type;
  const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
  const instance = {
    uid: uid++,
    vnode,
    type,
    parent,
    appContext,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new EffectScope(
      true
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: parent ? parent.provides : Object.create(appContext.provides),
    ids: parent ? parent.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: normalizePropsOptions(type, appContext),
    emitsOptions: normalizeEmitsOptions(type, appContext),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: EMPTY_OBJ,
    // inheritAttrs
    inheritAttrs: type.inheritAttrs,
    // state
    ctx: EMPTY_OBJ,
    data: EMPTY_OBJ,
    props: EMPTY_OBJ,
    attrs: EMPTY_OBJ,
    slots: EMPTY_OBJ,
    refs: EMPTY_OBJ,
    setupState: EMPTY_OBJ,
    setupContext: null,
    // suspense related
    suspense,
    suspenseId: suspense ? suspense.pendingId : 0,
    asyncDep: null,
    asyncResolved: false,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: false,
    isUnmounted: false,
    isDeactivated: false,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  {
    instance.ctx = { _: instance };
  }
  instance.root = parent ? parent.root : instance;
  instance.emit = emit.bind(null, instance);
  if (vnode.ce) {
    vnode.ce(instance);
  }
  return instance;
}
let currentInstance = null;
const getCurrentInstance = () => currentInstance || currentRenderingInstance;
let internalSetCurrentInstance;
let setInSSRSetupState;
{
  const g = getGlobalThis();
  const registerGlobalSetter = (key, setter) => {
    let setters;
    if (!(setters = g[key])) setters = g[key] = [];
    setters.push(setter);
    return (v) => {
      if (setters.length > 1) setters.forEach((set) => set(v));
      else setters[0](v);
    };
  };
  internalSetCurrentInstance = registerGlobalSetter(
    `__VUE_INSTANCE_SETTERS__`,
    (v) => currentInstance = v
  );
  setInSSRSetupState = registerGlobalSetter(
    `__VUE_SSR_SETTERS__`,
    (v) => isInSSRComponentSetup = v
  );
}
const setCurrentInstance = (instance) => {
  const prev = currentInstance;
  internalSetCurrentInstance(instance);
  instance.scope.on();
  return () => {
    instance.scope.off();
    internalSetCurrentInstance(prev);
  };
};
const unsetCurrentInstance = () => {
  currentInstance && currentInstance.scope.off();
  internalSetCurrentInstance(null);
};
function isStatefulComponent(instance) {
  return instance.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false, optimized = false) {
  isSSR && setInSSRSetupState(isSSR);
  const { props, children } = instance.vnode;
  const isStateful = isStatefulComponent(instance);
  initProps(instance, props, isStateful, isSSR);
  initSlots(instance, children, optimized);
  const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
  isSSR && setInSSRSetupState(false);
  return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
  const Component = instance.type;
  instance.accessCache = /* @__PURE__ */ Object.create(null);
  instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
  const { setup } = Component;
  if (setup) {
    pauseTracking();
    const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
    const reset = setCurrentInstance(instance);
    const setupResult = callWithErrorHandling(
      setup,
      instance,
      0,
      [
        instance.props,
        setupContext
      ]
    );
    const isAsyncSetup = isPromise$1(setupResult);
    resetTracking();
    reset();
    if ((isAsyncSetup || instance.sp) && !isAsyncWrapper(instance)) {
      markAsyncBoundary(instance);
    }
    if (isAsyncSetup) {
      setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
      if (isSSR) {
        return setupResult.then((resolvedResult) => {
          handleSetupResult(instance, resolvedResult);
        }).catch((e) => {
          handleError(e, instance, 0);
        });
      } else {
        instance.asyncDep = setupResult;
      }
    } else {
      handleSetupResult(instance, setupResult);
    }
  } else {
    finishComponentSetup(instance);
  }
}
function handleSetupResult(instance, setupResult, isSSR) {
  if (isFunction(setupResult)) {
    if (instance.type.__ssrInlineRender) {
      instance.ssrRender = setupResult;
    } else {
      instance.render = setupResult;
    }
  } else if (isObject$3(setupResult)) {
    instance.setupState = proxyRefs(setupResult);
  } else ;
  finishComponentSetup(instance);
}
function finishComponentSetup(instance, isSSR, skipOptions) {
  const Component = instance.type;
  if (!instance.render) {
    instance.render = Component.render || NOOP;
  }
  {
    const reset = setCurrentInstance(instance);
    pauseTracking();
    try {
      applyOptions(instance);
    } finally {
      resetTracking();
      reset();
    }
  }
}
const attrsProxyHandlers = {
  get(target, key) {
    track(target, "get", "");
    return target[key];
  }
};
function createSetupContext(instance) {
  const expose = (exposed) => {
    instance.exposed = exposed || {};
  };
  {
    return {
      attrs: new Proxy(instance.attrs, attrsProxyHandlers),
      slots: instance.slots,
      emit: instance.emit,
      expose
    };
  }
}
function getComponentPublicInstance(instance) {
  if (instance.exposed) {
    return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
      get(target, key) {
        if (key in target) {
          return target[key];
        } else if (key in publicPropertiesMap) {
          return publicPropertiesMap[key](instance);
        }
      },
      has(target, key) {
        return key in target || key in publicPropertiesMap;
      }
    }));
  } else {
    return instance.proxy;
  }
}
const classifyRE = /(?:^|[-_])(\w)/g;
const classify = (str) => str.replace(classifyRE, (c) => c.toUpperCase()).replace(/[-_]/g, "");
function getComponentName$1(Component, includeInferred = true) {
  return isFunction(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function formatComponentName(instance, Component, isRoot = false) {
  let name = getComponentName$1(Component);
  if (!name && Component.__file) {
    const match = Component.__file.match(/([^/\\]+)\.\w+$/);
    if (match) {
      name = match[1];
    }
  }
  if (!name && instance && instance.parent) {
    const inferFromRegistry = (registry) => {
      for (const key in registry) {
        if (registry[key] === Component) {
          return key;
        }
      }
    };
    name = inferFromRegistry(
      instance.components || instance.parent.type.components
    ) || inferFromRegistry(instance.appContext.components);
  }
  return name ? classify(name) : isRoot ? `App` : `Anonymous`;
}
function isClassComponent(value) {
  return isFunction(value) && "__vccOpts" in value;
}
const computed = (getterOrOptions, debugOptions) => {
  const c = computed$1(getterOrOptions, debugOptions, isInSSRComponentSetup);
  return c;
};
function h(type, propsOrChildren, children) {
  const l = arguments.length;
  if (l === 2) {
    if (isObject$3(propsOrChildren) && !isArray(propsOrChildren)) {
      if (isVNode(propsOrChildren)) {
        return createVNode(type, null, [propsOrChildren]);
      }
      return createVNode(type, propsOrChildren);
    } else {
      return createVNode(type, null, propsOrChildren);
    }
  } else {
    if (l > 3) {
      children = Array.prototype.slice.call(arguments, 2);
    } else if (l === 3 && isVNode(children)) {
      children = [children];
    }
    return createVNode(type, propsOrChildren, children);
  }
}
const version = "3.5.13";
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let policy = void 0;
const tt = typeof window !== "undefined" && window.trustedTypes;
if (tt) {
  try {
    policy = /* @__PURE__ */ tt.createPolicy("vue", {
      createHTML: (val) => val
    });
  } catch (e) {
  }
}
const unsafeToTrustedHTML = policy ? (val) => policy.createHTML(val) : (val) => val;
const svgNS = "http://www.w3.org/2000/svg";
const mathmlNS = "http://www.w3.org/1998/Math/MathML";
const doc = typeof document !== "undefined" ? document : null;
const templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
const nodeOps = {
  insert: (child, parent, anchor) => {
    parent.insertBefore(child, anchor || null);
  },
  remove: (child) => {
    const parent = child.parentNode;
    if (parent) {
      parent.removeChild(child);
    }
  },
  createElement: (tag, namespace, is, props) => {
    const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is ? doc.createElement(tag, { is }) : doc.createElement(tag);
    if (tag === "select" && props && props.multiple != null) {
      el.setAttribute("multiple", props.multiple);
    }
    return el;
  },
  createText: (text) => doc.createTextNode(text),
  createComment: (text) => doc.createComment(text),
  setText: (node, text) => {
    node.nodeValue = text;
  },
  setElementText: (el, text) => {
    el.textContent = text;
  },
  parentNode: (node) => node.parentNode,
  nextSibling: (node) => node.nextSibling,
  querySelector: (selector) => doc.querySelector(selector),
  setScopeId(el, id) {
    el.setAttribute(id, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(content, parent, anchor, namespace, start, end) {
    const before = anchor ? anchor.previousSibling : parent.lastChild;
    if (start && (start === end || start.nextSibling)) {
      while (true) {
        parent.insertBefore(start.cloneNode(true), anchor);
        if (start === end || !(start = start.nextSibling)) break;
      }
    } else {
      templateContainer.innerHTML = unsafeToTrustedHTML(
        namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content
      );
      const template2 = templateContainer.content;
      if (namespace === "svg" || namespace === "mathml") {
        const wrapper = template2.firstChild;
        while (wrapper.firstChild) {
          template2.appendChild(wrapper.firstChild);
        }
        template2.removeChild(wrapper);
      }
      parent.insertBefore(template2, anchor);
    }
    return [
      // first
      before ? before.nextSibling : parent.firstChild,
      // last
      anchor ? anchor.previousSibling : parent.lastChild
    ];
  }
};
const vtcKey = Symbol("_vtc");
function patchClass(el, value, isSVG) {
  const transitionClasses = el[vtcKey];
  if (transitionClasses) {
    value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
  }
  if (value == null) {
    el.removeAttribute("class");
  } else if (isSVG) {
    el.setAttribute("class", value);
  } else {
    el.className = value;
  }
}
const vShowOriginalDisplay = Symbol("_vod");
const vShowHidden = Symbol("_vsh");
const vShow = {
  beforeMount(el, { value }, { transition: transition2 }) {
    el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
    if (transition2 && value) {
      transition2.beforeEnter(el);
    } else {
      setDisplay(el, value);
    }
  },
  mounted(el, { value }, { transition: transition2 }) {
    if (transition2 && value) {
      transition2.enter(el);
    }
  },
  updated(el, { value, oldValue }, { transition: transition2 }) {
    if (!value === !oldValue) return;
    if (transition2) {
      if (value) {
        transition2.beforeEnter(el);
        setDisplay(el, true);
        transition2.enter(el);
      } else {
        transition2.leave(el, () => {
          setDisplay(el, false);
        });
      }
    } else {
      setDisplay(el, value);
    }
  },
  beforeUnmount(el, { value }) {
    setDisplay(el, value);
  }
};
function setDisplay(el, value) {
  el.style.display = value ? el[vShowOriginalDisplay] : "none";
  el[vShowHidden] = !value;
}
const CSS_VAR_TEXT = Symbol("");
const displayRE = /(^|;)\s*display\s*:/;
function patchStyle(el, prev, next) {
  const style = el.style;
  const isCssString = isString$1(next);
  let hasControlledDisplay = false;
  if (next && !isCssString) {
    if (prev) {
      if (!isString$1(prev)) {
        for (const key in prev) {
          if (next[key] == null) {
            setStyle(style, key, "");
          }
        }
      } else {
        for (const prevStyle of prev.split(";")) {
          const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
          if (next[key] == null) {
            setStyle(style, key, "");
          }
        }
      }
    }
    for (const key in next) {
      if (key === "display") {
        hasControlledDisplay = true;
      }
      setStyle(style, key, next[key]);
    }
  } else {
    if (isCssString) {
      if (prev !== next) {
        const cssVarText = style[CSS_VAR_TEXT];
        if (cssVarText) {
          next += ";" + cssVarText;
        }
        style.cssText = next;
        hasControlledDisplay = displayRE.test(next);
      }
    } else if (prev) {
      el.removeAttribute("style");
    }
  }
  if (vShowOriginalDisplay in el) {
    el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
    if (el[vShowHidden]) {
      style.display = "none";
    }
  }
}
const importantRE = /\s*!important$/;
function setStyle(style, name, val) {
  if (isArray(val)) {
    val.forEach((v) => setStyle(style, name, v));
  } else {
    if (val == null) val = "";
    if (name.startsWith("--")) {
      style.setProperty(name, val);
    } else {
      const prefixed = autoPrefix(style, name);
      if (importantRE.test(val)) {
        style.setProperty(
          hyphenate(prefixed),
          val.replace(importantRE, ""),
          "important"
        );
      } else {
        style[prefixed] = val;
      }
    }
  }
}
const prefixes = ["Webkit", "Moz", "ms"];
const prefixCache = {};
function autoPrefix(style, rawName) {
  const cached = prefixCache[rawName];
  if (cached) {
    return cached;
  }
  let name = camelize(rawName);
  if (name !== "filter" && name in style) {
    return prefixCache[rawName] = name;
  }
  name = capitalize(name);
  for (let i = 0; i < prefixes.length; i++) {
    const prefixed = prefixes[i] + name;
    if (prefixed in style) {
      return prefixCache[rawName] = prefixed;
    }
  }
  return rawName;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance, isBoolean = isSpecialBooleanAttr(key)) {
  if (isSVG && key.startsWith("xlink:")) {
    if (value == null) {
      el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (value == null || isBoolean && !includeBooleanAttr(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(
        key,
        isBoolean ? "" : isSymbol(value) ? String(value) : value
      );
    }
  }
}
function patchDOMProp(el, key, value, parentComponent, attrName) {
  if (key === "innerHTML" || key === "textContent") {
    if (value != null) {
      el[key] = key === "innerHTML" ? unsafeToTrustedHTML(value) : value;
    }
    return;
  }
  const tag = el.tagName;
  if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
  !tag.includes("-")) {
    const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
    const newValue = value == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      el.type === "checkbox" ? "on" : ""
    ) : String(value);
    if (oldValue !== newValue || !("_value" in el)) {
      el.value = newValue;
    }
    if (value == null) {
      el.removeAttribute(key);
    }
    el._value = value;
    return;
  }
  let needRemove = false;
  if (value === "" || value == null) {
    const type = typeof el[key];
    if (type === "boolean") {
      value = includeBooleanAttr(value);
    } else if (value == null && type === "string") {
      value = "";
      needRemove = true;
    } else if (type === "number") {
      value = 0;
      needRemove = true;
    }
  }
  try {
    el[key] = value;
  } catch (e) {
  }
  needRemove && el.removeAttribute(attrName || key);
}
function addEventListener(el, event, handler, options) {
  el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
  el.removeEventListener(event, handler, options);
}
const veiKey = Symbol("_vei");
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
  const invokers = el[veiKey] || (el[veiKey] = {});
  const existingInvoker = invokers[rawName];
  if (nextValue && existingInvoker) {
    existingInvoker.value = nextValue;
  } else {
    const [name, options] = parseName(rawName);
    if (nextValue) {
      const invoker = invokers[rawName] = createInvoker(
        nextValue,
        instance
      );
      addEventListener(el, name, invoker, options);
    } else if (existingInvoker) {
      removeEventListener(el, name, existingInvoker, options);
      invokers[rawName] = void 0;
    }
  }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name) {
  let options;
  if (optionsModifierRE.test(name)) {
    options = {};
    let m;
    while (m = name.match(optionsModifierRE)) {
      name = name.slice(0, name.length - m[0].length);
      options[m[0].toLowerCase()] = true;
    }
  }
  const event = name[2] === ":" ? name.slice(3) : hyphenate(name.slice(2));
  return [event, options];
}
let cachedNow = 0;
const p = /* @__PURE__ */ Promise.resolve();
const getNow = () => cachedNow || (p.then(() => cachedNow = 0), cachedNow = Date.now());
function createInvoker(initialValue, instance) {
  const invoker = (e) => {
    if (!e._vts) {
      e._vts = Date.now();
    } else if (e._vts <= invoker.attached) {
      return;
    }
    callWithAsyncErrorHandling(
      patchStopImmediatePropagation(e, invoker.value),
      instance,
      5,
      [e]
    );
  };
  invoker.value = initialValue;
  invoker.attached = getNow();
  return invoker;
}
function patchStopImmediatePropagation(e, value) {
  if (isArray(value)) {
    const originalStop = e.stopImmediatePropagation;
    e.stopImmediatePropagation = () => {
      originalStop.call(e);
      e._stopped = true;
    };
    return value.map(
      (fn) => (e2) => !e2._stopped && fn && fn(e2)
    );
  } else {
    return value;
  }
}
const isNativeOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const patchProp = (el, key, prevValue, nextValue, namespace, parentComponent) => {
  const isSVG = namespace === "svg";
  if (key === "class") {
    patchClass(el, nextValue, isSVG);
  } else if (key === "style") {
    patchStyle(el, prevValue, nextValue);
  } else if (isOn(key)) {
    if (!isModelListener(key)) {
      patchEvent(el, key, prevValue, nextValue, parentComponent);
    }
  } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
    patchDOMProp(el, key, nextValue);
    if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) {
      patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    }
  } else if (
    // #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !isString$1(nextValue))
  ) {
    patchDOMProp(el, camelize(key), nextValue, parentComponent, key);
  } else {
    if (key === "true-value") {
      el._trueValue = nextValue;
    } else if (key === "false-value") {
      el._falseValue = nextValue;
    }
    patchAttr(el, key, nextValue, isSVG);
  }
};
function shouldSetAsProp(el, key, value, isSVG) {
  if (isSVG) {
    if (key === "innerHTML" || key === "textContent") {
      return true;
    }
    if (key in el && isNativeOn(key) && isFunction(value)) {
      return true;
    }
    return false;
  }
  if (key === "spellcheck" || key === "draggable" || key === "translate") {
    return false;
  }
  if (key === "form") {
    return false;
  }
  if (key === "list" && el.tagName === "INPUT") {
    return false;
  }
  if (key === "type" && el.tagName === "TEXTAREA") {
    return false;
  }
  if (key === "width" || key === "height") {
    const tag = el.tagName;
    if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") {
      return false;
    }
  }
  if (isNativeOn(key) && isString$1(value)) {
    return false;
  }
  return key in el;
}
const getModelAssigner = (vnode) => {
  const fn = vnode.props["onUpdate:modelValue"] || false;
  return isArray(fn) ? (value) => invokeArrayFns(fn, value) : fn;
};
function onCompositionStart(e) {
  e.target.composing = true;
}
function onCompositionEnd(e) {
  const target = e.target;
  if (target.composing) {
    target.composing = false;
    target.dispatchEvent(new Event("input"));
  }
}
const assignKey = Symbol("_assign");
const vModelText = {
  created(el, { modifiers: { lazy, trim, number } }, vnode) {
    el[assignKey] = getModelAssigner(vnode);
    const castToNumber = number || vnode.props && vnode.props.type === "number";
    addEventListener(el, lazy ? "change" : "input", (e) => {
      if (e.target.composing) return;
      let domValue = el.value;
      if (trim) {
        domValue = domValue.trim();
      }
      if (castToNumber) {
        domValue = looseToNumber(domValue);
      }
      el[assignKey](domValue);
    });
    if (trim) {
      addEventListener(el, "change", () => {
        el.value = el.value.trim();
      });
    }
    if (!lazy) {
      addEventListener(el, "compositionstart", onCompositionStart);
      addEventListener(el, "compositionend", onCompositionEnd);
      addEventListener(el, "change", onCompositionEnd);
    }
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(el, { value }) {
    el.value = value == null ? "" : value;
  },
  beforeUpdate(el, { value, oldValue, modifiers: { lazy, trim, number } }, vnode) {
    el[assignKey] = getModelAssigner(vnode);
    if (el.composing) return;
    const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? looseToNumber(el.value) : el.value;
    const newValue = value == null ? "" : value;
    if (elValue === newValue) {
      return;
    }
    if (document.activeElement === el && el.type !== "range") {
      if (lazy && value === oldValue) {
        return;
      }
      if (trim && el.value.trim() === newValue) {
        return;
      }
    }
    el.value = newValue;
  }
};
const systemModifiers = ["ctrl", "shift", "alt", "meta"];
const modifierGuards = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, modifiers) => systemModifiers.some((m) => e[`${m}Key`] && !modifiers.includes(m))
};
const withModifiers = (fn, modifiers) => {
  const cache = fn._withMods || (fn._withMods = {});
  const cacheKey = modifiers.join(".");
  return cache[cacheKey] || (cache[cacheKey] = (event, ...args) => {
    for (let i = 0; i < modifiers.length; i++) {
      const guard = modifierGuards[modifiers[i]];
      if (guard && guard(event, modifiers)) return;
    }
    return fn(event, ...args);
  });
};
const keyNames = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
};
const withKeys = (fn, modifiers) => {
  const cache = fn._withKeys || (fn._withKeys = {});
  const cacheKey = modifiers.join(".");
  return cache[cacheKey] || (cache[cacheKey] = (event) => {
    if (!("key" in event)) {
      return;
    }
    const eventKey = hyphenate(event.key);
    if (modifiers.some(
      (k) => k === eventKey || keyNames[k] === eventKey
    )) {
      return fn(event);
    }
  });
};
const rendererOptions = /* @__PURE__ */ extend$2({ patchProp }, nodeOps);
let renderer;
function ensureRenderer() {
  return renderer || (renderer = createRenderer(rendererOptions));
}
const createApp = (...args) => {
  const app = ensureRenderer().createApp(...args);
  const { mount } = app;
  app.mount = (containerOrSelector) => {
    const container = normalizeContainer(containerOrSelector);
    if (!container) return;
    const component = app._component;
    if (!isFunction(component) && !component.render && !component.template) {
      component.template = container.innerHTML;
    }
    if (container.nodeType === 1) {
      container.textContent = "";
    }
    const proxy = mount(container, false, resolveRootNamespace(container));
    if (container instanceof Element) {
      container.removeAttribute("v-cloak");
      container.setAttribute("data-v-app", "");
    }
    return proxy;
  };
  return app;
};
function resolveRootNamespace(container) {
  if (container instanceof SVGElement) {
    return "svg";
  }
  if (typeof MathMLElement === "function" && container instanceof MathMLElement) {
    return "mathml";
  }
}
function normalizeContainer(container) {
  if (isString$1(container)) {
    const res = document.querySelector(container);
    return res;
  }
  return container;
}
function getDevtoolsGlobalHook() {
  return getTarget().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function getTarget() {
  return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const isProxyAvailable = typeof Proxy === "function";
const HOOK_SETUP = "devtools-plugin:setup";
const HOOK_PLUGIN_SETTINGS_SET = "plugin:settings:set";
let supported;
let perf;
function isPerformanceSupported() {
  var _a;
  if (supported !== void 0) {
    return supported;
  }
  if (typeof window !== "undefined" && window.performance) {
    supported = true;
    perf = window.performance;
  } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
    supported = true;
    perf = globalThis.perf_hooks.performance;
  } else {
    supported = false;
  }
  return supported;
}
function now$1() {
  return isPerformanceSupported() ? perf.now() : Date.now();
}
class ApiProxy {
  constructor(plugin, hook) {
    this.target = null;
    this.targetQueue = [];
    this.onQueue = [];
    this.plugin = plugin;
    this.hook = hook;
    const defaultSettings = {};
    if (plugin.settings) {
      for (const id in plugin.settings) {
        const item = plugin.settings[id];
        defaultSettings[id] = item.defaultValue;
      }
    }
    const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
    let currentSettings = Object.assign({}, defaultSettings);
    try {
      const raw = localStorage.getItem(localSettingsSaveId);
      const data = JSON.parse(raw);
      Object.assign(currentSettings, data);
    } catch (e) {
    }
    this.fallbacks = {
      getSettings() {
        return currentSettings;
      },
      setSettings(value) {
        try {
          localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
        } catch (e) {
        }
        currentSettings = value;
      },
      now() {
        return now$1();
      }
    };
    if (hook) {
      hook.on(HOOK_PLUGIN_SETTINGS_SET, (pluginId, value) => {
        if (pluginId === this.plugin.id) {
          this.fallbacks.setSettings(value);
        }
      });
    }
    this.proxiedOn = new Proxy({}, {
      get: (_target, prop) => {
        if (this.target) {
          return this.target.on[prop];
        } else {
          return (...args) => {
            this.onQueue.push({
              method: prop,
              args
            });
          };
        }
      }
    });
    this.proxiedTarget = new Proxy({}, {
      get: (_target, prop) => {
        if (this.target) {
          return this.target[prop];
        } else if (prop === "on") {
          return this.proxiedOn;
        } else if (Object.keys(this.fallbacks).includes(prop)) {
          return (...args) => {
            this.targetQueue.push({
              method: prop,
              args,
              resolve: () => {
              }
            });
            return this.fallbacks[prop](...args);
          };
        } else {
          return (...args) => {
            return new Promise((resolve2) => {
              this.targetQueue.push({
                method: prop,
                args,
                resolve: resolve2
              });
            });
          };
        }
      }
    });
  }
  async setRealTarget(target) {
    this.target = target;
    for (const item of this.onQueue) {
      this.target.on[item.method](...item.args);
    }
    for (const item of this.targetQueue) {
      item.resolve(await this.target[item.method](...item.args));
    }
  }
}
function setupDevtoolsPlugin(pluginDescriptor, setupFn) {
  const descriptor = pluginDescriptor;
  const target = getTarget();
  const hook = getDevtoolsGlobalHook();
  const enableProxy = isProxyAvailable && descriptor.enableEarlyProxy;
  if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) {
    hook.emit(HOOK_SETUP, pluginDescriptor, setupFn);
  } else {
    const proxy = enableProxy ? new ApiProxy(descriptor, hook) : null;
    const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
    list.push({
      pluginDescriptor: descriptor,
      setupFn,
      proxy
    });
    if (proxy) {
      setupFn(proxy.proxiedTarget);
    }
  }
}
/*!
 * vuex v4.1.0
 * (c) 2022 Evan You
 * @license MIT
 */
var storeKey = "store";
function forEachValue(obj, fn) {
  Object.keys(obj).forEach(function(key) {
    return fn(obj[key], key);
  });
}
function isObject$2(obj) {
  return obj !== null && typeof obj === "object";
}
function isPromise(val) {
  return val && typeof val.then === "function";
}
function partial(fn, arg) {
  return function() {
    return fn(arg);
  };
}
function genericSubscribe(fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend ? subs.unshift(fn) : subs.push(fn);
  }
  return function() {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  };
}
function resetStore(store2, hot) {
  store2._actions = /* @__PURE__ */ Object.create(null);
  store2._mutations = /* @__PURE__ */ Object.create(null);
  store2._wrappedGetters = /* @__PURE__ */ Object.create(null);
  store2._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var state = store2.state;
  installModule(store2, state, [], store2._modules.root, true);
  resetStoreState(store2, state, hot);
}
function resetStoreState(store2, state, hot) {
  var oldState = store2._state;
  var oldScope = store2._scope;
  store2.getters = {};
  store2._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var wrappedGetters = store2._wrappedGetters;
  var computedObj = {};
  var computedCache = {};
  var scope = effectScope(true);
  scope.run(function() {
    forEachValue(wrappedGetters, function(fn, key) {
      computedObj[key] = partial(fn, store2);
      computedCache[key] = computed(function() {
        return computedObj[key]();
      });
      Object.defineProperty(store2.getters, key, {
        get: function() {
          return computedCache[key].value;
        },
        enumerable: true
        // for local getters
      });
    });
  });
  store2._state = reactive({
    data: state
  });
  store2._scope = scope;
  if (store2.strict) {
    enableStrictMode(store2);
  }
  if (oldState) {
    if (hot) {
      store2._withCommit(function() {
        oldState.data = null;
      });
    }
  }
  if (oldScope) {
    oldScope.stop();
  }
}
function installModule(store2, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store2._modules.getNamespace(path);
  if (module.namespaced) {
    if (store2._modulesNamespaceMap[namespace] && false) ;
    store2._modulesNamespaceMap[namespace] = module;
  }
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store2._withCommit(function() {
      parentState[moduleName] = module.state;
    });
  }
  var local = module.context = makeLocalContext(store2, namespace, path);
  module.forEachMutation(function(mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store2, namespacedType, mutation, local);
  });
  module.forEachAction(function(action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store2, type, handler, local);
  });
  module.forEachGetter(function(getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store2, namespacedType, getter, local);
  });
  module.forEachChild(function(child, key) {
    installModule(store2, rootState, path.concat(key), child, hot);
  });
}
function makeLocalContext(store2, namespace, path) {
  var noNamespace = namespace === "";
  var local = {
    dispatch: noNamespace ? store2.dispatch : function(_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;
      if (!options || !options.root) {
        type = namespace + type;
      }
      return store2.dispatch(type, payload);
    },
    commit: noNamespace ? store2.commit : function(_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;
      if (!options || !options.root) {
        type = namespace + type;
      }
      store2.commit(type, payload, options);
    }
  };
  Object.defineProperties(local, {
    getters: {
      get: noNamespace ? function() {
        return store2.getters;
      } : function() {
        return makeLocalGetters(store2, namespace);
      }
    },
    state: {
      get: function() {
        return getNestedState(store2.state, path);
      }
    }
  });
  return local;
}
function makeLocalGetters(store2, namespace) {
  if (!store2._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store2.getters).forEach(function(type) {
      if (type.slice(0, splitPos) !== namespace) {
        return;
      }
      var localType = type.slice(splitPos);
      Object.defineProperty(gettersProxy, localType, {
        get: function() {
          return store2.getters[type];
        },
        enumerable: true
      });
    });
    store2._makeLocalGettersCache[namespace] = gettersProxy;
  }
  return store2._makeLocalGettersCache[namespace];
}
function registerMutation(store2, type, handler, local) {
  var entry = store2._mutations[type] || (store2._mutations[type] = []);
  entry.push(function wrappedMutationHandler(payload) {
    handler.call(store2, local.state, payload);
  });
}
function registerAction(store2, type, handler, local) {
  var entry = store2._actions[type] || (store2._actions[type] = []);
  entry.push(function wrappedActionHandler(payload) {
    var res = handler.call(store2, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store2.getters,
      rootState: store2.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store2._devtoolHook) {
      return res.catch(function(err) {
        store2._devtoolHook.emit("vuex:error", err);
        throw err;
      });
    } else {
      return res;
    }
  });
}
function registerGetter(store2, type, rawGetter, local) {
  if (store2._wrappedGetters[type]) {
    return;
  }
  store2._wrappedGetters[type] = function wrappedGetter(store22) {
    return rawGetter(
      local.state,
      // local state
      local.getters,
      // local getters
      store22.state,
      // root state
      store22.getters
      // root getters
    );
  };
}
function enableStrictMode(store2) {
  watch(function() {
    return store2._state.data;
  }, function() {
  }, { deep: true, flush: "sync" });
}
function getNestedState(state, path) {
  return path.reduce(function(state2, key) {
    return state2[key];
  }, state);
}
function unifyObjectStyle(type, payload, options) {
  if (isObject$2(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }
  return { type, payload, options };
}
var LABEL_VUEX_BINDINGS = "vuex bindings";
var MUTATIONS_LAYER_ID = "vuex:mutations";
var ACTIONS_LAYER_ID = "vuex:actions";
var INSPECTOR_ID = "vuex";
var actionId = 0;
function addDevtools(app, store2) {
  setupDevtoolsPlugin(
    {
      id: "org.vuejs.vuex",
      app,
      label: "Vuex",
      homepage: "https://next.vuex.vuejs.org/",
      logo: "https://vuejs.org/images/icons/favicon-96x96.png",
      packageName: "vuex",
      componentStateTypes: [LABEL_VUEX_BINDINGS]
    },
    function(api) {
      api.addTimelineLayer({
        id: MUTATIONS_LAYER_ID,
        label: "Vuex Mutations",
        color: COLOR_LIME_500
      });
      api.addTimelineLayer({
        id: ACTIONS_LAYER_ID,
        label: "Vuex Actions",
        color: COLOR_LIME_500
      });
      api.addInspector({
        id: INSPECTOR_ID,
        label: "Vuex",
        icon: "storage",
        treeFilterPlaceholder: "Filter stores..."
      });
      api.on.getInspectorTree(function(payload) {
        if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
          if (payload.filter) {
            var nodes = [];
            flattenStoreForInspectorTree(nodes, store2._modules.root, payload.filter, "");
            payload.rootNodes = nodes;
          } else {
            payload.rootNodes = [
              formatStoreForInspectorTree(store2._modules.root, "")
            ];
          }
        }
      });
      api.on.getInspectorState(function(payload) {
        if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
          var modulePath = payload.nodeId;
          makeLocalGetters(store2, modulePath);
          payload.state = formatStoreForInspectorState(
            getStoreModule(store2._modules, modulePath),
            modulePath === "root" ? store2.getters : store2._makeLocalGettersCache,
            modulePath
          );
        }
      });
      api.on.editInspectorState(function(payload) {
        if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
          var modulePath = payload.nodeId;
          var path = payload.path;
          if (modulePath !== "root") {
            path = modulePath.split("/").filter(Boolean).concat(path);
          }
          store2._withCommit(function() {
            payload.set(store2._state.data, path, payload.state.value);
          });
        }
      });
      store2.subscribe(function(mutation, state) {
        var data = {};
        if (mutation.payload) {
          data.payload = mutation.payload;
        }
        data.state = state;
        api.notifyComponentUpdate();
        api.sendInspectorTree(INSPECTOR_ID);
        api.sendInspectorState(INSPECTOR_ID);
        api.addTimelineEvent({
          layerId: MUTATIONS_LAYER_ID,
          event: {
            time: Date.now(),
            title: mutation.type,
            data
          }
        });
      });
      store2.subscribeAction({
        before: function(action, state) {
          var data = {};
          if (action.payload) {
            data.payload = action.payload;
          }
          action._id = actionId++;
          action._time = Date.now();
          data.state = state;
          api.addTimelineEvent({
            layerId: ACTIONS_LAYER_ID,
            event: {
              time: action._time,
              title: action.type,
              groupId: action._id,
              subtitle: "start",
              data
            }
          });
        },
        after: function(action, state) {
          var data = {};
          var duration = Date.now() - action._time;
          data.duration = {
            _custom: {
              type: "duration",
              display: duration + "ms",
              tooltip: "Action duration",
              value: duration
            }
          };
          if (action.payload) {
            data.payload = action.payload;
          }
          data.state = state;
          api.addTimelineEvent({
            layerId: ACTIONS_LAYER_ID,
            event: {
              time: Date.now(),
              title: action.type,
              groupId: action._id,
              subtitle: "end",
              data
            }
          });
        }
      });
    }
  );
}
var COLOR_LIME_500 = 8702998;
var COLOR_DARK = 6710886;
var COLOR_WHITE = 16777215;
var TAG_NAMESPACED = {
  label: "namespaced",
  textColor: COLOR_WHITE,
  backgroundColor: COLOR_DARK
};
function extractNameFromPath(path) {
  return path && path !== "root" ? path.split("/").slice(-2, -1)[0] : "Root";
}
function formatStoreForInspectorTree(module, path) {
  return {
    id: path || "root",
    // all modules end with a `/`, we want the last segment only
    // cart/ -> cart
    // nested/cart/ -> cart
    label: extractNameFromPath(path),
    tags: module.namespaced ? [TAG_NAMESPACED] : [],
    children: Object.keys(module._children).map(
      function(moduleName) {
        return formatStoreForInspectorTree(
          module._children[moduleName],
          path + moduleName + "/"
        );
      }
    )
  };
}
function flattenStoreForInspectorTree(result, module, filter, path) {
  if (path.includes(filter)) {
    result.push({
      id: path || "root",
      label: path.endsWith("/") ? path.slice(0, path.length - 1) : path || "Root",
      tags: module.namespaced ? [TAG_NAMESPACED] : []
    });
  }
  Object.keys(module._children).forEach(function(moduleName) {
    flattenStoreForInspectorTree(result, module._children[moduleName], filter, path + moduleName + "/");
  });
}
function formatStoreForInspectorState(module, getters, path) {
  getters = path === "root" ? getters : getters[path];
  var gettersKeys = Object.keys(getters);
  var storeState = {
    state: Object.keys(module.state).map(function(key) {
      return {
        key,
        editable: true,
        value: module.state[key]
      };
    })
  };
  if (gettersKeys.length) {
    var tree = transformPathsToObjectTree(getters);
    storeState.getters = Object.keys(tree).map(function(key) {
      return {
        key: key.endsWith("/") ? extractNameFromPath(key) : key,
        editable: false,
        value: canThrow(function() {
          return tree[key];
        })
      };
    });
  }
  return storeState;
}
function transformPathsToObjectTree(getters) {
  var result = {};
  Object.keys(getters).forEach(function(key) {
    var path = key.split("/");
    if (path.length > 1) {
      var target = result;
      var leafKey = path.pop();
      path.forEach(function(p2) {
        if (!target[p2]) {
          target[p2] = {
            _custom: {
              value: {},
              display: p2,
              tooltip: "Module",
              abstract: true
            }
          };
        }
        target = target[p2]._custom.value;
      });
      target[leafKey] = canThrow(function() {
        return getters[key];
      });
    } else {
      result[key] = canThrow(function() {
        return getters[key];
      });
    }
  });
  return result;
}
function getStoreModule(moduleMap, path) {
  var names = path.split("/").filter(function(n) {
    return n;
  });
  return names.reduce(
    function(module, moduleName, i) {
      var child = module[moduleName];
      if (!child) {
        throw new Error('Missing module "' + moduleName + '" for path "' + path + '".');
      }
      return i === names.length - 1 ? child : child._children;
    },
    path === "root" ? moduleMap : moduleMap.root._children
  );
}
function canThrow(cb) {
  try {
    return cb();
  } catch (e) {
    return e;
  }
}
var Module = function Module2(rawModule, runtime) {
  this.runtime = runtime;
  this._children = /* @__PURE__ */ Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === "function" ? rawState() : rawState) || {};
};
var prototypeAccessors$1 = { namespaced: { configurable: true } };
prototypeAccessors$1.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
Module.prototype.addChild = function addChild(key, module) {
  this._children[key] = module;
};
Module.prototype.removeChild = function removeChild(key) {
  delete this._children[key];
};
Module.prototype.getChild = function getChild(key) {
  return this._children[key];
};
Module.prototype.hasChild = function hasChild(key) {
  return key in this._children;
};
Module.prototype.update = function update(rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};
Module.prototype.forEachChild = function forEachChild(fn) {
  forEachValue(this._children, fn);
};
Module.prototype.forEachGetter = function forEachGetter(fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};
Module.prototype.forEachAction = function forEachAction(fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};
Module.prototype.forEachMutation = function forEachMutation(fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};
Object.defineProperties(Module.prototype, prototypeAccessors$1);
var ModuleCollection = function ModuleCollection2(rawRootModule) {
  this.register([], rawRootModule, false);
};
ModuleCollection.prototype.get = function get(path) {
  return path.reduce(function(module, key) {
    return module.getChild(key);
  }, this.root);
};
ModuleCollection.prototype.getNamespace = function getNamespace(path) {
  var module = this.root;
  return path.reduce(function(namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + "/" : "");
  }, "");
};
ModuleCollection.prototype.update = function update$1(rawRootModule) {
  update2([], this.root, rawRootModule);
};
ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
  var this$1$1 = this;
  if (runtime === void 0) runtime = true;
  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function(rawChildModule, key) {
      this$1$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};
ModuleCollection.prototype.unregister = function unregister(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);
  if (!child) {
    return;
  }
  if (!child.runtime) {
    return;
  }
  parent.removeChild(key);
};
ModuleCollection.prototype.isRegistered = function isRegistered(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (parent) {
    return parent.hasChild(key);
  }
  return false;
};
function update2(path, targetModule, newModule) {
  targetModule.update(newModule);
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        return;
      }
      update2(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}
function createStore(options) {
  return new Store(options);
}
var Store = function Store2(options) {
  var this$1$1 = this;
  if (options === void 0) options = {};
  var plugins = options.plugins;
  if (plugins === void 0) plugins = [];
  var strict = options.strict;
  if (strict === void 0) strict = false;
  var devtools = options.devtools;
  this._committing = false;
  this._actions = /* @__PURE__ */ Object.create(null);
  this._actionSubscribers = [];
  this._mutations = /* @__PURE__ */ Object.create(null);
  this._wrappedGetters = /* @__PURE__ */ Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  this._subscribers = [];
  this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  this._scope = null;
  this._devtools = devtools;
  var store2 = this;
  var ref2 = this;
  var dispatch2 = ref2.dispatch;
  var commit2 = ref2.commit;
  this.dispatch = function boundDispatch(type, payload) {
    return dispatch2.call(store2, type, payload);
  };
  this.commit = function boundCommit(type, payload, options2) {
    return commit2.call(store2, type, payload, options2);
  };
  this.strict = strict;
  var state = this._modules.root.state;
  installModule(this, state, [], this._modules.root);
  resetStoreState(this, state);
  plugins.forEach(function(plugin) {
    return plugin(this$1$1);
  });
};
var prototypeAccessors = { state: { configurable: true } };
Store.prototype.install = function install(app, injectKey) {
  app.provide(injectKey || storeKey, this);
  app.config.globalProperties.$store = this;
  var useDevtools = this._devtools !== void 0 ? this._devtools : false;
  if (useDevtools) {
    addDevtools(app, this);
  }
};
prototypeAccessors.state.get = function() {
  return this._state.data;
};
prototypeAccessors.state.set = function(v) {
};
Store.prototype.commit = function commit(_type, _payload, _options) {
  var this$1$1 = this;
  var ref2 = unifyObjectStyle(_type, _payload, _options);
  var type = ref2.type;
  var payload = ref2.payload;
  var mutation = { type, payload };
  var entry = this._mutations[type];
  if (!entry) {
    return;
  }
  this._withCommit(function() {
    entry.forEach(function commitIterator(handler) {
      handler(payload);
    });
  });
  this._subscribers.slice().forEach(function(sub) {
    return sub(mutation, this$1$1.state);
  });
};
Store.prototype.dispatch = function dispatch(_type, _payload) {
  var this$1$1 = this;
  var ref2 = unifyObjectStyle(_type, _payload);
  var type = ref2.type;
  var payload = ref2.payload;
  var action = { type, payload };
  var entry = this._actions[type];
  if (!entry) {
    return;
  }
  try {
    this._actionSubscribers.slice().filter(function(sub) {
      return sub.before;
    }).forEach(function(sub) {
      return sub.before(action, this$1$1.state);
    });
  } catch (e) {
  }
  var result = entry.length > 1 ? Promise.all(entry.map(function(handler) {
    return handler(payload);
  })) : entry[0](payload);
  return new Promise(function(resolve2, reject) {
    result.then(function(res) {
      try {
        this$1$1._actionSubscribers.filter(function(sub) {
          return sub.after;
        }).forEach(function(sub) {
          return sub.after(action, this$1$1.state);
        });
      } catch (e) {
      }
      resolve2(res);
    }, function(error2) {
      try {
        this$1$1._actionSubscribers.filter(function(sub) {
          return sub.error;
        }).forEach(function(sub) {
          return sub.error(action, this$1$1.state, error2);
        });
      } catch (e) {
      }
      reject(error2);
    });
  });
};
Store.prototype.subscribe = function subscribe(fn, options) {
  return genericSubscribe(fn, this._subscribers, options);
};
Store.prototype.subscribeAction = function subscribeAction(fn, options) {
  var subs = typeof fn === "function" ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options);
};
Store.prototype.watch = function watch$12(getter, cb, options) {
  var this$1$1 = this;
  return watch(function() {
    return getter(this$1$1.state, this$1$1.getters);
  }, cb, Object.assign({}, options));
};
Store.prototype.replaceState = function replaceState(state) {
  var this$1$1 = this;
  this._withCommit(function() {
    this$1$1._state.data = state;
  });
};
Store.prototype.registerModule = function registerModule(path, rawModule, options) {
  if (options === void 0) options = {};
  if (typeof path === "string") {
    path = [path];
  }
  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  resetStoreState(this, this.state);
};
Store.prototype.unregisterModule = function unregisterModule(path) {
  var this$1$1 = this;
  if (typeof path === "string") {
    path = [path];
  }
  this._modules.unregister(path);
  this._withCommit(function() {
    var parentState = getNestedState(this$1$1.state, path.slice(0, -1));
    delete parentState[path[path.length - 1]];
  });
  resetStore(this);
};
Store.prototype.hasModule = function hasModule(path) {
  if (typeof path === "string") {
    path = [path];
  }
  return this._modules.isRegistered(path);
};
Store.prototype.hotUpdate = function hotUpdate(newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};
Store.prototype._withCommit = function _withCommit(fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};
Object.defineProperties(Store.prototype, prototypeAccessors);
var mapMutations = normalizeNamespace(function(namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function(ref2) {
    var key = ref2.key;
    var val = ref2.val;
    res[key] = function mappedMutation() {
      var args = [], len = arguments.length;
      while (len--) args[len] = arguments[len];
      var commit2 = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, "mapMutations", namespace);
        if (!module) {
          return;
        }
        commit2 = module.context.commit;
      }
      return typeof val === "function" ? val.apply(this, [commit2].concat(args)) : commit2.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});
var mapGetters = normalizeNamespace(function(namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function(ref2) {
    var key = ref2.key;
    var val = ref2.val;
    val = namespace + val;
    res[key] = function mappedGetter() {
      if (namespace && !getModuleByNamespace(this.$store, "mapGetters", namespace)) {
        return;
      }
      return this.$store.getters[val];
    };
    res[key].vuex = true;
  });
  return res;
});
var mapActions = normalizeNamespace(function(namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function(ref2) {
    var key = ref2.key;
    var val = ref2.val;
    res[key] = function mappedAction() {
      var args = [], len = arguments.length;
      while (len--) args[len] = arguments[len];
      var dispatch2 = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, "mapActions", namespace);
        if (!module) {
          return;
        }
        dispatch2 = module.context.dispatch;
      }
      return typeof val === "function" ? val.apply(this, [dispatch2].concat(args)) : dispatch2.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});
function normalizeMap(map) {
  if (!isValidMap(map)) {
    return [];
  }
  return Array.isArray(map) ? map.map(function(key) {
    return { key, val: key };
  }) : Object.keys(map).map(function(key) {
    return { key, val: map[key] };
  });
}
function isValidMap(map) {
  return Array.isArray(map) || isObject$2(map);
}
function normalizeNamespace(fn) {
  return function(namespace, map) {
    if (typeof namespace !== "string") {
      map = namespace;
      namespace = "";
    } else if (namespace.charAt(namespace.length - 1) !== "/") {
      namespace += "/";
    }
    return fn(namespace, map);
  };
}
function getModuleByNamespace(store2, helper, namespace) {
  var module = store2._modulesNamespaceMap[namespace];
  return module;
}
function roundBackToNearest95(price) {
  price = price / 100;
  let adjustedPrice = price * 0.99;
  const result = Math.floor(adjustedPrice) + 0.95;
  return result * 100;
}
const store$1 = (config) => {
  return createStore({
    state() {
      var _a, _b;
      return {
        config,
        currency: config.currency,
        steps: config.steps,
        currentTab: "",
        currentGrid: 3,
        // default products qty per row on mobile
        addedProductsQuantity: 0,
        productsBox: [],
        productsBoxSeparatedVariants: [],
        discount: 0,
        /**
         * If the currency rate is not equal to 1, we need to round the specific discount amount to the nearest 0.95.
         */
        specificDiscountAmount: +window.Shopify.currency.rate < 1 || +window.Shopify.currency.rate > 1 ? roundBackToNearest95(+((_a = config.steps.find((step) => step.firstAddedProductDiscount)) == null ? void 0 : _a.firstAddedProductDiscount) * +window.Shopify.currency.rate) : +((_b = config.steps.find((step) => step.firstAddedProductDiscount)) == null ? void 0 : _b.firstAddedProductDiscount),
        stepWithSpecificDiscount: config.steps.find((step) => step.firstAddedProductDiscount),
        numberOfSpecificDiscountsUsed: 1,
        productTileWidth: null
      };
    },
    mutations: {
      setPassedStep(state, stepIdx) {
        state.steps.forEach((step, idx) => {
          step.isPassed = idx <= stepIdx ? true : false;
        });
      },
      setCurrentGrid(state, number) {
        state.currentGrid = number;
      },
      setCurrentTab(state, tabPosition) {
        state.steps.forEach((step) => {
          step.tabs.forEach((tab) => {
            tab.current = false;
          });
        });
        state.steps[tabPosition.stepIdx].tabs[tabPosition.tabIdx].current = true;
        state.currentTab = state.steps[tabPosition.stepIdx].tabs[tabPosition.tabIdx];
      },
      applySpecificDiscount(state) {
        state.numberOfSpecificDiscountsUsed--;
      },
      applySpecificDiscount(state) {
        state.numberOfSpecificDiscountsUsed--;
      },
      disapplySpecificDiscount(state) {
        state.numberOfSpecificDiscountsUsed++;
      },
      resetSpecificDiscountApplying(state) {
        state.numberOfSpecificDiscountsUsed = 1;
      },
      setProductsBoxSeparatedVariants(state, variants) {
        state.productsBoxSeparatedVariants = variants;
      },
      ADD_TO_BOX(state, variant) {
        const productIndex = state.productsBox.findIndex((p2) => p2.id === variant.id);
        if (productIndex !== -1) {
          state.productsBox[productIndex].addedQty += 1;
          state.addedProductsQuantity++;
        } else {
          state.productsBox.push({ ...variant, addedQty: 1 });
          state.addedProductsQuantity++;
        }
        state.productsBox = [...state.productsBox];
      },
      REMOVE_FROM_BOX(state, variant) {
        const productIndex = state.productsBox.findIndex((p2) => p2.id === variant.id);
        if (productIndex !== -1) {
          state.productsBox[productIndex].addedQty -= 1;
          if (state.productsBox[productIndex].addedQty === 0) {
            state.productsBox.splice(productIndex, 1);
          }
          state.addedProductsQuantity--;
        }
        state.productsBox = [...state.productsBox];
      },
      SET_QUANTITY(state, { variant, quantity }) {
        const productIndex = state.productsBox.findIndex((p2) => p2.id === variant.id);
        if (productIndex !== -1) {
          if (state.productsBox[productIndex].addedQty < quantity) {
            state.addedProductsQuantity -= quantity;
          }
          state.productsBox[productIndex].addedQty = quantity;
          if (state.productsBox[productIndex].addedQty === 0) {
            state.productsBox.splice(productIndex, 1);
            state.addedProductsQuantity -= quantity;
          }
        } else if (quantity > 0) {
          state.productsBox.push({ ...variant, addedQty: quantity });
          state.addedProductsQuantity += quantity;
        }
        state.productsBox = [...state.productsBox];
      },
      calculateDiscount(state) {
        if (!state.productsBox || !state.productsBox.length || state.productsBox.length < 1) {
          state.discount = 0;
          return;
        }
        let stepsWithAddedProductsQty = {};
        state.productsBox.forEach((variant) => {
          if (!variant.stepName && !variant.tabName) {
            return;
          }
          const alreadyAdded = stepsWithAddedProductsQty[variant.stepName];
          stepsWithAddedProductsQty[variant.stepName] = alreadyAdded > 0 ? alreadyAdded + variant.addedQty : variant.addedQty;
        });
        const stepWithDiscounts = state.steps.find((step) => step.discounts);
        const discounts = [...stepWithDiscounts.discounts].sort((a, b3) => b3.discount_percent - a.discount_percent);
        const addedQtyForFoundStep = stepsWithAddedProductsQty[stepWithDiscounts.title];
        let result = 0;
        for (const discount of discounts) {
          if (addedQtyForFoundStep >= discount.products_quantity) {
            result = discount.discount_percent;
            break;
          }
        }
        state.discount = result;
      },
      updateProductTileWidth(state, width) {
        state.productTileWidth = width;
      }
    },
    actions: {
      addToBox({ commit: commit2 }, variant) {
        commit2("ADD_TO_BOX", variant);
      },
      removeFromBox({ commit: commit2 }, variant) {
        commit2("REMOVE_FROM_BOX", variant);
      },
      setQuantity({ commit: commit2 }, payload) {
        commit2("SET_QUANTITY", payload);
      },
      updateProductTileWidth({ commit: commit2 }, width) {
        commit2("updateProductTileWidth", width);
      }
    },
    getters: {
      productTileWidth: (state) => state.productTileWidth,
      getAddedUniqueProductsQty: (state) => {
        var _a;
        return ((_a = state.productsBox) == null ? void 0 : _a.length) || 0;
      },
      getSteps: (state) => {
        return state.steps;
      },
      getCurrentGrid: (state) => {
        return state.currentGrid;
      },
      getCurrentStep: (state) => {
        const passedSteps = state.steps.filter((step) => step.isPassed);
        const currentStep = passedSteps[passedSteps.length - 1] || state.steps[0];
        return currentStep;
      },
      getCurrentTab(state) {
        return state.currentTab;
      },
      getProductsBox: (state) => {
        return state.productsBox;
      },
      getAddedProductsQuantity: (state) => {
        return state.addedProductsQuantity;
      },
      getDiscount: (state) => {
        return state.discount;
      },
      getNextDiscount: (state) => {
        var _a;
        const empty = {
          discount_percent: 0,
          products_quantity: 0,
          theLastOneReached: true
        };
        const stepWithDiscounts = (_a = state.steps) == null ? void 0 : _a.find((step) => {
          var _a2;
          return (_a2 = step.discounts) == null ? void 0 : _a2.length;
        });
        if (!stepWithDiscounts) {
          return empty;
        }
        const discounts = [...stepWithDiscounts.discounts].sort((a, b3) => b3.discount_percent - a.discount_percent).reverse();
        if (!discounts.length) {
          return empty;
        }
        if (!state.discount) {
          return { ...discounts[0], theLastOneReached: false };
        }
        const currentDiscountIdx = discounts.findIndex((discount) => discount.discount_percent === state.discount);
        if (currentDiscountIdx === -1) {
          return empty;
        }
        const theLastOneReached = currentDiscountIdx === discounts.length - 1;
        const result = theLastOneReached ? { ...discounts[discounts.length - 1] } : { ...discounts[currentDiscountIdx + 1] };
        result.theLastOneReached = theLastOneReached;
        return result;
      },
      /** Скидка (%), которая применится при указанном количестве продуктов в шаге со скидками */
      getDiscountForQuantity: (state) => (quantity) => {
        var _a;
        const stepWithDiscounts = state.steps.find((step) => step.discounts);
        if (!((_a = stepWithDiscounts == null ? void 0 : stepWithDiscounts.discounts) == null ? void 0 : _a.length)) return null;
        const sorted = [...stepWithDiscounts.discounts].sort((a, b3) => b3.discount_percent - a.discount_percent);
        const tier = sorted.find((d) => quantity >= d.products_quantity);
        return tier ? tier.discount_percent : null;
      },
      getSpecificDiscountAmount: (state) => {
        return state.specificDiscountAmount;
      },
      getNumberOfSpecificDiscountsUsed: (state) => {
        return state.numberOfSpecificDiscountsUsed;
      },
      getVariantsAddedQuantuty: (state) => (variantId) => {
        var _a;
        return state.addedProductsQuantity > 0 ? (_a = state.productsBox.find((v) => v.id === variantId)) == null ? void 0 : _a.addedQty : 0;
      },
      getAddedDiscountableProductsQty: (state) => {
        if (state.addedProductsQuantity < 1) {
          return 0;
        }
        let res = 0;
        const stepWithDiscounts = state.steps.find((step) => step.discounts);
        const discountableProducts = state.productsBox.filter((product) => product.stepName === stepWithDiscounts.title);
        if (discountableProducts.length < 1) {
          return 0;
        }
        discountableProducts.forEach((product) => {
          res += product.addedQty;
        });
        return res;
      },
      getProductsBoxSeparatedVariants: (state) => {
        return state.productsBoxSeparatedVariants;
      },
      // price total / portions qty - discount
      // portions qty = metafield * added qty
      getReductedPricePerPortion: (state) => {
        let priceTotal = 0;
        let portionsTotal = 0;
        state.productsBox.forEach((variant) => {
          const product = variant.product;
          const productPortions = product.portions;
          const variantPortions = variant.portions;
          const portions = +productPortions || +variantPortions;
          if (portions) {
            portionsTotal += portions * +variant.addedQty;
            priceTotal += +variant.price / 100 * +variant.addedQty;
          }
        });
        const pricePerPortion = priceTotal / portionsTotal;
        const pricePerPortionDiscounted = pricePerPortion * (1 - state.discount / 100);
        return pricePerPortionDiscounted;
      },
      getCappedSpecificDiscountForVariant: (state) => (variant) => {
        const specificDiscountAmountBase = Number(state.specificDiscountAmount) || 0;
        const priceVariant = Number(variant == null ? void 0 : variant.price) || 0;
        return Math.min(specificDiscountAmountBase, priceVariant);
      },
      /**
       * Checks if a variant is eligible for category discount
       * Eligibility is determined by the isCategoryDiscountable flag set in Liquid template
       * @param {Object} state - Vuex state
       * @returns {Function} Function that takes a variant and returns boolean
       */
      isVariantEligibleForCategoryDiscount: (state) => (variant) => {
        if (!variant) {
          return false;
        }
        if (variant.isCategoryDiscountable === true) {
          const step = state.steps.find((s) => s.title === variant.stepName);
          if (step && step.categoryDiscount) {
            return true;
          } else {
            console.warn("[Category Discount] Variant has isCategoryDiscountable=true but step has no categoryDiscount configured");
            return false;
          }
        }
        return false;
      },
      /**
       * Gets the category discount percentage for a variant
       * Only returns discount if variant has isCategoryDiscountable flag set to true
       * @param {Object} state - Vuex state
       * @returns {Function} Function that takes a variant and returns discount percentage or 0
       */
      getCategoryDiscountForVariant: (state) => (variant) => {
        if (!variant) {
          return 0;
        }
        if (variant.isCategoryDiscountable !== true) {
          return 0;
        }
        const step = state.steps.find((s) => s.title === variant.stepName);
        if (!step || !step.categoryDiscount) {
          console.warn("[Category Discount] getCategoryDiscountForVariant: Variant is eligible but step has no categoryDiscount configured");
          return 0;
        }
        return Number(step.categoryDiscount);
      },
      /**
       * Calculates the effective discount percentage for a variant
       * Combines bundle discount and category discount additively (percentages are summed)
       * @param {Object} state - Vuex state
       * @returns {Function} Function that takes a variant and returns effective discount percentage
       */
      getEffectiveDiscountForVariant: (state, getters) => (variant) => {
        const bundleDiscount = state.discount || 0;
        const categoryDiscount = getters.getCategoryDiscountForVariant(variant) || 0;
        if (bundleDiscount === 0) {
          return categoryDiscount;
        }
        if (categoryDiscount === 0) {
          return bundleDiscount;
        }
        return bundleDiscount + categoryDiscount;
      },
      /**
       * Gets the display discount percentage for a variant
       * Eligibility for category discount is checked via isCategoryDiscountable flag
       * Returns bundle discount if category discount is not applicable,
       * or category discount if bundle discount is not yet reached,
       * or combined discount (sum of percentages) if both are applicable
       * @param {Object} state - Vuex state
       * @returns {Function} Function that takes a variant and returns display discount percentage
       */
      getDisplayDiscountForVariant: (state, getters) => (variant) => {
        const bundleDiscount = state.discount || 0;
        const isEligibleForCategory = (variant == null ? void 0 : variant.isCategoryDiscountable) === true;
        const categoryDiscount = isEligibleForCategory ? getters.getCategoryDiscountForVariant(variant) || 0 : 0;
        if (!isEligibleForCategory) {
          return bundleDiscount;
        }
        if (bundleDiscount === 0) {
          return categoryDiscount;
        }
        return bundleDiscount + categoryDiscount;
      }
    }
  });
};
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$s = {
  data() {
    return {
      icons: null,
      screenWidth: window.innerWidth
    };
  },
  methods: {
    setGrid(number) {
      if (this.screenWidth >= 375 && this.screenWidth < 640 && number === 3) {
        return;
      }
      if (this.screenWidth < 375) {
        return;
      }
      this.$store.commit("setCurrentGrid", number);
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
      if (this.currentGrid === 3 && this.screenWidth < 640) {
        this.setGrid(2);
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.updateScreenWidth);
    if (this.screenWidth >= 640) {
      this.setGrid(3);
    } else if (this.screenWidth >= 375 && this.screenWidth < 640) {
      this.setGrid(2);
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  created() {
    this.icons = this.$store.state.config.htmlSnippets.icons;
  },
  computed: {
    ...mapGetters({
      currentGrid: "getCurrentGrid"
    })
  }
};
const _hoisted_1$p = { class: "bb-header__grid-switcher" };
const _hoisted_2$k = ["innerHTML"];
const _hoisted_3$h = ["innerHTML"];
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$p, [
    withDirectives(createBaseVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event) => $options.setGrid(3)),
      class: normalizeClass(["bb-hedaer__grid-button", { "bb-hedaer__grid-button--active": _ctx.currentGrid === 3 }]),
      innerHTML: $data.icons["grid-3"]
    }, null, 10, _hoisted_2$k), [
      [vShow, $data.screenWidth >= 640]
    ]),
    withDirectives(createBaseVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event) => $options.setGrid(2)),
      class: normalizeClass(["bb-hedaer__grid-button", { "bb-hedaer__grid-button--active": _ctx.currentGrid === 2 }]),
      innerHTML: $data.icons["grid-2"]
    }, null, 10, _hoisted_3$h), [
      [vShow, $data.screenWidth >= 640]
    ])
  ]);
}
const GridSwitcher = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$s]]);
const _sfc_main$r = {
  props: [
    "tab",
    "tabIdx",
    "isCurrent",
    "tabsContainer",
    "hasProducts"
  ],
  data() {
    return {};
  },
  methods: {
    setCurrentTab(event) {
      if (!this.hasProducts) return;
      if (!!this.tabsContainer && !!this.tabsContainer.offsetLeft && (!!event.target && !!event.target.offsetLeft)) {
        const x3 = event.target.offsetLeft - this.tabsContainer.offsetLeft;
        this.tabsContainer.scroll({
          left: x3,
          behavior: "smooth"
        });
      }
      this.$emit("setCurrentTab", this.tabIdx);
    },
    title(str) {
      return str.includes("®") ? str.replace("®", `<sup>®</sup>`) : str;
    }
  },
  mounted() {
  }
};
const _hoisted_1$o = ["disabled", "innerHTML"];
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.setCurrentTab && $options.setCurrentTab(...args)),
    class: normalizeClass(["bb-product-grid__tab label-s", { "bb-product-grid__tab--active": $props.isCurrent, "bb-product-grid__tab--disabled": !$props.hasProducts }]),
    disabled: !$props.hasProducts,
    innerHTML: $options.title($props.tab.title)
  }, null, 10, _hoisted_1$o);
}
const Tab$1 = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$r]]);
const _sfc_main$q = {
  props: {
    src: String,
    additionalClasses: String,
    loading: String,
    alt: String,
    width: Number,
    height: Number,
    useSrcset: Boolean,
    usePlaceholder: Boolean,
    sizes: {
      type: Array,
      default: () => [200, 300, 400, 500, 600, 700, 800, 900, 1e3, 1100, 1200]
    }
  },
  data() {
    return {
      showPlaceholder: true
    };
  },
  methods: {
    addPrefixBeforeExtension(str, prefix) {
      if (!str) {
        return "";
      }
      const extensions = [".png", ".webp", ".jpg"];
      for (const ext of extensions) {
        if (str.includes(ext)) {
          str = str.replace(ext, `${prefix}${ext}`);
        }
      }
      return str;
    }
  },
  computed: {
    srcset() {
      let result = "";
      this.sizes.forEach((size, idx) => {
        const newSrc = this.addPrefixBeforeExtension(this.src, `_${size}x`);
        const comma = idx === this.sizes.length - 1 ? "" : ",";
        result += `${newSrc} ${size}w${comma}`;
      });
      return result;
    },
    imageStyle() {
      return this.showPlaceholder ? { opacity: 0, height: "1px", width: "1px" } : {};
    }
  }
};
const _hoisted_1$n = ["src", "width", "height", "alt"];
const _hoisted_2$j = ["loading", "src", "srcset", "width", "height", "alt"];
const _hoisted_3$g = ["loading", "src", "width", "height", "alt"];
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.useSrcset ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["bb-image-wrapper", $props.additionalClasses])
  }, [
    withDirectives(createBaseVNode("img", {
      src: $options.addPrefixBeforeExtension($props.src, "_10x"),
      width: $props.width,
      height: $props.height,
      alt: $props.alt,
      class: "bb-image-wrapper__placeholder"
    }, null, 8, _hoisted_1$n), [
      [vShow, $data.showPlaceholder && $props.usePlaceholder]
    ]),
    createBaseVNode("img", {
      loading: $props.loading,
      src: $props.src,
      sizes: "(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 0px) / 4 - 18px)",
      srcset: $options.srcset,
      width: $props.width,
      height: $props.height,
      alt: $props.alt,
      style: normalizeStyle($options.imageStyle),
      onLoad: _cache[0] || (_cache[0] = () => $data.showPlaceholder = false)
    }, null, 44, _hoisted_2$j)
  ], 2)) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(["bb-image-wrapper", $props.additionalClasses])
  }, [
    createBaseVNode("img", {
      loading: $props.loading,
      src: $props.src,
      width: $props.width,
      height: $props.height,
      alt: $props.alt
    }, null, 8, _hoisted_3$g)
  ], 2));
}
const Image$1 = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$q]]);
const _sfc_main$p = {
  props: {
    variantIncoming: Object,
    product: Object
  },
  data() {
    var _a;
    return {
      disabled: false,
      addedQty: 0,
      maximum: ((_a = this.variantIncoming) == null ? void 0 : _a.inventory_quantity) || 99,
      variant: this.variantIncoming
    };
  },
  methods: {
    validateInput() {
      if (this.addedQty > this.maximum) {
        this.addedQty = this.maximum;
      }
    },
    addToBox() {
      if (this.disabled || !this.variant.available) {
        return;
      }
      this.validateInput();
      this.$store.dispatch("addToBox", this.variant);
      this.addedQty += 1;
    },
    increaseQty() {
      this.validateInput();
      this.$store.dispatch("addToBox", this.variant);
      this.addedQty += 1;
    },
    decreaseQty() {
      const specificVariantIdx = this.productsBoxSeparatedVariants.findIndex((v) => v.specificDiscount);
      const specificVariant = this.productsBoxSeparatedVariants[specificVariantIdx];
      if ((specificVariant == null ? void 0 : specificVariant.id) === this.variant.id) {
        this.$store.commit("disapplySpecificDiscount");
      }
      if (this.addedQty > 0) {
        this.$store.dispatch("removeFromBox", this.variant);
        this.addedQty -= 1;
      }
    },
    updateQty() {
      this.validateInput();
      this.$store.dispatch("setQuantity", {
        variant: this.variant,
        quantity: this.addedQty
      });
    },
    getVariantsAddedQuantuty() {
      return this.$store.getters.getVariantsAddedQuantuty(this.variantIncoming.id);
    }
  },
  mounted() {
    this.addedQty = this.getVariantsAddedQuantuty() || 0;
  },
  updated() {
    this.variant = this.variantIncoming;
  },
  computed: {
    minusButtonClass() {
      return {
        "bb-quantity-selector__button--disabled": this.addedQty < 1
      };
    },
    plusButtonClass() {
      return {
        "bb-quantity-selector__button--disabled": this.maximum === this.addedQty
      };
    },
    ...mapGetters({
      addedUniqueProductsQty: "getAddedUniqueProductsQty",
      productsBoxWithVariants: "getProductsBox",
      productsBoxSeparatedVariants: "getProductsBoxSeparatedVariants"
    }),
    disabledATB() {
      const condition = !this.variant.available || this.addedUniqueProductsQty === +this.$store.state.config.maximum_unique_products;
      this.disabled = condition;
      return {
        "disabled": condition
      };
    },
    innerTextATB() {
      return this.variant.available ? this.$store.state.config.translations.addToBox : this.$store.state.config.translations.soldOut;
    }
  },
  watch: {
    variant: {
      handler(newV, old) {
        this.maximum = (newV == null ? void 0 : newV.inventory_quantity) || 99;
        this.addedQty = this.getVariantsAddedQuantuty() || 0;
      },
      deep: true
    },
    productsBoxWithVariants: {
      handler(newV, old) {
        const array = newV;
        const foundVariant = array.find((v) => v.id === this.variant.id);
        if (foundVariant && foundVariant.addedQty !== this.addedQty) {
          this.addedQty = foundVariant.addedQty;
        } else if (this.addedQty > 0 && !foundVariant) {
          this.addedQty = 0;
        }
      },
      deep: true,
      immediate: true
      // Ensure watcher runs on component mount to sync with pre-initialized box state
    }
  }
};
const _hoisted_1$m = ["innerHTML"];
const _hoisted_2$i = { class: "bb-product__add-to-box_text label-m" };
const _hoisted_3$f = { class: "bb-quantity-selector" };
const _hoisted_4$b = ["innerHTML"];
const _hoisted_5$a = ["innerHTML"];
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(Fragment, null, [
    withDirectives(createBaseVNode("button", {
      class: normalizeClass(["bb-product__add-to-box btn btn--secondary btn--transparent btn--small btn--border", $options.disabledATB]),
      onClick: _cache[0] || (_cache[0] = (...args) => $options.addToBox && $options.addToBox(...args)),
      type: "button"
    }, [
      $data.variant.available ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "bb-product__add-to-box_icon",
        innerHTML: _ctx.$store.state.config.htmlSnippets.icons.plus
      }, null, 8, _hoisted_1$m)) : createCommentVNode("", true),
      createBaseVNode("span", _hoisted_2$i, toDisplayString($options.innerTextATB), 1)
    ], 2), [
      [vShow, $data.addedQty === 0]
    ]),
    withDirectives(createBaseVNode("div", _hoisted_3$f, [
      createBaseVNode("button", {
        class: normalizeClass(["bb-quantity-selector__button", $options.minusButtonClass]),
        onClick: _cache[1] || (_cache[1] = (...args) => $options.decreaseQty && $options.decreaseQty(...args)),
        innerHTML: _ctx.$store.state.config.htmlSnippets.icons.minus
      }, null, 10, _hoisted_4$b),
      withDirectives(createBaseVNode("input", {
        class: "bb-quantity-selector__input heading-s",
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $data.addedQty = $event),
        readonly: ""
      }, null, 512), [
        [
          vModelText,
          $data.addedQty,
          void 0,
          { number: true }
        ]
      ]),
      createBaseVNode("button", {
        class: normalizeClass(["bb-quantity-selector__button bb-quantity-selector__button--plus", $options.plusButtonClass]),
        onClick: _cache[3] || (_cache[3] = (...args) => $options.increaseQty && $options.increaseQty(...args)),
        innerHTML: _ctx.$store.state.config.htmlSnippets.icons.plusRound
      }, null, 10, _hoisted_5$a)
    ], 512), [
      [vShow, $data.addedQty > 0]
    ])
  ], 64);
}
const QuantitySelector$1 = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$p]]);
const _sfc_main$o = {
  props: {
    product: Object
  },
  data() {
    return {
      isActive: false,
      uid: Math.random().toString(36).slice(2),
      scrollStartY: null
    };
  },
  methods: {
    showContext() {
      if (window.innerWidth > 768) {
        this.activate();
      }
    },
    hideContext() {
      if (window.innerWidth > 768) {
        this.isActive = false;
      }
    },
    toggleContext() {
      if (window.innerWidth <= 768) {
        if (!this.isActive) {
          this.activate();
        } else {
          this.isActive = false;
        }
      }
    },
    activate() {
      this.isActive = true;
      this.scrollStartY = window.scrollY;
      window.dispatchEvent(new CustomEvent("mhd-open", { detail: { uid: this.uid } }));
    },
    closeOnClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isActive = false;
      }
    },
    onMhdOpen(event) {
      if (event.detail.uid !== this.uid) {
        this.isActive = false;
      }
    },
    onScroll() {
      if (this.isActive && this.scrollStartY !== null && Math.abs(window.scrollY - this.scrollStartY) >= 20) {
        this.isActive = false;
        this.scrollStartY = null;
      }
    }
  },
  computed: {
    ...mapGetters(["productTileWidth"]),
    mhdPadding() {
      return window.innerWidth < 740 ? 8 : 16;
    }
  },
  mounted() {
    document.addEventListener("click", this.closeOnClickOutside);
    window.addEventListener("mhd-open", this.onMhdOpen);
    window.addEventListener("scroll", this.onScroll, { passive: true });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeOnClickOutside);
    window.removeEventListener("mhd-open", this.onMhdOpen);
    window.removeEventListener("scroll", this.onScroll);
  }
};
const _hoisted_1$l = ["aria-label"];
const _hoisted_2$h = { class: "bb-product__mhd-title label-xs" };
const _hoisted_3$e = { class: "bb-product__mhd-context_content body-s" };
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "bb-product__mhd-wrapper",
    onClick: [
      _cache[2] || (_cache[2] = (...args) => $options.toggleContext && $options.toggleContext(...args)),
      _cache[3] || (_cache[3] = withModifiers(() => {
      }, ["stop"]))
    ],
    tabindex: "0",
    "aria-label": `${$props.product.mhd.title}. ${$props.product.mhd.description}`
  }, [
    createBaseVNode("div", {
      class: "bb-product__mhd",
      onMouseenter: _cache[0] || (_cache[0] = (...args) => $options.showContext && $options.showContext(...args)),
      onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.hideContext && $options.hideContext(...args))
    }, [
      _cache[4] || (_cache[4] = createBaseVNode("div", { class: "bb-product__mhd-icon-wrapper" }, [
        createBaseVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "10",
          height: "10",
          viewBox: "0 0 10 10",
          fill: "none"
        }, [
          createBaseVNode("path", {
            d: "M5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0ZM4.99414 6.26758C4.63677 6.26758 4.37519 6.51482 4.375 6.86523C4.375 7.22273 4.63664 7.4707 4.99414 7.4707C5.35831 7.47053 5.61914 7.22261 5.61914 6.86523C5.61895 6.51494 5.35818 6.26776 4.99414 6.26758ZM4.45703 2.5V3.83398L4.72559 5.88281H5.26855L5.53711 3.83398V2.5H4.45703Z",
            fill: "black"
          })
        ])
      ], -1)),
      createBaseVNode("span", _hoisted_2$h, toDisplayString($props.product.mhd.title), 1)
    ], 32),
    $data.isActive ? (openBlock(), createElementBlock("p", {
      key: 0,
      class: "bb-product__mhd-context",
      style: normalizeStyle(`width: calc(${_ctx.productTileWidth}px - ${$options.mhdPadding}px);`)
    }, [
      _cache[5] || (_cache[5] = createBaseVNode("span", { class: "bb-product__mhd-triangle" }, null, -1)),
      createBaseVNode("span", _hoisted_3$e, toDisplayString($props.product.mhd.description), 1)
    ], 4)) : createCommentVNode("", true)
  ], 8, _hoisted_1$l);
}
const MHD = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$o]]);
const _sfc_main$n = {
  props: {
    label: {
      type: Object,
      required: true
    }
  },
  computed: {
    labelStyle() {
      const style = {};
      if (this.label.background_color) {
        style.backgroundColor = this.label.background_color;
      }
      if (this.label.text_color) {
        style.color = this.label.text_color;
      }
      if (this.label.border_color) {
        style.borderColor = this.label.border_color;
      }
      return style;
    }
  }
};
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", {
    class: "bb-product__label label-xs",
    style: normalizeStyle($options.labelStyle)
  }, toDisplayString($props.label.text), 5);
}
const LabelBadge = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$n]]);
const _sfc_main$m = {
  props: {
    variant: Object,
    product: Object,
    titleFromVariant: Boolean
  },
  data() {
    return {};
  },
  methods: {
    formatPrice(price, type) {
      if (!price || price <= 0) {
        return "0.00";
      }
      const isUKStore = Shopify.currency.active === "GBP" || Shopify.locale === "en-GB";
      const formattedPrice = (price / 100).toFixed(2);
      if (type === "comparePrice") {
        if (isUKStore) {
          return `${formattedPrice}`;
        }
        return `${formattedPrice.split(".").join(",")}`;
      }
      if (isUKStore) {
        return `£ ${formattedPrice}`;
      }
      return `${formattedPrice.split(".").join(",")} ${this.$store.state.currency}`;
    }
  },
  computed: {
    subtext_m_m() {
      var _a, _b, _c;
      return ((_a = this.variant) == null ? void 0 : _a.subtext_m_m) || ((_c = (_b = this.variant) == null ? void 0 : _b.product) == null ? void 0 : _c.subtext_m_m) || null;
    },
    price() {
      let discountedPrice = this.variant.price;
      if (this.numberOfSpecificDiscountsUsed > 0 && this.variant.specificDiscountable && this.atLeastOneProductFromTheFirstStep) {
        discountedPrice -= this.cappedSpecificDiscount;
      } else {
        const bundleDiscount = this.discount || 0;
        const categoryDiscount = this.categoryDiscount || 0;
        if (bundleDiscount > 0 && categoryDiscount > 0) {
          const combinedDiscount = bundleDiscount + categoryDiscount;
          discountedPrice = discountedPrice * (1 - combinedDiscount / 100);
        } else if (bundleDiscount > 0) {
          discountedPrice = discountedPrice * (1 - bundleDiscount / 100);
        } else if (categoryDiscount > 0) {
          discountedPrice = discountedPrice * (1 - categoryDiscount / 100);
        }
      }
      if (discountedPrice < 0) {
        discountedPrice = 0;
      }
      return {
        formatted: this.formatPrice(discountedPrice),
        unformatted: discountedPrice,
        specificDiscount: this.cappedSpecificDiscount
      };
    },
    priceCompare() {
      var _a, _b;
      return {
        formatted: this.formatPrice((_a = this.variant) == null ? void 0 : _a.price, "comparePrice"),
        unformatted: (_b = this.variant) == null ? void 0 : _b.price
      };
    },
    priceCompareFormatted() {
      var _a;
      if (this.price.unformatted === 0) {
        const price = (_a = this.variant) == null ? void 0 : _a.price;
        if (!price || price <= 0) {
          return "0.00";
        }
        const isUKStore = Shopify.currency.active === "GBP" || Shopify.locale === "en-GB";
        const formattedPrice = (price / 100).toFixed(2);
        if (isUKStore) {
          return `£ ${formattedPrice}`;
        }
        return `${formattedPrice.split(".").join(",")} ${this.$store.state.currency}`;
      } else {
        return this.priceCompare.formatted;
      }
    },
    atLeastOneProductFromTheFirstStep() {
      return this.productsBoxWithVariants.find((v) => v.stepName === this.steps[0].title);
    },
    cappedSpecificDiscount() {
      return this.$store.getters.getCappedSpecificDiscountForVariant(this.variant);
    },
    categoryDiscount() {
      return this.$store.getters.getCategoryDiscountForVariant(this.variant);
    },
    displayDiscount() {
      return this.$store.getters.getDisplayDiscountForVariant(this.variant);
    },
    ...mapGetters({
      discount: "getDiscount",
      specificDiscountAmount: "getSpecificDiscountAmount",
      numberOfSpecificDiscountsUsed: "getNumberOfSpecificDiscountsUsed",
      productsBoxWithVariants: "getProductsBox",
      steps: "getSteps"
    })
  },
  components: {
    Image: Image$1,
    QuantitySelector: QuantitySelector$1,
    MHD,
    LabelBadge
  }
};
const _hoisted_1$k = {
  key: 0,
  class: "bb-product__variant"
};
const _hoisted_2$g = { class: "bb-product__variant_header" };
const _hoisted_3$d = { class: "bb-product__body" };
const _hoisted_4$a = { class: "bb-product__title heading-l-small-case heading-m-md" };
const _hoisted_5$9 = {
  key: 0,
  class: "bb-product__title-subtext body-s"
};
const _hoisted_6$7 = {
  key: 0,
  class: "bb-product__price-item bb-product__price--normal body-m-strong"
};
const _hoisted_7$4 = {
  key: 1,
  class: "bb-product__price-item bb-product__price--free body-s-strong"
};
const _hoisted_8$4 = { class: "bb-product__discount-wrapper" };
const _hoisted_9$3 = {
  key: 1,
  class: "bb-product__price-item bb-product__price--discount body-s-strong"
};
const _hoisted_10$3 = { class: "bb-product__controls" };
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  const _component_MHD = resolveComponent("MHD");
  const _component_LabelBadge = resolveComponent("LabelBadge");
  const _component_Image = resolveComponent("Image");
  const _component_QuantitySelector = resolveComponent("QuantitySelector");
  return $props.variant ? (openBlock(), createElementBlock("div", _hoisted_1$k, [
    createBaseVNode("div", _hoisted_2$g, [
      ((_c = (_b = (_a = $props.variant) == null ? void 0 : _a.product) == null ? void 0 : _b.mhd) == null ? void 0 : _c.description) && ((_f = (_e = (_d = $props.variant) == null ? void 0 : _d.product) == null ? void 0 : _e.mhd) == null ? void 0 : _f.title) ? (openBlock(), createBlock(_component_MHD, {
        key: 0,
        product: $props.variant.product
      }, null, 8, ["product"])) : ((_g = $props.variant.labels) == null ? void 0 : _g[0]) ? (openBlock(), createBlock(_component_LabelBadge, {
        key: 1,
        label: (_h = $props.variant.labels) == null ? void 0 : _h[0]
      }, null, 8, ["label"])) : createCommentVNode("", true),
      createVNode(_component_Image, {
        src: ((_j = (_i = $props.variant) == null ? void 0 : _i.featured_image) == null ? void 0 : _j.src) || ((_k = $props.product) == null ? void 0 : _k.featured_image),
        additionalClasses: "bb-product__image-wrapper",
        alt: ((_m = (_l = $props.variant) == null ? void 0 : _l.featured_image) == null ? void 0 : _m.alt) || ((_n = $props.variant) == null ? void 0 : _n.productTitle),
        width: 200,
        height: 200,
        useSrcset: true,
        usePlaceholder: true,
        loading: "lazy"
      }, null, 8, ["src", "alt"])
    ]),
    createBaseVNode("div", _hoisted_3$d, [
      createBaseVNode("span", _hoisted_4$a, toDisplayString($props.titleFromVariant ? $props.variant.title === "Default Title" ? $props.variant.productTitle : $props.variant.title : (_o = $props.variant) == null ? void 0 : _o.productTitle), 1),
      $options.subtext_m_m ? (openBlock(), createElementBlock("span", _hoisted_5$9, toDisplayString($options.subtext_m_m), 1)) : createCommentVNode("", true),
      createBaseVNode("div", {
        class: normalizeClass(["bb-product__price", { "free-product": $options.price.unformatted === 0 }]),
        style: normalizeStyle({
          flexDirection: $options.price.unformatted === 0 ? "row-reverse" : "row",
          justifyContent: $options.price.unformatted === 0 ? "flex-end" : "flex-start"
        })
      }, [
        $options.price.unformatted > 0 ? (openBlock(), createElementBlock("span", _hoisted_6$7, toDisplayString($options.price.formatted), 1)) : (openBlock(), createElementBlock("span", _hoisted_7$4, toDisplayString(_ctx.$store.state.config.translations.free), 1)),
        createBaseVNode("div", _hoisted_8$4, [
          $options.priceCompare.unformatted > $options.price.unformatted ? (openBlock(), createElementBlock("del", {
            key: 0,
            class: normalizeClass(["bb-product__price-item bb-product__price--compare", $options.price.unformatted === 0 ? "body-m-strong" : "body-s"]),
            style: normalizeStyle({
              color: $options.price.unformatted === 0 ? "#000000" : "#737373"
            })
          }, toDisplayString($options.priceCompareFormatted), 7)) : createCommentVNode("", true),
          _ctx.numberOfSpecificDiscountsUsed > 0 && $props.variant.specificDiscountable && $options.price.unformatted > 0 && this.atLeastOneProductFromTheFirstStep ? (openBlock(), createElementBlock("div", _hoisted_9$3, " -" + toDisplayString($options.formatPrice($options.cappedSpecificDiscount)), 1)) : $options.displayDiscount > 0 ? withDirectives((openBlock(), createElementBlock("div", {
            key: 2,
            class: "bb-product__price-item bb-product__price--discount body-s-strong"
          }, " -" + toDisplayString(Math.round($options.displayDiscount)) + "% ", 513)), [
            [vShow, $props.variant.specificDiscountable ? _ctx.numberOfSpecificDiscountsUsed < 1 : true]
          ]) : createCommentVNode("", true)
        ])
      ], 6),
      createBaseVNode("div", _hoisted_10$3, [
        createVNode(_component_QuantitySelector, {
          variantIncoming: $props.variant,
          product: $props.product
        }, null, 8, ["variantIncoming", "product"])
      ])
    ])
  ])) : createCommentVNode("", true);
}
const Variant = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$m]]);
const _sfc_main$l = {
  props: {
    isLastRendered: Boolean,
    variant: Object,
    step: Object,
    product: Object,
    useFirstAvailabeVariant: Boolean,
    separateVariants: Boolean
  },
  data() {
    var _a;
    return {
      selectedVariant: this.getFirstAvailableVariant() || ((_a = this.product) == null ? void 0 : _a.variants[0])
    };
  },
  computed: {
    productTileStyle() {
      var _a, _b, _c, _d;
      const color = this.useFirstAvailabeVariant ? (_a = this.product) == null ? void 0 : _a.background_color_product_tile : ((_b = this.variant) == null ? void 0 : _b.split_bg_color) || ((_d = (_c = this.variant) == null ? void 0 : _c.product) == null ? void 0 : _d.background_color_product_tile);
      if (!color || !color.trim()) return {};
      return { backgroundColor: color };
    }
  },
  methods: {
    ...mapActions(["updateProductTileWidth"]),
    getFirstAvailableVariant() {
      var _a, _b, _c;
      if (!this.product) {
        return;
      }
      return ((_a = this.product) == null ? void 0 : _a.variants.length) === 1 ? (_b = this.product) == null ? void 0 : _b.variants[0] : (_c = this.product) == null ? void 0 : _c.variants.find((v) => {
        return v.available;
      });
    },
    updateTileWidth() {
      const newWidth = this.$el.offsetWidth;
      this.updateProductTileWidth(newWidth);
    }
  },
  mounted() {
    if (this.isLastRendered) {
      this.$emit("theLastOneMounted");
    }
    window.addEventListener("resize", () => {
      this.updateTileWidth();
    });
    this.updateTileWidth();
  },
  components: {
    Image: Image$1,
    Variant
  }
};
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_Variant = resolveComponent("Variant");
  return $options.getFirstAvailableVariant() && ((_a = $props.product) == null ? void 0 : _a.available) && $props.useFirstAvailabeVariant ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "bb-product",
    style: normalizeStyle($options.productTileStyle)
  }, [
    createVNode(_component_Variant, {
      product: $props.product,
      variant: $data.selectedVariant
    }, null, 8, ["product", "variant"])
  ], 4)) : $props.separateVariants && !$props.useFirstAvailabeVariant ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: "bb-product",
    style: normalizeStyle($options.productTileStyle)
  }, [
    createVNode(_component_Variant, {
      variant: $props.variant,
      titleFromVariant: $props.step.number !== 1
    }, null, 8, ["variant", "titleFromVariant"])
  ], 4)) : createCommentVNode("", true);
}
const Product = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$l]]);
const _sfc_main$k = {
  props: {
    isLastRendered: Boolean
  },
  mounted() {
    if (this.isLastRendered) {
      this.$emit("theLastOneMounted");
    }
  }
};
const _hoisted_1$j = { class: "bb-product--placeholder bb-product" };
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$j, _cache[0] || (_cache[0] = [
    createBaseVNode("div", { class: "bb-product__variant" }, [
      createBaseVNode("div", { class: "bb-product__image-placeholder" }),
      createBaseVNode("div", { class: "bb-product__controls" })
    ], -1)
  ]));
}
const ProductPlaceholder = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k]]);
const _sfc_main$j = {
  props: {
    tab: Object,
    step: Object
  },
  data() {
    return {
      variantsPerRow: 0,
      variantsToShow: []
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      let calculateVariantsPerRowTimer = setTimeout(() => {
        this.calculateVariantsPerRow();
        clearTimeout(calculateVariantsPerRowTimer);
      }, 20);
    });
    window.addEventListener("scroll", () => {
      let calculateVariantsToShowTimer = setTimeout(() => {
        this.calculateVariantsToShow();
        clearTimeout(calculateVariantsToShowTimer);
      }, 20);
    });
  },
  updated() {
    if (this.variantsPerRow < 1 && this.tab.variants) {
      this.calculateVariantsPerRow();
    }
    if (this.variantsToShow.length < 1 && this.variantsPerRow) {
      this.calculateVariantsToShow(this.variantsPerRow);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateVariantsPerRow);
  },
  methods: {
    calculateVariantsPerRow() {
      var _a, _b, _c, _d;
      if (!this.isShown) {
        this.variantsPerRow = 0;
        return;
      }
      if (window.innerWidth <= 768) {
        if (this.currentGrid > 0) {
          this.variantsPerRow = this.currentGrid;
        } else if (window.innerWidth < 375) {
          this.variantsPerRow = 1;
        }
        return;
      }
      const container = this.$el.offsetWidth ? this.$el : this.$el.parentNode;
      const containerWidth = container ? (_a = container.getBoundingClientRect()) == null ? void 0 : _a.width : 0;
      const firstVariantEl = this.$refs.variants && this.$refs.variants.length > 0 ? this.$refs.variants[0].$el : null;
      const itemWidth = firstVariantEl ? (_b = firstVariantEl.getBoundingClientRect()) == null ? void 0 : _b.width : (_d = (_c = this.$refs.productPlaceholder) == null ? void 0 : _c.$el) == null ? void 0 : _d.getBoundingClientRect().width;
      const gridGap = 30;
      const containerStyles = window.getComputedStyle(container);
      const paddingLeft = parseFloat(containerStyles.paddingLeft);
      const paddingRight = parseFloat(containerStyles.paddingRight);
      const res = Math.floor((containerWidth - (paddingLeft + paddingRight) + gridGap) / (itemWidth + gridGap));
      this.variantsPerRow = res < 0 ? this.variantsPerRow : res;
    },
    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return element ? rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth) : false;
    },
    calculateVariantsToShow(initialValue = 0) {
      var _a;
      if (!this.isShown || !this.tab.variants || !this.tab.variants.length || this.tab.variants.length < 1) {
        return;
      }
      if (initialValue > 0) {
        this.variantsToShow = this.tab.variants.slice(0, this.variantsPerRow * 2);
      }
      if (!this.$refs.variants) {
        return;
      }
      const variantsRefsLength = this.$refs.variants.length;
      const variantElementIdx = variantsRefsLength - this.variantsPerRow;
      const variantElement = variantElementIdx < variantsRefsLength ? (_a = this.$refs.variants[variantElementIdx]) == null ? void 0 : _a.$el : null;
      if (!variantElement) {
        return;
      }
      if (this.isInViewport(variantElement)) {
        const fromIdx = variantsRefsLength - 1;
        const toIdx = variantsRefsLength - 1 + this.variantsPerRow;
        const additionalVariants = this.tab.variants.slice(fromIdx, toIdx);
        additionalVariants.forEach((v) => {
          const alreadyAddedVariant = this.variantsToShow.find((variant) => (variant == null ? void 0 : variant.id) === (v == null ? void 0 : v.id));
          if (!alreadyAddedVariant) {
            this.variantsToShow.push(v);
          }
        });
      }
    },
    theLastOneMounted() {
      this.calculateVariantsToShow();
    }
  },
  computed: {
    ...mapGetters({
      currentGrid: "getCurrentGrid",
      currentTab: "getCurrentTab"
    }),
    isShown() {
      return this.currentTab.title === this.tab.title;
    },
    gridClass() {
      return {
        "bb-product-grid__container--2_per_row": this.currentGrid === 2,
        "bb-product-grid__container--3_per_row": this.currentGrid === 3
      };
    }
  },
  watch: {
    step(newStep, old) {
      if (this.step.title === newStep.title) {
        this.variantsToShow = [];
        this.calculateVariantsPerRow();
        this.calculateVariantsToShow(this.variantsPerRow);
      }
    }
  },
  components: {
    Product,
    ProductPlaceholder
  }
};
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProductPlaceholder = resolveComponent("ProductPlaceholder");
  const _component_Product = resolveComponent("Product");
  return withDirectives((openBlock(), createElementBlock("div", {
    class: normalizeClass(["bb-product-grid__container", $options.gridClass])
  }, [
    withDirectives(createVNode(_component_ProductPlaceholder, { ref: "productPlaceholder" }, null, 512), [
      [vShow, $data.variantsToShow.length < 1]
    ]),
    (openBlock(true), createElementBlock(Fragment, null, renderList($data.variantsToShow, (variant, idx) => {
      var _a;
      return withDirectives((openBlock(), createBlock(_component_Product, {
        ref_for: true,
        ref: "variants",
        key: idx,
        isLastRendered: $data.variantsToShow.length - 1 === idx,
        variant,
        separateVariants: true,
        step: $props.step,
        onTheLastOneMounted: $options.theLastOneMounted
      }, null, 8, ["isLastRendered", "variant", "step", "onTheLastOneMounted"])), [
        [vShow, !((_a = variant == null ? void 0 : variant.title) == null ? void 0 : _a.includes("Reward"))]
      ]);
    }), 128))
  ], 2)), [
    [vShow, $options.isShown]
  ]);
}
const ProductsContainer = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j]]);
const _sfc_main$i = {
  props: ["tabs", "currentStep"],
  data() {
    return {};
  },
  methods: {
    initCurrentTab() {
      this.$store.commit("setCurrentTab", {
        stepIdx: this.currentStep.number - 1,
        tabIdx: this.getInitalTabFromUrl()
      });
    },
    setCurrentTab(clickedTab) {
      this.$store.commit("setCurrentTab", {
        stepIdx: this.currentStep.number - 1,
        tabIdx: clickedTab
      });
      this.$nextTick(() => {
        const bbHeader = document.querySelector(".bb-header.bb-steps-big");
        if (!bbHeader) return;
        const rootStyles = getComputedStyle(document.documentElement);
        const headerHeight = parseFloat(rootStyles.getPropertyValue("--header-height")) || 0;
        const announcementBarHeight = parseFloat(rootStyles.getPropertyValue("--announcement-bar-height")) || 0;
        let stickyOffset;
        const w = window.innerWidth;
        if (w < 740) {
          stickyOffset = 30;
        } else if (w >= 740 && w <= 1e3) {
          stickyOffset = 70;
        } else {
          stickyOffset = 50;
        }
        const targetY = headerHeight + announcementBarHeight + bbHeader.offsetHeight - stickyOffset;
        if (window.scrollY > targetY) {
          window.scrollTo({ top: Math.max(0, targetY), behavior: "instant" });
        }
      });
    },
    getInitalTabFromUrl() {
      var _a;
      const url = window.location.search;
      const urlParams = new URLSearchParams(url);
      const tabFromUrlParams = Number(urlParams.get("tab")) || 0;
      const tabsLength = ((_a = this.tabs) == null ? void 0 : _a.length) ?? 0;
      const isTabFromUrlParamsValid = tabFromUrlParams > 0 && tabFromUrlParams <= tabsLength;
      return this.currentStep.number === 1 && isTabFromUrlParamsValid ? tabFromUrlParams - 1 : 0;
    }
  },
  mounted() {
    this.initCurrentTab();
  },
  computed: {
    ...mapGetters({
      currentTab: "getCurrentTab"
    }),
    currentTabIndex() {
      const index = this.tabs.findIndex((tab) => tab.current);
      return index === -1 ? 0 : index;
    }
  },
  watch: {
    currentStep(newV, old) {
      this.setCurrentTab(0);
    }
  },
  components: {
    Tab: Tab$1,
    ProductsContainer
  }
};
const _hoisted_1$i = { class: "bb-product-grid" };
const _hoisted_2$f = ["innerHTML"];
const _hoisted_3$c = {
  key: 0,
  class: "bb-product-grid__header"
};
const _hoisted_4$9 = { class: "bb-product-grid__body" };
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tab = resolveComponent("Tab");
  const _component_ProductsContainer = resolveComponent("ProductsContainer");
  return openBlock(), createElementBlock("div", _hoisted_1$i, [
    createBaseVNode("div", {
      class: "bb-product-grid__heading hidden-on-desktop",
      innerHTML: $props.currentStep.heading
    }, null, 8, _hoisted_2$f),
    $props.tabs.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_3$c, [
      createBaseVNode("div", {
        class: normalizeClass(["bb-product-grid__tabs", $props.tabs.length > 4 ? `bb-product-grid-big` : "bb-product-grid-small"]),
        ref: "tabsContainer"
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.tabs, (tab, idx) => {
          return openBlock(), createBlock(_component_Tab, {
            onSetCurrentTab: $options.setCurrentTab,
            key: idx,
            tab,
            tabIdx: idx,
            isCurrent: idx === $options.currentTabIndex,
            tabsContainer: _ctx.$refs.tabsContainer,
            hasProducts: !!(tab.variants && tab.variants.length)
          }, null, 8, ["onSetCurrentTab", "tab", "tabIdx", "isCurrent", "tabsContainer", "hasProducts"]);
        }), 128))
      ], 2)
    ])) : createCommentVNode("", true),
    createBaseVNode("div", _hoisted_4$9, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.tabs, (tab, idx) => {
        return openBlock(), createBlock(_component_ProductsContainer, {
          key: idx,
          tab,
          step: $props.currentStep
        }, null, 8, ["tab", "step"]);
      }), 128))
    ])
  ]);
}
const ProductGrid = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i]]);
const _sfc_main$h = {
  props: [
    "number",
    "title",
    /** CDN URL from Liquid (`box_builder_step.icon` file upload); empty falls back to step number */
    "stepIconUrl",
    "isPassed",
    "isPrevious",
    "isDisabled"
  ],
  data() {
    return {};
  },
  methods: {
    passTheStep() {
      if (this.isDisabled) {
        return;
      }
      this.$store.commit("setPassedStep", this.number - 1);
      this.updateUrlForStep(this.number);
    },
    updateUrlForStep(stepNumber) {
      const url = new URL(window.location.href);
      url.searchParams.set("tab", String(stepNumber));
      window.history.replaceState({}, "", url);
    }
  },
  mounted() {
  },
  computed: {
    resolvedIconUrl() {
      const u = this.stepIconUrl;
      return typeof u === "string" && u.trim() !== "" ? u : "";
    }
  },
  watch: {},
  components: {}
};
const _hoisted_1$h = { class: "bb-step__header" };
const _hoisted_2$e = {
  key: 0,
  class: "bb-step__header_number"
};
const _hoisted_3$b = ["src"];
const _hoisted_4$8 = {
  key: 1,
  class: "bb-step__header_number"
};
const _hoisted_5$8 = { class: "bb-step__headr_title label-xs" };
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.passTheStep && $options.passTheStep(...args)),
    class: normalizeClass(["bb-step", { "bb-step--active": !$props.isPrevious && $props.isPassed, "bb-step--previous": $props.isPrevious }])
  }, [
    createBaseVNode("div", _hoisted_1$h, [
      $options.resolvedIconUrl ? (openBlock(), createElementBlock("span", _hoisted_2$e, [
        createBaseVNode("img", {
          src: $options.resolvedIconUrl,
          alt: "",
          class: "bb-step__icon-img"
        }, null, 8, _hoisted_3$b)
      ])) : (openBlock(), createElementBlock("span", _hoisted_4$8, toDisplayString($props.number), 1)),
      createBaseVNode("span", _hoisted_5$8, toDisplayString($props.title), 1)
    ]),
    _cache[1] || (_cache[1] = createBaseVNode("div", { class: "bb-step__selector" }, null, -1))
  ], 2);
}
const Step = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h]]);
const DEBUG_BUILD$2 = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const GLOBAL_OBJ = globalThis;
const SDK_VERSION = "10.60.0";
function getMainCarrier() {
  getSentryCarrier(GLOBAL_OBJ);
  return GLOBAL_OBJ;
}
function getSentryCarrier(carrier) {
  const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
  __SENTRY__.version = __SENTRY__.version || SDK_VERSION;
  return __SENTRY__[SDK_VERSION] = __SENTRY__[SDK_VERSION] || {};
}
function getGlobalSingleton(name, creator, obj = GLOBAL_OBJ) {
  const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
  const carrier = __SENTRY__[SDK_VERSION] = __SENTRY__[SDK_VERSION] || {};
  return carrier[name] || (carrier[name] = creator());
}
const CONSOLE_LEVELS = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
];
const PREFIX = "Sentry Logger ";
const originalConsoleMethods = {};
function consoleSandbox(callback) {
  if (!("console" in GLOBAL_OBJ)) {
    return callback();
  }
  const console2 = GLOBAL_OBJ.console;
  const wrappedFuncs = {};
  const wrappedLevels = Object.keys(originalConsoleMethods);
  wrappedLevels.forEach((level) => {
    const originalConsoleMethod = originalConsoleMethods[level];
    wrappedFuncs[level] = console2[level];
    console2[level] = originalConsoleMethod;
  });
  try {
    return callback();
  } finally {
    wrappedLevels.forEach((level) => {
      console2[level] = wrappedFuncs[level];
    });
  }
}
function enable() {
  _getLoggerSettings().enabled = true;
}
function disable() {
  _getLoggerSettings().enabled = false;
}
function isEnabled() {
  return _getLoggerSettings().enabled;
}
function log(...args) {
  _maybeLog("log", ...args);
}
function warn(...args) {
  _maybeLog("warn", ...args);
}
function error(...args) {
  _maybeLog("error", ...args);
}
function _maybeLog(level, ...args) {
  if (!DEBUG_BUILD$2) {
    return;
  }
  if (isEnabled()) {
    consoleSandbox(() => {
      GLOBAL_OBJ.console[level](`${PREFIX}[${level}]:`, ...args);
    });
  }
}
function _getLoggerSettings() {
  if (!DEBUG_BUILD$2) {
    return { enabled: false };
  }
  return getGlobalSingleton("loggerSettings", () => ({ enabled: false }));
}
const debug = {
  /** Enable logging. */
  enable,
  /** Disable logging. */
  disable,
  /** Check if logging is enabled. */
  isEnabled,
  /** Log a message. */
  log,
  /** Log a warning. */
  warn,
  /** Log an error. */
  error
};
const STACKTRACE_FRAME_LIMIT = 50;
const UNKNOWN_FUNCTION = "?";
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b3) => a[0] - b3[0]).map((p2) => p2[1]);
  return (stack2, skipFirstLines = 0, framesToPop = 0) => {
    const frames = [];
    const lines = stack2.split("\n");
    for (let i = skipFirstLines; i < lines.length; i++) {
      let line = lines[i];
      if (line.length > 1024) {
        line = line.slice(0, 1024);
      }
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, "$1") : line;
      if (cleanedLine.includes("Error: ")) {
        continue;
      }
      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);
        if (frame) {
          frames.push(frame);
          break;
        }
      }
      if (frames.length >= STACKTRACE_FRAME_LIMIT + framesToPop) {
        break;
      }
    }
    return stripSentryFramesAndReverse(frames.slice(framesToPop));
  };
}
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}
function stripSentryFramesAndReverse(stack2) {
  if (!stack2.length) {
    return [];
  }
  const localStack = Array.from(stack2);
  if (/sentryWrapped/.test(getLastStackFrame(localStack).function || "")) {
    localStack.pop();
  }
  localStack.reverse();
  if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || "")) {
    localStack.pop();
    if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || "")) {
      localStack.pop();
    }
  }
  return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map((frame) => ({
    ...frame,
    filename: frame.filename || getLastStackFrame(localStack).filename,
    function: frame.function || UNKNOWN_FUNCTION
  }));
}
function getLastStackFrame(arr) {
  return arr[arr.length - 1] || {};
}
const defaultFunctionName = "<anonymous>";
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== "function") {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch {
    return defaultFunctionName;
  }
}
function getFramesFromEvent(event) {
  const exception = event.exception;
  if (exception) {
    const frames = [];
    try {
      exception.values.forEach((value) => {
        if (value.stacktrace.frames) {
          frames.push(...value.stacktrace.frames);
        }
      });
      return frames;
    } catch {
      return void 0;
    }
  }
  return void 0;
}
const handlers = {};
const instrumented = {};
function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  handlers[type].push(handler);
  return () => {
    const typeHandlers = handlers[type];
    if (typeHandlers) {
      const index = typeHandlers.indexOf(handler);
      if (index !== -1) {
        typeHandlers.splice(index, 1);
      }
    }
  };
}
function maybeInstrument(type, instrumentFn) {
  if (!instrumented[type]) {
    instrumented[type] = true;
    try {
      instrumentFn();
    } catch (e) {
      DEBUG_BUILD$2 && debug.error(`Error while instrumenting ${type}`, e);
    }
  }
}
function triggerHandlers(type, data) {
  const typeHandlers = type && handlers[type];
  if (!typeHandlers) {
    return;
  }
  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      DEBUG_BUILD$2 && debug.error(
        `Error while triggering instrumentation handler.
Type: ${type}
Name: ${getFunctionName(handler)}
Error:`,
        e
      );
    }
  }
}
let _oldOnErrorHandler = null;
function addGlobalErrorInstrumentationHandler(handler) {
  const type = "error";
  addHandler(type, handler);
  maybeInstrument(type, instrumentError);
}
function instrumentError() {
  _oldOnErrorHandler = GLOBAL_OBJ.onerror;
  GLOBAL_OBJ.onerror = function(msg, url, line, column, error2) {
    const handlerData = {
      column,
      error: error2,
      line,
      msg,
      url
    };
    triggerHandlers("error", handlerData);
    if (_oldOnErrorHandler) {
      return _oldOnErrorHandler.apply(this, arguments);
    }
    return false;
  };
  GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
let _oldOnUnhandledRejectionHandler = null;
function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
  const type = "unhandledrejection";
  addHandler(type, handler);
  maybeInstrument(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = GLOBAL_OBJ.onunhandledrejection;
  GLOBAL_OBJ.onunhandledrejection = function(e) {
    const handlerData = e;
    triggerHandlers("unhandledrejection", handlerData);
    if (_oldOnUnhandledRejectionHandler) {
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }
    return true;
  };
  GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
const objectToString = Object.prototype.toString;
function isError(wat) {
  switch (objectToString.call(wat)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}
function isErrorEvent$1(wat) {
  return isBuiltin(wat, "ErrorEvent");
}
function isDOMError(wat) {
  return isBuiltin(wat, "DOMError");
}
function isDOMException(wat) {
  return isBuiltin(wat, "DOMException");
}
function isString(wat) {
  return isBuiltin(wat, "String");
}
function isParameterizedString(wat) {
  return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function isPrimitive(wat) {
  return wat === null || isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function isPlainObject(wat) {
  return isBuiltin(wat, "Object");
}
function isEvent(wat) {
  return typeof Event !== "undefined" && isInstanceOf(wat, Event);
}
function isRegExp(wat) {
  return isBuiltin(wat, "RegExp");
}
function isThenable(wat) {
  return Boolean((wat == null ? void 0 : wat.then) && typeof wat.then === "function");
}
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch {
    return false;
  }
}
function isRequest(request) {
  return typeof Request !== "undefined" && isInstanceOf(request, Request);
}
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }
  const original = source[name];
  if (typeof original !== "function") {
    return;
  }
  const wrapped = replacementFactory(original);
  if (typeof wrapped === "function") {
    markFunctionWrapped(wrapped, original);
  }
  try {
    source[name] = wrapped;
  } catch {
    DEBUG_BUILD$2 && debug.log(`Failed to replace method "${name}" in object`, source);
  }
}
function addNonEnumerableProperty(obj, name, value) {
  try {
    Object.defineProperty(obj, name, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value,
      writable: true,
      configurable: true
    });
  } catch {
    DEBUG_BUILD$2 && debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
  }
}
function markFunctionWrapped(wrapped, original) {
  try {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, "__sentry_original__", original);
  } catch {
  }
}
function getOriginalFunction(func) {
  return func.__sentry_original__;
}
function convertToPlainObject(value) {
  if (isError(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value)
    };
  }
  if (isEvent(value)) {
    const { type, target, currentTarget, detail } = value;
    return {
      type,
      target,
      currentTarget,
      ...detail ? { detail } : {},
      ...getOwnProperties(value)
    };
  }
  return value;
}
function getOwnProperties(obj) {
  if (typeof obj === "object" && obj !== null) {
    return Object.fromEntries(Object.entries(obj));
  }
  return {};
}
function extractExceptionKeysForMessage(exception) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();
  return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
let RESOLVED_RUNNER;
function withRandomSafeContext(cb) {
  if (RESOLVED_RUNNER !== void 0) {
    return RESOLVED_RUNNER ? RESOLVED_RUNNER(cb) : cb();
  }
  const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
  const globalWithSymbol = GLOBAL_OBJ;
  if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
    RESOLVED_RUNNER = globalWithSymbol[sym];
    return RESOLVED_RUNNER(cb);
  }
  RESOLVED_RUNNER = null;
  return cb();
}
function safeMathRandom() {
  return withRandomSafeContext(() => Math.random());
}
function safeDateNow() {
  return withRandomSafeContext(() => Date.now());
}
const SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function hasSkipNormalizationHint(value) {
  return Boolean(value[SENTRY_SKIP_NORMALIZATION]);
}
function getNormalizationDepthOverrideHint(value) {
  const v = value[SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
  return typeof v === "number" ? v : void 0;
}
let stringifier;
function setNormalizeStringifier(newStringifier) {
  stringifier = newStringifier;
}
function normalize(input, depth = 100, maxProperties = Infinity) {
  try {
    return visit("", input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}
function normalizeToSize(object, depth = 3, maxSize = 100 * 1024) {
  const normalized = normalize(object, depth);
  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }
  return normalized;
}
function visit(key, value, depth = Infinity, maxProperties = Infinity, memo = memoBuilder()) {
  const [memoize, unmemoize] = memo;
  if (value == null || // this matches null and undefined -> eqeq not eqeqeq
  ["boolean", "string"].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  const stringified = stringifyValue(key, value);
  if (!stringified.startsWith("[object ")) {
    return stringified;
  }
  if (hasSkipNormalizationHint(value)) {
    return value;
  }
  const overrideDepth = getNormalizationDepthOverrideHint(value);
  const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
  if (remainingDepth === 0) {
    return stringified.replace("object ", "");
  }
  if (memoize(value)) {
    return "[Circular ~]";
  }
  const valueWithToJSON = value;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      return visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch {
    }
  }
  const normalized = Array.isArray(value) ? [] : {};
  let numAdded = 0;
  const visitable = convertToPlainObject(value);
  for (const visitKey in visitable) {
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }
    if (numAdded >= maxProperties) {
      normalized[visitKey] = "[MaxProperties ~]";
      break;
    }
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
    numAdded++;
  }
  unmemoize(value);
  return normalized;
}
function stringifyValue(key, value) {
  try {
    if (stringifier) {
      const stringified = stringifier(value);
      if (stringified) {
        return stringified;
      }
    }
    if (typeof global !== "undefined" && value === global) {
      return "[Global]";
    }
    if (typeof value === "number" && !Number.isFinite(value)) {
      return `[${value}]`;
    }
    if (typeof value === "function") {
      return `[Function: ${getFunctionName(value)}]`;
    }
    if (typeof value === "symbol") {
      return `[${String(value)}]`;
    }
    if (typeof value === "bigint") {
      return `[BigInt: ${String(value)}]`;
    }
    const objName = getConstructorName$1(value);
    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
function getConstructorName$1(value) {
  const prototype = Object.getPrototypeOf(value);
  return (prototype == null ? void 0 : prototype.constructor) ? prototype.constructor.name : "null prototype";
}
function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}
function memoBuilder() {
  const inner = /* @__PURE__ */ new WeakSet();
  function memoize(obj) {
    if (inner.has(obj)) {
      return true;
    }
    inner.add(obj);
    return false;
  }
  function unmemoize(obj) {
    inner.delete(obj);
  }
  return [memoize, unmemoize];
}
function truncate(str, max = 0) {
  if (typeof str !== "string" || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return "";
  }
  const output = [];
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    if (isPrimitive(value)) {
      output.push(String(value));
    } else if (value instanceof Error) {
      output.push(value.message ? `${value.name}: ${value.message}` : value.name);
    } else {
      output.push(stringifyValue(void 0, value));
    }
  }
  return output.join(delimiter);
}
function isMatchingPattern(value, pattern, requireExactStringMatch = false) {
  if (!isString(value)) {
    return false;
  }
  if (isRegExp(pattern)) {
    return pattern.test(value);
  }
  if (isString(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }
  if (typeof pattern === "function") {
    return pattern(value);
  }
  return false;
}
function stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
  for (const pattern of patterns) {
    if (isMatchingPattern(testString, pattern, requireExactStringMatch)) {
      return true;
    }
  }
  return false;
}
function getCrypto() {
  const gbl = GLOBAL_OBJ;
  return gbl.crypto || gbl.msCrypto;
}
let emptyUuid;
function getRandomByte() {
  return safeMathRandom() * 16;
}
function uuid4(crypto2 = getCrypto()) {
  try {
    if (crypto2 == null ? void 0 : crypto2.randomUUID) {
      return withRandomSafeContext(() => crypto2.randomUUID()).replace(/-/g, "");
    }
  } catch {
  }
  if (!emptyUuid) {
    emptyUuid = "10000000100040008000" + 1e11;
  }
  return emptyUuid.replace(
    /[018]/g,
    (c) => (
      // eslint-disable-next-line no-bitwise
      (c ^ (getRandomByte() & 15) >> c / 4).toString(16)
    )
  );
}
function getFirstException(event) {
  var _a, _b;
  return (_b = (_a = event.exception) == null ? void 0 : _a.values) == null ? void 0 : _b[0];
}
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }
  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || "<unknown>";
  }
  return eventId || "<unknown>";
}
function addExceptionTypeValue(event, value, type) {
  const exception = event.exception = event.exception || {};
  const values = exception.values = exception.values || [];
  const firstException = values[0] = values[0] || {};
  if (!firstException.value) {
    firstException.value = value || "";
  }
  if (!firstException.type) {
    firstException.type = "Error";
  }
}
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }
  const defaultMechanism = { type: "generic", handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };
  if (newMechanism && "data" in newMechanism) {
    const mergedData = { ...currentMechanism == null ? void 0 : currentMechanism.data, ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}
function checkOrSetAlreadyCaught(exception) {
  if (isAlreadyCaptured(exception)) {
    return true;
  }
  try {
    addNonEnumerableProperty(exception, "__sentry_captured__", true);
  } catch {
  }
  return false;
}
function isAlreadyCaptured(exception) {
  try {
    return exception.__sentry_captured__;
  } catch {
  }
}
const ONE_SECOND_IN_MS = 1e3;
function dateTimestampInSeconds() {
  return safeDateNow() / ONE_SECOND_IN_MS;
}
function createUnixTimestampInSecondsFunc() {
  const { performance: performance2 } = GLOBAL_OBJ;
  if (!(performance2 == null ? void 0 : performance2.now) || !performance2.timeOrigin) {
    return dateTimestampInSeconds;
  }
  const timeOrigin = performance2.timeOrigin;
  return () => {
    return (timeOrigin + withRandomSafeContext(() => performance2.now())) / ONE_SECOND_IN_MS;
  };
}
let _cachedTimestampInSeconds;
function timestampInSeconds() {
  const func = _cachedTimestampInSeconds ?? (_cachedTimestampInSeconds = createUnixTimestampInSecondsFunc());
  return func();
}
function makeSession(context) {
  const startingTime = timestampInSeconds();
  const session = {
    sid: uuid4(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session)
  };
  if (context) {
    updateSession(session, context);
  }
  return session;
}
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }
    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }
  session.timestamp = context.timestamp || timestampInSeconds();
  if (context.abnormal_mechanism) {
    session.abnormal_mechanism = context.abnormal_mechanism;
  }
  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    session.sid = context.sid.length === 32 ? context.sid : uuid4();
  }
  if (context.init !== void 0) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === "number") {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = void 0;
  } else if (typeof context.duration === "number") {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === "number") {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}
function closeSession(session, status) {
  let context = {};
  if (session.status === "ok") {
    context = { status: "exited" };
  }
  updateSession(session, context);
}
function sessionToJSON(session) {
  return {
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1e3).toISOString(),
    timestamp: new Date(session.timestamp * 1e3).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
    duration: session.duration,
    abnormal_mechanism: session.abnormal_mechanism,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent
    }
  };
}
function merge(initialObj, mergeObj, levels = 2) {
  if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) {
    return mergeObj;
  }
  if (initialObj && Object.keys(mergeObj).length === 0) {
    return initialObj;
  }
  const output = { ...initialObj };
  for (const key in mergeObj) {
    if (Object.prototype.hasOwnProperty.call(mergeObj, key)) {
      output[key] = merge(output[key], mergeObj[key], levels - 1);
    }
  }
  return output;
}
function generateTraceId() {
  return uuid4();
}
function generateSpanId() {
  return uuid4().substring(16);
}
function makeWeakRef(value) {
  try {
    const WeakRefImpl = GLOBAL_OBJ.WeakRef;
    if (typeof WeakRefImpl === "function") {
      return new WeakRefImpl(value);
    }
  } catch {
  }
  return value;
}
function derefWeakRef(ref2) {
  if (!ref2) {
    return void 0;
  }
  if (typeof ref2 === "object" && "deref" in ref2 && typeof ref2.deref === "function") {
    try {
      return ref2.deref();
    } catch {
      return void 0;
    }
  }
  return ref2;
}
const SCOPE_SPAN_FIELD = "_sentrySpan";
function _setSpanForScope(scope, span) {
  if (span) {
    addNonEnumerableProperty(scope, SCOPE_SPAN_FIELD, makeWeakRef(span));
  } else {
    delete scope[SCOPE_SPAN_FIELD];
  }
}
function _getSpanForScope(scope) {
  return derefWeakRef(scope[SCOPE_SPAN_FIELD]);
}
const DEFAULT_MAX_BREADCRUMBS = 100;
class Scope {
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._attributes = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = {
      traceId: generateTraceId(),
      sampleRand: safeMathRandom()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const newScope = new Scope();
    newScope._breadcrumbs = [...this._breadcrumbs];
    newScope._tags = { ...this._tags };
    newScope._attributes = { ...this._attributes };
    newScope._extra = { ...this._extra };
    newScope._contexts = { ...this._contexts };
    if (this._contexts.flags) {
      newScope._contexts.flags = {
        values: [...this._contexts.flags.values]
      };
    }
    newScope._user = this._user;
    newScope._level = this._level;
    newScope._session = this._session;
    newScope._transactionName = this._transactionName;
    newScope._fingerprint = this._fingerprint;
    newScope._eventProcessors = [...this._eventProcessors];
    newScope._attachments = [...this._attachments];
    newScope._sdkProcessingMetadata = { ...this._sdkProcessingMetadata };
    newScope._propagationContext = { ...this._propagationContext };
    newScope._client = this._client;
    newScope._lastEventId = this._lastEventId;
    newScope._conversationId = this._conversationId;
    _setSpanForScope(newScope, _getSpanForScope(this));
    return newScope;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(client) {
    this._client = client;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(lastEventId) {
    this._lastEventId = lastEventId;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(user) {
    this._user = user || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    };
    if (this._session) {
      updateSession(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */
  setConversationId(conversationId) {
    this._conversationId = conversationId || void 0;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags
    };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(key, value) {
    return this.setTags({ [key]: value });
  }
  /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */
  setAttributes(newAttributes) {
    this._attributes = {
      ...this._attributes,
      ...newAttributes
    };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setAttribute(key, value) {
    return this.setAttributes({ [key]: value });
  }
  /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */
  removeAttribute(key) {
    if (key in this._attributes) {
      delete this._attributes[key];
      this._notifyScopeListeners();
    }
    return this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras
    };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(level) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(key, context) {
    if (context === null) {
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(captureContext) {
    if (!captureContext) {
      return this;
    }
    const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
    const scopeInstance = scopeToMerge instanceof Scope ? scopeToMerge.getScopeData() : isPlainObject(scopeToMerge) ? captureContext : void 0;
    const {
      tags,
      attributes,
      extra,
      user,
      contexts,
      level,
      fingerprint = [],
      propagationContext,
      conversationId
    } = scopeInstance || {};
    this._tags = { ...this._tags, ...tags };
    this._attributes = { ...this._attributes, ...attributes };
    this._extra = { ...this._extra, ...extra };
    this._contexts = { ...this._contexts, ...contexts };
    if (user && Object.keys(user).length) {
      this._user = user;
    }
    if (level) {
      this._level = level;
    }
    if (fingerprint.length) {
      this._fingerprint = fingerprint;
    }
    if (propagationContext) {
      this._propagationContext = propagationContext;
    }
    if (conversationId) {
      this._conversationId = conversationId;
    }
    return this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._attributes = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = void 0;
    this._transactionName = void 0;
    this._fingerprint = void 0;
    this._session = void 0;
    this._conversationId = void 0;
    _setSpanForScope(this, void 0);
    this._attachments = [];
    this.setPropagationContext({
      traceId: generateTraceId(),
      sampleRand: safeMathRandom()
    });
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    var _a;
    const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
    if (maxCrumbs <= 0) {
      return this;
    }
    const mergedBreadcrumb = {
      timestamp: dateTimestampInSeconds(),
      ...breadcrumb,
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: breadcrumb.message ? truncate(breadcrumb.message, 2048) : breadcrumb.message
    };
    this._breadcrumbs.push(mergedBreadcrumb);
    if (this._breadcrumbs.length > maxCrumbs) {
      this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
      (_a = this._client) == null ? void 0 : _a.recordDroppedEvent("buffer_overflow", "log_item");
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    this._attachments = [];
    return this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      attributes: this._attributes,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: _getSpanForScope(this),
      conversationId: this._conversationId
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = merge(this._sdkProcessingMetadata, newData, 2);
    return this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(context) {
    this._propagationContext = context;
    return this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(exception, hint) {
    const eventId = (hint == null ? void 0 : hint.event_id) || uuid4();
    if (!this._client) {
      DEBUG_BUILD$2 && debug.warn("No client configured on scope - will not capture exception!");
      return eventId;
    }
    const syntheticException = new Error("Sentry syntheticException");
    this._client.captureException(
      exception,
      {
        originalException: exception,
        syntheticException,
        ...hint,
        event_id: eventId
      },
      this
    );
    return eventId;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(message, level, hint) {
    const eventId = (hint == null ? void 0 : hint.event_id) || uuid4();
    if (!this._client) {
      DEBUG_BUILD$2 && debug.warn("No client configured on scope - will not capture message!");
      return eventId;
    }
    const syntheticException = (hint == null ? void 0 : hint.syntheticException) ?? new Error(message);
    this._client.captureMessage(
      message,
      level,
      {
        originalException: message,
        syntheticException,
        ...hint,
        event_id: eventId
      },
      this
    );
    return eventId;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(event, hint) {
    const eventId = event.event_id || (hint == null ? void 0 : hint.event_id) || uuid4();
    if (!this._client) {
      DEBUG_BUILD$2 && debug.warn("No client configured on scope - will not capture event!");
      return eventId;
    }
    this._client.captureEvent(event, { ...hint, event_id: eventId }, this);
    return eventId;
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach((callback) => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }
}
function getDefaultCurrentScope() {
  return getGlobalSingleton("defaultCurrentScope", () => new Scope());
}
function getDefaultIsolationScope() {
  return getGlobalSingleton("defaultIsolationScope", () => new Scope());
}
const isActualPromise = (p2) => p2 instanceof Promise && !p2[kChainedCopy];
const kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const chainAndCopyPromiseLike = (original, onSuccess, onError) => {
  const chained = original.then(
    (value) => {
      onSuccess(value);
      return value;
    },
    (err) => {
      onError(err);
      throw err;
    }
  );
  return isActualPromise(chained) && isActualPromise(original) ? chained : copyProps(original, chained);
};
const copyProps = (original, chained) => {
  if (!chained) return original;
  let mutated = false;
  for (const key in original) {
    if (key in chained) continue;
    mutated = true;
    const value = original[key];
    if (typeof value === "function") {
      Object.defineProperty(chained, key, {
        value: (...args) => value.apply(original, args),
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      chained[key] = value;
    }
  }
  if (mutated) Object.assign(chained, { [kChainedCopy]: true });
  return chained;
};
class AsyncContextStack {
  constructor(scope, isolationScope) {
    let assignedScope;
    if (!scope) {
      assignedScope = new Scope();
    } else {
      assignedScope = scope;
    }
    let assignedIsolationScope;
    if (!isolationScope) {
      assignedIsolationScope = new Scope();
    } else {
      assignedIsolationScope = isolationScope;
    }
    this._stack = [{ scope: assignedScope }];
    this._isolationScope = assignedIsolationScope;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(callback) {
    const scope = this._pushScope();
    let maybePromiseResult;
    try {
      maybePromiseResult = callback(scope);
    } catch (e) {
      this._popScope();
      throw e;
    }
    if (isThenable(maybePromiseResult)) {
      return chainAndCopyPromiseLike(
        maybePromiseResult,
        () => this._popScope(),
        () => this._popScope()
      );
    }
    this._popScope();
    return maybePromiseResult;
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const scope = this.getScope().clone();
    this._stack.push({
      client: this.getClient(),
      scope
    });
    return scope;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    if (this._stack.length <= 1) return false;
    return !!this._stack.pop();
  }
}
function getAsyncContextStack() {
  const registry = getMainCarrier();
  const sentry = getSentryCarrier(registry);
  return sentry.stack = sentry.stack || new AsyncContextStack(getDefaultCurrentScope(), getDefaultIsolationScope());
}
function withScope$1(callback) {
  return getAsyncContextStack().withScope(callback);
}
function withSetScope(scope, callback) {
  const stack2 = getAsyncContextStack();
  return stack2.withScope(() => {
    stack2.getStackTop().scope = scope;
    return callback(scope);
  });
}
function withIsolationScope(callback) {
  return getAsyncContextStack().withScope(() => {
    return callback(getAsyncContextStack().getIsolationScope());
  });
}
function getStackAsyncContextStrategy() {
  return {
    withIsolationScope,
    withScope: withScope$1,
    withSetScope,
    withSetIsolationScope: (_isolationScope, callback) => {
      return withIsolationScope(callback);
    },
    getCurrentScope: () => getAsyncContextStack().getScope(),
    getIsolationScope: () => getAsyncContextStack().getIsolationScope()
  };
}
function getAsyncContextStrategy(carrier) {
  const sentry = getSentryCarrier(carrier);
  if (sentry.acs) {
    return sentry.acs;
  }
  return getStackAsyncContextStrategy();
}
function isAttributeObject(maybeObj) {
  return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function attributeValueToTypedAttributeValue(rawValue, useFallback) {
  const { value, unit } = isAttributeObject(rawValue) ? rawValue : { value: rawValue, unit: void 0 };
  const attributeValue = getTypedAttributeValue(value);
  const checkedUnit = unit && typeof unit === "string" ? { unit } : {};
  if (attributeValue) {
    return { ...attributeValue, ...checkedUnit };
  }
  if (!useFallback || useFallback === "skip-undefined" && value === void 0) {
    return;
  }
  let stringValue = "";
  try {
    stringValue = JSON.stringify(value) ?? "";
  } catch {
  }
  return {
    value: stringValue,
    type: "string",
    ...checkedUnit
  };
}
function serializeAttributes(attributes, fallback = false) {
  const serializedAttributes = {};
  for (const [key, value] of Object.entries(attributes ?? {})) {
    const typedValue = attributeValueToTypedAttributeValue(value, fallback);
    if (typedValue) {
      serializedAttributes[key] = typedValue;
    }
  }
  return serializedAttributes;
}
function getTypedAttributeValue(value) {
  if (Array.isArray(value)) {
    return { value, type: "array" };
  }
  const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
  if (primitiveType) {
    return { value, type: primitiveType };
  }
}
function getCurrentScope() {
  const carrier = getMainCarrier();
  const acs = getAsyncContextStrategy(carrier);
  return acs.getCurrentScope();
}
function getIsolationScope() {
  const carrier = getMainCarrier();
  const acs = getAsyncContextStrategy(carrier);
  return acs.getIsolationScope();
}
function getGlobalScope() {
  return getGlobalSingleton("globalScope", () => new Scope());
}
function withScope(...rest) {
  const carrier = getMainCarrier();
  const acs = getAsyncContextStrategy(carrier);
  if (rest.length === 2) {
    const [scope, callback] = rest;
    if (!scope) {
      return acs.withScope(callback);
    }
    return acs.withSetScope(scope, callback);
  }
  return acs.withScope(rest[0]);
}
function getClient() {
  return getCurrentScope().getClient();
}
function getTraceContextFromScope(scope) {
  const propagationContext = scope.getPropagationContext();
  const { traceId, parentSpanId, propagationSpanId } = propagationContext;
  const traceContext = {
    trace_id: traceId,
    span_id: propagationSpanId || generateSpanId()
  };
  if (parentSpanId) {
    traceContext.parent_span_id = parentSpanId;
  }
  return traceContext;
}
const SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const SPAN_STATUS_UNSET = 0;
const SPAN_STATUS_OK = 1;
const SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function getCapturedScopesOnSpan(span) {
  const spanWithScopes = span;
  return {
    scope: spanWithScopes[SCOPE_ON_START_SPAN_FIELD],
    isolationScope: derefWeakRef(spanWithScopes[ISOLATION_SCOPE_ON_START_SPAN_FIELD])
  };
}
const SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
function baggageHeaderToDynamicSamplingContext(baggageHeader) {
  const baggageObject = parseBaggageHeader(baggageHeader);
  if (!baggageObject) {
    return void 0;
  }
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.startsWith(SENTRY_BAGGAGE_KEY_PREFIX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext;
  } else {
    return void 0;
  }
}
function parseBaggageHeader(baggageHeader) {
  if (!baggageHeader || !isString(baggageHeader) && !Array.isArray(baggageHeader)) {
    return void 0;
  }
  if (Array.isArray(baggageHeader)) {
    return baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      Object.entries(currBaggageObject).forEach(([key, value]) => {
        acc[key] = value;
      });
      return acc;
    }, {});
  }
  return baggageHeaderToObject(baggageHeader);
}
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader.split(",").map((baggageEntry) => {
    const eqIdx = baggageEntry.indexOf("=");
    if (eqIdx === -1) {
      return [];
    }
    const key = baggageEntry.slice(0, eqIdx);
    const value = baggageEntry.slice(eqIdx + 1);
    return [key, value].map((keyOrValue) => {
      try {
        return decodeURIComponent(keyOrValue.trim());
      } catch {
        return;
      }
    });
  }).reduce((acc, [key, value]) => {
    if (key && value) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
const ORG_ID_REGEX = /^o(\d+)\./;
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
  return protocol === "http" || protocol === "https";
}
function dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);
  if (!match) {
    consoleSandbox(() => {
      console.error(`Invalid Sentry Dsn: ${str}`);
    });
    return void 0;
  }
  const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
  let path = "";
  let projectId = lastPath;
  const split = projectId.split("/");
  if (split.length > 1) {
    path = split.slice(0, -1).join("/");
    projectId = split.pop();
  }
  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }
  return dsnFromComponents({ host, pass, path, projectId, port, protocol, publicKey });
}
function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || "",
    pass: components.pass || "",
    host: components.host,
    port: components.port || "",
    path: components.path || "",
    projectId: components.projectId
  };
}
function validateDsn(dsn) {
  if (!DEBUG_BUILD$2) {
    return true;
  }
  const { port, projectId, protocol } = dsn;
  const requiredComponents = ["protocol", "publicKey", "host", "projectId"];
  const hasMissingRequiredComponent = requiredComponents.find((component) => {
    if (!dsn[component]) {
      debug.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });
  if (hasMissingRequiredComponent) {
    return false;
  }
  if (!projectId.match(/^\d+$/)) {
    debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }
  if (!isValidProtocol(protocol)) {
    debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }
  if (port && isNaN(parseInt(port, 10))) {
    debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }
  return true;
}
function extractOrgIdFromDsnHost(host) {
  const match = host.match(ORG_ID_REGEX);
  return match == null ? void 0 : match[1];
}
function extractOrgIdFromClient(client) {
  const options = client.getOptions();
  const { host } = client.getDsn() || {};
  let org_id;
  if (options.orgId) {
    org_id = String(options.orgId);
  } else if (host) {
    org_id = extractOrgIdFromDsnHost(host);
  }
  return org_id;
}
function makeDsn(from) {
  const components = typeof from === "string" ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return void 0;
  }
  return components;
}
function parseSampleRate(sampleRate) {
  if (typeof sampleRate === "boolean") {
    return Number(sampleRate);
  }
  const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
  if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
    return void 0;
  }
  return rate;
}
const TRACE_FLAG_SAMPLED = 1;
let hasShownSpanDropWarning = false;
function spanToTraceContext(span) {
  const { spanId, traceId: trace_id, isRemote } = span.spanContext();
  const parent_span_id = isRemote ? spanId : spanToJSON(span).parent_span_id;
  const scope = getCapturedScopesOnSpan(span).scope;
  const span_id = isRemote ? (scope == null ? void 0 : scope.getPropagationContext().propagationSpanId) || generateSpanId() : spanId;
  return {
    parent_span_id,
    span_id,
    trace_id
  };
}
function convertSpanLinksForEnvelope(links) {
  if (links && links.length > 0) {
    return links.map(({ context: { spanId, traceId, traceFlags, ...restContext }, attributes }) => ({
      span_id: spanId,
      trace_id: traceId,
      sampled: traceFlags === TRACE_FLAG_SAMPLED,
      attributes,
      ...restContext
    }));
  } else {
    return void 0;
  }
}
function spanTimeInputToSeconds(input) {
  if (typeof input === "number") {
    return ensureTimestampInSeconds(input);
  }
  if (Array.isArray(input)) {
    return input[0] + input[1] / 1e9;
  }
  if (input instanceof Date) {
    return ensureTimestampInSeconds(input.getTime());
  }
  return timestampInSeconds();
}
function ensureTimestampInSeconds(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1e3 : timestamp;
}
function spanToJSON(span) {
  if (spanIsSentrySpan(span)) {
    return span.getSpanJSON();
  }
  const { spanId: span_id, traceId: trace_id } = span.spanContext();
  if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
    const { attributes, startTime, name, endTime, status, links } = span;
    return {
      span_id,
      trace_id,
      data: attributes,
      description: name,
      parent_span_id: getOtelParentSpanId(span),
      start_timestamp: spanTimeInputToSeconds(startTime),
      // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
      timestamp: spanTimeInputToSeconds(endTime) || void 0,
      status: getStatusMessage(status),
      op: attributes[SEMANTIC_ATTRIBUTE_SENTRY_OP],
      origin: attributes[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
      links: convertSpanLinksForEnvelope(links)
    };
  }
  return {
    span_id,
    trace_id,
    start_timestamp: 0,
    data: {}
  };
}
function getOtelParentSpanId(span) {
  var _a;
  return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? (_a = span.parentSpanContext) == null ? void 0 : _a.spanId : void 0;
}
function streamedSpanJsonToSerializedSpan(spanJson) {
  var _a;
  return {
    ...spanJson,
    attributes: serializeAttributes(spanJson.attributes),
    links: (_a = spanJson.links) == null ? void 0 : _a.map((link) => ({
      ...link,
      attributes: serializeAttributes(link.attributes)
    }))
  };
}
function spanIsOpenTelemetrySdkTraceBaseSpan(span) {
  const castSpan = span;
  return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function spanIsSentrySpan(span) {
  return typeof span.getSpanJSON === "function";
}
function spanIsSampled(span) {
  const { traceFlags } = span.spanContext();
  return traceFlags === TRACE_FLAG_SAMPLED;
}
function getStatusMessage(status) {
  if (!status || status.code === SPAN_STATUS_UNSET) {
    return void 0;
  }
  if (status.code === SPAN_STATUS_OK) {
    return "ok";
  }
  return status.message || "internal_error";
}
const ROOT_SPAN_FIELD = "_sentryRootSpan";
const getRootSpan = INTERNAL_getSegmentSpan;
function INTERNAL_getSegmentSpan(span) {
  return span[ROOT_SPAN_FIELD] || span;
}
function showSpanDropWarning() {
  if (!hasShownSpanDropWarning) {
    consoleSandbox(() => {
      console.warn(
        "[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`."
      );
    });
    hasShownSpanDropWarning = true;
  }
}
function hasSpansEnabled(maybeOptions) {
  var _a;
  if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) {
    return false;
  }
  const options = maybeOptions || ((_a = getClient()) == null ? void 0 : _a.getOptions());
  return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
  (options.tracesSampleRate != null || !!options.tracesSampler);
}
function logIgnoredSpan(droppedSpan) {
  debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function shouldIgnoreSpan(span, ignoreSpans) {
  if (!(ignoreSpans == null ? void 0 : ignoreSpans.length)) {
    return false;
  }
  for (const pattern of ignoreSpans) {
    if (isStringOrRegExp(pattern)) {
      if (span.description && isMatchingPattern(span.description, pattern)) {
        DEBUG_BUILD$2 && logIgnoredSpan(span);
        return true;
      }
      continue;
    }
    const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
    if (!pattern.name && !pattern.op && !hasAttributes) {
      continue;
    }
    const nameMatches = pattern.name ? span.description && isMatchingPattern(span.description, pattern.name) : true;
    const opMatches = pattern.op ? span.op && isMatchingPattern(span.op, pattern.op) : true;
    const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(
      ([key, valuePattern]) => {
        var _a;
        return _matchesAttributeValue((_a = span.attributes) == null ? void 0 : _a[key], valuePattern);
      }
    ) : true;
    if (nameMatches && opMatches && attrsMatch) {
      DEBUG_BUILD$2 && logIgnoredSpan(span);
      return true;
    }
  }
  return false;
}
function _matchesAttributeValue(actual, pat) {
  if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) {
    return isMatchingPattern(actual, pat);
  }
  if (Array.isArray(actual) && Array.isArray(pat)) {
    return actual.length === pat.length && actual.every((v, i) => v === pat[i]);
  }
  return actual === pat;
}
function reparentChildSpans(spans, dropSpan) {
  const droppedSpanParentId = dropSpan.parent_span_id;
  const droppedSpanId = dropSpan.span_id;
  if (!droppedSpanParentId) {
    return;
  }
  for (const span of spans) {
    if (span.parent_span_id === droppedSpanId) {
      span.parent_span_id = droppedSpanParentId;
    }
  }
}
function isStringOrRegExp(value) {
  return typeof value === "string" || value instanceof RegExp;
}
const NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
function spanIsNonRecordingSpan(span) {
  return !!span && span[NON_RECORDING_SPAN_FIELD] === true;
}
const DEFAULT_ENVIRONMENT = "production";
const FROZEN_DSC_FIELD = "_frozenDsc";
function getDynamicSamplingContextFromClient(trace_id, client) {
  const options = client.getOptions();
  const { publicKey: public_key } = client.getDsn() || {};
  const dsc = {
    environment: options.environment || DEFAULT_ENVIRONMENT,
    release: options.release,
    public_key,
    trace_id,
    org_id: extractOrgIdFromClient(client)
  };
  client.emit("createDsc", dsc);
  return dsc;
}
function getDynamicSamplingContextFromScope(client, scope) {
  const propagationContext = scope.getPropagationContext();
  return propagationContext.dsc || getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function getDynamicSamplingContextFromSpan(span) {
  var _a;
  const client = getClient();
  if (!client) {
    return {};
  }
  const rootSpan = getRootSpan(span);
  const rootSpanJson = spanToJSON(rootSpan);
  const rootSpanAttributes = rootSpanJson.data;
  const traceState = rootSpan.spanContext().traceState;
  const rootSpanSampleRate = (traceState == null ? void 0 : traceState.get("sentry.sample_rate")) ?? rootSpanAttributes[SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
  function applyLocalSampleRateToDsc(dsc2) {
    if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") {
      dsc2.sample_rate = `${rootSpanSampleRate}`;
    }
    return dsc2;
  }
  const frozenDsc = rootSpan[FROZEN_DSC_FIELD];
  if (frozenDsc) {
    return applyLocalSampleRateToDsc(frozenDsc);
  }
  if (spanIsNonRecordingSpan(rootSpan) && !hasSpansEnabled(client.getOptions())) {
    const capturedScope = getCapturedScopesOnSpan(rootSpan).scope;
    if (capturedScope) {
      return applyLocalSampleRateToDsc({ ...getDynamicSamplingContextFromScope(client, capturedScope) });
    }
  }
  const traceStateDsc = traceState == null ? void 0 : traceState.get("sentry.dsc");
  const dscOnTraceState = traceStateDsc && baggageHeaderToDynamicSamplingContext(traceStateDsc);
  if (dscOnTraceState) {
    return applyLocalSampleRateToDsc(dscOnTraceState);
  }
  const dsc = getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
  const source = rootSpanAttributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.span.source"];
  const name = rootSpanJson.description;
  if (source !== "url" && name) {
    dsc.transaction = name;
  }
  if (hasSpansEnabled()) {
    dsc.sampled = String(spanIsSampled(rootSpan));
    dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
    // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
    (traceState == null ? void 0 : traceState.get("sentry.sample_rand")) ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
    ((_a = getCapturedScopesOnSpan(rootSpan).scope) == null ? void 0 : _a.getPropagationContext().sampleRand.toString());
  }
  applyLocalSampleRateToDsc(dsc);
  client.emit("createDsc", dsc, rootSpan);
  return dsc;
}
function isStreamedBeforeSendSpanCallback(callback) {
  return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
function createEnvelope(headers, items = []) {
  return [headers, items];
}
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]];
}
function forEachEnvelopeItem(envelope, callback) {
  const envelopeItems = envelope[1];
  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);
    if (result) {
      return true;
    }
  }
  return false;
}
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}
function encodeUTF8(input) {
  const carrier = getSentryCarrier(GLOBAL_OBJ);
  return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function serializeEnvelope(envelope) {
  const [envHeaders, items] = envelope;
  let parts = JSON.stringify(envHeaders);
  function append(next) {
    if (typeof parts === "string") {
      parts = typeof next === "string" ? parts + next : [encodeUTF8(parts), next];
    } else {
      parts.push(typeof next === "string" ? encodeUTF8(next) : next);
    }
  }
  for (const item of items) {
    const [itemHeaders, payload] = item;
    append(`
${JSON.stringify(itemHeaders)}
`);
    if (typeof payload === "string" || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch {
        stringifiedPayload = JSON.stringify(normalize(payload));
      }
      append(stringifiedPayload);
    }
  }
  return typeof parts === "string" ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);
  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }
  return merged;
}
function createAttachmentEnvelopeItem(attachment) {
  const buffer = typeof attachment.data === "string" ? encodeUTF8(attachment.data) : attachment.data;
  return [
    {
      type: "attachment",
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType
    },
    buffer
  ];
}
const DATA_CATEGORY_OVERRIDES = {
  sessions: "session",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile_chunk: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  raw_security: "security",
  log: "log_item",
  trace_metric: "metric"
};
function _isOverriddenType(type) {
  return type in DATA_CATEGORY_OVERRIDES;
}
function envelopeItemTypeToDataCategory(type) {
  return _isOverriddenType(type) ? DATA_CATEGORY_OVERRIDES[type] : type;
}
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!(metadataOrEvent == null ? void 0 : metadataOrEvent.sdk)) {
    return;
  }
  const { name, version: version2 } = metadataOrEvent.sdk;
  return { name, version: version2 };
}
function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
  var _a;
  const dynamicSamplingContext = (_a = event.sdkProcessingMetadata) == null ? void 0 : _a.dynamicSamplingContext;
  return {
    event_id: event.event_id,
    sent_at: new Date(safeDateNow()).toISOString(),
    ...sdkInfo && { sdk: sdkInfo },
    ...!!tunnel && dsn && { dsn: dsnToString(dsn) },
    ...dynamicSamplingContext && {
      trace: dynamicSamplingContext
    }
  };
}
function _enhanceEventWithSdkInfo(event, newSdkInfo) {
  var _a, _b, _c, _d;
  if (!newSdkInfo) {
    return event;
  }
  const eventSdkInfo = event.sdk || {};
  event.sdk = {
    ...eventSdkInfo,
    name: eventSdkInfo.name || newSdkInfo.name,
    version: eventSdkInfo.version || newSdkInfo.version,
    integrations: [...((_a = event.sdk) == null ? void 0 : _a.integrations) || [], ...newSdkInfo.integrations || []],
    packages: [...((_b = event.sdk) == null ? void 0 : _b.packages) || [], ...newSdkInfo.packages || []],
    settings: ((_c = event.sdk) == null ? void 0 : _c.settings) || newSdkInfo.settings ? {
      ...(_d = event.sdk) == null ? void 0 : _d.settings,
      ...newSdkInfo.settings
    } : void 0
  };
  return event;
}
function createSessionEnvelope(session, dsn, metadata, tunnel) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date(safeDateNow()).toISOString(),
    ...sdkInfo && { sdk: sdkInfo },
    ...!!tunnel && dsn && { dsn: dsnToString(dsn) }
  };
  const envelopeItem = "aggregates" in session ? [{ type: "sessions" }, session] : [{ type: "session" }, session.toJSON()];
  return createEnvelope(envelopeHeaders, [envelopeItem]);
}
function createEventEnvelope(event, dsn, metadata, tunnel) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
  _enhanceEventWithSdkInfo(event, metadata == null ? void 0 : metadata.sdk);
  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
  delete event.sdkProcessingMetadata;
  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}
function hasSpanStreamingEnabled(client) {
  return client.getOptions().traceLifecycle === "stream";
}
function applyScopeDataToEvent(event, data) {
  const { fingerprint, span, breadcrumbs, sdkProcessingMetadata } = data;
  applyDataToEvent(event, data);
  if (span) {
    applySpanToEvent(event, span);
  }
  applyFingerprintToEvent(event, fingerprint);
  applyBreadcrumbsToEvent(event, breadcrumbs);
  applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function mergeScopeData(data, mergeData) {
  const {
    extra,
    tags,
    attributes,
    user,
    contexts,
    level,
    sdkProcessingMetadata,
    breadcrumbs,
    fingerprint,
    eventProcessors,
    attachments,
    propagationContext,
    transactionName,
    span
  } = mergeData;
  mergeAndOverwriteScopeData(data, "extra", extra);
  mergeAndOverwriteScopeData(data, "tags", tags);
  mergeAndOverwriteScopeData(data, "attributes", attributes);
  mergeAndOverwriteScopeData(data, "user", user);
  mergeAndOverwriteScopeData(data, "contexts", contexts);
  data.sdkProcessingMetadata = merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
  if (level) {
    data.level = level;
  }
  if (transactionName) {
    data.transactionName = transactionName;
  }
  if (span) {
    data.span = span;
  }
  if (breadcrumbs.length) {
    data.breadcrumbs = [...data.breadcrumbs, ...breadcrumbs];
  }
  if (fingerprint.length) {
    data.fingerprint = [...data.fingerprint, ...fingerprint];
  }
  if (eventProcessors.length) {
    data.eventProcessors = [...data.eventProcessors, ...eventProcessors];
  }
  if (attachments.length) {
    data.attachments = [...data.attachments, ...attachments];
  }
  data.propagationContext = { ...data.propagationContext, ...propagationContext };
}
function mergeAndOverwriteScopeData(data, prop, mergeVal) {
  data[prop] = merge(data[prop], mergeVal, 1);
}
function getCombinedScopeData(isolationScope, currentScope) {
  const scopeData = getGlobalScope().getScopeData();
  isolationScope && mergeScopeData(scopeData, isolationScope.getScopeData());
  currentScope && mergeScopeData(scopeData, currentScope.getScopeData());
  return scopeData;
}
function applyDataToEvent(event, data) {
  const { extra, tags, user, contexts, level, transactionName } = data;
  if (Object.keys(extra).length) {
    event.extra = { ...extra, ...event.extra };
  }
  if (Object.keys(tags).length) {
    event.tags = { ...tags, ...event.tags };
  }
  if (Object.keys(user).length) {
    event.user = { ...user, ...event.user };
  }
  if (Object.keys(contexts).length) {
    event.contexts = { ...contexts, ...event.contexts };
  }
  if (level) {
    event.level = level;
  }
  if (transactionName && event.type !== "transaction") {
    event.transaction = transactionName;
  }
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
  const mergedBreadcrumbs = [...event.breadcrumbs || [], ...breadcrumbs];
  event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
  event.sdkProcessingMetadata = {
    ...event.sdkProcessingMetadata,
    ...sdkProcessingMetadata
  };
}
function applySpanToEvent(event, span) {
  event.contexts = {
    trace: spanToTraceContext(span),
    ...event.contexts
  };
  event.sdkProcessingMetadata = {
    dynamicSamplingContext: getDynamicSamplingContextFromSpan(span),
    ...event.sdkProcessingMetadata
  };
  const rootSpan = getRootSpan(span);
  const transactionName = spanToJSON(rootSpan).description;
  if (transactionName && !event.transaction && event.type === "transaction") {
    event.transaction = transactionName;
  }
}
function applyFingerprintToEvent(event, fingerprint) {
  event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [event.fingerprint] : [];
  if (fingerprint) {
    event.fingerprint = event.fingerprint.concat(fingerprint);
  }
  if (!event.fingerprint.length) {
    delete event.fingerprint;
  }
}
function safeSetSpanJSONAttributes(spanJSON, newAttributes) {
  const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
  Object.entries(newAttributes).forEach(([key, value]) => {
    if (value != null && !(key in originalAttributes)) {
      originalAttributes[key] = value;
    }
  });
}
const STATE_PENDING = 0;
const STATE_RESOLVED = 1;
const STATE_REJECTED = 2;
function resolvedSyncPromise(value) {
  return new SyncPromise((resolve2) => {
    resolve2(value);
  });
}
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}
class SyncPromise {
  constructor(executor) {
    this._state = STATE_PENDING;
    this._handlers = [];
    this._runExecutor(executor);
  }
  /** @inheritdoc */
  then(onfulfilled, onrejected) {
    return new SyncPromise((resolve2, reject) => {
      this._handlers.push([
        false,
        (result) => {
          if (!onfulfilled) {
            resolve2(result);
          } else {
            try {
              resolve2(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        (reason) => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve2(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        }
      ]);
      this._executeHandlers();
    });
  }
  /** @inheritdoc */
  catch(onrejected) {
    return this.then((val) => val, onrejected);
  }
  /** @inheritdoc */
  finally(onfinally) {
    return new SyncPromise((resolve2, reject) => {
      let val;
      let isRejected;
      return this.then(
        (value) => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        (reason) => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        }
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }
        resolve2(val);
      });
    });
  }
  /** Excute the resolve/reject handlers. */
  _executeHandlers() {
    if (this._state === STATE_PENDING) {
      return;
    }
    const cachedHandlers = this._handlers.slice();
    this._handlers = [];
    cachedHandlers.forEach((handler) => {
      if (handler[0]) {
        return;
      }
      if (this._state === STATE_RESOLVED) {
        handler[1](this._value);
      }
      if (this._state === STATE_REJECTED) {
        handler[2](this._value);
      }
      handler[0] = true;
    });
  }
  /** Run the executor for the SyncPromise. */
  _runExecutor(executor) {
    const setResult = (state, value) => {
      if (this._state !== STATE_PENDING) {
        return;
      }
      if (isThenable(value)) {
        void value.then(resolve2, reject);
        return;
      }
      this._state = state;
      this._value = value;
      this._executeHandlers();
    };
    const resolve2 = (value) => {
      setResult(STATE_RESOLVED, value);
    };
    const reject = (reason) => {
      setResult(STATE_REJECTED, reason);
    };
    try {
      executor(resolve2, reject);
    } catch (e) {
      reject(e);
    }
  }
}
function notifyEventProcessors(processors, event, hint, index = 0) {
  try {
    const result = _notifyEventProcessors(event, hint, processors, index);
    return isThenable(result) ? result : resolvedSyncPromise(result);
  } catch (error2) {
    return rejectedSyncPromise(error2);
  }
}
function _notifyEventProcessors(event, hint, processors, index) {
  const processor = processors[index];
  if (!event || !processor) {
    return event;
  }
  const result = processor({ ...event }, hint);
  DEBUG_BUILD$2 && result === null && debug.log(`Event processor "${processor.id || "?"}" dropped event`);
  if (isThenable(result)) {
    return result.then((final) => _notifyEventProcessors(final, hint, processors, index + 1));
  }
  return _notifyEventProcessors(result, hint, processors, index + 1);
}
let parsedStackResults;
let lastSentryKeysCount;
let lastNativeKeysCount;
let cachedFilenameDebugIds;
function getFilenameToDebugIdMap(stackParser) {
  const sentryDebugIdMap = GLOBAL_OBJ._sentryDebugIds;
  const nativeDebugIdMap = GLOBAL_OBJ._debugIds;
  if (!sentryDebugIdMap && !nativeDebugIdMap) {
    return {};
  }
  const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
  const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
  if (cachedFilenameDebugIds && sentryDebugIdKeys.length === lastSentryKeysCount && nativeDebugIdKeys.length === lastNativeKeysCount) {
    return cachedFilenameDebugIds;
  }
  lastSentryKeysCount = sentryDebugIdKeys.length;
  lastNativeKeysCount = nativeDebugIdKeys.length;
  cachedFilenameDebugIds = {};
  if (!parsedStackResults) {
    parsedStackResults = {};
  }
  const processDebugIds = (debugIdKeys, debugIdMap) => {
    for (const key of debugIdKeys) {
      const debugId = debugIdMap[key];
      const result = parsedStackResults == null ? void 0 : parsedStackResults[key];
      if (result && cachedFilenameDebugIds && debugId) {
        cachedFilenameDebugIds[result[0]] = debugId;
        if (parsedStackResults) {
          parsedStackResults[key] = [result[0], debugId];
        }
      } else if (debugId) {
        const parsedStack = stackParser(key);
        for (let i = parsedStack.length - 1; i >= 0; i--) {
          const stackFrame = parsedStack[i];
          const filename = stackFrame == null ? void 0 : stackFrame.filename;
          if (filename && cachedFilenameDebugIds && parsedStackResults) {
            cachedFilenameDebugIds[filename] = debugId;
            parsedStackResults[key] = [filename, debugId];
            break;
          }
        }
      }
    }
  };
  if (sentryDebugIdMap) {
    processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
  }
  if (nativeDebugIdMap) {
    processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
  }
  return cachedFilenameDebugIds;
}
function prepareEvent(options, event, hint, scope, client, isolationScope) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1e3 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || uuid4(),
    timestamp: event.timestamp || dateTimestampInSeconds()
  };
  const integrations = hint.integrations || options.integrations.map((i) => i.name);
  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);
  if (client) {
    client.emit("applyFrameMetadata", event);
  }
  if (event.type === void 0) {
    applyDebugIds(prepared, options.stackParser);
  }
  const finalScope = getFinalScope(scope, hint.captureContext);
  if (hint.mechanism) {
    addExceptionMechanism(prepared, hint.mechanism);
  }
  const clientEventProcessors = client ? client.getEventProcessors() : [];
  const data = getCombinedScopeData(isolationScope, finalScope);
  const attachments = [...hint.attachments || [], ...data.attachments];
  if (attachments.length) {
    hint.attachments = attachments;
  }
  applyScopeDataToEvent(prepared, data);
  const eventProcessors = [
    ...clientEventProcessors,
    // Run scope event processors _after_ all other processors
    ...data.eventProcessors
  ];
  const isInternalException = hint.data && hint.data.__sentry__ === true;
  const result = isInternalException ? resolvedSyncPromise(prepared) : notifyEventProcessors(eventProcessors, prepared, hint);
  return result.then((evt) => {
    if (evt) {
      applyDebugMeta(evt);
    }
    if (typeof normalizeDepth === "number" && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}
function applyClientOptions(event, options) {
  var _a, _b;
  const { environment, release, dist, maxValueLength } = options;
  event.environment = event.environment || environment || DEFAULT_ENVIRONMENT;
  if (!event.release && release) {
    event.release = release;
  }
  if (!event.dist && dist) {
    event.dist = dist;
  }
  const request = event.request;
  if ((request == null ? void 0 : request.url) && maxValueLength) {
    request.url = truncate(request.url, maxValueLength);
  }
  if (maxValueLength) {
    (_b = (_a = event.exception) == null ? void 0 : _a.values) == null ? void 0 : _b.forEach((exception) => {
      if (exception.value) {
        exception.value = truncate(exception.value, maxValueLength);
      }
    });
  }
}
function applyDebugIds(event, stackParser) {
  var _a, _b;
  const filenameDebugIdMap = getFilenameToDebugIdMap(stackParser);
  (_b = (_a = event.exception) == null ? void 0 : _a.values) == null ? void 0 : _b.forEach((exception) => {
    var _a2, _b2;
    (_b2 = (_a2 = exception.stacktrace) == null ? void 0 : _a2.frames) == null ? void 0 : _b2.forEach((frame) => {
      if (frame.filename) {
        frame.debug_id = filenameDebugIdMap[frame.filename];
      }
    });
  });
}
function applyDebugMeta(event) {
  var _a, _b;
  const filenameDebugIdMap = {};
  (_b = (_a = event.exception) == null ? void 0 : _a.values) == null ? void 0 : _b.forEach((exception) => {
    var _a2, _b2;
    (_b2 = (_a2 = exception.stacktrace) == null ? void 0 : _a2.frames) == null ? void 0 : _b2.forEach((frame) => {
      if (frame.debug_id) {
        if (frame.abs_path) {
          filenameDebugIdMap[frame.abs_path] = frame.debug_id;
        } else if (frame.filename) {
          filenameDebugIdMap[frame.filename] = frame.debug_id;
        }
        delete frame.debug_id;
      }
    });
  });
  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.entries(filenameDebugIdMap).forEach(([filename, debug_id]) => {
    images.push({
      type: "sourcemap",
      code_file: filename,
      debug_id
    });
  });
}
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...event.sdk.integrations || [], ...integrationNames];
  }
}
function normalizeEvent(event, depth, maxBreadth) {
  var _a, _b;
  if (!event) {
    return null;
  }
  const normalized = {
    ...event,
    ...event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map((b3) => ({
        ...b3,
        ...b3.data && {
          data: normalize(b3.data, depth, maxBreadth)
        }
      }))
    },
    ...event.user && {
      user: normalize(event.user, depth, maxBreadth)
    },
    ...event.contexts && {
      contexts: normalize(event.contexts, depth, maxBreadth)
    },
    ...event.extra && {
      extra: normalize(event.extra, depth, maxBreadth)
    }
  };
  if (((_a = event.contexts) == null ? void 0 : _a.trace) && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
    }
  }
  if (event.spans) {
    normalized.spans = event.spans.map((span) => {
      return {
        ...span,
        ...span.data && {
          data: normalize(span.data, depth, maxBreadth)
        }
      };
    });
  }
  if (((_b = event.contexts) == null ? void 0 : _b.flags) && normalized.contexts) {
    normalized.contexts.flags = normalize(event.contexts.flags, 3, maxBreadth);
  }
  return normalized;
}
function getFinalScope(scope, captureContext) {
  if (!captureContext) {
    return scope;
  }
  const finalScope = scope ? scope.clone() : new Scope();
  finalScope.update(captureContext);
  return finalScope;
}
function parseEventHintOrCaptureContext(hint) {
  if (!hint) {
    return void 0;
  }
  if (hintIsScopeOrFunction(hint)) {
    return { captureContext: hint };
  }
  if (hintIsScopeContext(hint)) {
    return {
      captureContext: hint
    };
  }
  return hint;
}
function hintIsScopeOrFunction(hint) {
  return hint instanceof Scope || typeof hint === "function";
}
const captureContextKeys = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "propagationContext"
];
function hintIsScopeContext(hint) {
  return Object.keys(hint).some((key) => captureContextKeys.includes(key));
}
function captureException(exception, hint) {
  return getCurrentScope().captureException(exception, parseEventHintOrCaptureContext(hint));
}
function captureEvent(event, hint) {
  return getCurrentScope().captureEvent(event, hint);
}
function startSession(context) {
  const isolationScope = getIsolationScope();
  const { user } = getCombinedScopeData(isolationScope, getCurrentScope());
  const { userAgent } = GLOBAL_OBJ.navigator || {};
  const session = makeSession({
    user,
    ...userAgent && { userAgent },
    ...context
  });
  const currentSession = isolationScope.getSession();
  if ((currentSession == null ? void 0 : currentSession.status) === "ok") {
    updateSession(currentSession, { status: "exited" });
  }
  endSession();
  isolationScope.setSession(session);
  return session;
}
function endSession() {
  const isolationScope = getIsolationScope();
  const currentScope = getCurrentScope();
  const session = currentScope.getSession() || isolationScope.getSession();
  if (session) {
    closeSession(session);
  }
  _sendSessionUpdate();
  isolationScope.setSession();
}
function _sendSessionUpdate() {
  const isolationScope = getIsolationScope();
  const client = getClient();
  const session = isolationScope.getSession();
  if (session && client) {
    client.captureSession(session);
  }
}
function captureSession(end = false) {
  if (end) {
    endSession();
    return;
  }
  _sendSessionUpdate();
}
const SENTRY_API_VERSION = "7";
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
  const port = dsn.port ? `:${dsn.port}` : "";
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function _encodedAuth(dsn, sdkInfo) {
  const params = {
    sentry_version: SENTRY_API_VERSION
  };
  if (dsn.publicKey) {
    params.sentry_key = dsn.publicKey;
  }
  if (sdkInfo) {
    params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
  }
  return new URLSearchParams(params).toString();
}
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}
const installedIntegrations = [];
function filterDuplicates(integrations) {
  const integrationsByName = {};
  integrations.forEach((currentInstance2) => {
    const { name } = currentInstance2;
    const existingInstance = integrationsByName[name];
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance2.isDefaultInstance) {
      return;
    }
    integrationsByName[name] = currentInstance2;
  });
  return Object.values(integrationsByName);
}
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;
  defaultIntegrations.forEach((integration) => {
    integration.isDefaultInstance = true;
  });
  let integrations;
  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === "function") {
    const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
    integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [resolvedUserIntegrations];
  } else {
    integrations = defaultIntegrations;
  }
  return filterDuplicates(integrations);
}
function setupIntegrations(client, integrations) {
  const integrationIndex = {};
  integrations.forEach((integration) => {
    if (integration == null ? void 0 : integration.beforeSetup) {
      integration.beforeSetup(client);
    }
  });
  integrations.forEach((integration) => {
    if (integration) {
      setupIntegration(client, integration, integrationIndex);
    }
  });
  return integrationIndex;
}
function afterSetupIntegrations(client, integrations) {
  for (const integration of integrations) {
    if (integration == null ? void 0 : integration.afterAllSetup) {
      integration.afterAllSetup(client);
    }
  }
}
function setupIntegration(client, integration, integrationIndex) {
  if (integrationIndex[integration.name]) {
    DEBUG_BUILD$2 && debug.log(`Integration skipped because it was already installed: ${integration.name}`);
    return;
  }
  integrationIndex[integration.name] = integration;
  if (!installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
    integration.setupOnce();
    installedIntegrations.push(integration.name);
  }
  if (integration.setup && typeof integration.setup === "function") {
    integration.setup(client);
  }
  if (typeof integration.preprocessEvent === "function") {
    const callback = integration.preprocessEvent.bind(integration);
    client.on("preprocessEvent", (event, hint) => callback(event, hint, client));
  }
  if (typeof integration.processEvent === "function") {
    const callback = integration.processEvent.bind(integration);
    const processor = Object.assign((event, hint) => callback(event, hint, client), {
      id: integration.name
    });
    client.addEventProcessor(processor);
  }
  ["processSpan", "processSegmentSpan"].forEach((hook) => {
    const callback = integration[hook];
    if (typeof callback === "function") {
      client.on(hook, (span) => callback.call(integration, span, client));
    }
  });
  DEBUG_BUILD$2 && debug.log(`Integration installed: ${integration.name}`);
}
function defineIntegration(fn) {
  return fn;
}
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function getSDKSource() {
  /*! __SENTRY_SDK_SOURCE__ */
  return "npm";
}
function isNodeEnv() {
  return !isBrowserBundle() && Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]";
}
function isBrowser() {
  return typeof window !== "undefined" && (!isNodeEnv() || isElectronNodeRenderer());
}
function isElectronNodeRenderer() {
  const process2 = GLOBAL_OBJ.process;
  return (process2 == null ? void 0 : process2.type) === "renderer";
}
function createLogContainerEnvelopeItem(items, inferUserData) {
  const inferSetting = inferUserData ? "auto" : "never";
  return [
    {
      type: "log",
      item_count: items.length,
      content_type: "application/vnd.sentry.items.log+json"
    },
    {
      version: 2,
      ...isBrowser() && {
        ingest_settings: { infer_ip: inferSetting, infer_user_agent: inferSetting }
      },
      items
    }
  ];
}
function createLogEnvelope(logs, metadata, tunnel, dsn, inferUserData) {
  const headers = {};
  if (metadata == null ? void 0 : metadata.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version
    };
  }
  if (!!tunnel && !!dsn) {
    headers.dsn = dsnToString(dsn);
  }
  return createEnvelope(headers, [createLogContainerEnvelopeItem(logs, inferUserData)]);
}
function _INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
  const logBuffer = maybeLogBuffer ?? _INTERNAL_getLogBuffer(client) ?? [];
  if (logBuffer.length === 0) {
    return;
  }
  const clientOptions = client.getOptions();
  const envelope = createLogEnvelope(
    logBuffer,
    clientOptions._metadata,
    clientOptions.tunnel,
    client.getDsn(),
    client.getDataCollectionOptions().userInfo
  );
  _getBufferMap$1().set(client, []);
  client.emit("flushLogs");
  client.sendEnvelope(envelope);
}
function _INTERNAL_getLogBuffer(client) {
  return _getBufferMap$1().get(client);
}
function _getBufferMap$1() {
  return getGlobalSingleton("clientToLogBufferMap", () => /* @__PURE__ */ new WeakMap());
}
function createMetricContainerEnvelopeItem(items, inferUserData) {
  const inferSetting = inferUserData ? "auto" : "never";
  return [
    {
      type: "trace_metric",
      item_count: items.length,
      content_type: "application/vnd.sentry.items.trace-metric+json"
    },
    {
      version: 2,
      ...isBrowser() && {
        ingest_settings: { infer_ip: inferSetting, infer_user_agent: inferSetting }
      },
      items
    }
  ];
}
function createMetricEnvelope(metrics, metadata, tunnel, dsn, inferUserData) {
  const headers = {};
  if (metadata == null ? void 0 : metadata.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version
    };
  }
  if (!!tunnel && !!dsn) {
    headers.dsn = dsnToString(dsn);
  }
  return createEnvelope(headers, [createMetricContainerEnvelopeItem(metrics, inferUserData)]);
}
function _INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
  const metricBuffer = maybeMetricBuffer ?? _INTERNAL_getMetricBuffer(client) ?? [];
  if (metricBuffer.length === 0) {
    return;
  }
  const clientOptions = client.getOptions();
  const envelope = createMetricEnvelope(
    metricBuffer,
    clientOptions._metadata,
    clientOptions.tunnel,
    client.getDsn(),
    client.getDataCollectionOptions().userInfo
  );
  _getBufferMap().set(client, []);
  client.emit("flushMetrics");
  client.sendEnvelope(envelope);
}
function _INTERNAL_getMetricBuffer(client) {
  return _getBufferMap().get(client);
}
function _getBufferMap() {
  return getGlobalSingleton("clientToMetricBufferMap", () => /* @__PURE__ */ new WeakMap());
}
function spanJsonToSerializedStreamedSpan(span) {
  const streamedSpan = {
    trace_id: span.trace_id,
    span_id: span.span_id,
    parent_span_id: span.parent_span_id,
    name: span.description || "",
    start_timestamp: span.start_timestamp,
    end_timestamp: span.timestamp || span.start_timestamp,
    status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
    is_segment: false,
    attributes: { ...span.data },
    links: span.links
  };
  return streamedSpanJsonToSerializedSpan(streamedSpan);
}
function extractGenAiSpansFromEvent(event, client) {
  var _a, _b, _c;
  if (event.type !== "transaction" || !((_a = event.spans) == null ? void 0 : _a.length) || !((_b = event.sdkProcessingMetadata) == null ? void 0 : _b.hasGenAiSpans) || !client.getOptions().streamGenAiSpans || hasSpanStreamingEnabled(client)) {
    return void 0;
  }
  const genAiSpans = [];
  const remainingSpans = [];
  for (const span of event.spans) {
    if ((_c = span.op) == null ? void 0 : _c.startsWith("gen_ai.")) {
      genAiSpans.push(spanJsonToSerializedStreamedSpan(span));
    } else {
      remainingSpans.push(span);
    }
  }
  if (genAiSpans.length === 0) {
    return void 0;
  }
  event.spans = remainingSpans;
  const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
  return [
    { type: "span", item_count: genAiSpans.length, content_type: "application/vnd.sentry.items.span.v2+json" },
    {
      version: 2,
      ...isBrowser() && {
        ingest_settings: { infer_ip: inferSetting, infer_user_agent: inferSetting }
      },
      items: genAiSpans
    }
  ];
}
function safeUnref(timer) {
  if (typeof timer === "object" && typeof timer.unref === "function") {
    timer.unref();
  }
  return timer;
}
const SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function makePromiseBuffer(limit = 100) {
  const buffer = /* @__PURE__ */ new Set();
  function isReady() {
    return buffer.size < limit;
  }
  function remove2(task) {
    buffer.delete(task);
  }
  function add(taskProducer) {
    if (!isReady()) {
      return rejectedSyncPromise(SENTRY_BUFFER_FULL_ERROR);
    }
    const task = taskProducer();
    buffer.add(task);
    void task.then(
      () => remove2(task),
      () => remove2(task)
    );
    return task;
  }
  function drain(timeout) {
    if (!buffer.size) {
      return resolvedSyncPromise(true);
    }
    const drainPromise = Promise.allSettled(Array.from(buffer)).then(() => true);
    if (!timeout) {
      return drainPromise;
    }
    const promises = [
      drainPromise,
      new Promise((resolve2) => safeUnref(setTimeout(() => resolve2(false), timeout)))
    ];
    return Promise.race(promises);
  }
  return {
    get $() {
      return Array.from(buffer);
    },
    add,
    drain
  };
}
const DEFAULT_RETRY_AFTER = 60 * 1e3;
function parseRetryAfterHeader(header, now2 = safeDateNow()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1e3;
  }
  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now2;
  }
  return DEFAULT_RETRY_AFTER;
}
function disabledUntil(limits, dataCategory) {
  return limits[dataCategory] || limits.all || 0;
}
function isRateLimited(limits, dataCategory, now2 = safeDateNow()) {
  return disabledUntil(limits, dataCategory) > now2;
}
function updateRateLimits(limits, { statusCode, headers }, now2 = safeDateNow()) {
  const updatedRateLimits = {
    ...limits
  };
  const rateLimitHeader = headers == null ? void 0 : headers["x-sentry-rate-limits"];
  const retryAfterHeader = headers == null ? void 0 : headers["retry-after"];
  if (rateLimitHeader) {
    for (const limit of rateLimitHeader.trim().split(",")) {
      const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
      if (!categories) {
        updatedRateLimits.all = now2 + delay;
      } else {
        for (const category of categories.split(";")) {
          if (category === "metric_bucket") {
            if (!namespaces || namespaces.split(";").includes("custom")) {
              updatedRateLimits[category] = now2 + delay;
            }
          } else {
            updatedRateLimits[category] = now2 + delay;
          }
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now2 + parseRetryAfterHeader(retryAfterHeader, now2);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now2 + 60 * 1e3;
  }
  return updatedRateLimits;
}
const DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function createTransport(options, makeRequest, buffer = makePromiseBuffer(
  options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE
)) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);
  function send(envelope) {
    const filteredEnvelopeItems = [];
    forEachEnvelopeItem(envelope, (item, type) => {
      const dataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, dataCategory)) {
        options.recordDroppedEvent("ratelimit_backoff", dataCategory);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });
    if (filteredEnvelopeItems.length === 0) {
      return Promise.resolve({});
    }
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems);
    const recordEnvelopeLoss = (reason) => {
      if (envelopeContainsItemType(filteredEnvelope, ["client_report"])) {
        DEBUG_BUILD$2 && debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
        return;
      }
      forEachEnvelopeItem(filteredEnvelope, (item, type) => {
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type));
      });
    };
    const requestTask = () => makeRequest({ body: serializeEnvelope(filteredEnvelope) }).then(
      (response) => {
        if (response.statusCode === 413) {
          DEBUG_BUILD$2 && debug.error(
            "Sentry responded with status code 413. Envelope was discarded due to exceeding size limits."
          );
          recordEnvelopeLoss("send_error");
          return response;
        }
        if (DEBUG_BUILD$2 && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) {
          debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
        }
        rateLimits = updateRateLimits(rateLimits, response);
        return response;
      },
      (error2) => {
        recordEnvelopeLoss("network_error");
        DEBUG_BUILD$2 && debug.error("Encountered error running transport request:", error2);
        throw error2;
      }
    );
    return buffer.add(requestTask).then(
      (result) => result,
      (error2) => {
        if (error2 === SENTRY_BUFFER_FULL_ERROR) {
          DEBUG_BUILD$2 && debug.error("Skipped sending event because buffer is full.");
          recordEnvelopeLoss("queue_overflow");
          return Promise.resolve({});
        } else {
          throw error2;
        }
      }
    );
  }
  return {
    send,
    flush
  };
}
function createClientReportEnvelope(discarded_events, dsn, timestamp) {
  const clientReportItem = [
    { type: "client_report" },
    {
      timestamp: dateTimestampInSeconds(),
      discarded_events
    }
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}
function getPossibleEventMessages(event) {
  const possibleMessages = [];
  if (event.message) {
    possibleMessages.push(event.message);
  }
  try {
    const lastException = event.exception.values[event.exception.values.length - 1];
    if (lastException == null ? void 0 : lastException.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
      }
    }
  } catch {
  }
  return possibleMessages;
}
function convertTransactionEventToSpanJson(event) {
  var _a;
  const { trace_id, parent_span_id, span_id, status, origin, data, op } = ((_a = event.contexts) == null ? void 0 : _a.trace) ?? {};
  return {
    data: data ?? {},
    description: event.transaction,
    op,
    parent_span_id,
    span_id: span_id ?? "",
    start_timestamp: event.start_timestamp ?? 0,
    status,
    timestamp: event.timestamp,
    trace_id: trace_id ?? "",
    origin,
    profile_id: data == null ? void 0 : data[SEMANTIC_ATTRIBUTE_PROFILE_ID],
    exclusive_time: data == null ? void 0 : data[SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
    measurements: event.measurements,
    is_segment: true
  };
}
function convertSpanJsonToTransactionEvent(span) {
  return {
    type: "transaction",
    timestamp: span.timestamp,
    start_timestamp: span.start_timestamp,
    transaction: span.description,
    contexts: {
      trace: {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        op: span.op,
        status: span.status,
        origin: span.origin,
        data: {
          ...span.data,
          ...span.profile_id && { [SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id },
          ...span.exclusive_time && { [SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time }
        }
      }
    },
    measurements: span.measurements
  };
}
const PII_HEADER_SNIPPETS = ["forwarded", "-ip", "remote-", "via", "-user"];
function defaultPiiToCollectionOptions(sendDefaultPii) {
  return sendDefaultPii === true ? {
    userInfo: true,
    cookies: true,
    httpHeaders: { request: true, response: true },
    httpBodies: ["incomingRequest", "outgoingRequest", "incomingResponse", "outgoingResponse"],
    queryParams: true,
    genAI: { inputs: true, outputs: true },
    stackFrameVariables: true,
    frameContextLines: 7
    // default should be 5, but ContextLines integration uses 7
  } : {
    userInfo: false,
    cookies: { deny: PII_HEADER_SNIPPETS },
    httpHeaders: { request: { deny: PII_HEADER_SNIPPETS }, response: { deny: PII_HEADER_SNIPPETS } },
    httpBodies: [],
    queryParams: { deny: PII_HEADER_SNIPPETS },
    genAI: { inputs: false, outputs: false },
    stackFrameVariables: true,
    frameContextLines: 7
    // default should be 5, but ContextLines integration uses 7
  };
}
const DEFAULTS = {
  userInfo: true,
  cookies: true,
  httpHeaders: { request: true, response: true },
  httpBodies: ["incomingRequest", "outgoingRequest", "incomingResponse", "outgoingResponse"],
  queryParams: true,
  genAI: { inputs: true, outputs: true },
  stackFrameVariables: true,
  frameContextLines: 5
};
function resolveDataCollectionOptions(options) {
  var _a, _b, _c, _d;
  const base = options.dataCollection != null ? DEFAULTS : defaultPiiToCollectionOptions(options.sendDefaultPii);
  const dc = options.dataCollection ?? {};
  return {
    userInfo: dc.userInfo ?? base.userInfo,
    cookies: dc.cookies ?? base.cookies,
    httpHeaders: {
      request: ((_a = dc.httpHeaders) == null ? void 0 : _a.request) ?? base.httpHeaders.request,
      response: ((_b = dc.httpHeaders) == null ? void 0 : _b.response) ?? base.httpHeaders.response
    },
    httpBodies: dc.httpBodies ?? base.httpBodies,
    queryParams: dc.queryParams ?? base.queryParams,
    genAI: {
      inputs: ((_c = dc.genAI) == null ? void 0 : _c.inputs) ?? base.genAI.inputs,
      outputs: ((_d = dc.genAI) == null ? void 0 : _d.outputs) ?? base.genAI.outputs
    },
    stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
    frameContextLines: dc.frameContextLines ?? base.frameContextLines
  };
}
const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const DEFAULT_FLUSH_INTERVAL = 5e3;
function _makeInternalError(message) {
  return {
    message,
    [INTERNAL_ERROR_SYMBOL]: true
  };
}
function _makeDoNotSendEventError(message) {
  return {
    message,
    [DO_NOT_SEND_EVENT_SYMBOL]: true
  };
}
function _isInternalError(error2) {
  return !!error2 && typeof error2 === "object" && INTERNAL_ERROR_SYMBOL in error2;
}
function _isDoNotSendEventError(error2) {
  return !!error2 && typeof error2 === "object" && DO_NOT_SEND_EVENT_SYMBOL in error2;
}
function setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
  let weight = 0;
  let flushTimeout;
  let isTimerActive = false;
  client.on(flushHook, () => {
    weight = 0;
    clearTimeout(flushTimeout);
    isTimerActive = false;
  });
  client.on(afterCaptureHook, (item) => {
    weight += estimateSizeFn(item);
    if (weight >= 8e5) {
      flushFn(client);
    } else if (!isTimerActive) {
      const flushInterval = client.getOptions()._flushInterval ?? DEFAULT_FLUSH_INTERVAL;
      if (flushInterval > 0) {
        isTimerActive = true;
        flushTimeout = safeUnref(
          setTimeout(() => {
            flushFn(client);
          }, flushInterval)
        );
      }
    }
  });
  client.on("flush", () => {
    flushFn(client);
  });
}
class Client {
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(options) {
    var _a, _b, _c;
    this._options = options;
    this._integrations = {};
    this._numProcessing = 0;
    this._outcomes = {};
    this._hooks = {};
    this._eventProcessors = [];
    this._promiseBuffer = makePromiseBuffer(((_a = options.transportOptions) == null ? void 0 : _a.bufferSize) ?? DEFAULT_TRANSPORT_BUFFER_SIZE);
    this._dataCollection = resolveDataCollectionOptions(options);
    if (options.dsn) {
      this._dsn = makeDsn(options.dsn);
    } else {
      DEBUG_BUILD$2 && debug.warn("No DSN provided, client will not send events.");
    }
    if (this._dsn) {
      const url = getEnvelopeEndpointWithUrlEncodedAuth(
        this._dsn,
        options.tunnel,
        options._metadata ? options._metadata.sdk : void 0
      );
      this._transport = options.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url
      });
    }
    this._options.enableLogs = this._options.enableLogs ?? ((_b = this._options._experiments) == null ? void 0 : _b.enableLogs);
    if (this._options.enableLogs) {
      setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", estimateLogSizeInBytes, _INTERNAL_flushLogsBuffer);
    }
    const enableMetrics = this._options.enableMetrics ?? ((_c = this._options._experiments) == null ? void 0 : _c.enableMetrics) ?? true;
    if (enableMetrics) {
      setupWeightBasedFlushing(
        this,
        "afterCaptureMetric",
        "flushMetrics",
        estimateMetricSizeInBytes,
        _INTERNAL_flushMetricsBuffer
      );
    }
  }
  /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureException(exception, hint, scope) {
    const eventId = uuid4();
    if (checkOrSetAlreadyCaught(exception)) {
      DEBUG_BUILD$2 && debug.log(ALREADY_SEEN_ERROR);
      return eventId;
    }
    const hintWithEventId = {
      event_id: eventId,
      ...hint
    };
    this._process(
      () => this.eventFromException(exception, hintWithEventId).then((event) => this._captureEvent(event, hintWithEventId, scope)).then((res) => res),
      "error"
    );
    return hintWithEventId.event_id;
  }
  /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureMessage(message, level, hint, currentScope) {
    const hintWithEventId = {
      event_id: uuid4(),
      ...hint
    };
    const eventMessage = isParameterizedString(message) ? message : String(message);
    const isMessage = isPrimitive(message);
    const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
    this._process(
      () => promisedEvent.then((event) => this._captureEvent(event, hintWithEventId, currentScope)),
      isMessage ? "unknown" : "error"
    );
    return hintWithEventId.event_id;
  }
  /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureEvent(event, hint, currentScope) {
    const eventId = uuid4();
    if ((hint == null ? void 0 : hint.originalException) && checkOrSetAlreadyCaught(hint.originalException)) {
      DEBUG_BUILD$2 && debug.log(ALREADY_SEEN_ERROR);
      return eventId;
    }
    const hintWithEventId = {
      event_id: eventId,
      ...hint
    };
    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
    const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
    const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
    const dataCategory = getDataCategoryByType(event.type);
    this._process(
      () => this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope),
      dataCategory
    );
    return hintWithEventId.event_id;
  }
  /**
   * Captures a session.
   */
  captureSession(session) {
    this.sendSession(session);
    updateSession(session, { init: false });
  }
  /**
   * Get the current Dsn.
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * Get the current options.
   */
  getOptions() {
    return this._options;
  }
  /**
   * Get the resolved data collection configuration.
   */
  getDataCollectionOptions() {
    return this._dataCollection;
  }
  /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */
  getTransport() {
    return this._transport;
  }
  /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */
  // @ts-expect-error - PromiseLike is a subset of Promise
  async flush(timeout) {
    const transport = this._transport;
    this.emit("flush");
    if (!transport) {
      return true;
    }
    const clientFinished = await this._isClientDoneProcessing(timeout);
    const transportFlushed = await transport.flush(timeout);
    return clientFinished && transportFlushed;
  }
  /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */
  // @ts-expect-error - PromiseLike is a subset of Promise
  async close(timeout) {
    _INTERNAL_flushLogsBuffer(this);
    const result = await this.flush(timeout);
    this.getOptions().enabled = false;
    this.emit("close");
    return result;
  }
  /**
   * Get all installed event processors.
   */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /**
   * Adds an event processor that applies to any event processed by this client.
   */
  addEventProcessor(eventProcessor) {
    this._eventProcessors.push(eventProcessor);
  }
  /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */
  init() {
    if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({ name }) => name.startsWith("Spotlight"))) {
      this._setupIntegrations();
    }
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(integrationName) {
    return this._integrations[integrationName];
  }
  /**
   * Returns the names of all installed integrations.
   */
  getIntegrationNames() {
    return Object.keys(this._integrations);
  }
  /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */
  addIntegration(integration) {
    const isAlreadyInstalled = this._integrations[integration.name];
    if (!isAlreadyInstalled && integration.beforeSetup) {
      integration.beforeSetup(this);
    }
    setupIntegration(this, integration, this._integrations);
    if (!isAlreadyInstalled) {
      afterSetupIntegrations(this, [integration]);
    }
  }
  /**
   * Send a fully prepared event to Sentry.
   */
  sendEvent(event, hint = {}) {
    this.emit("beforeSendEvent", event, hint);
    const genAiSpanItem = extractGenAiSpansFromEvent(event, this);
    let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
    for (const attachment of hint.attachments || []) {
      env = addItemToEnvelope(env, createAttachmentEnvelopeItem(attachment));
    }
    if (genAiSpanItem) {
      env = addItemToEnvelope(env, genAiSpanItem);
    }
    this.sendEnvelope(env).then((sendResponse) => this.emit("afterSendEvent", event, sendResponse));
  }
  /**
   * Send a session or session aggregrates to Sentry.
   */
  sendSession(session) {
    const { release: clientReleaseOption, environment: clientEnvironmentOption = DEFAULT_ENVIRONMENT } = this._options;
    if ("aggregates" in session) {
      const sessionAttrs = session.attrs || {};
      if (!sessionAttrs.release && !clientReleaseOption) {
        DEBUG_BUILD$2 && debug.warn(MISSING_RELEASE_FOR_SESSION_ERROR);
        return;
      }
      sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
      sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
      session.attrs = sessionAttrs;
    } else {
      if (!session.release && !clientReleaseOption) {
        DEBUG_BUILD$2 && debug.warn(MISSING_RELEASE_FOR_SESSION_ERROR);
        return;
      }
      session.release = session.release || clientReleaseOption;
      session.environment = session.environment || clientEnvironmentOption;
    }
    this.emit("beforeSendSession", session);
    const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(env);
  }
  /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */
  recordDroppedEvent(reason, category, count = 1) {
    if (this._options.sendClientReports) {
      const key = `${reason}:${category}`;
      DEBUG_BUILD$2 && debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
      this._outcomes[key] = (this._outcomes[key] || 0) + count;
    }
  }
  /**
   * Register a hook on this client.
   */
  on(hook, callback) {
    const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
    const uniqueCallback = (...args) => callback(...args);
    hookCallbacks.add(uniqueCallback);
    return () => {
      hookCallbacks.delete(uniqueCallback);
    };
  }
  /**
   * Emit a hook that was previously registered via `on()`.
   */
  emit(hook, ...rest) {
    const callbacks = this._hooks[hook];
    if (callbacks) {
      callbacks.forEach((callback) => callback(...rest));
    }
  }
  /**
   * Send an envelope to Sentry.
   */
  // @ts-expect-error - PromiseLike is a subset of Promise
  async sendEnvelope(envelope) {
    this.emit("beforeEnvelope", envelope);
    if (this._isEnabled() && this._transport) {
      try {
        return await this._transport.send(envelope);
      } catch (reason) {
        DEBUG_BUILD$2 && debug.error("Error while sending envelope:", reason);
        return {};
      }
    }
    DEBUG_BUILD$2 && debug.error("Transport disabled");
    return {};
  }
  /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  registerCleanup(callback) {
  }
  /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */
  dispose() {
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations } = this._options;
    this._integrations = setupIntegrations(this, integrations);
    afterSetupIntegrations(this, integrations);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(session, event) {
    var _a, _b;
    let crashed = event.level === "fatal";
    let errored = false;
    const exceptions = (_a = event.exception) == null ? void 0 : _a.values;
    if (exceptions) {
      errored = true;
      crashed = false;
      for (const ex of exceptions) {
        if (((_b = ex.mechanism) == null ? void 0 : _b.handled) === false) {
          crashed = true;
          break;
        }
      }
    }
    const sessionNonTerminal = session.status === "ok";
    const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
    if (shouldUpdateAndSend) {
      updateSession(session, {
        ...crashed && { status: "crashed" },
        errors: session.errors || Number(errored || crashed)
      });
      this.captureSession(session);
    }
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  async _isClientDoneProcessing(timeout) {
    let ticked = 0;
    while (!timeout || ticked < timeout) {
      await new Promise((resolve2) => setTimeout(resolve2, 1));
      if (!this._numProcessing) {
        return true;
      }
      ticked++;
    }
    return false;
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== false && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(event, hint, currentScope, isolationScope) {
    const options = this.getOptions();
    const integrations = this.getIntegrationNames();
    if (!hint.integrations && integrations.length) {
      hint.integrations = integrations;
    }
    this.emit("preprocessEvent", event, hint);
    if (!event.type) {
      isolationScope.setLastEventId(event.event_id || hint.event_id);
    }
    return prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt) => {
      var _a;
      if (evt === null) {
        return evt;
      }
      this.emit("postprocessEvent", evt, hint);
      evt.contexts = {
        trace: { ...(_a = evt.contexts) == null ? void 0 : _a.trace, ...getTraceContextFromScope(currentScope) },
        ...evt.contexts
      };
      const dynamicSamplingContext = getDynamicSamplingContextFromScope(this, currentScope);
      evt.sdkProcessingMetadata = {
        dynamicSamplingContext,
        ...evt.sdkProcessingMetadata
      };
      return evt;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(event, hint = {}, currentScope = getCurrentScope(), isolationScope = getIsolationScope()) {
    if (DEBUG_BUILD$2 && isErrorEvent(event)) {
      debug.log(`Captured error event \`${getPossibleEventMessages(event)[0] || "<unknown>"}\``);
    }
    return this._processEvent(event, hint, currentScope, isolationScope).then(
      (finalEvent) => {
        return finalEvent.event_id;
      },
      (reason) => {
        if (DEBUG_BUILD$2) {
          if (_isDoNotSendEventError(reason)) {
            debug.log(reason.message);
          } else if (_isInternalError(reason)) {
            debug.warn(reason.message);
          } else {
            debug.warn(reason);
          }
        }
        return void 0;
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(event, hint, currentScope, isolationScope) {
    const options = this.getOptions();
    const { sampleRate } = options;
    const isTransaction = isTransactionEvent(event);
    const isError2 = isErrorEvent(event);
    const eventType = event.type || "error";
    const beforeSendLabel = `before send for type \`${eventType}\``;
    const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : parseSampleRate(sampleRate);
    if (isError2 && typeof parsedSampleRate === "number" && safeMathRandom() > parsedSampleRate) {
      this.recordDroppedEvent("sample_rate", "error");
      return rejectedSyncPromise(
        _makeDoNotSendEventError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`
        )
      );
    }
    const dataCategory = getDataCategoryByType(event.type);
    return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared) => {
      var _a;
      if (prepared === null) {
        this.recordDroppedEvent("event_processor", dataCategory);
        throw _makeDoNotSendEventError("An event processor returned `null`, will not send event.");
      }
      const isInternalException = ((_a = hint.data) == null ? void 0 : _a.__sentry__) === true;
      if (isInternalException) {
        return prepared;
      }
      const result = processBeforeSend(this, options, prepared, hint);
      return _validateBeforeSendResult(result, beforeSendLabel);
    }).then((processedEvent) => {
      var _a;
      if (processedEvent === null) {
        this.recordDroppedEvent("before_send", dataCategory);
        if (isTransaction) {
          const spans = event.spans || [];
          const spanCount = 1 + spans.length;
          this.recordDroppedEvent("before_send", "span", spanCount);
        }
        throw _makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
      }
      const session = currentScope.getSession() || isolationScope.getSession();
      if (isError2 && session) {
        this._updateSessionFromEvent(session, processedEvent);
      }
      if (isTransaction) {
        const spanCountBefore = ((_a = processedEvent.sdkProcessingMetadata) == null ? void 0 : _a.spanCountBeforeProcessing) || 0;
        const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
        const droppedSpanCount = spanCountBefore - spanCountAfter;
        if (droppedSpanCount > 0) {
          this.recordDroppedEvent("before_send", "span", droppedSpanCount);
        }
      }
      const transactionInfo = processedEvent.transaction_info;
      if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
        const source = "custom";
        processedEvent.transaction_info = {
          ...transactionInfo,
          source
        };
      }
      this.sendEvent(processedEvent, hint);
      return processedEvent;
    }).then(null, (reason) => {
      if (_isDoNotSendEventError(reason) || _isInternalError(reason)) {
        throw reason;
      }
      this.captureException(reason, {
        mechanism: {
          handled: false,
          type: "internal"
        },
        data: {
          __sentry__: true
        },
        originalException: reason
      });
      throw _makeInternalError(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`
      );
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(taskProducer, dataCategory) {
    this._numProcessing++;
    void this._promiseBuffer.add(taskProducer).then(
      (value) => {
        this._numProcessing--;
        return value;
      },
      (reason) => {
        this._numProcessing--;
        if (reason === SENTRY_BUFFER_FULL_ERROR) {
          this.recordDroppedEvent("queue_overflow", dataCategory);
        }
        return reason;
      }
    );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.entries(outcomes).map(([key, quantity]) => {
      const [reason, category] = key.split(":");
      return {
        reason,
        category,
        quantity
      };
    });
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    DEBUG_BUILD$2 && debug.log("Flushing outcomes...");
    const outcomes = this._clearOutcomes();
    if (outcomes.length === 0) {
      DEBUG_BUILD$2 && debug.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      DEBUG_BUILD$2 && debug.log("No dsn provided, will not send outcomes");
      return;
    }
    DEBUG_BUILD$2 && debug.log("Sending outcomes:", outcomes);
    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsnToString(this._dsn));
    this.sendEnvelope(envelope);
  }
}
function getDataCategoryByType(type) {
  return type === "replay_event" ? "replay" : type || "error";
}
function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if (isThenable(beforeSendResult)) {
    return beforeSendResult.then(
      (event) => {
        if (!isPlainObject(event) && event !== null) {
          throw _makeInternalError(invalidValueError);
        }
        return event;
      },
      (e) => {
        throw _makeInternalError(`${beforeSendLabel} rejected with ${e}`);
      }
    );
  } else if (!isPlainObject(beforeSendResult) && beforeSendResult !== null) {
    throw _makeInternalError(invalidValueError);
  }
  return beforeSendResult;
}
function processBeforeSend(client, options, event, hint) {
  const { beforeSend, beforeSendTransaction, ignoreSpans } = options;
  const beforeSendSpan = !isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
  let processedEvent = event;
  if (isErrorEvent(processedEvent) && beforeSend) {
    return beforeSend(processedEvent, hint);
  }
  if (isTransactionEvent(processedEvent)) {
    if (beforeSendSpan || ignoreSpans) {
      const rootSpanJson = convertTransactionEventToSpanJson(processedEvent);
      if ((ignoreSpans == null ? void 0 : ignoreSpans.length) && shouldIgnoreSpan(
        { description: rootSpanJson.description, op: rootSpanJson.op, attributes: rootSpanJson.data },
        ignoreSpans
      )) {
        return null;
      }
      if (beforeSendSpan) {
        const processedRootSpanJson = beforeSendSpan(rootSpanJson);
        if (!processedRootSpanJson) {
          showSpanDropWarning();
        } else {
          processedEvent = merge(event, convertSpanJsonToTransactionEvent(processedRootSpanJson));
        }
      }
      if (processedEvent.spans) {
        const processedSpans = [];
        const initialSpans = processedEvent.spans;
        for (const span of initialSpans) {
          if ((ignoreSpans == null ? void 0 : ignoreSpans.length) && shouldIgnoreSpan({ description: span.description, op: span.op, attributes: span.data }, ignoreSpans)) {
            reparentChildSpans(initialSpans, span);
            continue;
          }
          if (beforeSendSpan) {
            const processedSpan = beforeSendSpan(span);
            if (!processedSpan) {
              showSpanDropWarning();
              processedSpans.push(span);
            } else {
              processedSpans.push(processedSpan);
            }
          } else {
            processedSpans.push(span);
          }
        }
        const droppedSpans = processedEvent.spans.length - processedSpans.length;
        if (droppedSpans) {
          client.recordDroppedEvent("before_send", "span", droppedSpans);
        }
        processedEvent.spans = processedSpans;
      }
    }
    if (beforeSendTransaction) {
      if (processedEvent.spans) {
        const spanCountBefore = processedEvent.spans.length;
        processedEvent.sdkProcessingMetadata = {
          ...event.sdkProcessingMetadata,
          spanCountBeforeProcessing: spanCountBefore
        };
      }
      return beforeSendTransaction(processedEvent, hint);
    }
  }
  return processedEvent;
}
function isErrorEvent(event) {
  return event.type === void 0;
}
function isTransactionEvent(event) {
  return event.type === "transaction";
}
function estimateMetricSizeInBytes(metric) {
  let weight = 0;
  if (metric.name) {
    weight += metric.name.length * 2;
  }
  weight += 8;
  return weight + estimateAttributesSizeInBytes(metric.attributes);
}
function estimateLogSizeInBytes(log2) {
  let weight = 0;
  if (log2.message) {
    weight += log2.message.length * 2;
  }
  return weight + estimateAttributesSizeInBytes(log2.attributes);
}
function estimateAttributesSizeInBytes(attributes) {
  if (!attributes) {
    return 0;
  }
  let weight = 0;
  Object.values(attributes).forEach((value) => {
    if (Array.isArray(value)) {
      weight += value.length * estimatePrimitiveSizeInBytes(value[0]);
    } else if (isPrimitive(value)) {
      weight += estimatePrimitiveSizeInBytes(value);
    } else {
      weight += 100;
    }
  });
  return weight;
}
function estimatePrimitiveSizeInBytes(value) {
  if (typeof value === "string") {
    return value.length * 2;
  } else if (typeof value === "number") {
    return 8;
  } else if (typeof value === "boolean") {
    return 4;
  }
  return 0;
}
function initAndBind(clientClass, options) {
  if (options.debug === true) {
    if (DEBUG_BUILD$2) {
      debug.enable();
    } else {
      consoleSandbox(() => {
        console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
      });
    }
  }
  const scope = getCurrentScope();
  scope.update(options.initialScope);
  const client = new clientClass(options);
  setCurrentClient(client);
  client.init();
  return client;
}
function setCurrentClient(client) {
  getCurrentScope().setClient(client);
}
function parseUrl(url) {
  if (!url) {
    return {};
  }
  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!match) {
    return {};
  }
  const query = match[6] || "";
  const fragment = match[8] || "";
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment
    // everything minus origin
  };
}
function stripDataUrlContent(url, includeDataPrefix = true) {
  if (url.startsWith("data:")) {
    const match = url.match(/^data:([^;,]+)/);
    const mimeType = match ? match[1] : "text/plain";
    const isBase64 = url.includes(";base64,");
    const dataStart = url.indexOf(",");
    let dataPrefix = "";
    if (includeDataPrefix && dataStart !== -1) {
      const data = url.slice(dataStart + 1);
      dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
    }
    return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
  }
  return url;
}
function addAutoIpAddressToSession(session) {
  var _a;
  if ("aggregates" in session) {
    if (((_a = session.attrs) == null ? void 0 : _a["ip_address"]) === void 0) {
      session.attrs = {
        ...session.attrs,
        ip_address: "{{auto}}"
      };
    }
  } else {
    if (session.ipAddress === void 0) {
      session.ipAddress = "{{auto}}";
    }
  }
}
function applySdkMetadata(options, name, names = [name], source = "npm") {
  const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
  if (!sdk.name) {
    sdk.name = `sentry.javascript.${name}`;
    sdk.packages = names.map((name2) => ({
      name: `${source}:@sentry/${name2}`,
      version: SDK_VERSION
    }));
    sdk.version = SDK_VERSION;
  }
}
const DEFAULT_BREADCRUMBS = 100;
function addBreadcrumb(breadcrumb, hint) {
  const client = getClient();
  const isolationScope = getIsolationScope();
  if (!client) return;
  const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } = client.getOptions();
  if (maxBreadcrumbs <= 0) return;
  const timestamp = dateTimestampInSeconds();
  const mergedBreadcrumb = { timestamp, ...breadcrumb };
  const finalBreadcrumb = beforeBreadcrumb ? consoleSandbox(() => beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
  if (finalBreadcrumb === null) return;
  if (client.emit) {
    client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
  }
  isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
let originalFunctionToString;
const INTEGRATION_NAME$8 = "FunctionToString";
const SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const _functionToStringIntegration = () => {
  return {
    name: INTEGRATION_NAME$8,
    setupOnce() {
      originalFunctionToString = Function.prototype.toString;
      try {
        Function.prototype.toString = function(...args) {
          const originalFunction = getOriginalFunction(this);
          const context = SETUP_CLIENTS.has(getClient()) && originalFunction !== void 0 ? originalFunction : this;
          return originalFunctionToString.apply(context, args);
        };
      } catch {
      }
    },
    setup(client) {
      SETUP_CLIENTS.set(client, true);
    }
  };
};
const functionToStringIntegration = defineIntegration(_functionToStringIntegration);
const DEFAULT_IGNORE_ERRORS = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
  /^Cannot redefine property: googletag$/,
  // This is thrown when google tag manager is used in combination with an ad blocker
  /^Can't find variable: gmo$/,
  // Error from Google Search App https://issuetracker.google.com/issues/396043331
  /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
  // Random error that happens but not actionable or noticeable to end-users.
  /can't redefine non-configurable property "solana"/,
  // Probably a browser extension or custom browser (Brave) throwing this error
  /vv\(\)\.getRestrictions is not a function/,
  // Error thrown by GTM, seemingly not affecting end-users
  /Can't find variable: _AutofillCallbackHandler/,
  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
  /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
  // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
  /^Java exception was raised during method invocation$/
  // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065)
];
const INTEGRATION_NAME$7 = "EventFilters";
const eventFiltersIntegration = defineIntegration((options = {}) => {
  let mergedOptions;
  return {
    name: INTEGRATION_NAME$7,
    setup(client) {
      const clientOptions = client.getOptions();
      mergedOptions = _mergeOptions(options, clientOptions);
    },
    processEvent(event, _hint, client) {
      if (!mergedOptions) {
        const clientOptions = client.getOptions();
        mergedOptions = _mergeOptions(options, clientOptions);
      }
      return _shouldDropEvent$1(event, mergedOptions) ? null : event;
    }
  };
});
const inboundFiltersIntegration = defineIntegration((options = {}) => {
  return {
    ...eventFiltersIntegration(options),
    name: "InboundFilters"
  };
});
function _mergeOptions(internalOptions = {}, clientOptions = {}) {
  return {
    allowUrls: [...internalOptions.allowUrls || [], ...clientOptions.allowUrls || []],
    denyUrls: [...internalOptions.denyUrls || [], ...clientOptions.denyUrls || []],
    ignoreErrors: [
      ...internalOptions.ignoreErrors || [],
      ...clientOptions.ignoreErrors || [],
      ...internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS
    ],
    ignoreTransactions: [...internalOptions.ignoreTransactions || [], ...clientOptions.ignoreTransactions || []]
  };
}
function _shouldDropEvent$1(event, options) {
  if (!event.type) {
    if (_isIgnoredError(event, options.ignoreErrors)) {
      DEBUG_BUILD$2 && debug.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${getEventDescription(event)}`
      );
      return true;
    }
    if (_isUselessError(event)) {
      DEBUG_BUILD$2 && debug.warn(
        `Event dropped due to not having an error message, error type or stacktrace.
Event: ${getEventDescription(
          event
        )}`
      );
      return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
      DEBUG_BUILD$2 && debug.warn(
        `Event dropped due to being matched by \`denyUrls\` option.
Event: ${getEventDescription(
          event
        )}.
Url: ${_getEventFilterUrl(event)}`
      );
      return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
      DEBUG_BUILD$2 && debug.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${getEventDescription(
          event
        )}.
Url: ${_getEventFilterUrl(event)}`
      );
      return true;
    }
  } else if (event.type === "transaction") {
    if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
      DEBUG_BUILD$2 && debug.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${getEventDescription(event)}`
      );
      return true;
    }
  }
  return false;
}
function _isIgnoredError(event, ignoreErrors) {
  if (!(ignoreErrors == null ? void 0 : ignoreErrors.length)) {
    return false;
  }
  return getPossibleEventMessages(event).some((message) => stringMatchesSomePattern(message, ignoreErrors));
}
function _isIgnoredTransaction(event, ignoreTransactions) {
  if (!(ignoreTransactions == null ? void 0 : ignoreTransactions.length)) {
    return false;
  }
  const name = event.transaction;
  return name ? stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
  if (!(denyUrls == null ? void 0 : denyUrls.length)) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : stringMatchesSomePattern(url, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
  if (!(allowUrls == null ? void 0 : allowUrls.length)) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : stringMatchesSomePattern(url, allowUrls);
}
function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];
    if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") {
      return frame.filename || null;
    }
  }
  return null;
}
function _getEventFilterUrl(event) {
  var _a, _b;
  try {
    const rootException = [...((_a = event.exception) == null ? void 0 : _a.values) ?? []].reverse().find((value) => {
      var _a2, _b2, _c;
      return ((_a2 = value.mechanism) == null ? void 0 : _a2.parent_id) === void 0 && ((_c = (_b2 = value.stacktrace) == null ? void 0 : _b2.frames) == null ? void 0 : _c.length);
    });
    const frames = (_b = rootException == null ? void 0 : rootException.stacktrace) == null ? void 0 : _b.frames;
    return frames ? _getLastValidUrl(frames) : null;
  } catch {
    DEBUG_BUILD$2 && debug.error(`Cannot extract url for event ${getEventDescription(event)}`);
    return null;
  }
}
function _isUselessError(event) {
  var _a, _b;
  if (!((_b = (_a = event.exception) == null ? void 0 : _a.values) == null ? void 0 : _b.length)) {
    return false;
  }
  return (
    // No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value) => value.stacktrace || value.type && value.type !== "Error" || value.value)
  );
}
function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
  var _a;
  if (!((_a = event.exception) == null ? void 0 : _a.values) || !hint || !isInstanceOf(hint.originalException, Error)) {
    return;
  }
  const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
  if (originalException) {
    event.exception.values = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      hint.originalException,
      key,
      event.exception.values,
      originalException,
      0
    );
  }
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error2, key, prevExceptions, exception, exceptionId) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }
  let newExceptions = [...prevExceptions];
  if (isInstanceOf(error2[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId, error2);
    const newException = exceptionFromErrorImplementation(parser, error2[key]);
    const newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      error2[key],
      key,
      [newException, ...newExceptions],
      newException,
      newExceptionId
    );
  }
  if (isExceptionGroup(error2)) {
    error2.errors.forEach((childError, i) => {
      if (isInstanceOf(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId, error2);
        const newException = exceptionFromErrorImplementation(parser, childError);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(
          exceptionFromErrorImplementation,
          parser,
          limit,
          childError,
          key,
          [newException, ...newExceptions],
          newException,
          newExceptionId
        );
      }
    });
  }
  return newExceptions;
}
function isExceptionGroup(error2) {
  return Array.isArray(error2.errors);
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId, error2) {
  exception.mechanism = {
    handled: true,
    type: "auto.core.linked_errors",
    ...isExceptionGroup(error2) && { is_exception_group: true },
    ...exception.mechanism,
    exception_id: exceptionId
  };
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
  exception.mechanism = {
    handled: true,
    ...exception.mechanism,
    type: "chained",
    source,
    exception_id: exceptionId,
    parent_id: parentId
  };
}
function hasSentryFetchUrlHost(error2) {
  return isError(error2) && "__sentry_fetch_url_host__" in error2 && typeof error2.__sentry_fetch_url_host__ === "string";
}
function _enhanceErrorWithSentryInfo(error2) {
  if (hasSentryFetchUrlHost(error2)) {
    return `${error2.message} (${error2.__sentry_fetch_url_host__})`;
  }
  return error2.message;
}
const _filter = /* @__PURE__ */ new Set([]);
function addConsoleInstrumentationHandler(handler) {
  const type = "console";
  const removeHandler = addHandler(type, handler);
  maybeInstrument(type, instrumentConsole);
  return removeHandler;
}
function instrumentConsole() {
  if (!("console" in GLOBAL_OBJ)) {
    return;
  }
  CONSOLE_LEVELS.forEach(function(level) {
    if (!(level in GLOBAL_OBJ.console)) {
      return;
    }
    fill(GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
      originalConsoleMethods[level] = originalConsoleMethod;
      return function(...args) {
        const firstArg = args[0];
        const log2 = originalConsoleMethods[level];
        const isFiltered = _filter.size && typeof firstArg === "string" && stringMatchesSomePattern(firstArg, _filter);
        if (!isFiltered) {
          triggerHandlers("console", { args, level });
        }
        if (!isFiltered || DEBUG_BUILD$2 && debug.isEnabled()) {
          log2 == null ? void 0 : log2.apply(GLOBAL_OBJ.console, args);
        }
      };
    });
  });
}
function severityLevelFromString(level) {
  return level === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(level) ? level : "log";
}
const INTEGRATION_NAME$6 = "Dedupe";
const _dedupeIntegration = () => {
  let previousEvent;
  return {
    name: INTEGRATION_NAME$6,
    processEvent(currentEvent) {
      if (currentEvent.type) {
        return currentEvent;
      }
      try {
        if (_shouldDropEvent(currentEvent, previousEvent)) {
          DEBUG_BUILD$2 && debug.warn("Event dropped due to being a duplicate of previously captured event.");
          return null;
        }
      } catch {
      }
      return previousEvent = currentEvent;
    }
  };
};
const dedupeIntegration = defineIntegration(_dedupeIntegration);
function _shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }
  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }
  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }
  return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;
  if (!currentMessage && !previousMessage) {
    return false;
  }
  if (currentMessage && !previousMessage || !currentMessage && previousMessage) {
    return false;
  }
  if (currentMessage !== previousMessage) {
    return false;
  }
  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }
  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }
  return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);
  if (!previousException || !currentException) {
    return false;
  }
  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }
  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }
  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }
  return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = getFramesFromEvent(currentEvent);
  let previousFrames = getFramesFromEvent(previousEvent);
  if (!currentFrames && !previousFrames) {
    return true;
  }
  if (currentFrames && !previousFrames || !currentFrames && previousFrames) {
    return false;
  }
  currentFrames = currentFrames;
  previousFrames = previousFrames;
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];
    if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) {
      return false;
    }
  }
  return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }
  if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) {
    return false;
  }
  currentFingerprint = currentFingerprint;
  previousFingerprint = previousFingerprint;
  try {
    return !!(currentFingerprint.join("") === previousFingerprint.join(""));
  } catch {
    return false;
  }
}
function _getExceptionFromEvent(event) {
  var _a, _b;
  return (_b = (_a = event.exception) == null ? void 0 : _a.values) == null ? void 0 : _b[0];
}
const INTEGRATION_NAME$5 = "ConversationId";
const _conversationIdIntegration = () => {
  return {
    name: INTEGRATION_NAME$5,
    setup(client) {
      client.on("spanStart", (span) => {
        const scopeData = getCurrentScope().getScopeData();
        const isolationScopeData = getIsolationScope().getScopeData();
        const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
        if (conversationId) {
          const { op, data: attributes, description: name } = spanToJSON(span);
          if (!(op == null ? void 0 : op.startsWith("gen_ai.")) && !attributes["ai.operationId"] && !(name == null ? void 0 : name.startsWith("ai."))) {
            return;
          }
          span.setAttribute(GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
        }
      });
    }
  };
};
const conversationIdIntegration = defineIntegration(_conversationIdIntegration);
function getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
  if (statusCode === void 0) {
    return void 0;
  } else if (statusCode >= 400 && statusCode < 500) {
    return "warning";
  } else if (statusCode >= 500) {
    return "error";
  } else {
    return void 0;
  }
}
const WINDOW$3 = GLOBAL_OBJ;
function supportsHistory() {
  return "history" in WINDOW$3 && !!WINDOW$3.history;
}
function _isFetchSupported() {
  if (!("fetch" in WINDOW$3)) {
    return false;
  }
  try {
    new Headers();
    new Request("data:,");
    new Response();
    return true;
  } catch {
    return false;
  }
}
function isNativeFunction(func) {
  return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function supportsNativeFetch() {
  var _a;
  if (typeof EdgeRuntime === "string") {
    return true;
  }
  if (!_isFetchSupported()) {
    return false;
  }
  if (isNativeFunction(WINDOW$3.fetch)) {
    return true;
  }
  let result = false;
  const doc2 = WINDOW$3.document;
  if (doc2 && typeof doc2.createElement === "function") {
    try {
      const sandbox = doc2.createElement("iframe");
      sandbox.hidden = true;
      doc2.head.appendChild(sandbox);
      if ((_a = sandbox.contentWindow) == null ? void 0 : _a.fetch) {
        result = isNativeFunction(sandbox.contentWindow.fetch);
      }
      doc2.head.removeChild(sandbox);
    } catch (err) {
      DEBUG_BUILD$2 && debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
  }
  return result;
}
function addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
  const type = "fetch";
  const removeHandler = addHandler(type, handler);
  maybeInstrument(type, () => instrumentFetch(void 0, skipNativeFetchCheck));
  return removeHandler;
}
function instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
  if (skipNativeFetchCheck && !supportsNativeFetch()) {
    return;
  }
  fill(GLOBAL_OBJ, "fetch", function(originalFetch) {
    return function(...args) {
      const virtualError = new Error();
      const { method, url } = parseFetchArgs(args);
      const handlerData = {
        args,
        fetchData: {
          method,
          url
        },
        startTimestamp: timestampInSeconds() * 1e3,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError,
        headers: getHeadersFromFetchArgs(args)
      };
      {
        triggerHandlers("fetch", {
          ...handlerData
        });
      }
      return originalFetch.apply(GLOBAL_OBJ, args).then(
        async (response) => {
          {
            triggerHandlers("fetch", {
              ...handlerData,
              endTimestamp: timestampInSeconds() * 1e3,
              response
            });
          }
          return response;
        },
        (error2) => {
          triggerHandlers("fetch", {
            ...handlerData,
            endTimestamp: timestampInSeconds() * 1e3,
            error: error2
          });
          if (isError(error2) && error2.stack === void 0) {
            error2.stack = virtualError.stack;
            addNonEnumerableProperty(error2, "framesToPop", 1);
          }
          const client = getClient();
          const enhanceOption = (client == null ? void 0 : client.getOptions().enhanceFetchErrorMessages) ?? "always";
          const shouldEnhance = enhanceOption !== false;
          if (shouldEnhance && error2 instanceof TypeError && (error2.message === "Failed to fetch" || error2.message === "Load failed" || error2.message === "NetworkError when attempting to fetch resource.")) {
            try {
              const url2 = new URL(handlerData.fetchData.url);
              const hostname = url2.host;
              if (enhanceOption === "always") {
                error2.message = `${error2.message} (${hostname})`;
              } else {
                addNonEnumerableProperty(error2, "__sentry_fetch_url_host__", hostname);
              }
            } catch {
            }
          }
          throw error2;
        }
      );
    };
  });
}
function hasProp(obj, prop) {
  return !!obj && typeof obj === "object" && !!obj[prop];
}
function getUrlFromResource(resource) {
  if (typeof resource === "string") {
    return resource;
  }
  if (!resource) {
    return "";
  }
  if (hasProp(resource, "url")) {
    return resource.url;
  }
  if (resource.toString) {
    return resource.toString();
  }
  return "";
}
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: "GET", url: "" };
  }
  if (fetchArgs.length === 2) {
    const [resource, options] = fetchArgs;
    return {
      url: getUrlFromResource(resource),
      method: hasProp(options, "method") ? String(options.method).toUpperCase() : (
        // Request object as first argument
        isRequest(resource) && hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
      )
    };
  }
  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg),
    method: hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
  };
}
function getHeadersFromFetchArgs(fetchArgs) {
  const [requestArgument, optionsArgument] = fetchArgs;
  try {
    if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) {
      return new Headers(optionsArgument.headers);
    }
    if (isRequest(requestArgument)) {
      return new Headers(requestArgument.headers);
    }
  } catch {
  }
  return;
}
const WINDOW$2 = GLOBAL_OBJ;
function getLocationHref() {
  try {
    return WINDOW$2.document.location.href;
  } catch {
    return "";
  }
}
function getComponentName(elem, maxTraverseHeight = 5) {
  if (!WINDOW$2.HTMLElement) {
    return null;
  }
  let currentElem = elem;
  for (let i = 0; i < maxTraverseHeight; i++) {
    if (!currentElem) {
      return null;
    }
    if (currentElem instanceof HTMLElement) {
      if (currentElem.dataset["sentryComponent"]) {
        return currentElem.dataset["sentryComponent"];
      }
      if (currentElem.dataset["sentryElement"]) {
        return currentElem.dataset["sentryElement"];
      }
    }
    currentElem = currentElem.parentNode;
  }
  return null;
}
const WINDOW$1 = GLOBAL_OBJ;
let ignoreOnError = 0;
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}
function ignoreNextOnError() {
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}
function wrap(fn, options = {}) {
  function isFunction2(fn2) {
    return typeof fn2 === "function";
  }
  if (!isFunction2(fn)) {
    return fn;
  }
  try {
    const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
    if (hasOwnWrapper) {
      const wrapper = fn.__sentry_wrapped__;
      if (typeof wrapper === "function") {
        return wrapper;
      } else {
        return fn;
      }
    }
    if (getOriginalFunction(fn)) {
      return fn;
    }
  } catch {
    return fn;
  }
  const sentryWrapped = function(...args) {
    GLOBAL_OBJ._sentryWrappedDepth = (GLOBAL_OBJ._sentryWrappedDepth || 0) + 1;
    try {
      const wrappedArguments = args.map((arg) => wrap(arg, options));
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();
      withScope((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            addExceptionTypeValue(event, void 0);
            addExceptionMechanism(event, options.mechanism);
          }
          event.extra = {
            ...event.extra,
            arguments: args
          };
          return event;
        });
        captureException(ex);
      });
      throw ex;
    } finally {
      GLOBAL_OBJ._sentryWrappedDepth = (GLOBAL_OBJ._sentryWrappedDepth || 0) - 1;
    }
  };
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch {
  }
  markFunctionWrapped(sentryWrapped, fn);
  addNonEnumerableProperty(fn, "__sentry_wrapped__", sentryWrapped);
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, "name", {
        get() {
          return fn.name;
        }
      });
    }
  } catch {
  }
  return sentryWrapped;
}
function getHttpRequestData() {
  const url = getLocationHref();
  const { referrer } = WINDOW$1.document || {};
  const { userAgent } = WINDOW$1.navigator || {};
  const headers = {
    ...referrer && { Referer: referrer },
    ...userAgent && { "User-Agent": userAgent }
  };
  const request = {
    url,
    headers
  };
  return request;
}
function exceptionFromError(stackParser, ex) {
  const frames = parseStackFrames(stackParser, ex);
  const exception = {
    type: extractType(ex),
    value: extractMessage(ex)
  };
  if (frames.length) {
    exception.stacktrace = { frames };
  }
  if (exception.type === void 0 && exception.value === "") {
    exception.value = "Unrecoverable error caught";
  }
  return exception;
}
function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
  const client = getClient();
  const normalizeDepth = client == null ? void 0 : client.getOptions().normalizeDepth;
  const errorFromProp = getErrorPropertyFromObject(exception);
  const extra = {
    __serialized__: normalizeToSize(exception, normalizeDepth)
  };
  if (errorFromProp) {
    return {
      exception: {
        values: [exceptionFromError(stackParser, errorFromProp)]
      },
      extra
    };
  }
  const event = {
    exception: {
      values: [
        {
          type: isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection })
        }
      ]
    },
    extra
  };
  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception.values[0].stacktrace = { frames };
    }
  }
  return event;
}
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)]
    }
  };
}
function parseStackFrames(stackParser, ex) {
  const stacktrace = ex.stacktrace || ex.stack || "";
  const skipLines = getSkipFirstStackStringLines(ex);
  const framesToPop = getPopFirstTopFrames(ex);
  try {
    return stackParser(stacktrace, skipLines, framesToPop);
  } catch {
  }
  return [];
}
const reactMinifiedRegexp = /Minified React error #\d+;/i;
function getSkipFirstStackStringLines(ex) {
  if (ex && reactMinifiedRegexp.test(ex.message)) {
    return 1;
  }
  return 0;
}
function getPopFirstTopFrames(ex) {
  if (typeof ex.framesToPop === "number") {
    return ex.framesToPop;
  }
  return 0;
}
function isWebAssemblyException(exception) {
  if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") {
    return exception instanceof WebAssembly.Exception;
  } else {
    return false;
  }
}
function extractType(ex) {
  const name = ex == null ? void 0 : ex.name;
  if (!name && isWebAssemblyException(ex)) {
    const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
    return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
  }
  return name;
}
function extractMessage(ex) {
  const message = ex == null ? void 0 : ex.message;
  if (isWebAssemblyException(ex)) {
    if (Array.isArray(ex.message) && ex.message.length == 2) {
      return ex.message[1];
    }
    return "wasm exception";
  }
  if (!message) {
    return "No error message";
  }
  if (message.error && typeof message.error.message === "string") {
    return _enhanceErrorWithSentryInfo(message.error);
  }
  return _enhanceErrorWithSentryInfo(ex);
}
function eventFromException(stackParser, exception, hint, attachStacktrace) {
  const syntheticException = (hint == null ? void 0 : hint.syntheticException) || void 0;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  addExceptionMechanism(event);
  event.level = "error";
  if (hint == null ? void 0 : hint.event_id) {
    event.event_id = hint.event_id;
  }
  return resolvedSyncPromise(event);
}
function eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
  const syntheticException = (hint == null ? void 0 : hint.syntheticException) || void 0;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint == null ? void 0 : hint.event_id) {
    event.event_id = hint.event_id;
  }
  return resolvedSyncPromise(event);
}
function eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
  var _a, _b;
  let event;
  if (isErrorEvent$1(exception) && exception.error) {
    const errorEvent = exception;
    return eventFromError(stackParser, errorEvent.error);
  }
  if (isDOMError(exception) || isDOMException(exception)) {
    const domException = exception;
    if ("stack" in exception) {
      event = eventFromError(stackParser, exception);
      const firstException = (_b = (_a = event.exception) == null ? void 0 : _a.values) == null ? void 0 : _b[0];
      if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
        const frames = parseStackFrames(stackParser, syntheticException);
        if (frames.length) {
          firstException.stacktrace = { frames };
          addExceptionMechanism(event, { synthetic: true });
        }
      }
    } else {
      const name = domException.name || (isDOMError(domException) ? "DOMError" : "DOMException");
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      addExceptionTypeValue(event, message);
    }
    if ("code" in domException) {
      event.tags = { ...event.tags, "DOMException.code": `${domException.code}` };
    }
    return event;
  }
  if (isError(exception)) {
    return eventFromError(stackParser, exception);
  }
  if (isPlainObject(exception) || isEvent(exception)) {
    const objectException = exception;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    addExceptionMechanism(event, {
      synthetic: true
    });
    return event;
  }
  event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
  addExceptionTypeValue(event, `${exception}`);
  addExceptionMechanism(event, {
    synthetic: true
  });
  return event;
}
function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
  const event = {};
  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: message, stacktrace: { frames } }]
      };
    }
    addExceptionMechanism(event, { synthetic: true });
  }
  if (isParameterizedString(message)) {
    const { __sentry_template_string__, __sentry_template_values__ } = message;
    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__
    };
    return event;
  }
  event.message = message;
  return event;
}
function getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }) {
  const keys = extractExceptionKeysForMessage(exception);
  const captureType = isUnhandledRejection ? "promise rejection" : "exception";
  if (isErrorEvent$1(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }
  if (isEvent(exception)) {
    const className = getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }
  return `Object captured as ${captureType} with keys: ${keys}`;
}
function getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : void 0;
  } catch {
  }
}
function getErrorPropertyFromObject(obj) {
  return Object.values(obj).find((v) => v instanceof Error);
}
class BrowserClient extends Client {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(options) {
    var _a;
    const opts = applyDefaultOptions(options);
    const sdkSource = WINDOW$1.SENTRY_SDK_SOURCE || getSDKSource();
    applySdkMetadata(opts, "browser", ["browser"], sdkSource);
    super(opts);
    const { userInfo } = this.getDataCollectionOptions();
    if ((_a = opts._metadata) == null ? void 0 : _a.sdk) {
      opts._metadata.sdk.settings = {
        // Only allow IP inferral by Relay if the user opted in via dataCollection
        infer_ip: userInfo ? "auto" : "never",
        // purposefully allowing already passed settings to override the default
        ...opts._metadata.sdk.settings
      };
    }
    const { sendClientReports, enableLogs, _experiments, enableMetrics: enableMetricsOption } = this._options;
    const enableMetrics = enableMetricsOption ?? (_experiments == null ? void 0 : _experiments.enableMetrics) ?? true;
    if (WINDOW$1.document && (sendClientReports || enableLogs || enableMetrics)) {
      WINDOW$1.document.addEventListener("visibilitychange", () => {
        if (WINDOW$1.document.visibilityState === "hidden") {
          if (sendClientReports) {
            this._flushOutcomes();
          }
          if (enableLogs) {
            _INTERNAL_flushLogsBuffer(this);
          }
          if (enableMetrics) {
            _INTERNAL_flushMetricsBuffer(this);
          }
        }
      });
    }
    if (userInfo) {
      this.on("beforeSendSession", addAutoIpAddressToSession);
    }
  }
  /**
   * @inheritDoc
   */
  eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(message, level = "info", hint) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(event, hint, currentScope, isolationScope) {
    event.platform = event.platform || "javascript";
    return super._prepareEvent(event, hint, currentScope, isolationScope);
  }
}
function applyDefaultOptions(optionsArg) {
  var _a;
  return {
    release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (_a = WINDOW$1.SENTRY_RELEASE) == null ? void 0 : _a.id,
    // This supports the variable that sentry-webpack-plugin injects
    sendClientReports: true,
    // We default this to true, as it is the safer scenario
    parentSpanIsAlwaysRootSpan: true,
    ...optionsArg
  };
}
const DEBUG_BUILD$1 = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const WINDOW = GLOBAL_OBJ;
const DEFAULT_MAX_STRING_LENGTH = 80;
const accessors = {};
try {
  if (typeof Node !== "undefined") {
    accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
  }
  if (typeof Element !== "undefined") {
    accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
    accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
    accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
    accessors.getAttribute = Element.prototype.getAttribute;
  }
  if (typeof HTMLElement !== "undefined") {
    accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
  }
} catch {
}
function _safeRead(el, prop, arg) {
  const fn = accessors[prop];
  if (fn) {
    try {
      return fn.call(el, arg);
    } catch {
    }
  }
  const val = el[prop];
  return typeof val === "function" ? val.call(el, arg) : val;
}
function htmlTreeAsString(elem, options = {}) {
  if (!elem) {
    return "<unknown>";
  }
  try {
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = " > ";
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
        break;
      }
      out.push(nextStr);
      len += nextStr.length;
      currentElem = _safeRead(currentElem, "parentNode");
    }
    return out.reverse().join(separator);
  } catch {
    return "<unknown>";
  }
}
function _htmlElementAsString(el, keyAttrs) {
  const out = [];
  const tagName = _safeRead(el, "tagName");
  if (!tagName) {
    return "";
  }
  if (typeof HTMLElement !== "undefined") {
    if (el instanceof HTMLElement) {
      const dataset = _safeRead(el, "dataset");
      if (dataset) {
        if (dataset["sentryComponent"]) {
          return dataset["sentryComponent"];
        }
        if (dataset["sentryElement"]) {
          return dataset["sentryElement"];
        }
      }
    }
  }
  out.push(tagName.toLowerCase());
  const keyAttrPairs = (keyAttrs == null ? void 0 : keyAttrs.length) ? keyAttrs.filter((keyAttr) => _safeRead(el, "getAttribute", keyAttr)).map((keyAttr) => [keyAttr, _safeRead(el, "getAttribute", keyAttr)]) : null;
  if (keyAttrPairs == null ? void 0 : keyAttrPairs.length) {
    keyAttrPairs.forEach((keyAttrPair) => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    const id = _safeRead(el, "id");
    if (id) {
      out.push(`#${id}`);
    }
    const className = _safeRead(el, "className");
    if (className && isString(className)) {
      const classes2 = className.split(/\s+/);
      for (const c of classes2) {
        out.push(`.${c}`);
      }
    }
  }
  for (const k of ["aria-label", "type", "name", "title", "alt"]) {
    const attr = _safeRead(el, "getAttribute", k);
    if (attr) {
      out.push(`[${k}="${attr}"]`);
    }
  }
  return out.join("");
}
const DEBOUNCE_DURATION = 1e3;
let debounceTimerID;
let lastCapturedEventType;
let lastCapturedEventTargetId;
function addClickKeypressInstrumentationHandler(handler) {
  const type = "dom";
  addHandler(type, handler);
  maybeInstrument(type, instrumentDOM);
}
function instrumentDOM() {
  if (!WINDOW.document) {
    return;
  }
  const triggerDOMHandler = triggerHandlers.bind(null, "dom");
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
  WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
  ["EventTarget", "Node"].forEach((target) => {
    var _a, _b;
    const globalObject = WINDOW;
    const proto = (_a = globalObject[target]) == null ? void 0 : _a.prototype;
    if (!((_b = proto == null ? void 0 : proto.hasOwnProperty) == null ? void 0 : _b.call(proto, "addEventListener"))) {
      return;
    }
    fill(proto, "addEventListener", function(originalAddEventListener) {
      return function(type, listener, options) {
        if (type === "click" || type == "keypress") {
          try {
            const handlers2 = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
            const handlerForType = handlers2[type] = handlers2[type] || { refCount: 0 };
            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }
            handlerForType.refCount++;
          } catch {
          }
        }
        return originalAddEventListener.call(this, type, listener, options);
      };
    });
    fill(
      proto,
      "removeEventListener",
      function(originalRemoveEventListener) {
        return function(type, listener, options) {
          if (type === "click" || type == "keypress") {
            try {
              const handlers2 = this.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers2[type];
              if (handlerForType) {
                handlerForType.refCount--;
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = void 0;
                  delete handlers2[type];
                }
                if (Object.keys(handlers2).length === 0) {
                  delete this.__sentry_instrumentation_handlers__;
                }
              }
            } catch {
            }
          }
          return originalRemoveEventListener.call(this, type, listener, options);
        };
      }
    );
  });
}
function isSimilarToLastCapturedEvent(event) {
  if (event.type !== lastCapturedEventType) {
    return false;
  }
  try {
    if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) {
      return false;
    }
  } catch {
  }
  return true;
}
function shouldSkipDOMEvent(eventType, target) {
  if (eventType !== "keypress") {
    return false;
  }
  if (!(target == null ? void 0 : target.tagName)) {
    return true;
  }
  if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
    return false;
  }
  return true;
}
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    if (!event || event["_sentryCaptured"]) {
      return;
    }
    const target = getEventTarget(event);
    if (shouldSkipDOMEvent(event.type, target)) {
      return;
    }
    addNonEnumerableProperty(event, "_sentryCaptured", true);
    if (target && !target._sentryId) {
      addNonEnumerableProperty(target, "_sentryId", uuid4());
    }
    const name = event.type === "keypress" ? "input" : event.type;
    if (!isSimilarToLastCapturedEvent(event)) {
      const handlerData = { event, name, global: globalListener };
      handler(handlerData);
      lastCapturedEventType = event.type;
      lastCapturedEventTargetId = target ? target._sentryId : void 0;
    }
    clearTimeout(debounceTimerID);
    debounceTimerID = WINDOW.setTimeout(() => {
      lastCapturedEventTargetId = void 0;
      lastCapturedEventType = void 0;
    }, DEBOUNCE_DURATION);
  };
}
function getEventTarget(event) {
  try {
    return event.target;
  } catch {
    return null;
  }
}
let lastHref;
function addHistoryInstrumentationHandler(handler) {
  const type = "history";
  addHandler(type, handler);
  maybeInstrument(type, instrumentHistory);
}
function instrumentHistory() {
  WINDOW.addEventListener("popstate", () => {
    const to = WINDOW.location.href;
    const from = lastHref;
    lastHref = to;
    if (from === to) {
      return;
    }
    const handlerData = { from, to };
    triggerHandlers("history", handlerData);
  });
  if (!supportsHistory()) {
    return;
  }
  function historyReplacementFunction(originalHistoryFunction) {
    return function(...args) {
      const url = args.length > 2 ? args[2] : void 0;
      if (url) {
        const from = lastHref;
        const to = getAbsoluteUrl(String(url));
        lastHref = to;
        if (from === to) {
          return originalHistoryFunction.apply(this, args);
        }
        const handlerData = { from, to };
        triggerHandlers("history", handlerData);
      }
      return originalHistoryFunction.apply(this, args);
    };
  }
  fill(WINDOW.history, "pushState", historyReplacementFunction);
  fill(WINDOW.history, "replaceState", historyReplacementFunction);
}
function getAbsoluteUrl(urlOrPath) {
  try {
    const url = new URL(urlOrPath, WINDOW.location.origin);
    return url.toString();
  } catch {
    return urlOrPath;
  }
}
const cachedImplementations = {};
function getNativeImplementation(name) {
  const cached = cachedImplementations[name];
  if (cached) {
    return cached;
  }
  let impl = WINDOW[name];
  if (isNativeFunction(impl)) {
    return cachedImplementations[name] = impl.bind(WINDOW);
  }
  const document2 = WINDOW.document;
  if (document2 && typeof document2.createElement === "function") {
    try {
      const sandbox = document2.createElement("iframe");
      sandbox.hidden = true;
      document2.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow == null ? void 0 : contentWindow[name]) {
        impl = contentWindow[name];
      }
      document2.head.removeChild(sandbox);
    } catch (e) {
      DEBUG_BUILD$1 && debug.warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
  }
  if (!impl) {
    return impl;
  }
  return cachedImplementations[name] = impl.bind(WINDOW);
}
function clearCachedImplementation(name) {
  cachedImplementations[name] = void 0;
}
const SENTRY_XHR_DATA_KEY = "__sentry_xhr_v3__";
function addXhrInstrumentationHandler(handler) {
  const type = "xhr";
  addHandler(type, handler);
  maybeInstrument(type, instrumentXHR);
}
function instrumentXHR() {
  if (!WINDOW.XMLHttpRequest) {
    return;
  }
  const xhrproto = XMLHttpRequest.prototype;
  xhrproto.open = new Proxy(xhrproto.open, {
    apply(originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
      const virtualError = new Error();
      const startTimestamp = timestampInSeconds() * 1e3;
      const method = isString(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
      const url = parseXhrUrlArg(xhrOpenArgArray[1]);
      if (!method || !url) {
        return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
      }
      xhrOpenThisArg[SENTRY_XHR_DATA_KEY] = {
        method,
        url,
        request_headers: {}
      };
      if (method === "POST" && url.match(/sentry_key/)) {
        xhrOpenThisArg.__sentry_own_request__ = true;
      }
      const onreadystatechangeHandler = () => {
        const xhrInfo = xhrOpenThisArg[SENTRY_XHR_DATA_KEY];
        if (!xhrInfo) {
          return;
        }
        if (xhrOpenThisArg.readyState === 4) {
          try {
            xhrInfo.status_code = xhrOpenThisArg.status;
          } catch {
          }
          const handlerData = {
            endTimestamp: timestampInSeconds() * 1e3,
            startTimestamp,
            xhr: xhrOpenThisArg,
            virtualError
          };
          triggerHandlers("xhr", handlerData);
        }
      };
      if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") {
        xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
          apply(originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
            onreadystatechangeHandler();
            return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
          }
        });
      } else {
        xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
      }
      xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
        apply(originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
          const [header, value] = setRequestHeaderArgArray;
          const xhrInfo = setRequestHeaderThisArg[SENTRY_XHR_DATA_KEY];
          if (xhrInfo && isString(header) && isString(value)) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }
          return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
        }
      });
      return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
    }
  });
  xhrproto.send = new Proxy(xhrproto.send, {
    apply(originalSend, sendThisArg, sendArgArray) {
      const sentryXhrData = sendThisArg[SENTRY_XHR_DATA_KEY];
      if (!sentryXhrData) {
        return originalSend.apply(sendThisArg, sendArgArray);
      }
      if (sendArgArray[0] !== void 0) {
        sentryXhrData.body = sendArgArray[0];
      }
      const handlerData = {
        startTimestamp: timestampInSeconds() * 1e3,
        xhr: sendThisArg
      };
      triggerHandlers("xhr", handlerData);
      return originalSend.apply(sendThisArg, sendArgArray);
    }
  });
}
function parseXhrUrlArg(url) {
  if (isString(url)) {
    return url;
  }
  try {
    return url.toString();
  } catch {
  }
  return void 0;
}
function isElement(wat) {
  if (typeof Element === "undefined") {
    return false;
  }
  try {
    return wat instanceof Element;
  } catch {
    return false;
  }
}
const DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function makeFetchTransport(options, nativeFetch = getNativeImplementation("fetch")) {
  let pendingBodySize = 0;
  let pendingCount = 0;
  async function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;
    const requestOptions = {
      body: request.body,
      method: "POST",
      referrerPolicy: "strict-origin",
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
      ...options.fetchOptions
    };
    try {
      const response = await nativeFetch(options.url, requestOptions);
      return {
        statusCode: response.status,
        headers: {
          "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": response.headers.get("Retry-After")
        }
      };
    } catch (e) {
      clearCachedImplementation("fetch");
      throw e;
    } finally {
      pendingBodySize -= requestSize;
      pendingCount--;
    }
  }
  return createTransport(
    options,
    makeRequest,
    makePromiseBuffer(options.bufferSize || DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE)
  );
}
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const CHROME_PRIORITY = 30;
const GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func === "<anonymous>" ? UNKNOWN_FUNCTION : func,
    in_app: true
    // All browser frames are considered in_app
  };
  if (lineno !== void 0) {
    frame.lineno = lineno;
  }
  if (colno !== void 0) {
    frame.colno = colno;
  }
  return frame;
}
const chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const chromeStackParserFn = (line) => {
  var _a;
  const dataUriMatch = line.match(chromeDataUriRegex);
  if (dataUriMatch) {
    return {
      filename: `<data:${dataUriMatch[2]}>`,
      function: dataUriMatch[1]
    };
  }
  const noFnParts = chromeRegexNoFnName.exec(line);
  if (noFnParts) {
    const [, filename, line2, col] = noFnParts;
    return createFrame(filename, UNKNOWN_FUNCTION, +line2, +col);
  }
  const parts = chromeRegex.exec(line);
  if (parts) {
    const isEval = ((_a = parts[2]) == null ? void 0 : _a.indexOf("eval")) === 0;
    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);
      if (subMatch) {
        parts[2] = subMatch[1];
        parts[3] = subMatch[2];
        parts[4] = subMatch[3];
      }
    }
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);
    return createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
  }
  return;
};
const chromeStackLineParser = [CHROME_PRIORITY, chromeStackParserFn];
const geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const gecko = (line) => {
  const parts = geckoREgex.exec(line);
  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);
      if (subMatch) {
        parts[1] = parts[1] || "eval";
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = "";
      }
    }
    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);
    return createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
  }
  return;
};
const geckoStackLineParser = [GECKO_PRIORITY, gecko];
const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser];
const defaultStackParser = createStackParser(...defaultStackLineParsers);
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf("safari-extension") !== -1;
  const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
  return isSafariExtension || isSafariWebExtension ? [
    func.indexOf("@") !== -1 ? func.split("@")[0] : UNKNOWN_FUNCTION,
    isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
  ] : [func, filename];
};
const MAX_ALLOWED_STRING_LENGTH = 1024;
const INTEGRATION_NAME$4 = "Breadcrumbs";
const _breadcrumbsIntegration = (options = {}) => {
  const _options = {
    console: true,
    dom: true,
    fetch: true,
    history: true,
    sentry: true,
    xhr: true,
    ...options
  };
  return {
    name: INTEGRATION_NAME$4,
    setup(client) {
      if (_options.console) {
        addConsoleInstrumentationHandler(_getConsoleBreadcrumbHandler(client));
      }
      if (_options.dom) {
        addClickKeypressInstrumentationHandler(_getDomBreadcrumbHandler(client, _options.dom));
      }
      if (_options.xhr) {
        addXhrInstrumentationHandler(_getXhrBreadcrumbHandler(client));
      }
      if (_options.fetch) {
        addFetchInstrumentationHandler(_getFetchBreadcrumbHandler(client));
      }
      if (_options.history) {
        addHistoryInstrumentationHandler(_getHistoryBreadcrumbHandler(client));
      }
      if (_options.sentry) {
        client.on("beforeSendEvent", _getSentryBreadcrumbHandler(client));
      }
    }
  };
};
const breadcrumbsIntegration = defineIntegration(_breadcrumbsIntegration);
function _getSentryBreadcrumbHandler(client) {
  return function addSentryBreadcrumb(event) {
    if (getClient() !== client) {
      return;
    }
    addBreadcrumb(
      {
        category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
        event_id: event.event_id,
        level: event.level,
        message: getEventDescription(event)
      },
      {
        event
      }
    );
  };
}
function _getDomBreadcrumbHandler(client, dom) {
  return function _innerDomBreadcrumb(handlerData) {
    if (getClient() !== client) {
      return;
    }
    let target;
    let componentName;
    let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
    let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      DEBUG_BUILD && debug.warn(
        `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`
      );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }
    if (typeof keyAttrs === "string") {
      keyAttrs = [keyAttrs];
    }
    try {
      const event = handlerData.event;
      const element = _isEvent(event) ? event.target : event;
      target = htmlTreeAsString(element, { keyAttrs, maxStringLength });
      componentName = getComponentName(element);
    } catch {
      target = "<unknown>";
    }
    if (target.length === 0) {
      return;
    }
    const breadcrumb = {
      category: `ui.${handlerData.name}`,
      message: target
    };
    if (componentName) {
      breadcrumb.data = { "ui.component_name": componentName };
    }
    addBreadcrumb(breadcrumb, {
      event: handlerData.event,
      name: handlerData.name,
      global: handlerData.global
    });
  };
}
function _getConsoleBreadcrumbHandler(client) {
  return function _consoleBreadcrumb(handlerData) {
    if (getClient() !== client) {
      return;
    }
    const breadcrumb = {
      category: "console",
      data: {
        arguments: handlerData.args,
        logger: "console"
      },
      level: severityLevelFromString(handlerData.level),
      message: safeJoin(handlerData.args, " ")
    };
    if (handlerData.level === "assert") {
      if (handlerData.args[0] === false) {
        breadcrumb.message = `Assertion failed: ${safeJoin(handlerData.args.slice(1), " ") || "console.assert"}`;
        breadcrumb.data.arguments = handlerData.args.slice(1);
      } else {
        return;
      }
    }
    addBreadcrumb(breadcrumb, {
      input: handlerData.args,
      level: handlerData.level
    });
  };
}
function _getXhrBreadcrumbHandler(client) {
  return function _xhrBreadcrumb(handlerData) {
    if (getClient() !== client) {
      return;
    }
    const { startTimestamp, endTimestamp } = handlerData;
    const sentryXhrData = handlerData.xhr[SENTRY_XHR_DATA_KEY];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) {
      return;
    }
    const { method, url, status_code, body } = sentryXhrData;
    const data = {
      method,
      url,
      status_code
    };
    const hint = {
      xhr: handlerData.xhr,
      input: body,
      startTimestamp,
      endTimestamp
    };
    const breadcrumb = {
      category: "xhr",
      data,
      type: "http",
      level: getBreadcrumbLogLevelFromHttpStatusCode(status_code)
    };
    client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
    addBreadcrumb(breadcrumb, hint);
  };
}
function _getFetchBreadcrumbHandler(client) {
  return function _fetchBreadcrumb(handlerData) {
    if (getClient() !== client) {
      return;
    }
    const { startTimestamp, endTimestamp } = handlerData;
    if (!endTimestamp) {
      return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") {
      return;
    }
    if (handlerData.error) {
      const hint = {
        data: handlerData.error,
        input: handlerData.args,
        startTimestamp,
        endTimestamp
      };
      const breadcrumb = {
        category: "fetch",
        data: handlerData.fetchData,
        level: "error",
        type: "http"
      };
      client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
      addBreadcrumb(breadcrumb, hint);
    } else {
      const response = handlerData.response;
      const data = {
        ...handlerData.fetchData,
        status_code: response == null ? void 0 : response.status
      };
      const hint = {
        input: handlerData.args,
        response,
        startTimestamp,
        endTimestamp
      };
      const breadcrumb = {
        category: "fetch",
        data,
        type: "http",
        level: getBreadcrumbLogLevelFromHttpStatusCode(data.status_code)
      };
      client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
      addBreadcrumb(breadcrumb, hint);
    }
  };
}
function _getHistoryBreadcrumbHandler(client) {
  return function _historyBreadcrumb(handlerData) {
    if (getClient() !== client) {
      return;
    }
    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = parseUrl(WINDOW$1.location.href);
    let parsedFrom = from ? parseUrl(from) : void 0;
    const parsedTo = parseUrl(to);
    if (!(parsedFrom == null ? void 0 : parsedFrom.path)) {
      parsedFrom = parsedLoc;
    }
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
      to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
      from = parsedFrom.relative;
    }
    addBreadcrumb({
      category: "navigation",
      data: {
        from,
        to
      }
    });
  };
}
function _isEvent(event) {
  return !!event && !!event.target;
}
const DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(
  ","
);
const INTEGRATION_NAME$3 = "BrowserApiErrors";
const _browserApiErrorsIntegration = (options = {}) => {
  const _options = {
    XMLHttpRequest: true,
    eventTarget: true,
    requestAnimationFrame: true,
    setInterval: true,
    setTimeout: true,
    unregisterOriginalCallbacks: false,
    ...options
  };
  return {
    name: INTEGRATION_NAME$3,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      if (_options.setTimeout) {
        fill(WINDOW$1, "setTimeout", _wrapTimeFunction);
      }
      if (_options.setInterval) {
        fill(WINDOW$1, "setInterval", _wrapTimeFunction);
      }
      if (_options.requestAnimationFrame) {
        fill(WINDOW$1, "requestAnimationFrame", _wrapRAF);
      }
      if (_options.XMLHttpRequest && "XMLHttpRequest" in WINDOW$1) {
        fill(XMLHttpRequest.prototype, "send", _wrapXHR);
      }
      const eventTargetOption = _options.eventTarget;
      if (eventTargetOption) {
        const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
        eventTarget.forEach((target) => _wrapEventTarget(target, _options));
      }
    }
  };
};
const browserApiErrorsIntegration = defineIntegration(_browserApiErrorsIntegration);
function _wrapTimeFunction(original) {
  return function(...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        handled: false,
        type: `auto.browser.browserapierrors.${getFunctionName(original)}`
      }
    });
    return original.apply(this, args);
  };
}
function _wrapRAF(original) {
  return function(callback) {
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            handler: getFunctionName(original)
          },
          handled: false,
          type: "auto.browser.browserapierrors.requestAnimationFrame"
        }
      })
    ]);
  };
}
function _wrapXHR(originalSend) {
  return function(...args) {
    const xhr = this;
    const xmlHttpRequestProps = ["onload", "onerror", "onprogress", "onreadystatechange"];
    xmlHttpRequestProps.forEach((prop) => {
      if (prop in xhr && typeof xhr[prop] === "function") {
        fill(xhr, prop, function(original) {
          const wrapOptions = {
            mechanism: {
              data: {
                handler: getFunctionName(original)
              },
              handled: false,
              type: `auto.browser.browserapierrors.xhr.${prop}`
            }
          };
          const originalFunction = getOriginalFunction(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = getFunctionName(originalFunction);
          }
          return wrap(original, wrapOptions);
        });
      }
    });
    return originalSend.apply(this, args);
  };
}
function _wrapEventTarget(target, integrationOptions) {
  var _a, _b;
  const globalObject = WINDOW$1;
  const proto = (_a = globalObject[target]) == null ? void 0 : _a.prototype;
  if (!((_b = proto == null ? void 0 : proto.hasOwnProperty) == null ? void 0 : _b.call(proto, "addEventListener"))) {
    return;
  }
  fill(proto, "addEventListener", function(original) {
    return function(eventName, fn, options) {
      try {
        if (isEventListenerObject(fn)) {
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                handler: getFunctionName(fn),
                target
              },
              handled: false,
              type: "auto.browser.browserapierrors.handleEvent"
            }
          });
        }
      } catch {
      }
      if (integrationOptions.unregisterOriginalCallbacks) {
        unregisterOriginalCallback(this, eventName, fn);
      }
      return original.apply(this, [
        eventName,
        wrap(fn, {
          mechanism: {
            data: {
              handler: getFunctionName(fn),
              target
            },
            handled: false,
            type: "auto.browser.browserapierrors.addEventListener"
          }
        }),
        options
      ]);
    };
  });
  fill(proto, "removeEventListener", function(originalRemoveEventListener) {
    return function(eventName, fn, options) {
      try {
        if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
          const originalEventHandler = fn.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        }
      } catch {
      }
      return originalRemoveEventListener.call(this, eventName, fn, options);
    };
  });
}
function isEventListenerObject(obj) {
  return typeof obj.handleEvent === "function";
}
function unregisterOriginalCallback(target, eventName, fn) {
  if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") {
    target.removeEventListener(eventName, fn);
  }
}
const browserSessionIntegration = defineIntegration((options = {}) => {
  const lifecycle = options.lifecycle ?? "route";
  return {
    name: "BrowserSession",
    setupOnce() {
      if (typeof WINDOW$1.document === "undefined") {
        DEBUG_BUILD && debug.warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
        return;
      }
      startSession({ ignoreDuration: true });
      captureSession();
      const isolationScope = getIsolationScope();
      let previousUser = isolationScope.getUser();
      isolationScope.addScopeListener((scope) => {
        const maybeNewUser = scope.getUser();
        if ((previousUser == null ? void 0 : previousUser.id) !== (maybeNewUser == null ? void 0 : maybeNewUser.id) || (previousUser == null ? void 0 : previousUser.ip_address) !== (maybeNewUser == null ? void 0 : maybeNewUser.ip_address)) {
          captureSession();
          previousUser = maybeNewUser;
        }
      });
      if (lifecycle === "route") {
        addHistoryInstrumentationHandler(({ from, to }) => {
          if (from !== to) {
            startSession({ ignoreDuration: true });
            captureSession();
          }
        });
      }
    }
  };
});
const INTEGRATION_NAME$2 = "CultureContext";
const _cultureContextIntegration = () => {
  return {
    name: INTEGRATION_NAME$2,
    preprocessEvent(event) {
      var _a;
      const culture = getCultureContext();
      if (culture) {
        event.contexts = {
          ...event.contexts,
          culture: { ...culture, ...(_a = event.contexts) == null ? void 0 : _a.culture }
        };
      }
    },
    processSegmentSpan(span) {
      const culture = getCultureContext();
      if (culture) {
        safeSetSpanJSONAttributes(span, {
          "culture.locale": culture.locale,
          "culture.timezone": culture.timezone,
          "culture.calendar": culture.calendar
        });
      }
    }
  };
};
const cultureContextIntegration = defineIntegration(_cultureContextIntegration);
function getCultureContext() {
  try {
    const intl = WINDOW$1.Intl;
    if (!intl) {
      return void 0;
    }
    const options = intl.DateTimeFormat().resolvedOptions();
    return {
      locale: options.locale,
      timezone: options.timeZone,
      calendar: options.calendar
    };
  } catch {
    return void 0;
  }
}
const INTEGRATION_NAME$1 = "GlobalHandlers";
const _globalHandlersIntegration = (options = {}) => {
  const _options = {
    onerror: true,
    onunhandledrejection: true,
    ...options
  };
  return {
    name: INTEGRATION_NAME$1,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(client) {
      if (_options.onerror) {
        _installGlobalOnErrorHandler(client);
        globalHandlerLog("onerror");
      }
      if (_options.onunhandledrejection) {
        _installGlobalOnUnhandledRejectionHandler(client);
        globalHandlerLog("onunhandledrejection");
      }
    }
  };
};
const globalHandlersIntegration = defineIntegration(_globalHandlersIntegration);
function _installGlobalOnErrorHandler(client) {
  addGlobalErrorInstrumentationHandler((data) => {
    const { stackParser, attachStacktrace } = getOptions();
    if (getClient() !== client || shouldIgnoreOnError()) {
      return;
    }
    const { msg, url, line, column, error: error2 } = data;
    const event = _enhanceEventWithInitialFrame(
      eventFromUnknownInput(stackParser, error2 || msg, void 0, attachStacktrace, false),
      url,
      line,
      column
    );
    event.level = "error";
    captureEvent(event, {
      originalException: error2,
      mechanism: {
        handled: false,
        type: "auto.browser.global_handlers.onerror"
      }
    });
  });
}
function _installGlobalOnUnhandledRejectionHandler(client) {
  addGlobalUnhandledRejectionInstrumentationHandler((e) => {
    const { stackParser, attachStacktrace } = getOptions();
    if (getClient() !== client || shouldIgnoreOnError()) {
      return;
    }
    const error2 = _getUnhandledRejectionError(e);
    const event = isPrimitive(error2) ? _eventFromRejectionWithPrimitive(error2) : eventFromUnknownInput(stackParser, error2, void 0, attachStacktrace, true);
    event.level = "error";
    captureEvent(event, {
      originalException: error2,
      mechanism: {
        handled: false,
        type: "auto.browser.global_handlers.onunhandledrejection"
      }
    });
  });
}
function _getUnhandledRejectionError(error2) {
  if (isPrimitive(error2)) {
    return error2;
  }
  try {
    if ("reason" in error2) {
      return error2.reason;
    }
    if ("detail" in error2 && "reason" in error2.detail) {
      return error2.detail.reason;
    }
  } catch {
  }
  return error2;
}
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`
        }
      ]
    }
  };
}
function _enhanceEventWithInitialFrame(event, url, lineno, colno) {
  const e = event.exception = event.exception || {};
  const ev = e.values = e.values || [];
  const ev0 = ev[0] = ev[0] || {};
  const ev0s = ev0.stacktrace = ev0.stacktrace || {};
  const ev0sf = ev0s.frames = ev0s.frames || [];
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      lineno,
      filename: getFilenameFromUrl(url) ?? getLocationHref(),
      function: UNKNOWN_FUNCTION,
      in_app: true
    });
  }
  return event;
}
function globalHandlerLog(type) {
  DEBUG_BUILD && debug.log(`Global Handler attached: ${type}`);
}
function getOptions() {
  const client = getClient();
  const options = (client == null ? void 0 : client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false
  };
  return options;
}
function getFilenameFromUrl(url) {
  if (!isString(url) || url.length === 0) {
    return void 0;
  }
  if (url.startsWith("data:")) {
    return `<${stripDataUrlContent(url, false)}>`;
  }
  return url;
}
const httpContextIntegration = defineIntegration(() => {
  return {
    name: "HttpContext",
    preprocessEvent(event) {
      var _a;
      if (!WINDOW$1.navigator && !WINDOW$1.location && !WINDOW$1.document) {
        return;
      }
      const reqData = getHttpRequestData();
      const headers = {
        ...reqData.headers,
        ...(_a = event.request) == null ? void 0 : _a.headers
      };
      event.request = {
        ...reqData,
        ...event.request,
        headers
      };
    },
    processSegmentSpan(span) {
      var _a;
      const spanOp = (_a = span.attributes) == null ? void 0 : _a[SEMANTIC_ATTRIBUTE_SENTRY_OP];
      if (!WINDOW$1.navigator && !WINDOW$1.location && !WINDOW$1.document) {
        return;
      }
      const reqData = getHttpRequestData();
      safeSetSpanJSONAttributes(span, {
        // Coerce empty string to undefined so the helper's nullish check drops it,
        // rather than writing an empty `url.full` attribute onto the span.
        "url.full": spanOp !== "http.client" ? reqData.url : void 0,
        "http.request.header.user_agent": reqData.headers["User-Agent"],
        "http.request.header.referer": reqData.headers["Referer"]
      });
    }
  };
});
const DEFAULT_KEY = "cause";
const DEFAULT_LIMIT = 5;
const INTEGRATION_NAME = "LinkedErrors";
const _linkedErrorsIntegration = (options = {}) => {
  const limit = options.limit || DEFAULT_LIMIT;
  const key = options.key || DEFAULT_KEY;
  return {
    name: INTEGRATION_NAME,
    preprocessEvent(event, hint, client) {
      const options2 = client.getOptions();
      applyAggregateErrorsToEvent(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        exceptionFromError,
        options2.stackParser,
        key,
        limit,
        event,
        hint
      );
    }
  };
};
const linkedErrorsIntegration = defineIntegration(_linkedErrorsIntegration);
const HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function normalizeStringifyValue(value) {
  if (typeof window !== "undefined" && value === window) {
    return "[Window]";
  }
  if (typeof document !== "undefined" && value === document) {
    return "[Document]";
  }
  if (isElement(value)) {
    const objName = getConstructorName(value);
    if (HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) {
      return `[HTMLElement: ${htmlTreeAsString(value)}]`;
    }
  }
  return void 0;
}
function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);
  return (prototype == null ? void 0 : prototype.constructor) ? prototype.constructor.name : "null prototype";
}
function checkAndWarnIfIsEmbeddedBrowserExtension() {
  if (_isEmbeddedBrowserExtension()) {
    if (DEBUG_BUILD) {
      consoleSandbox(() => {
        console.error(
          "[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
        );
      });
    }
    return true;
  }
  return false;
}
function _isEmbeddedBrowserExtension() {
  var _a;
  if (typeof WINDOW$1.window === "undefined") {
    return false;
  }
  const _window = WINDOW$1;
  if (_window.nw) {
    return false;
  }
  const extensionObject = _window["chrome"] || _window["browser"];
  if (!((_a = extensionObject == null ? void 0 : extensionObject.runtime) == null ? void 0 : _a.id)) {
    return false;
  }
  const href = getLocationHref();
  const isDedicatedExtensionPage = WINDOW$1 === WINDOW$1.top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
  return !isDedicatedExtensionPage;
}
function getDefaultIntegrations(_options) {
  return [
    // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
    // eslint-disable-next-line typescript/no-deprecated
    inboundFiltersIntegration(),
    functionToStringIntegration(),
    conversationIdIntegration(),
    browserApiErrorsIntegration(),
    breadcrumbsIntegration(),
    globalHandlersIntegration(),
    linkedErrorsIntegration(),
    dedupeIntegration(),
    httpContextIntegration(),
    cultureContextIntegration(),
    browserSessionIntegration()
  ];
}
function init(options = {}) {
  const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && checkAndWarnIfIsEmbeddedBrowserExtension();
  let defaultIntegrations = options.defaultIntegrations == null ? getDefaultIntegrations() : options.defaultIntegrations;
  const clientOptions = {
    ...options,
    enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
    stackParser: stackParserFromStackParserOptions(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup({
      integrations: options.integrations,
      defaultIntegrations
    }),
    transport: options.transport || makeFetchTransport
  };
  setNormalizeStringifier(normalizeStringifyValue);
  return initAndBind(BrowserClient, clientOptions);
}
let isSentryInitialized = false;
const DEFAULT_BOX_BUILDER_DSN = "https://5c4122c49fba7260f1ba268552384d9c@o1123257.ingest.us.sentry.io/4511195019018240";
const MIX_AND_MATCH_422_PREFIX = "[Mix&Match] cart/add.js failed with 422:";
function resolveDsn(config) {
  var _a, _b;
  return (config == null ? void 0 : config.sentryDsn) || ((_b = (_a = window == null ? void 0 : window.themeVariables) == null ? void 0 : _a.sentry) == null ? void 0 : _b.dsn) || (window == null ? void 0 : window.SENTRY_DSN) || DEFAULT_BOX_BUILDER_DSN;
}
function initBoxBuilderSentry(config = {}) {
  var _a, _b;
  if (isSentryInitialized) return;
  const dsn = resolveDsn(config);
  init({
    dsn,
    sendDefaultPii: true,
    environment: ((_a = window == null ? void 0 : window.Shopify) == null ? void 0 : _a.shop) || "unknown-shop",
    release: ((_b = window == null ? void 0 : window.themeVariables) == null ? void 0 : _b.themeVersion) || "theme-unknown",
    beforeSend(event) {
      var _a2, _b2, _c, _d, _e;
      const eventMessage = (event == null ? void 0 : event.message) || ((_c = (_b2 = (_a2 = event == null ? void 0 : event.exception) == null ? void 0 : _a2.values) == null ? void 0 : _b2[0]) == null ? void 0 : _c.value) || "";
      const isMixAndMatch422Message = String(eventMessage).startsWith(MIX_AND_MATCH_422_PREFIX);
      const isBoxBuilderModule = ((_d = event == null ? void 0 : event.tags) == null ? void 0 : _d.module) === "box-builder";
      const isHttp422 = String((_e = event == null ? void 0 : event.tags) == null ? void 0 : _e.http_status) === "422";
      if (isMixAndMatch422Message && isBoxBuilderModule && isHttp422) {
        return event;
      }
      return null;
    }
  });
  isSentryInitialized = true;
}
function captureBoxBuilder422({ error: error2, context = {} }) {
  if (!isSentryInitialized || !withScope || !captureException) {
    return;
  }
  withScope((scope) => {
    var _a, _b, _c, _d;
    scope.setLevel("error");
    scope.setTag("module", "box-builder");
    scope.setTag("feature", "add-bundle-to-cart");
    scope.setTag("http_status", "422");
    scope.setTag("shop", ((_a = window == null ? void 0 : window.Shopify) == null ? void 0 : _a.shop) || "unknown");
    scope.setTag("currency", ((_c = (_b = window == null ? void 0 : window.Shopify) == null ? void 0 : _b.currency) == null ? void 0 : _c.active) || "unknown");
    scope.setTag("locale", ((_d = window == null ? void 0 : window.Shopify) == null ? void 0 : _d.locale) || "unknown");
    scope.setContext("box_builder_request", context.request || {});
    scope.setContext("box_builder_response", context.response || {});
    scope.setContext("box_builder_state", context.state || {});
    scope.setContext("box_builder_runtime", context.runtime || {});
    scope.setContext("box_builder_cart", context.cart || {});
    if (context == null ? void 0 : context.extra) {
      Object.entries(context.extra).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
    }
    captureException(error2 instanceof Error ? error2 : new Error(`${MIX_AND_MATCH_422_PREFIX} unknown`));
  });
}
const _sfc_main$g = {
  props: [
    "isDisabled",
    "bbHeaderCoords"
  ],
  data() {
    return {
      expandedView: false,
      slotsInFirstRow: 5,
      productsPerRow: 5,
      specificDiscountedVariantIndex: "",
      initedFromSessionStorage: false,
      is_old_checkout: this.$store.state.config.is_old_checkout,
      proccessingAddToCart: false,
      discountMessageIcon: '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="25" viewBox="0 0 21 25" fill="none"><path d="M21 1.97932C21 2.32767 20.7724 2.64032 20.4341 2.75972C19.596 3.05391 19.5833 3.48474 19.5769 3.68045L18.9195 23.3629C18.8902 24.2811 18.1234 25 17.1747 25H3.82535C2.87664 25 2.10979 24.2811 2.08054 23.3641L1.42306 3.66937C1.41797 3.48474 1.40399 3.05391 0.565918 2.76096C0.22764 2.64279 0 2.3289 0 1.98055V0H21V1.97932ZM3.82662 23.7691H17.1747C17.4315 23.7691 17.6401 23.5746 17.6477 23.3247L18.1984 6.82792H2.80034L3.351 23.3259C3.35863 23.5746 3.56719 23.7703 3.82408 23.7703L3.82662 23.7691ZM19.7283 1.23092H1.273V1.70975C1.95591 2.01009 2.66172 2.57632 2.69479 3.64106L2.75965 5.597H18.2404L18.3065 3.63245C18.3396 2.57632 19.0466 2.01009 19.7283 1.71098V1.23092Z" fill="currentColor"/><path d="M8.7482 20.2905H12.3586C12.7096 20.2905 12.9945 20.5662 12.9945 20.906C12.9945 21.2457 12.7096 21.5214 12.3586 21.5214H8.7482C8.3972 21.5214 8.11234 21.2457 8.11234 20.906C8.11234 20.5662 8.3972 20.2905 8.7482 20.2905Z" fill="currentColor"/><path d="M12.8521 17.6539C12.8521 17.9936 12.5672 18.2693 12.2162 18.2693C11.8652 18.2693 11.5803 17.9936 11.5803 17.6539C11.5803 17.3523 11.6414 17.0606 11.7609 16.7861C12.117 15.97 12.9322 15.4394 13.8453 15.4247C13.8516 15.4247 13.858 15.4247 13.8656 15.4247H13.8834C13.8898 15.4247 13.8974 15.4247 13.9038 15.4247C14.794 15.4394 15.6003 15.9515 15.9665 16.7381C16.1102 17.0483 15.9678 17.4126 15.6473 17.5517C15.3268 17.6908 14.9504 17.5529 14.8067 17.2427C14.6414 16.8882 14.2764 16.6581 13.8745 16.6544C13.4625 16.6581 13.0937 16.8956 12.9334 17.2637C12.88 17.3868 12.8533 17.5172 12.8533 17.6526L12.8521 17.6539Z" fill="currentColor"/><path d="M5.23442 17.5529C4.91395 17.4138 4.77151 17.0495 4.91522 16.7393C5.28148 15.9527 6.08775 15.4394 6.97796 15.4259C6.98431 15.4259 6.99067 15.4259 6.9983 15.4259H7.01611C7.02247 15.4259 7.02883 15.4259 7.03646 15.4259C7.94955 15.4407 8.76473 15.9712 9.12081 16.7861C9.24036 17.0618 9.3014 17.3535 9.3014 17.6539C9.3014 17.9936 9.01653 18.2693 8.66554 18.2693C8.31454 18.2693 8.02967 17.9936 8.02967 17.6539C8.02967 17.5185 8.00297 17.388 7.94955 17.2649C7.78932 16.8968 7.42052 16.6593 7.00848 16.6556C6.60661 16.6593 6.24163 16.8895 6.0763 17.244C5.9326 17.5542 5.55617 17.692 5.23569 17.5529H5.23442Z" fill="currentColor"/><path d="M16.0301 19.1876C16.6761 19.1876 17.1632 19.4916 17.1632 19.8941C17.1632 20.2966 16.6761 20.6007 16.0301 20.6007C15.3841 20.6007 14.897 20.2966 14.897 19.8941C14.897 19.4916 15.3841 19.1876 16.0301 19.1876Z" fill="currentColor"/><path d="M4.94193 19.1876C5.58796 19.1876 6.07503 19.4916 6.07503 19.8941C6.07503 20.2966 5.58796 20.6007 4.94193 20.6007C4.29589 20.6007 3.80882 20.2966 3.80882 19.8941C3.80882 19.4916 4.29589 19.1876 4.94193 19.1876Z" fill="currentColor"/></svg>'
    };
  },
  created() {
    if (this.is_old_checkout) {
      this.initItemsFromSessionStorage();
    }
  },
  methods: {
    getResponseHeaders(response) {
      var _a;
      const headers = {};
      (_a = response == null ? void 0 : response.headers) == null ? void 0 : _a.forEach((value, key) => {
        headers[key] = value;
      });
      return headers;
    },
    getSafeJson(value, fallback = null) {
      try {
        return JSON.parse(JSON.stringify(value));
      } catch (e) {
        return fallback;
      }
    },
    getAllCookiesObject() {
      const cookiesRaw = (document == null ? void 0 : document.cookie) || "";
      if (!cookiesRaw) return {};
      return cookiesRaw.split(";").reduce((acc, part) => {
        const trimmed = part.trim();
        const separatorIndex = trimmed.indexOf("=");
        if (separatorIndex < 0) return acc;
        const key = trimmed.slice(0, separatorIndex);
        const value = trimmed.slice(separatorIndex + 1);
        acc[key] = decodeURIComponent(value || "");
        return acc;
      }, {});
    },
    buildNestedItemsDetails(items = []) {
      var _a, _b, _c;
      const nestedMap = ((_b = (_a = items == null ? void 0 : items[0]) == null ? void 0 : _a.properties) == null ? void 0 : _b._nestedVariantsIds) || {};
      const variantsIndex = new Map((this.productsVariants || []).map((v) => [String(v.id), v]));
      const baseUrl = ((_c = window == null ? void 0 : window.location) == null ? void 0 : _c.origin) || "";
      return Object.entries(nestedMap).map(([variantId, quantity]) => {
        const variant = variantsIndex.get(String(variantId));
        const product = (variant == null ? void 0 : variant.product) || {};
        const productHandle = (product == null ? void 0 : product.handle) || "";
        const productUrl = productHandle ? `${baseUrl}/products/${productHandle}` : "";
        return {
          variantId: String(variantId),
          quantity,
          variantTitle: (variant == null ? void 0 : variant.title) || "",
          productTitle: (variant == null ? void 0 : variant.productTitle) || (product == null ? void 0 : product.title) || "",
          productHandle,
          productUrl,
          variantSku: (variant == null ? void 0 : variant.sku) || "",
          stepName: (variant == null ? void 0 : variant.stepName) || "",
          tabName: (variant == null ? void 0 : variant.tabName) || ""
        };
      });
    },
    buildNestedItemsHumanSummary(nestedItemsDetails = []) {
      if (!nestedItemsDetails.length) {
        return "No nested items found in request payload.";
      }
      return nestedItemsDetails.map((item) => {
        const title = item.productTitle || item.variantTitle || `Variant ${item.variantId}`;
        const quantity = item.quantity || 0;
        const skuPart = item.variantSku ? `, SKU: ${item.variantSku}` : "";
        const stepPart = item.stepName ? `, Step: ${item.stepName}` : "";
        const tabPart = item.tabName ? `, Tab: ${item.tabName}` : "";
        const urlPart = item.productUrl ? `, URL: ${item.productUrl}` : "";
        return `Qty ${quantity} x ${title} (Variant ID: ${item.variantId}${skuPart}${stepPart}${tabPart}${urlPart})`;
      }).join(" | ");
    },
    build422SentryContext({
      response,
      responseJson,
      responseText,
      formData,
      items,
      orderTimestamp
    }) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B;
      const allCookies = this.getAllCookiesObject();
      const nestedItemsDetails = this.buildNestedItemsDetails(items);
      const nestedItemsSummary = this.buildNestedItemsHumanSummary(nestedItemsDetails);
      const cartCookie = this.getCookie("box-builder-products");
      const requestItemsCount = Array.isArray(items) ? items.length : 0;
      const nestedItemsCount = nestedItemsDetails.length;
      return {
        request: {
          url: "/cart/add.js",
          method: "POST",
          payload: this.getSafeJson(formData, {}),
          items: this.getSafeJson(items, []),
          timestamp: orderTimestamp
        },
        response: {
          status: response == null ? void 0 : response.status,
          statusText: response == null ? void 0 : response.statusText,
          ok: response == null ? void 0 : response.ok,
          url: response == null ? void 0 : response.url,
          headers: this.getResponseHeaders(response),
          bodyJson: this.getSafeJson(responseJson, {}),
          bodyText: responseText || ""
        },
        state: {
          addedQty: this.addedQty,
          discount: this.discount,
          currentStep: this.getSafeJson(this.currentStep, {}),
          productsVariants: this.getSafeJson(this.productsVariants, []),
          productsBoxWithVariants: this.getSafeJson(this.productsBoxWithVariants, []),
          cartCookie: this.getCookie("box-builder-products"),
          config: this.getSafeJson((_b = (_a = this.$store) == null ? void 0 : _a.state) == null ? void 0 : _b.config, {})
        },
        cart: {
          cartUrl: ((_d = (_c = window == null ? void 0 : window.themeVariables) == null ? void 0 : _c.routes) == null ? void 0 : _d.cartUrl) || "",
          routeRoot: ((_f = (_e = window == null ? void 0 : window.Shopify) == null ? void 0 : _e.routes) == null ? void 0 : _f.root) || ""
        },
        runtime: {
          pageUrl: ((_g = window == null ? void 0 : window.location) == null ? void 0 : _g.href) || "",
          referrer: (document == null ? void 0 : document.referrer) || "",
          userAgent: (navigator == null ? void 0 : navigator.userAgent) || "",
          language: (navigator == null ? void 0 : navigator.language) || "",
          viewport: {
            width: window == null ? void 0 : window.innerWidth,
            height: window == null ? void 0 : window.innerHeight
          },
          shopify: this.getSafeJson(window == null ? void 0 : window.Shopify, {}),
          themeVariables: this.getSafeJson(window == null ? void 0 : window.themeVariables, {})
        },
        extra: {
          sectionId: ((_k = (_j = (_i = (_h = this.$store) == null ? void 0 : _h.state) == null ? void 0 : _i.config) == null ? void 0 : _j.section) == null ? void 0 : _k.id) || "",
          parentVariantId: ((_n = (_m = (_l = this.$store) == null ? void 0 : _l.state) == null ? void 0 : _m.config) == null ? void 0 : _n.parentVariantId) || "",
          rootId: ((_q = (_p = (_o = this.$store) == null ? void 0 : _o.state) == null ? void 0 : _p.config) == null ? void 0 : _q.rootId) || "",
          nestedItemsDetails: this.getSafeJson(nestedItemsDetails, []),
          nestedItemsRawMap: this.getSafeJson(((_s = (_r = items == null ? void 0 : items[0]) == null ? void 0 : _r.properties) == null ? void 0 : _s._nestedVariantsIds) || {}, {}),
          requestItemsRaw: this.getSafeJson(items, []),
          humanReadableSummary: `422 on /cart/add.js. Parent variant: ${((_v = (_u = (_t = this.$store) == null ? void 0 : _t.state) == null ? void 0 : _u.config) == null ? void 0 : _v.parentVariantId) || "n/a"}. Root ID: ${((_y = (_x = (_w = this.$store) == null ? void 0 : _w.state) == null ? void 0 : _x.config) == null ? void 0 : _y.rootId) || "n/a"}. Request items count: ${requestItemsCount}. Nested items count: ${nestedItemsCount}.`,
          nestedItemsSummary,
          cartCookie,
          allCookies: this.getSafeJson(allCookies, {}),
          allCookieKeys: Object.keys(allCookies),
          currentPath: ((_z = window == null ? void 0 : window.location) == null ? void 0 : _z.pathname) || "",
          currentQuery: ((_A = window == null ? void 0 : window.location) == null ? void 0 : _A.search) || "",
          currentHash: ((_B = window == null ? void 0 : window.location) == null ? void 0 : _B.hash) || ""
        }
      };
    },
    getBundleTooBigErrorText() {
      var _a, _b, _c, _d;
      return ((_d = (_c = (_b = (_a = this.$store) == null ? void 0 : _a.state) == null ? void 0 : _b.config) == null ? void 0 : _c.translations) == null ? void 0 : _d.bundleTooBigError) || "Your bundle is too big. Please remove some items and try again.";
    },
    findAddedBundleLineItem(cartContent, orderTimestamp) {
      var _a, _b, _c;
      const parentVariantId = String(((_c = (_b = (_a = this.$store) == null ? void 0 : _a.state) == null ? void 0 : _b.config) == null ? void 0 : _c.parentVariantId) || "");
      const expectedTimestamp = String(orderTimestamp || "");
      const items = (cartContent == null ? void 0 : cartContent.items) || [];
      return items.find((item) => {
        var _a2;
        const matchesVariant = String(item == null ? void 0 : item.id) === parentVariantId;
        const itemTimestamp = String(((_a2 = item == null ? void 0 : item.properties) == null ? void 0 : _a2._order_timestamp) || "");
        const matchesTimestamp = expectedTimestamp ? itemTimestamp === expectedTimestamp : false;
        return matchesVariant && matchesTimestamp;
      }) || null;
    },
    isBundleZeroPrice(lineItem) {
      if (!lineItem) return false;
      return Number(lineItem.final_line_price) === 0 || Number(lineItem.final_price) === 0 || Number(lineItem.line_price) === 0 || Number(lineItem.price) === 0;
    },
    async removeLineItemFromCart(lineItemKey) {
      if (!lineItemKey) return null;
      return fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: 0
        })
      }).then((response) => response.json()).catch((error2) => {
        console.error("Error removing zero-price bundle from cart:", error2);
        return null;
      });
    },
    goToStep1() {
      this.$store.commit("setPassedStep", 0);
      const url = new URL(window.location.href);
      url.searchParams.set("tab", "1");
      window.history.replaceState({}, "", url);
    },
    async addToCart() {
      var _a;
      if (this.proccessingAddToCart || this.addedQty < 1 || this.disableATC) {
        return;
      }
      this.proccessingAddToCart = true;
      await this.removeBundleFromCart();
      setTimeout(() => {
        this.proccessingAddToCart = false;
      }, 3e3);
      var orderTimestamp = Date.now();
      let items = [];
      if (this.is_old_checkout) {
        this.productsVariants.forEach((variant) => {
          if (variant.available) {
            const foundIndex = items.findIndex((item) => item.id === variant.id);
            if (foundIndex === -1) {
              items.push({
                id: variant.id,
                quantity: 1,
                properties: {
                  _order_timestamp: orderTimestamp,
                  _has_specific_discount: variant.specificDiscount > 0,
                  _stepName: variant.stepName,
                  // needs to quick find this variant object in tabs on created hook
                  _tabName: variant.tabName
                  // needs to quick find this variant object in tabs on created hook
                }
              });
            } else {
              items[foundIndex].quantity++;
            }
          }
        });
      } else {
        const parentVariantId = this.$store.state.config.parentVariantId;
        if (!parentVariantId) return;
        const nestedProductVariantsIds = {};
        this.productsVariants.forEach((variant) => {
          if (nestedProductVariantsIds[variant.id]) {
            nestedProductVariantsIds[variant.id]++;
          } else {
            nestedProductVariantsIds[variant.id] = 1;
          }
        });
        items = [
          {
            id: parentVariantId,
            quantity: 1,
            properties: {
              _order_timestamp: orderTimestamp,
              _nestedVariantsIds: nestedProductVariantsIds,
              _bundle_type: "mix_powder",
              _root_id: (_a = this.$store.state.config) == null ? void 0 : _a.rootId
            }
          }
        ];
      }
      const formData = {
        "items": items
      };
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      }).then(async (response) => {
        let responseJson = {};
        let responseText = "";
        let notificationStatus = response.ok ? "success" : "error";
        let notificationErrorText = "";
        try {
          responseJson = await response.clone().json();
        } catch (e) {
          try {
            responseText = await response.clone().text();
          } catch (err) {
            responseText = "";
          }
        }
        if (!response.ok && response.status === 422) {
          const description = (responseJson == null ? void 0 : responseJson.description) || responseText || "Unprocessable Entity on /cart/add.js";
          const sentryError = new Error(`[Mix&Match] cart/add.js failed with 422: ${description}`);
          captureBoxBuilder422({
            error: sentryError,
            context: this.build422SentryContext({
              response,
              responseJson,
              responseText,
              formData,
              items,
              orderTimestamp
            })
          });
        }
        if (response.ok) {
          this.setCookie("box-builder-products", JSON.stringify(items), 1);
          const response2 = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
          const cartContent = await response2.json();
          const addedBundleLineItem = this.findAddedBundleLineItem(cartContent, orderTimestamp);
          const isZeroPriceBundle = this.isBundleZeroPrice(addedBundleLineItem);
          if (isZeroPriceBundle) {
            await this.removeLineItemFromCart(addedBundleLineItem == null ? void 0 : addedBundleLineItem.key);
            notificationStatus = "error";
            notificationErrorText = this.getBundleTooBigErrorText();
          } else {
            document.documentElement.dispatchEvent(new CustomEvent("variant:added", {
              bubbles: true,
              detail: {
                variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
              }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent
              }
            }));
            cartContent["sections"] = responseJson["sections"];
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: true
              }
            }));
          }
        }
        document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: notificationStatus,
            error: notificationErrorText || (responseJson == null ? void 0 : responseJson.description) || responseText || ""
          }
        }));
      }).catch((error2) => {
        console.error("Error:", error2);
      });
    },
    setCookie(key, value, daysToExpire = 1) {
      const expirationDate = /* @__PURE__ */ new Date();
      expirationDate.setTime(expirationDate.getTime() + daysToExpire * 24 * 60 * 60 * 1e3);
      const expires = "expires=" + expirationDate.toUTCString();
      document.cookie = key + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
    },
    getCookie(key) {
      const name = key + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(";");
      for (let i = 0; i < cookieArray.length; i++) {
        const cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
      return "";
    },
    async initItemsFromSessionStorage() {
      let products = this.getCookie("box-builder-products");
      if (!products) {
        return;
      }
      try {
        products = JSON.parse(products);
      } catch (error2) {
        console.error(error2);
      }
      let cartItems;
      await fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }).then((response) => {
        return response.json();
      }).then((data) => {
        cartItems = data.items;
        return data;
      }).catch((error2) => {
        console.error("Error:", error2);
      });
      const cartQuantityById = new Map(cartItems.map((item) => [item.id, item.quantity]));
      const updatedProducts = products.filter((product) => cartQuantityById.has(product.id)).map((product) => ({
        ...product,
        // Keep all existing fields
        quantity: cartQuantityById.get(product.id)
        // Update quantity
      }));
      updatedProducts.forEach((p2) => {
        const step = this.steps.find((s) => s.title === p2.properties._stepName);
        const tab = step.tabs.find((t) => t.title === p2.properties._tabName);
        const foundVariant = tab.variants.find((v) => v.id === p2.id);
        for (let i = 0; i < p2.quantity; i++) {
          this.$store.dispatch("addToBox", foundVariant);
        }
      });
      this.initedFromSessionStorage = true;
    },
    remove(variant) {
      const foundVariantIdx = this.productsVariants.findIndex(
        (v) => v.id === variant.id
      );
      if (foundVariantIdx < 0) {
        return;
      }
      const foundVariant = this.productsVariants[foundVariantIdx];
      if (foundVariant.specificDiscount) {
        this.$store.commit("disapplySpecificDiscount");
      }
      this.$store.dispatch("removeFromBox", foundVariant);
    },
    updateProductsPerRow() {
      this.productsPerRow = 5;
    },
    showDiscountInPlaceholder(item) {
      if (!this.isOnDiscountStep) return false;
      if (item.discountPercent == null) return false;
      if (item.showDiscountLabel === false) return false;
      const currentDiscount = this.discount || 0;
      return item.discountPercent > currentDiscount;
    },
    getBoxProductStyle(item) {
      var _a, _b, _c;
      const color = ((_a = item.variant) == null ? void 0 : _a.split_bg_color) || ((_c = (_b = item.variant) == null ? void 0 : _b.product) == null ? void 0 : _c.background_color_product_tile);
      if (!color || !String(color).trim()) return {};
      return { backgroundColor: color };
    },
    getBlockIndex(rowIdx, slotIdx, row) {
      return rowIdx * row.length + slotIdx;
    },
    expand() {
      if (this.addedQty > this.slotsInFirstRow) {
        this.expandedView = true;
      } else {
        this.expandedView = false;
      }
    },
    formatPrice(price, dontDevideBy100 = false) {
      var _a, _b, _c, _d, _e;
      const isUKStore = Shopify.currency.active === "GBP" || Shopify.locale === "en-GB";
      if (isUKStore) {
        if (dontDevideBy100) {
          const priceDecimalsLength = (_b = (_a = price.toString().split(".")) == null ? void 0 : _a[1]) == null ? void 0 : _b.length;
          if (priceDecimalsLength > 2) {
            price = +price.toString().slice(0, -1 * (priceDecimalsLength - 2));
          }
          if (priceDecimalsLength < 2) {
            price = +price.toFixed(2);
          }
          const result = price && price > 0 ? `${price}` : "0.00";
          return `£ ${result}`;
        } else {
          const result = price && price > 0 ? (price / 100).toFixed(2) : "0.00";
          return `£ ${result}`;
        }
      } else {
        if (dontDevideBy100) {
          const priceDecimalsLength = (_d = (_c = price.toString().split(".")) == null ? void 0 : _c[1]) == null ? void 0 : _d.length;
          if (priceDecimalsLength > 2) {
            price = +price.toString().slice(0, -1 * (priceDecimalsLength - 2));
          }
          if (priceDecimalsLength < 2) {
            price = +price.toFixed(2);
          }
          const result = price && price > 0 ? (_e = `${price}`) == null ? void 0 : _e.split(".").join(",") : "0,00";
          return `${result} ${this.$store.state.currency}`;
        } else {
          const result = price && price > 0 ? (price / 100).toFixed(2).split(".").join(",") : "0,00";
          return `${result} ${this.$store.state.currency}`;
        }
      }
    },
    goToNextStep() {
      if (this.isDisabled) {
        return;
      }
      this.$store.commit("setPassedStep", this.currentStep.number);
      window.scrollTo({ top: this.bbHeaderCoords.top - this.bbHeaderCoords.height * 2, behavior: "smooth" });
    },
    async removeBundleFromCart() {
      const updates = {};
      if (!this.is_old_checkout) {
        const parentVariantId = this.$store.state.config.parentVariantId;
        if (parentVariantId) {
          updates[parentVariantId] = 0;
        }
      } else {
        let products = this.getCookie("box-builder-products");
        if (!products) {
          return;
        }
        try {
          products = JSON.parse(products);
        } catch (error2) {
          console.error(error2);
        }
        products.reduce((obj, product) => {
          obj[product.id] = 0;
          return obj;
        }, updates);
      }
      if (Object.keys(updates).length === 0) {
        return;
      }
      return fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          updates
        })
      }).then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      }).catch((error2) => {
        console.error("Error:", error2);
      });
    }
  },
  mounted() {
    window.addEventListener("resize", this.updateProductsPerRow);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateProductsPerRow);
  },
  computed: {
    ...mapGetters({
      productsBoxWithVariants: "getProductsBox",
      addedQty: "getAddedProductsQuantity",
      discount: "getDiscount",
      currentStep: "getCurrentStep",
      nextDiscount: "getNextDiscount",
      discountableProductsAddedQty: "getAddedDiscountableProductsQty",
      numberOfSpecificDiscountsUsed: "getNumberOfSpecificDiscountsUsed",
      specificDiscountAmount: "getSpecificDiscountAmount",
      steps: "getSteps",
      pricePerPortion: "getReductedPricePerPortion"
    }),
    checkoutButtonStyle() {
      var _a;
      const section = (_a = this.$store.state.config) == null ? void 0 : _a.section;
      if ((section == null ? void 0 : section.override_primary_button_background_checkout) && (section == null ? void 0 : section.primary_button_background_checkout) && !this.disableATC) {
        return { backgroundColor: section.primary_button_background_checkout };
      }
      return {};
    },
    shakerDiscountFormatted() {
      var _a;
      const specificDiscountedVariantValue = (_a = this.productsVariants) == null ? void 0 : _a[this.specificDiscountedVariantIndex];
      const capped = specificDiscountedVariantValue ? this.$store.getters.getCappedSpecificDiscountForVariant(specificDiscountedVariantValue) : this.$store.state.specificDiscountAmount;
      return this.formatPrice(capped);
    },
    pricePerPortionFormatted() {
      return this.formatPrice(this.pricePerPortion, true);
    },
    hasSavings() {
      const compare = Number(this.priceCompare.unformatted);
      const current = Number(this.price.unformatted);
      return compare > current;
    },
    stepWithProgressiveDiscount() {
      var _a;
      return ((_a = this.steps) == null ? void 0 : _a.find((step) => {
        var _a2;
        return (_a2 = step.discounts) == null ? void 0 : _a2.length;
      })) || null;
    },
    isOnDiscountStep() {
      var _a, _b;
      return !!this.stepWithProgressiveDiscount && ((_a = this.currentStep) == null ? void 0 : _a.number) === ((_b = this.stepWithProgressiveDiscount) == null ? void 0 : _b.number);
    },
    savingsPrice() {
      return this.formatPrice(this.priceCompare.unformatted - this.price.unformatted, true);
    },
    atLeastOneProductFromTheFirstStep() {
      return this.productsBoxWithVariants.find((v) => v.stepName === this.steps[0].title);
    },
    productsVariants() {
      if (!this.productsBoxWithVariants || !this.productsBoxWithVariants.length || this.productsBoxWithVariants.length < 1) {
        return;
      }
      const result = [];
      this.$store.commit("resetSpecificDiscountApplying");
      this.productsBoxWithVariants.forEach((variant) => {
        for (let i = 0; i < (variant.addedQty || 1); i++) {
          if (variant.specificDiscountable && this.numberOfSpecificDiscountsUsed > 0) {
            this.$store.commit("applySpecificDiscount");
            variant.specificDiscount = this.$store.getters.getCappedSpecificDiscountForVariant(variant);
          } else {
            variant.specificDiscount = 0;
          }
          result.push({ ...variant });
        }
      });
      this.$store.commit("setProductsBoxSeparatedVariants", result);
      return result;
    },
    rows() {
      var _a;
      const slotsInFirstRow = this.slotsInFirstRow;
      const expanded = this.expandedView;
      let products, rowsQty;
      if ((_a = this.productsVariants) == null ? void 0 : _a.length) {
        products = this.productsVariants.map((product, index) => ({
          ...product,
          index
        }));
        if (expanded) {
          rowsQty = Math.max(1, Math.ceil((this.addedQty + 1) / this.productsPerRow));
        } else if (this.addedQty > slotsInFirstRow) {
          rowsQty = 1 + Math.ceil((this.addedQty - (slotsInFirstRow - 1)) / this.productsPerRow);
        } else {
          rowsQty = 1;
        }
      }
      rowsQty = !products ? 1 : rowsQty;
      const rows = [];
      const discountTierAlreadyShown = /* @__PURE__ */ new Set();
      let discountPlaceholderCount = 0;
      for (let i = 0; i < rowsQty; i++) {
        const row = [];
        const isFirstRow = i === 0;
        const showExpandInFirstRow = !expanded && isFirstRow && this.addedQty > slotsInFirstRow;
        const slotsInThisRow = expanded ? this.productsPerRow : isFirstRow ? slotsInFirstRow : this.productsPerRow;
        const startIdx = expanded ? i * this.productsPerRow : isFirstRow ? 0 : this.addedQty > slotsInFirstRow ? slotsInFirstRow - 1 + (i - 1) * this.productsPerRow : i * this.productsPerRow;
        for (let j = 0; j < slotsInThisRow; j++) {
          const isExpandSlot = showExpandInFirstRow && j === slotsInFirstRow - 1;
          if (isExpandSlot) {
            row.push({
              placeholder: false,
              expandButton: true
            });
            continue;
          }
          const isLastVisibleCell = expanded && i === rowsQty - 1 && j === slotsInThisRow - 1;
          if (isLastVisibleCell) {
            row.push({
              placeholder: false,
              expandButton: false,
              collapseButton: true
            });
            continue;
          }
          const productIndex = startIdx + j;
          if ((products == null ? void 0 : products.length) && products[productIndex]) {
            const productVariant = products[productIndex];
            row.push({
              variant: productVariant,
              placeholder: false,
              expandButton: false
            });
            continue;
          }
          const slotQuantityForDiscount = this.discountableProductsAddedQty + discountPlaceholderCount + 1;
          const discountPercent = this.$store.getters.getDiscountForQuantity(slotQuantityForDiscount);
          const isFirstSlotForThisTier = discountPercent != null && !discountTierAlreadyShown.has(discountPercent);
          if (discountPercent != null) discountTierAlreadyShown.add(discountPercent);
          discountPlaceholderCount++;
          row.push({
            placeholder: true,
            expandButton: false,
            slotIndex: productIndex,
            discountPercent,
            showDiscountLabel: isFirstSlotForThisTier
          });
        }
        rows.push(row);
      }
      return rows;
    },
    price() {
      var _a;
      let result = 0;
      let specificDiscountedPrice = 0;
      if (!((_a = this.productsVariants) == null ? void 0 : _a.length)) {
        return {
          formatted: this.formatPrice(result),
          unformatted: result
        };
      }
      this.productsVariants.forEach((variant, idx) => {
        var _a2, _b, _c;
        const variantPrice = +((_a2 = variant.price / 100) == null ? void 0 : _a2.toFixed(2));
        if (variant.specificDiscount && this.atLeastOneProductFromTheFirstStep) {
          const specificDiscount = +((_b = variant.specificDiscount / 100) == null ? void 0 : _b.toFixed(2));
          this.specificDiscountedVariantIndex = idx;
          const discountedPrice = +((_c = variantPrice - specificDiscount) == null ? void 0 : _c.toFixed(2));
          specificDiscountedPrice += discountedPrice;
        } else {
          const bundleDiscount = this.discount || 0;
          const categoryDiscount = this.$store.getters.getCategoryDiscountForVariant(variant) || 0;
          let discountedPrice = variantPrice;
          if (bundleDiscount > 0 && categoryDiscount > 0) {
            const combinedDiscount = bundleDiscount + categoryDiscount;
            discountedPrice = +(variantPrice * (1 - combinedDiscount / 100)).toFixed(2);
          } else if (bundleDiscount > 0) {
            discountedPrice = +(variantPrice * (1 - bundleDiscount / 100)).toFixed(2);
          } else if (categoryDiscount > 0) {
            discountedPrice = +(variantPrice * (1 - categoryDiscount / 100)).toFixed(2);
          }
          result += discountedPrice;
        }
      });
      result += specificDiscountedPrice;
      result = result.toFixed(2);
      return {
        formatted: this.formatPrice(result, true),
        unformatted: result
      };
    },
    priceCompare() {
      var _a;
      let result = 0;
      if (!((_a = this.productsVariants) == null ? void 0 : _a.length)) {
        return {
          formatted: this.formatPrice(result),
          unformatted: result
        };
      }
      this.productsVariants.forEach((variant) => {
        result += variant.price;
      });
      return {
        formatted: this.formatPrice(result),
        unformatted: result / 100
      };
    },
    nextDiscountMessage() {
      var _a;
      const discountTemplate = (_a = this.$store.state.config.htmlSnippets) == null ? void 0 : _a.discountTemplate;
      const canWordTranslated = this.nextDiscount.products_quantity - this.discountableProductsAddedQty > 1 ? this.$store.state.config.translations.cans : this.$store.state.config.translations.can;
      const leftCub = discountTemplate.includes("&lcub;") ? "&lcub;" : "{";
      const rightCub = discountTemplate.includes("&rcub;") ? "&rcub;" : "}";
      const qtyStr = `${leftCub}qty${rightCub}`;
      const discountStr = `${leftCub}discount${rightCub}`;
      const canStr = `${leftCub}can${rightCub}`;
      return this.nextDiscount && discountTemplate ? discountTemplate.replace(qtyStr, `${this.nextDiscount.products_quantity - this.discountableProductsAddedQty} ${canWordTranslated}`).replace(discountStr, this.nextDiscount.discount_percent).replace(canStr, canWordTranslated) : "";
    },
    disableATC() {
      return this.addedQty < 1;
    }
  },
  watch: {
    addedQty(newV, old) {
      if (old > this.slotsInFirstRow && newV <= this.slotsInFirstRow) {
        this.expandedView = false;
      }
    }
  },
  components: {
    Image: Image$1
  }
};
const _hoisted_1$g = { class: "bb-box-root" };
const _hoisted_2$d = { class: "bb-box__header-wrapper" };
const _hoisted_3$a = { class: "bb-box__header" };
const _hoisted_4$7 = {
  key: 0,
  class: "bb-box__discount-message radius-large"
};
const _hoisted_5$7 = ["innerHTML"];
const _hoisted_6$6 = ["innerHTML"];
const _hoisted_7$3 = { class: "bb-box" };
const _hoisted_8$3 = { class: "bb-box__inner" };
const _hoisted_9$2 = { class: "bb-box__body" };
const _hoisted_10$2 = { class: "bb-box__scroll-container" };
const _hoisted_11$2 = { class: "bb-box__container" };
const _hoisted_12$2 = ["aria-label", "onClick", "innerHTML"];
const _hoisted_13$2 = ["innerHTML"];
const _hoisted_14$2 = {
  key: 3,
  class: "bb-box__product_placeholder bb-box__product_placeholder--discount"
};
const _hoisted_15$2 = { class: "bb-box__placeholder-save label-xs" };
const _hoisted_16$2 = { class: "bb-box__placeholder-percent label-xs" };
const _hoisted_17$2 = ["innerHTML"];
const _hoisted_18$2 = {
  key: 5,
  class: "bb-product__variant_specific-discount"
};
const _hoisted_19$1 = { class: "bb-box__body_summary" };
const _hoisted_20$1 = {
  key: 0,
  class: "bb-box__summary_price-wrapper"
};
const _hoisted_21$1 = { class: "bb-box__summary_price-wrapper--desktop" };
const _hoisted_22$1 = { class: "bb-box__summary_price-left" };
const _hoisted_23$1 = { class: "bb-box__savings label-xs" };
const _hoisted_24$1 = {
  key: 0,
  class: "bb-box__percent-off body-m-strong"
};
const _hoisted_25$1 = { class: "bb-box__summary_price-right" };
const _hoisted_26$1 = {
  key: 0,
  class: "bb-box__summary_price-compare label-xs"
};
const _hoisted_27$1 = { class: "bb-box__summary_price-normal body-m-strong" };
const _hoisted_28 = { class: "bb-box__summary_price-mobile" };
const _hoisted_29 = {
  key: 0,
  class: "label-m bb-box__summary_price-mobile-item bb-box__summary-discount"
};
const _hoisted_30 = { class: "bb-box__summary_price-mobile-wrapper" };
const _hoisted_31 = {
  key: 0,
  class: "label-m bb-box__summary_price-mobile-item bb-box__saving"
};
const _hoisted_32 = {
  key: 1,
  class: "label-m bb-box__summary_price-mobile-item bb-box__summary-compare-price"
};
const _hoisted_33 = { class: "label-m bb-box__summary_price-mobile-item bb-box__price-formatted" };
const _hoisted_34 = { class: "bb-box__summary_controls" };
const _hoisted_35 = ["disabled"];
const _hoisted_36 = { key: 0 };
const _hoisted_37 = { key: 1 };
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = resolveComponent("Image");
  return openBlock(), createElementBlock("div", _hoisted_1$g, [
    createBaseVNode("div", _hoisted_2$d, [
      createBaseVNode("div", _hoisted_3$a, [
        _ctx.nextDiscount && !_ctx.nextDiscount.theLastOneReached && !$options.isOnDiscountStep ? (openBlock(), createElementBlock("div", _hoisted_4$7, [
          createBaseVNode("span", {
            class: "bb-box__discount-message-icon",
            innerHTML: $data.discountMessageIcon,
            "aria-hidden": "true"
          }, null, 8, _hoisted_5$7),
          createBaseVNode("span", {
            class: "bb-box__discount-message-text label-s",
            innerHTML: $options.nextDiscountMessage
          }, null, 8, _hoisted_6$6)
        ])) : createCommentVNode("", true)
      ])
    ]),
    createBaseVNode("div", _hoisted_7$3, [
      createBaseVNode("div", _hoisted_8$3, [
        createBaseVNode("div", _hoisted_9$2, [
          createBaseVNode("div", _hoisted_10$2, [
            createBaseVNode("div", _hoisted_11$2, [
              (openBlock(true), createElementBlock(Fragment, null, renderList($options.rows, (row, topIdx) => {
                return withDirectives((openBlock(), createElementBlock("div", {
                  class: "bb-box__container_row",
                  key: topIdx
                }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(row, (item, idx) => {
                    var _a, _b, _c, _d;
                    return openBlock(), createElementBlock("div", {
                      class: normalizeClass(["bb-box__product radius-small", {
                        "product-selected": !!item.variant,
                        "bb-box__product_expand-btn--wrapper": item.expandButton ? !$data.expandedView : false,
                        "bb-box__product_collapse-btn--wrapper": item.collapseButton,
                        "bb-box__box_expand-btn--disabled": item.expandButton && _ctx.addedQty <= $data.slotsInFirstRow,
                        "bb-box__product--darken-17": !item.collapseButton && $options.isOnDiscountStep && $options.getBlockIndex(topIdx, idx, row) === 2,
                        "bb-box__product--darken-20": !item.collapseButton && $options.isOnDiscountStep && $options.getBlockIndex(topIdx, idx, row) >= 3
                      }]),
                      key: idx,
                      onClick: _cache[2] || (_cache[2] = withModifiers(() => {
                      }, ["stop"])),
                      style: normalizeStyle($options.getBoxProductStyle(item))
                    }, [
                      !!item.variant ? (openBlock(), createElementBlock("button", {
                        key: 0,
                        class: "bb-box__product-remove",
                        type: "button",
                        "aria-label": _ctx.$store.state.config.translations.removeButton,
                        onClick: ($event) => $options.remove(item.variant),
                        innerHTML: _ctx.$store.state.config.htmlSnippets.icons.close
                      }, null, 8, _hoisted_12$2)) : createCommentVNode("", true),
                      item.expandButton ? (openBlock(), createElementBlock("button", {
                        key: 1,
                        class: "bb-box__product_placeholder bb-box__box_expand-btn label-xs",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = withModifiers((...args) => $options.expand && $options.expand(...args), ["stop"]))
                      }, toDisplayString(_ctx.$store.state.config.translations.expand), 1)) : createCommentVNode("", true),
                      item.collapseButton ? (openBlock(), createElementBlock("button", {
                        key: 2,
                        class: "bb-box__product_placeholder bb-box__box_expand-btn label-xs",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event) => $data.expandedView = false),
                        innerHTML: _ctx.$store.state.config.translations.showLess || "Show less"
                      }, null, 8, _hoisted_13$2)) : createCommentVNode("", true),
                      item.placeholder && !item.expandButton && $options.showDiscountInPlaceholder(item) ? (openBlock(), createElementBlock("div", _hoisted_14$2, [
                        createBaseVNode("span", _hoisted_15$2, toDisplayString(_ctx.$store.state.config.translations.savings || "SAVE"), 1),
                        createBaseVNode("span", _hoisted_16$2, toDisplayString(item.discountPercent) + "%", 1)
                      ])) : item.placeholder && !item.expandButton ? (openBlock(), createElementBlock("div", {
                        key: 4,
                        class: "bb-box__product_placeholder",
                        innerHTML: _ctx.$store.state.config.htmlSnippets.icons.placeholder
                      }, null, 8, _hoisted_17$2)) : createCommentVNode("", true),
                      ((_a = item.variant) == null ? void 0 : _a.specificDiscountable) && ((_b = item.variant) == null ? void 0 : _b.index) === $data.specificDiscountedVariantIndex && $options.atLeastOneProductFromTheFirstStep ? (openBlock(), createElementBlock("span", _hoisted_18$2, " -" + toDisplayString($options.shakerDiscountFormatted), 1)) : createCommentVNode("", true),
                      (item.expandButton ? $data.expandedView : !item.placeholder) && item.variant ? (openBlock(), createBlock(_component_Image, {
                        key: 6,
                        src: ((_c = item.variant.featured_image) == null ? void 0 : _c.src) || item.variant.featured_image,
                        additionalClasses: "bb-box__product_image-wrapper",
                        alt: ((_d = item.variant.featured_image) == null ? void 0 : _d.alt) || item.variant.title,
                        width: 60,
                        height: 60,
                        useSrcset: true,
                        usePlaceholder: false,
                        loading: "eager"
                      }, null, 8, ["src", "alt"])) : createCommentVNode("", true)
                    ], 6);
                  }), 128))
                ])), [
                  [vShow, topIdx === 0 || $data.expandedView]
                ]);
              }), 128))
            ])
          ]),
          createBaseVNode("div", _hoisted_19$1, [
            Number($options.price.unformatted) > 0 ? (openBlock(), createElementBlock("div", _hoisted_20$1, [
              createBaseVNode("div", _hoisted_21$1, [
                withDirectives(createBaseVNode("div", _hoisted_22$1, [
                  $options.hasSavings ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createBaseVNode("span", _hoisted_23$1, toDisplayString(_ctx.$store.state.config.translations.savings) + " " + toDisplayString($options.savingsPrice), 1),
                    _ctx.discount > 0 ? (openBlock(), createElementBlock("span", _hoisted_24$1, toDisplayString(_ctx.discount) + "% " + toDisplayString(_ctx.$store.state.config.translations.percentOff), 1)) : createCommentVNode("", true)
                  ], 64)) : createCommentVNode("", true)
                ], 512), [
                  [vShow, $options.hasSavings]
                ]),
                createBaseVNode("div", _hoisted_25$1, [
                  $options.hasSavings ? (openBlock(), createElementBlock("del", _hoisted_26$1, toDisplayString($options.priceCompare.formatted), 1)) : createCommentVNode("", true),
                  createBaseVNode("span", _hoisted_27$1, toDisplayString($options.price.formatted), 1)
                ])
              ]),
              createBaseVNode("div", _hoisted_28, [
                $options.hasSavings && _ctx.discount > 0 ? (openBlock(), createElementBlock("span", _hoisted_29, toDisplayString(_ctx.discount) + "% " + toDisplayString(_ctx.$store.state.config.translations.percentOff), 1)) : createCommentVNode("", true),
                createBaseVNode("div", _hoisted_30, [
                  $options.hasSavings ? (openBlock(), createElementBlock("span", _hoisted_31, toDisplayString(_ctx.$store.state.config.translations.savings) + " " + toDisplayString($options.savingsPrice), 1)) : createCommentVNode("", true),
                  $options.hasSavings ? (openBlock(), createElementBlock("del", _hoisted_32, toDisplayString($options.priceCompare.formatted), 1)) : createCommentVNode("", true),
                  createBaseVNode("span", _hoisted_33, toDisplayString($options.price.formatted), 1)
                ])
              ])
            ])) : createCommentVNode("", true),
            createBaseVNode("div", _hoisted_34, [
              _ctx.currentStep.number !== _ctx.$store.state.steps.length ? (openBlock(), createElementBlock("button", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = (...args) => $options.goToNextStep && $options.goToNextStep(...args)),
                class: "bb-box__summary_next-step-button btn btn--secondary btn--small btn--transparent",
                type: "button",
                disabled: _ctx.addedQty < 1
              }, toDisplayString(_ctx.$store.state.config.translations.continue), 9, _hoisted_35)) : createCommentVNode("", true),
              createBaseVNode("button", {
                class: normalizeClass(["bb-box__summary_checkout-button btn btn--primary btn--medium", {
                  "bb-box__summary_checkout-button--wider": _ctx.currentStep.number === _ctx.$store.state.steps.length,
                  "disabled": $options.disableATC
                }]),
                onClick: _cache[4] || (_cache[4] = (...args) => $options.addToCart && $options.addToCart(...args)),
                type: "button",
                style: normalizeStyle($options.checkoutButtonStyle)
              }, [
                !$data.initedFromSessionStorage ? (openBlock(), createElementBlock("span", _hoisted_36, toDisplayString(_ctx.$store.state.config.translations.checkout), 1)) : (openBlock(), createElementBlock("span", _hoisted_37, toDisplayString(_ctx.$store.state.config.translations.updateCart), 1))
              ], 6)
            ])
          ])
        ])
      ])
    ])
  ]);
}
const Box = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g]]);
const _sfc_main$f = {
  data() {
    return {
      config: null,
      bbHeaderCoords: { top: 0, left: 0, width: 0, height: 0 }
    };
  },
  methods: {
    initStepFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const tabParam = params.get("tab");
      const tabNum = tabParam ? parseInt(tabParam, 10) : NaN;
      if (!Number.isNaN(tabNum) && tabNum >= 1 && tabNum <= this.steps.length) {
        this.$store.commit("setPassedStep", tabNum - 1);
      }
    },
    calculateDiscount() {
      this.$store.commit("calculateDiscount");
    },
    getBBHeaderCoords() {
      this.$nextTick(() => {
        const bbHeader = this.$refs.bbHeader;
        if (bbHeader) {
          let element = bbHeader;
          let top = 0;
          let left = 0;
          while (element) {
            top += element.offsetTop;
            left += element.offsetLeft;
            element = element.offsetParent;
          }
          this.bbHeaderCoords = {
            top,
            left,
            width: bbHeader.offsetWidth,
            height: bbHeader.offsetHeight
          };
        }
      });
    },
    async fireCustomProductViewed() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      const analytics = window.Shopify.analytics;
      if (typeof analytics === "undefined" || !analytics.publish) {
        console.warn("analytics.publish is not available");
        return;
      }
      const variantId = (_a = this.$store.state.config) == null ? void 0 : _a.parentVariantId;
      if (!variantId) {
        return;
      }
      let productId = (_b = this.config) == null ? void 0 : _b.mixMatchProductID;
      if (!productId) {
        console.warn("Mix & Match product ID not found in config, using default");
        return;
      }
      let currencyCode = "PLN";
      if ((_d = (_c = window.themeVariables) == null ? void 0 : _c.settings) == null ? void 0 : _d.cartCurrency) {
        currencyCode = window.themeVariables.settings.cartCurrency;
      } else if ((_f = (_e = window.Shopify) == null ? void 0 : _e.currency) == null ? void 0 : _f.active) {
        currencyCode = window.Shopify.currency.active;
      } else if ((_h = (_g = window.Shopify) == null ? void 0 : _g.locale) == null ? void 0 : _h.currency) {
        currencyCode = window.Shopify.locale.currency;
      } else if (((_i = window.Shopify) == null ? void 0 : _i.shop) && window.Shopify.shop.includes("pl")) {
        currencyCode = "PLN";
      } else if (((_j = window.Shopify) == null ? void 0 : _j.shop) && (window.Shopify.shop.includes("fr") || window.Shopify.shop.includes("de"))) {
        currencyCode = "EUR";
      }
      const imageUrl = ((_l = (_k = this.$store.state.config) == null ? void 0 : _k.parentProduct) == null ? void 0 : _l.featured_image) || "https://cdn.shopify.com/s/files/1/0913/0600/0750/files/ProductImage_mixandmatch_eac910ec-f2d5-4a9a-8ac7-ba8418d16573.png?v=1745319690";
      const eventData = {
        productVariant: {
          price: {
            amount: 0,
            // Fallback price for Mix & Match or 0
            currencyCode
          },
          product: {
            title: "Mix & Match",
            vendor: "HOLY",
            id: String(productId),
            untranslatedTitle: "Mix & Match",
            url: "/pages/mix-n-match",
            type: "20 - Other Items"
          },
          id: String(variantId),
          image: {
            src: imageUrl
          },
          sku: "NOSYNC",
          // M&M products currently have no SKU
          title: "Mix & Match",
          untranslatedTitle: "Mix & Match"
        }
      };
      try {
        analytics.publish("custom_product_viewed", eventData);
      } catch (error2) {
        console.error("Error firing custom_product_viewed event:", error2);
      }
    }
  },
  created() {
    this.config = this.$store.state.config;
  },
  computed: {
    ...mapGetters({
      steps: "getSteps",
      currentStep: "getCurrentStep",
      addedProductsQty: "getAddedProductsQuantity",
      addedDiscountableProductsQty: "getAddedDiscountableProductsQty"
    }),
    isStepDisabled() {
      return false;
    },
    currentStepIndex() {
      return this.currentStep.number - 1;
    },
    previousStepIndexes() {
      return this.steps.slice(0, this.currentStepIndex).map((step) => step.number - 1);
    }
  },
  mounted() {
    this.initStepFromUrl();
    this.getBBHeaderCoords();
    window.addEventListener("resize", this.getBBHeaderCoords);
    this.$nextTick(() => {
      this.fireCustomProductViewed();
    });
  },
  watch: {
    addedProductsQty(newV, old) {
      this.calculateDiscount();
    }
  },
  components: {
    Step,
    GridSwitcher,
    ProductGrid,
    Box
  }
};
const _hoisted_1$f = {
  class: "bb-header bb-steps-big",
  ref: "bbHeader"
};
const _hoisted_2$c = { class: "bb-steps__wrapper" };
const _hoisted_3$9 = { class: "bb-steps" };
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Step = resolveComponent("Step");
  const _component_GridSwitcher = resolveComponent("GridSwitcher");
  const _component_ProductGrid = resolveComponent("ProductGrid");
  const _component_Box = resolveComponent("Box");
  return openBlock(), createElementBlock(Fragment, null, [
    createBaseVNode("div", _hoisted_1$f, [
      createBaseVNode("div", _hoisted_2$c, [
        createBaseVNode("div", _hoisted_3$9, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.steps, (step, idx) => {
            return openBlock(), createBlock(_component_Step, {
              key: idx,
              title: step.title,
              number: step.number,
              "step-icon-url": step.step_icon_url,
              isPassed: idx === 0 || step.isPassed,
              isDisabled: false,
              isPrevious: $options.previousStepIndexes.includes(idx)
            }, null, 8, ["title", "number", "step-icon-url", "isPassed", "isPrevious"]);
          }), 128))
        ])
      ]),
      createVNode(_component_GridSwitcher)
    ], 512),
    createVNode(_component_ProductGrid, {
      tabs: _ctx.currentStep.tabs,
      currentStep: _ctx.currentStep
    }, null, 8, ["tabs", "currentStep"]),
    createVNode(_component_Box, {
      isDisabled: $options.isStepDisabled,
      bbHeaderCoords: $data.bbHeaderCoords
    }, null, 8, ["isDisabled", "bbHeaderCoords"])
  ], 64);
}
const App$1 = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f]]);
function sortObjectsByAvailability(arr) {
  arr.sort((a, b3) => {
    if (!a.available && b3.available) {
      return 1;
    } else if (a.available && !b3.available) {
      return -1;
    }
    return 0;
  });
}
function findVariantById(steps, variantId) {
  if (!steps || !variantId) return null;
  const searchId = String(variantId);
  for (const step of steps) {
    if (!step.tabs) continue;
    for (const tab of step.tabs) {
      if (!tab.variants) continue;
      const foundVariant = tab.variants.find((v) => String(v.id) === searchId);
      if (foundVariant) {
        return foundVariant;
      }
    }
  }
  return null;
}
function preInitializeBoxWithVariant(vuexStore, steps) {
  const urlParams = new URLSearchParams(window.location.search);
  const selectedVariantId = urlParams.get("selectedVariantId");
  if (!selectedVariantId) {
    return;
  }
  const variant = findVariantById(steps, selectedVariantId);
  if (!variant) {
    console.warn(`Variant with ID ${selectedVariantId} not found in box-builder data`);
    return;
  }
  if (!variant.available) {
    console.warn(`Variant with ID ${selectedVariantId} is not available (sold out)`);
    return;
  }
  vuexStore.commit("ADD_TO_BOX", variant);
  vuexStore.commit("calculateDiscount");
}
const boxBuilderMain = (selectors2) => {
  var _a;
  const jsonData = (_a = document.querySelector(selectors2.json)) == null ? void 0 : _a.textContent;
  let data;
  try {
    data = jsonData ? JSON.parse(jsonData) : null;
  } catch (error2) {
    console.error(error2);
    return;
  }
  if (!data) return;
  initBoxBuilderSentry(data);
  for (let i = 0; i < data.steps.length; i++) {
    const step = data.steps[i];
    step.tabs.forEach((tab, j) => {
      let variants = [];
      if (step.showOnlyFirstVariant) {
        tab.products.forEach((product) => {
          if (product.tags.includes("hide_product")) return;
          let variant = product.variants[0];
          if (product.tags.includes(`_hidden-variant:${variant.id}`) || variant.isHidden == "true") return;
          variant = {
            ...variant,
            collectionName: tab.collection.title,
            stepName: step.title,
            tabName: tab.title,
            productTitle: product.title,
            product,
            featured_image: !variant.featured_image ? { src: product.featured_image } : variant.featured_image,
            // Preserve isCategoryDiscountable flag from Liquid
            isCategoryDiscountable: variant.isCategoryDiscountable
          };
          variants.push(variant);
        });
      } else {
        tab.products.forEach((product) => {
          if (product.tags.includes("hide_product")) return;
          const newVariantsList = [];
          product.variants.forEach((variant) => {
            if (product.tags.includes(`_hidden-variant:${variant.id}`) || variant.isHidden == "true") return;
            const newV = {
              ...variant,
              collectionName: tab.collection.title,
              stepName: step.title,
              tabName: tab.title,
              productTitle: product.title,
              product,
              specificDiscountable: step.firstAddedProductDiscount ? true : false,
              featured_image: !variant.featured_image ? { src: product.featured_image } : variant.featured_image,
              // Preserve isCategoryDiscountable flag from Liquid
              isCategoryDiscountable: variant.isCategoryDiscountable
            };
            newVariantsList.push(newV);
          });
          product.variants = newVariantsList;
          variants.push(...product.variants);
        });
      }
      sortObjectsByAvailability(variants);
      step.tabs[j].variants = variants;
    });
  }
  const vuexStore = store$1(data);
  preInitializeBoxWithVariant(vuexStore, data.steps);
  const app = createApp(App$1);
  app.use(vuexStore);
  app.config.devtools = true;
  app.mount(selectors2.app);
};
function formatMoney$1(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format;
  function defaultOption(opt, def2) {
    return typeof opt == "undefined" ? def2 : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = number.toFixed(precision);
    var parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_with_dot_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
function normalizeVariantId(id) {
  return id == null ? "" : String(id).trim();
}
function resolveGiftVariantIdForPricing(state, getters, giftsConfig) {
  if (!Array.isArray(giftsConfig) || giftsConfig.length === 0 || getters.areGiftsLocked) {
    return null;
  }
  const selected = state.selectedGiftVariantId;
  if (selected != null && selected !== "") {
    return selected;
  }
  const first = giftsConfig.find((g) => g.available === true);
  return first ? first.id : null;
}
function variantCompareAtOrPriceCents(variant) {
  if (!variant || typeof variant.price !== "number") return 0;
  const cap = variant.compare_at_price;
  if (typeof cap === "number" && cap > 0) return cap;
  return variant.price;
}
function getDefaultSelectedGiftVariantId(config) {
  const gifts = config.gifts;
  if (!Array.isArray(gifts) || gifts.length === 0) return null;
  const firstAvailable = gifts.find((g) => g.available === true);
  return firstAvailable ? firstAvailable.id : null;
}
function getInitialGiftSelection(params) {
  const threshold = params.config.giftsUnlockThreshold || 0;
  if (threshold > 0) {
    const preselectedBoxes = (params.config.preselectedVariantsIds || []).filter((id) => {
      var _a, _b;
      const v = (_b = (_a = params.config.variantAndProductIndex) == null ? void 0 : _a.variantsById) == null ? void 0 : _b[id];
      return v == null ? void 0 : v.isSampleBox;
    });
    if (preselectedBoxes.length < threshold) return null;
  }
  return getDefaultSelectedGiftVariantId(params.config);
}
const store = (params) => {
  return createStore({
    state() {
      var _a, _b;
      return {
        initialData: params,
        /**
         * @example
         * {
         *  [variantId]: selectedQuantity
         * }
         */
        selectedBoxesVariantsIds: ((_a = params.config.preselectedVariantsIds) == null ? void 0 : _a.reduce((acc, variantId) => {
          const variant = params.config.variantAndProductIndex.variantsById[variantId];
          if (variant == null ? void 0 : variant.isSampleBox) {
            acc[variantId] = 1;
          }
          return acc;
        }, {})) || {},
        /**
         * @example
         * {
         *  [variantId]: selectedQuantity
         * }
         */
        selectedShakersVariantsIds: ((_b = params.config.preselectedVariantsIds) == null ? void 0 : _b.reduce((acc, variantId) => {
          const variant = params.config.variantAndProductIndex.variantsById[variantId];
          if (variant == null ? void 0 : variant.isShaker) {
            acc[variantId] = 1;
          }
          return acc;
        }, {})) || {},
        selectedGiftVariantId: getInitialGiftSelection(params),
        currentProductImageSlide: 0
      };
    },
    mutations: {
      SET_SAMPLE_BOX_QUANTITY(state, { variantId, quantity }) {
        const copiedSelectedBoxesVariantsIds = {
          ...state.selectedBoxesVariantsIds
        };
        copiedSelectedBoxesVariantsIds[variantId] = quantity;
        state.selectedBoxesVariantsIds = copiedSelectedBoxesVariantsIds;
      },
      SET_SHAKER_QUANTITY(state, { variantId, quantity }) {
        state.selectedShakersVariantsIds = {};
        state.selectedShakersVariantsIds[variantId] = quantity;
      },
      SET_SELECTED_GIFT_VARIANT_ID(state, variantId) {
        state.selectedGiftVariantId = variantId;
      },
      SET_CURRENT_PRODUCT_IMAGE_SLIDE(state, slideIndex) {
        state.currentProductImageSlide = slideIndex;
      }
    },
    actions: {},
    getters: {
      getInitialData(state) {
        return state.initialData;
      },
      /**
       * Finds the product which holds current selected variants in its metafields.
       *
       * The main required condition is that a product should have Sample Boxes. There can't be that the product has only shakers.
       * So we are looking for exact mach by the selected boxes variants IDs and their quantity which is always 1 for each sample box.
       *
       * We check shakers only if the product has specific shakers in its metafields. If it doesn't, we don't care about NOT specific shakers.
       *
       * If no match - returns the default wrapper product.
       *
       * When multiple preselect products match, prefers the one whose id equals the wrapper product id.
       *
       */
      getSelectionRelatedProduct(state) {
        const { product, bulletPointsHtml } = state.initialData.config.wrapperProduct;
        const defaultWrapperProduct = product;
        if (bulletPointsHtml) {
          defaultWrapperProduct.bulletPointsHtml = bulletPointsHtml;
        }
        if (state.initialData.disableDynamicChanges) {
          return defaultWrapperProduct;
        }
        const matches = [];
        const preselectProducts = state.initialData.config.preselectProducts;
        for (const { product: product2, metafields } of preselectProducts) {
          product2.metafields = metafields || {};
          const productChildren = product2.metafields.children;
          if (!productChildren) continue;
          const boxesVariantsIds = productChildren.boxesVariantsIds;
          if (!(boxesVariantsIds == null ? void 0 : boxesVariantsIds.length)) continue;
          const expectedBoxIds = (Array.isArray(boxesVariantsIds) ? boxesVariantsIds : []).map(normalizeVariantId).filter(Boolean).sort();
          const selectedBoxIds = Object.entries(state.selectedBoxesVariantsIds).filter(([_, qty]) => qty === 1).map(([id]) => normalizeVariantId(id)).filter(Boolean).sort();
          const isThereBoxesMatch = expectedBoxIds.length > 0 && selectedBoxIds.length === expectedBoxIds.length && selectedBoxIds.every((id, i) => id === expectedBoxIds[i]) && Object.entries(state.selectedBoxesVariantsIds).filter(([_, qty]) => qty > 1).length === 0;
          if (!isThereBoxesMatch) continue;
          const rawSpecific = product2.metafields.specificShakers;
          const specificShakers = Array.isArray(rawSpecific) ? rawSpecific.map(normalizeVariantId).filter(Boolean) : [];
          const isThereSpecificShakersMatch = !specificShakers.length ? true : specificShakers.filter((shakerID) => {
            const sel = state.selectedShakersVariantsIds;
            return sel[shakerID] === 1 || sel[normalizeVariantId(shakerID)] === 1;
          }).length === specificShakers.length;
          if (isThereBoxesMatch && isThereSpecificShakersMatch) {
            matches.push(product2);
          }
        }
        if (matches.length === 0) {
          return defaultWrapperProduct;
        }
        if (matches.length === 1) {
          return matches[0];
        }
        const wrapperMatch = matches.find(
          (match) => String(match.id) === String(defaultWrapperProduct.id)
        );
        return wrapperMatch ?? matches[0];
      },
      /** Alias for getSelectionRelatedProduct — the resolved primary product for UI and cart. */
      getPrimarySelectionRelatedProduct(state, getters) {
        return getters.getSelectionRelatedProduct ?? null;
      },
      getSelectedBoxesVariantsIds(state) {
        return state.selectedBoxesVariantsIds;
      },
      getSelectedShakersVariantsIds(state) {
        return state.selectedShakersVariantsIds;
      },
      getSelectedGiftVariantId(state) {
        return state.selectedGiftVariantId;
      },
      areGiftsLocked(state, getters) {
        const threshold = state.initialData.config.giftsUnlockThreshold;
        if (!threshold) return false;
        return getters.getSelectedBoxesCount < threshold;
      },
      getSelectedBoxesCount(state) {
        let count = 0;
        for (const quantity of Object.values(state.selectedBoxesVariantsIds)) {
          count += quantity;
        }
        return count;
      },
      getProductById: (state) => (productId) => {
        return state.initialData.config.variantAndProductIndex.productsById[productId] || null;
      },
      getVariantById: (state) => (variantId) => {
        return state.initialData.config.variantAndProductIndex.variantsById[variantId] || null;
      },
      getDiscountForShakerProductById: (state, getters) => (params2) => {
        var _a, _b;
        const sampleBoxesQuantity = getters.getSelectedBoxesCount;
        const shakerProductId = params2.productId;
        const shakerVariantId = params2.variantId;
        let discountAmount = 0;
        const lvl2ShakerDiscounts = state.initialData.config.shakerDiscountsLvl2 || [];
        const relatedLvl2Discount = lvl2ShakerDiscounts.find((discount) => {
          const sampleBoxesThreshold = +discount.sample_boxes_quantity_threshold;
          const shakerMatch = discount.shakers_variants.some(
            (shVariantId) => shVariantId.includes(shakerVariantId)
          );
          return shakerMatch && sampleBoxesQuantity >= sampleBoxesThreshold;
        });
        if (relatedLvl2Discount) {
          discountAmount += +relatedLvl2Discount.discount_amount;
        }
        const shakersCollectionsFiltered = state.initialData.config.shakersCollections.filter(
          (collection) => collection.products.some((product) => product.id === shakerProductId)
        );
        const shakerCollection = shakersCollectionsFiltered.reduce((highest, current) => {
          var _a2, _b2, _c, _d;
          const currentDiscount = ((_b2 = (_a2 = state.initialData.config.shakersDiscounts) == null ? void 0 : _a2.find((discount) => discount.collectionId == current.id)) == null ? void 0 : _b2.discountAmount) || 0;
          const highestDiscount = ((_d = (_c = state.initialData.config.shakersDiscounts) == null ? void 0 : _c.find((discount) => discount.collectionId == highest.id)) == null ? void 0 : _d.discountAmount) || 0;
          return currentDiscount > highestDiscount ? current : highest;
        }, shakersCollectionsFiltered == null ? void 0 : shakersCollectionsFiltered[0]);
        if (!(shakerCollection == null ? void 0 : shakerCollection.id))
          return {
            discountAmount
          };
        discountAmount += ((_b = (_a = state.initialData.config.shakersDiscounts) == null ? void 0 : _a.find(
          (discount) => discount.collectionId == shakerCollection.id
        )) == null ? void 0 : _b.discountAmount) || 0;
        return {
          discountAmount
        };
      },
      getLvl2DiscountBadgeByShakerVariantId: (state, getters) => (shakerVariantId) => {
        const sampleBoxesQuantity = getters.getSelectedBoxesCount;
        const lvl2ShakerDiscounts = state.initialData.config.shakerDiscountsLvl2 || [];
        const relatedLvl2Discount = lvl2ShakerDiscounts.find((discount) => {
          const sampleBoxesThreshold = +discount.sample_boxes_quantity_threshold;
          const shakerMatch = discount.shakers_variants.some(
            (shVariantId) => shVariantId.includes(shakerVariantId)
          );
          return shakerMatch && sampleBoxesQuantity >= sampleBoxesThreshold;
        });
        if (relatedLvl2Discount) {
          return relatedLvl2Discount.promo_tag || null;
        }
        return null;
      },
      getPrices: (state, getters) => {
        var _a, _b, _c, _d, _e, _f;
        let shakersDiscount = 0;
        let boxesDiscount = 0;
        let boxesPriceTotal = 0;
        let sampleBoxesPortionsQuantity = 0;
        let shakersPriceTotal = 0;
        let temporaryBoxesCount = 0;
        const sampleBoxesThresholds = state.initialData.config.sampleBoxesThresholds || [];
        Object.keys(state.selectedBoxesVariantsIds).forEach((variantId) => {
          const qty = state.selectedBoxesVariantsIds[variantId];
          if (!qty) return;
          const variant = getters.getVariantById(variantId);
          const product = getters.getProductById(variant == null ? void 0 : variant.productId);
          temporaryBoxesCount += qty;
          sampleBoxesPortionsQuantity += (product == null ? void 0 : product.portions) * qty || 0;
          boxesPriceTotal += (variant == null ? void 0 : variant.price) / 100 * qty || 0;
        });
        if (temporaryBoxesCount > 0) {
          sampleBoxesThresholds.forEach((threshold) => {
            if (temporaryBoxesCount >= threshold.quantity) {
              boxesDiscount += threshold.discountAmount;
            }
          });
          const maxThreshold = sampleBoxesThresholds[sampleBoxesThresholds.length - 1];
          if (temporaryBoxesCount > maxThreshold.quantity) {
            const extraBoxes = temporaryBoxesCount - maxThreshold.quantity;
            boxesDiscount += extraBoxes * maxThreshold.discountAmount;
          }
        }
        Object.keys(state.selectedShakersVariantsIds).forEach((variantId) => {
          var _a2;
          const qty = state.selectedShakersVariantsIds[variantId];
          if (qty <= 0) return;
          const variant = getters.getVariantById(variantId);
          getters.getProductById(variant == null ? void 0 : variant.productId);
          shakersPriceTotal += (variant == null ? void 0 : variant.price) / 100 * qty || 0;
          let shakersDiscountIntermediate = ((_a2 = getters.getDiscountForShakerProductById({
            productId: variant == null ? void 0 : variant.productId,
            variantId: variant.id
          })) == null ? void 0 : _a2.discountAmount) || 0;
          const variantPriceInEuro = (variant == null ? void 0 : variant.price) / 100 || 0;
          shakersDiscountIntermediate = shakersDiscountIntermediate > variantPriceInEuro ? variantPriceInEuro : shakersDiscountIntermediate;
          shakersDiscount += shakersDiscountIntermediate || 0;
        });
        const additionalDiscountSbThresholdQty = (_b = (_a = state.initialData.config) == null ? void 0 : _a.additionalBundleDiscount) == null ? void 0 : _b.sampleBoxesThresholdQty;
        const bundleDiscountAmount = getters.getSelectedBoxesCount >= additionalDiscountSbThresholdQty ? ((_d = (_c = state.initialData.config) == null ? void 0 : _c.additionalBundleDiscount) == null ? void 0 : _d.amount) || 0 : 0;
        const totalDiscountAmount = boxesPriceTotal > 0 ? boxesDiscount + shakersDiscount + bundleDiscountAmount : shakersDiscount;
        const priceTotal = shakersPriceTotal + boxesPriceTotal;
        const priceTotalDiscounted = priceTotal - totalDiscountAmount;
        let compareAtSum = 0;
        Object.keys(state.selectedBoxesVariantsIds).forEach((variantId) => {
          const qty = state.selectedBoxesVariantsIds[variantId];
          if (!qty) return;
          const v = getters.getVariantById(variantId);
          compareAtSum += variantCompareAtOrPriceCents(v) / 100 * qty;
        });
        Object.keys(state.selectedShakersVariantsIds).forEach((variantId) => {
          const qty = state.selectedShakersVariantsIds[variantId];
          if (qty <= 0) return;
          const v = getters.getVariantById(variantId);
          compareAtSum += variantCompareAtOrPriceCents(v) / 100 * qty;
        });
        const giftsConfig = state.initialData.config.gifts || [];
        const giftVariantIdForPricing = resolveGiftVariantIdForPricing(state, getters, giftsConfig);
        let giftPortions = 0;
        if (giftVariantIdForPricing) {
          const giftVariant = getters.getVariantById(giftVariantIdForPricing);
          const giftFromConfig = giftsConfig.find(
            (g) => normalizeVariantId(g.id) === normalizeVariantId(giftVariantIdForPricing)
          );
          if (giftVariant) {
            compareAtSum += variantCompareAtOrPriceCents(giftVariant) / 100;
          }
          const giftProduct = giftVariant ? getters.getProductById(giftVariant.productId) : null;
          giftPortions = +((giftVariant == null ? void 0 : giftVariant.portions) ?? (giftProduct == null ? void 0 : giftProduct.portions) ?? (giftFromConfig == null ? void 0 : giftFromConfig.portions) ?? 0);
        }
        const compareAtSubtotal = compareAtSum;
        const savingsVersusCompareAt = Math.max(0, compareAtSubtotal - priceTotalDiscounted);
        const giftsConfigForPortions = state.initialData.config.gifts || [];
        if (giftsConfigForPortions.length > 0 && state.selectedGiftVariantId) {
          const giftVariant = getters.getVariantById(state.selectedGiftVariantId);
          const giftProduct = getters.getProductById(giftVariant == null ? void 0 : giftVariant.productId);
          +((giftVariant == null ? void 0 : giftVariant.portions) ?? (giftProduct == null ? void 0 : giftProduct.portions) ?? 0);
          ((giftVariant == null ? void 0 : giftVariant.price) || 0) / 100;
        }
        const portionsTotal = sampleBoxesPortionsQuantity + giftPortions;
        const currencyRate = typeof window !== "undefined" && ((_f = (_e = window.Shopify) == null ? void 0 : _e.currency) == null ? void 0 : _f.rate) ? +window.Shopify.currency.rate : 1;
        const perDrinkOffset = (+state.initialData.config.remainingShakerValue || 0) * currencyRate;
        const pricePerPortion = compareAtSubtotal / portionsTotal;
        const productsPriceForPortions = priceTotalDiscounted - (shakersPriceTotal - shakersDiscount - perDrinkOffset);
        const pricePerPortionDiscounted = portionsTotal ? productsPriceForPortions / portionsTotal : 0;
        return {
          formatted: {
            total: formatMoney$1(compareAtSubtotal, state.initialData.moneyFormat),
            discountTotal: formatMoney$1(priceTotalDiscounted, state.initialData.moneyFormat),
            discountAmount: formatMoney$1(savingsVersusCompareAt, state.initialData.moneyFormat),
            perPortion: formatMoney$1(pricePerPortion, state.initialData.moneyFormat),
            perPortionDiscounted: formatMoney$1(pricePerPortionDiscounted, state.initialData.moneyFormat)
          },
          unformatted: {
            total: compareAtSubtotal,
            discountTotal: priceTotalDiscounted,
            discountAmount: savingsVersusCompareAt,
            bundleDiscountAmount: totalDiscountAmount,
            perPortion: pricePerPortion,
            perPortionDiscounted: pricePerPortionDiscounted
          }
        };
      },
      getAddToCartPayload: (state, getters) => {
        const mainProduct = getters.getPrimarySelectionRelatedProduct;
        const nestedProductVariantsIds = [];
        const nestedItemsTotalPrice = getters.getPrices.unformatted.total;
        Object.keys(state.selectedBoxesVariantsIds).forEach((variantId) => {
          if (state.selectedBoxesVariantsIds[variantId] > 0) {
            nestedProductVariantsIds.push({
              id: variantId,
              quantity: state.selectedBoxesVariantsIds[variantId]
            });
          }
        });
        Object.keys(state.selectedShakersVariantsIds).forEach((variantId) => {
          if (state.selectedShakersVariantsIds[variantId] > 0) {
            nestedProductVariantsIds.push({
              id: variantId,
              quantity: state.selectedShakersVariantsIds[variantId]
            });
          }
        });
        if (state.selectedGiftVariantId) {
          nestedProductVariantsIds.push({
            id: state.selectedGiftVariantId,
            quantity: 1
          });
        }
        return [
          {
            id: mainProduct.variants[0].id,
            quantity: 1,
            properties: {
              _nestedVariantsIds: JSON.stringify(nestedProductVariantsIds),
              _root_id: state.initialData.config.rootId,
              _nested_items_total_price: nestedItemsTotalPrice * 100,
              // in cents
              _bundle_type: "starter_powder"
            }
          }
        ];
      },
      getNestedProductsImagesSrc: (state, getters) => {
        const nestedProductsImages = [];
        Object.keys(state.selectedShakersVariantsIds).forEach((variantId) => {
          var _a;
          if (state.selectedShakersVariantsIds[variantId] > 0) {
            const variant = getters.getVariantById(variantId);
            const productVariant = variant;
            const product = getters.getProductById(productVariant == null ? void 0 : productVariant.productId);
            if ((_a = product.additionalShakerImages) == null ? void 0 : _a.length) return;
            const images = [product == null ? void 0 : product.images[0]];
            images == null ? void 0 : images.forEach((image) => nestedProductsImages.push(image));
          }
        });
        Object.keys(state.selectedBoxesVariantsIds).forEach((variantId) => {
          var _a, _b, _c;
          if (state.selectedBoxesVariantsIds[variantId] > 0) {
            const variant = getters.getVariantById(variantId);
            const productVariant = variant;
            const product = getters.getProductById(productVariant == null ? void 0 : productVariant.productId);
            const image = ((_a = productVariant == null ? void 0 : productVariant.featured_image) == null ? void 0 : _a.src) ? (_b = productVariant.featured_image) == null ? void 0 : _b.src : (_c = product == null ? void 0 : product.images) == null ? void 0 : _c[0];
            if (image) {
              nestedProductsImages.push(image);
            }
          }
        });
        return nestedProductsImages;
      },
      getAdditionalShakerImagesSrc: (state, getters) => {
        const result = [];
        Object.keys(state.selectedShakersVariantsIds).forEach((variantId) => {
          var _a;
          if (state.selectedShakersVariantsIds[variantId] > 0) {
            const variant = getters.getVariantById(variantId);
            const productVariant = variant;
            const product = getters.getProductById(productVariant == null ? void 0 : productVariant.productId);
            if ((_a = product.additionalShakerImages) == null ? void 0 : _a.length) {
              result.push(...product.additionalShakerImages);
              result.push(product == null ? void 0 : product.images[0]);
            }
          }
        });
        return result;
      },
      getCurrentProductImageSlide(state) {
        return state.currentProductImageSlide;
      },
      getNextSbPrice(state) {
        var _a, _b, _c, _d;
        const sampleBoxesThresholds = state.initialData.config.sampleBoxesThresholds || [];
        const selectedBoxesCount = Object.values(state.selectedBoxesVariantsIds).reduce((acc, qty) => acc + qty, 0) + 1;
        const lastThreshold = sampleBoxesThresholds[sampleBoxesThresholds.length - 1];
        const isMaximumThresholdReached = sampleBoxesThresholds.length && selectedBoxesCount >= (lastThreshold == null ? void 0 : lastThreshold.quantity);
        const threshold = isMaximumThresholdReached ? lastThreshold : sampleBoxesThresholds.find((threshold2) => threshold2.quantity === selectedBoxesCount);
        const baseVariantPriceCents = (_d = (_c = (_b = (_a = state.initialData.config.sampleBoxesProducts) == null ? void 0 : _a[0]) == null ? void 0 : _b.variants) == null ? void 0 : _c[0]) == null ? void 0 : _d.price;
        const sbPrice = baseVariantPriceCents / 100 - ((threshold == null ? void 0 : threshold.discountAmount) || 0);
        if (isNaN(sbPrice) || sbPrice <= 0) return;
        return {
          formatted: formatMoney$1(sbPrice, state.initialData.moneyFormat),
          unformatted: sbPrice
        };
      }
    }
  });
};
/**
 * Vue 3 Carousel 0.16.0
 * (c) 2025
 * @license MIT
 */
const BREAKPOINT_MODE_OPTIONS = ["viewport", "carousel"];
const DIR_MAP = {
  "bottom-to-top": "btt",
  "left-to-right": "ltr",
  "right-to-left": "rtl",
  "top-to-bottom": "ttb"
};
const DIR_OPTIONS = [
  "ltr",
  "left-to-right",
  "rtl",
  "right-to-left",
  "ttb",
  "top-to-bottom",
  "btt",
  "bottom-to-top"
];
const I18N_DEFAULT_CONFIG = {
  ariaGallery: "Gallery",
  ariaNavigateToPage: "Navigate to page {slideNumber}",
  ariaNavigateToSlide: "Navigate to slide {slideNumber}",
  ariaNextSlide: "Navigate to next slide",
  ariaPreviousSlide: "Navigate to previous slide",
  iconArrowDown: "Arrow pointing downwards",
  iconArrowLeft: "Arrow pointing to the left",
  iconArrowRight: "Arrow pointing to the right",
  iconArrowUp: "Arrow pointing upwards",
  itemXofY: "Item {currentSlide} of {slidesCount}"
};
const SLIDE_EFFECTS = ["slide", "fade"];
const SNAP_ALIGN_OPTIONS = [
  "center",
  "start",
  "end",
  "center-even",
  "center-odd"
];
const DEFAULT_MOUSE_WHEEL_THRESHOLD = 10;
const DEFAULT_DRAG_THRESHOLD = 0.08;
const DEFAULT_CONFIG = {
  autoplay: 0,
  breakpointMode: BREAKPOINT_MODE_OPTIONS[0],
  breakpoints: void 0,
  dir: DIR_OPTIONS[0],
  enabled: true,
  gap: 0,
  height: "auto",
  i18n: I18N_DEFAULT_CONFIG,
  ignoreAnimations: false,
  itemsToScroll: 1,
  itemsToShow: 1,
  modelValue: 0,
  mouseDrag: true,
  mouseWheel: false,
  pauseAutoplayOnHover: false,
  preventExcessiveDragging: false,
  slideEffect: SLIDE_EFFECTS[0],
  snapAlign: SNAP_ALIGN_OPTIONS[0],
  touchDrag: true,
  transition: 300,
  wrapAround: false
};
const injectCarousel = Symbol("carousel");
const createSlideRegistry = (emit2) => {
  const slides = shallowReactive([]);
  const updateSlideIndexes = (startIndex) => {
    if (startIndex !== void 0) {
      slides.slice(startIndex).forEach((slide2, offset) => {
        var _a;
        (_a = slide2.exposed) === null || _a === void 0 ? void 0 : _a.setIndex(startIndex + offset);
      });
    } else {
      slides.forEach((slide2, index) => {
        var _a;
        (_a = slide2.exposed) === null || _a === void 0 ? void 0 : _a.setIndex(index);
      });
    }
  };
  return {
    cleanup: () => {
      slides.splice(0, slides.length);
    },
    getSlides: () => slides,
    registerSlide: (slide2, index) => {
      if (!slide2)
        return;
      if (slide2.props.isClone) {
        return;
      }
      const slideIndex = index !== null && index !== void 0 ? index : slides.length;
      slides.splice(slideIndex, 0, slide2);
      updateSlideIndexes(slideIndex);
      emit2("slide-registered", { slide: slide2, index: slideIndex });
    },
    unregisterSlide: (slide2) => {
      const slideIndex = slides.indexOf(slide2);
      if (slideIndex === -1)
        return;
      emit2("slide-unregistered", { slide: slide2, index: slideIndex });
      slides.splice(slideIndex, 1);
      updateSlideIndexes(slideIndex);
    }
  };
};
function calculateAverage(numbers) {
  if (numbers.length === 0)
    return 0;
  const sum = numbers.reduce((acc, num) => acc + num, 0);
  return sum / numbers.length;
}
function createCloneSlides({ slides, position, toShow }) {
  const clones = [];
  const isBefore = position === "before";
  const start = isBefore ? -toShow : 0;
  const end = isBefore ? 0 : toShow;
  if (slides.length <= 0) {
    return clones;
  }
  for (let i = start; i < end; i++) {
    const index = isBefore ? i : i + slides.length;
    const props = {
      index,
      isClone: true,
      id: void 0,
      // Make sure we don't duplicate the id which would be invalid html
      key: `clone-${position}-${i}`
    };
    const vnode = slides[(i % slides.length + slides.length) % slides.length].vnode;
    const clone = cloneVNode(vnode, props);
    clone.el = null;
    clones.push(clone);
  }
  return clones;
}
const FOCUSABLE_ELEMENTS_SELECTOR = 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
function disableChildrenTabbing(node) {
  if (!node.el || !(node.el instanceof Element)) {
    return;
  }
  const elements = node.el.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR);
  for (const el of elements) {
    if (el instanceof HTMLElement && !el.hasAttribute("disabled") && el.getAttribute("aria-hidden") !== "true") {
      el.setAttribute("tabindex", "-1");
    }
  }
}
function except(obj, keys) {
  return Object.keys(obj).filter((k) => !keys.includes(k)).reduce((acc, key) => (acc[key] = obj[key], acc), {});
}
function getDraggedSlidesCount(params) {
  const { isVertical, isReversed, dragged, effectiveSlideSize, threshold } = params;
  const dragValue = isVertical ? dragged.y : dragged.x;
  if (dragValue === 0)
    return 0;
  const dragRatio = dragValue / effectiveSlideSize;
  const absRatio = Math.abs(dragRatio);
  if (absRatio < threshold)
    return 0;
  const slidesDragged = absRatio < 1 ? Math.sign(dragRatio) : Math.round(dragRatio);
  return isReversed ? slidesDragged : -slidesDragged;
}
function getNumberInRange({ val, max, min }) {
  if (max < min) {
    return val;
  }
  return Math.min(Math.max(val, isNaN(min) ? val : min), isNaN(max) ? val : max);
}
function getTransformValues(el) {
  const { transform } = window.getComputedStyle(el);
  return transform.split(/[(,)]/).slice(1, -1).map((v) => parseFloat(v));
}
function getScaleMultipliers(transformElements) {
  let widthMultiplier = 1;
  let heightMultiplier = 1;
  transformElements.forEach((el) => {
    const transformArr = getTransformValues(el);
    if (transformArr.length === 6) {
      widthMultiplier /= transformArr[0];
      heightMultiplier /= transformArr[3];
    }
  });
  return { widthMultiplier, heightMultiplier };
}
function getSnapAlignOffsetByItemsToShow(align, itemsToShow) {
  switch (align) {
    case "start":
      return 0;
    case "center":
    case "center-odd":
      return (itemsToShow - 1) / 2;
    case "center-even":
      return (itemsToShow - 2) / 2;
    case "end":
      return itemsToShow - 1;
    default:
      return 0;
  }
}
function getSnapAlignOffsetBySlideAndViewport(align, slideSize, viewportSize) {
  switch (align) {
    case "start":
      return 0;
    case "center":
    case "center-odd":
      return (viewportSize - slideSize) / 2;
    case "center-even":
      return viewportSize / 2 - slideSize;
    case "end":
      return viewportSize - slideSize;
    default:
      return 0;
  }
}
function getSnapAlignOffset({ slideSize, viewportSize, align, itemsToShow }) {
  if (itemsToShow !== void 0) {
    return getSnapAlignOffsetByItemsToShow(align, itemsToShow);
  }
  if (slideSize !== void 0 && viewportSize !== void 0) {
    return getSnapAlignOffsetBySlideAndViewport(align, slideSize, viewportSize);
  }
  return 0;
}
function i18nFormatter(string = "", values = {}) {
  return Object.entries(values).reduce((acc, [key, value]) => acc.replace(`{${key}}`, String(value)), string);
}
function mapNumberToRange({ val, max, min = 0 }) {
  const mod = max - min + 1;
  return ((val - min) % mod + mod) % mod + min;
}
function throttle(fn, ms = 0) {
  let isThrottled = false;
  let start = 0;
  let frameId = null;
  function throttled(...args) {
    if (isThrottled)
      return;
    isThrottled = true;
    const step = () => {
      frameId = requestAnimationFrame((time) => {
        const elapsed = time - start;
        if (elapsed > ms) {
          start = time;
          fn(...args);
          isThrottled = false;
        } else {
          step();
        }
      });
    };
    step();
  }
  throttled.cancel = () => {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
      isThrottled = false;
    }
  };
  return throttled;
}
function toCssValue(value, unit = "px") {
  if (value === null || value === void 0 || value === "") {
    return void 0;
  }
  if (typeof value === "number" || parseFloat(value).toString() === value) {
    return `${value}${unit}`;
  }
  return value;
}
const ARIA = /* @__PURE__ */ defineComponent({
  name: "CarouselAria",
  setup() {
    const carousel = inject(injectCarousel);
    if (!carousel) {
      return () => "";
    }
    return () => h("div", {
      class: ["carousel__liveregion", "carousel__sr-only"],
      "aria-live": "polite",
      "aria-atomic": "true"
    }, i18nFormatter(carousel.config.i18n["itemXofY"], {
      currentSlide: carousel.currentSlide + 1,
      slidesCount: carousel.slidesCount
    }));
  }
});
function useDrag(options) {
  let isTouch = false;
  const startPosition = { x: 0, y: 0 };
  const dragged = reactive({ x: 0, y: 0 });
  const isDragging = ref(false);
  const { isSliding } = options;
  const sliding = computed(() => {
    return typeof isSliding === "boolean" ? isSliding : isSliding.value;
  });
  const handleDragStart = (event) => {
    var _a;
    const targetTagName = event.target.tagName;
    if (["INPUT", "TEXTAREA", "SELECT"].includes(targetTagName) || sliding.value) {
      return;
    }
    isTouch = event.type === "touchstart";
    if (isTouch && event.touches.length > 1) {
      return;
    } else if (!isTouch) {
      event.preventDefault();
      if (event.button !== 0) {
        return;
      }
    }
    startPosition.x = isTouch ? event.touches[0].clientX : event.clientX;
    startPosition.y = isTouch ? event.touches[0].clientY : event.clientY;
    const moveEvent = isTouch ? "touchmove" : "mousemove";
    const endEvent = isTouch ? "touchend" : "mouseup";
    document.addEventListener(moveEvent, handleDrag, { passive: false });
    document.addEventListener(endEvent, handleDragEnd, { passive: true });
    (_a = options.onDragStart) === null || _a === void 0 ? void 0 : _a.call(options);
  };
  const handleDrag = throttle((event) => {
    var _a;
    if (isTouch && event.touches.length > 1) {
      return;
    }
    isDragging.value = true;
    const currentX = isTouch ? event.touches[0].clientX : event.clientX;
    const currentY = isTouch ? event.touches[0].clientY : event.clientY;
    dragged.x = currentX - startPosition.x;
    dragged.y = currentY - startPosition.y;
    (_a = options.onDrag) === null || _a === void 0 ? void 0 : _a.call(options, { deltaX: dragged.x, deltaY: dragged.y, isTouch });
  });
  const handleDragEnd = () => {
    var _a;
    handleDrag.cancel();
    const draggedDistance = Math.abs(dragged.x) + Math.abs(dragged.y);
    if (!isTouch && draggedDistance > 10) {
      window.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
      }, { once: true, capture: true });
    }
    (_a = options.onDragEnd) === null || _a === void 0 ? void 0 : _a.call(options);
    dragged.x = 0;
    dragged.y = 0;
    isDragging.value = false;
    const moveEvent = isTouch ? "touchmove" : "mousemove";
    const endEvent = isTouch ? "touchend" : "mouseup";
    document.removeEventListener(moveEvent, handleDrag);
    document.removeEventListener(endEvent, handleDragEnd);
  };
  return {
    dragged,
    isDragging,
    handleDragStart
  };
}
function useHover() {
  const isHover = ref(false);
  const handleMouseEnter = () => {
    isHover.value = true;
  };
  const handleMouseLeave = () => {
    isHover.value = false;
  };
  return {
    isHover,
    handleMouseEnter,
    handleMouseLeave
  };
}
function useWheel(options) {
  const { isVertical, isSliding, config } = options;
  const vertical = computed(() => {
    return typeof isVertical === "boolean" ? isVertical : isVertical.value;
  });
  const sliding = computed(() => {
    return typeof isSliding === "boolean" ? isSliding : isSliding.value;
  });
  const handleScroll = (event) => {
    var _a, _b;
    event.preventDefault();
    if (!config.mouseWheel || sliding.value) {
      return;
    }
    const threshold = typeof config.mouseWheel === "object" ? (_a = config.mouseWheel.threshold) !== null && _a !== void 0 ? _a : DEFAULT_MOUSE_WHEEL_THRESHOLD : DEFAULT_MOUSE_WHEEL_THRESHOLD;
    const deltaY = Math.abs(event.deltaY) > threshold ? event.deltaY : 0;
    const deltaX = Math.abs(event.deltaX) > threshold ? event.deltaX : 0;
    if (deltaY === 0 && deltaX === 0) {
      return;
    }
    const primaryDelta = vertical.value ? deltaY : deltaX;
    const effectiveDelta = primaryDelta !== 0 ? primaryDelta : vertical.value ? deltaX : deltaY;
    const isScrollingForward = effectiveDelta > 0;
    (_b = options.onWheel) === null || _b === void 0 ? void 0 : _b.call(options, { deltaX, deltaY, isScrollingForward });
  };
  return {
    handleScroll
  };
}
const carouselProps = {
  // time to auto advance slides in ms
  autoplay: {
    default: DEFAULT_CONFIG.autoplay,
    type: Number
  },
  // an object to store breakpoints
  breakpoints: {
    default: DEFAULT_CONFIG.breakpoints,
    type: Object
  },
  // controls the breakpoint mode relative to the carousel container or the viewport
  breakpointMode: {
    default: DEFAULT_CONFIG.breakpointMode,
    validator(value) {
      return BREAKPOINT_MODE_OPTIONS.includes(value);
    }
  },
  clamp: {
    type: Boolean
  },
  // control the direction of the carousel
  dir: {
    type: String,
    default: DEFAULT_CONFIG.dir,
    validator(value, props) {
      if (!DIR_OPTIONS.includes(value)) {
        return false;
      }
      const normalizedDir = value in DIR_MAP ? DIR_MAP[value] : value;
      if (["ttb", "btt"].includes(normalizedDir) && (!props.height || props.height === "auto")) {
        console.warn(`[vue3-carousel]: The dir "${value}" is not supported with height "auto".`);
      }
      return true;
    }
  },
  // enable/disable the carousel component
  enabled: {
    default: DEFAULT_CONFIG.enabled,
    type: Boolean
  },
  // control the gap between slides
  gap: {
    default: DEFAULT_CONFIG.gap,
    type: Number
  },
  // set carousel height
  height: {
    default: DEFAULT_CONFIG.height,
    type: [Number, String]
  },
  // aria-labels and additional text labels
  i18n: {
    default: DEFAULT_CONFIG.i18n,
    type: Object
  },
  ignoreAnimations: {
    default: false,
    type: [Array, Boolean, String]
  },
  // count of items to be scrolled
  itemsToScroll: {
    default: DEFAULT_CONFIG.itemsToScroll,
    type: Number
  },
  // count of items to showed per view
  itemsToShow: {
    default: DEFAULT_CONFIG.itemsToShow,
    type: [Number, String]
  },
  // slide number number of initial slide
  modelValue: {
    default: void 0,
    type: Number
  },
  // toggle mouse dragging
  mouseDrag: {
    default: DEFAULT_CONFIG.mouseDrag,
    type: [Boolean, Object]
  },
  // toggle mouse wheel scrolling
  mouseWheel: {
    default: DEFAULT_CONFIG.mouseWheel,
    type: [Boolean, Object]
  },
  // control mouse scroll threshold
  mouseScrollThreshold: {
    default: DEFAULT_CONFIG.mouseScrollThreshold,
    type: Number
  },
  pauseAutoplayOnHover: {
    default: DEFAULT_CONFIG.pauseAutoplayOnHover,
    type: Boolean
  },
  preventExcessiveDragging: {
    default: false,
    type: Boolean,
    validator(value, props) {
      if (value && props.wrapAround) {
        console.warn(`[vue3-carousel]: "preventExcessiveDragging" cannot be used with wrapAround. The setting will be ignored.`);
      }
      return true;
    }
  },
  slideEffect: {
    type: String,
    default: DEFAULT_CONFIG.slideEffect,
    validator(value) {
      return SLIDE_EFFECTS.includes(value);
    }
  },
  // control snap position alignment
  snapAlign: {
    default: DEFAULT_CONFIG.snapAlign,
    validator(value) {
      return SNAP_ALIGN_OPTIONS.includes(value);
    }
  },
  // toggle touch dragging
  touchDrag: {
    default: DEFAULT_CONFIG.touchDrag,
    type: [Boolean, Object]
  },
  // sliding transition time in ms
  transition: {
    default: DEFAULT_CONFIG.transition,
    type: Number
  },
  // control infinite scrolling mode
  wrapAround: {
    default: DEFAULT_CONFIG.wrapAround,
    type: Boolean
  }
};
const Carousel = /* @__PURE__ */ defineComponent({
  name: "VueCarousel",
  props: carouselProps,
  emits: [
    "before-init",
    "drag",
    "init",
    "loop",
    "slide-end",
    "slide-registered",
    "slide-start",
    "slide-unregistered",
    "update:modelValue",
    "wheel"
  ],
  setup(props, { slots, emit: emit2, expose }) {
    var _a;
    const slideRegistry = createSlideRegistry(emit2);
    const slides = slideRegistry.getSlides();
    const slidesCount = computed(() => slides.length);
    const root = ref(null);
    const viewport = ref(null);
    const slideSize = ref(0);
    const fallbackConfig = computed(() => Object.assign(Object.assign(Object.assign({}, DEFAULT_CONFIG), except(props, ["breakpoints", "modelValue"])), { i18n: Object.assign(Object.assign({}, DEFAULT_CONFIG.i18n), props.i18n) }));
    const config = shallowReactive(Object.assign({}, fallbackConfig.value));
    const currentSlideIndex = ref((_a = props.modelValue) !== null && _a !== void 0 ? _a : 0);
    const activeSlideIndex = ref(currentSlideIndex.value);
    watch(currentSlideIndex, (val) => activeSlideIndex.value = val);
    const prevSlideIndex = ref(0);
    const middleSlideIndex = computed(() => Math.ceil((slidesCount.value - 1) / 2));
    const maxSlideIndex = computed(() => slidesCount.value - 1);
    const minSlideIndex = computed(() => 0);
    let autoplayTimer = null;
    let transitionTimer = null;
    let resizeObserver = null;
    const effectiveSlideSize = computed(() => slideSize.value + config.gap);
    const normalizedDir = computed(() => {
      const dir = config.dir || "ltr";
      return dir in DIR_MAP ? DIR_MAP[dir] : dir;
    });
    const isReversed = computed(() => ["rtl", "btt"].includes(normalizedDir.value));
    const isVertical = computed(() => ["ttb", "btt"].includes(normalizedDir.value));
    const isAuto = computed(() => config.itemsToShow === "auto");
    const dimension = computed(() => isVertical.value ? "height" : "width");
    function updateBreakpointsConfig() {
      var _a2;
      if (!mounted.value) {
        return;
      }
      const widthSource = (fallbackConfig.value.breakpointMode === "carousel" ? (_a2 = root.value) === null || _a2 === void 0 ? void 0 : _a2.getBoundingClientRect().width : typeof window !== "undefined" ? window.innerWidth : 0) || 0;
      const breakpointsArray = Object.keys(props.breakpoints || {}).map((key) => Number(key)).sort((a, b3) => +b3 - +a);
      const newConfig = {};
      breakpointsArray.some((breakpoint) => {
        if (widthSource >= breakpoint) {
          Object.assign(newConfig, props.breakpoints[breakpoint]);
          if (newConfig.i18n) {
            Object.assign(newConfig.i18n, fallbackConfig.value.i18n, props.breakpoints[breakpoint].i18n);
          }
          return true;
        }
        return false;
      });
      Object.assign(config, fallbackConfig.value, newConfig);
      if (!isAuto.value) {
        config.itemsToShow = getNumberInRange({
          val: Number(config.itemsToShow),
          max: props.clamp ? slidesCount.value : Infinity,
          min: 1
        });
      }
    }
    const handleResize = throttle(() => {
      updateBreakpointsConfig();
      updateSlidesData();
      updateSlideSize();
    });
    const transformElements = shallowReactive(/* @__PURE__ */ new Set());
    const slidesRect = ref([]);
    function updateSlidesRectSize({ widthMultiplier, heightMultiplier }) {
      slidesRect.value = slides.map((slide2) => {
        var _a2;
        const rect = (_a2 = slide2.exposed) === null || _a2 === void 0 ? void 0 : _a2.getBoundingRect();
        return {
          width: rect.width * widthMultiplier,
          height: rect.height * heightMultiplier
        };
      });
    }
    const viewportRect = ref({
      width: 0,
      height: 0
    });
    function updateViewportRectSize({ widthMultiplier, heightMultiplier }) {
      var _a2;
      const rect = ((_a2 = viewport.value) === null || _a2 === void 0 ? void 0 : _a2.getBoundingClientRect()) || { width: 0, height: 0 };
      viewportRect.value = {
        width: rect.width * widthMultiplier,
        height: rect.height * heightMultiplier
      };
    }
    function updateSlideSize() {
      if (!viewport.value)
        return;
      const scaleMultipliers = getScaleMultipliers(transformElements);
      updateViewportRectSize(scaleMultipliers);
      updateSlidesRectSize(scaleMultipliers);
      if (isAuto.value) {
        slideSize.value = calculateAverage(slidesRect.value.map((slide2) => slide2[dimension.value]));
      } else {
        const itemsToShow = Number(config.itemsToShow);
        const totalGap = (itemsToShow - 1) * config.gap;
        slideSize.value = (viewportRect.value[dimension.value] - totalGap) / itemsToShow;
      }
    }
    function updateSlidesData() {
      if (!config.wrapAround && slidesCount.value > 0) {
        currentSlideIndex.value = getNumberInRange({
          val: currentSlideIndex.value,
          max: maxSlideIndex.value,
          min: minSlideIndex.value
        });
      }
    }
    const ignoreAnimations = computed(() => {
      if (typeof props.ignoreAnimations === "string") {
        return props.ignoreAnimations.split(",");
      } else if (Array.isArray(props.ignoreAnimations)) {
        return props.ignoreAnimations;
      } else if (!props.ignoreAnimations) {
        return [];
      }
      return false;
    });
    watchEffect(() => updateSlidesData());
    watchEffect(() => {
      updateSlideSize();
    });
    let animationInterval;
    const setAnimationInterval = (event) => {
      const target = event.target;
      if (!(target === null || target === void 0 ? void 0 : target.contains(root.value)) || Array.isArray(ignoreAnimations.value) && ignoreAnimations.value.includes(event.animationName)) {
        return;
      }
      transformElements.add(target);
      if (!animationInterval) {
        const stepAnimation = () => {
          animationInterval = requestAnimationFrame(() => {
            updateSlideSize();
            stepAnimation();
          });
        };
        stepAnimation();
      }
    };
    const finishAnimation = (event) => {
      const target = event.target;
      if (target) {
        transformElements.delete(target);
      }
      if (animationInterval && transformElements.size === 0) {
        cancelAnimationFrame(animationInterval);
        updateSlideSize();
      }
    };
    const mounted = ref(false);
    if (typeof document !== "undefined") {
      watchEffect(() => {
        if (mounted.value && ignoreAnimations.value !== false) {
          document.addEventListener("animationstart", setAnimationInterval);
          document.addEventListener("animationend", finishAnimation);
        } else {
          document.removeEventListener("animationstart", setAnimationInterval);
          document.removeEventListener("animationend", finishAnimation);
        }
      });
    }
    onMounted(() => {
      mounted.value = true;
      updateBreakpointsConfig();
      initAutoplay();
      if (root.value) {
        resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(root.value);
      }
      emit2("init");
    });
    onBeforeUnmount(() => {
      mounted.value = false;
      slideRegistry.cleanup();
      if (transitionTimer) {
        clearTimeout(transitionTimer);
      }
      if (animationInterval) {
        cancelAnimationFrame(animationInterval);
      }
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      if (typeof document !== "undefined") {
        handleBlur();
      }
      if (root.value) {
        root.value.removeEventListener("transitionend", updateSlideSize);
        root.value.removeEventListener("animationiteration", updateSlideSize);
      }
    });
    const { isHover, handleMouseEnter, handleMouseLeave } = useHover();
    const handleArrowKeys = throttle((event) => {
      if (event.ctrlKey)
        return;
      switch (event.key) {
        case "ArrowLeft":
        case "ArrowUp":
          if (isVertical.value === event.key.endsWith("Up")) {
            if (isReversed.value) {
              next(true);
            } else {
              prev(true);
            }
          }
          break;
        case "ArrowRight":
        case "ArrowDown":
          if (isVertical.value === event.key.endsWith("Down")) {
            if (isReversed.value) {
              prev(true);
            } else {
              next(true);
            }
          }
          break;
      }
    }, 200);
    const handleBlur = () => {
      document.removeEventListener("keydown", handleArrowKeys);
    };
    const handleFocus = () => {
      document.addEventListener("keydown", handleArrowKeys);
    };
    function initAutoplay() {
      if (!config.autoplay || config.autoplay <= 0) {
        return;
      }
      autoplayTimer = setInterval(() => {
        if (config.pauseAutoplayOnHover && isHover.value) {
          return;
        }
        next();
      }, config.autoplay);
    }
    function resetAutoplay() {
      stopAutoplay();
      initAutoplay();
    }
    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }
    const isSliding = ref(false);
    const onDrag = ({ deltaX, deltaY, isTouch }) => {
      var _a2, _b, _c, _d;
      emit2("drag", { deltaX, deltaY });
      const threshold = isTouch ? typeof config.touchDrag === "object" ? (_b = (_a2 = config.touchDrag) === null || _a2 === void 0 ? void 0 : _a2.threshold) !== null && _b !== void 0 ? _b : DEFAULT_DRAG_THRESHOLD : DEFAULT_DRAG_THRESHOLD : typeof config.mouseDrag === "object" ? (_d = (_c = config.mouseDrag) === null || _c === void 0 ? void 0 : _c.threshold) !== null && _d !== void 0 ? _d : DEFAULT_DRAG_THRESHOLD : DEFAULT_DRAG_THRESHOLD;
      const draggedSlides = getDraggedSlidesCount({
        isVertical: isVertical.value,
        isReversed: isReversed.value,
        dragged: { x: deltaX, y: deltaY },
        effectiveSlideSize: effectiveSlideSize.value,
        threshold
      });
      if (draggedSlides === 0) {
        return;
      }
      activeSlideIndex.value = config.wrapAround ? currentSlideIndex.value + draggedSlides : getNumberInRange({
        val: currentSlideIndex.value + draggedSlides,
        max: maxSlideIndex.value,
        min: minSlideIndex.value
      });
    };
    const onDragEnd = () => slideTo2(activeSlideIndex.value);
    const { dragged, isDragging, handleDragStart } = useDrag({
      isSliding,
      onDrag,
      onDragEnd
    });
    const onWheel = ({ deltaX, deltaY, isScrollingForward }) => {
      emit2("wheel", { deltaX, deltaY });
      if (isScrollingForward) {
        if (isReversed.value) {
          prev();
        } else {
          next();
        }
      } else {
        if (isReversed.value) {
          next();
        } else {
          prev();
        }
      }
    };
    const { handleScroll } = useWheel({
      isVertical,
      isSliding,
      config,
      onWheel
    });
    function next(skipTransition = false) {
      slideTo2(currentSlideIndex.value + config.itemsToScroll, skipTransition);
    }
    function prev(skipTransition = false) {
      slideTo2(currentSlideIndex.value - config.itemsToScroll, skipTransition);
    }
    function slideTo2(slideIndex, skipTransition = false) {
      if (!skipTransition && isSliding.value) {
        return;
      }
      const targetIndex = (config.wrapAround ? mapNumberToRange : getNumberInRange)({
        val: slideIndex,
        max: maxSlideIndex.value,
        min: minSlideIndex.value
      });
      if (currentSlideIndex.value === targetIndex) {
        return;
      }
      prevSlideIndex.value = currentSlideIndex.value;
      emit2("slide-start", {
        slidingToIndex: slideIndex,
        currentSlideIndex: currentSlideIndex.value,
        prevSlideIndex: prevSlideIndex.value,
        slidesCount: slidesCount.value
      });
      stopAutoplay();
      isSliding.value = true;
      currentSlideIndex.value = slideIndex;
      if (targetIndex !== slideIndex) {
        modelWatcher.pause();
      }
      emit2("update:modelValue", targetIndex);
      const transitionCallback = () => {
        if (config.wrapAround && targetIndex !== slideIndex) {
          modelWatcher.resume();
          currentSlideIndex.value = targetIndex;
          emit2("loop", {
            currentSlideIndex: currentSlideIndex.value,
            slidingToIndex: slideIndex
          });
        }
        emit2("slide-end", {
          currentSlideIndex: currentSlideIndex.value,
          prevSlideIndex: prevSlideIndex.value,
          slidesCount: slidesCount.value
        });
        isSliding.value = false;
        resetAutoplay();
      };
      transitionTimer = setTimeout(transitionCallback, config.transition);
    }
    function restartCarousel() {
      updateBreakpointsConfig();
      updateSlidesData();
      updateSlideSize();
      resetAutoplay();
    }
    watch(() => [fallbackConfig.value, props.breakpoints], () => updateBreakpointsConfig(), { deep: true });
    watch(() => props.autoplay, () => resetAutoplay());
    const modelWatcher = watch(() => props.modelValue, (val) => {
      if (val === currentSlideIndex.value) {
        return;
      }
      slideTo2(Number(val), true);
    });
    emit2("before-init");
    const clonedSlidesCount = computed(() => {
      if (!config.wrapAround) {
        return { before: 0, after: 0 };
      }
      if (isAuto.value) {
        return { before: slides.length, after: slides.length };
      }
      const itemsToShow = Number(config.itemsToShow);
      const slidesToClone = Math.ceil(itemsToShow + (config.itemsToScroll - 1));
      const before = slidesToClone - activeSlideIndex.value;
      const after = slidesToClone - (slidesCount.value - (activeSlideIndex.value + 1));
      return {
        before: Math.max(0, before),
        after: Math.max(0, after)
      };
    });
    const clonedSlidesOffset = computed(() => {
      if (!clonedSlidesCount.value.before) {
        return 0;
      }
      if (isAuto.value) {
        return slidesRect.value.slice(-1 * clonedSlidesCount.value.before).reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0) * -1;
      }
      return clonedSlidesCount.value.before * effectiveSlideSize.value * -1;
    });
    const snapAlignOffset = computed(() => {
      var _a2;
      if (isAuto.value) {
        const slideIndex = (currentSlideIndex.value % slides.length + slides.length) % slides.length;
        return getSnapAlignOffset({
          slideSize: (_a2 = slidesRect.value[slideIndex]) === null || _a2 === void 0 ? void 0 : _a2[dimension.value],
          viewportSize: viewportRect.value[dimension.value],
          align: config.snapAlign
        });
      }
      return getSnapAlignOffset({
        align: config.snapAlign,
        itemsToShow: +config.itemsToShow
      });
    });
    const scrolledOffset = computed(() => {
      let output = 0;
      if (isAuto.value) {
        if (currentSlideIndex.value < 0) {
          output = slidesRect.value.slice(currentSlideIndex.value).reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0) * -1;
        } else {
          output = slidesRect.value.slice(0, currentSlideIndex.value).reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0);
        }
        output -= snapAlignOffset.value;
        if (!config.wrapAround) {
          const maxSlidingValue = slidesRect.value.reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0) - viewportRect.value[dimension.value] - config.gap;
          output = getNumberInRange({
            val: output,
            max: maxSlidingValue,
            min: 0
          });
        }
      } else {
        let scrolledSlides = currentSlideIndex.value - snapAlignOffset.value;
        if (!config.wrapAround) {
          scrolledSlides = getNumberInRange({
            val: scrolledSlides,
            max: slidesCount.value - +config.itemsToShow,
            min: 0
          });
        }
        output = scrolledSlides * effectiveSlideSize.value;
      }
      return output * (isReversed.value ? 1 : -1);
    });
    const visibleRange = computed(() => {
      var _a2, _b;
      if (!isAuto.value) {
        const base = currentSlideIndex.value - snapAlignOffset.value;
        if (config.wrapAround) {
          return {
            min: Math.floor(base),
            max: Math.ceil(base + Number(config.itemsToShow) - 1)
          };
        }
        return {
          min: Math.floor(getNumberInRange({
            val: base,
            max: slidesCount.value - Number(config.itemsToShow),
            min: 0
          })),
          max: Math.ceil(getNumberInRange({
            val: base + Number(config.itemsToShow) - 1,
            max: slidesCount.value - 1,
            min: 0
          }))
        };
      }
      let minIndex = 0;
      {
        let accumulatedSize = 0;
        let index = 0 - clonedSlidesCount.value.before;
        const offset = Math.abs(scrolledOffset.value + clonedSlidesOffset.value);
        while (accumulatedSize <= offset) {
          const normalizedIndex = (index % slides.length + slides.length) % slides.length;
          accumulatedSize += ((_a2 = slidesRect.value[normalizedIndex]) === null || _a2 === void 0 ? void 0 : _a2[dimension.value]) + config.gap;
          index++;
        }
        minIndex = index - 1;
      }
      let maxIndex = 0;
      {
        let index = minIndex;
        let accumulatedSize = 0;
        if (index < 0) {
          accumulatedSize = slidesRect.value.slice(0, index).reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0) - Math.abs(scrolledOffset.value + clonedSlidesOffset.value);
        } else {
          accumulatedSize = slidesRect.value.slice(0, index).reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0) - Math.abs(scrolledOffset.value);
        }
        while (accumulatedSize < viewportRect.value[dimension.value]) {
          const normalizedIndex = (index % slides.length + slides.length) % slides.length;
          accumulatedSize += ((_b = slidesRect.value[normalizedIndex]) === null || _b === void 0 ? void 0 : _b[dimension.value]) + config.gap;
          index++;
        }
        maxIndex = index - 1;
      }
      return {
        min: Math.floor(minIndex),
        max: Math.ceil(maxIndex)
      };
    });
    const trackTransform = computed(() => {
      if (config.slideEffect === "fade") {
        return void 0;
      }
      const translateAxis = isVertical.value ? "Y" : "X";
      const dragOffset = isVertical.value ? dragged.y : dragged.x;
      let totalOffset = scrolledOffset.value + dragOffset;
      if (!config.wrapAround && config.preventExcessiveDragging) {
        let maxSlidingValue = 0;
        if (isAuto.value) {
          maxSlidingValue = slidesRect.value.reduce((acc, slide2) => acc + slide2[dimension.value], 0);
        } else {
          maxSlidingValue = (slidesCount.value - Number(config.itemsToShow)) * effectiveSlideSize.value;
        }
        const min = isReversed.value ? 0 : -1 * maxSlidingValue;
        const max = isReversed.value ? maxSlidingValue : 0;
        totalOffset = getNumberInRange({
          val: totalOffset,
          min,
          max
        });
      }
      return `translate${translateAxis}(${totalOffset}px)`;
    });
    const carouselStyle = computed(() => ({
      "--vc-carousel-height": toCssValue(config.height),
      "--vc-cloned-offset": toCssValue(clonedSlidesOffset.value),
      "--vc-slide-gap": toCssValue(config.gap),
      "--vc-transition-duration": isSliding.value ? toCssValue(config.transition, "ms") : void 0
    }));
    const nav = { slideTo: slideTo2, next, prev };
    const provided = reactive({
      activeSlide: activeSlideIndex,
      config,
      currentSlide: currentSlideIndex,
      isSliding,
      isVertical,
      maxSlide: maxSlideIndex,
      minSlide: minSlideIndex,
      nav,
      normalizedDir,
      slideRegistry,
      slideSize,
      slides,
      slidesCount,
      viewport,
      visibleRange
    });
    provide(injectCarousel, provided);
    const data = reactive({
      config,
      currentSlide: currentSlideIndex,
      maxSlide: maxSlideIndex,
      middleSlide: middleSlideIndex,
      minSlide: minSlideIndex,
      slideSize,
      slidesCount
    });
    expose(reactive(Object.assign({
      data,
      next,
      prev,
      restartCarousel,
      slideTo: slideTo2,
      updateBreakpointsConfig,
      updateSlideSize,
      updateSlidesData
    }, toRefs(provided))));
    return () => {
      var _a2;
      const slotSlides = slots.default || slots.slides;
      const outputSlides = (slotSlides === null || slotSlides === void 0 ? void 0 : slotSlides(data)) || [];
      const { before, after } = clonedSlidesCount.value;
      const slidesBefore = createCloneSlides({
        slides,
        position: "before",
        toShow: before
      });
      const slidesAfter = createCloneSlides({
        slides,
        position: "after",
        toShow: after
      });
      const output = [...slidesBefore, ...outputSlides, ...slidesAfter];
      if (!config.enabled || !output.length) {
        return h("section", {
          ref: root,
          class: ["carousel", "is-disabled"]
        }, output);
      }
      const addonsElements = ((_a2 = slots.addons) === null || _a2 === void 0 ? void 0 : _a2.call(slots, data)) || [];
      const trackEl = h("ol", {
        class: "carousel__track",
        onMousedownCapture: config.mouseDrag ? handleDragStart : null,
        onTouchstartPassiveCapture: config.touchDrag ? handleDragStart : null,
        onWheel: config.mouseWheel ? handleScroll : null,
        style: { transform: trackTransform.value }
      }, output);
      const viewPortEl = h("div", { class: "carousel__viewport", ref: viewport }, trackEl);
      return h("section", {
        ref: root,
        class: [
          "carousel",
          `is-${normalizedDir.value}`,
          `is-effect-${config.slideEffect}`,
          {
            "is-dragging": isDragging.value,
            "is-hover": isHover.value,
            "is-sliding": isSliding.value,
            "is-vertical": isVertical.value
          }
        ],
        dir: normalizedDir.value,
        style: carouselStyle.value,
        "aria-label": config.i18n["ariaGallery"],
        tabindex: "0",
        onBlur: handleBlur,
        onFocus: handleFocus,
        onMouseenter: handleMouseEnter,
        onMouseleave: handleMouseLeave
      }, [viewPortEl, addonsElements, h(ARIA)]);
    };
  }
});
var IconName;
(function(IconName2) {
  IconName2["arrowDown"] = "arrowDown";
  IconName2["arrowLeft"] = "arrowLeft";
  IconName2["arrowRight"] = "arrowRight";
  IconName2["arrowUp"] = "arrowUp";
})(IconName || (IconName = {}));
const Slide = /* @__PURE__ */ defineComponent({
  name: "CarouselSlide",
  props: {
    id: {
      type: String,
      default: (props) => props.isClone ? void 0 : useId()
    },
    index: {
      type: Number,
      default: void 0
    },
    isClone: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { attrs, slots, expose }) {
    const carousel = inject(injectCarousel);
    provide(injectCarousel, void 0);
    if (!carousel) {
      return () => "";
    }
    const currentIndex = ref(props.index);
    const setIndex = (newIndex) => {
      currentIndex.value = newIndex;
    };
    const instance = getCurrentInstance();
    const getBoundingRect = () => {
      const el = instance.vnode.el;
      return el ? el.getBoundingClientRect() : { width: 0, height: 0 };
    };
    expose({
      id: props.id,
      setIndex,
      getBoundingRect
    });
    const isActive = computed(() => currentIndex.value === carousel.activeSlide);
    const isPrev = computed(() => currentIndex.value === carousel.activeSlide - 1);
    const isNext = computed(() => currentIndex.value === carousel.activeSlide + 1);
    const isVisible = computed(() => currentIndex.value >= carousel.visibleRange.min && currentIndex.value <= carousel.visibleRange.max);
    const slideStyle = computed(() => {
      if (carousel.config.itemsToShow === "auto") {
        return;
      }
      const itemsToShow = carousel.config.itemsToShow;
      const dimension = carousel.config.gap > 0 && itemsToShow > 1 ? `calc(${100 / itemsToShow}% - ${carousel.config.gap * (itemsToShow - 1) / itemsToShow}px)` : `${100 / itemsToShow}%`;
      return carousel.isVertical ? { height: dimension } : { width: dimension };
    });
    carousel.slideRegistry.registerSlide(instance, props.index);
    onUnmounted(() => {
      carousel.slideRegistry.unregisterSlide(instance);
    });
    if (props.isClone) {
      onMounted(() => {
        disableChildrenTabbing(instance.vnode);
      });
      onUpdated(() => {
        disableChildrenTabbing(instance.vnode);
      });
    }
    return () => {
      var _a, _b;
      if (!carousel.config.enabled) {
        return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
      }
      return h("li", {
        style: [attrs.style, Object.assign({}, slideStyle.value)],
        class: {
          carousel__slide: true,
          "carousel__slide--clone": props.isClone,
          "carousel__slide--visible": isVisible.value,
          "carousel__slide--active": isActive.value,
          "carousel__slide--prev": isPrev.value,
          "carousel__slide--next": isNext.value,
          "carousel__slide--sliding": carousel.isSliding
        },
        onFocusin: () => {
          if (carousel.viewport) {
            carousel.viewport.scrollLeft = 0;
          }
          carousel.nav.slideTo(currentIndex.value);
        },
        id: props.isClone ? void 0 : props.id,
        "aria-hidden": props.isClone || void 0
      }, (_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots, {
        currentIndex: currentIndex.value,
        isActive: isActive.value,
        isClone: props.isClone,
        isPrev: isPrev.value,
        isNext: isNext.value,
        isSliding: carousel.isSliding,
        isVisible: isVisible.value
      }));
    };
  }
});
const _sfc_main$e = {
  name: "ProductMoreInfo",
  props: {
    imageIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isContentVisible: false,
      mediaThumbnails: null,
      MOBILE_BREAKPOINT: 900
    };
  },
  computed: {
    ...mapGetters({
      product: "getSelectionRelatedProduct",
      initalData: "getInitialData",
      currentProductImageSlide: "getCurrentProductImageSlide"
    }),
    moreInfo() {
      var _a, _b;
      return (_b = (_a = this.product) == null ? void 0 : _a.moreInfo) == null ? void 0 : _b[this.imageIndex];
    }
  },
  methods: {
    switchContentVisibility() {
      this.isContentVisible = !this.isContentVisible;
    },
    handleDocumentClick(e) {
      if (!this.isContentVisible) return;
      const contentEl = this.$refs.moreInfoContent;
      if (!contentEl) return;
      if (contentEl.contains(e.target)) return;
      if (e.target.closest("[data-more-info-toggle]")) return;
      this.isContentVisible = false;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleDocumentClick, true);
    this.mediaThumbnails = document.querySelector(".media-gallery .media-gallery__thumbnails");
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick, true);
  },
  watch: {
    isContentVisible(newValue) {
      if (!this.mediaThumbnails) return;
      this.mediaThumbnails.style.opacity = newValue && window.innerWidth <= this.MOBILE_BREAKPOINT ? "0" : "1";
    },
    currentProductImageSlide(newIndex) {
      this.isContentVisible = false;
    }
  }
};
const _hoisted_1$e = { class: "bundle-builder__more--info-left" };
const _hoisted_2$b = { class: "heading" };
const _hoisted_3$8 = { class: "bundle-builder__more--info-right" };
const _hoisted_4$6 = { class: "more-info-label" };
const _hoisted_5$6 = ["innerHTML"];
const _hoisted_6$5 = {
  ref: "moreInfoContent",
  class: "bundle-builder__more--info-content"
};
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  return ((_a = $options.moreInfo) == null ? void 0 : _a.title) && ((_b = $options.moreInfo) == null ? void 0 : _b.content) ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["bundle-builder__more--info", { active: $data.isContentVisible }])
  }, [
    createBaseVNode("div", _hoisted_1$e, [
      createBaseVNode("span", _hoisted_2$b, toDisplayString($options.moreInfo.title), 1)
    ]),
    createBaseVNode("div", _hoisted_3$8, [
      createBaseVNode("button", {
        onClick: _cache[0] || (_cache[0] = (...args) => $options.switchContentVisibility && $options.switchContentVisibility(...args))
      }, [
        createBaseVNode("span", _hoisted_4$6, toDisplayString(_ctx.initalData.translations.moreInfo), 1),
        createBaseVNode("span", {
          class: "more-info-icon",
          innerHTML: _ctx.initalData.htmlSnippets.icons.moreInfo
        }, null, 8, _hoisted_5$6)
      ])
    ]),
    withDirectives(createBaseVNode("div", _hoisted_6$5, [
      createBaseVNode("p", null, toDisplayString($options.moreInfo.content), 1)
    ], 512), [
      [vShow, $data.isContentVisible]
    ])
  ], 2)) : createCommentVNode("", true);
}
const ProductMoreInfo = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e]]);
const _sfc_main$d = {
  name: "ProductMedia",
  components: {
    Carousel,
    Slide,
    ProductMoreInfo
  },
  data() {
    return {
      currentSlide: 0
    };
  },
  computed: {
    ...mapGetters({
      product: "getSelectionRelatedProduct",
      nestedProductsImagesSrc: "getNestedProductsImagesSrc",
      additionalShakerImagesSrc: "getAdditionalShakerImagesSrc"
    }),
    images() {
      var _a, _b;
      const productImages = (_a = this.product) == null ? void 0 : _a.images;
      const images = ((_b = this.additionalShakerImagesSrc) == null ? void 0 : _b.length) ? [...this.additionalShakerImagesSrc] : [];
      if (productImages == null ? void 0 : productImages.length) {
        images.push(...productImages);
      }
      images.push(...this.nestedProductsImagesSrc);
      const uniqueImagesSet = new Set(images.map((img) => img.src || img));
      const imagesArray = Array.from(uniqueImagesSet).map((src) => {
        return typeof src === "string" ? src : src.src;
      });
      return imagesArray;
    },
    isMoreInfoImageSelected() {
      var _a, _b;
      return (_b = (_a = this.product) == null ? void 0 : _a.moreInfo) == null ? void 0 : _b[this.currentSlide];
    }
  },
  methods: {
    goTo(index) {
      this.currentSlide = index;
    },
    ...mapMutations({
      setCurrentProductSlide: "SET_CURRENT_PRODUCT_IMAGE_SLIDE"
    })
  },
  watch: {
    currentSlide(newIndex) {
      this.setCurrentProductSlide(newIndex);
    },
    // Show first image on product change
    product() {
      this.currentSlide = 0;
    }
  }
};
const _hoisted_1$d = { class: "media-gallery" };
const _hoisted_2$a = ["onClick"];
const _hoisted_3$7 = ["src", "alt"];
const _hoisted_4$5 = { class: "media-gallery__slide_content" };
const _hoisted_5$5 = { class: "media-gallery__image-wrapper" };
const _hoisted_6$4 = ["src", "alt"];
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProductMoreInfo = resolveComponent("ProductMoreInfo");
  const _component_Slide = resolveComponent("Slide");
  const _component_Carousel = resolveComponent("Carousel");
  return openBlock(), createElementBlock("div", _hoisted_1$d, [
    createBaseVNode("div", {
      class: normalizeClass(["media-gallery__thumbnails", {
        "has-more-info-badge": !$options.isMoreInfoImageSelected
      }])
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($options.images, (img, index) => {
        var _a, _b;
        return openBlock(), createElementBlock("button", {
          key: index,
          onClick: ($event) => $options.goTo(index),
          class: normalizeClass([{
            active: $data.currentSlide === index,
            "has-more-info-badge--thumb": (_b = (_a = _ctx.product) == null ? void 0 : _a.moreInfo) == null ? void 0 : _b[index]
          }, "media-gallery__thumb"])
        }, [
          createBaseVNode("img", {
            src: img,
            alt: `Thumb ${index + 1}`
          }, null, 8, _hoisted_3$7)
        ], 10, _hoisted_2$a);
      }), 128))
    ], 2),
    createVNode(_component_Carousel, {
      ref: "carouselRef",
      modelValue: $data.currentSlide,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.currentSlide = $event),
      "wrap-around": true,
      "items-to-show": 1,
      transition: 0.3,
      class: "media-gallery__carousel"
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($options.images, (img, index) => {
          return openBlock(), createBlock(_component_Slide, { key: index }, {
            default: withCtx(() => {
              var _a, _b, _c, _d;
              return [
                createBaseVNode("div", _hoisted_4$5, [
                  createBaseVNode("div", _hoisted_5$5, [
                    createBaseVNode("img", {
                      class: normalizeClass(["media-gallery__image", {
                        "has-more-info-badge": (_b = (_a = _ctx.product) == null ? void 0 : _a.moreInfo) == null ? void 0 : _b[index]
                      }]),
                      src: img,
                      alt: `Image ${index + 1}`
                    }, null, 10, _hoisted_6$4),
                    ((_d = (_c = _ctx.product) == null ? void 0 : _c.moreInfo) == null ? void 0 : _d.length) ? (openBlock(), createBlock(_component_ProductMoreInfo, {
                      key: 0,
                      imageIndex: $data.currentSlide
                    }, null, 8, ["imageIndex"])) : createCommentVNode("", true)
                  ])
                ])
              ];
            }),
            _: 2
          }, 1024);
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]);
}
const ProductMedia = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d]]);
const _sfc_main$c = {
  name: "ProductMeta",
  computed: {
    ...mapGetters({
      product: "getSelectionRelatedProduct",
      initialData: "getInitialData"
    }),
    reviewsSku() {
      var _a, _b;
      return ((_b = (_a = this.initialData) == null ? void 0 : _a.config) == null ? void 0 : _b.reviewsSku) || "";
    }
  },
  mounted() {
    this.initReviews();
  },
  watch: {
    product() {
      this.$nextTick(this.renderReviewsSnippet);
    }
  },
  methods: {
    async initReviews() {
      await this.loadReviewsScript();
      this.renderReviewsSnippet();
    },
    loadReviewsScript() {
      return new Promise((resolve2, reject) => {
        if (document.getElementById("reviews-io-script")) return resolve2();
        const script = document.createElement("script");
        script.id = "reviews-io-script";
        script.src = "https://widget.reviews.io/rating-snippet/dist.js";
        script.async = true;
        script.onload = resolve2;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    },
    renderReviewsSnippet() {
      if (!this.$refs.reviewsSnippet || !this.reviewsSku) return;
      try {
        if (typeof window.ratingSnippet === "function") {
          window.ratingSnippet("ruk_rating_snippet", {
            store: "holy",
            mode: "default",
            color: "#0E1311",
            linebreak: false,
            usePolaris: true,
            showEmptyStars: false,
            singularText: "Review",
            text: "Reviews"
          });
        }
      } catch (e) {
        console.error("Reviews.io snippet init failed", e);
      }
    }
  }
};
const _hoisted_1$c = ["data-sku"];
const _hoisted_2$9 = { class: "product-meta__title heading heading-3" };
const _hoisted_3$6 = ["innerHTML"];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    $options.reviewsSku ? (openBlock(), createElementBlock("div", {
      key: 0,
      ref: "reviewsSnippet",
      class: "ruk_rating_snippet",
      "data-sku": $options.reviewsSku
    }, null, 8, _hoisted_1$c)) : createCommentVNode("", true),
    createBaseVNode("h1", _hoisted_2$9, toDisplayString(_ctx.product.title), 1),
    _ctx.product.bulletPointsHtml ? (openBlock(), createElementBlock("div", {
      key: 1,
      innerHTML: _ctx.product.bulletPointsHtml
    }, null, 8, _hoisted_3$6)) : createCommentVNode("", true)
  ]);
}
const ProductMeta = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c]]);
const _sfc_main$b = {
  name: "QuantitySelector",
  props: {
    productVariant: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      quantity: this.getInitialQuantityValue(),
      quantityInput: `${this.getInitialQuantityValue()}`
    };
  },
  computed: {
    ...mapGetters({
      initialData: "getInitialData"
    }),
    isSampleBox() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.initialData.config.variantAndProductIndex) == null ? void 0 : _a.variantsById) == null ? void 0 : _b[this.productVariant.id]) == null ? void 0 : _c.isSampleBox;
    }
  },
  methods: {
    ...mapMutations({
      setSampleBoxQuantity: "SET_SAMPLE_BOX_QUANTITY",
      setShakerQuantity: "SET_SHAKER_QUANTITY"
    }),
    increaseQuantity() {
      if (this.quantity < 5) {
        this.quantity++;
        this.quantityInput = String(this.quantity);
      }
    },
    decreaseQuantity() {
      if (this.quantity > 0) {
        this.quantity--;
        this.quantityInput = String(this.quantity);
      }
    },
    handleInput(event) {
      const raw = event.target.value;
      let numeric = raw.replace(/\D/g, "");
      let value = Number(numeric || 0);
      if (value > 5) value = 5;
      this.quantityInput = String(value);
      this.quantity = value;
    },
    sanitizeQuantity() {
      let value = Number(this.quantity || 0);
      if (value > 5) value = 5;
      this.quantityInput = String(value);
      this.quantity = value;
    },
    getInitialQuantityValue() {
      var _a;
      return ((_a = this.$store.state.selectedBoxesVariantsIds) == null ? void 0 : _a[this.productVariant.id]) || 0;
    }
  },
  watch: {
    quantity(newQuantity) {
      if (this.isSampleBox) {
        this.setSampleBoxQuantity({ variantId: this.productVariant.id, quantity: newQuantity });
      }
    }
  }
};
const _hoisted_1$b = ["innerHTML"];
const _hoisted_2$8 = ["innerHTML"];
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "quantity-selector",
    style: normalizeStyle({
      flexDirection: $data.quantity === 0 ? "row-reverse" : "row"
    })
  }, [
    withDirectives(createBaseVNode("button", {
      class: "qty-selector-btn",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.decreaseQuantity && $options.decreaseQuantity(...args)),
      innerHTML: _ctx.initialData.htmlSnippets.icons.minus
    }, null, 8, _hoisted_1$b), [
      [vShow, $data.quantity]
    ]),
    withDirectives(createBaseVNode("input", {
      class: "qty-selector-input",
      type: "text",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.quantityInput = $event),
      onInput: _cache[2] || (_cache[2] = (...args) => $options.handleInput && $options.handleInput(...args)),
      onBlur: _cache[3] || (_cache[3] = (...args) => $options.sanitizeQuantity && $options.sanitizeQuantity(...args)),
      inputmode: "numeric",
      pattern: "[0-9]*",
      maxlength: "1"
    }, null, 544), [
      [vShow, $data.quantity],
      [vModelText, $data.quantityInput]
    ]),
    createBaseVNode("button", {
      class: "qty-selector-btn qty-selector-btn__plus",
      onClick: _cache[4] || (_cache[4] = (...args) => $options.increaseQuantity && $options.increaseQuantity(...args)),
      innerHTML: _ctx.initialData.htmlSnippets.icons.plus
    }, null, 8, _hoisted_2$8)
  ], 4);
}
const QuantitySelector = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b]]);
const _sfc_main$a = {
  name: "SampleBox",
  props: {
    productVariant: {
      type: Object,
      required: true
    },
    hideQuantitySelector: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quantity: 0
    };
  },
  computed: {
    ...mapGetters({
      initalData: "getInitialData"
    }),
    product() {
      return this.initalData.config.variantAndProductIndex.productsById[this.productVariant.productId];
    },
    imageSrc() {
      var _a, _b, _c, _d;
      return ((_b = (_a = this.productVariant) == null ? void 0 : _a.featured_image) == null ? void 0 : _b.src) ? (_c = this.productVariant.featured_image) == null ? void 0 : _c.src : (_d = this.product.images) == null ? void 0 : _d[0];
    },
    title() {
      var _a, _b;
      return ((_a = this.product) == null ? void 0 : _a.customTitle) || ((_b = this.product) == null ? void 0 : _b.title);
    },
    subtitle() {
      var _a;
      return (_a = this.productVariant) == null ? void 0 : _a.sampleBoxSubtitle;
    }
  },
  components: {
    QuantitySelector
  }
};
const _hoisted_1$a = { class: "samplebox-line" };
const _hoisted_2$7 = ["src", "alt"];
const _hoisted_3$5 = { class: "samplebox-texts" };
const _hoisted_4$4 = { class: "samplebox-title" };
const _hoisted_5$4 = {
  key: 0,
  class: "samplebox-subtitle"
};
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QuantitySelector = resolveComponent("QuantitySelector");
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    createBaseVNode("img", {
      class: "samplebox-image",
      src: $options.imageSrc,
      alt: $options.title
    }, null, 8, _hoisted_2$7),
    createBaseVNode("div", _hoisted_3$5, [
      createBaseVNode("span", _hoisted_4$4, toDisplayString($options.title), 1),
      $options.subtitle ? (openBlock(), createElementBlock("p", _hoisted_5$4, toDisplayString($options.subtitle), 1)) : createCommentVNode("", true)
    ]),
    !$props.hideQuantitySelector ? (openBlock(), createBlock(_component_QuantitySelector, {
      key: 0,
      productVariant: $props.productVariant
    }, null, 8, ["productVariant"])) : createCommentVNode("", true)
  ]);
}
const SampleBox = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a]]);
const _sfc_main$9 = {
  name: "ModalWindow",
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("update:modelValue", false);
    }
  },
  computed: {
    ...mapGetters({
      initalData: "getInitialData"
    })
  },
  watch: {
    modelValue(newValue) {
      if (newValue) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "initial";
      }
    }
  }
};
const _hoisted_1$9 = { class: "modal-window" };
const _hoisted_2$6 = ["innerHTML"];
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.modelValue ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "modal-overlay",
    onClick: _cache[1] || (_cache[1] = withModifiers((...args) => $options.close && $options.close(...args), ["self"]))
  }, [
    createBaseVNode("div", _hoisted_1$9, [
      renderSlot(_ctx.$slots, "default"),
      createBaseVNode("button", {
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args)),
        innerHTML: _ctx.initalData.htmlSnippets.icons.close
      }, null, 8, _hoisted_2$6)
    ])
  ])) : createCommentVNode("", true);
}
const ModalWindow = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9]]);
const _sfc_main$8 = {
  name: "InfoIcon",
  props: {
    infoText: {
      type: String,
      default: ""
    },
    iconSvg: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showTooltip: false,
      isTouchDevice: false
    };
  },
  mounted() {
    this.isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    if (this.isTouchDevice) {
      document.addEventListener("click", this.handleOutsideClick);
    }
  },
  beforeUnmount() {
    if (this.isTouchDevice) {
      document.removeEventListener("click", this.handleOutsideClick);
    }
  },
  methods: {
    handleMouseEnter() {
      if (!this.isTouchDevice) {
        this.showTooltip = true;
      }
    },
    handleMouseLeave() {
      if (!this.isTouchDevice) {
        this.showTooltip = false;
      }
    },
    handleClick(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.isTouchDevice) {
        this.showTooltip = !this.showTooltip;
      }
    },
    handleTouchStart(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.isTouchDevice) {
        this.showTooltip = !this.showTooltip;
      }
    },
    handleOutsideClick(event) {
      if (this.showTooltip && this.isTouchDevice) {
        const wrapper = this.$el;
        const tooltip = wrapper == null ? void 0 : wrapper.querySelector(".info-tooltip");
        if (wrapper && !wrapper.contains(event.target) && tooltip && !tooltip.contains(event.target)) {
          this.showTooltip = false;
        }
      }
    }
  }
};
const _hoisted_1$8 = ["innerHTML"];
const _hoisted_2$5 = ["innerHTML"];
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.infoText ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "info-icon-wrapper",
    onClick: _cache[8] || (_cache[8] = withModifiers(() => {
    }, ["stop"]))
  }, [
    createBaseVNode("div", {
      class: "info-icon",
      onMouseenter: _cache[0] || (_cache[0] = (...args) => $options.handleMouseEnter && $options.handleMouseEnter(...args)),
      onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.handleMouseLeave && $options.handleMouseLeave(...args)),
      onClick: _cache[2] || (_cache[2] = (...args) => $options.handleClick && $options.handleClick(...args)),
      onTouchstart: _cache[3] || (_cache[3] = (...args) => $options.handleTouchStart && $options.handleTouchStart(...args)),
      innerHTML: $props.iconSvg
    }, null, 40, _hoisted_1$8),
    $data.showTooltip ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "info-tooltip",
      onMouseenter: _cache[4] || (_cache[4] = (...args) => $options.handleMouseEnter && $options.handleMouseEnter(...args)),
      onMouseleave: _cache[5] || (_cache[5] = (...args) => $options.handleMouseLeave && $options.handleMouseLeave(...args)),
      onClick: _cache[6] || (_cache[6] = withModifiers(() => {
      }, ["stop"])),
      onTouchstart: _cache[7] || (_cache[7] = withModifiers(() => {
      }, ["stop"]))
    }, [
      _cache[9] || (_cache[9] = createBaseVNode("div", { class: "info-tooltip__arrow" }, null, -1)),
      createBaseVNode("div", {
        class: "info-tooltip__content",
        innerHTML: $props.infoText
      }, null, 8, _hoisted_2$5)
    ], 32)) : createCommentVNode("", true)
  ])) : createCommentVNode("", true);
}
const InfoIcon = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__scopeId", "data-v-a51bf6ac"]]);
const _sfc_main$7 = {
  name: "ShakerCard",
  components: {
    InfoIcon
  },
  props: {
    productVariant: {
      type: Array,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    getProductsById(productId) {
      const productsById = this.initialData.config.variantAndProductIndex.productsById;
      return productsById[productId];
    },
    formatMoney(cents, format) {
      if (typeof cents == "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format;
      function defaultOption(opt, def2) {
        return typeof opt == "undefined" ? def2 : opt;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = number.toFixed(precision);
        var parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
        return dollars + cents2;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }
      let result = formatString.replace(placeholderRegex, value);
      if (result.includes(".00")) ;
      return formatString.replace(placeholderRegex, value);
    }
  },
  computed: {
    ...mapGetters({
      initialData: "getInitialData",
      discountForShakerProductById: "getDiscountForShakerProductById",
      getLvl2DiscountBadgeByShakerVariantId: "getLvl2DiscountBadgeByShakerVariantId"
    }),
    lvl2DiscountBadge() {
      return this.getLvl2DiscountBadgeByShakerVariantId(this.productVariant.id);
    },
    shakerDiscount() {
      var _a;
      return ((_a = this.discountForShakerProductById({
        productId: this.productVariant.productId,
        variantId: this.productVariant.id
      })) == null ? void 0 : _a.discountAmount) || 0;
    },
    shakerPrice() {
      const remainingShakerValue = (+this.initialData.config.remainingShakerValue || 0) * +window.Shopify.currency.rate;
      const discount = this.shakerDiscount * +window.Shopify.currency.rate + remainingShakerValue;
      const price = this.productVariant.price / 100;
      const finalPrice = Math.round((price - discount) * 100) / 100;
      const roundedFinalPrice = Math.abs(finalPrice) < 0.01 ? 0 : Math.floor(finalPrice);
      const plusSymbol = finalPrice < 0 ? "" : "+";
      const isUK = window.Shopify.country === "GB";
      if (isUK) {
        return `${plusSymbol}${this.initialData.currency}${roundedFinalPrice}`;
      } else {
        return `${plusSymbol}${roundedFinalPrice}${this.initialData.currency}`;
      }
    },
    product() {
      return this.getProductsById(this.productVariant.productId);
    },
    imageSrc() {
      var _a, _b, _c, _d, _e;
      return ((_b = (_a = this.productVariant) == null ? void 0 : _a.featured_image) == null ? void 0 : _b.src) ? (_c = this.productVariant.featured_image) == null ? void 0 : _c.src : (_e = (_d = this.product) == null ? void 0 : _d.images) == null ? void 0 : _e[0];
    },
    title() {
      var _a, _b, _c, _d;
      return ((_a = this.productVariant) == null ? void 0 : _a.title) && ((_b = this.productVariant) == null ? void 0 : _b.title) !== "Default Title" ? (_c = this.productVariant) == null ? void 0 : _c.title : (_d = this.product) == null ? void 0 : _d.title;
    },
    shakerInfoText() {
      const product = this.product;
      if (product && product.shakerTooltipText) {
        return product.shakerTooltipText;
      }
      return "";
    },
    infoIconSvg() {
      var _a, _b, _c;
      return ((_c = (_b = (_a = this.initialData) == null ? void 0 : _a.htmlSnippets) == null ? void 0 : _b.icons) == null ? void 0 : _c.info) || "";
    }
  }
};
const _hoisted_1$7 = ["selected"];
const _hoisted_2$4 = { class: "shaker-card__lvl2-badge_wrapper" };
const _hoisted_3$4 = {
  key: 0,
  class: "shaker-card__lvl2-badge"
};
const _hoisted_4$3 = { class: "shaker-card__info-icon-wrapper" };
const _hoisted_5$3 = { class: "shaker-image-wrapper" };
const _hoisted_6$3 = ["src", "alt"];
const _hoisted_7$2 = { class: "shaker-title" };
const _hoisted_8$2 = { class: "shaker-card__additional-info" };
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InfoIcon = resolveComponent("InfoIcon");
  return $options.imageSrc && $options.title && $props.productVariant.isHidden !== "true" ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["shaker-card", { "shaker-card--unavailable": !$props.productVariant.available }]),
    selected: $props.selected
  }, [
    createBaseVNode("div", _hoisted_2$4, [
      $options.lvl2DiscountBadge ? (openBlock(), createElementBlock("div", _hoisted_3$4, toDisplayString($options.lvl2DiscountBadge), 1)) : createCommentVNode("", true)
    ]),
    createBaseVNode("div", _hoisted_4$3, [
      createVNode(_component_InfoIcon, {
        infoText: $options.shakerInfoText,
        iconSvg: $options.infoIconSvg
      }, null, 8, ["infoText", "iconSvg"])
    ]),
    createBaseVNode("div", _hoisted_5$3, [
      createBaseVNode("img", {
        class: "shaker-image",
        src: $options.imageSrc,
        alt: $options.title
      }, null, 8, _hoisted_6$3)
    ]),
    createBaseVNode("span", _hoisted_7$2, toDisplayString($options.title), 1),
    createBaseVNode("span", _hoisted_8$2, toDisplayString($props.productVariant.available ? $options.shakerPrice : _ctx.initialData.translations.outOfStock), 1)
  ], 10, _hoisted_1$7)) : createCommentVNode("", true);
}
const ShakerCard = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7]]);
const _sfc_main$6 = {
  name: "Tabs",
  data() {
    return {
      tabs: [],
      activeIndex: 0
    };
  },
  provide() {
    return {
      registerTab: this.registerTab,
      getActiveIndex: () => this.activeIndex
    };
  },
  methods: {
    registerTab(tab) {
      this.tabs.push(tab);
    },
    selectTab(i) {
      this.activeIndex = i;
    }
  }
};
const _hoisted_1$6 = { class: "tabs-header" };
const _hoisted_2$3 = ["onClick"];
const _hoisted_3$3 = { class: "tabs-content" };
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createBaseVNode("div", _hoisted_1$6, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($data.tabs, (tab, i) => {
        return openBlock(), createElementBlock("button", {
          class: normalizeClass(["tabs-header__button", { active: $data.activeIndex === i }]),
          key: tab.title,
          onClick: ($event) => $options.selectTab(i),
          type: "button"
        }, toDisplayString(tab.title), 11, _hoisted_2$3);
      }), 128))
    ]),
    createBaseVNode("div", _hoisted_3$3, [
      renderSlot(_ctx.$slots, "default")
    ])
  ]);
}
const Tabs = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6]]);
const _sfc_main$5 = {
  name: "Tab",
  props: {
    title: { type: String, required: true }
  },
  inject: ["registerTab", "getActiveIndex"],
  data() {
    return {
      index: null
    };
  },
  computed: {
    isActive() {
      return this.getActiveIndex() === this.index;
    }
  },
  created() {
    this.index = this.$parent.tabs.length;
    this.registerTab({ title: this.title });
  }
};
const _hoisted_1$5 = { key: 0 };
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return $options.isActive ? (openBlock(), createElementBlock("div", _hoisted_1$5, [
    renderSlot(_ctx.$slots, "default")
  ])) : createCommentVNode("", true);
}
const Tab = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5]]);
const _sfc_main$4 = {
  name: "Shaker",
  data() {
    return {
      _selectedShaker: "",
      isModalOpen: false
    };
  },
  created() {
    var _a;
    let firstAvailableShaker = null;
    const collections = this.initalData.config.shakersCollections.filter((collection) => !collection.hidden);
    for (const collection of collections) {
      for (const product of collection.products || []) {
        for (const variant of product.variants || []) {
          if (variant.available) {
            firstAvailableShaker = variant;
            break;
          }
        }
        if (firstAvailableShaker) break;
      }
      if (firstAvailableShaker) break;
    }
    const preselectedShakerVairantId = (_a = Object.keys(this.selectedShakersVariantsIds)) == null ? void 0 : _a[0];
    const preselectedShakerVairant = this.getVariantById(preselectedShakerVairantId);
    const initialShaker = preselectedShakerVairant && preselectedShakerVairant.available ? preselectedShakerVairant : firstAvailableShaker;
    if (initialShaker) {
      this.selectShaker(initialShaker);
    }
  },
  methods: {
    ...mapMutations({
      setShakerQuantity: "SET_SHAKER_QUANTITY"
    }),
    selectShaker(shakerVariant) {
      this._selectedShaker = shakerVariant;
      this.setShakerQuantity({
        variantId: this._selectedShaker.id,
        quantity: 1
      });
      this.isModalOpen = false;
    },
    openModalWindow() {
      this.isModalOpen = true;
    },
    backToOverview() {
      this.isModalOpen = false;
    },
    getCollectionVariants(collection) {
      const result = [];
      collection.products.forEach((product) => {
        result.push(...product.variants);
      });
      return result;
    },
    getVariantById(variantId) {
      const variantsById = this.initalData.config.variantAndProductIndex.variantsById;
      return variantsById[variantId];
    },
    findProductById(productId) {
      return this.getProductById(productId);
    }
  },
  computed: {
    ...mapGetters({
      initalData: "getInitialData",
      prices: "getPrices",
      selectedShakersVariantsIds: "getSelectedShakersVariantsIds",
      getProductById: "getProductById"
    }),
    shakersCollections() {
      const notHidden = this.initalData.config.shakersCollections.filter((collection) => !collection.hidden);
      return notHidden;
    },
    product() {
      return this.initalData.config.variantAndProductIndex.productsById[this._selectedShaker.productId];
    },
    imageSrc() {
      var _a, _b, _c, _d, _e;
      return ((_b = (_a = this._selectedShaker) == null ? void 0 : _a.featured_image) == null ? void 0 : _b.src) ? (_c = this._selectedShaker.featured_image) == null ? void 0 : _c.src : (_e = (_d = this.product) == null ? void 0 : _d.images) == null ? void 0 : _e[0];
    },
    title() {
      var _a, _b, _c, _d;
      return ((_a = this.productVariant) == null ? void 0 : _a.title) && ((_b = this.productVariant) == null ? void 0 : _b.title) !== "Default Title" ? (_c = this.productVariant) == null ? void 0 : _c.title : (_d = this.product) == null ? void 0 : _d.title;
    },
    shakersVariants() {
      const shakerProducts = this.initalData.config.shakersProducts;
      const variantsOfShakers = shakerProducts.map((product) => product.variants);
      return variantsOfShakers == null ? void 0 : variantsOfShakers.flat();
    }
  },
  components: {
    QuantitySelector,
    ModalWindow,
    ShakerCard,
    Tabs,
    Tab
  }
};
const _hoisted_1$4 = { class: "shaker-selection" };
const _hoisted_2$2 = { class: "shaker-selection__clickable_header" };
const _hoisted_3$2 = { class: "shaker-selection__clickable_header__inner" };
const _hoisted_4$2 = ["src", "alt"];
const _hoisted_5$2 = { class: "selected-shaker-title" };
const _hoisted_6$2 = ["innerHTML"];
const _hoisted_7$1 = { class: "shaker-selection__clickable_footer" };
const _hoisted_8$1 = {
  key: 0,
  class: "shaker-selection__devider"
};
const _hoisted_9$1 = {
  key: 1,
  class: "shaker-selection__bottom-image-wrapper"
};
const _hoisted_10$1 = ["src"];
const _hoisted_11$1 = { class: "shaker-selection__more-shakers" };
const _hoisted_12$1 = { class: "shakers-modal-content" };
const _hoisted_13$1 = { class: "h3" };
const _hoisted_14$1 = { class: "shakers-container" };
const _hoisted_15$1 = { class: "shaker-selection__price-card_wrapper" };
const _hoisted_16$1 = { class: "shaker-selection__price-card" };
const _hoisted_17$1 = { class: "shaker-selection__price-card_text" };
const _hoisted_18$1 = { class: "shaker-selection__price-card_price" };
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ShakerCard = resolveComponent("ShakerCard");
  const _component_Tab = resolveComponent("Tab");
  const _component_Tabs = resolveComponent("Tabs");
  const _component_ModalWindow = resolveComponent("ModalWindow");
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    createBaseVNode("div", {
      class: "shaker-selection__clickable",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.openModalWindow && $options.openModalWindow(...args))
    }, [
      createBaseVNode("div", _hoisted_2$2, [
        createBaseVNode("div", _hoisted_3$2, [
          createBaseVNode("img", {
            class: "selected-shaker-image",
            src: $options.imageSrc,
            alt: $options.title
          }, null, 8, _hoisted_4$2)
        ]),
        createBaseVNode("span", _hoisted_5$2, toDisplayString($options.title), 1),
        createBaseVNode("div", {
          class: "shaker-selection__refresh-icon",
          innerHTML: _ctx.initalData.htmlSnippets.icons.refresh
        }, null, 8, _hoisted_6$2)
      ]),
      createBaseVNode("div", _hoisted_7$1, [
        _ctx.initalData.images.shakerBottom ? (openBlock(), createElementBlock("div", _hoisted_8$1)) : createCommentVNode("", true),
        _ctx.initalData.images.shakerBottom ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
          _ctx.initalData.images.shakerBottom ? (openBlock(), createElementBlock("img", {
            key: 0,
            class: "shaker-selection__bottom-image",
            src: _ctx.initalData.images.shakerBottom
          }, null, 8, _hoisted_10$1)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createBaseVNode("div", _hoisted_11$1, toDisplayString(_ctx.initalData.translations.moreShakers), 1)
      ])
    ]),
    createVNode(_component_ModalWindow, {
      modelValue: $data.isModalOpen,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.isModalOpen = $event)
    }, {
      default: withCtx(() => [
        createBaseVNode("div", _hoisted_12$1, [
          createBaseVNode("h3", _hoisted_13$1, toDisplayString(_ctx.initalData.translations.chooseYourShaker), 1),
          createVNode(_component_Tabs, null, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList($options.shakersCollections, (collection, idx) => {
                return openBlock(), createBlock(_component_Tab, {
                  title: collection.title,
                  key: idx
                }, {
                  default: withCtx(() => [
                    createBaseVNode("div", _hoisted_14$1, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList($options.getCollectionVariants(collection), (shakerVariant, idx2) => {
                        return openBlock(), createBlock(_component_ShakerCard, {
                          key: idx2,
                          onClick: ($event) => shakerVariant.available ? $options.selectShaker(shakerVariant) : null,
                          productVariant: shakerVariant,
                          selected: $data._selectedShaker.id == shakerVariant.id
                        }, null, 8, ["onClick", "productVariant", "selected"]);
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1032, ["title"]);
              }), 128))
            ]),
            _: 1
          }),
          createBaseVNode("div", _hoisted_15$1, [
            createBaseVNode("div", _hoisted_16$1, [
              createBaseVNode("span", _hoisted_17$1, toDisplayString(_ctx.initalData.translations.currentTotal), 1),
              createBaseVNode("span", _hoisted_18$1, toDisplayString(_ctx.prices.formatted.discountTotal), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]);
}
const ShakerSelection = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4]]);
const _sfc_main$3 = {
  name: "Gift",
  props: {
    productVariant: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      initalData: "getInitialData",
      selectedGiftVariantId: "getSelectedGiftVariantId",
      giftsLocked: "areGiftsLocked"
    }),
    product() {
      return this.initalData.config.variantAndProductIndex.productsById[this.productVariant.productId];
    },
    isLocked() {
      return this.giftsLocked;
    },
    lockIconSrc() {
      var _a;
      return ((_a = this.initalData.images) == null ? void 0 : _a.giftLockIcon) || "";
    },
    imageSrc() {
      var _a, _b, _c, _d, _e;
      if ((_b = (_a = this.productVariant) == null ? void 0 : _a.featured_image) == null ? void 0 : _b.src) {
        return this.productVariant.featured_image.src;
      }
      if (((_c = this.productVariant) == null ? void 0 : _c.featured_image) && typeof this.productVariant.featured_image === "string") {
        return this.productVariant.featured_image;
      }
      return (_e = (_d = this.product) == null ? void 0 : _d.images) == null ? void 0 : _e[0];
    },
    displayImageSrc() {
      return this.isLocked ? this.lockIconSrc : this.imageSrc;
    },
    lockedMessage() {
      var _a, _b;
      return ((_b = (_a = this.initalData) == null ? void 0 : _a.translations) == null ? void 0 : _b.giftsLockedMessage) || "";
    },
    title() {
      var _a, _b;
      const variantTitle = (_a = this.productVariant) == null ? void 0 : _a.title;
      return variantTitle && variantTitle !== "Default Title" ? variantTitle : (_b = this.product) == null ? void 0 : _b.title;
    },
    subtitle() {
      var _a, _b;
      const variantTitle = (_a = this.productVariant) == null ? void 0 : _a.title;
      const hasRealVariant = variantTitle && variantTitle !== "Default Title";
      return hasRealVariant ? (_b = this.product) == null ? void 0 : _b.title : null;
    },
    isAvailable() {
      return this.productVariant.available === true;
    },
    isSelected() {
      return this.selectedGiftVariantId === this.productVariant.id;
    }
  },
  methods: {
    selectGift() {
      if (!this.isAvailable || this.isLocked) return;
      this.$store.commit("SET_SELECTED_GIFT_VARIANT_ID", this.productVariant.id);
    }
  }
};
const _hoisted_1$3 = ["tabindex", "aria-disabled", "aria-pressed"];
const _hoisted_2$1 = ["src", "alt"];
const _hoisted_3$1 = { class: "samplebox-texts" };
const _hoisted_4$1 = { class: "samplebox-title" };
const _hoisted_5$1 = {
  key: 0,
  class: "samplebox-subtitle"
};
const _hoisted_6$1 = {
  key: 0,
  class: "gift-locked-message"
};
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["samplebox-line gift-line", {
      "gift-line--selected": $options.isSelected && $options.isAvailable && !$options.isLocked,
      "gift-line--disabled": !$options.isAvailable,
      "gift-line--locked": $options.isLocked
    }]),
    role: "button",
    tabindex: $options.isAvailable && !$options.isLocked ? 0 : -1,
    "aria-disabled": !$options.isAvailable || $options.isLocked,
    "aria-pressed": $options.isSelected && $options.isAvailable && !$options.isLocked,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.selectGift && $options.selectGift(...args)),
    onKeydown: [
      _cache[1] || (_cache[1] = withKeys(withModifiers((...args) => $options.selectGift && $options.selectGift(...args), ["prevent"]), ["enter"])),
      _cache[2] || (_cache[2] = withKeys(withModifiers((...args) => $options.selectGift && $options.selectGift(...args), ["prevent"]), ["space"]))
    ]
  }, [
    createBaseVNode("img", {
      class: normalizeClass(["samplebox-image", { "samplebox-image--lock": $options.isLocked }]),
      src: $options.displayImageSrc,
      alt: $options.isLocked ? "Locked" : $options.title
    }, null, 10, _hoisted_2$1),
    createBaseVNode("div", _hoisted_3$1, [
      createBaseVNode("span", _hoisted_4$1, toDisplayString($options.title), 1),
      $options.subtitle ? (openBlock(), createElementBlock("p", _hoisted_5$1, toDisplayString($options.subtitle), 1)) : createCommentVNode("", true)
    ]),
    $options.isLocked && $options.lockedMessage ? (openBlock(), createElementBlock("div", _hoisted_6$1, toDisplayString($options.lockedMessage), 1)) : createCommentVNode("", true)
  ], 42, _hoisted_1$3);
}
const Gift = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
const _sfc_main$2 = {
  name: "ProductUsp",
  computed: {
    ...mapGetters({
      initalData: "getInitialData"
    })
  },
  mounted() {
    this.initPaypalBadge();
  },
  methods: {
    initPaypalBadge() {
      const waitFor = (testFn, successFn, repeat = false, timeout = 1e4, interval = 25) => {
        if (timeout < 0) return;
        if (testFn()) {
          successFn();
        } else {
          setTimeout(() => {
            repeat ? waitFor(testFn, successFn, repeat, timeout, interval) : waitFor(testFn, successFn, repeat, timeout - interval, interval);
          }, interval);
        }
      };
      const q = (sel, scope = document) => scope.querySelector(sel);
      const insert = (target, position, element, exists) => {
        if (!target || exists) return;
        typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
      };
      const EXPID = "HLY-7";
      const VAR = "1";
      const testInfo = () => {
        window.runningExperiments = window.runningExperiments || {};
        window.runningExperiments[EXPID] = {
          name: "Add paypal badge to USP section on PDP",
          variation: `${VAR}`,
          logs: []
        };
        waitFor(
          () => q("body"),
          () => {
            q("body").classList.add(`${EXPID}`);
          }
        );
      };
      const insertPaypalSection = () => {
        const paypalSVG = `
          <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
            <path d="M15.1658 9.84595C14.9826 9.8461 14.8055 9.91158 14.6662 10.0306C14.5269 10.1497 14.4347 10.3145 14.406 10.4955L13.1436 18.5026C13.2024 18.1287 13.5246 17.8531 13.9034 17.8531H17.6028C21.3261 17.8531 24.4854 15.137 25.0627 11.4562C25.1057 11.1814 25.13 10.9041 25.1356 10.626C24.1894 10.1298 23.0779 9.84595 21.86 9.84595H15.1658Z" fill="#001C64"/>
            <path d="M25.1358 10.6265C25.1302 10.9045 25.1059 11.1819 25.0629 11.4567C24.4856 15.1375 21.326 17.8536 17.603 17.8536H13.9035C13.5251 17.8536 13.2026 18.1289 13.1437 18.5031L11.9829 25.861L11.2558 30.477C11.2416 30.5662 11.2469 30.6574 11.2714 30.7443C11.2959 30.8312 11.3389 30.9118 11.3976 30.9805C11.4562 31.0491 11.5291 31.1043 11.6111 31.1421C11.6931 31.1798 11.7823 31.1994 11.8726 31.1994H15.8881C16.0713 31.1992 16.2485 31.1337 16.3877 31.0147C16.527 30.8956 16.6193 30.7308 16.6479 30.5498L17.7056 23.8414C17.7342 23.6604 17.8266 23.4955 17.966 23.3764C18.1054 23.2573 18.2827 23.1919 18.466 23.1919H20.8301C24.5534 23.1919 27.7127 20.4758 28.29 16.795C28.7 14.1827 27.3843 11.8054 25.1358 10.6265Z" fill="#0070E0"/>
            <path d="M10.6041 4.50854C10.2257 4.50854 9.90319 4.78381 9.84433 5.15748L6.6933 25.1385C6.63355 25.5178 6.92666 25.8609 7.31073 25.8609H11.9835L13.1437 18.5029L14.4062 10.4958C14.4348 10.3148 14.5271 10.15 14.6663 10.0309C14.8056 9.91189 14.9828 9.8464 15.166 9.84625H21.8601C23.0783 9.84625 24.1895 10.1304 25.1357 10.6263C25.2005 7.2752 22.4353 4.50854 18.6336 4.50854H10.6041Z" fill="#003087"/>
          </svg>
        `;
        const paypalSection = `
          <div class="${EXPID}__paypal-container text_content text_content--usp text_content--full">
            <div class="${EXPID}__paypal-visible-section" style="display: flex;">
              <div class="${EXPID}__svg">${paypalSVG}</div>
              <div class="${EXPID}__paypal-text">Bezahle nach <br> 30 Tagen</div>
            </div>
            <div id="${EXPID}__paypal-section">
              <div style="text-align:center" 
                data-pp-message
                data-pp-buyerCountry="DE"
                data-pp-amount="10.99"
                data-pp-placement="cart"
                data-pp-style-layout="text"
                data-pp-style-logo-type="alternative"
                data-pp-style-text-color="black"
                data-pp-style-text-size="10"
                data-pp-style-text-align="right">
              </div>
            </div>
          </div>`;
        const script = document.createElement("script");
        script.setAttribute(
          "src",
          "https://www.paypal.com/sdk/js?client-id=AQMcCMPtGI5E_PtXfx-geaeFabK2E9Bd87VHtWjV4ryNgh8ZGvQ2B5_4DD0PZYsJAlQgrE-RBmE_tp2v&locale=de_DE&components=messages&enable-funding=paylater"
        );
        script.setAttribute("data-namespace", "paypal_sdk");
        waitFor(
          () => q("head") && q(".product-form .delivery_text"),
          () => {
            insert(q("head"), "beforeend", script, q('script[src*="paypal.com/sdk/js"]'));
            insert(q(".product-form .delivery_text"), "afterbegin", paypalSection, q(`.${EXPID}__paypal-container`));
          }
        );
      };
      waitFor(
        () => document.querySelector("[data-pay-pal-badge]"),
        () => {
          const el = document.querySelector("[data-pay-pal-badge]");
          if (el && el.getAttribute("data-pay-pal-badge") === "true") {
            testInfo();
            insertPaypalSection();
          }
        },
        true
      );
    }
  }
};
const _hoisted_1$2 = ["innerHTML"];
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    innerHTML: _ctx.initalData.htmlSnippets.usp
  }, null, 8, _hoisted_1$2);
}
const ProducUsp = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
const _sfc_main$1 = {
  name: "ProducAccordion",
  computed: {
    ...mapGetters({
      product: "getSelectionRelatedProduct"
    })
  }
};
const _hoisted_1$1 = ["innerHTML"];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  return ((_a = _ctx.product) == null ? void 0 : _a.accordionHtml) ? (openBlock(), createElementBlock("div", {
    key: 0,
    innerHTML: (_b = _ctx.product) == null ? void 0 : _b.accordionHtml
  }, null, 8, _hoisted_1$1)) : createCommentVNode("", true);
}
const ProductAccordion = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
const _sfc_main = {
  name: "BundleBuilder",
  methods: {
    /**
     * 1. Gets line items from the cart
     * 2. Updates their properties with the '_bundle_index' property but starts from 1
     * 3. Line item with the _bundle_type: "starter_powder" is that what we are looking for
     */
    async setBundleIndexesForLineItems() {
      try {
        const cartResponse = await fetch("/cart.js");
        const cart = await cartResponse.json();
        const starterPowders = cart.items.filter(
          (item) => item.properties && item.properties._bundle_type === "starter_powder"
        );
        for (let i = 0; i < starterPowders.length; i++) {
          const item = starterPowders[i];
          const newProperties = {
            ...item.properties,
            _bundle_index: i + 1
          };
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: item.key,
              properties: newProperties,
              quantity: item.quantity
            })
          });
        }
        console.log(`✅ Updated ${starterPowders.length} starter_powder items with bundle indexes`);
      } catch (error2) {
        console.error("❌ Error updating bundle indexes:", error2);
      }
    },
    async addToCart() {
      if (this.atcDisabled) return;
      const orderTimestamp = (/* @__PURE__ */ new Date()).getTime();
      if (!this.prices.unformatted.total) {
        return;
      }
      const items = JSON.parse(JSON.stringify(this.atcPayload));
      items.forEach((item) => {
        item.properties = item.properties || {};
        item.properties._bundleBuilderTimestamp = orderTimestamp;
      });
      const formData = {
        "items": items
      };
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
      const responseJson = await response.json();
      if (response.ok) {
        try {
          this.setCookie("bundle_added", "true", 1);
          console.log("✅ Bundle added - cookie bundle_added set to true");
        } catch (error2) {
          console.error("❌ Error setting bundle_added cookie:", error2);
        }
        document.documentElement.dispatchEvent(new CustomEvent("variant:added", {
          bubbles: true,
          detail: {
            variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
          }
        }));
        await fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
          cartContent["sections"] = responseJson["sections"];
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: true
            }
          }));
        });
      }
      document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: response.ok ? "success" : "error",
          error: responseJson["description"] || ""
        }
      }));
      await this.setBundleIndexesForLineItems();
    },
    async instantCheckout() {
      if (this.atcDisabled) return;
      await this.addToCart();
      await this.setBundleIndexesForLineItems();
      window.location.href = "/checkout";
    },
    setCookie(key, value, daysToExpire = 1) {
      const expirationDate = /* @__PURE__ */ new Date();
      expirationDate.setTime(expirationDate.getTime() + daysToExpire * 24 * 60 * 60 * 1e3);
      const expires = "expires=" + expirationDate.toUTCString();
      document.cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
    },
    getCookie(key) {
      const name = key + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(";");
      for (let i = 0; i < cookieArray.length; i++) {
        const cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
      return "";
    }
  },
  computed: {
    ...mapGetters({
      initialData: "getInitialData",
      prices: "getPrices",
      atcPayload: "getAddToCartPayload",
      selectedSampleBoxesQuantity: "getSelectedBoxesCount",
      nextSbPrice: "getNextSbPrice",
      areGiftsLocked: "areGiftsLocked"
    }),
    sampleBoxesProducts() {
      return this.initialData.config.sampleBoxesProducts;
    },
    sampleBoxesVariants() {
      var _a;
      return (_a = this.sampleBoxesProducts.map((product) => {
        const variants = product.variants;
        const sampleBoxSubtitle = product == null ? void 0 : product.sampleBoxSubtitle;
        variants[0].sampleBoxSubtitle = sampleBoxSubtitle;
        return variants;
      })) == null ? void 0 : _a.flat();
    },
    hasGifts() {
      return this.initialData.config.gifts && this.initialData.config.gifts.length > 0;
    },
    giftsVariants() {
      if (!this.hasGifts) return [];
      return this.initialData.config.gifts;
    },
    giftsLabel() {
      return this.initialData.config.giftsLabel || this.initialData.translations.boxesHeading;
    },
    shakerHeading() {
      return this.initialData.translations.shakersHeading;
    },
    atcDisabled() {
      if (this.hasGifts) {
        if (this.$store.getters.areGiftsLocked) {
          return !this.selectedSampleBoxesQuantity;
        }
        return !this.$store.getters.getSelectedGiftVariantId;
      }
      return !this.selectedSampleBoxesQuantity;
    },
    pricePerDrinkMessage() {
      const price = this.prices.formatted.perPortionDiscounted || this.prices.formatted.perPortion;
      const message = this.initialData.translations.perDrink.replace("{{ price }}", price);
      return message;
    },
    selectedSampleBoxesDeliveryNotice() {
      const selectedVariantIds = Object.keys(this.$store.state.selectedBoxesVariantsIds || {}).filter((variantId) => this.$store.state.selectedBoxesVariantsIds[variantId] > 0);
      const resolveDeliveryNotice = (variantId) => {
        var _a, _b, _c, _d;
        const variant = this.$store.getters.getVariantById(variantId);
        if (!variant) return null;
        const variantNotice = variant.deliveryNotice || ((_b = (_a = variant == null ? void 0 : variant.metafields) == null ? void 0 : _a.delivery) == null ? void 0 : _b.notice) || null;
        if (variantNotice && String(variantNotice).trim()) return String(variantNotice).trim();
        const product = this.$store.getters.getProductById(variant.productId);
        const productNotice = (product == null ? void 0 : product.deliveryNotice) || ((_d = (_c = product == null ? void 0 : product.metafields) == null ? void 0 : _c.delivery) == null ? void 0 : _d.notice) || null;
        return productNotice && String(productNotice).trim() ? String(productNotice).trim() : null;
      };
      if (selectedVariantIds.length === 0) return null;
      const notices = selectedVariantIds.map(resolveDeliveryNotice).filter(Boolean);
      if (notices.length === 0) return null;
      return notices.reduce(
        (longest, current) => current.length > longest.length ? current : longest
      );
    },
    selectedSampleBoxesDeliveryMessage() {
      var _a, _b;
      const notice = this.selectedSampleBoxesDeliveryNotice;
      if (notice) {
        return notice;
      }
      const fallbackMessage = (_b = (_a = this.initialData) == null ? void 0 : _a.htmlSnippets) == null ? void 0 : _b.getItTomorrow;
      if (typeof fallbackMessage === "string" && fallbackMessage.trim()) {
        return fallbackMessage;
      }
      return null;
    },
    nextBoxPriceMessage() {
      var _a, _b, _c;
      const template2 = (_b = (_a = this.initialData) == null ? void 0 : _a.translations) == null ? void 0 : _b.nextBoxPriceTemplate;
      if (!template2 || typeof template2 !== "string") return null;
      const trimmed = template2.trim();
      if (!trimmed) return null;
      const price = (_c = this.nextSbPrice) == null ? void 0 : _c.formatted;
      if (!price) return null;
      return trimmed.split("{price}").join(String(price));
    }
  },
  watch: {
    areGiftsLocked(newLocked, oldLocked) {
      if (!this.hasGifts) return;
      if (newLocked === false && oldLocked === true && !this.$store.getters.getSelectedGiftVariantId) {
        const firstAvailable = this.giftsVariants.find((g) => g.available === true);
        if (firstAvailable) {
          this.$store.commit("SET_SELECTED_GIFT_VARIANT_ID", firstAvailable.id);
        }
      }
    },
    selectedSampleBoxesQuantity() {
      if (!this.hasGifts) return;
      if (this.$store.getters.areGiftsLocked) {
        if (this.$store.getters.getSelectedGiftVariantId) {
          this.$store.commit("SET_SELECTED_GIFT_VARIANT_ID", null);
        }
      } else if (!this.$store.getters.getSelectedGiftVariantId) {
        const firstAvailable = this.giftsVariants.find((g) => g.available === true);
        if (firstAvailable) {
          this.$store.commit("SET_SELECTED_GIFT_VARIANT_ID", firstAvailable.id);
        }
      }
    }
  },
  components: {
    ProductMedia,
    ProductMeta,
    SampleBox,
    ShakerSelection,
    Gift,
    ProducUsp,
    ProductAccordion
  }
};
const _hoisted_1 = { class: "conatiner-inner" };
const _hoisted_2 = { class: "left-column" };
const _hoisted_3 = { class: "right-column" };
const _hoisted_4 = { class: "boxes-and-shakers-column" };
const _hoisted_5 = { class: "sample-boxes-wrapper" };
const _hoisted_6 = { class: "product-category-heading" };
const _hoisted_7 = { class: "sample-boxes-container" };
const _hoisted_8 = { class: "shaker-wrapper" };
const _hoisted_9 = { class: "product-category-heading" };
const _hoisted_10 = { class: "shaker-container" };
const _hoisted_11 = {
  key: 0,
  class: "gifts-wrapper"
};
const _hoisted_12 = { class: "product-category-heading" };
const _hoisted_13 = { class: "gifts-container" };
const _hoisted_14 = { class: "price-card" };
const _hoisted_15 = {
  key: 0,
  class: "price-card__next-sb-price show-on-desktop"
};
const _hoisted_16 = { class: "price-wrapper" };
const _hoisted_17 = { class: "price-wrapper__left-column" };
const _hoisted_18 = {
  key: 0,
  class: "price-card__next-sb-price show-on-mobile"
};
const _hoisted_19 = { class: "price-card__subheading show-on-desktop" };
const _hoisted_20 = { class: "price-wrapper__right-column" };
const _hoisted_21 = { class: "price-card__heading" };
const _hoisted_22 = { class: "price-card__buttons" };
const _hoisted_23 = ["disabled"];
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = { class: "price-card__atc_inner-" };
const _hoisted_26 = ["innerHTML", "disabled"];
const _hoisted_27 = ["innerHTML"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  const _component_ProductMedia = resolveComponent("ProductMedia");
  const _component_ProductMeta = resolveComponent("ProductMeta");
  const _component_SampleBox = resolveComponent("SampleBox");
  const _component_ShakerSelection = resolveComponent("ShakerSelection");
  const _component_Gift = resolveComponent("Gift");
  const _component_ProducUsp = resolveComponent("ProducUsp");
  const _component_ProductAccordion = resolveComponent("ProductAccordion");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createBaseVNode("div", _hoisted_2, [
      createVNode(_component_ProductMedia)
    ]),
    createBaseVNode("div", _hoisted_3, [
      createVNode(_component_ProductMeta),
      createBaseVNode("div", _hoisted_4, [
        createBaseVNode("div", _hoisted_5, [
          createBaseVNode("h2", _hoisted_6, toDisplayString(_ctx.initialData.translations.boxesHeading), 1),
          createBaseVNode("div", _hoisted_7, [
            (openBlock(true), createElementBlock(Fragment, null, renderList($options.sampleBoxesVariants, (variant, idx) => {
              return openBlock(), createBlock(_component_SampleBox, {
                key: idx,
                productVariant: variant
              }, null, 8, ["productVariant"]);
            }), 128))
          ])
        ]),
        createBaseVNode("div", _hoisted_8, [
          createBaseVNode("h2", _hoisted_9, toDisplayString($options.shakerHeading), 1),
          createBaseVNode("div", _hoisted_10, [
            createVNode(_component_ShakerSelection)
          ])
        ])
      ]),
      $options.hasGifts ? (openBlock(), createElementBlock("div", _hoisted_11, [
        createBaseVNode("h2", _hoisted_12, toDisplayString($options.giftsLabel), 1),
        createBaseVNode("div", _hoisted_13, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($options.giftsVariants, (giftVariant, idx) => {
            return openBlock(), createBlock(_component_Gift, {
              key: idx,
              productVariant: giftVariant
            }, null, 8, ["productVariant"]);
          }), 128))
        ])
      ])) : createCommentVNode("", true),
      createVNode(_component_ProducUsp),
      createVNode(_component_ProductAccordion),
      createBaseVNode("div", _hoisted_14, [
        $options.nextBoxPriceMessage ? (openBlock(), createElementBlock("p", _hoisted_15, toDisplayString($options.nextBoxPriceMessage), 1)) : createCommentVNode("", true),
        createBaseVNode("div", _hoisted_16, [
          createBaseVNode("div", _hoisted_17, [
            $options.nextBoxPriceMessage ? (openBlock(), createElementBlock("p", _hoisted_18, toDisplayString($options.nextBoxPriceMessage), 1)) : createCommentVNode("", true),
            withDirectives(createBaseVNode("span", { class: "price-card__heading show-on-desktop" }, toDisplayString(_ctx.initialData.translations.youSave) + " " + toDisplayString(_ctx.prices.formatted.discountAmount), 513), [
              [vShow, _ctx.prices.unformatted.discountAmount > 0]
            ]),
            createBaseVNode("span", _hoisted_19, toDisplayString($options.pricePerDrinkMessage), 1)
          ]),
          createBaseVNode("div", _hoisted_20, [
            createBaseVNode("span", _hoisted_21, toDisplayString(_ctx.prices.formatted.discountTotal), 1),
            withDirectives(createBaseVNode("span", { class: "price-card__crossed price-card__subheading" }, toDisplayString(_ctx.prices.formatted.total), 513), [
              [vShow, _ctx.prices.unformatted.total > _ctx.prices.unformatted.discountTotal]
            ])
          ])
        ]),
        createBaseVNode("div", _hoisted_22, [
          createBaseVNode("button", {
            disabled: $options.atcDisabled,
            class: "price-card__atc",
            onClick: _cache[0] || (_cache[0] = (...args) => $options.addToCart && $options.addToCart(...args))
          }, [
            createBaseVNode("div", {
              class: "bb-box__checkout-button_svg-wrapper",
              innerHTML: _ctx.initialData.htmlSnippets.icons.cart
            }, null, 8, _hoisted_24),
            createBaseVNode("span", _hoisted_25, toDisplayString(_ctx.initialData.translations.atc), 1)
          ], 8, _hoisted_23),
          ((_b = (_a = _ctx.initialData) == null ? void 0 : _a.config) == null ? void 0 : _b.showPayWithPaypal) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "price-card__paypal",
            innerHTML: _ctx.initialData.htmlSnippets.paypal,
            disabled: $options.atcDisabled,
            onClick: _cache[1] || (_cache[1] = (...args) => $options.instantCheckout && $options.instantCheckout(...args))
          }, null, 8, _hoisted_26)) : createCommentVNode("", true),
          $options.selectedSampleBoxesDeliveryMessage ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "price-card__delivery",
            innerHTML: $options.selectedSampleBoxesDeliveryMessage
          }, null, 8, _hoisted_27)) : createCommentVNode("", true)
        ])
      ])
    ])
  ]);
}
const App = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
function sortBySpecificShakersFirst(arr) {
  return arr.sort((a, b3) => {
    var _a, _b, _c, _d, _e, _f;
    const aHasShakers = Array.isArray((_a = a.metafields) == null ? void 0 : _a.specificShakers) && a.metafields.specificShakers.length > 0;
    const bHasShakers = Array.isArray((_b = b3.metafields) == null ? void 0 : _b.specificShakers) && b3.metafields.specificShakers.length > 0;
    const aBoxesCount = Array.isArray((_d = (_c = a.metafields) == null ? void 0 : _c.children) == null ? void 0 : _d.boxesVariantsIds) ? a.metafields.children.boxesVariantsIds.length : 0;
    const bBoxesCount = Array.isArray((_f = (_e = b3.metafields) == null ? void 0 : _e.children) == null ? void 0 : _f.boxesVariantsIds) ? b3.metafields.children.boxesVariantsIds.length : 0;
    if (aHasShakers && !bHasShakers) return -1;
    if (!aHasShakers && bHasShakers) return 1;
    return bBoxesCount - aBoxesCount;
  });
}
function getPreselectedVariantsIds(data) {
  var _a, _b, _c, _d, _e;
  const urlParams = new URLSearchParams(window.location.search);
  const preselectParam = urlParams.get("preselect");
  const variantIds = preselectParam ? preselectParam.split(",").map((id) => id.trim()) : [];
  if (variantIds.length) return variantIds;
  const preselectProductId = data.preselectProductId;
  if (!preselectProductId) return variantIds;
  const preselectProduct = data.config.preselectProducts.find(({ product }) => product.id == preselectProductId);
  if (!preselectProduct) return variantIds;
  const preselectedBoxesVariantsIds = ((_b = (_a = preselectProduct.metafields) == null ? void 0 : _a.children) == null ? void 0 : _b.boxesVariantsIds) || [];
  const preselectedShakersVariantsIds = ((_d = (_c = preselectProduct.metafields) == null ? void 0 : _c.children) == null ? void 0 : _d.shakersVariantsIds) || [];
  const preselectedSpecificShakersVariantsIds = ((_e = preselectProduct.metafields) == null ? void 0 : _e.specificShakers) || [];
  variantIds.push(
    ...preselectedBoxesVariantsIds,
    ...preselectedShakersVariantsIds,
    ...preselectedSpecificShakersVariantsIds
  );
  const uniqueVariantIds = Array.from(new Set(variantIds));
  if (uniqueVariantIds.length) {
    urlParams.set("preselect", uniqueVariantIds.join(","));
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);
  }
  return uniqueVariantIds;
}
function buildVariantAndProductIndex(config) {
  const variantsById = {};
  const productsById = {};
  const allProducts = [...config.sampleBoxesProducts];
  const shakers = [];
  config.shakersCollections.forEach((collection) => {
    allProducts.push(...collection.products);
    shakers.push(...collection.products);
  });
  config.shakersProducts = shakers;
  if (config.gifts && config.gifts.length > 0) {
    config.gifts.forEach((giftVariant) => {
      var _a;
      if (!giftVariant.productId && ((_a = giftVariant.product) == null ? void 0 : _a.id)) {
        giftVariant.productId = giftVariant.product.id;
      }
      const giftPortions = giftVariant.portions;
      if (giftPortions != null && giftVariant.product) {
        giftVariant.product.portions = giftPortions;
      }
      variantsById[giftVariant.id] = giftVariant;
      if (giftVariant.productId && !productsById[giftVariant.productId]) {
        let giftProduct = allProducts.find((p2) => p2.id === giftVariant.productId);
        if (!giftProduct && giftVariant.product) {
          giftProduct = giftVariant.product;
          allProducts.push(giftProduct);
        }
        if (giftProduct) {
          if (giftPortions != null) {
            giftProduct.portions = giftPortions;
          }
          productsById[giftVariant.productId] = giftProduct;
        }
      } else if (giftVariant.productId && giftPortions != null) {
        const existing = productsById[giftVariant.productId];
        if (existing) existing.portions = giftPortions;
      }
    });
  }
  allProducts.forEach((product) => {
    productsById[product.id] = product;
    product.variants.forEach((variant) => {
      variant.productId = product.id;
      variant.isSampleBox = config.sampleBoxesProducts.some((p2) => p2.id === product.id);
      variant.isShaker = config.shakersProducts.some((p2) => p2.id === product.id);
      variantsById[variant.id] = variant;
    });
  });
  if (config.gifts && config.gifts.length > 0) {
    config.gifts.forEach((gv) => {
      const v = variantsById[gv.id];
      if (!v) return;
      if (gv.portions != null) {
        v.portions = gv.portions;
      }
    });
  }
  return { variantsById, productsById };
}
function formatDiscountsList(discounts) {
  var _a, _b;
  const sampleBoxesThresholds = [];
  const shakersDiscounts = [];
  (_a = discounts == null ? void 0 : discounts.sampleBoxesThresholds) == null ? void 0 : _a.forEach((discount) => {
    sampleBoxesThresholds.push({
      discountAmount: +discount.discount_amount,
      quantity: +discount.quantity
    });
  });
  (_b = discounts == null ? void 0 : discounts.shakerDiscounts) == null ? void 0 : _b.forEach((discount) => {
    var _a2, _b2;
    shakersDiscounts.push({
      discountAmount: +discount.discount_amount,
      collectionId: (_b2 = (_a2 = discount.collection) == null ? void 0 : _a2.split("/")) == null ? void 0 : _b2.pop()
    });
  });
  sampleBoxesThresholds.sort((a, b3) => a.quantity - b3.quantity);
  return {
    sampleBoxesThresholds,
    shakersDiscounts
  };
}
function formatShakersProducts(config) {
  config.shakersCollections.forEach((collection) => {
    collection.products.forEach((product) => {
      product.variants = product.variantsWithMetafields;
      delete product.variantsWithMetafields;
    });
  });
}
const bundleBuilderInit = (selectors2) => {
  var _a, _b;
  const jsonData = (_a = document.querySelector(selectors2.json)) == null ? void 0 : _a.textContent;
  let data;
  try {
    data = jsonData ? JSON.parse(jsonData) : null;
  } catch (error2) {
    console.error("Error parsing JSON data for bundle builder:", error2);
    return;
  }
  if (!data) return;
  data.config.preselectedVariantsIds = getPreselectedVariantsIds(data);
  data.config.preselectProducts = sortBySpecificShakersFirst(data.config.preselectProducts);
  formatShakersProducts(data.config);
  data.config.variantAndProductIndex = buildVariantAndProductIndex(data.config);
  const currncySymbol = {
    "holyenergypl.myshopify.com": "zł",
    "holyenergyfr.myshopify.com": "€",
    "holyenergy.myshopify.com": "€",
    "holy-uk.myshopify.com": "£"
  };
  const shop = (_b = window.Shopify) == null ? void 0 : _b.shop;
  const moneyFormat = {
    "holyenergypl.myshopify.com": `{{ amount_with_dot_separator }} ${currncySymbol[shop]}`,
    "holyenergyfr.myshopify.com": `${currncySymbol[shop]}{{ amount_with_dot_separator }}`,
    "holyenergy.myshopify.com": `${currncySymbol[shop]}{{ amount_with_dot_separator }}`,
    "holy-uk.myshopify.com": `${currncySymbol[shop]}{{ amount_with_comma_separator }}`
  };
  data.moneyFormat = moneyFormat[shop] || "€{{ amount_with_dot_separator }}";
  const {
    sampleBoxesThresholds,
    shakersDiscounts
  } = formatDiscountsList(data.config.discounts);
  data.config.sampleBoxesThresholds = sampleBoxesThresholds;
  data.config.shakersDiscounts = shakersDiscounts;
  console.log("Bundle Builder init data:", data);
  const vuexStore = store(data);
  const app = createApp(App);
  app.use(vuexStore);
  app.config.devtools = true;
  app.mount(selectors2.app);
};
const selectors$2 = {
  videoDesktop: "ds-hero-featured-video",
  videoMobile: "ds-hero-featured-video-mobile"
};
class FeaturedVideo {
  constructor(sectionEl) {
    __publicField(this, "handleResize", () => {
      const wasDesktop = this.isDesktop;
      const isNowDesktop = window.innerWidth >= this.mediaRules.desktop;
      if (isNowDesktop === wasDesktop) return;
      this.isDesktop = isNowDesktop;
      ["videoDesktop", "videoMobile"].forEach((key) => {
        const v = this.elements[key];
        if (v) v.pause();
      });
      this.initPlaybackTrigger();
    });
    this.section = sectionEl;
    this.elements = {
      videoDesktop: sectionEl.querySelector(`#${selectors$2.videoDesktop}`),
      videoMobile: sectionEl.querySelector(`#${selectors$2.videoMobile}`)
    };
    if (!this.elements.videoDesktop && !this.elements.videoMobile) return;
    this.videoTriggers = { hover: "hover", view: "view" };
    this.mediaRules = { desktop: 1e3 };
    this.isDesktop = window.innerWidth >= this.mediaRules.desktop;
    this.isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const triggerSource = this.elements.videoDesktop || this.elements.videoMobile;
    this.triggerDesktop = triggerSource ? triggerSource.getAttribute("data-trigger") : this.videoTriggers.view;
    this.initPlaybackTrigger();
    window.addEventListener("resize", this.handleResize);
  }
  // helper: currently active video given current breakpoint
  getActiveVideo() {
    if (this.isDesktop) {
      return this.elements.videoDesktop || this.elements.videoMobile;
    }
    return this.elements.videoMobile || this.elements.videoDesktop;
  }
  initPlaybackTrigger() {
    this.removeTriggerHandlers();
    if (this.isTouchDevice || !this.isDesktop) {
      this.launchVideoInView();
    } else {
      this.triggerDesktop === this.videoTriggers.hover ? this.launchVideoOnHover() : this.launchVideoInView();
    }
  }
  launchVideoOnHover() {
    const v = this.getActiveVideo();
    if (!v) return;
    this.hoverHandler = () => v.play().catch(() => {
    });
    this.leaveHandler = () => v.pause();
    v.addEventListener("mouseenter", this.hoverHandler);
    v.addEventListener("mouseleave", this.leaveHandler);
  }
  launchVideoInView() {
    const v = this.getActiveVideo();
    if (!v) return;
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target !== this.getActiveVideo()) return;
          const active = this.getActiveVideo();
          if (!active) return;
          if (entry.isIntersecting) {
            active.play().catch(() => {
            });
          } else {
            active.pause();
          }
        });
      },
      { threshold: 0.85 }
    );
    this.observer.observe(v);
  }
  removeTriggerHandlers() {
    ["videoDesktop", "videoMobile"].forEach((key) => {
      const v = this.elements[key];
      if (!v) return;
      if (this.hoverHandler) {
        v.removeEventListener("mouseenter", this.hoverHandler);
      }
      if (this.leaveHandler) {
        v.removeEventListener("mouseleave", this.leaveHandler);
      }
    });
    this.hoverHandler = null;
    this.leaveHandler = null;
    if (this.observer) {
      ["videoDesktop", "videoMobile"].forEach((key) => {
        const v = this.elements[key];
        if (v) this.observer.unobserve(v);
      });
      this.observer.disconnect();
      this.observer = null;
    }
  }
  removeAllEvents() {
    ["videoDesktop", "videoMobile"].forEach((key) => {
      const v = this.elements[key];
      if (v) v.pause();
    });
    this.removeTriggerHandlers();
    window.removeEventListener("resize", this.handleResize);
  }
}
function initializeFeaturedVideos() {
  const sections = document.querySelectorAll('[data-section-type="ds-main-hero-component"]');
  if (!sections.length) return;
  sections.forEach((section) => {
    new FeaturedVideo(section);
  });
}
initializeFeaturedVideos();
const selectors$1 = {
  imageLabelElement: ".image-label__wrapper",
  imageLabelContent: ".image-label",
  radioButton: ".collection-block-swatch__radio",
  productItem: ".product-item",
  primaryImage: ".product-item__primary-image",
  imageWrapper: ".product-item__image-wrapper > a",
  aspectRatio: ".product-item__aspect-ratio",
  variantLabelsContainer: ".ds-labels__variant-tags",
  descriptionContainer: ".product_info_description_",
  imageWrapperContainer: ".product-item__image-wrapper",
  soldOutLabel: ".ds-label--sold-out"
};
function decodeHtmlEntities(htmlString) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  return tempDiv.innerHTML || htmlString;
}
function decodeHtmlEntitiesToText(htmlString) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  return tempDiv.textContent || tempDiv.innerText || htmlString;
}
function generateSrcset(baseUrl, existingParams, sizes) {
  const srcsetParts = sizes.map((size) => {
    let url = `${baseUrl}?width=${size}`;
    if (existingParams) {
      const paramsWithoutWidth = existingParams.split("&").filter((param) => !param.startsWith("width=")).join("&");
      if (paramsWithoutWidth) {
        url += `&${paramsWithoutWidth}`;
      }
    }
    return `${url} ${size}w`;
  });
  return srcsetParts.join(", ");
}
function showLoadingPlaceholder(productImage, parentContainer) {
  if (!productImage || !parentContainer) return;
  const aspectRatio = productImage.closest(selectors$1.aspectRatio);
  if (aspectRatio) {
    aspectRatio.classList.add("is-loading");
  }
  const originalSrc = productImage.src;
  productImage.dataset.originalSrc = originalSrc;
  productImage.style.opacity = "0.5";
  productImage.style.filter = "blur(2px)";
  productImage.style.transition = "opacity 0.2s ease, filter 0.2s ease";
}
function hideLoadingPlaceholder(productImage, parentContainer) {
  if (!productImage || !parentContainer) return;
  const aspectRatio = productImage.closest(selectors$1.aspectRatio);
  if (aspectRatio) {
    aspectRatio.classList.remove("is-loading");
  }
  productImage.style.opacity = "1";
  productImage.style.filter = "none";
  productImage.style.transition = "opacity 0.3s ease, filter 0.3s ease";
}
function updateProductImage(productImage, variantImageUrl, parentContainer) {
  if (!productImage || !variantImageUrl) return;
  const originalSrc = productImage.src;
  productImage.dataset.originalSrc = originalSrc;
  const decodedUrl = decodeHtmlEntitiesToText(variantImageUrl);
  const urlParts = decodedUrl.split("?");
  const baseUrl = urlParts[0];
  const existingParams = urlParts[1] || "";
  const sizes = [200, 300, 400, 500, 600, 700, 800, 900, 1e3, 1100, 1200];
  const srcset = generateSrcset(baseUrl, existingParams, sizes);
  const handleImageLoad = () => {
    hideLoadingPlaceholder(productImage, parentContainer);
    productImage.removeEventListener("load", handleImageLoad);
    productImage.removeEventListener("error", handleImageError);
  };
  const handleImageError = () => {
    const storedOriginalSrc = productImage.dataset.originalSrc;
    if (storedOriginalSrc) {
      productImage.src = storedOriginalSrc;
    }
    hideLoadingPlaceholder(productImage, parentContainer);
    productImage.removeEventListener("load", handleImageLoad);
    productImage.removeEventListener("error", handleImageError);
  };
  productImage.removeEventListener("load", handleImageLoad);
  productImage.removeEventListener("error", handleImageError);
  productImage.addEventListener("load", handleImageLoad);
  productImage.addEventListener("error", handleImageError);
  showLoadingPlaceholder(productImage, parentContainer);
  productImage.src = decodedUrl;
  productImage.setAttribute("srcset", srcset);
  if (productImage.complete && productImage.naturalWidth > 0) {
    requestAnimationFrame(() => {
      hideLoadingPlaceholder(productImage, parentContainer);
    });
  }
}
function updateProductUrl(productUrl, variantUrl) {
  if (productUrl && variantUrl) {
    productUrl.setAttribute("href", variantUrl);
  }
}
function saveVariantToSession(radio, variantImageUrl) {
  const variantId = radio.getAttribute("data-variant");
  const variantPrice = radio.getAttribute("data-variant-price");
  const variantTitle = radio.getAttribute("data-variant-title");
  const productId = radio.getAttribute("data-product");
  const splitedVariantIndex = radio.getAttribute("data-splited-variant-index");
  if (!variantImageUrl || !variantId || !productId || !variantTitle) {
    return;
  }
  const selectedVariant = {
    featured_media: variantImageUrl,
    id: variantId,
    title: variantTitle,
    price: variantPrice,
    mainId: productId,
    splitedVariantIndex: splitedVariantIndex || null
  };
  sessionStorage.setItem("selectedVariant", JSON.stringify(selectedVariant));
}
function updateImageLabel(radio, parentContainer) {
  const imageLabelContent = radio.getAttribute("data-image-label");
  const imageLabelElement = parentContainer.querySelector(selectors$1.imageLabelElement);
  if (!imageLabelElement) return;
  if (imageLabelContent) {
    const labelContent = imageLabelElement.querySelector(selectors$1.imageLabelContent);
    if (labelContent) {
      labelContent.innerText = imageLabelContent;
    }
    imageLabelElement.classList.remove("hidden");
  } else {
    imageLabelElement.classList.add("hidden");
  }
}
function updateVariantLabels(radio, parentContainer) {
  const labelsContainer = parentContainer.querySelector(selectors$1.variantLabelsContainer);
  if (!labelsContainer) return;
  const labelsHtml = radio.getAttribute("data-variant-labels");
  if (labelsHtml) {
    labelsContainer.innerHTML = decodeHtmlEntities(labelsHtml);
  } else {
    labelsContainer.innerHTML = "";
  }
}
function updateVariantDescription(radio, parentContainer) {
  const descriptionContainer = parentContainer.querySelector(selectors$1.descriptionContainer);
  if (!descriptionContainer) return;
  const descriptionHtml = radio.getAttribute("data-variant-description");
  const defaultDescription = descriptionContainer.getAttribute("data-product-description");
  if (descriptionHtml) {
    const decodedDescription = decodeHtmlEntities(descriptionHtml);
    descriptionContainer.innerHTML = decodedDescription;
    descriptionContainer.classList.remove("hidden");
    return;
  }
  if (defaultDescription) {
    const decodedDefaultDescription = decodeHtmlEntities(defaultDescription);
    descriptionContainer.innerHTML = decodedDefaultDescription;
    descriptionContainer.classList.remove("hidden");
  } else {
    descriptionContainer.innerHTML = "";
    descriptionContainer.classList.add("hidden");
  }
}
function updateSoldOutState(radio, parentContainer) {
  const isAvailable = radio.getAttribute("data-variant-available") === "true";
  const soldOutLabel = parentContainer.querySelector(selectors$1.soldOutLabel);
  if (isAvailable) {
    parentContainer.classList.remove("product-item--sold-out");
    if (soldOutLabel) soldOutLabel.classList.add("hidden");
  } else {
    parentContainer.classList.add("product-item--sold-out");
    if (soldOutLabel) soldOutLabel.classList.remove("hidden");
  }
}
function updateVariantBackground(radio, parentContainer) {
  const bgColor = (radio.getAttribute("data-variant-bg-color") || "").trim();
  const defaultBgColor = (parentContainer.getAttribute("data-product-bg-color") || "").trim();
  const imageWrapper = parentContainer.querySelector(selectors$1.imageWrapperContainer);
  const nextBgColor = bgColor && bgColor !== "null" ? bgColor : defaultBgColor && defaultBgColor !== "null" ? defaultBgColor : "";
  if (nextBgColor) {
    parentContainer.style.setProperty("--product-image-background-color", nextBgColor);
    parentContainer.classList.add("ds-product-item__image-background-color");
    if (imageWrapper) {
      imageWrapper.style.background = nextBgColor;
    }
  } else {
    parentContainer.style.removeProperty("--product-image-background-color");
    parentContainer.classList.remove("ds-product-item__image-background-color");
    if (imageWrapper) {
      imageWrapper.style.background = "";
    }
  }
}
function handleVariantChange(radio) {
  const parentContainer = radio.closest(selectors$1.productItem);
  if (!parentContainer) return;
  parentContainer.querySelectorAll(selectors$1.radioButton).forEach((otherRadio) => {
    if (otherRadio !== radio) {
      otherRadio.checked = false;
    }
  });
  radio.checked = true;
  const variantImageUrl = radio.getAttribute("variant-image");
  if (variantImageUrl) {
    const productImage = parentContainer.querySelector(selectors$1.primaryImage);
    if (productImage && productImage.dataset.overviewOverride !== "true") {
      updateProductImage(productImage, variantImageUrl, parentContainer);
    }
  }
  const variantUrl = radio.getAttribute("data-variant-url");
  const productUrl = parentContainer.querySelector(selectors$1.imageWrapper);
  updateProductUrl(productUrl, variantUrl);
  if (variantImageUrl) {
    saveVariantToSession(radio, variantImageUrl);
  }
  updateImageLabel(radio, parentContainer);
  updateVariantLabels(radio, parentContainer);
  updateVariantDescription(radio, parentContainer);
  updateVariantBackground(radio, parentContainer);
  updateSoldOutState(radio, parentContainer);
}
function findRadioFromLabel(label) {
  const labelFor = label.getAttribute("for");
  if (labelFor) {
    const radio = document.getElementById(labelFor);
    if (radio && radio.classList.contains("collection-block-swatch__radio")) {
      return radio;
    }
  }
  let sibling = label.previousElementSibling;
  while (sibling) {
    if (sibling.classList.contains("collection-block-swatch__radio")) {
      return sibling;
    }
    sibling = sibling.previousElementSibling;
  }
  return null;
}
function initVariantSelector() {
  sessionStorage.removeItem("selectedVariant");
  document.addEventListener("change", (e) => {
    if (e.target.classList.contains("collection-block-swatch__radio")) {
      handleVariantChange(e.target);
    }
  });
  document.addEventListener("click", (e) => {
    const label = e.target.closest(".collection-block-swatch__item");
    if (label) {
      const radio = findRadioFromLabel(label);
      if (radio) {
        setTimeout(() => {
          if (radio.checked) {
            handleVariantChange(radio);
          }
        }, 0);
      }
    }
  });
  document.querySelectorAll(selectors$1.radioButton).forEach((radio) => {
    if (radio.checked) {
      handleVariantChange(radio);
    }
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initVariantSelector);
} else {
  initVariantSelector();
}
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".bb-header.bb-steps-big");
  if (!header) return;
  const getStickyOffset = () => {
    if (typeof window.getStickyHeaderOffset === "function") {
      return window.getStickyHeaderOffset();
    }
    const rootStyles = getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(rootStyles.getPropertyValue("--header-height")) || 0;
    const announcementBarHeight = parseFloat(rootStyles.getPropertyValue("--announcement-bar-height")) || 0;
    return headerHeight + announcementBarHeight - 40;
  };
  const onScroll2 = () => {
    const rect = header.getBoundingClientRect();
    const stickyOffset = getStickyOffset();
    if (rect.top <= stickyOffset) {
      header.classList.add("bb-sticky-active");
    } else {
      header.classList.remove("bb-sticky-active");
    }
  };
  window.addEventListener("scroll", onScroll2, { passive: true });
  window.addEventListener("resize", onScroll2);
  window.addEventListener("load", onScroll2);
  onScroll2();
});
function initSafariProductImageWrapperHeightFix() {
  const ua2 = navigator.userAgent || "";
  const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(ua2);
  if (!isSafariBrowser) return;
  const selector = ".product-item.ds-product-item .product-item__image-wrapper";
  let rafId = null;
  const applyHeights = () => {
    document.querySelectorAll(selector).forEach((element) => {
      const width = Math.round(element.getBoundingClientRect().width);
      if (width > 0) {
        element.style.height = `${width}px`;
      }
    });
  };
  const scheduleApply = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(applyHeights);
  };
  scheduleApply();
  window.addEventListener("resize", scheduleApply, { passive: true });
  window.addEventListener("load", scheduleApply);
  const observer = new MutationObserver(scheduleApply);
  observer.observe(document.body, { childList: true, subtree: true });
}
initSafariProductImageWrapperHeightFix();
function initDsTasteDial() {
  document.querySelectorAll(".ds-taste-dial").forEach((section) => {
    const inner = section.querySelector(".ds-taste-dial__inner");
    if (!inner) return;
    const buttons = Array.from(section.querySelectorAll(".ds-taste-dial__turn-button[data-turn]"));
    const paginationDots = Array.from(section.querySelectorAll(".ds-taste-dial__pagination-dot[data-dot-index]"));
    const stepArrows = Array.from(section.querySelectorAll(".ds-taste-dial__step-arrow[data-step-direction]"));
    const setActiveButton = (activeButton) => {
      buttons.forEach((btn) => {
        const isActive = btn === activeButton;
        btn.toggleAttribute("data-active", isActive);
        btn.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    };
    const setActiveDot = (turn) => {
      const activeIndex = Number(turn) - 1;
      paginationDots.forEach((dot, index) => {
        dot.classList.toggle("is-active", index === activeIndex);
      });
    };
    const setStepArrowsState = (turn) => {
      const activeTurn = Number(turn);
      stepArrows.forEach((arrow) => {
        const direction = Number(arrow.getAttribute("data-step-direction"));
        if (Number.isNaN(direction)) return;
        const isDisabled = activeTurn <= 1 && direction < 0 || activeTurn >= 5 && direction > 0;
        arrow.toggleAttribute("disabled", isDisabled);
        arrow.classList.toggle("is-hidden", isDisabled);
        arrow.setAttribute("aria-hidden", isDisabled ? "true" : "false");
      });
    };
    const turnImage = section.querySelector(".turn-image");
    if (!turnImage) return;
    const moodEl = section.querySelector(".ds-taste-dial__mood-image");
    const step1MoodSvg = moodEl ? moodEl.innerHTML : "";
    const moodSvgs = {
      1: step1MoodSvg,
      2: `<svg xmlns="http://www.w3.org/2000/svg" width="215" height="207" viewBox="0 0 215 207" fill="none"><path d="M35.9085 144.137L32.4166 181.471C30.8259 198.547 48.0911 211.083 63.8431 204.291L98.257 189.466C103.96 187.021 110.44 187.021 116.143 189.466L150.557 204.291C166.309 211.083 183.574 198.547 181.983 181.471L178.492 144.137C177.91 137.966 179.927 131.796 184.001 127.139L208.754 99.0019C220.083 86.1173 213.487 65.8202 196.765 62.0557L160.218 53.8282C154.165 52.4699 148.927 48.6666 145.746 43.3109L126.618 11.0606C117.889 -3.68686 96.5499 -3.68686 87.7815 11.0606L68.6541 43.3109C65.4726 48.6666 60.2349 52.4699 54.1824 53.8282L17.6345 62.0557C0.912559 65.8202 -5.68312 86.1173 5.64593 99.0019L30.3991 127.139C34.5117 131.796 36.4904 137.966 35.9085 144.137Z" fill="#FFF200"/><path d="M133.137 40.6719C136.707 38.3434 117.657 -6.28707 100.818 9.15894C97.8698 11.8756 97.7922 14.5146 99.7321 15.7953C101.672 17.076 102.603 13.9325 109.082 15.446C114.747 16.7655 128.21 43.8543 133.137 40.6331V40.6719Z" fill="white"/><path d="M206.854 83.2067C206.854 80.1408 204.797 74.2806 198.745 71.3699C195.408 69.7787 177.522 64.7724 177.522 64.7724C175.854 64.5007 172.168 63.6469 171.547 66.2859C171.004 68.6533 174.69 69.7787 175.699 70.0504C178.415 70.749 191.8 76.1822 196.339 78.9765C201.034 81.8872 200.491 88.5623 199.482 90.2699C199.016 91.0849 197.581 93.8016 198.473 95.0046C198.978 95.6644 200.064 95.7808 200.801 95.3151C203.556 93.5299 206.854 89.9595 206.854 83.2067Z" fill="white"/><path d="M59.3432 58.0584C59.3432 58.0584 59.4208 58.0584 59.4596 58.0972C59.5372 58.0972 59.6148 58.0972 59.6924 58.0972C59.576 58.0972 59.4596 58.0972 59.3432 58.0584Z" fill="white"/><path d="M60.0804 60.1541C58.5673 57.0493 35.2108 59.96 33.6201 66.0531C32.2234 71.5251 44.5224 67.8771 48.4022 66.9845C51.5836 66.2471 61.5935 63.2588 60.0416 60.1541H60.0804Z" fill="white"/><path d="M176.746 181.665C175.621 159.893 175.117 145.03 172.323 145.03C168.599 145.03 169.724 157.953 169.569 176.077C169.569 179.608 169.258 185.74 166.659 189.155C163.633 193.114 157.541 194.783 160.141 199.983C162.74 205.184 177.29 196.917 176.746 181.665Z" fill="white"/><path d="M78.1215 190.475C77.6172 189.544 76.492 189.35 72.4958 190.785C64.5422 193.58 54.9203 190.669 51.3896 196.452C45.5311 205.999 79.7511 195.753 78.1603 190.475H78.1215Z" fill="white"/><path d="M162.624 61.2407C162.624 61.2407 162.779 61.2407 162.857 61.2795C162.895 61.2795 162.934 61.2795 163.012 61.2795C162.895 61.2795 162.74 61.2795 162.624 61.2407Z" fill="white"/><path d="M167.745 64.1514C167.396 60.5034 159.753 59.6108 160.684 64.3455C161.499 67.4502 167.668 67.7995 167.745 64.1514Z" fill="white"/><path d="M92.438 17.9686C91.0025 19.2493 89.9162 22.975 93.8348 22.7033C95.9299 22.5481 97.831 19.3269 96.861 17.7357C95.6971 15.8341 93.5632 16.8043 92.438 17.9686Z" fill="white"/><path d="M88.0151 93.8404C87.8987 91.7835 87.9375 78.3167 79.7898 78.5108C73.233 78.666 73.3106 93.8404 73.3106 96.1301C73.3106 96.557 73.3882 98.8467 74.9789 99.5841C74.9789 99.5841 76.4144 100.283 77.5784 100.904C78.1603 101.214 78.1603 102.029 77.5784 102.301C76.1816 102.922 74.5133 103.814 74.2029 105.25C73.6209 109.054 74.7849 113.128 77.2292 116.156C78.7423 118.018 81.1478 119.26 83.4369 118.212C89.567 115.418 88.3254 98.6527 88.0539 93.8404H88.0151Z" fill="#231F20"/><path d="M139.578 93.8015C139.461 91.7447 139.384 78.2779 131.236 78.5496C124.679 78.7436 124.834 93.918 124.873 96.2465C124.873 96.6734 124.951 98.9632 126.58 99.6617C126.58 99.6617 128.016 100.36 129.18 100.942C129.762 101.214 129.762 102.068 129.18 102.34C127.783 102.96 126.115 103.853 125.843 105.289C125.3 109.092 126.464 113.167 128.947 116.156C130.46 118.018 132.905 119.221 135.194 118.174C141.285 115.341 139.927 98.5751 139.655 93.7627L139.578 93.8015Z" fill="#231F20"/><path d="M137.172 57.0105C140.548 48.2009 155.601 58.0972 153.739 65.2381C151.916 69.0802 146.949 65.665 144.544 63.9574C141.906 62.1333 137.405 61.1631 137.133 57.5927V57.0105H137.172Z" fill="#231F20"/><path d="M77.1904 57.0105C73.815 48.2009 58.7613 58.0972 60.6236 65.2381C62.4471 69.0802 67.4133 65.665 69.8188 63.9574C72.457 62.1333 76.9576 61.1631 77.2292 57.5927V57.0105H77.1904Z" fill="#231F20"/><path d="M148.501 117.475C147.027 116.35 144.893 116.621 143.729 118.096C143.264 118.717 131.779 133.193 107.181 133.232C82.5833 133.232 71.0991 118.717 70.6335 118.135C69.5084 116.66 67.3745 116.35 65.8613 117.475C64.387 118.601 64.0766 120.735 65.2018 122.249C65.4733 122.598 68.4996 126.44 74.4745 130.476C72.263 136.336 67.8788 149.92 71.5259 158.535C73.039 162.106 75.7161 164.745 79.2467 166.103C81.3806 166.918 83.2817 167.306 85.1828 167.306C93.7184 167.306 97.1714 159.195 99.6933 153.296L100.547 151.317C102.448 147.009 104.582 142.197 105.591 139.946C106.095 139.946 106.561 139.984 107.065 140.023C107.065 140.023 107.104 140.023 107.181 140.023C135.232 139.984 148.501 122.947 149.045 122.249C150.17 120.774 149.898 118.639 148.424 117.514L148.501 117.475Z" fill="#231F20"/><path d="M49.3333 122.792C57.1544 122.792 63.4947 119.612 63.4947 115.69C63.4947 111.768 57.1544 108.588 49.3333 108.588C41.5123 108.588 35.172 111.768 35.172 115.69C35.172 119.612 41.5123 122.792 49.3333 122.792Z" fill="#F391BC"/><path d="M165.029 122.792C172.85 122.792 179.191 119.612 179.191 115.69C179.191 111.768 172.85 108.588 165.029 108.588C157.208 108.588 150.868 111.768 150.868 115.69C150.868 119.612 157.208 122.792 165.029 122.792Z" fill="#F391BC"/><path d="M92.3604 138.898C91.5069 140.295 89.8774 143.516 88.7522 149.182C88.4418 150.812 87.0063 151.899 85.4156 151.899C85.1828 151.899 84.95 151.899 84.756 151.821C82.9325 151.433 81.7298 149.648 82.0789 147.824C83.1265 142.662 84.562 139.092 85.726 136.802C83.6309 135.948 81.7686 135.056 80.2942 134.318C77.8888 141.032 75.5997 150.579 77.8111 155.857C78.6259 157.759 79.9062 159.04 81.7298 159.738C83.0489 160.243 84.2128 160.476 85.2216 160.476C88.985 160.476 90.9637 156.556 93.5244 150.579L94.378 148.561C95.4643 146.116 96.9774 142.662 98.1802 139.946C96.473 139.674 94.4167 139.325 92.3604 138.82V138.898Z" fill="#F391BC"/></svg>`,
      3: `<svg xmlns="http://www.w3.org/2000/svg" width="215" height="207" viewBox="0 0 215 207" fill="none"><path d="M30.3991 127.139C34.5117 131.796 36.4904 137.966 35.9085 144.137L32.4166 181.471C30.8259 198.547 48.0911 211.083 63.8431 204.291L98.257 189.466C103.96 187.021 110.44 187.021 116.143 189.466L150.557 204.291C166.309 211.083 183.574 198.547 181.983 181.471L178.492 144.137C177.91 137.966 179.927 131.796 184.001 127.139L208.754 99.0019C220.083 86.1173 213.487 65.8202 196.765 62.0557L160.218 53.8282C154.165 52.4699 148.927 48.6666 145.746 43.3109L126.618 11.0606C117.889 -3.68686 96.5499 -3.68686 87.7815 11.0606L68.6541 43.3109C65.4726 48.6666 60.2349 52.4699 54.1824 53.8282L17.6345 62.0557C0.912559 65.8202 -5.68312 86.1173 5.64593 99.0019L30.3991 127.139Z" fill="#FFF200"/><path d="M133.175 40.6719C136.744 38.3434 117.694 -6.28707 100.856 9.15894C97.9071 11.8756 97.8295 14.5146 99.7694 15.7953C101.709 17.076 102.64 13.9325 109.12 15.446C114.784 16.7655 128.247 43.8543 133.175 40.6331V40.6719Z" fill="white"/><path d="M206.891 83.2067C206.891 80.1408 204.835 74.2806 198.782 71.3699C195.446 69.7787 177.56 64.7724 177.56 64.7724C175.891 64.5007 172.206 63.6469 171.585 66.2859C171.042 68.6533 174.727 69.7787 175.736 70.0504C178.452 70.749 191.837 76.1822 196.377 78.9765C201.071 81.8872 200.528 88.5623 199.519 90.2699C199.054 91.0849 197.618 93.8016 198.511 95.0046C199.015 95.6644 200.101 95.7808 200.839 95.3151C203.593 93.5299 206.891 89.9595 206.891 83.2067Z" fill="white"/><path d="M59.3806 58.0584C59.3806 58.0584 59.4581 58.0584 59.4969 58.0972C59.5745 58.0972 59.6521 58.0972 59.7297 58.0972C59.6133 58.0972 59.4969 58.0972 59.3806 58.0584Z" fill="white"/><path d="M60.1177 60.1541C58.6046 57.0493 35.2481 59.96 33.6574 66.0531C32.2607 71.5251 44.5597 67.8771 48.4395 66.9845C51.6209 66.2471 61.6308 63.2588 60.0789 60.1541H60.1177Z" fill="white"/><path d="M176.784 181.665C175.659 159.893 175.154 145.029 172.361 145.029C168.636 145.029 169.761 157.953 169.606 176.077C169.606 179.608 169.296 185.74 166.696 189.155C163.67 193.114 157.579 194.783 160.178 199.983C162.778 205.184 177.327 196.917 176.784 181.665Z" fill="white"/><path d="M78.1588 190.475C77.6545 189.544 76.5293 189.35 72.5331 190.785C64.5795 193.58 54.9576 190.669 51.4269 196.452C45.5684 205.999 79.7884 195.753 78.1976 190.475H78.1588Z" fill="white"/><path d="M162.661 61.2407C162.661 61.2407 162.816 61.2407 162.894 61.2795C162.933 61.2795 162.972 61.2795 163.049 61.2795C162.933 61.2795 162.778 61.2795 162.661 61.2407Z" fill="white"/><path d="M167.783 64.1514C167.433 60.5034 159.79 59.6108 160.721 64.3455C161.536 67.4502 167.705 67.7995 167.783 64.1514Z" fill="white"/><path d="M92.4753 17.9686C91.0398 19.2493 89.9535 22.975 93.8721 22.7033C95.9672 22.5481 97.8683 19.3269 96.8983 17.7357C95.7344 15.8341 93.6005 16.8043 92.4753 17.9686Z" fill="white"/><path d="M122.583 119.687C121.729 118.756 120.449 118.368 119.246 118.678C104.076 122.559 93.4065 113.555 92.9797 113.167C92.0874 112.391 90.8458 112.119 89.7207 112.469C88.5956 112.818 87.742 113.749 87.4316 114.914C85.8021 121.511 78.2753 154.809 88.0912 163.27C89.8759 164.783 91.8546 165.56 93.9885 165.56C94.7645 165.56 95.5404 165.443 96.3552 165.249C108.926 161.911 121.031 129.545 123.32 123.102C123.747 121.938 123.475 120.619 122.622 119.687H122.583Z" fill="#231F20"/><path d="M86.1125 90.1923C75.4818 84.1381 81.9999 68.8861 74.2402 68.8861C70.9424 68.8861 69.8948 72.9222 69.2353 78.9765C68.6921 84.2157 67.4506 86.6219 64.3079 88.9116C58.527 93.0642 57.5182 92.3656 57.2079 95.1987C56.7035 99.6229 62.8336 100.283 64.6959 101.641C67.1014 103.387 68.2265 106.065 69.1189 109.946C70.3604 115.224 70.1664 119.299 75.4042 119.066C80.6419 118.833 76.9561 106.919 82.349 102.456C85.6469 99.7005 90.6906 99.4289 91.0398 96.4017C91.3502 93.6463 90.5742 92.7537 86.0349 90.1923H86.1125Z" fill="#231F20"/><path d="M74.279 82.6245C72.2615 82.314 72.2615 84.4097 71.2916 85.9233C70.3216 87.4368 68.2265 88.9892 69.2353 90.3863C70.3992 91.9387 73.3479 90.464 74.5118 88.0966C75.831 85.4576 75.443 82.7798 74.279 82.6245Z" fill="white"/><path d="M69.2741 92.482C69.2741 92.2104 69.1965 91.9387 69.0413 91.667C69.0413 91.7447 69.1189 91.8223 69.1577 91.8999C68.5369 89.9206 65.4719 90.5804 65.6271 92.5985C65.7047 94.7718 69.4293 94.7718 69.2741 92.4432V92.482Z" fill="white"/><path d="M152.884 90.2699C139.654 85.9233 147.181 68.8861 139.421 68.8861C136.123 68.8861 135.658 72.3789 134.416 78.9765C133.446 84.1381 131.933 86.2338 128.79 88.4847C123.009 92.6373 122.35 92.0939 122.35 94.6942C122.35 98.7303 128.053 100.283 129.916 101.641C132.321 103.387 134.261 106.22 135.153 110.101C136.395 115.379 136.666 119.221 140.973 118.989C146.211 118.678 143.378 104.94 148.733 101.408C150.246 100.399 154.902 100.011 156.647 97.5272C158.005 95.5868 157.152 91.667 152.923 90.2699H152.884Z" fill="#231F20"/><path d="M138.49 82.6245C136.472 82.3141 136.472 84.4097 135.502 85.9233C134.533 87.4369 132.437 88.9892 133.446 90.3863C134.61 91.9387 137.559 90.464 138.723 88.0966C140.042 85.4576 139.654 82.7798 138.49 82.6245Z" fill="white"/><path d="M133.446 92.482C133.446 92.2104 133.369 91.9387 133.213 91.6671C133.213 91.7447 133.291 91.8223 133.33 91.8999C132.709 89.9206 129.644 90.5804 129.799 92.5985C129.877 94.7718 133.601 94.7718 133.446 92.4432V92.482Z" fill="white"/><path d="M136.434 45.6395C136.395 36.0536 154.048 40.0898 154.824 47.4635C154.514 51.7325 148.655 50.3354 145.823 49.5592C142.68 48.783 138.141 49.4816 136.628 46.2216L136.472 45.6783L136.434 45.6395Z" fill="#231F20"/><path d="M78.0036 45.6395C78.0424 36.0536 60.3893 40.0898 59.6133 47.4635C59.9237 51.7325 65.7822 50.3354 68.6145 49.5592C71.7571 48.783 76.2965 49.4816 77.8096 46.2216L77.9648 45.6783L78.0036 45.6395Z" fill="#231F20"/><path d="M49.3706 122.792C57.1917 122.792 63.532 119.612 63.532 115.69C63.532 111.768 57.1917 108.588 49.3706 108.588C41.5496 108.588 35.2093 111.768 35.2093 115.69C35.2093 119.612 41.5496 122.792 49.3706 122.792Z" fill="#F391BC"/><path d="M165.067 122.792C172.888 122.792 179.228 119.612 179.228 115.69C179.228 111.768 172.888 108.588 165.067 108.588C157.246 108.588 150.905 111.768 150.905 115.69C150.905 119.612 157.246 122.792 165.067 122.792Z" fill="#F391BC"/><path d="M107.801 141.77C102.834 137.927 94.5704 137.656 90.419 137.811C89.4879 147.28 89.7595 155.741 92.5141 158.108C93.3289 158.807 93.9497 158.846 94.5704 158.69C98.3339 157.681 103.261 150.463 107.801 141.77Z" fill="#F391BC"/></svg>`,
      4: `<svg xmlns="http://www.w3.org/2000/svg" width="215" height="207" viewBox="0 0 215 207" fill="none"><path d="M196.765 62.0557L160.218 53.8282C154.165 52.4699 148.927 48.6666 145.746 43.3109L126.618 11.0606C117.889 -3.68686 96.5499 -3.68686 87.7815 11.0606L68.6541 43.3109C65.4726 48.6666 60.2349 52.4699 54.1824 53.8282L17.6345 62.0557C0.912559 65.8202 -5.68312 86.1173 5.64593 99.0019L30.3991 127.139C34.5117 131.796 36.4904 137.966 35.9085 144.137L32.4166 181.471C30.8259 198.547 48.0911 211.083 63.8431 204.291L98.257 189.466C103.96 187.021 110.44 187.021 116.143 189.466L150.557 204.291C166.309 211.083 183.574 198.547 181.983 181.471L178.492 144.137C177.91 137.966 179.927 131.796 184.001 127.139L208.754 99.0019C220.083 86.1173 213.487 65.8202 196.765 62.0557Z" fill="#FFF200"/><path d="M133.175 40.7092C136.744 38.3806 117.694 -6.24982 100.856 9.1962C97.9071 11.9128 97.8295 14.5519 99.7694 15.8326C101.709 17.1133 102.64 13.9697 109.12 15.4833C114.784 16.8028 128.247 43.8915 133.175 40.6704V40.7092Z" fill="white"/><path d="M206.891 83.2439C206.891 80.178 204.835 74.3179 198.782 71.4072C195.446 69.816 177.56 64.8096 177.56 64.8096C175.891 64.538 172.206 63.6842 171.585 66.3232C171.042 68.6905 174.727 69.816 175.736 70.0877C178.452 70.7862 191.837 76.2195 196.377 79.0138C201.071 81.9244 200.528 88.5996 199.519 90.3072C199.054 91.1222 197.618 93.8388 198.511 95.0419C199.015 95.7017 200.101 95.8181 200.839 95.3524C203.593 93.5672 206.891 89.9967 206.891 83.2439Z" fill="white"/><path d="M176.784 181.703C175.659 159.931 175.154 145.067 172.361 145.067C168.636 145.067 169.761 157.99 169.606 176.114C169.606 179.646 169.296 185.777 166.696 189.193C163.67 193.151 157.579 194.82 160.178 200.02C162.778 205.221 177.327 196.955 176.784 181.703Z" fill="white"/><path d="M78.1589 190.512C77.6545 189.581 76.5293 189.387 72.5331 190.823C64.5795 193.617 54.9576 190.706 51.427 196.489C45.5684 206.036 79.7884 195.79 78.1976 190.512H78.1589Z" fill="white"/><path d="M162.661 61.278C162.661 61.278 162.816 61.278 162.894 61.3168C162.933 61.3168 162.972 61.3168 163.049 61.3168C162.933 61.3168 162.778 61.3168 162.661 61.278Z" fill="white"/><path d="M167.783 64.1887C167.433 60.5406 159.79 59.648 160.721 64.3827C161.536 67.4874 167.705 67.8367 167.783 64.1887Z" fill="white"/><path d="M92.4753 18.0059C91.0398 19.2866 89.9535 23.0122 93.8721 22.7406C95.9672 22.5853 97.8683 19.3642 96.8983 17.773C95.7344 15.8714 93.6005 16.8416 92.4753 18.0059Z" fill="white"/><path d="M59.3806 58.0956C59.3806 58.0956 59.4582 58.0957 59.497 58.1345C59.5746 58.1345 59.6522 58.1345 59.7298 58.1345C59.6134 58.1345 59.497 58.1345 59.3806 58.0956Z" fill="white"/><path d="M42.775 56.1552C42.775 56.1552 49.7586 49.286 54.9188 52.3907C60.0789 55.4954 52.3969 74.085 38.0028 79.3242C36.2181 79.984 34.8601 80.5273 33.3858 79.2854C30.6311 76.918 25.7038 70.3205 30.282 56.1552C32.2219 50.1398 38.2744 46.4141 40.9126 48.8591C43.2017 50.9548 42.7362 56.1552 42.7362 56.1552H42.775Z" fill="#F391BC"/><path d="M22.9491 82.2349C22.9491 82.2349 25.5098 78.354 27.8765 79.1302C30.2432 79.9064 30.3596 88.3279 23.3759 92.0148C22.6775 92.4029 21.3584 92.6746 20.6212 92.3253C19.3021 91.6267 17.3622 89.8415 17.9442 83.6708C18.177 81.0706 20.272 78.6645 21.5524 79.4018C22.6775 80.0616 22.9491 82.1961 22.9491 82.1961V82.2349Z" fill="#F391BC"/><path d="M46.9652 125.74C54.7862 125.74 61.1265 122.56 61.1265 118.638C61.1265 114.715 54.7862 111.536 46.9652 111.536C39.1441 111.536 32.8038 114.715 32.8038 118.638C32.8038 122.56 39.1441 125.74 46.9652 125.74Z" fill="#F391BC"/><path d="M167.783 125.74C175.604 125.74 181.944 122.56 181.944 118.638C181.944 114.715 175.604 111.536 167.783 111.536C159.961 111.536 153.621 114.715 153.621 118.638C153.621 122.56 159.961 125.74 167.783 125.74Z" fill="#F391BC"/><path d="M137.675 33.2966C138.956 23.866 155.91 30.2695 155.716 37.6433C154.824 41.7958 149.159 39.5837 146.482 38.4582C143.495 37.2552 138.878 37.3328 137.792 33.8788L137.714 33.2966H137.675Z" fill="#231F20"/><path d="M79.0124 32.8309C77.3829 23.4779 60.6997 30.4248 61.1653 37.7985C62.2128 41.9123 67.761 39.5061 70.438 38.2642C73.3867 36.9835 78.0037 36.8671 78.9736 33.4131L79.0512 32.8309H79.0124Z" fill="#231F20"/><path d="M162.04 119.569C162.04 119.569 162.04 119.569 162.04 119.53C160.644 114.912 157.811 112.816 155.639 111.846C150.75 109.673 143.922 110.721 134.765 115.067C121.69 121.277 108.305 121.393 107.956 121.393C107.839 121.393 94.4541 121.277 81.3791 115.067C72.2228 110.721 65.3943 109.634 60.5057 111.846C58.3718 112.816 55.5008 114.912 54.104 119.53C54.104 119.53 54.104 119.53 54.104 119.569C52.5133 124.925 49.6422 143.32 79.2452 154.963C94.8809 161.095 106.055 160.901 108.072 160.823C108.383 160.823 108.848 160.823 109.469 160.823C113.349 160.823 123.514 160.241 136.938 154.963C166.541 143.32 163.67 124.925 162.079 119.569H162.04Z" fill="#231F20"/><path d="M77.8485 68.5343C62.9888 67.7193 58.2166 88.715 65.1615 99.8144C70.632 106.373 84.5218 107.305 88.4016 100.086C93.2125 89.4912 92.8245 69.6209 78.4692 68.5343H77.8485Z" fill="#231F20"/><path d="M153.97 83.9037C154.048 76.724 148.849 68.9234 141.633 68.5741C127.122 67.0993 122.544 84.7187 126.23 96.5554C128.946 104.278 140.197 106.956 147.142 103.852C153.388 101.989 154.164 88.7548 154.009 84.3694V83.8649L153.97 83.9037Z" fill="#231F20"/><path d="M79.09 80.2556C79.2452 77.4614 77.4993 74.7059 74.8222 73.9298C70.3992 72.3386 66.597 79.6735 67.179 84.4082C68.9637 92.791 79.09 87.4353 79.0512 80.8766V80.2556H79.09Z" fill="white"/><path d="M85.4529 93.994C84.2502 89.6086 77.6545 90.6565 77.4217 95.0807C76.7233 102.183 86.6944 100.863 85.5693 94.4598L85.4529 93.994Z" fill="white"/><path d="M87.7808 86.4651C87.2376 84.7963 84.5993 84.1365 83.6682 85.9218C82.6982 87.5517 84.4442 89.6862 85.6469 89.5698C86.8884 89.5698 88.1688 87.9786 87.8972 86.8532L87.7808 86.4651Z" fill="white"/><path d="M148.345 93.994C147.142 89.6086 140.546 90.6565 140.313 95.0807C139.615 102.183 149.586 100.863 148.461 94.4598L148.345 93.994Z" fill="white"/><path d="M150.673 86.4651C150.129 84.7963 147.491 84.1365 146.56 85.9218C145.59 87.5517 147.336 89.6862 148.539 89.5698C149.78 89.5698 151.061 87.9786 150.789 86.8532L150.673 86.4651Z" fill="white"/><path d="M142.059 80.4109C142.215 77.6166 140.469 74.8612 137.792 74.085C133.369 72.4938 129.566 79.8287 130.148 84.5634C131.933 92.9462 142.059 87.5905 142.021 81.0318V80.4109H142.059Z" fill="white"/><path d="M156.066 128.03C151.293 131.639 145.28 134.705 143.65 135.559C143.146 135.791 142.641 135.908 142.137 135.908C140.895 135.908 139.693 135.209 139.111 134.045C138.257 132.376 138.956 130.319 140.624 129.504C146.133 126.749 152.574 122.713 154.979 120.113C154.32 118.832 153.505 118.327 152.884 118.056C151.255 117.318 147.064 116.736 137.675 121.199C123.165 128.107 108.771 128.185 108.189 128.185C107.335 128.185 92.9409 128.107 78.4304 121.199C69.0413 116.736 64.8899 117.318 63.2216 118.056C62.6008 118.327 61.786 118.832 61.1265 120.113C63.532 122.713 69.9725 126.749 75.4818 129.504C77.1501 130.358 77.8485 132.376 76.9949 134.045C76.4129 135.248 75.2102 135.908 73.9687 135.908C73.4643 135.908 72.9599 135.791 72.4555 135.559C70.826 134.744 64.8123 131.639 60.0401 128.03C60.7773 134.084 65.3167 142.234 81.6895 148.676C95.7344 154.187 105.822 154.109 107.607 154.071C107.723 154.071 107.878 154.071 107.995 154.071H108.111C108.111 154.071 108.383 154.071 108.499 154.071C110.284 154.071 120.371 154.226 134.416 148.676C150.789 142.234 155.328 134.084 156.066 128.03Z" fill="white"/></svg>`,
      5: `<svg xmlns="http://www.w3.org/2000/svg" width="215" height="207" viewBox="0 0 215 207" fill="none">
          <path d="M185.662 68.6458L152.448 61.1561C146.948 59.9196 142.188 56.4574 139.297 51.5821L121.914 22.2239C113.981 8.79901 94.5883 8.79901 86.6198 22.2239L69.2371 51.5821C66.3459 56.4574 61.586 59.9196 56.0856 61.1561L22.8717 68.6458C7.67516 72.0727 1.68115 90.5496 11.9767 102.279L34.4719 127.892C38.2093 132.131 40.0075 137.749 39.4787 143.366L36.3054 177.352C34.8598 192.897 50.5499 204.308 64.865 198.125L96.1397 184.63C101.323 182.404 107.211 182.404 112.394 184.63L143.669 198.125C157.984 204.308 173.674 192.897 172.228 177.352L169.055 143.366C168.526 137.749 170.36 132.131 174.062 127.892L196.557 102.279C206.853 90.5496 200.859 72.0727 185.662 68.6458Z" fill="#231F20"/>
          <path d="M47.4822 218.651C47.1296 218.651 46.8123 218.581 46.4949 218.404C45.7193 218.016 45.2256 217.168 45.2962 216.284L47.2706 189.011L27.5962 191.908C26.7852 192.049 25.9743 191.696 25.5159 191.024C25.0576 190.353 24.9518 189.505 25.3044 188.763L37.927 159.829L30.7342 161.278C29.9233 161.454 29.1123 161.136 28.5834 160.5C28.0546 159.865 27.9488 158.981 28.2661 158.239L36.6577 141.458L29.0065 141.67C28.1956 141.67 27.4552 141.282 27.0673 140.61C26.6442 139.939 26.6442 139.056 27.0673 138.385L33.5902 127.044L8.27433 112.948C7.63968 112.595 7.21657 111.924 7.14605 111.182C7.07553 110.44 7.39286 109.733 7.99226 109.274L13.7747 104.752L2.3861 98.8166C1.61041 98.4633 1.11678 97.6507 1.11678 96.8028C1.11678 95.9549 1.61041 95.1777 2.3861 94.8244L16.7012 87.6174L0.728937 73.2033C0.0942774 72.6027 -0.152535 71.7195 0.0942775 70.8716C0.376348 70.0237 1.11678 69.4584 1.963 69.3524L30.3111 66.4202L28.8655 56.1748C28.7597 55.4683 29.0065 54.7617 29.5354 54.2671C30.0643 53.7725 30.7695 53.5605 31.4747 53.7018L56.2617 58.5065L56.4027 48.7911C56.4027 47.9079 56.9668 47.1307 57.7778 46.7774C58.5887 46.4241 59.5407 46.6361 60.1401 47.2367L66.7335 53.7018L69.2017 29.6783C69.3074 28.9011 69.8011 28.2652 70.5062 27.9472C71.2114 27.6293 72.0224 27.6999 72.657 28.1592L79.9204 33.2818L92.8956 1.41536C93.213 0.602801 93.9534 0.0728706 94.7996 0.00221318C95.6458 -0.0331155 96.4568 0.3555 96.8799 1.0974L115.003 33.0699L126.356 14.7343C126.815 13.9924 127.696 13.5684 128.578 13.7097C129.459 13.8511 130.164 14.487 130.376 15.3349L141.059 53.3132L147.617 51.2641C148.217 51.0875 148.887 51.1582 149.416 51.4761C149.944 51.7941 150.332 52.3593 150.438 52.9599L151.672 59.637L182.065 61.0855C182.735 61.0855 183.37 61.4388 183.793 61.9687C184.216 62.4987 184.322 63.2052 184.146 63.8765L182.03 71.6135L212.353 73.5919C213.234 73.6625 214.01 74.2631 214.292 75.111C214.574 75.9589 214.292 76.9128 213.587 77.478L188.412 98.3926L204.243 104.434C205.16 104.787 205.724 105.67 205.654 106.66C205.583 107.649 204.913 108.426 203.961 108.673L179.703 114.361L188.906 126.02C189.505 126.762 189.54 127.786 189.047 128.563C188.553 129.341 187.601 129.729 186.684 129.517L168.138 125.101L180.091 139.974C180.479 140.434 180.62 141.034 180.549 141.635C180.479 142.236 180.161 142.765 179.703 143.119L172.193 148.807L184.78 185.266C185.062 186.043 184.851 186.891 184.287 187.492C183.722 188.092 182.876 188.339 182.065 188.092L165.635 183.358L176.001 205.262C176.424 206.145 176.212 207.205 175.472 207.841C174.731 208.477 173.674 208.583 172.863 208.088L145.396 192.791L144.021 202.683C143.915 203.425 143.422 204.096 142.752 204.379C142.046 204.697 141.271 204.626 140.636 204.202L115.708 186.326L112.711 192.402C112.359 193.109 111.689 193.568 110.913 193.639C110.137 193.709 109.397 193.356 108.938 192.72L101.464 183.005L88.2062 199.574C87.7831 200.139 87.2895 200.528 86.408 200.457C85.7028 200.457 85.0329 200.104 84.645 199.539L79.4267 192.155L48.822 218.016C48.3989 218.369 47.9053 218.546 47.4117 218.546L47.4822 218.651ZM49.6682 184.206C50.2324 184.206 50.7613 184.418 51.1491 184.807C51.6427 185.266 51.8896 185.902 51.8543 186.573L50.0561 211.374L78.51 187.35C78.9684 186.962 79.603 186.785 80.2024 186.856C80.8018 186.926 81.366 187.28 81.7186 187.774L86.5843 194.663L99.8416 178.094C100.265 177.529 100.899 177.211 101.605 177.211C102.31 177.211 102.944 177.564 103.368 178.129L110.455 187.315L112.923 182.298C113.205 181.733 113.698 181.309 114.333 181.132C114.968 180.956 115.602 181.062 116.131 181.415L140.213 198.726L141.553 189.011C141.659 188.269 142.117 187.633 142.787 187.315C143.457 186.997 144.233 187.032 144.867 187.421L168.914 200.669L159.605 180.956C159.218 180.179 159.359 179.26 159.923 178.589C160.487 177.918 161.368 177.67 162.215 177.882L179.245 182.793L167.539 148.807C167.221 147.888 167.539 146.899 168.279 146.334L175.26 141.034L160.698 122.911C160.099 122.169 160.064 121.144 160.557 120.332C161.051 119.519 162.003 119.166 162.92 119.378L181.536 123.829L174.132 114.432C173.674 113.831 173.533 113.054 173.779 112.347C174.026 111.641 174.626 111.111 175.366 110.934L195.993 106.094L183.37 101.254C182.629 100.972 182.101 100.336 181.995 99.5585C181.854 98.7812 182.171 98.004 182.77 97.5094L206.605 77.7253L179.104 75.9236C178.434 75.8882 177.834 75.535 177.446 75.005C177.059 74.4751 176.953 73.7685 177.129 73.1326L179.209 65.5016L149.839 64.0885C148.781 64.0885 147.899 63.3112 147.723 62.2867L146.63 56.2808L140.213 58.2946C139.614 58.4712 139.014 58.4005 138.485 58.1179C137.956 57.8353 137.569 57.3054 137.428 56.7401L127.449 21.5527L116.907 38.6165C116.484 39.2877 115.708 39.6763 115.003 39.6763C114.227 39.6763 113.522 39.2524 113.134 38.5458L95.4695 7.38591L83.1994 37.5566C82.9526 38.1925 82.4237 38.6871 81.7891 38.8638C81.1544 39.0757 80.4492 38.9344 79.8851 38.5458L73.2917 33.8824L70.7178 58.6832C70.612 59.4957 70.0479 60.2023 69.2369 60.4849C68.4612 60.7676 67.5798 60.5556 66.9804 59.9903L60.8806 54.0198L60.7748 61.2268C60.7748 61.8981 60.4575 62.4987 59.9638 62.9226C59.4702 63.3466 58.8003 63.4879 58.1656 63.3819L33.837 58.6832L35.1768 68.1513C35.2474 68.7519 35.1063 69.3524 34.7185 69.8117C34.3306 70.271 33.8018 70.5889 33.2024 70.6596L7.49864 73.3092L22.2368 86.5928C22.801 87.0874 23.0478 87.8293 22.942 88.5712C22.8362 89.3131 22.3779 89.9491 21.708 90.2317L8.59167 96.8735L18.993 102.349C19.6982 102.667 20.1566 103.339 20.2271 104.116C20.2976 104.858 19.9803 105.635 19.3809 106.094L13.4221 110.758L37.786 124.324C38.3149 124.607 38.6675 125.101 38.8438 125.666C39.0201 126.232 38.9143 126.832 38.6322 127.362L32.9555 137.219L40.1484 137.007C40.8888 136.972 41.6292 137.36 42.0523 137.996C42.4754 138.632 42.546 139.445 42.2286 140.116L34.1543 156.19L41.4882 154.707C42.2991 154.53 43.1454 154.848 43.6742 155.519C44.2031 156.19 44.2736 157.074 43.9211 157.815L31.1573 186.997L49.4567 184.277C49.4567 184.277 49.6682 184.277 49.774 184.277L49.6682 184.206Z" fill="white"/>
          <path d="M82.8118 112.277C79.4975 112.277 76.0774 111.676 72.9041 110.475C67.7563 108.532 63.9483 105.246 62.1501 101.254C58.2011 92.4574 61.0571 81.2228 68.6377 75.6409C75.619 70.5182 81.613 70.4476 85.4562 71.2955C90.0751 72.32 94.1299 75.3229 96.3865 79.3857C98.8193 83.7665 98.1847 90.8322 94.8703 96.2022C91.9439 100.936 87.5365 103.48 82.5297 103.233C77.1351 103.021 74.5612 100.371 73.3272 98.2159C70.6828 93.5172 72.1989 87.2287 73.7503 84.3318C75.3017 81.5055 78.3692 79.8803 81.6483 80.2336C84.7158 80.5516 87.1839 82.5653 88.0301 85.4269C88.8763 88.2886 87.607 91.3268 87.466 91.6801C86.9724 92.8106 85.6678 93.3052 84.5748 92.8106C83.4465 92.316 82.9529 91.0089 83.4465 89.9137C83.658 89.4544 84.1516 87.794 83.8343 86.6988C83.3407 84.9677 81.6835 84.685 81.1899 84.6144C80.0264 84.4731 78.475 84.897 77.6288 86.4515C76.43 88.6772 75.5837 93.2346 77.1704 96.0255C78.1576 97.7567 79.9558 98.6752 82.706 98.7812C87.0076 98.9578 89.652 96.2022 91.0976 93.8352C93.5305 89.8783 94.1652 84.4377 92.508 81.4701C90.8861 78.5378 87.8891 76.3121 84.5042 75.5702C80.3084 74.6517 75.7248 75.8882 71.2469 79.1738C65.3587 83.4839 63.1021 92.528 66.1696 99.3818C67.4742 102.314 70.436 104.752 74.4555 106.271C79.9558 108.355 86.373 108.285 91.2387 106.059C91.7676 105.812 92.2965 105.529 92.8253 105.211C93.8478 104.575 95.2229 104.893 95.8576 105.953C96.4923 107.013 96.1749 108.355 95.1172 108.991C94.4472 109.415 93.7773 109.768 93.0721 110.086C89.9694 111.5 86.4435 112.206 82.8118 112.206V112.277Z" fill="white"/>
          <path d="M137.111 117.611C136.088 117.611 135.101 117.541 134.078 117.399C128.049 116.481 123.254 112.559 121.315 106.907C119.34 101.184 120.609 94.9304 124.629 90.6556C128.014 87.0521 132.139 85.4976 136.229 86.3102C140.707 87.1934 143.845 90.5143 144.973 93.4112C146.313 96.8735 146.348 102.385 143.774 105.847C142.223 107.967 139.861 109.062 137.146 108.815C134.854 108.638 132.915 107.507 131.822 105.67C130.905 104.186 130.2 101.572 131.892 97.686C132.386 96.5555 133.69 96.0609 134.783 96.5555C135.912 97.0501 136.405 98.3573 135.912 99.4524C135.171 101.148 135.066 102.526 135.559 103.374C136.053 104.186 137.04 104.363 137.428 104.398C138.627 104.469 139.508 104.116 140.213 103.197C141.694 101.184 141.729 97.3327 140.813 94.9657C140.143 93.1993 138.027 91.1149 135.348 90.5849C132.738 90.055 130.165 91.1149 127.802 93.6232C124.911 96.6968 123.994 101.219 125.44 105.388C126.885 109.521 130.235 112.277 134.713 112.948C138.803 113.584 142.893 112.559 146.137 110.122C149.24 107.79 151.39 104.292 151.884 100.795C152.624 95.425 151.073 90.0197 147.653 86.0275C144.585 82.4593 140.354 80.4809 135.735 80.4456C126.956 80.3749 121.773 87.4054 121.738 87.476C120.997 88.4652 119.622 88.6419 118.67 87.9353C117.683 87.2287 117.471 85.8509 118.176 84.8617C118.459 84.5084 124.77 75.9942 135.594 75.9942H135.771C141.694 76.0295 147.089 78.5732 151.003 83.0953C155.269 88.0413 157.208 94.7184 156.291 101.36C155.621 106.094 152.906 110.581 148.816 113.619C145.432 116.163 141.377 117.505 137.146 117.505L137.111 117.611Z" fill="white"/>
          <path d="M119.657 125.419L114.439 164.987C121.068 165.058 127.167 164.422 132.315 163.185L136.3 132.944C131.681 130.082 126.039 127.503 119.657 125.454V125.419Z" fill="white"/>
          <path d="M104.778 121.745C101.675 121.215 98.6431 120.826 95.6813 120.579L90.2514 161.878C92.649 162.479 95.1172 163.009 97.6911 163.433C101.323 164.069 104.849 164.457 108.304 164.705L113.699 123.653C110.843 122.911 107.881 122.275 104.813 121.745H104.778Z" fill="white"/>
          <path d="M53.4764 134.393C52.595 139.551 56.1209 145.026 62.6437 149.902L66.1696 123.193C59.0473 125.631 54.3227 129.482 53.5117 134.393H53.4764Z" fill="white"/>
          <path d="M72.5867 121.498L68.3557 153.611C72.8688 156.155 78.2634 158.416 84.2222 160.253L89.511 120.226C83.3054 120.084 77.5935 120.508 72.5867 121.498Z" fill="white"/>
          <path d="M141.976 137.042L138.803 161.066C144.55 158.628 148.217 155.13 148.957 150.785C149.733 146.228 147.053 141.423 141.941 137.042H141.976Z" fill="white"/>
          </svg>`
    };
    const setMoodSvg = (turn) => {
      if (!moodEl) return;
      const svg = moodSvgs[Number(turn)];
      if (typeof svg === "string" && svg.length > 0) {
        moodEl.innerHTML = svg;
      }
    };
    const messagesScript = section.querySelector(".ds-taste-dial__step-messages");
    const headingEl = section.querySelector(".ds-taste-dial__content-heading");
    const labelEl = section.querySelector(".ds-taste-dial__content-label");
    const messageBoxEl = section.querySelector(".ds-taste-dial__content-message");
    const messageWrapperEl = section.querySelector(".ds-taste-dial__content-message-wrapper");
    if (messageWrapperEl) messageWrapperEl.style.opacity = "0";
    let stepMessages = null;
    if (messagesScript) {
      try {
        stepMessages = JSON.parse(messagesScript.textContent || "{}");
      } catch (e) {
        stepMessages = null;
      }
    }
    const layoutMessageBox = () => {
      if (!messageBoxEl || !messageWrapperEl) return;
      const wrapperWidth = messageWrapperEl.getBoundingClientRect().width;
      const target = Math.ceil(wrapperWidth + 80);
      messageBoxEl.style.width = `${target}px`;
    };
    let messageFadeTimeoutId = null;
    let messageFadeToken = 0;
    const setStepMessage = (turn) => {
      if (!stepMessages || !headingEl || !labelEl) return;
      const msg = stepMessages[String(turn)];
      if (!msg) return;
      const token = ++messageFadeToken;
      if (messageFadeTimeoutId) {
        window.clearTimeout(messageFadeTimeoutId);
        messageFadeTimeoutId = null;
      }
      const doSwap = () => {
        if (token !== messageFadeToken) return;
        headingEl.textContent = msg.heading || "";
        labelEl.textContent = msg.label || "";
        requestAnimationFrame(() => {
          if (token !== messageFadeToken) return;
          layoutMessageBox();
          messageWrapperEl.style.opacity = "1";
        });
      };
      if (messageWrapperEl) {
        messageWrapperEl.style.opacity = "0";
        const onEnd = (e) => {
          if (e.propertyName !== "opacity") return;
          messageWrapperEl.removeEventListener("transitionend", onEnd);
          doSwap();
        };
        messageWrapperEl.addEventListener("transitionend", onEnd);
        messageFadeTimeoutId = window.setTimeout(() => {
          messageWrapperEl.removeEventListener("transitionend", onEnd);
          doSwap();
        }, 170);
      } else {
        doSwap();
      }
    };
    let resizeRafId = null;
    const onResize2 = () => {
      if (resizeRafId) return;
      resizeRafId = requestAnimationFrame(() => {
        resizeRafId = null;
        layoutMessageBox();
      });
    };
    window.addEventListener("resize", onResize2, { passive: true });
    let turnAnimTimeoutId = null;
    const stopTurnAnimation = () => {
      inner.classList.remove("ds-taste-dial__inner--play-turn-animation");
      if (turnAnimTimeoutId) {
        window.clearTimeout(turnAnimTimeoutId);
        turnAnimTimeoutId = null;
      }
    };
    const scheduleTurnAnimation = () => {
      if (turnAnimTimeoutId) window.clearTimeout(turnAnimTimeoutId);
      turnAnimTimeoutId = window.setTimeout(() => {
        inner.classList.add("ds-taste-dial__inner--play-turn-animation");
      }, 2e3);
    };
    const applyTurn = (turn) => {
      const normalizedTurn = String(turn);
      const nextButton2 = buttons.find((btn) => btn.getAttribute("data-turn") === normalizedTurn);
      if (!nextButton2) return;
      const computed2 = getComputedStyle(turnImage).transform;
      turnImage.style.transform = computed2;
      stopTurnAnimation();
      inner.setAttribute("data-active-turn", normalizedTurn);
      setActiveButton(nextButton2);
      setActiveDot(normalizedTurn);
      setStepArrowsState(normalizedTurn);
      setMoodSvg(normalizedTurn);
      setStepMessage(normalizedTurn);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          turnImage.style.transform = "";
        });
      });
      scheduleTurnAnimation();
    };
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        applyTurn(button.getAttribute("data-turn"));
      });
    });
    paginationDots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const dotIndex = Number(dot.getAttribute("data-dot-index"));
        if (!Number.isNaN(dotIndex)) {
          applyTurn(dotIndex + 1);
        }
      });
    });
    stepArrows.forEach((arrow) => {
      arrow.addEventListener("click", () => {
        const direction = Number(arrow.getAttribute("data-step-direction"));
        if (Number.isNaN(direction) || direction === 0) return;
        const currentTurn = Number(inner.getAttribute("data-active-turn") || 1);
        const nextTurn = Math.min(5, Math.max(1, currentTurn + direction));
        if (nextTurn !== currentTurn) applyTurn(nextTurn);
      });
    });
    const isMobileViewport = () => window.matchMedia("(max-width: 767px)").matches;
    const swipeTarget = section.querySelector(".ds-taste-dial__image");
    if (swipeTarget) {
      let startX = 0;
      let startY = 0;
      const MIN_SWIPE_DISTANCE = 35;
      const MAX_VERTICAL_DRIFT = 70;
      swipeTarget.addEventListener("touchstart", (event) => {
        if (!isMobileViewport()) return;
        if (event.target.closest(".ds-taste-dial__turn-button")) return;
        const touch = event.touches[0];
        if (!touch) return;
        startX = touch.clientX;
        startY = touch.clientY;
      }, { passive: true });
      swipeTarget.addEventListener("touchend", (event) => {
        if (!isMobileViewport()) return;
        if (event.target.closest(".ds-taste-dial__turn-button")) return;
        const touch = event.changedTouches[0];
        if (!touch) return;
        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        if (absX < MIN_SWIPE_DISTANCE || absY > MAX_VERTICAL_DRIFT || absX <= absY) return;
        const currentTurn = Number(inner.getAttribute("data-active-turn") || 1);
        const direction = deltaX < 0 ? 1 : -1;
        const nextTurn = Math.min(5, Math.max(1, currentTurn + direction));
        if (nextTurn !== currentTurn) applyTurn(nextTurn);
      }, { passive: true });
    }
    const defaultButton = buttons.find((b3) => b3.getAttribute("data-turn") === "1") || buttons[0];
    if (defaultButton) {
      applyTurn(defaultButton.getAttribute("data-turn"));
    }
    stopTurnAnimation();
    scheduleTurnAnimation();
  });
}
initDsTasteDial();
var x4 = Object.defineProperty, R4 = Object.defineProperties;
var j4 = Object.getOwnPropertyDescriptors;
var N1 = Object.getOwnPropertySymbols;
var $3 = Object.prototype.hasOwnProperty, W3 = Object.prototype.propertyIsEnumerable;
var _2 = (v, r, a) => r in v ? x4(v, r, { enumerable: true, configurable: true, writable: true, value: a }) : v[r] = a, D = (v, r) => {
  for (var a in r || (r = {})) $3.call(r, a) && _2(v, a, r[a]);
  if (N1) for (var a of N1(r)) W3.call(r, a) && _2(v, a, r[a]);
  return v;
}, z = (v, r) => R4(v, j4(r));
var V1 = (v, r) => {
  var a = {};
  for (var h2 in v) $3.call(v, h2) && r.indexOf(h2) < 0 && (a[h2] = v[h2]);
  if (v != null && N1) for (var h2 of N1(v)) r.indexOf(h2) < 0 && W3.call(v, h2) && (a[h2] = v[h2]);
  return a;
};
var b = (v, r, a) => _2(v, typeof r != "symbol" ? r + "" : r, a);
var E = (v, r, a) => new Promise((h2, d) => {
  var g = (j) => {
    try {
      R(a.next(j));
    } catch ($) {
      d($);
    }
  }, T = (j) => {
    try {
      R(a.throw(j));
    } catch ($) {
      d($);
    }
  }, R = (j) => j.done ? h2(j.value) : Promise.resolve(j.value).then(g, T);
  R((a = a.apply(v, r)).next());
});
var y2 = class {
  requestAnimationFrame(r) {
    return requestAnimationFrame(r);
  }
  cancelAnimationFrame(r) {
    cancelAnimationFrame(r);
  }
}, g2 = class {
  constructor() {
    b(this, "_lastHandleId", 0);
    b(this, "_lastImmediate", null);
  }
  requestAnimationFrame(r) {
    return this._lastHandleId >= Number.MAX_SAFE_INTEGER && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(() => {
      r(Date.now());
    }), this._lastHandleId;
  }
  cancelAnimationFrame(r) {
    this._lastImmediate && clearImmediate(this._lastImmediate);
  }
}, q1 = class {
  constructor() {
    b(this, "_strategy");
    this._strategy = typeof requestAnimationFrame == "function" ? new y2() : new g2();
  }
  requestAnimationFrame(r) {
    return this._strategy.requestAnimationFrame(r);
  }
  cancelAnimationFrame(r) {
    this._strategy.cancelAnimationFrame(r);
  }
};
var O = typeof window != "undefined" && typeof window.document != "undefined";
var J1 = new Uint8Array([80, 75, 3, 4]), z3 = ["v", "ip", "op", "layers", "fr", "w", "h"], w2 = "0.44.0", C2 = "@lottiefiles/dotlottie-web", U3 = 0.75;
var A4 = (() => {
  var r;
  var v = typeof document != "undefined" ? (r = document.currentScript) == null ? void 0 : r.src : void 0;
  return function(a = {}) {
    var h2, d = a, g, T, R = new Promise((t, e) => {
      g = t, T = e;
    }), j = Object.assign({}, d), $ = "./this.program", U = "", l1;
    typeof document != "undefined" && document.currentScript && (U = document.currentScript.src), v && (U = v), U.startsWith("blob:") ? U = "" : U = U.substr(0, U.replace(/[?#].*/, "").lastIndexOf("/") + 1), l1 = (t) => fetch(t, { credentials: "same-origin" }).then((e) => e.ok ? e.arrayBuffer() : Promise.reject(Error(e.status + " : " + e.url)));
    var T1 = d.print || console.log.bind(console), K = d.printErr || console.error.bind(console);
    Object.assign(d, j), j = null, d.thisProgram && ($ = d.thisProgram);
    var F1 = d.wasmBinary, x1, R1 = false, K1, X, k, a1, f1, t1, F, S2, T2;
    function F2() {
      var t = x1.buffer;
      d.HEAP8 = X = new Int8Array(t), d.HEAP16 = a1 = new Int16Array(t), d.HEAPU8 = k = new Uint8Array(t), d.HEAPU16 = f1 = new Uint16Array(t), d.HEAP32 = t1 = new Int32Array(t), d.HEAPU32 = F = new Uint32Array(t), d.HEAPF32 = S2 = new Float32Array(t), d.HEAPF64 = T2 = new Float64Array(t);
    }
    var x22 = [], R2 = [], j2 = [];
    function K3() {
      var t = d.preRun.shift();
      x22.unshift(t);
    }
    var n1 = 0, p1 = null;
    function j1(t) {
      var e;
      throw (e = d.onAbort) == null || e.call(d, t), t = "Aborted(" + t + ")", K(t), R1 = true, t = new WebAssembly.RuntimeError(t + ". Build with -sASSERTIONS for more info."), T(t), t;
    }
    var A2 = (t) => t.startsWith("data:application/octet-stream;base64,"), v1;
    function k2(t) {
      if (t == v1 && F1) return new Uint8Array(F1);
      throw "both async and sync fetching of the wasm failed";
    }
    function X3(t) {
      return F1 ? Promise.resolve().then(() => k2(t)) : l1(t).then((e) => new Uint8Array(e), () => k2(t));
    }
    function D2(t, e, n) {
      return X3(t).then((i) => WebAssembly.instantiate(i, e)).then(n, (i) => {
        K(`failed to asynchronously prepare wasm: ${i}`), j1(i);
      });
    }
    function Z3(t, e) {
      var n = v1;
      return F1 || typeof WebAssembly.instantiateStreaming != "function" || A2(n) || typeof fetch != "function" ? D2(n, t, e) : fetch(n, { credentials: "same-origin" }).then((i) => WebAssembly.instantiateStreaming(i, t).then(e, function(o) {
        return K(`wasm streaming compile failed: ${o}`), K("falling back to ArrayBuffer instantiation"), D2(n, t, e);
      }));
    }
    class O2 {
      constructor(e) {
        b(this, "name", "ExitStatus");
        this.message = `Program terminated with exit(${e})`, this.status = e;
      }
    }
    var Z1 = (t) => {
      for (; 0 < t.length; ) t.shift()(d);
    }, Q1 = d.noExitRuntime || true, $2 = typeof TextDecoder != "undefined" ? new TextDecoder() : void 0, m1 = (t, e = 0, n = NaN) => {
      var i = e + n;
      for (n = e; t[n] && !(n >= i); ) ++n;
      if (16 < n - e && t.buffer && $2) return $2.decode(t.subarray(e, n));
      for (i = ""; e < n; ) {
        var o = t[e++];
        if (o & 128) {
          var s = t[e++] & 63;
          if ((o & 224) == 192) i += String.fromCharCode((o & 31) << 6 | s);
          else {
            var u = t[e++] & 63;
            o = (o & 240) == 224 ? (o & 15) << 12 | s << 6 | u : (o & 7) << 18 | s << 12 | u << 6 | t[e++] & 63, 65536 > o ? i += String.fromCharCode(o) : (o -= 65536, i += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023));
          }
        } else i += String.fromCharCode(o);
      }
      return i;
    }, W2 = [], z2 = 0, s1 = 0;
    class e2 {
      constructor(e) {
        this.Fc = e, this.dc = e - 24;
      }
    }
    var U2 = (t) => {
      var e = s1;
      if (!e) return P1(0), 0;
      var n = new e2(e);
      F[n.dc + 16 >> 2] = e;
      var i = F[n.dc + 4 >> 2];
      if (!i) return P1(0), e;
      for (var o of t) {
        if (o === 0 || o === i) break;
        if (u3(o, i, n.dc + 16)) return P1(o), e;
      }
      return P1(i), e;
    }, _1 = (t, e, n) => {
      var i = k;
      if (0 < n) {
        n = e + n - 1;
        for (var o = 0; o < t.length; ++o) {
          var s = t.charCodeAt(o);
          if (55296 <= s && 57343 >= s) {
            var u = t.charCodeAt(++o);
            s = 65536 + ((s & 1023) << 10) | u & 1023;
          }
          if (127 >= s) {
            if (e >= n) break;
            i[e++] = s;
          } else {
            if (2047 >= s) {
              if (e + 1 >= n) break;
              i[e++] = 192 | s >> 6;
            } else {
              if (65535 >= s) {
                if (e + 2 >= n) break;
                i[e++] = 224 | s >> 12;
              } else {
                if (e + 3 >= n) break;
                i[e++] = 240 | s >> 18, i[e++] = 128 | s >> 12 & 63;
              }
              i[e++] = 128 | s >> 6 & 63;
            }
            i[e++] = 128 | s & 63;
          }
        }
        i[e] = 0;
      }
    }, r1 = (t, e) => Object.defineProperty(e, "name", { value: t }), t2 = [], Z = [], M, Q3 = (t) => {
      throw new M(t);
    }, c1 = (t) => {
      if (!t) throw new M("Cannot use deleted val. handle = " + t);
      return Z[t];
    }, y1 = (t) => {
      switch (t) {
        case void 0:
          return 2;
        case null:
          return 4;
        case true:
          return 6;
        case false:
          return 8;
        default:
          let e = t2.pop() || Z.length;
          return Z[e] = t, Z[e + 1] = 1, e;
      }
    }, B2 = (t) => {
      var e = Error, n = r1(t, function(i) {
        this.name = t, this.message = i, i = Error(i).stack, i !== void 0 && (this.stack = this.toString() + `
` + i.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return n.prototype = Object.create(e.prototype), n.prototype.constructor = n, n.prototype.toString = function() {
        return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
      }, n;
    }, H2, N2, A = (t) => {
      for (var e = ""; k[t]; ) e += N2[k[t++]];
      return e;
    }, g1 = {}, n2 = (t, e) => {
      if (e === void 0) throw new M("ptr should not be undefined");
      for (; t.ic; ) e = t.tc(e), t = t.ic;
      return e;
    }, i1 = {}, V2 = (t) => {
      t = a3(t);
      var e = A(t);
      return Q(t), e;
    }, w1 = (t, e) => {
      var n = i1[t];
      if (n === void 0) throw t = `${e} has unknown type ${V2(t)}`, new M(t);
      return n;
    }, A1 = () => {
    }, r2 = false, q2 = (t, e, n) => e === n ? t : n.ic === void 0 ? null : (t = q2(t, e, n.ic), t === null ? null : n.Ec(t)), J2 = {}, e0 = (t, e) => (e = n2(t, e), g1[e]), C1, k1 = (t, e) => {
      if (!e.fc || !e.dc) throw new C1("makeClassHandle requires ptr and ptrType");
      if (!!e.lc != !!e.jc) throw new C1("Both smartPtrType and smartPtr must be specified");
      return e.count = { value: 1 }, d1(Object.create(t, { cc: { value: e, writable: true } }));
    }, d1 = (t) => typeof FinalizationRegistry == "undefined" ? (d1 = (e) => e, t) : (r2 = new FinalizationRegistry((e) => {
      e = e.cc, --e.count.value, e.count.value === 0 && (e.jc ? e.lc.nc(e.jc) : e.fc.ec.nc(e.dc));
    }), d1 = (e) => {
      var n = e.cc;
      return n.jc && r2.register(e, { cc: n }, e), e;
    }, A1 = (e) => {
      r2.unregister(e);
    }, d1(t)), D1 = {}, i2 = (t) => {
      for (; t.length; ) {
        var e = t.pop();
        t.pop()(e);
      }
    };
    function b1(t) {
      return this.fromWireType(F[t >> 2]);
    }
    var u1 = {}, O1 = {}, G = (t, e, n) => {
      function i(c) {
        if (c = n(c), c.length !== t.length) throw new C1("Mismatched type converter count");
        for (var l = 0; l < t.length; ++l) J(t[l], c[l]);
      }
      t.forEach((c) => O1[c] = e);
      var o = Array(e.length), s = [], u = 0;
      e.forEach((c, l) => {
        i1.hasOwnProperty(c) ? o[l] = i1[c] : (s.push(c), u1.hasOwnProperty(c) || (u1[c] = []), u1[c].push(() => {
          o[l] = i1[c], ++u, u === s.length && i(o);
        }));
      }), s.length === 0 && i(o);
    };
    function t0(t, e, n = {}) {
      var i = e.name;
      if (!t) throw new M(`type "${i}" must have a positive integer typeid pointer`);
      if (i1.hasOwnProperty(t)) {
        if (n.Mc) return;
        throw new M(`Cannot register type '${i}' twice`);
      }
      i1[t] = e, delete O1[t], u1.hasOwnProperty(t) && (e = u1[t], delete u1[t], e.forEach((o) => o()));
    }
    function J(t, e, n = {}) {
      return t0(t, e, n);
    }
    var o2 = (t) => {
      throw new M(t.cc.fc.ec.name + " instance already deleted");
    };
    function $1() {
    }
    var a2 = (t, e, n) => {
      if (t[e].hc === void 0) {
        var i = t[e];
        t[e] = function(...o) {
          if (!t[e].hc.hasOwnProperty(o.length)) throw new M(`Function '${n}' called with an invalid number of arguments (${o.length}) - expects one of (${t[e].hc})!`);
          return t[e].hc[o.length].apply(this, o);
        }, t[e].hc = [], t[e].hc[i.pc] = i;
      }
    }, s2 = (t, e, n) => {
      if (d.hasOwnProperty(t)) {
        if (n === void 0 || d[t].hc !== void 0 && d[t].hc[n] !== void 0) throw new M(`Cannot register public name '${t}' twice`);
        if (a2(d, t, t), d[t].hc.hasOwnProperty(n)) throw new M(`Cannot register multiple overloads of a function with the same number of arguments (${n})!`);
        d[t].hc[n] = e;
      } else d[t] = e, d[t].pc = n;
    }, r0 = (t) => {
      t = t.replace(/[^a-zA-Z0-9_]/g, "$");
      var e = t.charCodeAt(0);
      return 48 <= e && 57 >= e ? `_${t}` : t;
    };
    function i0(t, e, n, i, o, s, u, c) {
      this.name = t, this.constructor = e, this.oc = n, this.nc = i, this.ic = o, this.Hc = s, this.tc = u, this.Ec = c, this.Bc = [];
    }
    var c2 = (t, e, n) => {
      for (; e !== n; ) {
        if (!e.tc) throw new M(`Expected null or instance of ${n.name}, got an instance of ${e.name}`);
        t = e.tc(t), e = e.ic;
      }
      return t;
    };
    function o0(t, e) {
      if (e === null) {
        if (this.xc) throw new M(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!e.cc) throw new M(`Cannot pass "${h22(e)}" as a ${this.name}`);
      if (!e.cc.dc) throw new M(`Cannot pass deleted object as a pointer of type ${this.name}`);
      return c2(e.cc.dc, e.cc.fc.ec, this.ec);
    }
    function a0(t, e) {
      if (e === null) {
        if (this.xc) throw new M(`null is not a valid ${this.name}`);
        if (this.wc) {
          var n = this.yc();
          return t !== null && t.push(this.nc, n), n;
        }
        return 0;
      }
      if (!e || !e.cc) throw new M(`Cannot pass "${h22(e)}" as a ${this.name}`);
      if (!e.cc.dc) throw new M(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (!this.vc && e.cc.fc.vc) throw new M(`Cannot convert argument of type ${e.cc.lc ? e.cc.lc.name : e.cc.fc.name} to parameter type ${this.name}`);
      if (n = c2(e.cc.dc, e.cc.fc.ec, this.ec), this.wc) {
        if (e.cc.jc === void 0) throw new M("Passing raw pointer to smart pointer is illegal");
        switch (this.Tc) {
          case 0:
            if (e.cc.lc === this) n = e.cc.jc;
            else throw new M(`Cannot convert argument of type ${e.cc.lc ? e.cc.lc.name : e.cc.fc.name} to parameter type ${this.name}`);
            break;
          case 1:
            n = e.cc.jc;
            break;
          case 2:
            if (e.cc.lc === this) n = e.cc.jc;
            else {
              var i = e.clone();
              n = this.Pc(n, y1(() => i.delete())), t !== null && t.push(this.nc, n);
            }
            break;
          default:
            throw new M("Unsupporting sharing policy");
        }
      }
      return n;
    }
    function s0(t, e) {
      if (e === null) {
        if (this.xc) throw new M(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!e.cc) throw new M(`Cannot pass "${h22(e)}" as a ${this.name}`);
      if (!e.cc.dc) throw new M(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (e.cc.fc.vc) throw new M(`Cannot convert argument of type ${e.cc.fc.name} to parameter type ${this.name}`);
      return c2(e.cc.dc, e.cc.fc.ec, this.ec);
    }
    function L1(t, e, n, i, o, s, u, c, l, f, p5) {
      this.name = t, this.ec = e, this.xc = n, this.vc = i, this.wc = o, this.Oc = s, this.Tc = u, this.Cc = c, this.yc = l, this.Pc = f, this.nc = p5, o || e.ic !== void 0 ? this.toWireType = a0 : (this.toWireType = i ? o0 : s0, this.kc = null);
    }
    var G2 = (t, e, n) => {
      if (!d.hasOwnProperty(t)) throw new C1("Replacing nonexistent public symbol");
      d[t].hc !== void 0 && n !== void 0 ? d[t].hc[n] = e : (d[t] = e, d[t].pc = n);
    }, P, c0 = (t, e, n = []) => (t.includes("j") ? (t = t.replace(/p/g, "i"), e = (0, d["dynCall_" + t])(e, ...n)) : e = P.get(e)(...n), e), d0 = (t, e) => (...n) => c0(t, e, n), W = (t, e) => {
      t = A(t);
      var n = t.includes("j") ? d0(t, e) : P.get(e);
      if (typeof n != "function") throw new M(`unknown function pointer with signature ${t}: ${e}`);
      return n;
    }, Y22, M1 = (t, e) => {
      function n(s) {
        o[s] || i1[s] || (O1[s] ? O1[s].forEach(n) : (i.push(s), o[s] = true));
      }
      var i = [], o = {};
      throw e.forEach(n), new Y22(`${t}: ` + i.map(V2).join([", "]));
    };
    function K2(t) {
      for (var e = 1; e < t.length; ++e) if (t[e] !== null && t[e].kc === void 0) return true;
      return false;
    }
    function X2(t) {
      var e = Function;
      if (!(e instanceof Function)) throw new TypeError(`new_ called with constructor type ${typeof e} which is not a function`);
      var n = r1(e.name || "unknownFunctionName", function() {
      });
      return n.prototype = e.prototype, n = new n(), t = e.apply(n, t), t instanceof Object ? t : n;
    }
    function W1(t, e, n, i, o, s) {
      var u = e.length;
      if (2 > u) throw new M("argTypes array size mismatch! Must at least get return value and 'this' types!");
      var c = e[1] !== null && n !== null, l = K2(e);
      for (n = e[0].name !== "void", i = [t, Q3, i, o, i2, e[0], e[1]], o = 0; o < u - 2; ++o) i.push(e[o + 2]);
      if (!l) for (o = c ? 1 : 2; o < e.length; ++o) e[o].kc !== null && i.push(e[o].kc);
      l = K2(e), o = e.length - 2;
      var f = [], p5 = ["fn"];
      for (c && p5.push("thisWired"), u = 0; u < o; ++u) f.push(`arg${u}`), p5.push(`arg${u}Wired`);
      f = f.join(","), p5 = p5.join(","), f = `return function (${f}) {
`, l && (f += `var destructors = [];
`);
      var C = l ? "destructors" : "null", L = "humanName throwBindingError invoker fn runDestructors retType classParam".split(" ");
      for (c && (f += `var thisWired = classParam['toWireType'](${C}, this);
`), u = 0; u < o; ++u) f += `var arg${u}Wired = argType${u}['toWireType'](${C}, arg${u});
`, L.push(`argType${u}`);
      if (f += (n || s ? "var rv = " : "") + `invoker(${p5});
`, l) f += `runDestructors(destructors);
`;
      else for (u = c ? 1 : 2; u < e.length; ++u) s = u === 1 ? "thisWired" : "arg" + (u - 2) + "Wired", e[u].kc !== null && (f += `${s}_dtor(${s});
`, L.push(`${s}_dtor`));
      n && (f += `var ret = retType['fromWireType'](rv);
return ret;
`);
      let [I, S] = [L, f + `}
`];
      return I.push(S), e = X2(I)(...i), r1(t, e);
    }
    var z1 = (t, e) => {
      for (var n = [], i = 0; i < t; i++) n.push(F[e + 4 * i >> 2]);
      return n;
    }, d2 = (t) => {
      t = t.trim();
      let e = t.indexOf("(");
      return e !== -1 ? t.substr(0, e) : t;
    }, u2 = (t) => {
      9 < t && --Z[t + 1] === 0 && (Z[t] = void 0, t2.push(t));
    }, Z2 = { name: "emscripten::val", fromWireType: (t) => {
      var e = c1(t);
      return u2(t), e;
    }, toWireType: (t, e) => y1(e), mc: 8, readValueFromPointer: b1, kc: null }, u0 = (t, e, n) => {
      switch (e) {
        case 1:
          return n ? function(i) {
            return this.fromWireType(X[i]);
          } : function(i) {
            return this.fromWireType(k[i]);
          };
        case 2:
          return n ? function(i) {
            return this.fromWireType(a1[i >> 1]);
          } : function(i) {
            return this.fromWireType(f1[i >> 1]);
          };
        case 4:
          return n ? function(i) {
            return this.fromWireType(t1[i >> 2]);
          } : function(i) {
            return this.fromWireType(F[i >> 2]);
          };
        default:
          throw new TypeError(`invalid integer width (${e}): ${t}`);
      }
    }, h22 = (t) => {
      if (t === null) return "null";
      var e = typeof t;
      return e === "object" || e === "array" || e === "function" ? t.toString() : "" + t;
    }, h0 = (t, e) => {
      switch (e) {
        case 4:
          return function(n) {
            return this.fromWireType(S2[n >> 2]);
          };
        case 8:
          return function(n) {
            return this.fromWireType(T2[n >> 3]);
          };
        default:
          throw new TypeError(`invalid float width (${e}): ${t}`);
      }
    }, l0 = (t, e, n) => {
      switch (e) {
        case 1:
          return n ? (i) => X[i] : (i) => k[i];
        case 2:
          return n ? (i) => a1[i >> 1] : (i) => f1[i >> 1];
        case 4:
          return n ? (i) => t1[i >> 2] : (i) => F[i >> 2];
        default:
          throw new TypeError(`invalid integer width (${e}): ${t}`);
      }
    }, f0 = Object.assign({ optional: true }, Z2), Q2 = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0, p0 = (t, e) => {
      for (var n = t >> 1, i = n + e / 2; !(n >= i) && f1[n]; ) ++n;
      if (n <<= 1, 32 < n - t && Q2) return Q2.decode(k.subarray(t, n));
      for (n = "", i = 0; !(i >= e / 2); ++i) {
        var o = a1[t + 2 * i >> 1];
        if (o == 0) break;
        n += String.fromCharCode(o);
      }
      return n;
    }, v0 = (t, e, n) => {
      if (n != null || (n = 2147483647), 2 > n) return 0;
      n -= 2;
      var i = e;
      n = n < 2 * t.length ? n / 2 : t.length;
      for (var o = 0; o < n; ++o) a1[e >> 1] = t.charCodeAt(o), e += 2;
      return a1[e >> 1] = 0, e - i;
    }, m0 = (t) => 2 * t.length, _0 = (t, e) => {
      for (var n = 0, i = ""; !(n >= e / 4); ) {
        var o = t1[t + 4 * n >> 2];
        if (o == 0) break;
        ++n, 65536 <= o ? (o -= 65536, i += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023)) : i += String.fromCharCode(o);
      }
      return i;
    }, y0 = (t, e, n) => {
      if (n != null || (n = 2147483647), 4 > n) return 0;
      var i = e;
      n = i + n - 4;
      for (var o = 0; o < t.length; ++o) {
        var s = t.charCodeAt(o);
        if (55296 <= s && 57343 >= s) {
          var u = t.charCodeAt(++o);
          s = 65536 + ((s & 1023) << 10) | u & 1023;
        }
        if (t1[e >> 2] = s, e += 4, e + 4 > n) break;
      }
      return t1[e >> 2] = 0, e - i;
    }, g0 = (t) => {
      for (var e = 0, n = 0; n < t.length; ++n) {
        var i = t.charCodeAt(n);
        55296 <= i && 57343 >= i && ++n, e += 4;
      }
      return e;
    }, l2 = 0, e3 = (t, e, n) => {
      var i = [];
      return t = t.toWireType(i, n), i.length && (F[e >> 2] = y1(i)), t;
    }, U1 = [], w0 = {}, C0 = (t) => {
      var e = U1.length;
      return U1.push(t), e;
    }, b0 = (t, e) => {
      for (var n = Array(t), i = 0; i < t; ++i) n[i] = w1(F[e + 4 * i >> 2], "parameter " + i);
      return n;
    }, E1 = {}, t3 = (t) => {
      if (!(t instanceof O2 || t == "unwind")) throw t;
    }, n3 = (t) => {
      var e;
      throw K1 = t, Q1 || 0 < l2 || ((e = d.onExit) == null || e.call(d, t), R1 = true), new O2(t);
    }, L0 = (t) => {
      if (!R1) try {
        if (t(), !(Q1 || 0 < l2)) try {
          K1 = t = K1, n3(t);
        } catch (e) {
          t3(e);
        }
      } catch (e) {
        t3(e);
      }
    }, f2 = {}, r3 = () => {
      if (!p2) {
        var t = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _: $ || "./this.program" }, e;
        for (e in f2) f2[e] === void 0 ? delete t[e] : t[e] = f2[e];
        var n = [];
        for (e in t) n.push(`${e}=${t[e]}`);
        p2 = n;
      }
      return p2;
    }, p2, M0 = [null, [], []], E0 = () => {
      if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") return (t) => crypto.getRandomValues(t);
      j1("initRandomDevice");
    }, i3 = (t) => (i3 = E0())(t);
    M = d.BindingError = class extends Error {
      constructor(t) {
        super(t), this.name = "BindingError";
      }
    }, Z.push(0, 1, void 0, 1, null, 1, true, 1, false, 1), d.count_emval_handles = () => Z.length / 2 - 5 - t2.length, H2 = d.PureVirtualError = B2("PureVirtualError");
    for (var o3 = Array(256), B1 = 0; 256 > B1; ++B1) o3[B1] = String.fromCharCode(B1);
    N2 = o3, C1 = d.InternalError = class extends Error {
      constructor(t) {
        super(t), this.name = "InternalError";
      }
    }, Object.assign($1.prototype, { isAliasOf: function(t) {
      if (!(this instanceof $1 && t instanceof $1)) return false;
      var e = this.cc.fc.ec, n = this.cc.dc;
      t.cc = t.cc;
      var i = t.cc.fc.ec;
      for (t = t.cc.dc; e.ic; ) n = e.tc(n), e = e.ic;
      for (; i.ic; ) t = i.tc(t), i = i.ic;
      return e === i && n === t;
    }, clone: function() {
      if (this.cc.dc || o2(this), this.cc.rc) return this.cc.count.value += 1, this;
      var t = d1, e = Object, n = e.create, i = Object.getPrototypeOf(this), o = this.cc;
      return t = t(n.call(e, i, { cc: { value: { count: o.count, sc: o.sc, rc: o.rc, dc: o.dc, fc: o.fc, jc: o.jc, lc: o.lc } } })), t.cc.count.value += 1, t.cc.sc = false, t;
    }, delete() {
      if (this.cc.dc || o2(this), this.cc.sc && !this.cc.rc) throw new M("Object already scheduled for deletion");
      A1(this);
      var t = this.cc;
      --t.count.value, t.count.value === 0 && (t.jc ? t.lc.nc(t.jc) : t.fc.ec.nc(t.dc)), this.cc.rc || (this.cc.jc = void 0, this.cc.dc = void 0);
    }, isDeleted: function() {
      return !this.cc.dc;
    }, deleteLater: function() {
      if (this.cc.dc || o2(this), this.cc.sc && !this.cc.rc) throw new M("Object already scheduled for deletion");
      return this.cc.sc = true, this;
    } }), Object.assign(L1.prototype, { Ic(t) {
      return this.Cc && (t = this.Cc(t)), t;
    }, zc(t) {
      var e;
      (e = this.nc) == null || e.call(this, t);
    }, mc: 8, readValueFromPointer: b1, fromWireType: function(t) {
      function e() {
        return this.wc ? k1(this.ec.oc, { fc: this.Oc, dc: n, lc: this, jc: t }) : k1(this.ec.oc, { fc: this, dc: t });
      }
      var n = this.Ic(t);
      if (!n) return this.zc(t), null;
      var i = e0(this.ec, n);
      if (i !== void 0) return i.cc.count.value === 0 ? (i.cc.dc = n, i.cc.jc = t, i.clone()) : (i = i.clone(), this.zc(t), i);
      if (i = this.ec.Hc(n), i = J2[i], !i) return e.call(this);
      i = this.vc ? i.Dc : i.pointerType;
      var o = q2(n, this.ec, i.ec);
      return o === null ? e.call(this) : this.wc ? k1(i.ec.oc, { fc: i, dc: o, lc: this, jc: t }) : k1(i.ec.oc, { fc: i, dc: o });
    } }), Y22 = d.UnboundTypeError = B2("UnboundTypeError");
    var P0 = { l: (t, e, n, i) => j1(`Assertion failed: ${t ? m1(k, t) : ""}, at: ` + [e ? e ? m1(k, e) : "" : "unknown filename", n, i ? i ? m1(k, i) : "" : "unknown function"]), Fa: (t) => {
      var e = new e2(t);
      return X[e.dc + 12] == 0 && (X[e.dc + 12] = 1, z2--), X[e.dc + 13] = 0, W2.push(e), d3(t), h3(t);
    }, Ea: () => {
      m(0, 0);
      var t = W2.pop();
      c3(t.Fc), s1 = 0;
    }, b: () => U2([]), o: (t, e) => U2([t, e]), v: (t, e, n) => {
      var i = new e2(t);
      throw F[i.dc + 16 >> 2] = 0, F[i.dc + 4 >> 2] = e, F[i.dc + 8 >> 2] = n, s1 = t, z2++, s1;
    }, d: (t) => {
      throw s1 || (s1 = t), s1;
    }, wa: () => {
    }, ta: () => {
    }, ua: () => {
    }, ya: function() {
    }, va: () => {
    }, Aa: () => j1(""), da: (t, e, n) => {
      t = A(t), e = w1(e, "wrapper"), n = c1(n);
      var i = e.ec, o = i.oc, s = i.ic.oc, u = i.ic.constructor;
      return t = r1(t, function(...c) {
        i.ic.Bc.forEach((function(l) {
          if (this[l] === s[l]) throw new H2(`Pure virtual function ${l} must be implemented in JavaScript`);
        }).bind(this)), Object.defineProperty(this, "__parent", { value: o }), this.__construct(...c);
      }), o.__construct = function(...c) {
        if (this === o) throw new M("Pass correct 'this' to __construct");
        c = u.implement(this, ...c), A1(c);
        var l = c.cc;
        if (c.notifyOnDestruction(), l.rc = true, Object.defineProperties(this, { cc: { value: l } }), d1(this), c = l.dc, c = n2(i, c), g1.hasOwnProperty(c)) throw new M(`Tried to register registered instance: ${c}`);
        g1[c] = this;
      }, o.__destruct = function() {
        if (this === o) throw new M("Pass correct 'this' to __destruct");
        A1(this);
        var c = this.cc.dc;
        if (c = n2(i, c), g1.hasOwnProperty(c)) delete g1[c];
        else throw new M(`Tried to unregister unregistered instance: ${c}`);
      }, t.prototype = Object.create(o), Object.assign(t.prototype, n), y1(t);
    }, N: (t) => {
      var e = D1[t];
      delete D1[t];
      var n = e.yc, i = e.nc, o = e.Ac, s = o.map((u) => u.Lc).concat(o.map((u) => u.Rc));
      G([t], s, (u) => {
        var c = {};
        return o.forEach((l, f) => {
          var p5 = u[f], C = l.Jc, L = l.Kc, I = u[f + o.length], S = l.Qc, B = l.Sc;
          c[l.Gc] = { read: (V) => p5.fromWireType(C(L, V)), write: (V, I1) => {
            var q = [];
            S(B, V, I.toWireType(q, I1)), i2(q);
          } };
        }), [{ name: e.name, fromWireType: (l) => {
          var f = {}, p5;
          for (p5 in c) f[p5] = c[p5].read(l);
          return i(l), f;
        }, toWireType: (l, f) => {
          for (var p5 in c) if (!(p5 in f)) throw new TypeError(`Missing field: "${p5}"`);
          var C = n();
          for (p5 in c) c[p5].write(C, f[p5]);
          return l !== null && l.push(i, C), C;
        }, mc: 8, readValueFromPointer: b1, kc: i }];
      });
    }, ma: () => {
    }, Pa: (t, e, n, i) => {
      e = A(e), J(t, { name: e, fromWireType: function(o) {
        return !!o;
      }, toWireType: function(o, s) {
        return s ? n : i;
      }, mc: 8, readValueFromPointer: function(o) {
        return this.fromWireType(k[o]);
      }, kc: null });
    }, C: (t, e, n, i, o, s, u, c, l, f, p5, C, L) => {
      p5 = A(p5), s = W(o, s), c && (c = W(u, c)), f && (f = W(l, f)), L = W(C, L);
      var I = r0(p5);
      s2(I, function() {
        M1(`Cannot construct ${p5} due to unbound types`, [i]);
      }), G([t, e, n], i ? [i] : [], (S) => {
        if (S = S[0], i) var B = S.ec, V = B.oc;
        else V = $1.prototype;
        S = r1(p5, function(...m2) {
          if (Object.getPrototypeOf(this) !== I1) throw new M("Use 'new' to construct " + p5);
          if (q.qc === void 0) throw new M(p5 + " has no accessible constructor");
          var O3 = q.qc[m2.length];
          if (O3 === void 0) throw new M(`Tried to invoke ctor of ${p5} with invalid number of parameters (${m2.length}) - expected (${Object.keys(q.qc).toString()}) parameters instead!`);
          return O3.apply(this, m2);
        });
        var I1 = Object.create(V, { constructor: { value: S } });
        S.prototype = I1;
        var q = new i0(p5, S, I1, L, B, s, c, f);
        if (q.ic) {
          var S1;
          (S1 = q.ic).uc != null || (S1.uc = []), q.ic.uc.push(q);
        }
        return B = new L1(p5, q, true, false, false), S1 = new L1(p5 + "*", q, false, false, false), V = new L1(p5 + " const*", q, false, true, false), J2[t] = { pointerType: S1, Dc: V }, G2(I, S), [B, S1, V];
      });
    }, L: (t, e, n, i, o, s, u, c) => {
      var l = z1(n, i);
      e = A(e), e = d2(e), s = W(o, s), G([], [t], (f) => {
        function p5() {
          M1(`Cannot call ${C} due to unbound types`, l);
        }
        f = f[0];
        var C = `${f.name}.${e}`;
        e.startsWith("@@") && (e = Symbol[e.substring(2)]);
        var L = f.ec.constructor;
        return L[e] === void 0 ? (p5.pc = n - 1, L[e] = p5) : (a2(L, e, C), L[e].hc[n - 1] = p5), G([], l, (I) => {
          if (I = W1(C, [I[0], null].concat(I.slice(1)), null, s, u, c), L[e].hc === void 0 ? (I.pc = n - 1, L[e] = I) : L[e].hc[n - 1] = I, f.ec.uc) for (let S of f.ec.uc) S.constructor.hasOwnProperty(e) || (S.constructor[e] = I);
          return [];
        }), [];
      });
    }, K: (t, e, n, i, o, s) => {
      var u = z1(e, n);
      o = W(i, o), G([], [t], (c) => {
        c = c[0];
        var l = `constructor ${c.name}`;
        if (c.ec.qc === void 0 && (c.ec.qc = []), c.ec.qc[e - 1] !== void 0) throw new M(`Cannot register multiple constructors with identical number of parameters (${e - 1}) for class '${c.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
        return c.ec.qc[e - 1] = () => {
          M1(`Cannot construct ${c.name} due to unbound types`, u);
        }, G([], u, (f) => (f.splice(1, 0, null), c.ec.qc[e - 1] = W1(l, f, null, o, s), [])), [];
      });
    }, m: (t, e, n, i, o, s, u, c, l) => {
      var f = z1(n, i);
      e = A(e), e = d2(e), s = W(o, s), G([], [t], (p5) => {
        function C() {
          M1(`Cannot call ${L} due to unbound types`, f);
        }
        p5 = p5[0];
        var L = `${p5.name}.${e}`;
        e.startsWith("@@") && (e = Symbol[e.substring(2)]), c && p5.ec.Bc.push(e);
        var I = p5.ec.oc, S = I[e];
        return S === void 0 || S.hc === void 0 && S.className !== p5.name && S.pc === n - 2 ? (C.pc = n - 2, C.className = p5.name, I[e] = C) : (a2(I, e, L), I[e].hc[n - 2] = C), G([], f, (B) => (B = W1(L, B, p5, s, u, l), I[e].hc === void 0 ? (B.pc = n - 2, I[e] = B) : I[e].hc[n - 2] = B, [])), [];
      });
    }, Oa: (t) => J(t, Z2), P: (t, e, n, i) => {
      function o() {
      }
      e = A(e), o.values = {}, J(t, { name: e, constructor: o, fromWireType: function(s) {
        return this.constructor.values[s];
      }, toWireType: (s, u) => u.value, mc: 8, readValueFromPointer: u0(e, n, i), kc: null }), s2(e, o);
    }, w: (t, e, n) => {
      var i = w1(t, "enum");
      e = A(e), t = i.constructor, i = Object.create(i.constructor.prototype, { value: { value: n }, constructor: { value: r1(`${i.name}_${e}`, function() {
      }) } }), t.values[n] = i, t[e] = i;
    }, aa: (t, e, n) => {
      e = A(e), J(t, { name: e, fromWireType: (i) => i, toWireType: (i, o) => o, mc: 8, readValueFromPointer: h0(e, n), kc: null });
    }, M: (t, e, n, i, o, s, u) => {
      var c = z1(e, n);
      t = A(t), t = d2(t), o = W(i, o), s2(t, function() {
        M1(`Cannot call ${t} due to unbound types`, c);
      }, e - 1), G([], c, (l) => (G2(t, W1(t, [l[0], null].concat(l.slice(1)), null, o, s, u), e - 1), []));
    }, z: (t, e, n, i, o) => {
      if (e = A(e), o === -1 && (o = 4294967295), o = (c) => c, i === 0) {
        var s = 32 - 8 * n;
        o = (c) => c << s >>> s;
      }
      var u = e.includes("unsigned") ? function(c, l) {
        return l >>> 0;
      } : function(c, l) {
        return l;
      };
      J(t, { name: e, fromWireType: o, toWireType: u, mc: 8, readValueFromPointer: l0(e, n, i !== 0), kc: null });
    }, r: (t, e, n) => {
      function i(s) {
        return new o(X.buffer, F[s + 4 >> 2], F[s >> 2]);
      }
      var o = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][e];
      n = A(n), J(t, { name: n, fromWireType: i, mc: 8, readValueFromPointer: i }, { Mc: true });
    }, O: (t) => {
      J(t, f0);
    }, T: (t, e, n, i, o, s, u, c, l, f, p5, C) => {
      n = A(n), s = W(o, s), c = W(u, c), f = W(l, f), C = W(p5, C), G([t], [e], (L) => (L = L[0], [new L1(n, L.ec, false, false, true, L, i, s, c, f, C)]));
    }, ba: (t, e) => {
      e = A(e);
      var n = e === "std::string";
      J(t, { name: e, fromWireType: function(i) {
        var o = F[i >> 2], s = i + 4;
        if (n) for (var u = s, c = 0; c <= o; ++c) {
          var l = s + c;
          if (c == o || k[l] == 0) {
            if (u = u ? m1(k, u, l - u) : "", f === void 0) var f = u;
            else f += "\0", f += u;
            u = l + 1;
          }
        }
        else {
          for (f = Array(o), c = 0; c < o; ++c) f[c] = String.fromCharCode(k[s + c]);
          f = f.join("");
        }
        return Q(i), f;
      }, toWireType: function(i, o) {
        o instanceof ArrayBuffer && (o = new Uint8Array(o));
        var s, u = typeof o == "string";
        if (!(u || o instanceof Uint8Array || o instanceof Uint8ClampedArray || o instanceof Int8Array)) throw new M("Cannot pass non-string to std::string");
        if (n && u) for (var c = s = 0; c < o.length; ++c) {
          var l = o.charCodeAt(c);
          127 >= l ? s++ : 2047 >= l ? s += 2 : 55296 <= l && 57343 >= l ? (s += 4, ++c) : s += 3;
        }
        else s = o.length;
        if (c = v2(4 + s + 1), l = c + 4, F[c >> 2] = s, n && u) _1(o, l, s + 1);
        else if (u) for (u = 0; u < s; ++u) {
          var f = o.charCodeAt(u);
          if (255 < f) throw Q(l), new M("String has UTF-16 code units that do not fit in 8 bits");
          k[l + u] = f;
        }
        else for (u = 0; u < s; ++u) k[l + u] = o[u];
        return i !== null && i.push(Q, c), c;
      }, mc: 8, readValueFromPointer: b1, kc(i) {
        Q(i);
      } });
    }, S: (t, e, n) => {
      if (n = A(n), e === 2) var i = p0, o = v0, s = m0, u = (c) => f1[c >> 1];
      else e === 4 && (i = _0, o = y0, s = g0, u = (c) => F[c >> 2]);
      J(t, { name: n, fromWireType: (c) => {
        for (var l = F[c >> 2], f, p5 = c + 4, C = 0; C <= l; ++C) {
          var L = c + 4 + C * e;
          (C == l || u(L) == 0) && (p5 = i(p5, L - p5), f === void 0 ? f = p5 : (f += "\0", f += p5), p5 = L + e);
        }
        return Q(c), f;
      }, toWireType: (c, l) => {
        if (typeof l != "string") throw new M(`Cannot pass non-string to C++ string type ${n}`);
        var f = s(l), p5 = v2(4 + f + e);
        return F[p5 >> 2] = f / e, o(l, p5 + 4, f + e), c !== null && c.push(Q, p5), p5;
      }, mc: 8, readValueFromPointer: b1, kc(c) {
        Q(c);
      } });
    }, H: (t, e, n, i, o, s) => {
      D1[t] = { name: A(e), yc: W(n, i), nc: W(o, s), Ac: [] };
    }, x: (t, e, n, i, o, s, u, c, l, f) => {
      D1[t].Ac.push({ Gc: A(e), Lc: n, Jc: W(i, o), Kc: s, Rc: u, Qc: W(c, l), Sc: f });
    }, Qa: (t, e) => {
      e = A(e), J(t, { Nc: true, name: e, mc: 0, fromWireType: () => {
      }, toWireType: () => {
      } });
    }, Ga: function() {
      return Date.now();
    }, ra: () => {
      Q1 = false, l2 = 0;
    }, na: () => {
      throw 1 / 0;
    }, ca: (t, e, n) => (t = c1(t), e = w1(e, "emval::as"), e3(e, n, t)), Sa: (t, e, n, i) => (t = U1[t], e = c1(e), t(null, e, n, i)), D: (t, e, n, i, o) => {
      t = U1[t], e = c1(e);
      var s = w0[n];
      return n = s === void 0 ? A(n) : s, t(e, e[n], i, o);
    }, Ja: u2, A: (t, e, n) => {
      e = b0(t, e);
      var i = e.shift();
      t--;
      var o = `return function (obj, func, destructorsRef, args) {
`, s = 0, u = [];
      n === 0 && u.push("obj");
      for (var c = ["retType"], l = [i], f = 0; f < t; ++f) u.push("arg" + f), c.push("argType" + f), l.push(e[f]), o += `  var arg${f} = argType${f}.readValueFromPointer(args${s ? "+" + s : ""});
`, s += e[f].mc;
      return o += `  var rv = ${n === 1 ? "new func" : "func.call"}(${u.join(", ")});
`, i.Nc || (c.push("emval_returnValue"), l.push(e3), o += `  return emval_returnValue(retType, destructorsRef, rv);
`), c.push(o + `};
`), t = X2(c)(...l), n = `methodCaller<(${e.map((p5) => p5.name).join(", ")}) => ${i.name}>`, C0(r1(n, t));
    }, Ta: (t) => {
      9 < t && (Z[t + 1] += 1);
    }, Ra: (t) => {
      var e = c1(t);
      i2(e), u2(t);
    }, F: (t, e) => (t = w1(t, "_emval_take_value"), t = t.readValueFromPointer(e), y1(t)), oa: (t, e) => {
      if (E1[t] && (clearTimeout(E1[t].id), delete E1[t]), !e) return 0;
      var n = setTimeout(() => {
        delete E1[t], L0(() => s3(t, performance.now()));
      }, e);
      return E1[t] = { id: n, Uc: e }, 0;
    }, pa: (t, e, n, i) => {
      var o = (/* @__PURE__ */ new Date()).getFullYear(), s = new Date(o, 0, 1).getTimezoneOffset();
      o = new Date(o, 6, 1).getTimezoneOffset(), F[t >> 2] = 60 * Math.max(s, o), t1[e >> 2] = +(s != o), e = (u) => {
        var c = Math.abs(u);
        return `UTC${0 <= u ? "-" : "+"}${String(Math.floor(c / 60)).padStart(2, "0")}${String(c % 60).padStart(2, "0")}`;
      }, t = e(s), e = e(o), o < s ? (_1(t, n, 17), _1(e, i, 17)) : (_1(t, i, 17), _1(e, n, 17));
    }, qa: (t) => {
      var e = k.length;
      if (t >>>= 0, 2147483648 < t) return false;
      for (var n = 1; 4 >= n; n *= 2) {
        var i = e * (1 + 0.2 / n);
        i = Math.min(i, t + 100663296);
        e: {
          i = (Math.min(2147483648, 65536 * Math.ceil(Math.max(t, i) / 65536)) - x1.buffer.byteLength + 65535) / 65536 | 0;
          try {
            x1.grow(i), F2();
            var o = 1;
            break e;
          } catch (s) {
          }
          o = void 0;
        }
        if (o) return true;
      }
      return false;
    }, Ca: (t, e) => {
      var n = 0;
      return r3().forEach((i, o) => {
        var s = e + n;
        for (o = F[t + 4 * o >> 2] = s, s = 0; s < i.length; ++s) X[o++] = i.charCodeAt(s);
        X[o] = 0, n += i.length + 1;
      }), 0;
    }, Da: (t, e) => {
      var n = r3();
      F[t >> 2] = n.length;
      var i = 0;
      return n.forEach((o) => i += o.length + 1), F[e >> 2] = i, 0;
    }, za: () => 52, xa: () => 52, U: (t, e, n, i) => {
      for (var o = 0, s = 0; s < n; s++) {
        var u = F[e >> 2], c = F[e + 4 >> 2];
        e += 8;
        for (var l = 0; l < c; l++) {
          var f = t, p5 = k[u + l], C = M0[f];
          p5 === 0 || p5 === 10 ? ((f === 1 ? T1 : K)(m1(C)), C.length = 0) : C.push(p5);
        }
        o += c;
      }
      return F[i >> 2] = o, 0;
    }, Ia: Q0, n: D0, $: j0, La: J0, g: x0, u: O0, Na: A0, G: z0, J: N0, f: R0, _: q0, h: $0, Ma: B0, k: U0, R: H0, t: W0, V: a4, W: o4, Xa: I4, bb: C4, ha: l4, ka: d4, la: c4, fa: p4, db: g4, I: s4, a: S0, B: Z0, E: k0, X: r4, c: I0, Ka: G0, Ha: e4, e: T0, Y: t4, Q: i4, j: F0, y: n4, i: V0, p: Y0, s: K0, Z: X0, Wa: S4, Za: E4, Ya: P4, ab: b4, $a: L4, _a: M4, cb: w4, ia: h4, ga: f4, Va: T4, fb: _4, ea: v4, gb: m4, ja: u4, Ua: F4, eb: y4, q: (t) => t, Ba: n3, sa: (t, e) => (i3(k.subarray(t, t + e)), 0) }, w = function() {
      var n;
      function t(i) {
        var o;
        return w = i.exports, x1 = w.hb, F2(), P = w.mb, R2.unshift(w.ib), n1--, (o = d.monitorRunDependencies) == null || o.call(d, n1), n1 == 0 && (p1 && (i = p1, p1 = null, i())), w;
      }
      n1++, (n = d.monitorRunDependencies) == null || n.call(d, n1);
      var e = { a: P0 };
      if (d.instantiateWasm) try {
        return d.instantiateWasm(e, t);
      } catch (i) {
        K(`Module.instantiateWasm callback failed with error: ${i}`), T(i);
      }
      return v1 != null || (v1 = A2("DotLottiePlayer.wasm") ? "DotLottiePlayer.wasm" : d.locateFile ? d.locateFile("DotLottiePlayer.wasm", U) : U + "DotLottiePlayer.wasm"), Z3(e, function(i) {
        t(i.instance);
      }).catch(T), {};
    }(), v2 = (t) => (v2 = w.jb)(t), a3 = (t) => (a3 = w.kb)(t), Q = (t) => (Q = w.lb)(t), s3 = (t, e) => (s3 = w.nb)(t, e), m = (t, e) => (m = w.ob)(t, e), P1 = (t) => (P1 = w.pb)(t), _ = (t) => (_ = w.qb)(t), y = () => (y = w.rb)(), c3 = (t) => (c3 = w.sb)(t), d3 = (t) => (d3 = w.tb)(t), u3 = (t, e, n) => (u3 = w.ub)(t, e, n), h3 = (t) => (h3 = w.vb)(t), l3 = d.dynCall_ji = (t, e) => (l3 = d.dynCall_ji = w.wb)(t, e), f3 = d.dynCall_viji = (t, e, n, i, o) => (f3 = d.dynCall_viji = w.xb)(t, e, n, i, o), p3 = d.dynCall_jii = (t, e, n) => (p3 = d.dynCall_jii = w.yb)(t, e, n);
    d.dynCall_iijj = (t, e, n, i, o, s) => (d.dynCall_iijj = w.zb)(t, e, n, i, o, s), d.dynCall_vijj = (t, e, n, i, o, s) => (d.dynCall_vijj = w.Ab)(t, e, n, i, o, s);
    var v3 = d.dynCall_vjiii = (t, e, n, i, o, s) => (v3 = d.dynCall_vjiii = w.Bb)(t, e, n, i, o, s), m3 = d.dynCall_vij = (t, e, n, i) => (m3 = d.dynCall_vij = w.Cb)(t, e, n, i), _3 = d.dynCall_viijii = (t, e, n, i, o, s, u) => (_3 = d.dynCall_viijii = w.Db)(t, e, n, i, o, s, u), y3 = d.dynCall_jjji = (t, e, n, i, o, s) => (y3 = d.dynCall_jjji = w.Eb)(t, e, n, i, o, s), g3 = d.dynCall_viijj = (t, e, n, i, o, s, u) => (g3 = d.dynCall_viijj = w.Fb)(t, e, n, i, o, s, u), w3 = d.dynCall_viijji = (t, e, n, i, o, s, u, c) => (w3 = d.dynCall_viijji = w.Gb)(t, e, n, i, o, s, u, c), C3 = d.dynCall_viij = (t, e, n, i, o) => (C3 = d.dynCall_viij = w.Hb)(t, e, n, i, o), b3 = d.dynCall_iiiijj = (t, e, n, i, o, s, u, c) => (b3 = d.dynCall_iiiijj = w.Ib)(t, e, n, i, o, s, u, c), L3 = d.dynCall_viiij = (t, e, n, i, o, s) => (L3 = d.dynCall_viiij = w.Jb)(t, e, n, i, o, s), M3 = d.dynCall_viiji = (t, e, n, i, o, s) => (M3 = d.dynCall_viiji = w.Kb)(t, e, n, i, o, s), E3 = d.dynCall_jiii = (t, e, n, i) => (E3 = d.dynCall_jiii = w.Lb)(t, e, n, i), P3 = d.dynCall_viiiji = (t, e, n, i, o, s, u) => (P3 = d.dynCall_viiiji = w.Mb)(t, e, n, i, o, s, u), I3 = d.dynCall_viiijj = (t, e, n, i, o, s, u, c) => (I3 = d.dynCall_viiijj = w.Nb)(t, e, n, i, o, s, u, c), S3 = d.dynCall_viiiijjiiiiii = (t, e, n, i, o, s, u, c, l, f, p5, C, L, I, S) => (S3 = d.dynCall_viiiijjiiiiii = w.Ob)(t, e, n, i, o, s, u, c, l, f, p5, C, L, I, S), T3 = d.dynCall_viiiijjiiii = (t, e, n, i, o, s, u, c, l, f, p5, C, L) => (T3 = d.dynCall_viiiijjiiii = w.Pb)(t, e, n, i, o, s, u, c, l, f, p5, C, L), F3 = d.dynCall_iiiiiijjii = (t, e, n, i, o, s, u, c, l, f, p5, C) => (F3 = d.dynCall_iiiiiijjii = w.Qb)(t, e, n, i, o, s, u, c, l, f, p5, C), x3 = d.dynCall_viiiijjii = (t, e, n, i, o, s, u, c, l, f, p5) => (x3 = d.dynCall_viiiijjii = w.Rb)(t, e, n, i, o, s, u, c, l, f, p5), R3 = d.dynCall_viijiii = (t, e, n, i, o, s, u, c) => (R3 = d.dynCall_viijiii = w.Sb)(t, e, n, i, o, s, u, c), j3 = d.dynCall_iji = (t, e, n, i) => (j3 = d.dynCall_iji = w.Tb)(t, e, n, i), A3 = d.dynCall_vijjjj = (t, e, n, i, o, s, u, c, l, f) => (A3 = d.dynCall_vijjjj = w.Ub)(t, e, n, i, o, s, u, c, l, f);
    d.dynCall_vjii = (t, e, n, i, o) => (d.dynCall_vjii = w.Vb)(t, e, n, i, o), d.dynCall_vjfii = (t, e, n, i, o, s) => (d.dynCall_vjfii = w.Wb)(t, e, n, i, o, s), d.dynCall_vj = (t, e, n) => (d.dynCall_vj = w.Xb)(t, e, n), d.dynCall_vjiiiii = (t, e, n, i, o, s, u, c) => (d.dynCall_vjiiiii = w.Yb)(t, e, n, i, o, s, u, c), d.dynCall_vjiffii = (t, e, n, i, o, s, u, c) => (d.dynCall_vjiffii = w.Zb)(t, e, n, i, o, s, u, c), d.dynCall_vjiiii = (t, e, n, i, o, s, u) => (d.dynCall_vjiiii = w._b)(t, e, n, i, o, s, u), d.dynCall_iiiiij = (t, e, n, i, o, s, u) => (d.dynCall_iiiiij = w.$b)(t, e, n, i, o, s, u), d.dynCall_iiiiijj = (t, e, n, i, o, s, u, c, l) => (d.dynCall_iiiiijj = w.ac)(t, e, n, i, o, s, u, c, l), d.dynCall_iiiiiijj = (t, e, n, i, o, s, u, c, l, f) => (d.dynCall_iiiiiijj = w.bc)(t, e, n, i, o, s, u, c, l, f);
    function I0(t, e, n) {
      var i = y();
      try {
        P.get(t)(e, n);
      } catch (o) {
        if (_(i), o !== o + 0) throw o;
        m(1, 0);
      }
    }
    function S0(t, e) {
      var n = y();
      try {
        P.get(t)(e);
      } catch (i) {
        if (_(n), i !== i + 0) throw i;
        m(1, 0);
      }
    }
    function T0(t, e, n, i) {
      var o = y();
      try {
        P.get(t)(e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function F0(t, e, n, i, o) {
      var s = y();
      try {
        P.get(t)(e, n, i, o);
      } catch (u) {
        if (_(s), u !== u + 0) throw u;
        m(1, 0);
      }
    }
    function x0(t, e) {
      var n = y();
      try {
        return P.get(t)(e);
      } catch (i) {
        if (_(n), i !== i + 0) throw i;
        m(1, 0);
      }
    }
    function R0(t, e, n) {
      var i = y();
      try {
        return P.get(t)(e, n);
      } catch (o) {
        if (_(i), o !== o + 0) throw o;
        m(1, 0);
      }
    }
    function j0(t, e, n) {
      var i = y();
      try {
        return P.get(t)(e, n);
      } catch (o) {
        if (_(i), o !== o + 0) throw o;
        m(1, 0);
      }
    }
    function A0(t, e, n, i) {
      var o = y();
      try {
        return P.get(t)(e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function k0(t, e, n) {
      var i = y();
      try {
        P.get(t)(e, n);
      } catch (o) {
        if (_(i), o !== o + 0) throw o;
        m(1, 0);
      }
    }
    function D0(t, e) {
      var n = y();
      try {
        return P.get(t)(e);
      } catch (i) {
        if (_(n), i !== i + 0) throw i;
        m(1, 0);
      }
    }
    function O0(t, e, n) {
      var i = y();
      try {
        return P.get(t)(e, n);
      } catch (o) {
        if (_(i), o !== o + 0) throw o;
        m(1, 0);
      }
    }
    function $0(t, e, n, i) {
      var o = y();
      try {
        return P.get(t)(e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function W0(t, e, n, i, o, s) {
      var u = y();
      try {
        return P.get(t)(e, n, i, o, s);
      } catch (c) {
        if (_(u), c !== c + 0) throw c;
        m(1, 0);
      }
    }
    function z0(t, e, n, i, o, s) {
      var u = y();
      try {
        return P.get(t)(e, n, i, o, s);
      } catch (c) {
        if (_(u), c !== c + 0) throw c;
        m(1, 0);
      }
    }
    function U0(t, e, n, i, o) {
      var s = y();
      try {
        return P.get(t)(e, n, i, o);
      } catch (u) {
        if (_(s), u !== u + 0) throw u;
        m(1, 0);
      }
    }
    function B0(t, e, n, i, o) {
      var s = y();
      try {
        return P.get(t)(e, n, i, o);
      } catch (u) {
        if (_(s), u !== u + 0) throw u;
        m(1, 0);
      }
    }
    function H0(t, e, n, i, o, s, u) {
      var c = y();
      try {
        return P.get(t)(e, n, i, o, s, u);
      } catch (l) {
        if (_(c), l !== l + 0) throw l;
        m(1, 0);
      }
    }
    function N0(t, e, n, i, o, s) {
      var u = y();
      try {
        return P.get(t)(e, n, i, o, s);
      } catch (c) {
        if (_(u), c !== c + 0) throw c;
        m(1, 0);
      }
    }
    function V0(t, e, n, i, o, s) {
      var u = y();
      try {
        P.get(t)(e, n, i, o, s);
      } catch (c) {
        if (_(u), c !== c + 0) throw c;
        m(1, 0);
      }
    }
    function q0(t, e, n, i) {
      var o = y();
      try {
        return P.get(t)(e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function J0(t, e, n, i) {
      var o = y();
      try {
        return P.get(t)(e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function G0(t, e, n, i, o) {
      var s = y();
      try {
        P.get(t)(e, n, i, o);
      } catch (u) {
        if (_(s), u !== u + 0) throw u;
        m(1, 0);
      }
    }
    function Y0(t, e, n, i, o, s, u) {
      var c = y();
      try {
        P.get(t)(e, n, i, o, s, u);
      } catch (l) {
        if (_(c), l !== l + 0) throw l;
        m(1, 0);
      }
    }
    function K0(t, e, n, i, o, s, u, c) {
      var l = y();
      try {
        P.get(t)(e, n, i, o, s, u, c);
      } catch (f) {
        if (_(l), f !== f + 0) throw f;
        m(1, 0);
      }
    }
    function X0(t, e, n, i, o, s, u, c, l) {
      var f = y();
      try {
        P.get(t)(e, n, i, o, s, u, c, l);
      } catch (p5) {
        if (_(f), p5 !== p5 + 0) throw p5;
        m(1, 0);
      }
    }
    function Z0(t, e, n, i) {
      var o = y();
      try {
        P.get(t)(e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function Q0(t, e, n, i) {
      var o = y();
      try {
        return P.get(t)(e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function e4(t, e, n, i, o, s, u) {
      var c = y();
      try {
        P.get(t)(e, n, i, o, s, u);
      } catch (l) {
        if (_(c), l !== l + 0) throw l;
        m(1, 0);
      }
    }
    function t4(t, e, n, i, o) {
      var s = y();
      try {
        P.get(t)(e, n, i, o);
      } catch (u) {
        if (_(s), u !== u + 0) throw u;
        m(1, 0);
      }
    }
    function n4(t, e, n, i, o, s, u, c) {
      var l = y();
      try {
        P.get(t)(e, n, i, o, s, u, c);
      } catch (f) {
        if (_(l), f !== f + 0) throw f;
        m(1, 0);
      }
    }
    function r4(t, e, n, i) {
      var o = y();
      try {
        P.get(t)(e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function i4(t, e, n, i, o, s) {
      var u = y();
      try {
        P.get(t)(e, n, i, o, s);
      } catch (c) {
        if (_(u), c !== c + 0) throw c;
        m(1, 0);
      }
    }
    function o4(t, e, n, i, o, s, u, c, l) {
      var f = y();
      try {
        return P.get(t)(e, n, i, o, s, u, c, l);
      } catch (p5) {
        if (_(f), p5 !== p5 + 0) throw p5;
        m(1, 0);
      }
    }
    function a4(t, e, n, i, o, s, u, c) {
      var l = y();
      try {
        return P.get(t)(e, n, i, o, s, u, c);
      } catch (f) {
        if (_(l), f !== f + 0) throw f;
        m(1, 0);
      }
    }
    function s4(t) {
      var e = y();
      try {
        P.get(t)();
      } catch (n) {
        if (_(e), n !== n + 0) throw n;
        m(1, 0);
      }
    }
    function c4(t, e, n) {
      var i = y();
      try {
        return p3(t, e, n);
      } catch (o) {
        if (_(i), o !== o + 0) throw o;
        m(1, 0);
      }
    }
    function d4(t, e) {
      var n = y();
      try {
        return l3(t, e);
      } catch (i) {
        if (_(n), i !== i + 0) throw i;
        m(1, 0);
      }
    }
    function u4(t, e, n, i, o) {
      var s = y();
      try {
        f3(t, e, n, i, o);
      } catch (u) {
        if (_(s), u !== u + 0) throw u;
        m(1, 0);
      }
    }
    function h4(t, e, n, i, o, s) {
      var u = y();
      try {
        M3(t, e, n, i, o, s);
      } catch (c) {
        if (_(u), c !== c + 0) throw c;
        m(1, 0);
      }
    }
    function l4(t, e, n, i) {
      var o = y();
      try {
        return j3(t, e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function f4(t, e, n, i, o, s, u) {
      var c = y();
      try {
        _3(t, e, n, i, o, s, u);
      } catch (l) {
        if (_(c), l !== l + 0) throw l;
        m(1, 0);
      }
    }
    function p4(t, e, n, i) {
      var o = y();
      try {
        return E3(t, e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function v4(t, e, n, i, o, s, u, c) {
      var l = y();
      try {
        w3(t, e, n, i, o, s, u, c);
      } catch (f) {
        if (_(l), f !== f + 0) throw f;
        m(1, 0);
      }
    }
    function m4(t, e, n, i) {
      var o = y();
      try {
        m3(t, e, n, i);
      } catch (s) {
        if (_(o), s !== s + 0) throw s;
        m(1, 0);
      }
    }
    function _4(t, e, n, i, o, s, u) {
      var c = y();
      try {
        g3(t, e, n, i, o, s, u);
      } catch (l) {
        if (_(c), l !== l + 0) throw l;
        m(1, 0);
      }
    }
    function y4(t, e, n, i, o, s) {
      var u = y();
      try {
        v3(t, e, n, i, o, s);
      } catch (c) {
        if (_(u), c !== c + 0) throw c;
        m(1, 0);
      }
    }
    function g4(t, e, n, i, o, s) {
      var u = y();
      try {
        return y3(t, e, n, i, o, s);
      } catch (c) {
        if (_(u), c !== c + 0) throw c;
        m(1, 0);
      }
    }
    function w4(t, e, n, i, o) {
      var s = y();
      try {
        C3(t, e, n, i, o);
      } catch (u) {
        if (_(s), u !== u + 0) throw u;
        m(1, 0);
      }
    }
    function C4(t, e, n, i, o, s, u, c) {
      var l = y();
      try {
        return b3(t, e, n, i, o, s, u, c);
      } catch (f) {
        if (_(l), f !== f + 0) throw f;
        m(1, 0);
      }
    }
    function b4(t, e, n, i, o, s) {
      var u = y();
      try {
        L3(t, e, n, i, o, s);
      } catch (c) {
        if (_(u), c !== c + 0) throw c;
        m(1, 0);
      }
    }
    function L4(t, e, n, i, o, s, u) {
      var c = y();
      try {
        P3(t, e, n, i, o, s, u);
      } catch (l) {
        if (_(c), l !== l + 0) throw l;
        m(1, 0);
      }
    }
    function M4(t, e, n, i, o, s, u, c) {
      var l = y();
      try {
        I3(t, e, n, i, o, s, u, c);
      } catch (f) {
        if (_(l), f !== f + 0) throw f;
        m(1, 0);
      }
    }
    function E4(t, e, n, i, o, s, u, c, l, f, p5, C, L) {
      var I = y();
      try {
        T3(t, e, n, i, o, s, u, c, l, f, p5, C, L);
      } catch (S) {
        if (_(I), S !== S + 0) throw S;
        m(1, 0);
      }
    }
    function P4(t, e, n, i, o, s, u, c, l, f, p5, C, L, I, S) {
      var B = y();
      try {
        S3(t, e, n, i, o, s, u, c, l, f, p5, C, L, I, S);
      } catch (V) {
        if (_(B), V !== V + 0) throw V;
        m(1, 0);
      }
    }
    function I4(t, e, n, i, o, s, u, c, l, f, p5, C) {
      var L = y();
      try {
        return F3(t, e, n, i, o, s, u, c, l, f, p5, C);
      } catch (I) {
        if (_(L), I !== I + 0) throw I;
        m(1, 0);
      }
    }
    function S4(t, e, n, i, o, s, u, c, l, f, p5) {
      var C = y();
      try {
        x3(t, e, n, i, o, s, u, c, l, f, p5);
      } catch (L) {
        if (_(C), L !== L + 0) throw L;
        m(1, 0);
      }
    }
    function T4(t, e, n, i, o, s, u, c) {
      var l = y();
      try {
        R3(t, e, n, i, o, s, u, c);
      } catch (f) {
        if (_(l), f !== f + 0) throw f;
        m(1, 0);
      }
    }
    function F4(t, e, n, i, o, s, u, c, l, f) {
      var p5 = y();
      try {
        A3(t, e, n, i, o, s, u, c, l, f);
      } catch (C) {
        if (_(p5), C !== C + 0) throw C;
        m(1, 0);
      }
    }
    var H1;
    p1 = function t() {
      H1 || k3(), H1 || (p1 = t);
    };
    function k3() {
      function t() {
        var n;
        if (!H1 && (H1 = true, d.calledRun = true, !R1)) {
          if (Z1(R2), g(d), (n = d.onRuntimeInitialized) == null || n.call(d), d.postRun) for (typeof d.postRun == "function" && (d.postRun = [d.postRun]); d.postRun.length; ) {
            var e = d.postRun.shift();
            j2.unshift(e);
          }
          Z1(j2);
        }
      }
      if (!(0 < n1)) {
        if (d.preRun) for (typeof d.preRun == "function" && (d.preRun = [d.preRun]); d.preRun.length; ) K3();
        Z1(x22), 0 < n1 || (d.setStatus ? (d.setStatus("Running..."), setTimeout(() => {
          setTimeout(() => d.setStatus(""), 1), t();
        }, 1)) : t());
      }
    }
    if (d.preInit) for (typeof d.preInit == "function" && (d.preInit = [d.preInit]); 0 < d.preInit.length; ) d.preInit.pop()();
    return k3(), h2 = R, h2;
  };
})(), B3 = A4;
var o1 = class {
  constructor() {
    throw new Error("RendererLoader is a static class and cannot be instantiated.");
  }
  static _tryLoad(r) {
    return E(this, null, function* () {
      return yield B3({ locateFile: () => r });
    });
  }
  static _loadWithBackup() {
    return E(this, null, function* () {
      return this._ModulePromise || (this._ModulePromise = this._tryLoad(this._wasmURL).catch((r) => E(this, null, function* () {
        let a = `https://unpkg.com/${C2}@${w2}/dist/dotlottie-player.wasm`;
        console.warn(`Primary WASM load failed from ${this._wasmURL}. Error: ${r.message}`), console.warn(`Attempting to load WASM from backup URL: ${a}`);
        try {
          return yield this._tryLoad(a);
        } catch (h2) {
          throw console.error(`Primary WASM URL failed: ${r.message}`), console.error(`Backup WASM URL failed: ${h2.message}`), new Error("WASM loading failed from all sources.");
        }
      }))), this._ModulePromise;
    });
  }
  static load() {
    return E(this, null, function* () {
      return this._loadWithBackup();
    });
  }
  static setWasmUrl(r) {
    r !== this._wasmURL && (this._wasmURL = r, this._ModulePromise = null);
  }
};
b(o1, "_ModulePromise", null), b(o1, "_wasmURL", `https://cdn.jsdelivr.net/npm/${C2}@${w2}/dist/dotlottie-player.wasm`);
var h1 = class {
  constructor() {
    b(this, "_eventListeners", /* @__PURE__ */ new Map());
  }
  addEventListener(r, a) {
    let h2 = this._eventListeners.get(r);
    h2 || (h2 = /* @__PURE__ */ new Set(), this._eventListeners.set(r, h2)), h2.add(a);
  }
  removeEventListener(r, a) {
    let h2 = this._eventListeners.get(r);
    h2 && (a ? (h2.delete(a), h2.size === 0 && this._eventListeners.delete(r)) : this._eventListeners.delete(r));
  }
  dispatch(r) {
    let a = this._eventListeners.get(r.type);
    a == null || a.forEach((h2) => h2(r));
  }
  removeAllEventListeners() {
    this._eventListeners.clear();
  }
};
var H = class {
  static _initializeObserver() {
    if (this._observer) return;
    let r = (a) => {
      a.forEach((h2) => {
        let d = this._observedCanvases.get(h2.target);
        d && (h2.isIntersecting ? d.unfreeze() : d.freeze());
      });
    };
    this._observer = new IntersectionObserver(r, { threshold: 0 });
  }
  static observe(r, a) {
    var h2;
    this._initializeObserver(), !this._observedCanvases.has(r) && (this._observedCanvases.set(r, a), (h2 = this._observer) == null || h2.observe(r));
  }
  static unobserve(r) {
    var a, h2;
    (a = this._observer) == null || a.unobserve(r), this._observedCanvases.delete(r), this._observedCanvases.size === 0 && ((h2 = this._observer) == null || h2.disconnect(), this._observer = null);
  }
};
b(H, "_observer", null), b(H, "_observedCanvases", /* @__PURE__ */ new Map());
var N = class {
  static _initializeObserver() {
    if (this._observer) return;
    let r = (a) => {
      a.forEach((h2) => {
        let d = this._observedCanvases.get(h2.target);
        if (!d) return;
        let [g, T] = d;
        clearTimeout(T);
        let R = setTimeout(() => {
          g.resize();
        }, 100);
        this._observedCanvases.set(h2.target, [g, R]);
      });
    };
    this._observer = new ResizeObserver(r);
  }
  static observe(r, a) {
    var h2;
    this._initializeObserver(), !this._observedCanvases.has(r) && (this._observedCanvases.set(r, [a, 0]), (h2 = this._observer) == null || h2.observe(r));
  }
  static unobserve(r) {
    var h2;
    let a = this._observedCanvases.get(r);
    if (a) {
      let d = a[1];
      d && clearTimeout(d);
    }
    (h2 = this._observer) == null || h2.unobserve(r), this._observedCanvases.delete(r), !this._observedCanvases.size && this._observer && (this._observer.disconnect(), this._observer = null);
  }
};
b(N, "_observer", null), b(N, "_observedCanvases", /* @__PURE__ */ new Map());
function k4(v) {
  return /^#([\da-f]{6}|[\da-f]{8})$/iu.test(v);
}
function N3(v) {
  if (!k4(v)) return 0;
  let r = v.replace("#", "");
  return r = r.length === 6 ? `${r}ff` : r, parseInt(r, 16);
}
function b2(v) {
  if (v.byteLength < 4) return false;
  let r = new Uint8Array(v.slice(0, J1.byteLength));
  for (let a = 0; a < J1.length; a += 1) if (J1[a] !== r[a]) return false;
  return true;
}
function H3(v) {
  return z3.every((r) => Object.prototype.hasOwnProperty.call(v, r));
}
function L2(v) {
  if (typeof v == "string") try {
    return H3(JSON.parse(v));
  } catch (r) {
    return false;
  }
  else return H3(v);
}
function e1() {
  return 1 + ((O ? window.devicePixelRatio : 1) - 1) * U3;
}
function G1(v) {
  let r = v.getBoundingClientRect();
  return r.top >= 0 && r.left >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight) && r.right <= (window.innerWidth || document.documentElement.clientWidth);
}
var M2 = (v, r) => v === "reverse" ? r.Mode.Reverse : v === "bounce" ? r.Mode.Bounce : v === "reverse-bounce" ? r.Mode.ReverseBounce : r.Mode.Forward, D4 = (v, r) => v === "contain" ? r.Fit.Contain : v === "cover" ? r.Fit.Cover : v === "fill" ? r.Fit.Fill : v === "fit-height" ? r.Fit.FitHeight : v === "fit-width" ? r.Fit.FitWidth : r.Fit.None, O4 = (v, r) => {
  let a = new r.VectorFloat();
  return a.push_back(v[0]), a.push_back(v[1]), a;
}, E2 = (v, r) => {
  let a = new r.VectorFloat();
  return v.length !== 2 || (a.push_back(v[0]), a.push_back(v[1])), a;
}, P2 = (v, r) => {
  var a, h2;
  return v ? { align: O4((a = v.align) != null ? a : [0.5, 0.5], r), fit: D4((h2 = v.fit) != null ? h2 : "contain", r) } : r.createDefaultLayout();
}, x = class x2 {
  constructor(r) {
    b(this, "_canvas");
    b(this, "_context", null);
    b(this, "_eventManager");
    b(this, "_animationFrameId", null);
    b(this, "_frameManager");
    b(this, "_dotLottieCore", null);
    b(this, "_renderConfig", {});
    b(this, "_isFrozen", false);
    b(this, "_backgroundColor", null);
    b(this, "_pointerUpMethod");
    b(this, "_pointerDownMethod");
    b(this, "_pointerMoveMethod");
    b(this, "_pointerEnterMethod");
    b(this, "_pointerExitMethod");
    var a, h2, d;
    this._canvas = r.canvas, this._eventManager = new h1(), this._frameManager = new q1(), this._renderConfig = z(D({}, r.renderConfig), { devicePixelRatio: ((a = r.renderConfig) == null ? void 0 : a.devicePixelRatio) || e1(), freezeOnOffscreen: (d = (h2 = r.renderConfig) == null ? void 0 : h2.freezeOnOffscreen) != null ? d : true }), o1.load().then((g) => {
      var T, R, j, $, U, l1, T1, K;
      x2._wasmModule = g, this._dotLottieCore = new g.DotLottiePlayer({ themeId: (T = r.themeId) != null ? T : "", stateMachineId: "", autoplay: (R = r.autoplay) != null ? R : false, backgroundColor: 0, loopAnimation: (j = r.loop) != null ? j : false, mode: M2(($ = r.mode) != null ? $ : "forward", g), segment: E2((U = r.segment) != null ? U : [], g), speed: (l1 = r.speed) != null ? l1 : 1, useFrameInterpolation: (T1 = r.useFrameInterpolation) != null ? T1 : true, marker: (K = r.marker) != null ? K : "", layout: P2(r.layout, g) }), this._eventManager.dispatch({ type: "ready" }), r.data ? this._loadFromData(r.data) : r.src && this._loadFromSrc(r.src), r.backgroundColor && this.setBackgroundColor(r.backgroundColor);
    }).catch((g) => {
      this._eventManager.dispatch({ type: "loadError", error: new Error(`Failed to load wasm module: ${g}`) });
    }), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
  }
  _dispatchError(r) {
    console.error(r), this._eventManager.dispatch({ type: "loadError", error: new Error(r) });
  }
  _fetchData(r) {
    return E(this, null, function* () {
      let a = yield fetch(r);
      if (!a.ok) throw new Error(`Failed to fetch animation data from URL: ${r}. ${a.status}: ${a.statusText}`);
      let h2 = yield a.arrayBuffer();
      return b2(h2) ? h2 : new TextDecoder().decode(h2);
    });
  }
  _loadFromData(r) {
    if (this._dotLottieCore === null) return;
    let a = this._canvas.width, h2 = this._canvas.height, d = false;
    if (typeof r == "string") {
      if (!L2(r)) {
        this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
        return;
      }
      d = this._dotLottieCore.loadAnimationData(r, a, h2);
    } else if (r instanceof ArrayBuffer) {
      if (!b2(r)) {
        this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
        return;
      }
      d = this._dotLottieCore.loadDotLottieData(r, a, h2);
    } else if (typeof r == "object") {
      if (!L2(r)) {
        this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
        return;
      }
      d = this._dotLottieCore.loadAnimationData(JSON.stringify(r), a, h2);
    } else {
      this._dispatchError(`Unsupported data type for animation data. Expected: 
          - string (Lottie JSON),
          - ArrayBuffer (dotLottie),
          - object (Lottie JSON). 
          Received: ${typeof r}`);
      return;
    }
    d ? (this._eventManager.dispatch({ type: "load" }), O && this.resize(), this._eventManager.dispatch({ type: "frame", currentFrame: this.currentFrame }), this._render(), this._dotLottieCore.config().autoplay && (this._dotLottieCore.play(), this._dotLottieCore.isPlaying() ? (this._eventManager.dispatch({ type: "play" }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))) : console.error("something went wrong, the animation was suppose to autoplay")), O && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && H.observe(this._canvas, this), this._renderConfig.autoResize && N.observe(this._canvas, this))) : this._dispatchError("Failed to load animation data");
  }
  _loadFromSrc(r) {
    this._fetchData(r).then((a) => this._loadFromData(a)).catch((a) => this._dispatchError(`Failed to load animation data from URL: ${r}. ${a}`));
  }
  get buffer() {
    return this._dotLottieCore ? this._dotLottieCore.buffer() : null;
  }
  get activeAnimationId() {
    var r;
    return (r = this._dotLottieCore) == null ? void 0 : r.activeAnimationId();
  }
  get activeThemeId() {
    var r;
    return (r = this._dotLottieCore) == null ? void 0 : r.activeThemeId();
  }
  get layout() {
    var a;
    let r = (a = this._dotLottieCore) == null ? void 0 : a.config().layout;
    if (r) return { align: [r.align.get(0), r.align.get(1)], fit: (() => {
      var h2, d, g, T, R, j;
      switch (r.fit) {
        case ((h2 = x2._wasmModule) == null ? void 0 : h2.Fit.Contain):
          return "contain";
        case ((d = x2._wasmModule) == null ? void 0 : d.Fit.Cover):
          return "cover";
        case ((g = x2._wasmModule) == null ? void 0 : g.Fit.Fill):
          return "fill";
        case ((T = x2._wasmModule) == null ? void 0 : T.Fit.FitHeight):
          return "fit-height";
        case ((R = x2._wasmModule) == null ? void 0 : R.Fit.FitWidth):
          return "fit-width";
        case ((j = x2._wasmModule) == null ? void 0 : j.Fit.None):
          return "none";
        default:
          return "contain";
      }
    })() };
  }
  get marker() {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.config().marker;
  }
  get manifest() {
    var r;
    try {
      let a = (r = this._dotLottieCore) == null ? void 0 : r.manifestString();
      if (this._dotLottieCore === null || !a) return null;
      let h2 = JSON.parse(a);
      return Object.keys(h2).length === 0 ? null : h2;
    } catch (a) {
      return null;
    }
  }
  get renderConfig() {
    return this._renderConfig;
  }
  get segment() {
    var a;
    let r = (a = this._dotLottieCore) == null ? void 0 : a.config().segment;
    if (r && r.size() === 2) return [r.get(0), r.get(1)];
  }
  get loop() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.config().loopAnimation) != null ? a : false;
  }
  get mode() {
    var a, h2, d, g;
    let r = (a = this._dotLottieCore) == null ? void 0 : a.config().mode;
    return r === ((h2 = x2._wasmModule) == null ? void 0 : h2.Mode.Reverse) ? "reverse" : r === ((d = x2._wasmModule) == null ? void 0 : d.Mode.Bounce) ? "bounce" : r === ((g = x2._wasmModule) == null ? void 0 : g.Mode.ReverseBounce) ? "reverse-bounce" : "forward";
  }
  get isFrozen() {
    return this._isFrozen;
  }
  get backgroundColor() {
    var r;
    return (r = this._backgroundColor) != null ? r : "";
  }
  get autoplay() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.config().autoplay) != null ? a : false;
  }
  get useFrameInterpolation() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.config().useFrameInterpolation) != null ? a : false;
  }
  get speed() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.config().speed) != null ? a : 0;
  }
  get isReady() {
    return this._dotLottieCore !== null;
  }
  get isLoaded() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.isLoaded()) != null ? a : false;
  }
  get isPlaying() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.isPlaying()) != null ? a : false;
  }
  get isPaused() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.isPaused()) != null ? a : false;
  }
  get isStopped() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.isStopped()) != null ? a : false;
  }
  get currentFrame() {
    return this._dotLottieCore ? Math.round(this._dotLottieCore.currentFrame() * 100) / 100 : 0;
  }
  get loopCount() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.loopCount()) != null ? a : 0;
  }
  get totalFrames() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.totalFrames()) != null ? a : 0;
  }
  get duration() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.duration()) != null ? a : 0;
  }
  get segmentDuration() {
    var r, a;
    return (a = (r = this._dotLottieCore) == null ? void 0 : r.segmentDuration()) != null ? a : 0;
  }
  get canvas() {
    return this._canvas;
  }
  load(r) {
    var a, h2, d, g, T, R, j, $, U;
    this._dotLottieCore === null || x2._wasmModule === null || (this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), this._isFrozen = false, this._dotLottieCore.setConfig({ themeId: (a = r.themeId) != null ? a : "", stateMachineId: "", autoplay: (h2 = r.autoplay) != null ? h2 : false, backgroundColor: 0, loopAnimation: (d = r.loop) != null ? d : false, mode: M2((g = r.mode) != null ? g : "forward", x2._wasmModule), segment: E2((T = r.segment) != null ? T : [], x2._wasmModule), speed: (R = r.speed) != null ? R : 1, useFrameInterpolation: (j = r.useFrameInterpolation) != null ? j : true, marker: ($ = r.marker) != null ? $ : "", layout: P2(r.layout, x2._wasmModule) }), r.data ? this._loadFromData(r.data) : r.src && this._loadFromSrc(r.src), this.setBackgroundColor((U = r.backgroundColor) != null ? U : ""));
  }
  _render() {
    if (this._dotLottieCore === null) return false;
    if (!this._context && "getContext" in this._canvas && typeof this._canvas.getContext == "function" && (this._context = this._canvas.getContext("2d")), this._dotLottieCore.render()) {
      if (this._context) {
        let a = this._dotLottieCore.buffer(), h2 = new Uint8ClampedArray(a, 0, this._canvas.width * this._canvas.height * 4), d = null;
        typeof ImageData == "undefined" ? (d = this._context.createImageData(this._canvas.width, this._canvas.height), d.data.set(h2)) : d = new ImageData(h2, this._canvas.width, this._canvas.height), this._context.putImageData(d, 0, 0);
      }
      return this._eventManager.dispatch({ type: "render", currentFrame: this.currentFrame }), true;
    }
    return false;
  }
  _draw() {
    if (!(this._dotLottieCore === null || !this._dotLottieCore.isPlaying())) try {
      let r = Math.round(this._dotLottieCore.requestFrame() * 1e3) / 1e3;
      if (this._dotLottieCore.setFrame(r) && (this._eventManager.dispatch({ type: "frame", currentFrame: this.currentFrame }), this._render() && this._dotLottieCore.isComplete())) if (this._dotLottieCore.config().loopAnimation) this._eventManager.dispatch({ type: "loop", loopCount: this._dotLottieCore.loopCount() });
      else {
        this._eventManager.dispatch({ type: "complete" });
        return;
      }
      this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this));
    } catch (r) {
      console.error("Error in animation frame:", r), this._eventManager.dispatch({ type: "renderError", error: r }), r instanceof WebAssembly.RuntimeError && this.destroy();
    }
  }
  play() {
    if (this._dotLottieCore === null) return;
    this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), (this._dotLottieCore.play() || this._dotLottieCore.isPlaying()) && (this._isFrozen = false, this._eventManager.dispatch({ type: "play" }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))), O && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !G1(this._canvas) && this.freeze();
  }
  pause() {
    if (this._dotLottieCore === null) return;
    (this._dotLottieCore.pause() || this._dotLottieCore.isPaused()) && this._eventManager.dispatch({ type: "pause" });
  }
  stop() {
    if (this._dotLottieCore === null) return;
    this._dotLottieCore.stop() && (this._eventManager.dispatch({ type: "frame", currentFrame: this.currentFrame }), this._render(), this._eventManager.dispatch({ type: "stop" }));
  }
  setFrame(r) {
    if (this._dotLottieCore === null || r < 0 || r > this._dotLottieCore.totalFrames()) return;
    this._dotLottieCore.seek(r) && (this._eventManager.dispatch({ type: "frame", currentFrame: this.currentFrame }), this._render());
  }
  setSpeed(r) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(z(D({}, this._dotLottieCore.config()), { speed: r }));
  }
  setBackgroundColor(r) {
    this._dotLottieCore !== null && (O && this._canvas instanceof HTMLCanvasElement ? this._canvas.style.backgroundColor = r : this._dotLottieCore.setConfig(z(D({}, this._dotLottieCore.config()), { backgroundColor: N3(r) })), this._backgroundColor = r);
  }
  setLoop(r) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(z(D({}, this._dotLottieCore.config()), { loopAnimation: r }));
  }
  setUseFrameInterpolation(r) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(z(D({}, this._dotLottieCore.config()), { useFrameInterpolation: r }));
  }
  addEventListener(r, a) {
    this._eventManager.addEventListener(r, a);
  }
  removeEventListener(r, a) {
    this._eventManager.removeEventListener(r, a);
  }
  destroy() {
    var r;
    this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), O && this._canvas instanceof HTMLCanvasElement && (H.unobserve(this._canvas), N.unobserve(this._canvas)), (r = this._dotLottieCore) == null || r.delete(), this._dotLottieCore = null, this._context = null, this._eventManager.dispatch({ type: "destroy" }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
  }
  freeze() {
    this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null, this._isFrozen = true, this._eventManager.dispatch({ type: "freeze" }));
  }
  unfreeze() {
    this._animationFrameId === null && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this)), this._isFrozen = false, this._eventManager.dispatch({ type: "unfreeze" }));
  }
  resize() {
    if (!this._dotLottieCore || !this.isLoaded) return;
    if (O && this._canvas instanceof HTMLCanvasElement) {
      let a = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, { height: h2, width: d } = this._canvas.getBoundingClientRect();
      h2 !== 0 && d !== 0 && (this._canvas.width = d * a, this._canvas.height = h2 * a);
    }
    this._dotLottieCore.resize(this._canvas.width, this._canvas.height) && this._render();
  }
  setSegment(r, a) {
    this._dotLottieCore === null || x2._wasmModule === null || this._dotLottieCore.setConfig(z(D({}, this._dotLottieCore.config()), { segment: E2([r, a], x2._wasmModule) }));
  }
  setMode(r) {
    this._dotLottieCore === null || x2._wasmModule === null || this._dotLottieCore.setConfig(z(D({}, this._dotLottieCore.config()), { mode: M2(r, x2._wasmModule) }));
  }
  setRenderConfig(r) {
    let g = r, { devicePixelRatio: a, freezeOnOffscreen: h2 } = g, d = V1(g, ["devicePixelRatio", "freezeOnOffscreen"]);
    this._renderConfig = z(D(D({}, this._renderConfig), d), { devicePixelRatio: a || e1(), freezeOnOffscreen: h2 != null ? h2 : true }), O && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? N.observe(this._canvas, this) : N.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? H.observe(this._canvas, this) : (H.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
  }
  loadAnimation(r) {
    if (this._dotLottieCore === null || this._dotLottieCore.activeAnimationId() === r) return;
    this._dotLottieCore.loadAnimation(r, this._canvas.width, this._canvas.height) ? (this._eventManager.dispatch({ type: "load" }), this.resize()) : this._eventManager.dispatch({ type: "loadError", error: new Error(`Failed to animation :${r}`) });
  }
  setMarker(r) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(z(D({}, this._dotLottieCore.config()), { marker: r }));
  }
  markers() {
    var a;
    let r = (a = this._dotLottieCore) == null ? void 0 : a.markers();
    if (r) {
      let h2 = [];
      for (let d = 0; d < r.size(); d += 1) {
        let g = r.get(d);
        h2.push({ name: g.name, time: g.time, duration: g.duration });
      }
      return h2;
    }
    return [];
  }
  setTheme(r) {
    if (this._dotLottieCore === null) return false;
    let a = this._dotLottieCore.setTheme(r);
    return this._render(), a;
  }
  resetTheme() {
    return this._dotLottieCore === null ? false : this._dotLottieCore.resetTheme();
  }
  setThemeData(r) {
    if (this._dotLottieCore === null) return false;
    let a = this._dotLottieCore.setThemeData(r);
    return this._render(), a;
  }
  setSlots(r) {
    this._dotLottieCore !== null && this._dotLottieCore.setSlots(r);
  }
  setLayout(r) {
    this._dotLottieCore === null || x2._wasmModule === null || this._dotLottieCore.setConfig(z(D({}, this._dotLottieCore.config()), { layout: P2(r, x2._wasmModule) }));
  }
  setViewport(r, a, h2, d) {
    return this._dotLottieCore === null ? false : this._dotLottieCore.setViewport(r, a, h2, d);
  }
  static setWasmUrl(r) {
    o1.setWasmUrl(r);
  }
  loadStateMachine(r) {
    var a, h2;
    return (h2 = (a = this._dotLottieCore) == null ? void 0 : a.stateMachineLoad(r)) != null ? h2 : false;
  }
  startStateMachine() {
    if (x2._wasmModule === null || this._dotLottieCore === null) return false;
    let r = x2._wasmModule.createDefaultOpenURL(), a = this._dotLottieCore.stateMachineStart(r);
    return a && this._setupStateMachineListeners(), a;
  }
  stopStateMachine() {
    var a, h2;
    let r = (h2 = (a = this._dotLottieCore) == null ? void 0 : a.stateMachineStop()) != null ? h2 : false;
    return r && this._cleanupStateMachineListeners(), r;
  }
  _getPointerPosition(r) {
    let a = this._canvas.getBoundingClientRect(), h2 = this._canvas.width / a.width, d = this._canvas.height / a.height, g = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, T = (r.clientX - a.left) * h2 / g, R = (r.clientY - a.top) * d / g;
    return { x: T, y: R };
  }
  _onPointerUp(r) {
    let { x: a, y: h2 } = this._getPointerPosition(r);
    this.postPointerUpEvent(a, h2);
  }
  _onPointerDown(r) {
    let { x: a, y: h2 } = this._getPointerPosition(r);
    this.postPointerDownEvent(a, h2);
  }
  _onPointerMove(r) {
    let { x: a, y: h2 } = this._getPointerPosition(r);
    this.postPointerMoveEvent(a, h2);
  }
  _onPointerEnter(r) {
    let { x: a, y: h2 } = this._getPointerPosition(r);
    this.postPointerEnterEvent(a, h2);
  }
  _onPointerLeave(r) {
    let { x: a, y: h2 } = this._getPointerPosition(r);
    this.postPointerExitEvent(a, h2);
  }
  postPointerUpEvent(r, a) {
    var h2;
    return (h2 = this._dotLottieCore) == null ? void 0 : h2.stateMachinePostPointerUpEvent(r, a);
  }
  postPointerDownEvent(r, a) {
    var h2;
    return (h2 = this._dotLottieCore) == null ? void 0 : h2.stateMachinePostPointerDownEvent(r, a);
  }
  postPointerMoveEvent(r, a) {
    var h2;
    return (h2 = this._dotLottieCore) == null ? void 0 : h2.stateMachinePostPointerMoveEvent(r, a);
  }
  postPointerEnterEvent(r, a) {
    var h2;
    return (h2 = this._dotLottieCore) == null ? void 0 : h2.stateMachinePostPointerEnterEvent(r, a);
  }
  postPointerExitEvent(r, a) {
    var h2;
    return (h2 = this._dotLottieCore) == null ? void 0 : h2.stateMachinePostPointerExitEvent(r, a);
  }
  getStateMachineListeners() {
    if (!this._dotLottieCore) return [];
    let r = this._dotLottieCore.stateMachineFrameworkSetup(), a = [];
    for (let h2 = 0; h2 < r.size(); h2 += 1) a.push(r.get(h2));
    return a;
  }
  _setupStateMachineListeners() {
    if (O && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
      let r = this.getStateMachineListeners();
      r.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), r.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), r.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), r.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), r.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
    }
  }
  _cleanupStateMachineListeners() {
    O && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
  }
  loadStateMachineData(r) {
    var a, h2;
    return (h2 = (a = this._dotLottieCore) == null ? void 0 : a.stateMachineLoadData(r)) != null ? h2 : false;
  }
  animationSize() {
    var h2, d, g, T;
    let r = (d = (h2 = this._dotLottieCore) == null ? void 0 : h2.animationSize().get(0)) != null ? d : 0, a = (T = (g = this._dotLottieCore) == null ? void 0 : g.animationSize().get(1)) != null ? T : 0;
    return { width: r, height: a };
  }
  setStateMachineBooleanContext(r, a) {
    var h2, d;
    return (d = (h2 = this._dotLottieCore) == null ? void 0 : h2.stateMachineSetBooleanInput(r, a)) != null ? d : false;
  }
  setStateMachineNumericContext(r, a) {
    var h2, d;
    return (d = (h2 = this._dotLottieCore) == null ? void 0 : h2.stateMachineSetNumericInput(r, a)) != null ? d : false;
  }
  setStateMachineStringContext(r, a) {
    var h2, d;
    return (d = (h2 = this._dotLottieCore) == null ? void 0 : h2.stateMachineSetStringInput(r, a)) != null ? d : false;
  }
  getLayerBoundingBox(r) {
    var d;
    let a = (d = this._dotLottieCore) == null ? void 0 : d.getLayerBounds(r);
    if (!a || a.size() !== 8) return;
    let h2 = [];
    for (let g = 0; g < 8; g += 1) h2.push(a.get(g));
    return h2;
  }
  static transformThemeToLottieSlots(r, a) {
    var h2, d;
    return (d = (h2 = x2._wasmModule) == null ? void 0 : h2.transformThemeToLottieSlots(r, a)) != null ? d : "";
  }
};
b(x, "_wasmModule", null);
var V3 = x;
var I2 = class {
  constructor() {
    if (typeof Worker == "undefined") throw new Error("Worker is not supported in this environment.");
    let r = new Blob([new Uint8Array([34, 117, 115, 101, 32, 115, 116, 114, 105, 99, 116, 34, 59, 10, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 105, 101, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 68, 101, 115, 99, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 68, 101, 115, 99, 114, 105, 112, 116, 111, 114, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 83, 121, 109, 98, 111, 108, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 112, 114, 111, 112, 101, 114, 116, 121, 73, 115, 69, 110, 117, 109, 101, 114, 97, 98, 108, 101, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 32, 61, 32, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 107, 101, 121, 32, 105, 110, 32, 111, 98, 106, 32, 63, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 123, 32, 101, 110, 117, 109, 101, 114, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 99, 111, 110, 102, 105, 103, 117, 114, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 119, 114, 105, 116, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 118, 97, 108, 117, 101, 32, 125, 41, 32, 58, 32, 111, 98, 106, 91, 107, 101, 121, 93, 32, 61, 32, 118, 97, 108, 117, 101, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 105, 110, 32, 98, 32, 124, 124, 32, 40, 98, 32, 61, 32, 123, 125, 41, 41, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 46, 99, 97, 108, 108, 40, 98, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 97, 44, 32, 112, 114, 111, 112, 44, 32, 98, 91, 112, 114, 111, 112, 93, 41, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 41, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 111, 102, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 40, 98, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 46, 99, 97, 108, 108, 40, 98, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 97, 44, 32, 112, 114, 111, 112, 44, 32, 98, 91, 112, 114, 111, 112, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 115, 40, 97, 44, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 68, 101, 115, 99, 115, 40, 98, 41, 41, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 111, 98, 106, 82, 101, 115, 116, 32, 61, 32, 40, 115, 111, 117, 114, 99, 101, 44, 32, 101, 120, 99, 108, 117, 100, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 118, 97, 114, 32, 116, 97, 114, 103, 101, 116, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 105, 110, 32, 115, 111, 117, 114, 99, 101, 41, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 46, 99, 97, 108, 108, 40, 115, 111, 117, 114, 99, 101, 44, 32, 112, 114, 111, 112, 41, 32, 38, 38, 32, 101, 120, 99, 108, 117, 100, 101, 46, 105, 110, 100, 101, 120, 79, 102, 40, 112, 114, 111, 112, 41, 32, 60, 32, 48, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 114, 103, 101, 116, 91, 112, 114, 111, 112, 93, 32, 61, 32, 115, 111, 117, 114, 99, 101, 91, 112, 114, 111, 112, 93, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 115, 111, 117, 114, 99, 101, 32, 33, 61, 32, 110, 117, 108, 108, 32, 38, 38, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 41, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 111, 102, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 40, 115, 111, 117, 114, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 120, 99, 108, 117, 100, 101, 46, 105, 110, 100, 101, 120, 79, 102, 40, 112, 114, 111, 112, 41, 32, 60, 32, 48, 32, 38, 38, 32, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 46, 99, 97, 108, 108, 40, 115, 111, 117, 114, 99, 101, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 114, 103, 101, 116, 91, 112, 114, 111, 112, 93, 32, 61, 32, 115, 111, 117, 114, 99, 101, 91, 112, 114, 111, 112, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 97, 114, 103, 101, 116, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 32, 61, 32, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 111, 98, 106, 44, 32, 116, 121, 112, 101, 111, 102, 32, 107, 101, 121, 32, 33, 61, 61, 32, 34, 115, 121, 109, 98, 111, 108, 34, 32, 63, 32, 107, 101, 121, 32, 43, 32, 34, 34, 32, 58, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 97, 115, 121, 110, 99, 32, 61, 32, 40, 95, 95, 116, 104, 105, 115, 44, 32, 95, 95, 97, 114, 103, 117, 109, 101, 110, 116, 115, 44, 32, 103, 101, 110, 101, 114, 97, 116, 111, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 80, 114, 111, 109, 105, 115, 101, 40, 40, 114, 101, 115, 111, 108, 118, 101, 44, 32, 114, 101, 106, 101, 99, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 117, 108, 102, 105, 108, 108, 101, 100, 32, 61, 32, 40, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 110, 101, 120, 116, 40, 118, 97, 108, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 106, 101, 99, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 101, 106, 101, 99, 116, 101, 100, 32, 61, 32, 40, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 116, 104, 114, 111, 119, 40, 118, 97, 108, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 106, 101, 99, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 115, 116, 101, 112, 32, 61, 32, 40, 120, 41, 32, 61, 62, 32, 120, 46, 100, 111, 110, 101, 32, 63, 32, 114, 101, 115, 111, 108, 118, 101, 40, 120, 46, 118, 97, 108, 117, 101, 41, 32, 58, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 115, 111, 108, 118, 101, 40, 120, 46, 118, 97, 108, 117, 101, 41, 46, 116, 104, 101, 110, 40, 102, 117, 108, 102, 105, 108, 108, 101, 100, 44, 32, 114, 101, 106, 101, 99, 116, 101, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 32, 61, 32, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 97, 112, 112, 108, 121, 40, 95, 95, 116, 104, 105, 115, 44, 32, 95, 95, 97, 114, 103, 117, 109, 101, 110, 116, 115, 41, 41, 46, 110, 101, 120, 116, 40, 41, 41, 59, 10, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 97, 110, 105, 109, 97, 116, 105, 111, 110, 45, 102, 114, 97, 109, 101, 45, 109, 97, 110, 97, 103, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 87, 101, 98, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 78, 111, 100, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 34, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 62, 61, 32, 78, 117, 109, 98, 101, 114, 46, 77, 65, 88, 95, 83, 65, 70, 69, 95, 73, 78, 84, 69, 71, 69, 82, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 43, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 32, 61, 32, 115, 101, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 108, 108, 98, 97, 99, 107, 40, 68, 97, 116, 101, 46, 110, 111, 119, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 95, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 101, 97, 114, 73, 109, 109, 101, 100, 105, 97, 116, 101, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 115, 116, 114, 97, 116, 101, 103, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 63, 32, 110, 101, 119, 32, 87, 101, 98, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 40, 41, 32, 58, 32, 110, 101, 119, 32, 78, 111, 100, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 110, 115, 116, 97, 110, 116, 115, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 119, 105, 110, 100, 111, 119, 32, 33, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 38, 38, 32, 116, 121, 112, 101, 111, 102, 32, 119, 105, 110, 100, 111, 119, 46, 100, 111, 99, 117, 109, 101, 110, 116, 32, 33, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 59, 10, 32, 32, 118, 97, 114, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 91, 56, 48, 44, 32, 55, 53, 44, 32, 51, 44, 32, 52, 93, 41, 59, 10, 32, 32, 118, 97, 114, 32, 76, 79, 84, 84, 73, 69, 95, 74, 83, 79, 78, 95, 77, 65, 78, 68, 65, 84, 79, 82, 89, 95, 70, 73, 69, 76, 68, 83, 32, 61, 32, 91, 34, 118, 34, 44, 32, 34, 105, 112, 34, 44, 32, 34, 111, 112, 34, 44, 32, 34, 108, 97, 121, 101, 114, 115, 34, 44, 32, 34, 102, 114, 34, 44, 32, 34, 119, 34, 44, 32, 34, 104, 34, 93, 59, 10, 32, 32, 118, 97, 114, 32, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 32, 61, 32, 34, 48, 46, 52, 52, 46, 48, 34, 59, 10, 32, 32, 118, 97, 114, 32, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 32, 61, 32, 34, 64, 108, 111, 116, 116, 105, 101, 102, 105, 108, 101, 115, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 119, 101, 98, 34, 59, 10, 32, 32, 118, 97, 114, 32, 68, 69, 70, 65, 85, 76, 84, 95, 68, 80, 82, 95, 70, 65, 67, 84, 79, 82, 32, 61, 32, 48, 46, 55, 53, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 114, 101, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 106, 115, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 77, 111, 100, 117, 108, 101, 32, 61, 32, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 118, 97, 114, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 111, 99, 117, 109, 101, 110, 116, 32, 33, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 63, 32, 40, 95, 97, 32, 61, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 114, 99, 32, 58, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 109, 111, 100, 117, 108, 101, 65, 114, 103, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 109, 111, 100, 117, 108, 101, 65, 114, 103, 44, 32, 97, 97, 44, 32, 98, 97, 44, 32, 99, 97, 32, 61, 32, 110, 101, 119, 32, 80, 114, 111, 109, 105, 115, 101, 40, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 44, 32, 100, 97, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 123, 125, 44, 32, 108, 41, 44, 32, 101, 97, 32, 61, 32, 34, 46, 47, 116, 104, 105, 115, 46, 112, 114, 111, 103, 114, 97, 109, 34, 44, 32, 112, 32, 61, 32, 34, 34, 44, 32, 102, 97, 59, 10, 32, 32, 32, 32, 32, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 111, 99, 117, 109, 101, 110, 116, 32, 38, 38, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 32, 38, 38, 32, 40, 112, 32, 61, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 32, 38, 38, 32, 40, 112, 32, 61, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 112, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 98, 108, 111, 98, 58, 34, 41, 32, 63, 32, 112, 32, 61, 32, 34, 34, 32, 58, 32, 112, 32, 61, 32, 112, 46, 115, 117, 98, 115, 116, 114, 40, 48, 44, 32, 112, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 91, 63, 35, 93, 46, 42, 47, 44, 32, 34, 34, 41, 46, 108, 97, 115, 116, 73, 110, 100, 101, 120, 79, 102, 40, 34, 47, 34, 41, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 102, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 102, 101, 116, 99, 104, 40, 97, 44, 32, 123, 32, 99, 114, 101, 100, 101, 110, 116, 105, 97, 108, 115, 58, 32, 34, 115, 97, 109, 101, 45, 111, 114, 105, 103, 105, 110, 34, 32, 125, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 98, 41, 32, 61, 62, 32, 98, 46, 111, 107, 32, 63, 32, 98, 46, 97, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 40, 41, 32, 58, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 106, 101, 99, 116, 40, 69, 114, 114, 111, 114, 40, 98, 46, 115, 116, 97, 116, 117, 115, 32, 43, 32, 34, 32, 58, 32, 34, 32, 43, 32, 98, 46, 117, 114, 108, 41, 41, 10, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 97, 32, 61, 32, 108, 46, 112, 114, 105, 110, 116, 32, 124, 124, 32, 99, 111, 110, 115, 111, 108, 101, 46, 108, 111, 103, 46, 98, 105, 110, 100, 40, 99, 111, 110, 115, 111, 108, 101, 41, 44, 32, 113, 32, 61, 32, 108, 46, 112, 114, 105, 110, 116, 69, 114, 114, 32, 124, 124, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 46, 98, 105, 110, 100, 40, 99, 111, 110, 115, 111, 108, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 108, 44, 32, 100, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 100, 97, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 116, 104, 105, 115, 80, 114, 111, 103, 114, 97, 109, 32, 38, 38, 32, 40, 101, 97, 32, 61, 32, 108, 46, 116, 104, 105, 115, 80, 114, 111, 103, 114, 97, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 105, 97, 32, 61, 32, 108, 46, 119, 97, 115, 109, 66, 105, 110, 97, 114, 121, 44, 32, 106, 97, 44, 32, 107, 97, 32, 61, 32, 102, 97, 108, 115, 101, 44, 32, 110, 97, 44, 32, 114, 44, 32, 116, 44, 32, 119, 44, 32, 120, 44, 32, 65, 44, 32, 66, 44, 32, 111, 97, 44, 32, 112, 97, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 113, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 106, 97, 46, 98, 117, 102, 102, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 46, 72, 69, 65, 80, 56, 32, 61, 32, 114, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 56, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 46, 72, 69, 65, 80, 49, 54, 32, 61, 32, 119, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 49, 54, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 46, 72, 69, 65, 80, 85, 56, 32, 61, 32, 116, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 46, 72, 69, 65, 80, 85, 49, 54, 32, 61, 32, 120, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 49, 54, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 46, 72, 69, 65, 80, 51, 50, 32, 61, 32, 65, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 46, 72, 69, 65, 80, 85, 51, 50, 32, 61, 32, 66, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 46, 72, 69, 65, 80, 70, 51, 50, 32, 61, 32, 111, 97, 32, 61, 32, 110, 101, 119, 32, 70, 108, 111, 97, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 46, 72, 69, 65, 80, 70, 54, 52, 32, 61, 32, 112, 97, 32, 61, 32, 110, 101, 119, 32, 70, 108, 111, 97, 116, 54, 52, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 97, 32, 61, 32, 91, 93, 44, 32, 115, 97, 32, 61, 32, 91, 93, 44, 32, 116, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 108, 46, 112, 114, 101, 82, 117, 110, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 67, 32, 61, 32, 48, 44, 32, 118, 97, 32, 61, 32, 110, 117, 108, 108, 44, 32, 68, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 108, 46, 111, 110, 65, 98, 111, 114, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 108, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 34, 65, 98, 111, 114, 116, 101, 100, 40, 34, 32, 43, 32, 97, 32, 43, 32, 34, 41, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 113, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 97, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 110, 101, 119, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 82, 117, 110, 116, 105, 109, 101, 69, 114, 114, 111, 114, 40, 97, 32, 43, 32, 34, 46, 32, 66, 117, 105, 108, 100, 32, 119, 105, 116, 104, 32, 45, 115, 65, 83, 83, 69, 82, 84, 73, 79, 78, 83, 32, 102, 111, 114, 32, 109, 111, 114, 101, 32, 105, 110, 102, 111, 46, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 120, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 97, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 100, 97, 116, 97, 58, 97, 112, 112, 108, 105, 99, 97, 116, 105, 111, 110, 47, 111, 99, 116, 101, 116, 45, 115, 116, 114, 101, 97, 109, 59, 98, 97, 115, 101, 54, 52, 44, 34, 41, 44, 32, 121, 97, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 122, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 32, 61, 61, 32, 121, 97, 32, 38, 38, 32, 105, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 105, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 34, 98, 111, 116, 104, 32, 97, 115, 121, 110, 99, 32, 97, 110, 100, 32, 115, 121, 110, 99, 32, 102, 101, 116, 99, 104, 105, 110, 103, 32, 111, 102, 32, 116, 104, 101, 32, 119, 97, 115, 109, 32, 102, 97, 105, 108, 101, 100, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 65, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 97, 32, 63, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 115, 111, 108, 118, 101, 40, 41, 46, 116, 104, 101, 110, 40, 40, 41, 32, 61, 62, 32, 122, 97, 40, 97, 41, 41, 32, 58, 32, 102, 97, 40, 97, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 98, 41, 32, 61, 62, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 41, 32, 61, 62, 32, 122, 97, 40, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 66, 97, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 65, 97, 40, 97, 41, 46, 116, 104, 101, 110, 40, 40, 100, 41, 32, 61, 62, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 40, 100, 44, 32, 98, 41, 41, 46, 116, 104, 101, 110, 40, 99, 44, 32, 40, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 40, 96, 102, 97, 105, 108, 101, 100, 32, 116, 111, 32, 97, 115, 121, 110, 99, 104, 114, 111, 110, 111, 117, 115, 108, 121, 32, 112, 114, 101, 112, 97, 114, 101, 32, 119, 97, 115, 109, 58, 32, 36, 123, 100, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 67, 97, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 121, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 97, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 83, 116, 114, 101, 97, 109, 105, 110, 103, 32, 124, 124, 32, 120, 97, 40, 99, 41, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 102, 101, 116, 99, 104, 32, 63, 32, 66, 97, 40, 99, 44, 32, 97, 44, 32, 98, 41, 32, 58, 32, 102, 101, 116, 99, 104, 40, 99, 44, 32, 123, 32, 99, 114, 101, 100, 101, 110, 116, 105, 97, 108, 115, 58, 32, 34, 115, 97, 109, 101, 45, 111, 114, 105, 103, 105, 110, 34, 32, 125, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 100, 41, 32, 61, 62, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 83, 116, 114, 101, 97, 109, 105, 110, 103, 40, 100, 44, 32, 97, 41, 46, 116, 104, 101, 110, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 40, 96, 119, 97, 115, 109, 32, 115, 116, 114, 101, 97, 109, 105, 110, 103, 32, 99, 111, 109, 112, 105, 108, 101, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 40, 34, 102, 97, 108, 108, 105, 110, 103, 32, 98, 97, 99, 107, 32, 116, 111, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 66, 97, 40, 99, 44, 32, 97, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 108, 97, 115, 115, 32, 68, 97, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 110, 97, 109, 101, 34, 44, 32, 34, 69, 120, 105, 116, 83, 116, 97, 116, 117, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 96, 80, 114, 111, 103, 114, 97, 109, 32, 116, 101, 114, 109, 105, 110, 97, 116, 101, 100, 32, 119, 105, 116, 104, 32, 101, 120, 105, 116, 40, 36, 123, 97, 125, 41, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 116, 97, 116, 117, 115, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 48, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 97, 46, 115, 104, 105, 102, 116, 40, 41, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 70, 97, 32, 61, 32, 108, 46, 110, 111, 69, 120, 105, 116, 82, 117, 110, 116, 105, 109, 101, 32, 124, 124, 32, 116, 114, 117, 101, 44, 32, 71, 97, 32, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 32, 63, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 44, 32, 72, 32, 61, 32, 40, 97, 44, 32, 98, 32, 61, 32, 48, 44, 32, 99, 32, 61, 32, 78, 97, 78, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 32, 43, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 99, 32, 61, 32, 98, 59, 32, 97, 91, 99, 93, 32, 38, 38, 32, 33, 40, 99, 32, 62, 61, 32, 100, 41, 59, 32, 41, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 54, 32, 60, 32, 99, 32, 45, 32, 98, 32, 38, 38, 32, 97, 46, 98, 117, 102, 102, 101, 114, 32, 38, 38, 32, 71, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 71, 97, 46, 100, 101, 99, 111, 100, 101, 40, 97, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 98, 44, 32, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 100, 32, 61, 32, 34, 34, 59, 32, 98, 32, 60, 32, 99, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 97, 91, 98, 43, 43, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 38, 32, 49, 50, 56, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 57, 50, 32, 61, 61, 32, 40, 101, 32, 38, 32, 50, 50, 52, 41, 41, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 40, 101, 32, 38, 32, 51, 49, 41, 32, 60, 60, 32, 54, 32, 124, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 50, 50, 52, 32, 61, 61, 32, 40, 101, 32, 38, 32, 50, 52, 48, 41, 32, 63, 32, 40, 101, 32, 38, 32, 49, 53, 41, 32, 60, 60, 32, 49, 50, 32, 124, 32, 102, 32, 60, 60, 32, 54, 32, 124, 32, 104, 32, 58, 32, 40, 101, 32, 38, 32, 55, 41, 32, 60, 60, 32, 49, 56, 32, 124, 32, 102, 32, 60, 60, 32, 49, 50, 32, 124, 32, 104, 32, 60, 60, 32, 54, 32, 124, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 54, 53, 53, 51, 54, 32, 62, 32, 101, 32, 63, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 32, 58, 32, 40, 101, 32, 45, 61, 32, 54, 53, 53, 51, 54, 44, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 53, 53, 50, 57, 54, 32, 124, 32, 101, 32, 62, 62, 32, 49, 48, 44, 32, 53, 54, 51, 50, 48, 32, 124, 32, 101, 32, 38, 32, 49, 48, 50, 51, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 72, 97, 32, 61, 32, 91, 93, 44, 32, 73, 97, 32, 61, 32, 48, 44, 32, 73, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 99, 108, 97, 115, 115, 32, 74, 97, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 70, 99, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 100, 99, 32, 61, 32, 97, 32, 45, 32, 50, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 77, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 73, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 75, 97, 40, 48, 41, 44, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 110, 101, 119, 32, 74, 97, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 99, 46, 100, 99, 32, 43, 32, 49, 54, 32, 62, 62, 32, 50, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 66, 91, 99, 46, 100, 99, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 100, 41, 32, 114, 101, 116, 117, 114, 110, 32, 75, 97, 40, 48, 41, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 111, 102, 32, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 101, 32, 124, 124, 32, 101, 32, 61, 61, 61, 32, 100, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 76, 97, 40, 101, 44, 32, 100, 44, 32, 99, 46, 100, 99, 32, 43, 32, 49, 54, 41, 41, 32, 114, 101, 116, 117, 114, 110, 32, 75, 97, 40, 101, 41, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 75, 97, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 78, 97, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 116, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 60, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 98, 32, 43, 32, 99, 32, 45, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 53, 53, 50, 57, 54, 32, 60, 61, 32, 102, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 43, 43, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 54, 53, 53, 51, 54, 32, 43, 32, 40, 40, 102, 32, 38, 32, 49, 48, 50, 51, 41, 32, 60, 60, 32, 49, 48, 41, 32, 124, 32, 104, 32, 38, 32, 49, 48, 50, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 50, 55, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 48, 52, 55, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 49, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 57, 50, 32, 124, 32, 102, 32, 62, 62, 32, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 54, 53, 53, 51, 53, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 50, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 50, 50, 52, 32, 124, 32, 102, 32, 62, 62, 32, 49, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 51, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 50, 52, 48, 32, 124, 32, 102, 32, 62, 62, 32, 49, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 62, 62, 32, 49, 50, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 62, 62, 32, 54, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 74, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 40, 98, 44, 32, 34, 110, 97, 109, 101, 34, 44, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 97, 32, 125, 41, 44, 32, 79, 97, 32, 61, 32, 91, 93, 44, 32, 75, 32, 61, 32, 91, 93, 44, 32, 76, 44, 32, 80, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 77, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 67, 97, 110, 110, 111, 116, 32, 117, 115, 101, 32, 100, 101, 108, 101, 116, 101, 100, 32, 118, 97, 108, 46, 32, 104, 97, 110, 100, 108, 101, 32, 61, 32, 34, 32, 43, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 75, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 81, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 118, 111, 105, 100, 32, 48, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 110, 117, 108, 108, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 116, 114, 117, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 102, 97, 108, 115, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 32, 61, 32, 79, 97, 46, 112, 111, 112, 40, 41, 32, 124, 124, 32, 75, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 91, 98, 93, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 91, 98, 32, 43, 32, 49, 93, 32, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 69, 114, 114, 111, 114, 44, 32, 99, 32, 61, 32, 74, 40, 97, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 69, 114, 114, 111, 114, 40, 100, 41, 46, 115, 116, 97, 99, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 100, 32, 38, 38, 32, 40, 116, 104, 105, 115, 46, 115, 116, 97, 99, 107, 32, 61, 32, 116, 104, 105, 115, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 32, 43, 32, 34, 92, 110, 34, 32, 43, 32, 100, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 94, 69, 114, 114, 111, 114, 40, 58, 91, 94, 92, 110, 93, 42, 41, 63, 92, 110, 47, 44, 32, 34, 34, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 116, 111, 83, 116, 114, 105, 110, 103, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 63, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 58, 32, 96, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 58, 32, 36, 123, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 83, 97, 44, 32, 84, 97, 44, 32, 78, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 34, 34, 59, 32, 116, 91, 97, 93, 59, 32, 41, 32, 98, 32, 43, 61, 32, 84, 97, 91, 116, 91, 97, 43, 43, 93, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 85, 97, 32, 61, 32, 123, 125, 44, 32, 86, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 112, 116, 114, 32, 115, 104, 111, 117, 108, 100, 32, 110, 111, 116, 32, 98, 101, 32, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 97, 46, 105, 99, 59, 32, 41, 32, 98, 32, 61, 32, 97, 46, 116, 99, 40, 98, 41, 44, 32, 97, 32, 61, 32, 97, 46, 105, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 79, 32, 61, 32, 123, 125, 44, 32, 89, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 88, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 78, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 90, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 79, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 41, 32, 116, 104, 114, 111, 119, 32, 97, 32, 61, 32, 96, 36, 123, 98, 125, 32, 104, 97, 115, 32, 117, 110, 107, 110, 111, 119, 110, 32, 116, 121, 112, 101, 32, 36, 123, 89, 97, 40, 97, 41, 125, 96, 44, 32, 110, 101, 119, 32, 76, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 36, 97, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 97, 98, 32, 61, 32, 102, 97, 108, 115, 101, 44, 32, 98, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 61, 61, 61, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 46, 105, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 98, 40, 97, 44, 32, 98, 44, 32, 99, 46, 105, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 32, 61, 61, 61, 32, 97, 32, 63, 32, 110, 117, 108, 108, 32, 58, 32, 99, 46, 69, 99, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 99, 98, 32, 61, 32, 123, 125, 44, 32, 100, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 86, 97, 40, 97, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 97, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 101, 98, 44, 32, 102, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 102, 99, 32, 124, 124, 32, 33, 98, 46, 100, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 101, 98, 40, 34, 109, 97, 107, 101, 67, 108, 97, 115, 115, 72, 97, 110, 100, 108, 101, 32, 114, 101, 113, 117, 105, 114, 101, 115, 32, 112, 116, 114, 32, 97, 110, 100, 32, 112, 116, 114, 84, 121, 112, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 33, 98, 46, 108, 99, 32, 33, 61, 61, 32, 33, 33, 98, 46, 106, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 101, 98, 40, 34, 66, 111, 116, 104, 32, 115, 109, 97, 114, 116, 80, 116, 114, 84, 121, 112, 101, 32, 97, 110, 100, 32, 115, 109, 97, 114, 116, 80, 116, 114, 32, 109, 117, 115, 116, 32, 98, 101, 32, 115, 112, 101, 99, 105, 102, 105, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 99, 111, 117, 110, 116, 32, 61, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 49, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 81, 40, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 97, 44, 32, 123, 32, 99, 99, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 98, 44, 32, 119, 114, 105, 116, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 32, 125, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 81, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 61, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 70, 105, 110, 97, 108, 105, 122, 97, 116, 105, 111, 110, 82, 101, 103, 105, 115, 116, 114, 121, 41, 32, 114, 101, 116, 117, 114, 110, 32, 81, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 98, 44, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 98, 32, 61, 32, 110, 101, 119, 32, 70, 105, 110, 97, 108, 105, 122, 97, 116, 105, 111, 110, 82, 101, 103, 105, 115, 116, 114, 121, 40, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 46, 99, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 45, 98, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 98, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 38, 38, 32, 40, 98, 46, 106, 99, 32, 63, 32, 98, 46, 108, 99, 46, 110, 99, 40, 98, 46, 106, 99, 41, 32, 58, 32, 98, 46, 102, 99, 46, 101, 99, 46, 110, 99, 40, 98, 46, 100, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 46, 99, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 106, 99, 32, 38, 38, 32, 97, 98, 46, 114, 101, 103, 105, 115, 116, 101, 114, 40, 98, 44, 32, 123, 32, 99, 99, 58, 32, 99, 32, 125, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 36, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 98, 46, 117, 110, 114, 101, 103, 105, 115, 116, 101, 114, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 81, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 103, 98, 32, 61, 32, 123, 125, 44, 32, 104, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 46, 112, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 112, 111, 112, 40, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 66, 91, 97, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 82, 32, 61, 32, 123, 125, 44, 32, 106, 98, 32, 61, 32, 123, 125, 44, 32, 84, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 99, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 46, 108, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 97, 46, 108, 101, 110, 103, 116, 104, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 101, 98, 40, 34, 77, 105, 115, 109, 97, 116, 99, 104, 101, 100, 32, 116, 121, 112, 101, 32, 99, 111, 110, 118, 101, 114, 116, 101, 114, 32, 99, 111, 117, 110, 116, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 107, 32, 61, 32, 48, 59, 32, 107, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 107, 41, 32, 83, 40, 97, 91, 107, 93, 44, 32, 103, 91, 107, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 103, 41, 32, 61, 62, 32, 106, 98, 91, 103, 93, 32, 61, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 65, 114, 114, 97, 121, 40, 98, 46, 108, 101, 110, 103, 116, 104, 41, 44, 32, 102, 32, 61, 32, 91, 93, 44, 32, 104, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 103, 44, 32, 107, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 32, 63, 32, 101, 91, 107, 93, 32, 61, 32, 79, 91, 103, 93, 32, 58, 32, 40, 102, 46, 112, 117, 115, 104, 40, 103, 41, 44, 32, 82, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 32, 124, 124, 32, 40, 82, 91, 103, 93, 32, 61, 32, 91, 93, 41, 44, 32, 82, 91, 103, 93, 46, 112, 117, 115, 104, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 91, 107, 93, 32, 61, 32, 79, 91, 103, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 43, 43, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 61, 61, 32, 102, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 100, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 102, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 100, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 107, 98, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 110, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 116, 121, 112, 101, 32, 34, 36, 123, 100, 125, 34, 32, 109, 117, 115, 116, 32, 104, 97, 118, 101, 32, 97, 32, 112, 111, 115, 105, 116, 105, 118, 101, 32, 105, 110, 116, 101, 103, 101, 114, 32, 116, 121, 112, 101, 105, 100, 32, 112, 111, 105, 110, 116, 101, 114, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 46, 77, 99, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 116, 121, 112, 101, 32, 39, 36, 123, 100, 125, 39, 32, 116, 119, 105, 99, 101, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 91, 97, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 106, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 82, 91, 97, 93, 44, 32, 100, 101, 108, 101, 116, 101, 32, 82, 91, 97, 93, 44, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 41, 32, 61, 62, 32, 101, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 83, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 98, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 97, 46, 99, 99, 46, 102, 99, 46, 101, 99, 46, 110, 97, 109, 101, 32, 43, 32, 34, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 97, 108, 114, 101, 97, 100, 121, 32, 100, 101, 108, 101, 116, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 109, 98, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 98, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 111, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 91, 98, 93, 46, 104, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 91, 98, 93, 46, 104, 99, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 101, 46, 108, 101, 110, 103, 116, 104, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 70, 117, 110, 99, 116, 105, 111, 110, 32, 39, 36, 123, 99, 125, 39, 32, 99, 97, 108, 108, 101, 100, 32, 119, 105, 116, 104, 32, 97, 110, 32, 105, 110, 118, 97, 108, 105, 100, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 97, 114, 103, 117, 109, 101, 110, 116, 115, 32, 40, 36, 123, 101, 46, 108, 101, 110, 103, 116, 104, 125, 41, 32, 45, 32, 101, 120, 112, 101, 99, 116, 115, 32, 111, 110, 101, 32, 111, 102, 32, 40, 36, 123, 97, 91, 98, 93, 46, 104, 99, 125, 41, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 91, 98, 93, 46, 104, 99, 91, 101, 46, 108, 101, 110, 103, 116, 104, 93, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 46, 104, 99, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 46, 104, 99, 91, 100, 46, 112, 99, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 112, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 108, 91, 97, 93, 46, 104, 99, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 108, 91, 97, 93, 46, 104, 99, 91, 99, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 112, 117, 98, 108, 105, 99, 32, 110, 97, 109, 101, 32, 39, 36, 123, 97, 125, 39, 32, 116, 119, 105, 99, 101, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 111, 98, 40, 108, 44, 32, 97, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 91, 97, 93, 46, 104, 99, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 99, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 109, 117, 108, 116, 105, 112, 108, 101, 32, 111, 118, 101, 114, 108, 111, 97, 100, 115, 32, 111, 102, 32, 97, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 105, 116, 104, 32, 116, 104, 101, 32, 115, 97, 109, 101, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 97, 114, 103, 117, 109, 101, 110, 116, 115, 32, 40, 36, 123, 99, 125, 41, 33, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 91, 97, 93, 46, 104, 99, 91, 99, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 108, 91, 97, 93, 32, 61, 32, 98, 44, 32, 108, 91, 97, 93, 46, 112, 99, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 113, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 91, 94, 97, 45, 122, 65, 45, 90, 48, 45, 57, 95, 93, 47, 103, 44, 32, 34, 36, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 52, 56, 32, 60, 61, 32, 98, 32, 38, 38, 32, 53, 55, 32, 62, 61, 32, 98, 32, 63, 32, 96, 95, 36, 123, 97, 125, 96, 32, 58, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 114, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 111, 99, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 99, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 105, 99, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 72, 99, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 116, 99, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 69, 99, 32, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 66, 99, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 115, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 98, 32, 33, 61, 61, 32, 99, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 116, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 69, 120, 112, 101, 99, 116, 101, 100, 32, 110, 117, 108, 108, 32, 111, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 111, 102, 32, 36, 123, 99, 46, 110, 97, 109, 101, 125, 44, 32, 103, 111, 116, 32, 97, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 111, 102, 32, 36, 123, 98, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 46, 116, 99, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 46, 105, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 116, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 120, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 99, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 117, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 99, 99, 46, 100, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 98, 40, 98, 46, 99, 99, 46, 100, 99, 44, 32, 98, 46, 99, 99, 46, 102, 99, 46, 101, 99, 44, 32, 116, 104, 105, 115, 46, 101, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 118, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 120, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 119, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 121, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 46, 110, 99, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 32, 124, 124, 32, 33, 98, 46, 99, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 117, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 99, 99, 46, 100, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 118, 99, 32, 38, 38, 32, 98, 46, 99, 99, 46, 102, 99, 46, 118, 99, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 99, 99, 46, 108, 99, 32, 63, 32, 98, 46, 99, 99, 46, 108, 99, 46, 110, 97, 109, 101, 32, 58, 32, 98, 46, 99, 99, 46, 102, 99, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 115, 98, 40, 98, 46, 99, 99, 46, 100, 99, 44, 32, 98, 46, 99, 99, 46, 102, 99, 46, 101, 99, 44, 32, 116, 104, 105, 115, 46, 101, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 119, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 98, 46, 99, 99, 46, 106, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 80, 97, 115, 115, 105, 110, 103, 32, 114, 97, 119, 32, 112, 111, 105, 110, 116, 101, 114, 32, 116, 111, 32, 115, 109, 97, 114, 116, 32, 112, 111, 105, 110, 116, 101, 114, 32, 105, 115, 32, 105, 108, 108, 101, 103, 97, 108, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 116, 104, 105, 115, 46, 84, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 48, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 99, 99, 46, 108, 99, 32, 61, 61, 61, 32, 116, 104, 105, 115, 41, 32, 99, 32, 61, 32, 98, 46, 99, 99, 46, 106, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 99, 99, 46, 108, 99, 32, 63, 32, 98, 46, 99, 99, 46, 108, 99, 46, 110, 97, 109, 101, 32, 58, 32, 98, 46, 99, 99, 46, 102, 99, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 98, 46, 99, 99, 46, 106, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 99, 99, 46, 108, 99, 32, 61, 61, 61, 32, 116, 104, 105, 115, 41, 32, 99, 32, 61, 32, 98, 46, 99, 99, 46, 106, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 80, 99, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 81, 97, 40, 40, 41, 32, 61, 62, 32, 100, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 46, 110, 99, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 85, 110, 115, 117, 112, 112, 111, 114, 116, 105, 110, 103, 32, 115, 104, 97, 114, 105, 110, 103, 32, 112, 111, 108, 105, 99, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 120, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 99, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 117, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 99, 99, 46, 100, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 99, 99, 46, 102, 99, 46, 118, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 99, 99, 46, 102, 99, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 98, 40, 98, 46, 99, 99, 46, 100, 99, 44, 32, 98, 46, 99, 99, 46, 102, 99, 46, 101, 99, 44, 32, 116, 104, 105, 115, 46, 101, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 120, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 101, 99, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 120, 99, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 118, 99, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 119, 99, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 79, 99, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 84, 99, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 67, 99, 32, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 121, 99, 32, 61, 32, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 80, 99, 32, 61, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 99, 32, 61, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 98, 46, 105, 99, 32, 63, 32, 116, 104, 105, 115, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 32, 61, 32, 118, 98, 32, 58, 32, 40, 116, 104, 105, 115, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 32, 61, 32, 100, 32, 63, 32, 116, 98, 32, 58, 32, 119, 98, 44, 32, 116, 104, 105, 115, 46, 107, 99, 32, 61, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 121, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 101, 98, 40, 34, 82, 101, 112, 108, 97, 99, 105, 110, 103, 32, 110, 111, 110, 101, 120, 105, 115, 116, 101, 110, 116, 32, 112, 117, 98, 108, 105, 99, 32, 115, 121, 109, 98, 111, 108, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 108, 91, 97, 93, 46, 104, 99, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 99, 32, 63, 32, 108, 91, 97, 93, 46, 104, 99, 91, 99, 93, 32, 61, 32, 98, 32, 58, 32, 40, 108, 91, 97, 93, 32, 61, 32, 98, 44, 32, 108, 91, 97, 93, 46, 112, 99, 32, 61, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 85, 44, 32, 122, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 91, 93, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 106, 34, 41, 32, 63, 32, 40, 97, 32, 61, 32, 97, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 112, 47, 103, 44, 32, 34, 105, 34, 41, 44, 32, 98, 32, 61, 32, 40, 48, 44, 32, 108, 91, 34, 100, 121, 110, 67, 97, 108, 108, 95, 34, 32, 43, 32, 97, 93, 41, 40, 98, 44, 32, 46, 46, 46, 99, 41, 41, 32, 58, 32, 98, 32, 61, 32, 85, 46, 103, 101, 116, 40, 98, 41, 40, 46, 46, 46, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 65, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 46, 46, 46, 99, 41, 32, 61, 62, 32, 122, 98, 40, 97, 44, 32, 98, 44, 32, 99, 41, 44, 32, 86, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 78, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 106, 34, 41, 32, 63, 32, 65, 98, 40, 97, 44, 32, 98, 41, 32, 58, 32, 85, 46, 103, 101, 116, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 117, 110, 107, 110, 111, 119, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 112, 111, 105, 110, 116, 101, 114, 32, 119, 105, 116, 104, 32, 115, 105, 103, 110, 97, 116, 117, 114, 101, 32, 36, 123, 97, 125, 58, 32, 36, 123, 98, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 66, 98, 44, 32, 67, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 99, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 91, 102, 93, 32, 124, 124, 32, 79, 91, 102, 93, 32, 124, 124, 32, 40, 106, 98, 91, 102, 93, 32, 63, 32, 106, 98, 91, 102, 93, 46, 102, 111, 114, 69, 97, 99, 104, 40, 99, 41, 32, 58, 32, 40, 100, 46, 112, 117, 115, 104, 40, 102, 41, 44, 32, 101, 91, 102, 93, 32, 61, 32, 116, 114, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 91, 93, 44, 32, 101, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 66, 98, 40, 96, 36, 123, 97, 125, 58, 32, 96, 32, 43, 32, 100, 46, 109, 97, 112, 40, 89, 97, 41, 46, 106, 111, 105, 110, 40, 91, 34, 44, 32, 34, 93, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 68, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 49, 59, 32, 98, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 98, 41, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 91, 98, 93, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 91, 98, 93, 46, 107, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 69, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 70, 117, 110, 99, 116, 105, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 98, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 70, 117, 110, 99, 116, 105, 111, 110, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 110, 101, 119, 95, 32, 99, 97, 108, 108, 101, 100, 32, 119, 105, 116, 104, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 121, 112, 101, 111, 102, 32, 98, 125, 32, 119, 104, 105, 99, 104, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 102, 117, 110, 99, 116, 105, 111, 110, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 74, 40, 98, 46, 110, 97, 109, 101, 32, 124, 124, 32, 34, 117, 110, 107, 110, 111, 119, 110, 70, 117, 110, 99, 116, 105, 111, 110, 78, 97, 109, 101, 34, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 110, 101, 119, 32, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 46, 97, 112, 112, 108, 121, 40, 99, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 79, 98, 106, 101, 99, 116, 32, 63, 32, 97, 32, 58, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 70, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 62, 32, 104, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 97, 114, 103, 84, 121, 112, 101, 115, 32, 97, 114, 114, 97, 121, 32, 115, 105, 122, 101, 32, 109, 105, 115, 109, 97, 116, 99, 104, 33, 32, 77, 117, 115, 116, 32, 97, 116, 32, 108, 101, 97, 115, 116, 32, 103, 101, 116, 32, 114, 101, 116, 117, 114, 110, 32, 118, 97, 108, 117, 101, 32, 97, 110, 100, 32, 39, 116, 104, 105, 115, 39, 32, 116, 121, 112, 101, 115, 33, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 49, 93, 32, 38, 38, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 99, 44, 32, 107, 32, 61, 32, 68, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 34, 118, 111, 105, 100, 34, 32, 33, 61, 61, 32, 98, 91, 48, 93, 46, 110, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 91, 97, 44, 32, 80, 97, 44, 32, 100, 44, 32, 101, 44, 32, 104, 98, 44, 32, 98, 91, 48, 93, 44, 32, 98, 91, 49, 93, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 104, 32, 45, 32, 50, 59, 32, 43, 43, 101, 41, 32, 100, 46, 112, 117, 115, 104, 40, 98, 91, 101, 32, 43, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 107, 41, 32, 102, 111, 114, 32, 40, 101, 32, 61, 32, 103, 32, 63, 32, 49, 32, 58, 32, 50, 59, 32, 101, 32, 60, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 101, 93, 46, 107, 99, 32, 38, 38, 32, 100, 46, 112, 117, 115, 104, 40, 98, 91, 101, 93, 46, 107, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 32, 61, 32, 68, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 98, 46, 108, 101, 110, 103, 116, 104, 32, 45, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 91, 93, 44, 32, 110, 32, 61, 32, 91, 34, 102, 110, 34, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 110, 46, 112, 117, 115, 104, 40, 34, 116, 104, 105, 115, 87, 105, 114, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 101, 59, 32, 43, 43, 104, 41, 32, 109, 46, 112, 117, 115, 104, 40, 96, 97, 114, 103, 36, 123, 104, 125, 96, 41, 44, 32, 110, 46, 112, 117, 115, 104, 40, 96, 97, 114, 103, 36, 123, 104, 125, 87, 105, 114, 101, 100, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 109, 46, 106, 111, 105, 110, 40, 34, 44, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 110, 46, 106, 111, 105, 110, 40, 34, 44, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 96, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 40, 36, 123, 109, 125, 41, 32, 123, 10, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 32, 38, 38, 32, 40, 109, 32, 43, 61, 32, 34, 118, 97, 114, 32, 100, 101, 115, 116, 114, 117, 99, 116, 111, 114, 115, 32, 61, 32, 91, 93, 59, 92, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 117, 32, 61, 32, 107, 32, 63, 32, 34, 100, 101, 115, 116, 114, 117, 99, 116, 111, 114, 115, 34, 32, 58, 32, 34, 110, 117, 108, 108, 34, 44, 32, 118, 32, 61, 32, 34, 104, 117, 109, 97, 110, 78, 97, 109, 101, 32, 116, 104, 114, 111, 119, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 32, 105, 110, 118, 111, 107, 101, 114, 32, 102, 110, 32, 114, 117, 110, 68, 101, 115, 116, 114, 117, 99, 116, 111, 114, 115, 32, 114, 101, 116, 84, 121, 112, 101, 32, 99, 108, 97, 115, 115, 80, 97, 114, 97, 109, 34, 46, 115, 112, 108, 105, 116, 40, 34, 32, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 40, 109, 32, 43, 61, 32, 96, 118, 97, 114, 32, 116, 104, 105, 115, 87, 105, 114, 101, 100, 32, 61, 32, 99, 108, 97, 115, 115, 80, 97, 114, 97, 109, 91, 39, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 39, 93, 40, 36, 123, 117, 125, 44, 32, 116, 104, 105, 115, 41, 59, 10, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 101, 59, 32, 43, 43, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 43, 61, 32, 96, 118, 97, 114, 32, 97, 114, 103, 36, 123, 104, 125, 87, 105, 114, 101, 100, 32, 61, 32, 97, 114, 103, 84, 121, 112, 101, 36, 123, 104, 125, 91, 39, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 39, 93, 40, 36, 123, 117, 125, 44, 32, 97, 114, 103, 36, 123, 104, 125, 41, 59, 10, 96, 44, 32, 118, 46, 112, 117, 115, 104, 40, 96, 97, 114, 103, 84, 121, 112, 101, 36, 123, 104, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 43, 61, 32, 40, 99, 32, 124, 124, 32, 102, 32, 63, 32, 34, 118, 97, 114, 32, 114, 118, 32, 61, 32, 34, 32, 58, 32, 34, 34, 41, 32, 43, 32, 96, 105, 110, 118, 111, 107, 101, 114, 40, 36, 123, 110, 125, 41, 59, 10, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 41, 32, 109, 32, 43, 61, 32, 34, 114, 117, 110, 68, 101, 115, 116, 114, 117, 99, 116, 111, 114, 115, 40, 100, 101, 115, 116, 114, 117, 99, 116, 111, 114, 115, 41, 59, 92, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 103, 32, 63, 32, 49, 32, 58, 32, 50, 59, 32, 104, 32, 60, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 49, 32, 61, 61, 61, 32, 104, 32, 63, 32, 34, 116, 104, 105, 115, 87, 105, 114, 101, 100, 34, 32, 58, 32, 34, 97, 114, 103, 34, 32, 43, 32, 40, 104, 32, 45, 32, 50, 41, 32, 43, 32, 34, 87, 105, 114, 101, 100, 34, 44, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 104, 93, 46, 107, 99, 32, 38, 38, 32, 40, 109, 32, 43, 61, 32, 96, 36, 123, 102, 125, 95, 100, 116, 111, 114, 40, 36, 123, 102, 125, 41, 59, 10, 96, 44, 32, 118, 46, 112, 117, 115, 104, 40, 96, 36, 123, 102, 125, 95, 100, 116, 111, 114, 96, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 38, 38, 32, 40, 109, 32, 43, 61, 32, 34, 118, 97, 114, 32, 114, 101, 116, 32, 61, 32, 114, 101, 116, 84, 121, 112, 101, 91, 39, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 39, 93, 40, 114, 118, 41, 59, 92, 110, 114, 101, 116, 117, 114, 110, 32, 114, 101, 116, 59, 92, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 91, 121, 44, 32, 122, 93, 32, 61, 32, 91, 118, 44, 32, 109, 32, 43, 32, 34, 125, 92, 110, 34, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 46, 112, 117, 115, 104, 40, 122, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 69, 98, 40, 121, 41, 40, 46, 46, 46, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 74, 40, 97, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 71, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 91, 93, 44, 32, 100, 32, 61, 32, 48, 59, 32, 100, 32, 60, 32, 97, 59, 32, 100, 43, 43, 41, 32, 99, 46, 112, 117, 115, 104, 40, 66, 91, 98, 32, 43, 32, 52, 32, 42, 32, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 72, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 116, 114, 105, 109, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 32, 61, 32, 97, 46, 105, 110, 100, 101, 120, 79, 102, 40, 34, 40, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 45, 49, 32, 33, 61, 61, 32, 98, 32, 63, 32, 97, 46, 115, 117, 98, 115, 116, 114, 40, 48, 44, 32, 98, 41, 32, 58, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 73, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 57, 32, 60, 32, 97, 32, 38, 38, 32, 48, 32, 61, 61, 61, 32, 45, 45, 75, 91, 97, 32, 43, 32, 49, 93, 32, 38, 38, 32, 40, 75, 91, 97, 93, 32, 61, 32, 118, 111, 105, 100, 32, 48, 44, 32, 79, 97, 46, 112, 117, 115, 104, 40, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 74, 98, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 34, 101, 109, 115, 99, 114, 105, 112, 116, 101, 110, 58, 58, 118, 97, 108, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 77, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 81, 97, 40, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 99, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 105, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 99, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 75, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 114, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 116, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 119, 91, 100, 32, 62, 62, 32, 49, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 120, 91, 100, 32, 62, 62, 32, 49, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 65, 91, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 66, 91, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 105, 110, 116, 101, 103, 101, 114, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 117, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 34, 110, 117, 108, 108, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 61, 32, 98, 32, 124, 124, 32, 34, 97, 114, 114, 97, 121, 34, 32, 61, 61, 61, 32, 98, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 61, 32, 98, 32, 63, 32, 97, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 32, 58, 32, 34, 34, 32, 43, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 76, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 111, 97, 91, 99, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 56, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 112, 97, 91, 99, 32, 62, 62, 32, 51, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 102, 108, 111, 97, 116, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 78, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 114, 91, 100, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 116, 91, 100, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 119, 91, 100, 32, 62, 62, 32, 49, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 120, 91, 100, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 65, 91, 100, 32, 62, 62, 32, 50, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 66, 91, 100, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 105, 110, 116, 101, 103, 101, 114, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 79, 98, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 123, 32, 111, 112, 116, 105, 111, 110, 97, 108, 58, 32, 116, 114, 117, 101, 32, 125, 44, 32, 74, 98, 41, 44, 32, 80, 98, 32, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 32, 63, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 34, 117, 116, 102, 45, 49, 54, 108, 101, 34, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 44, 32, 81, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 32, 62, 62, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 100, 32, 61, 32, 99, 32, 43, 32, 98, 32, 47, 32, 50, 59, 32, 33, 40, 99, 32, 62, 61, 32, 100, 41, 32, 38, 38, 32, 120, 91, 99, 93, 59, 32, 41, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 60, 60, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 51, 50, 32, 60, 32, 99, 32, 45, 32, 97, 32, 38, 38, 32, 80, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 80, 98, 46, 100, 101, 99, 111, 100, 101, 40, 116, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 97, 44, 32, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 34, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 100, 32, 61, 32, 48, 59, 32, 33, 40, 100, 32, 62, 61, 32, 98, 32, 47, 32, 50, 41, 59, 32, 43, 43, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 119, 91, 97, 32, 43, 32, 50, 32, 42, 32, 100, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 32, 101, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 99, 32, 58, 32, 99, 32, 61, 32, 50, 49, 52, 55, 52, 56, 51, 54, 52, 55, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 62, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 45, 61, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 99, 32, 60, 32, 50, 32, 42, 32, 97, 46, 108, 101, 110, 103, 116, 104, 32, 63, 32, 99, 32, 47, 32, 50, 32, 58, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 99, 59, 32, 43, 43, 101, 41, 32, 119, 91, 98, 32, 62, 62, 32, 49, 93, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 44, 32, 98, 32, 43, 61, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 91, 98, 32, 62, 62, 32, 49, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 45, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 83, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 50, 32, 42, 32, 97, 46, 108, 101, 110, 103, 116, 104, 44, 32, 84, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 48, 44, 32, 100, 32, 61, 32, 34, 34, 59, 32, 33, 40, 99, 32, 62, 61, 32, 98, 32, 47, 32, 52, 41, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 65, 91, 97, 32, 43, 32, 52, 32, 42, 32, 99, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 32, 101, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 54, 53, 53, 51, 54, 32, 60, 61, 32, 101, 32, 63, 32, 40, 101, 32, 45, 61, 32, 54, 53, 53, 51, 54, 44, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 53, 53, 50, 57, 54, 32, 124, 32, 101, 32, 62, 62, 32, 49, 48, 44, 32, 53, 54, 51, 50, 48, 32, 124, 32, 101, 32, 38, 32, 49, 48, 50, 51, 41, 41, 32, 58, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 85, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 99, 32, 58, 32, 99, 32, 61, 32, 50, 49, 52, 55, 52, 56, 51, 54, 52, 55, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 52, 32, 62, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 100, 32, 43, 32, 99, 32, 45, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 53, 53, 50, 57, 54, 32, 60, 61, 32, 102, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 43, 43, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 54, 53, 53, 51, 54, 32, 43, 32, 40, 40, 102, 32, 38, 32, 49, 48, 50, 51, 41, 32, 60, 60, 32, 49, 48, 41, 32, 124, 32, 104, 32, 38, 32, 49, 48, 50, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 65, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 52, 32, 62, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 65, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 45, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 86, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 48, 44, 32, 99, 32, 61, 32, 48, 59, 32, 99, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 53, 53, 50, 57, 54, 32, 60, 61, 32, 100, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 100, 32, 38, 38, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 87, 98, 32, 61, 32, 48, 44, 32, 88, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 100, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 40, 66, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 81, 97, 40, 100, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 89, 98, 32, 61, 32, 91, 93, 44, 32, 90, 98, 32, 61, 32, 123, 125, 44, 32, 36, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 89, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 89, 98, 46, 112, 117, 115, 104, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 97, 99, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 65, 114, 114, 97, 121, 40, 97, 41, 44, 32, 100, 32, 61, 32, 48, 59, 32, 100, 32, 60, 32, 97, 59, 32, 43, 43, 100, 41, 32, 99, 91, 100, 93, 32, 61, 32, 90, 97, 40, 66, 91, 98, 32, 43, 32, 52, 32, 42, 32, 100, 32, 62, 62, 32, 50, 93, 44, 32, 34, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 34, 32, 43, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 99, 32, 61, 32, 123, 125, 44, 32, 99, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 68, 97, 32, 124, 124, 32, 34, 117, 110, 119, 105, 110, 100, 34, 32, 61, 61, 32, 97, 41, 41, 32, 116, 104, 114, 111, 119, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 100, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 97, 32, 124, 124, 32, 48, 32, 60, 32, 87, 98, 32, 124, 124, 32, 40, 40, 95, 97, 50, 32, 61, 32, 108, 46, 111, 110, 69, 120, 105, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 108, 44, 32, 97, 41, 44, 32, 107, 97, 32, 61, 32, 116, 114, 117, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 68, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 101, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 107, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 40, 41, 44, 32, 33, 40, 70, 97, 32, 124, 124, 32, 48, 32, 60, 32, 87, 98, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 32, 61, 32, 97, 32, 61, 32, 110, 97, 44, 32, 100, 99, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 99, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 99, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 102, 99, 32, 61, 32, 123, 125, 44, 32, 104, 99, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 103, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 83, 69, 82, 58, 32, 34, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 79, 71, 78, 65, 77, 69, 58, 32, 34, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 65, 84, 72, 58, 32, 34, 47, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 87, 68, 58, 32, 34, 47, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 72, 79, 77, 69, 58, 32, 34, 47, 104, 111, 109, 101, 47, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 65, 78, 71, 58, 32, 40, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 32, 38, 38, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 46, 108, 97, 110, 103, 117, 97, 103, 101, 115, 32, 38, 38, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 46, 108, 97, 110, 103, 117, 97, 103, 101, 115, 91, 48, 93, 32, 124, 124, 32, 34, 67, 34, 41, 46, 114, 101, 112, 108, 97, 99, 101, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 45, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 95, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 32, 43, 32, 34, 46, 85, 84, 70, 45, 56, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 58, 32, 101, 97, 32, 124, 124, 32, 34, 46, 47, 116, 104, 105, 115, 46, 112, 114, 111, 103, 114, 97, 109, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 102, 99, 41, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 102, 99, 91, 98, 93, 32, 63, 32, 100, 101, 108, 101, 116, 101, 32, 97, 91, 98, 93, 32, 58, 32, 97, 91, 98, 93, 32, 61, 32, 102, 99, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 97, 41, 32, 99, 46, 112, 117, 115, 104, 40, 96, 36, 123, 98, 125, 61, 36, 123, 97, 91, 98, 93, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 99, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 103, 99, 44, 32, 105, 99, 32, 61, 32, 91, 110, 117, 108, 108, 44, 32, 91, 93, 44, 32, 91, 93, 93, 44, 32, 106, 99, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 114, 121, 112, 116, 111, 32, 38, 38, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 114, 121, 112, 116, 111, 46, 103, 101, 116, 82, 97, 110, 100, 111, 109, 86, 97, 108, 117, 101, 115, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 97, 41, 32, 61, 62, 32, 99, 114, 121, 112, 116, 111, 46, 103, 101, 116, 82, 97, 110, 100, 111, 109, 86, 97, 108, 117, 101, 115, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 34, 105, 110, 105, 116, 82, 97, 110, 100, 111, 109, 68, 101, 118, 105, 99, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 107, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 107, 99, 32, 61, 32, 106, 99, 40, 41, 41, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 76, 32, 61, 32, 108, 46, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 101, 120, 116, 101, 110, 100, 115, 32, 69, 114, 114, 111, 114, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 112, 101, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 75, 46, 112, 117, 115, 104, 40, 48, 44, 32, 49, 44, 32, 118, 111, 105, 100, 32, 48, 44, 32, 49, 44, 32, 110, 117, 108, 108, 44, 32, 49, 44, 32, 116, 114, 117, 101, 44, 32, 49, 44, 32, 102, 97, 108, 115, 101, 44, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 99, 111, 117, 110, 116, 95, 101, 109, 118, 97, 108, 95, 104, 97, 110, 100, 108, 101, 115, 32, 61, 32, 40, 41, 32, 61, 62, 32, 75, 46, 108, 101, 110, 103, 116, 104, 32, 47, 32, 50, 32, 45, 32, 53, 32, 45, 32, 79, 97, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 83, 97, 32, 61, 32, 108, 46, 80, 117, 114, 101, 86, 105, 114, 116, 117, 97, 108, 69, 114, 114, 111, 114, 32, 61, 32, 82, 97, 40, 34, 80, 117, 114, 101, 86, 105, 114, 116, 117, 97, 108, 69, 114, 114, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 99, 32, 61, 32, 65, 114, 114, 97, 121, 40, 50, 53, 54, 41, 44, 32, 109, 99, 32, 61, 32, 48, 59, 32, 50, 53, 54, 32, 62, 32, 109, 99, 59, 32, 43, 43, 109, 99, 41, 32, 108, 99, 91, 109, 99, 93, 32, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 109, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 84, 97, 32, 61, 32, 108, 99, 59, 10, 32, 32, 32, 32, 32, 32, 101, 98, 32, 61, 32, 108, 46, 73, 110, 116, 101, 114, 110, 97, 108, 69, 114, 114, 111, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 101, 120, 116, 101, 110, 100, 115, 32, 69, 114, 114, 111, 114, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 112, 101, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 73, 110, 116, 101, 114, 110, 97, 108, 69, 114, 114, 111, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 110, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 65, 108, 105, 97, 115, 79, 102, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 116, 104, 105, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 110, 98, 32, 38, 38, 32, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 110, 98, 41, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 104, 105, 115, 46, 99, 99, 46, 102, 99, 46, 101, 99, 44, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 99, 99, 46, 100, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 99, 99, 32, 61, 32, 97, 46, 99, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 46, 99, 99, 46, 102, 99, 46, 101, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 97, 32, 61, 32, 97, 46, 99, 99, 46, 100, 99, 59, 32, 98, 46, 105, 99, 59, 32, 41, 32, 99, 32, 61, 32, 98, 46, 116, 99, 40, 99, 41, 44, 32, 98, 32, 61, 32, 98, 46, 105, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 100, 46, 105, 99, 59, 32, 41, 32, 97, 32, 61, 32, 100, 46, 116, 99, 40, 97, 41, 44, 32, 100, 32, 61, 32, 100, 46, 105, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 61, 61, 61, 32, 100, 32, 38, 38, 32, 99, 32, 61, 61, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 111, 110, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 99, 46, 100, 99, 32, 124, 124, 32, 108, 98, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 99, 99, 46, 114, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 99, 99, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 43, 61, 32, 49, 44, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 81, 44, 32, 98, 32, 61, 32, 79, 98, 106, 101, 99, 116, 44, 32, 99, 32, 61, 32, 98, 46, 99, 114, 101, 97, 116, 101, 44, 32, 100, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 80, 114, 111, 116, 111, 116, 121, 112, 101, 79, 102, 40, 116, 104, 105, 115, 41, 44, 32, 101, 32, 61, 32, 116, 104, 105, 115, 46, 99, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 99, 97, 108, 108, 40, 98, 44, 32, 100, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 99, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 123, 32, 99, 111, 117, 110, 116, 58, 32, 101, 46, 99, 111, 117, 110, 116, 44, 32, 115, 99, 58, 32, 101, 46, 115, 99, 44, 32, 114, 99, 58, 32, 101, 46, 114, 99, 44, 32, 100, 99, 58, 32, 101, 46, 100, 99, 44, 32, 102, 99, 58, 32, 101, 46, 102, 99, 44, 32, 106, 99, 58, 32, 101, 46, 106, 99, 44, 32, 108, 99, 58, 32, 101, 46, 108, 99, 32, 125, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 99, 99, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 43, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 99, 99, 46, 115, 99, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 99, 46, 100, 99, 32, 124, 124, 32, 108, 98, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 99, 99, 46, 115, 99, 32, 38, 38, 32, 33, 116, 104, 105, 115, 46, 99, 99, 46, 114, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 79, 98, 106, 101, 99, 116, 32, 97, 108, 114, 101, 97, 100, 121, 32, 115, 99, 104, 101, 100, 117, 108, 101, 100, 32, 102, 111, 114, 32, 100, 101, 108, 101, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 36, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 116, 104, 105, 115, 46, 99, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 45, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 38, 38, 32, 40, 97, 46, 106, 99, 32, 63, 32, 97, 46, 108, 99, 46, 110, 99, 40, 97, 46, 106, 99, 41, 32, 58, 32, 97, 46, 102, 99, 46, 101, 99, 46, 110, 99, 40, 97, 46, 100, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 99, 46, 114, 99, 32, 124, 124, 32, 40, 116, 104, 105, 115, 46, 99, 99, 46, 106, 99, 32, 61, 32, 118, 111, 105, 100, 32, 48, 44, 32, 116, 104, 105, 115, 46, 99, 99, 46, 100, 99, 32, 61, 32, 118, 111, 105, 100, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 68, 101, 108, 101, 116, 101, 100, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 33, 116, 104, 105, 115, 46, 99, 99, 46, 100, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 76, 97, 116, 101, 114, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 99, 46, 100, 99, 32, 124, 124, 32, 108, 98, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 99, 99, 46, 115, 99, 32, 38, 38, 32, 33, 116, 104, 105, 115, 46, 99, 99, 46, 114, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 79, 98, 106, 101, 99, 116, 32, 97, 108, 114, 101, 97, 100, 121, 32, 115, 99, 104, 101, 100, 117, 108, 101, 100, 32, 102, 111, 114, 32, 100, 101, 108, 101, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 98, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 99, 46, 115, 99, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 120, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 99, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 67, 99, 32, 38, 38, 32, 40, 97, 32, 61, 32, 116, 104, 105, 115, 46, 67, 99, 40, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 122, 99, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 116, 104, 105, 115, 46, 110, 99, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 99, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 105, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 98, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 119, 99, 32, 63, 32, 102, 98, 40, 116, 104, 105, 115, 46, 101, 99, 46, 111, 99, 44, 32, 123, 32, 102, 99, 58, 32, 116, 104, 105, 115, 46, 79, 99, 44, 32, 100, 99, 58, 32, 99, 44, 32, 108, 99, 58, 32, 116, 104, 105, 115, 44, 32, 106, 99, 58, 32, 97, 32, 125, 41, 32, 58, 32, 102, 98, 40, 116, 104, 105, 115, 46, 101, 99, 46, 111, 99, 44, 32, 123, 32, 102, 99, 58, 32, 116, 104, 105, 115, 44, 32, 100, 99, 58, 32, 97, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 73, 99, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 122, 99, 40, 97, 41, 44, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 100, 98, 40, 116, 104, 105, 115, 46, 101, 99, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 100, 46, 99, 99, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 100, 46, 99, 99, 46, 100, 99, 32, 61, 32, 99, 44, 32, 100, 46, 99, 99, 46, 106, 99, 32, 61, 32, 97, 44, 32, 100, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 100, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 122, 99, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 116, 104, 105, 115, 46, 101, 99, 46, 72, 99, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 99, 98, 91, 100, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 100, 41, 32, 114, 101, 116, 117, 114, 110, 32, 98, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 116, 104, 105, 115, 46, 118, 99, 32, 63, 32, 100, 46, 68, 99, 32, 58, 32, 100, 46, 112, 111, 105, 110, 116, 101, 114, 84, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 98, 98, 40, 99, 44, 32, 116, 104, 105, 115, 46, 101, 99, 44, 32, 100, 46, 101, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 32, 61, 61, 61, 32, 101, 32, 63, 32, 98, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 41, 32, 58, 32, 116, 104, 105, 115, 46, 119, 99, 32, 63, 32, 102, 98, 40, 100, 46, 101, 99, 46, 111, 99, 44, 32, 123, 32, 102, 99, 58, 32, 100, 44, 32, 100, 99, 58, 32, 101, 44, 32, 108, 99, 58, 32, 116, 104, 105, 115, 44, 32, 106, 99, 58, 32, 97, 32, 125, 41, 32, 58, 32, 102, 98, 40, 100, 46, 101, 99, 46, 111, 99, 44, 32, 123, 32, 102, 99, 58, 32, 100, 44, 32, 100, 99, 58, 32, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 66, 98, 32, 61, 32, 108, 46, 85, 110, 98, 111, 117, 110, 100, 84, 121, 112, 101, 69, 114, 114, 111, 114, 32, 61, 32, 82, 97, 40, 34, 85, 110, 98, 111, 117, 110, 100, 84, 121, 112, 101, 69, 114, 114, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 121, 100, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 119, 97, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 65, 115, 115, 101, 114, 116, 105, 111, 110, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 97, 32, 63, 32, 72, 40, 116, 44, 32, 97, 41, 32, 58, 32, 34, 34, 125, 44, 32, 97, 116, 58, 32, 96, 32, 43, 32, 91, 98, 32, 63, 32, 98, 32, 63, 32, 72, 40, 116, 44, 32, 98, 41, 32, 58, 32, 34, 34, 32, 58, 32, 34, 117, 110, 107, 110, 111, 119, 110, 32, 102, 105, 108, 101, 110, 97, 109, 101, 34, 44, 32, 99, 44, 32, 100, 32, 63, 32, 100, 32, 63, 32, 72, 40, 116, 44, 32, 100, 41, 32, 58, 32, 34, 34, 32, 58, 32, 34, 117, 110, 107, 110, 111, 119, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 34, 93, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 110, 101, 119, 32, 74, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 32, 114, 91, 98, 46, 100, 99, 32, 43, 32, 49, 50, 93, 32, 38, 38, 32, 40, 114, 91, 98, 46, 100, 99, 32, 43, 32, 49, 50, 93, 32, 61, 32, 49, 44, 32, 73, 97, 45, 45, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 91, 98, 46, 100, 99, 32, 43, 32, 49, 51, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 72, 97, 46, 112, 117, 115, 104, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 99, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 111, 99, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 48, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 72, 97, 46, 112, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 112, 99, 40, 97, 46, 70, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 58, 32, 40, 41, 32, 61, 62, 32, 77, 97, 40, 91, 93, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 111, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 77, 97, 40, 91, 97, 44, 32, 98, 93, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 110, 101, 119, 32, 74, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 100, 46, 100, 99, 32, 43, 32, 49, 54, 32, 62, 62, 32, 50, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 100, 46, 100, 99, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 100, 46, 100, 99, 32, 43, 32, 56, 32, 62, 62, 32, 50, 93, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 43, 43, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 32, 124, 124, 32, 40, 73, 32, 61, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 97, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 97, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 65, 97, 58, 32, 40, 41, 32, 61, 62, 32, 119, 97, 40, 34, 34, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 78, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 90, 97, 40, 98, 44, 32, 34, 119, 114, 97, 112, 112, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 77, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 101, 99, 44, 32, 101, 32, 61, 32, 100, 46, 111, 99, 44, 32, 102, 32, 61, 32, 100, 46, 105, 99, 46, 111, 99, 44, 32, 104, 32, 61, 32, 100, 46, 105, 99, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 74, 40, 97, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 46, 105, 99, 46, 66, 99, 46, 102, 111, 114, 69, 97, 99, 104, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 91, 107, 93, 32, 61, 61, 61, 32, 102, 91, 107, 93, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 83, 97, 40, 96, 80, 117, 114, 101, 32, 118, 105, 114, 116, 117, 97, 108, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 36, 123, 107, 125, 32, 109, 117, 115, 116, 32, 98, 101, 32, 105, 109, 112, 108, 101, 109, 101, 110, 116, 101, 100, 32, 105, 110, 32, 74, 97, 118, 97, 83, 99, 114, 105, 112, 116, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 40, 116, 104, 105, 115, 44, 32, 34, 95, 95, 112, 97, 114, 101, 110, 116, 34, 44, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 95, 99, 111, 110, 115, 116, 114, 117, 99, 116, 40, 46, 46, 46, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 95, 95, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 32, 61, 61, 61, 32, 101, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 80, 97, 115, 115, 32, 99, 111, 114, 114, 101, 99, 116, 32, 39, 116, 104, 105, 115, 39, 32, 116, 111, 32, 95, 95, 99, 111, 110, 115, 116, 114, 117, 99, 116, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 104, 46, 105, 109, 112, 108, 101, 109, 101, 110, 116, 40, 116, 104, 105, 115, 44, 32, 46, 46, 46, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 36, 97, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 103, 46, 99, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 110, 111, 116, 105, 102, 121, 79, 110, 68, 101, 115, 116, 114, 117, 99, 116, 105, 111, 110, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 114, 99, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 105, 101, 115, 40, 116, 104, 105, 115, 44, 32, 123, 32, 99, 99, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 107, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 81, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 107, 46, 100, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 86, 97, 40, 100, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 85, 97, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 84, 114, 105, 101, 100, 32, 116, 111, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 114, 101, 103, 105, 115, 116, 101, 114, 101, 100, 32, 105, 110, 115, 116, 97, 110, 99, 101, 58, 32, 36, 123, 103, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 97, 91, 103, 93, 32, 61, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 95, 95, 100, 101, 115, 116, 114, 117, 99, 116, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 32, 61, 61, 61, 32, 101, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 80, 97, 115, 115, 32, 99, 111, 114, 114, 101, 99, 116, 32, 39, 116, 104, 105, 115, 39, 32, 116, 111, 32, 95, 95, 100, 101, 115, 116, 114, 117, 99, 116, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 36, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 116, 104, 105, 115, 46, 99, 99, 46, 100, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 86, 97, 40, 100, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 85, 97, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 41, 32, 100, 101, 108, 101, 116, 101, 32, 85, 97, 91, 103, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 84, 114, 105, 101, 100, 32, 116, 111, 32, 117, 110, 114, 101, 103, 105, 115, 116, 101, 114, 32, 117, 110, 114, 101, 103, 105, 115, 116, 101, 114, 101, 100, 32, 105, 110, 115, 116, 97, 110, 99, 101, 58, 32, 36, 123, 103, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 97, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 81, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 78, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 103, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 103, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 46, 121, 99, 44, 32, 100, 32, 61, 32, 98, 46, 110, 99, 44, 32, 101, 32, 61, 32, 98, 46, 65, 99, 44, 32, 102, 32, 61, 32, 101, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 76, 99, 41, 46, 99, 111, 110, 99, 97, 116, 40, 101, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 82, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 40, 91, 97, 93, 44, 32, 102, 44, 32, 40, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 107, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 110, 32, 61, 32, 104, 91, 109, 93, 44, 32, 117, 32, 61, 32, 107, 46, 74, 99, 44, 32, 118, 32, 61, 32, 107, 46, 75, 99, 44, 32, 121, 32, 61, 32, 104, 91, 109, 32, 43, 32, 101, 46, 108, 101, 110, 103, 116, 104, 93, 44, 32, 122, 32, 61, 32, 107, 46, 81, 99, 44, 32, 69, 32, 61, 32, 107, 46, 83, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 91, 107, 46, 71, 99, 93, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 58, 32, 40, 70, 41, 32, 61, 62, 32, 110, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 117, 40, 118, 44, 32, 70, 41, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 114, 105, 116, 101, 58, 32, 40, 70, 44, 32, 108, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 71, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 122, 40, 69, 44, 32, 70, 44, 32, 121, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 71, 44, 32, 108, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 98, 40, 71, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 46, 110, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 107, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 123, 125, 44, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 110, 32, 105, 110, 32, 103, 41, 32, 109, 91, 110, 93, 32, 61, 32, 103, 91, 110, 93, 46, 114, 101, 97, 100, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 107, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 110, 32, 105, 110, 32, 103, 41, 32, 105, 102, 32, 40, 33, 40, 110, 32, 105, 110, 32, 109, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 77, 105, 115, 115, 105, 110, 103, 32, 102, 105, 101, 108, 100, 58, 32, 34, 36, 123, 110, 125, 34, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 117, 32, 61, 32, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 110, 32, 105, 110, 32, 103, 41, 32, 103, 91, 110, 93, 46, 119, 114, 105, 116, 101, 40, 117, 44, 32, 109, 91, 110, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 107, 32, 38, 38, 32, 107, 46, 112, 117, 115, 104, 40, 100, 44, 32, 117, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 117, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 99, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 105, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 99, 58, 32, 100, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 80, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 78, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 33, 33, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 32, 63, 32, 99, 32, 58, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 99, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 116, 91, 101, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 99, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 44, 32, 118, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 78, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 86, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 40, 103, 32, 61, 32, 86, 40, 104, 44, 32, 103, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 38, 38, 32, 40, 109, 32, 61, 32, 86, 40, 107, 44, 32, 109, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 86, 40, 117, 44, 32, 118, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 121, 32, 61, 32, 113, 98, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 112, 98, 40, 121, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 36, 123, 110, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 40, 91, 97, 44, 32, 98, 44, 32, 99, 93, 44, 32, 100, 32, 63, 32, 91, 100, 93, 32, 58, 32, 91, 93, 44, 32, 40, 122, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 122, 32, 61, 32, 122, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 32, 61, 32, 122, 46, 101, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 70, 32, 61, 32, 69, 46, 111, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 70, 32, 61, 32, 110, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 122, 32, 61, 32, 74, 40, 110, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 87, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 80, 114, 111, 116, 111, 116, 121, 112, 101, 79, 102, 40, 116, 104, 105, 115, 41, 32, 33, 61, 61, 32, 108, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 85, 115, 101, 32, 39, 110, 101, 119, 39, 32, 116, 111, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 34, 32, 43, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 71, 46, 113, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 110, 32, 43, 32, 34, 32, 104, 97, 115, 32, 110, 111, 32, 97, 99, 99, 101, 115, 115, 105, 98, 108, 101, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 77, 98, 32, 61, 32, 71, 46, 113, 99, 91, 87, 97, 46, 108, 101, 110, 103, 116, 104, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 77, 98, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 84, 114, 105, 101, 100, 32, 116, 111, 32, 105, 110, 118, 111, 107, 101, 32, 99, 116, 111, 114, 32, 111, 102, 32, 36, 123, 110, 125, 32, 119, 105, 116, 104, 32, 105, 110, 118, 97, 108, 105, 100, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 40, 36, 123, 87, 97, 46, 108, 101, 110, 103, 116, 104, 125, 41, 32, 45, 32, 101, 120, 112, 101, 99, 116, 101, 100, 32, 40, 36, 123, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 71, 46, 113, 99, 41, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 125, 41, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 105, 110, 115, 116, 101, 97, 100, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 77, 98, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 32, 87, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 97, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 70, 44, 32, 123, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 122, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 122, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 108, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 71, 32, 61, 32, 110, 101, 119, 32, 114, 98, 40, 110, 44, 32, 122, 44, 32, 108, 97, 44, 32, 118, 44, 32, 69, 44, 32, 102, 44, 32, 103, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 71, 46, 105, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 40, 109, 97, 32, 61, 32, 71, 46, 105, 99, 41, 46, 117, 99, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 50, 32, 58, 32, 109, 97, 46, 117, 99, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 71, 46, 105, 99, 46, 117, 99, 46, 112, 117, 115, 104, 40, 71, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 32, 61, 32, 110, 101, 119, 32, 120, 98, 40, 110, 44, 32, 71, 44, 32, 116, 114, 117, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 32, 61, 32, 110, 101, 119, 32, 120, 98, 40, 110, 32, 43, 32, 34, 42, 34, 44, 32, 71, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 70, 32, 61, 32, 110, 101, 119, 32, 120, 98, 40, 110, 32, 43, 32, 34, 32, 99, 111, 110, 115, 116, 42, 34, 44, 32, 71, 44, 32, 102, 97, 108, 115, 101, 44, 32, 116, 114, 117, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 98, 91, 97, 93, 32, 61, 32, 123, 32, 112, 111, 105, 110, 116, 101, 114, 84, 121, 112, 101, 58, 32, 109, 97, 44, 32, 68, 99, 58, 32, 70, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 121, 98, 40, 121, 44, 32, 122, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 69, 44, 32, 109, 97, 44, 32, 70, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 76, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 71, 98, 40, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 78, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 72, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 86, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 117, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 109, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 117, 32, 61, 32, 96, 36, 123, 109, 46, 110, 97, 109, 101, 125, 46, 36, 123, 98, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 64, 64, 34, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 83, 121, 109, 98, 111, 108, 91, 98, 46, 115, 117, 98, 115, 116, 114, 105, 110, 103, 40, 50, 41, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 118, 32, 61, 32, 109, 46, 101, 99, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 118, 91, 98, 93, 32, 63, 32, 40, 110, 46, 112, 99, 32, 61, 32, 99, 32, 45, 32, 49, 44, 32, 118, 91, 98, 93, 32, 61, 32, 110, 41, 32, 58, 32, 40, 111, 98, 40, 118, 44, 32, 98, 44, 32, 117, 41, 44, 32, 118, 91, 98, 93, 46, 104, 99, 91, 99, 32, 45, 32, 49, 93, 32, 61, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 40, 91, 93, 44, 32, 107, 44, 32, 40, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 121, 32, 61, 32, 70, 98, 40, 117, 44, 32, 91, 121, 91, 48, 93, 44, 32, 110, 117, 108, 108, 93, 46, 99, 111, 110, 99, 97, 116, 40, 121, 46, 115, 108, 105, 99, 101, 40, 49, 41, 41, 44, 32, 110, 117, 108, 108, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 118, 91, 98, 93, 46, 104, 99, 32, 63, 32, 40, 121, 46, 112, 99, 32, 61, 32, 99, 32, 45, 32, 49, 44, 32, 118, 91, 98, 93, 32, 61, 32, 121, 41, 32, 58, 32, 118, 91, 98, 93, 46, 104, 99, 91, 99, 32, 45, 32, 49, 93, 32, 61, 32, 121, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 46, 101, 99, 46, 117, 99, 41, 32, 102, 111, 114, 32, 40, 99, 111, 110, 115, 116, 32, 122, 32, 111, 102, 32, 109, 46, 101, 99, 46, 117, 99, 41, 32, 122, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 98, 41, 32, 124, 124, 32, 40, 122, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 91, 98, 93, 32, 61, 32, 121, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 75, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 71, 98, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 86, 40, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 103, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 96, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 36, 123, 103, 46, 110, 97, 109, 101, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 103, 46, 101, 99, 46, 113, 99, 32, 38, 38, 32, 40, 103, 46, 101, 99, 46, 113, 99, 32, 61, 32, 91, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 103, 46, 101, 99, 46, 113, 99, 91, 98, 32, 45, 32, 49, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 109, 117, 108, 116, 105, 112, 108, 101, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 115, 32, 119, 105, 116, 104, 32, 105, 100, 101, 110, 116, 105, 99, 97, 108, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 40, 36, 123, 98, 32, 45, 32, 49, 125, 41, 32, 102, 111, 114, 32, 99, 108, 97, 115, 115, 32, 39, 36, 123, 103, 46, 110, 97, 109, 101, 125, 39, 33, 32, 79, 118, 101, 114, 108, 111, 97, 100, 32, 114, 101, 115, 111, 108, 117, 116, 105, 111, 110, 32, 105, 115, 32, 99, 117, 114, 114, 101, 110, 116, 108, 121, 32, 111, 110, 108, 121, 32, 112, 101, 114, 102, 111, 114, 109, 101, 100, 32, 117, 115, 105, 110, 103, 32, 116, 104, 101, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 99, 111, 117, 110, 116, 44, 32, 110, 111, 116, 32, 97, 99, 116, 117, 97, 108, 32, 116, 121, 112, 101, 32, 105, 110, 102, 111, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 101, 99, 46, 113, 99, 91, 98, 32, 45, 32, 49, 93, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 36, 123, 103, 46, 110, 97, 109, 101, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 40, 91, 93, 44, 32, 104, 44, 32, 40, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 46, 115, 112, 108, 105, 99, 101, 40, 49, 44, 32, 48, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 101, 99, 46, 113, 99, 91, 98, 32, 45, 32, 49, 93, 32, 61, 32, 70, 98, 40, 107, 44, 32, 109, 44, 32, 110, 117, 108, 108, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 71, 98, 40, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 78, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 72, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 86, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 110, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 118, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 110, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 118, 32, 61, 32, 96, 36, 123, 110, 46, 110, 97, 109, 101, 125, 46, 36, 123, 98, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 64, 64, 34, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 83, 121, 109, 98, 111, 108, 91, 98, 46, 115, 117, 98, 115, 116, 114, 105, 110, 103, 40, 50, 41, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 110, 46, 101, 99, 46, 66, 99, 46, 112, 117, 115, 104, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 121, 32, 61, 32, 110, 46, 101, 99, 46, 111, 99, 44, 32, 122, 32, 61, 32, 121, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 122, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 122, 46, 104, 99, 32, 38, 38, 32, 122, 46, 99, 108, 97, 115, 115, 78, 97, 109, 101, 32, 33, 61, 61, 32, 110, 46, 110, 97, 109, 101, 32, 38, 38, 32, 122, 46, 112, 99, 32, 61, 61, 61, 32, 99, 32, 45, 32, 50, 32, 63, 32, 40, 117, 46, 112, 99, 32, 61, 32, 99, 32, 45, 32, 50, 44, 32, 117, 46, 99, 108, 97, 115, 115, 78, 97, 109, 101, 32, 61, 32, 110, 46, 110, 97, 109, 101, 44, 32, 121, 91, 98, 93, 32, 61, 32, 117, 41, 32, 58, 32, 40, 111, 98, 40, 121, 44, 32, 98, 44, 32, 118, 41, 44, 32, 121, 91, 98, 93, 46, 104, 99, 91, 99, 32, 45, 32, 50, 93, 32, 61, 32, 117, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 40, 91, 93, 44, 32, 109, 44, 32, 40, 69, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 32, 61, 32, 70, 98, 40, 118, 44, 32, 69, 44, 32, 110, 44, 32, 102, 44, 32, 104, 44, 32, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 121, 91, 98, 93, 46, 104, 99, 32, 63, 32, 40, 69, 46, 112, 99, 32, 61, 32, 99, 32, 45, 32, 50, 44, 32, 121, 91, 98, 93, 32, 61, 32, 69, 41, 32, 58, 32, 121, 91, 98, 93, 46, 104, 99, 91, 99, 32, 45, 32, 50, 93, 32, 61, 32, 69, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 83, 40, 97, 44, 32, 74, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 80, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 78, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 118, 97, 108, 117, 101, 115, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 118, 97, 108, 117, 101, 115, 91, 102, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 102, 44, 32, 104, 41, 32, 61, 62, 32, 104, 46, 118, 97, 108, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 99, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 75, 98, 40, 98, 44, 32, 99, 44, 32, 100, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 99, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 112, 98, 40, 98, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 97, 40, 97, 44, 32, 34, 101, 110, 117, 109, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 78, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 100, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 100, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 108, 117, 101, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 99, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 74, 40, 96, 36, 123, 100, 46, 110, 97, 109, 101, 125, 95, 36, 123, 98, 125, 96, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 118, 97, 108, 117, 101, 115, 91, 99, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 78, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 100, 41, 32, 61, 62, 32, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 100, 44, 32, 101, 41, 32, 61, 62, 32, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 99, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 76, 98, 40, 98, 44, 32, 99, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 99, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 77, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 71, 98, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 78, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 72, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 86, 40, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 112, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 97, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 45, 32, 49, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 40, 91, 93, 44, 32, 103, 44, 32, 40, 107, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 121, 98, 40, 97, 44, 32, 70, 98, 40, 97, 44, 32, 91, 107, 91, 48, 93, 44, 32, 110, 117, 108, 108, 93, 46, 99, 111, 110, 99, 97, 116, 40, 107, 46, 115, 108, 105, 99, 101, 40, 49, 41, 41, 44, 32, 110, 117, 108, 108, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 44, 32, 98, 32, 45, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 122, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 78, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 49, 32, 61, 61, 61, 32, 101, 32, 38, 38, 32, 40, 101, 32, 61, 32, 52, 50, 57, 52, 57, 54, 55, 50, 57, 53, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 51, 50, 32, 45, 32, 56, 32, 42, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 103, 32, 60, 60, 32, 102, 32, 62, 62, 62, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 98, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 117, 110, 115, 105, 103, 110, 101, 100, 34, 41, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 103, 44, 32, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 32, 62, 62, 62, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 103, 44, 32, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 40, 97, 44, 32, 123, 32, 110, 97, 109, 101, 58, 32, 98, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 101, 44, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 104, 44, 32, 109, 99, 58, 32, 56, 44, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 78, 98, 40, 98, 44, 32, 99, 44, 32, 48, 32, 33, 61, 61, 32, 100, 41, 44, 32, 107, 99, 58, 32, 110, 117, 108, 108, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 101, 40, 114, 46, 98, 117, 102, 102, 101, 114, 44, 32, 66, 91, 102, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 44, 32, 66, 91, 102, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 91, 73, 110, 116, 56, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 44, 32, 73, 110, 116, 49, 54, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 49, 54, 65, 114, 114, 97, 121, 44, 32, 73, 110, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 70, 108, 111, 97, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 70, 108, 111, 97, 116, 54, 52, 65, 114, 114, 97, 121, 93, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 78, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 40, 97, 44, 32, 123, 32, 110, 97, 109, 101, 58, 32, 99, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 100, 44, 32, 109, 99, 58, 32, 56, 44, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 100, 32, 125, 44, 32, 123, 32, 77, 99, 58, 32, 116, 114, 117, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 40, 97, 44, 32, 79, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 84, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 78, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 86, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 86, 40, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 86, 40, 107, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 32, 61, 32, 86, 40, 110, 44, 32, 117, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 40, 91, 97, 93, 44, 32, 91, 98, 93, 44, 32, 40, 118, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 118, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 110, 101, 119, 32, 120, 98, 40, 99, 44, 32, 118, 46, 101, 99, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 116, 114, 117, 101, 44, 32, 118, 44, 32, 100, 44, 32, 102, 44, 32, 103, 44, 32, 109, 44, 32, 117, 41, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 78, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 34, 115, 116, 100, 58, 58, 115, 116, 114, 105, 110, 103, 34, 32, 61, 61, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 66, 91, 100, 32, 62, 62, 32, 50, 93, 44, 32, 102, 32, 61, 32, 100, 32, 43, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 104, 32, 61, 32, 102, 44, 32, 103, 32, 61, 32, 48, 59, 32, 103, 32, 60, 61, 32, 101, 59, 32, 43, 43, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 102, 32, 43, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 61, 61, 32, 101, 32, 124, 124, 32, 48, 32, 61, 61, 32, 116, 91, 107, 93, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 104, 32, 63, 32, 72, 40, 116, 44, 32, 104, 44, 32, 107, 32, 45, 32, 104, 41, 32, 58, 32, 34, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 109, 41, 32, 118, 97, 114, 32, 109, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 109, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 48, 41, 44, 32, 109, 32, 43, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 107, 32, 43, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 65, 114, 114, 97, 121, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 103, 32, 61, 32, 48, 59, 32, 103, 32, 60, 32, 101, 59, 32, 43, 43, 103, 41, 32, 109, 91, 103, 93, 32, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 116, 91, 102, 32, 43, 32, 103, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 109, 46, 106, 111, 105, 110, 40, 34, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 38, 38, 32, 40, 101, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 44, 32, 104, 32, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 104, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 85, 105, 110, 116, 56, 67, 108, 97, 109, 112, 101, 100, 65, 114, 114, 97, 121, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 73, 110, 116, 56, 65, 114, 114, 97, 121, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 34, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 110, 111, 110, 45, 115, 116, 114, 105, 110, 103, 32, 116, 111, 32, 115, 116, 100, 58, 58, 115, 116, 114, 105, 110, 103, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 38, 38, 32, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 103, 32, 61, 32, 102, 32, 61, 32, 48, 59, 32, 103, 32, 60, 32, 101, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 101, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 49, 50, 55, 32, 62, 61, 32, 107, 32, 63, 32, 102, 43, 43, 32, 58, 32, 50, 48, 52, 55, 32, 62, 61, 32, 107, 32, 63, 32, 102, 32, 43, 61, 32, 50, 32, 58, 32, 53, 53, 50, 57, 54, 32, 60, 61, 32, 107, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 107, 32, 63, 32, 40, 102, 32, 43, 61, 32, 52, 44, 32, 43, 43, 103, 41, 32, 58, 32, 102, 32, 43, 61, 32, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 102, 32, 61, 32, 101, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 113, 99, 40, 52, 32, 43, 32, 102, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 32, 61, 32, 103, 32, 43, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 103, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 38, 38, 32, 104, 41, 32, 78, 97, 40, 101, 44, 32, 107, 44, 32, 102, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 102, 59, 32, 43, 43, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 101, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 53, 53, 32, 60, 32, 109, 41, 32, 116, 104, 114, 111, 119, 32, 80, 40, 107, 41, 44, 32, 110, 101, 119, 32, 76, 40, 34, 83, 116, 114, 105, 110, 103, 32, 104, 97, 115, 32, 85, 84, 70, 45, 49, 54, 32, 99, 111, 100, 101, 32, 117, 110, 105, 116, 115, 32, 116, 104, 97, 116, 32, 100, 111, 32, 110, 111, 116, 32, 102, 105, 116, 32, 105, 110, 32, 56, 32, 98, 105, 116, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 91, 107, 32, 43, 32, 104, 93, 32, 61, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 102, 59, 32, 43, 43, 104, 41, 32, 116, 91, 107, 32, 43, 32, 104, 93, 32, 61, 32, 101, 91, 104, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 100, 32, 38, 38, 32, 100, 46, 112, 117, 115, 104, 40, 80, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 99, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 105, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 99, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 83, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 78, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 81, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 82, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 83, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 120, 91, 103, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 52, 32, 61, 61, 61, 32, 98, 32, 38, 38, 32, 40, 100, 32, 61, 32, 84, 98, 44, 32, 101, 32, 61, 32, 85, 98, 44, 32, 102, 32, 61, 32, 86, 98, 44, 32, 104, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 66, 91, 103, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 107, 32, 61, 32, 66, 91, 103, 32, 62, 62, 32, 50, 93, 44, 32, 109, 44, 32, 110, 32, 61, 32, 103, 32, 43, 32, 52, 44, 32, 117, 32, 61, 32, 48, 59, 32, 117, 32, 60, 61, 32, 107, 59, 32, 43, 43, 117, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 118, 32, 61, 32, 103, 32, 43, 32, 52, 32, 43, 32, 117, 32, 42, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 117, 32, 61, 61, 32, 107, 32, 124, 124, 32, 48, 32, 61, 61, 32, 104, 40, 118, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 100, 40, 110, 44, 32, 118, 32, 45, 32, 110, 41, 44, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 109, 32, 63, 32, 109, 32, 61, 32, 110, 32, 58, 32, 40, 109, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 48, 41, 44, 32, 109, 32, 43, 61, 32, 110, 41, 44, 32, 110, 32, 61, 32, 118, 32, 43, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 103, 44, 32, 107, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 115, 116, 114, 105, 110, 103, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 76, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 110, 111, 110, 45, 115, 116, 114, 105, 110, 103, 32, 116, 111, 32, 67, 43, 43, 32, 115, 116, 114, 105, 110, 103, 32, 116, 121, 112, 101, 32, 36, 123, 99, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 102, 40, 107, 41, 44, 32, 110, 32, 61, 32, 113, 99, 40, 52, 32, 43, 32, 109, 32, 43, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 110, 32, 62, 62, 32, 50, 93, 32, 61, 32, 109, 32, 47, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 40, 107, 44, 32, 110, 32, 43, 32, 52, 44, 32, 109, 32, 43, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 103, 32, 38, 38, 32, 103, 46, 112, 117, 115, 104, 40, 80, 44, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 99, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 105, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 99, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 72, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 98, 91, 97, 93, 32, 61, 32, 123, 32, 110, 97, 109, 101, 58, 32, 78, 40, 98, 41, 44, 32, 121, 99, 58, 32, 86, 40, 99, 44, 32, 100, 41, 44, 32, 110, 99, 58, 32, 86, 40, 101, 44, 32, 102, 41, 44, 32, 65, 99, 58, 32, 91, 93, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 98, 91, 97, 93, 46, 65, 99, 46, 112, 117, 115, 104, 40, 123, 32, 71, 99, 58, 32, 78, 40, 98, 41, 44, 32, 76, 99, 58, 32, 99, 44, 32, 74, 99, 58, 32, 86, 40, 100, 44, 32, 101, 41, 44, 32, 75, 99, 58, 32, 102, 44, 32, 82, 99, 58, 32, 104, 44, 32, 81, 99, 58, 32, 86, 40, 103, 44, 32, 107, 41, 44, 32, 83, 99, 58, 32, 109, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 97, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 78, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 40, 97, 44, 32, 123, 32, 78, 99, 58, 32, 116, 114, 117, 101, 44, 32, 110, 97, 109, 101, 58, 32, 98, 44, 32, 109, 99, 58, 32, 48, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 71, 97, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 68, 97, 116, 101, 46, 110, 111, 119, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 97, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 70, 97, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 98, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 110, 102, 105, 110, 105, 116, 121, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 77, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 90, 97, 40, 98, 44, 32, 34, 101, 109, 118, 97, 108, 58, 58, 97, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 88, 98, 40, 98, 44, 32, 99, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 83, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 89, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 77, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 40, 110, 117, 108, 108, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 68, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 89, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 77, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 98, 91, 99, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 102, 32, 63, 32, 78, 40, 99, 41, 32, 58, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 40, 98, 44, 32, 98, 91, 99, 93, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 73, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 65, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 97, 99, 40, 97, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 45, 45, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 34, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 40, 111, 98, 106, 44, 32, 102, 117, 110, 99, 44, 32, 100, 101, 115, 116, 114, 117, 99, 116, 111, 114, 115, 82, 101, 102, 44, 32, 97, 114, 103, 115, 41, 32, 123, 92, 110, 34, 44, 32, 102, 32, 61, 32, 48, 44, 32, 104, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 99, 32, 38, 38, 32, 104, 46, 112, 117, 115, 104, 40, 34, 111, 98, 106, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 103, 32, 61, 32, 91, 34, 114, 101, 116, 84, 121, 112, 101, 34, 93, 44, 32, 107, 32, 61, 32, 91, 100, 93, 44, 32, 109, 32, 61, 32, 48, 59, 32, 109, 32, 60, 32, 97, 59, 32, 43, 43, 109, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 46, 112, 117, 115, 104, 40, 34, 97, 114, 103, 34, 32, 43, 32, 109, 41, 44, 32, 103, 46, 112, 117, 115, 104, 40, 34, 97, 114, 103, 84, 121, 112, 101, 34, 32, 43, 32, 109, 41, 44, 32, 107, 46, 112, 117, 115, 104, 40, 98, 91, 109, 93, 41, 44, 32, 101, 32, 43, 61, 32, 96, 32, 32, 118, 97, 114, 32, 97, 114, 103, 36, 123, 109, 125, 32, 61, 32, 97, 114, 103, 84, 121, 112, 101, 36, 123, 109, 125, 46, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 40, 97, 114, 103, 115, 36, 123, 102, 32, 63, 32, 34, 43, 34, 32, 43, 32, 102, 32, 58, 32, 34, 34, 125, 41, 59, 10, 96, 44, 32, 102, 32, 43, 61, 32, 98, 91, 109, 93, 46, 109, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 43, 61, 32, 96, 32, 32, 118, 97, 114, 32, 114, 118, 32, 61, 32, 36, 123, 49, 32, 61, 61, 61, 32, 99, 32, 63, 32, 34, 110, 101, 119, 32, 102, 117, 110, 99, 34, 32, 58, 32, 34, 102, 117, 110, 99, 46, 99, 97, 108, 108, 34, 125, 40, 36, 123, 104, 46, 106, 111, 105, 110, 40, 34, 44, 32, 34, 41, 125, 41, 59, 10, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 46, 78, 99, 32, 124, 124, 32, 40, 103, 46, 112, 117, 115, 104, 40, 34, 101, 109, 118, 97, 108, 95, 114, 101, 116, 117, 114, 110, 86, 97, 108, 117, 101, 34, 41, 44, 32, 107, 46, 112, 117, 115, 104, 40, 88, 98, 41, 44, 32, 101, 32, 43, 61, 32, 34, 32, 32, 114, 101, 116, 117, 114, 110, 32, 101, 109, 118, 97, 108, 95, 114, 101, 116, 117, 114, 110, 86, 97, 108, 117, 101, 40, 114, 101, 116, 84, 121, 112, 101, 44, 32, 100, 101, 115, 116, 114, 117, 99, 116, 111, 114, 115, 82, 101, 102, 44, 32, 114, 118, 41, 59, 92, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 112, 117, 115, 104, 40, 101, 32, 43, 32, 34, 125, 59, 92, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 69, 98, 40, 103, 41, 40, 46, 46, 46, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 96, 109, 101, 116, 104, 111, 100, 67, 97, 108, 108, 101, 114, 60, 40, 36, 123, 98, 46, 109, 97, 112, 40, 40, 110, 41, 32, 61, 62, 32, 110, 46, 110, 97, 109, 101, 41, 46, 106, 111, 105, 110, 40, 34, 44, 32, 34, 41, 125, 41, 32, 61, 62, 32, 36, 123, 100, 46, 110, 97, 109, 101, 125, 62, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 36, 98, 40, 74, 40, 99, 44, 32, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 84, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 57, 32, 60, 32, 97, 32, 38, 38, 32, 40, 75, 91, 97, 32, 43, 32, 49, 93, 32, 43, 61, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 77, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 90, 97, 40, 97, 44, 32, 34, 95, 101, 109, 118, 97, 108, 95, 116, 97, 107, 101, 95, 118, 97, 108, 117, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 81, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 111, 97, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 99, 91, 97, 93, 32, 38, 38, 32, 40, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 98, 99, 91, 97, 93, 46, 105, 100, 41, 44, 32, 100, 101, 108, 101, 116, 101, 32, 98, 99, 91, 97, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 98, 99, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 99, 40, 40, 41, 32, 61, 62, 32, 114, 99, 40, 97, 44, 32, 112, 101, 114, 102, 111, 114, 109, 97, 110, 99, 101, 46, 110, 111, 119, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 99, 91, 97, 93, 32, 61, 32, 123, 32, 105, 100, 58, 32, 99, 44, 32, 85, 99, 58, 32, 98, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 112, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 40, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 41, 41, 46, 103, 101, 116, 70, 117, 108, 108, 89, 101, 97, 114, 40, 41, 44, 32, 102, 32, 61, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 101, 44, 32, 48, 44, 32, 49, 41, 46, 103, 101, 116, 84, 105, 109, 101, 122, 111, 110, 101, 79, 102, 102, 115, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 101, 44, 32, 54, 44, 32, 49, 41, 46, 103, 101, 116, 84, 105, 109, 101, 122, 111, 110, 101, 79, 102, 102, 115, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 97, 32, 62, 62, 32, 50, 93, 32, 61, 32, 54, 48, 32, 42, 32, 77, 97, 116, 104, 46, 109, 97, 120, 40, 102, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 65, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 78, 117, 109, 98, 101, 114, 40, 102, 32, 33, 61, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 40, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 77, 97, 116, 104, 46, 97, 98, 115, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 96, 85, 84, 67, 36, 123, 48, 32, 60, 61, 32, 104, 32, 63, 32, 34, 45, 34, 32, 58, 32, 34, 43, 34, 125, 36, 123, 83, 116, 114, 105, 110, 103, 40, 77, 97, 116, 104, 46, 102, 108, 111, 111, 114, 40, 103, 32, 47, 32, 54, 48, 41, 41, 46, 112, 97, 100, 83, 116, 97, 114, 116, 40, 50, 44, 32, 34, 48, 34, 41, 125, 36, 123, 83, 116, 114, 105, 110, 103, 40, 103, 32, 37, 32, 54, 48, 41, 46, 112, 97, 100, 83, 116, 97, 114, 116, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 48, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 60, 32, 102, 32, 63, 32, 40, 78, 97, 40, 97, 44, 32, 99, 44, 32, 49, 55, 41, 44, 32, 78, 97, 40, 98, 44, 32, 100, 44, 32, 49, 55, 41, 41, 32, 58, 32, 40, 78, 97, 40, 97, 44, 32, 100, 44, 32, 49, 55, 41, 44, 32, 78, 97, 40, 98, 44, 32, 99, 44, 32, 49, 55, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 62, 62, 62, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 49, 52, 55, 52, 56, 51, 54, 52, 56, 32, 60, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 49, 59, 32, 52, 32, 62, 61, 32, 99, 59, 32, 99, 32, 42, 61, 32, 50, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 32, 42, 32, 40, 49, 32, 43, 32, 48, 46, 50, 32, 47, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 77, 97, 116, 104, 46, 109, 105, 110, 40, 100, 44, 32, 97, 32, 43, 32, 49, 48, 48, 54, 54, 51, 50, 57, 54, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 40, 77, 97, 116, 104, 46, 109, 105, 110, 40, 50, 49, 52, 55, 52, 56, 51, 54, 52, 56, 44, 32, 54, 53, 53, 51, 54, 32, 42, 32, 77, 97, 116, 104, 46, 99, 101, 105, 108, 40, 77, 97, 116, 104, 46, 109, 97, 120, 40, 97, 44, 32, 100, 41, 32, 47, 32, 54, 53, 53, 51, 54, 41, 41, 32, 45, 32, 106, 97, 46, 98, 117, 102, 102, 101, 114, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 43, 32, 54, 53, 53, 51, 53, 41, 32, 47, 32, 54, 53, 53, 51, 54, 32, 124, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 106, 97, 46, 103, 114, 111, 119, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 99, 40, 41, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 98, 32, 43, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 66, 91, 97, 32, 43, 32, 52, 32, 42, 32, 101, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 100, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 102, 41, 32, 114, 91, 101, 43, 43, 93, 32, 61, 32, 100, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 91, 101, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 43, 61, 32, 100, 46, 108, 101, 110, 103, 116, 104, 32, 43, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 68, 97, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 104, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 97, 32, 62, 62, 32, 50, 93, 32, 61, 32, 99, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 41, 32, 61, 62, 32, 100, 32, 43, 61, 32, 101, 46, 108, 101, 110, 103, 116, 104, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 122, 97, 58, 32, 40, 41, 32, 61, 62, 32, 53, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 97, 58, 32, 40, 41, 32, 61, 62, 32, 53, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 85, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 44, 32, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 99, 59, 32, 102, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 66, 91, 98, 32, 62, 62, 32, 50, 93, 44, 32, 103, 32, 61, 32, 66, 91, 98, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 107, 32, 61, 32, 48, 59, 32, 107, 32, 60, 32, 103, 59, 32, 107, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 97, 44, 32, 110, 32, 61, 32, 116, 91, 104, 32, 43, 32, 107, 93, 44, 32, 117, 32, 61, 32, 105, 99, 91, 109, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 110, 32, 124, 124, 32, 49, 48, 32, 61, 61, 61, 32, 110, 32, 63, 32, 40, 40, 49, 32, 61, 61, 61, 32, 109, 32, 63, 32, 104, 97, 32, 58, 32, 113, 41, 40, 72, 40, 117, 41, 41, 44, 32, 117, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 48, 41, 32, 58, 32, 117, 46, 112, 117, 115, 104, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 43, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 91, 100, 32, 62, 62, 32, 50, 93, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 115, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 58, 32, 116, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 36, 58, 32, 117, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 76, 97, 58, 32, 118, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 103, 58, 32, 119, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 58, 32, 120, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 78, 97, 58, 32, 121, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 71, 58, 32, 122, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 74, 58, 32, 65, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 58, 32, 66, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 58, 32, 67, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 58, 32, 68, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 77, 97, 58, 32, 69, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 58, 32, 70, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 58, 32, 71, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 58, 32, 72, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 86, 58, 32, 73, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 58, 32, 74, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 88, 97, 58, 32, 75, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 98, 58, 32, 76, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 97, 58, 32, 77, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 97, 58, 32, 78, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 58, 32, 79, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 97, 58, 32, 80, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 98, 58, 32, 81, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 58, 32, 82, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 58, 32, 83, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 66, 58, 32, 84, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 69, 58, 32, 85, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 88, 58, 32, 86, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 58, 32, 87, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 75, 97, 58, 32, 88, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 72, 97, 58, 32, 89, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 58, 32, 90, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 89, 58, 32, 36, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 58, 32, 97, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 106, 58, 32, 98, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 58, 32, 99, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 58, 32, 100, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 112, 58, 32, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 58, 32, 102, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 90, 58, 32, 103, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 58, 32, 104, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 90, 97, 58, 32, 106, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 89, 97, 58, 32, 107, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 98, 58, 32, 108, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 36, 97, 58, 32, 109, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 97, 58, 32, 110, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 98, 58, 32, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 97, 58, 32, 112, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 103, 97, 58, 32, 113, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 86, 97, 58, 32, 114, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 98, 58, 32, 115, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 97, 58, 32, 116, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 103, 98, 58, 32, 117, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 106, 97, 58, 32, 118, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 85, 97, 58, 32, 119, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 98, 58, 32, 120, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 113, 58, 32, 40, 97, 41, 32, 61, 62, 32, 97, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 66, 97, 58, 32, 100, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 97, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 99, 40, 116, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 97, 44, 32, 97, 32, 43, 32, 98, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 88, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 32, 61, 32, 99, 46, 101, 120, 112, 111, 114, 116, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 106, 97, 32, 61, 32, 88, 46, 104, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 32, 61, 32, 88, 46, 109, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 88, 46, 105, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 45, 45, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 51, 32, 61, 32, 108, 46, 109, 111, 110, 105, 116, 111, 114, 82, 117, 110, 68, 101, 112, 101, 110, 100, 101, 110, 99, 105, 101, 115, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 51, 46, 99, 97, 108, 108, 40, 108, 44, 32, 67, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 32, 67, 32, 38, 38, 32, 40, 110, 117, 108, 108, 32, 33, 61, 61, 32, 118, 97, 32, 38, 38, 32, 40, 99, 108, 101, 97, 114, 73, 110, 116, 101, 114, 118, 97, 108, 40, 118, 97, 41, 44, 32, 118, 97, 32, 61, 32, 110, 117, 108, 108, 41, 44, 32, 68, 32, 38, 38, 32, 40, 99, 32, 61, 32, 68, 44, 32, 68, 32, 61, 32, 110, 117, 108, 108, 44, 32, 99, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 88, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 43, 43, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 108, 46, 109, 111, 110, 105, 116, 111, 114, 82, 117, 110, 68, 101, 112, 101, 110, 100, 101, 110, 99, 105, 101, 115, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 108, 44, 32, 67, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 123, 32, 97, 58, 32, 121, 100, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 40, 98, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 40, 96, 77, 111, 100, 117, 108, 101, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 32, 99, 97, 108, 108, 98, 97, 99, 107, 32, 102, 97, 105, 108, 101, 100, 32, 119, 105, 116, 104, 32, 101, 114, 114, 111, 114, 58, 32, 36, 123, 99, 125, 96, 41, 44, 32, 98, 97, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 97, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 121, 97, 32, 58, 32, 121, 97, 32, 61, 32, 120, 97, 40, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 41, 32, 63, 32, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 32, 58, 32, 108, 46, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 32, 63, 32, 108, 46, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 40, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 44, 32, 112, 41, 32, 58, 32, 112, 32, 43, 32, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 40, 99, 46, 105, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 46, 99, 97, 116, 99, 104, 40, 98, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 125, 40, 41, 44, 32, 113, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 113, 99, 32, 61, 32, 88, 46, 106, 98, 41, 40, 97, 41, 44, 32, 88, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 88, 97, 32, 61, 32, 88, 46, 107, 98, 41, 40, 97, 41, 44, 32, 80, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 80, 32, 61, 32, 88, 46, 108, 98, 41, 40, 97, 41, 44, 32, 114, 99, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 114, 99, 32, 61, 32, 88, 46, 110, 98, 41, 40, 97, 44, 32, 98, 41, 44, 32, 87, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 87, 32, 61, 32, 88, 46, 111, 98, 41, 40, 97, 44, 32, 98, 41, 44, 32, 75, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 75, 97, 32, 61, 32, 88, 46, 112, 98, 41, 40, 97, 41, 44, 32, 89, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 89, 32, 61, 32, 88, 46, 113, 98, 41, 40, 97, 41, 44, 32, 90, 32, 61, 32, 40, 41, 32, 61, 62, 32, 40, 90, 32, 61, 32, 88, 46, 114, 98, 41, 40, 41, 44, 32, 112, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 112, 99, 32, 61, 32, 88, 46, 115, 98, 41, 40, 97, 41, 44, 32, 110, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 110, 99, 32, 61, 32, 88, 46, 116, 98, 41, 40, 97, 41, 44, 32, 76, 97, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 40, 76, 97, 32, 61, 32, 88, 46, 117, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 41, 44, 32, 111, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 111, 99, 32, 61, 32, 88, 46, 118, 98, 41, 40, 97, 41, 44, 32, 122, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 122, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 32, 61, 32, 88, 46, 119, 98, 41, 40, 97, 44, 32, 98, 41, 44, 32, 65, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 40, 65, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 105, 32, 61, 32, 88, 46, 120, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 44, 32, 66, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 40, 66, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 32, 61, 32, 88, 46, 121, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 106, 106, 32, 61, 32, 88, 46, 122, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 32, 61, 32, 88, 46, 65, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 67, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 67, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 32, 61, 32, 88, 46, 66, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 44, 32, 68, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 40, 68, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 32, 61, 32, 88, 46, 67, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 44, 32, 69, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 69, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 32, 61, 32, 88, 46, 68, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 44, 32, 70, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 106, 106, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 70, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 106, 106, 105, 32, 61, 32, 88, 46, 69, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 44, 32, 71, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 71, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 106, 32, 61, 32, 88, 46, 70, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 44, 32, 72, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 106, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 40, 72, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 106, 105, 32, 61, 32, 88, 46, 71, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 44, 32, 73, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 40, 73, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 32, 61, 32, 88, 46, 72, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 44, 32, 74, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 40, 74, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 106, 106, 32, 61, 32, 88, 46, 73, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 44, 32, 75, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 75, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 106, 32, 61, 32, 88, 46, 74, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 44, 32, 76, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 76, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 32, 61, 32, 88, 46, 75, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 44, 32, 77, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 40, 77, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 105, 32, 61, 32, 88, 46, 76, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 44, 32, 78, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 106, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 78, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 106, 105, 32, 61, 32, 88, 46, 77, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 44, 32, 79, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 40, 79, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 106, 106, 32, 61, 32, 88, 46, 78, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 44, 32, 80, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 105, 106, 106, 105, 105, 105, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 44, 32, 118, 44, 32, 121, 44, 32, 122, 41, 32, 61, 62, 32, 40, 80, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 105, 106, 106, 105, 105, 105, 105, 105, 105, 32, 61, 32, 88, 46, 79, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 44, 32, 118, 44, 32, 121, 44, 32, 122, 41, 44, 32, 81, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 105, 106, 106, 105, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 44, 32, 118, 41, 32, 61, 62, 32, 40, 81, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 105, 106, 106, 105, 105, 105, 105, 32, 61, 32, 88, 46, 80, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 44, 32, 118, 41, 44, 32, 82, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 41, 32, 61, 62, 32, 40, 82, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 105, 105, 32, 61, 32, 88, 46, 81, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 41, 44, 32, 83, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 105, 106, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 41, 32, 61, 62, 32, 40, 83, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 105, 105, 106, 106, 105, 105, 32, 61, 32, 88, 46, 82, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 41, 44, 32, 84, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 40, 84, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 105, 32, 61, 32, 88, 46, 83, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 44, 32, 85, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 106, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 40, 85, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 106, 105, 32, 61, 32, 88, 46, 84, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 44, 32, 86, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 41, 32, 61, 62, 32, 40, 86, 100, 32, 61, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 106, 106, 32, 61, 32, 88, 46, 85, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 32, 61, 32, 88, 46, 86, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 102, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 102, 105, 105, 32, 61, 32, 88, 46, 87, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 32, 61, 32, 88, 46, 88, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 105, 105, 32, 61, 32, 88, 46, 89, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 102, 102, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 102, 102, 105, 105, 32, 61, 32, 88, 46, 90, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 106, 105, 105, 105, 105, 32, 61, 32, 88, 46, 95, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 32, 61, 32, 88, 46, 36, 98, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 88, 46, 97, 99, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 41, 32, 61, 62, 32, 40, 108, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 88, 46, 98, 99, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 87, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 83, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 90, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 98, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 66, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 121, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 85, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 116, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 120, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 68, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 72, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 122, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 70, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 69, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 71, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 32, 33, 61, 61, 32, 107, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 65, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 67, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 118, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 88, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 32, 33, 61, 61, 32, 107, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 102, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 32, 33, 61, 61, 32, 109, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 103, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 32, 33, 61, 61, 32, 110, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 84, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 115, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 89, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 32, 33, 61, 61, 32, 107, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 36, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 99, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 32, 33, 61, 61, 32, 109, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 86, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 74, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 32, 33, 61, 61, 32, 110, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 73, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 32, 33, 61, 61, 32, 109, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 82, 99, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 46, 103, 101, 116, 40, 97, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 33, 61, 61, 32, 99, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 79, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 66, 100, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 78, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 122, 100, 40, 97, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 118, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 65, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 112, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 77, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 85, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 113, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 32, 33, 61, 61, 32, 107, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 80, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 77, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 116, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 72, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 32, 33, 61, 61, 32, 109, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 115, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 71, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 32, 33, 61, 61, 32, 107, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 120, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 81, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 70, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 111, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 76, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 74, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 32, 33, 61, 61, 32, 109, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 108, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 109, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 32, 33, 61, 61, 32, 107, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 32, 33, 61, 61, 32, 109, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 106, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 44, 32, 118, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 121, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 81, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 44, 32, 118, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 122, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 121, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 122, 32, 33, 61, 61, 32, 122, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 122, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 107, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 44, 32, 118, 44, 32, 121, 44, 32, 122, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 44, 32, 118, 44, 32, 121, 44, 32, 122, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 70, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 69, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 70, 32, 33, 61, 61, 32, 70, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 70, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 75, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 118, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 82, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 44, 32, 117, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 118, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 121, 32, 33, 61, 61, 32, 121, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 121, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 117, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 44, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 118, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 117, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 32, 33, 61, 61, 32, 118, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 118, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 114, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 32, 33, 61, 61, 32, 109, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 110, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 100, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 107, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 117, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 117, 32, 33, 61, 61, 32, 117, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 117, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 87, 100, 59, 10, 32, 32, 32, 32, 32, 32, 68, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 88, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 100, 32, 124, 124, 32, 89, 100, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 100, 32, 124, 124, 32, 40, 68, 32, 61, 32, 88, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 89, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 87, 100, 32, 38, 38, 32, 40, 87, 100, 32, 61, 32, 116, 114, 117, 101, 44, 32, 108, 46, 99, 97, 108, 108, 101, 100, 82, 117, 110, 32, 61, 32, 116, 114, 117, 101, 44, 32, 33, 107, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 115, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 108, 46, 111, 110, 82, 117, 110, 116, 105, 109, 101, 73, 110, 105, 116, 105, 97, 108, 105, 122, 101, 100, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 46, 112, 111, 115, 116, 82, 117, 110, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 108, 46, 112, 111, 115, 116, 82, 117, 110, 32, 38, 38, 32, 40, 108, 46, 112, 111, 115, 116, 82, 117, 110, 32, 61, 32, 91, 108, 46, 112, 111, 115, 116, 82, 117, 110, 93, 41, 59, 32, 108, 46, 112, 111, 115, 116, 82, 117, 110, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 108, 46, 112, 111, 115, 116, 82, 117, 110, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 48, 32, 60, 32, 67, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 46, 112, 114, 101, 82, 117, 110, 41, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 108, 46, 112, 114, 101, 82, 117, 110, 32, 38, 38, 32, 40, 108, 46, 112, 114, 101, 82, 117, 110, 32, 61, 32, 91, 108, 46, 112, 114, 101, 82, 117, 110, 93, 41, 59, 32, 108, 46, 112, 114, 101, 82, 117, 110, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 117, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 114, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 60, 32, 67, 32, 124, 124, 32, 40, 108, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 32, 63, 32, 40, 108, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 40, 34, 82, 117, 110, 110, 105, 110, 103, 46, 46, 46, 34, 41, 44, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 108, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 40, 34, 34, 41, 44, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 49, 41, 41, 32, 58, 32, 97, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 46, 112, 114, 101, 73, 110, 105, 116, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 108, 46, 112, 114, 101, 73, 110, 105, 116, 32, 38, 38, 32, 40, 108, 46, 112, 114, 101, 73, 110, 105, 116, 32, 61, 32, 91, 108, 46, 112, 114, 101, 73, 110, 105, 116, 93, 41, 59, 32, 48, 32, 60, 32, 108, 46, 112, 114, 101, 73, 110, 105, 116, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 108, 46, 112, 114, 101, 73, 110, 105, 116, 46, 112, 111, 112, 40, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 89, 100, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 32, 61, 32, 99, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 59, 10, 32, 32, 32, 32, 125, 59, 10, 32, 32, 125, 41, 40, 41, 59, 10, 32, 32, 118, 97, 114, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 112, 108, 97, 121, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 32, 61, 32, 99, 114, 101, 97, 116, 101, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 77, 111, 100, 117, 108, 101, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 114, 101, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 119, 97, 115, 109, 45, 108, 111, 97, 100, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 34, 82, 101, 110, 100, 101, 114, 101, 114, 76, 111, 97, 100, 101, 114, 32, 105, 115, 32, 97, 32, 115, 116, 97, 116, 105, 99, 32, 99, 108, 97, 115, 115, 32, 97, 110, 100, 32, 99, 97, 110, 110, 111, 116, 32, 98, 101, 32, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 100, 46, 34, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 116, 114, 121, 76, 111, 97, 100, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 117, 108, 101, 32, 61, 32, 121, 105, 101, 108, 100, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 112, 108, 97, 121, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 40, 123, 32, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 58, 32, 40, 41, 32, 61, 62, 32, 117, 114, 108, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 84, 114, 105, 101, 115, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 109, 111, 100, 117, 108, 101, 32, 102, 114, 111, 109, 32, 116, 104, 101, 32, 112, 114, 105, 109, 97, 114, 121, 32, 85, 82, 76, 44, 32, 102, 97, 108, 108, 105, 110, 103, 32, 98, 97, 99, 107, 32, 116, 111, 32, 97, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 32, 105, 102, 32, 110, 101, 99, 101, 115, 115, 97, 114, 121, 46, 10, 32, 32, 32, 32, 32, 42, 32, 84, 104, 114, 111, 119, 115, 32, 97, 110, 32, 101, 114, 114, 111, 114, 32, 105, 102, 32, 98, 111, 116, 104, 32, 85, 82, 76, 115, 32, 102, 97, 105, 108, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 80, 114, 111, 109, 105, 115, 101, 60, 77, 111, 100, 117, 108, 101, 62, 32, 45, 32, 65, 32, 112, 114, 111, 109, 105, 115, 101, 32, 116, 104, 97, 116, 32, 114, 101, 115, 111, 108, 118, 101, 115, 32, 116, 111, 32, 116, 104, 101, 32, 108, 111, 97, 100, 101, 100, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 108, 111, 97, 100, 87, 105, 116, 104, 66, 97, 99, 107, 117, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 116, 114, 121, 76, 111, 97, 100, 40, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 41, 46, 99, 97, 116, 99, 104, 40, 40, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 41, 32, 61, 62, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 97, 99, 107, 117, 112, 85, 114, 108, 32, 61, 32, 96, 104, 116, 116, 112, 115, 58, 47, 47, 117, 110, 112, 107, 103, 46, 99, 111, 109, 47, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 125, 64, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 125, 47, 100, 105, 115, 116, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 80, 114, 105, 109, 97, 114, 121, 32, 87, 65, 83, 77, 32, 108, 111, 97, 100, 32, 102, 97, 105, 108, 101, 100, 32, 102, 114, 111, 109, 32, 36, 123, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 125, 46, 32, 69, 114, 114, 111, 114, 58, 32, 36, 123, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 65, 116, 116, 101, 109, 112, 116, 105, 110, 103, 32, 116, 111, 32, 108, 111, 97, 100, 32, 87, 65, 83, 77, 32, 102, 114, 111, 109, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 58, 32, 36, 123, 98, 97, 99, 107, 117, 112, 85, 114, 108, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 121, 105, 101, 108, 100, 32, 116, 104, 105, 115, 46, 95, 116, 114, 121, 76, 111, 97, 100, 40, 98, 97, 99, 107, 117, 112, 85, 114, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 97, 99, 107, 117, 112, 69, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 96, 80, 114, 105, 109, 97, 114, 121, 32, 87, 65, 83, 77, 32, 85, 82, 76, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 96, 66, 97, 99, 107, 117, 112, 32, 87, 65, 83, 77, 32, 85, 82, 76, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 98, 97, 99, 107, 117, 112, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 34, 87, 65, 83, 77, 32, 108, 111, 97, 100, 105, 110, 103, 32, 102, 97, 105, 108, 101, 100, 32, 102, 114, 111, 109, 32, 97, 108, 108, 32, 115, 111, 117, 114, 99, 101, 115, 46, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 80, 117, 98, 108, 105, 99, 32, 109, 101, 116, 104, 111, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 32, 85, 116, 105, 108, 105, 122, 101, 115, 32, 97, 32, 112, 114, 105, 109, 97, 114, 121, 32, 97, 110, 100, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 32, 102, 111, 114, 32, 114, 111, 98, 117, 115, 116, 110, 101, 115, 115, 46, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 80, 114, 111, 109, 105, 115, 101, 60, 77, 111, 100, 117, 108, 101, 62, 32, 45, 32, 65, 32, 112, 114, 111, 109, 105, 115, 101, 32, 116, 104, 97, 116, 32, 114, 101, 115, 111, 108, 118, 101, 115, 32, 116, 111, 32, 116, 104, 101, 32, 108, 111, 97, 100, 101, 100, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 108, 111, 97, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 87, 105, 116, 104, 66, 97, 99, 107, 117, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 83, 101, 116, 115, 32, 97, 32, 110, 101, 119, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 32, 97, 110, 100, 32, 105, 110, 118, 97, 108, 105, 100, 97, 116, 101, 115, 32, 116, 104, 101, 32, 99, 117, 114, 114, 101, 110, 116, 32, 109, 111, 100, 117, 108, 101, 32, 112, 114, 111, 109, 105, 115, 101, 46, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 64, 112, 97, 114, 97, 109, 32, 115, 116, 114, 105, 110, 103, 32, 45, 32, 32, 84, 104, 101, 32, 110, 101, 119, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 117, 114, 108, 32, 61, 61, 61, 32, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 32, 61, 32, 117, 114, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 47, 47, 32, 101, 115, 108, 105, 110, 116, 45, 100, 105, 115, 97, 98, 108, 101, 45, 110, 101, 120, 116, 45, 108, 105, 110, 101, 32, 64, 116, 121, 112, 101, 115, 99, 114, 105, 112, 116, 45, 101, 115, 108, 105, 110, 116, 47, 110, 97, 109, 105, 110, 103, 45, 99, 111, 110, 118, 101, 110, 116, 105, 111, 110, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 44, 32, 34, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 47, 47, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 44, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 101, 100, 32, 117, 115, 105, 110, 103, 32, 112, 97, 99, 107, 97, 103, 101, 32, 105, 110, 102, 111, 114, 109, 97, 116, 105, 111, 110, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 44, 32, 34, 95, 119, 97, 115, 109, 85, 82, 76, 34, 44, 32, 96, 104, 116, 116, 112, 115, 58, 47, 47, 99, 100, 110, 46, 106, 115, 100, 101, 108, 105, 118, 114, 46, 110, 101, 116, 47, 110, 112, 109, 47, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 125, 64, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 125, 47, 100, 105, 115, 116, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 96, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 101, 118, 101, 110, 116, 45, 109, 97, 110, 97, 103, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 69, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 83, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 115, 101, 116, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 97, 100, 100, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 100, 105, 115, 112, 97, 116, 99, 104, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 101, 118, 101, 110, 116, 46, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 61, 62, 32, 108, 105, 115, 116, 101, 110, 101, 114, 40, 101, 118, 101, 110, 116, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 65, 108, 108, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 99, 108, 101, 97, 114, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 111, 102, 102, 115, 99, 114, 101, 101, 110, 45, 111, 98, 115, 101, 114, 118, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 67, 97, 108, 108, 98, 97, 99, 107, 32, 61, 32, 40, 101, 110, 116, 114, 105, 101, 115, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 110, 116, 114, 105, 101, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 110, 116, 114, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 110, 116, 114, 121, 46, 105, 115, 73, 110, 116, 101, 114, 115, 101, 99, 116, 105, 110, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 40, 105, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 67, 97, 108, 108, 98, 97, 99, 107, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 101, 115, 104, 111, 108, 100, 58, 32, 48, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 104, 97, 115, 40, 99, 97, 110, 118, 97, 115, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 100, 101, 108, 101, 116, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 98, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 100, 105, 115, 99, 111, 110, 110, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 114, 101, 115, 105, 122, 101, 45, 111, 98, 115, 101, 114, 118, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 82, 69, 83, 73, 90, 69, 95, 68, 69, 66, 79, 85, 78, 67, 69, 95, 84, 73, 77, 69, 32, 61, 32, 49, 48, 48, 59, 10, 32, 32, 118, 97, 114, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 105, 122, 101, 72, 97, 110, 100, 108, 101, 114, 32, 61, 32, 40, 101, 110, 116, 114, 105, 101, 115, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 110, 116, 114, 105, 101, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 110, 116, 114, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 108, 101, 109, 101, 110, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 101, 108, 101, 109, 101, 110, 116, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 116, 105, 109, 101, 111, 117, 116, 93, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 116, 105, 109, 101, 111, 117, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 110, 101, 119, 84, 105, 109, 101, 111, 117, 116, 32, 61, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 69, 83, 73, 90, 69, 95, 68, 69, 66, 79, 85, 78, 67, 69, 95, 84, 73, 77, 69, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 44, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 110, 101, 119, 84, 105, 109, 101, 111, 117, 116, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 101, 119, 32, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 114, 101, 115, 105, 122, 101, 72, 97, 110, 100, 108, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 104, 97, 115, 40, 99, 97, 110, 118, 97, 115, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 99, 97, 110, 118, 97, 115, 44, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 48, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 108, 101, 109, 101, 110, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 105, 109, 101, 111, 117, 116, 73, 100, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 91, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 105, 109, 101, 111, 117, 116, 73, 100, 41, 32, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 116, 105, 109, 101, 111, 117, 116, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 100, 101, 108, 101, 116, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 105, 122, 101, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 46, 100, 105, 115, 99, 111, 110, 110, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 117, 116, 105, 108, 115, 46, 116, 115, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 72, 101, 120, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 47, 94, 35, 40, 91, 92, 100, 97, 45, 102, 93, 123, 54, 125, 124, 91, 92, 100, 97, 45, 102, 93, 123, 56, 125, 41, 36, 47, 105, 117, 46, 116, 101, 115, 116, 40, 99, 111, 108, 111, 114, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 101, 120, 83, 116, 114, 105, 110, 103, 84, 111, 82, 71, 66, 65, 73, 110, 116, 40, 99, 111, 108, 111, 114, 72, 101, 120, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 72, 101, 120, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 72, 101, 120, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 101, 116, 32, 104, 101, 120, 32, 61, 32, 99, 111, 108, 111, 114, 72, 101, 120, 46, 114, 101, 112, 108, 97, 99, 101, 40, 34, 35, 34, 44, 32, 34, 34, 41, 59, 10, 32, 32, 32, 32, 104, 101, 120, 32, 61, 32, 104, 101, 120, 46, 108, 101, 110, 103, 116, 104, 32, 61, 61, 61, 32, 54, 32, 63, 32, 96, 36, 123, 104, 101, 120, 125, 102, 102, 96, 32, 58, 32, 104, 101, 120, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 112, 97, 114, 115, 101, 73, 110, 116, 40, 104, 101, 120, 44, 32, 49, 54, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 102, 105, 108, 101, 68, 97, 116, 97, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 60, 32, 52, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 105, 108, 101, 83, 105, 103, 110, 97, 116, 117, 114, 101, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 102, 105, 108, 101, 68, 97, 116, 97, 46, 115, 108, 105, 99, 101, 40, 48, 44, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 41, 41, 59, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 46, 108, 101, 110, 103, 116, 104, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 91, 105, 93, 32, 33, 61, 61, 32, 102, 105, 108, 101, 83, 105, 103, 110, 97, 116, 117, 114, 101, 91, 105, 93, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 106, 115, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 76, 79, 84, 84, 73, 69, 95, 74, 83, 79, 78, 95, 77, 65, 78, 68, 65, 84, 79, 82, 89, 95, 70, 73, 69, 76, 68, 83, 46, 101, 118, 101, 114, 121, 40, 40, 102, 105, 101, 108, 100, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 46, 99, 97, 108, 108, 40, 106, 115, 111, 110, 44, 32, 102, 105, 101, 108, 100, 41, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 102, 105, 108, 101, 68, 97, 116, 97, 32, 61, 61, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 74, 83, 79, 78, 46, 112, 97, 114, 115, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 95, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 112, 114, 32, 61, 32, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 63, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 58, 32, 49, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 49, 32, 43, 32, 40, 100, 112, 114, 32, 45, 32, 49, 41, 32, 42, 32, 68, 69, 70, 65, 85, 76, 84, 95, 68, 80, 82, 95, 70, 65, 67, 84, 79, 82, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 69, 108, 101, 109, 101, 110, 116, 73, 110, 86, 105, 101, 119, 112, 111, 114, 116, 40, 101, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 99, 116, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 99, 116, 46, 116, 111, 112, 32, 62, 61, 32, 48, 32, 38, 38, 32, 114, 101, 99, 116, 46, 108, 101, 102, 116, 32, 62, 61, 32, 48, 32, 38, 38, 32, 114, 101, 99, 116, 46, 98, 111, 116, 116, 111, 109, 32, 60, 61, 32, 40, 119, 105, 110, 100, 111, 119, 46, 105, 110, 110, 101, 114, 72, 101, 105, 103, 104, 116, 32, 124, 124, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 100, 111, 99, 117, 109, 101, 110, 116, 69, 108, 101, 109, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 41, 32, 38, 38, 32, 114, 101, 99, 116, 46, 114, 105, 103, 104, 116, 32, 60, 61, 32, 40, 119, 105, 110, 100, 111, 119, 46, 105, 110, 110, 101, 114, 87, 105, 100, 116, 104, 32, 124, 124, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 100, 111, 99, 117, 109, 101, 110, 116, 69, 108, 101, 109, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 41, 59, 10, 32, 32, 125, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 32, 61, 32, 40, 109, 111, 100, 101, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 114, 101, 118, 101, 114, 115, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 98, 111, 117, 110, 99, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 66, 111, 117, 110, 99, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 114, 101, 118, 101, 114, 115, 101, 45, 98, 111, 117, 110, 99, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 66, 111, 117, 110, 99, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 70, 111, 114, 119, 97, 114, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 32, 61, 32, 40, 102, 105, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 67, 111, 110, 116, 97, 105, 110, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 99, 111, 118, 101, 114, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 67, 111, 118, 101, 114, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 108, 108, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 108, 108, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 116, 45, 104, 101, 105, 103, 104, 116, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 116, 72, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 116, 45, 119, 105, 100, 116, 104, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 116, 87, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 78, 111, 110, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 32, 61, 32, 40, 97, 108, 105, 103, 110, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 86, 101, 99, 116, 111, 114, 70, 108, 111, 97, 116, 40, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 97, 108, 105, 103, 110, 91, 48, 93, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 97, 108, 105, 103, 110, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 32, 61, 32, 40, 115, 101, 103, 109, 101, 110, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 86, 101, 99, 116, 111, 114, 70, 108, 111, 97, 116, 40, 41, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 115, 101, 103, 109, 101, 110, 116, 46, 108, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 50, 41, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 115, 101, 103, 109, 101, 110, 116, 91, 48, 93, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 115, 101, 103, 109, 101, 110, 116, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 76, 97, 121, 111, 117, 116, 32, 61, 32, 40, 108, 97, 121, 111, 117, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 76, 97, 121, 111, 117, 116, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 40, 95, 97, 32, 61, 32, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 32, 58, 32, 91, 48, 46, 53, 44, 32, 48, 46, 53, 93, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 40, 95, 98, 32, 61, 32, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 44, 32, 109, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 125, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 61, 32, 99, 108, 97, 115, 115, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 99, 97, 110, 118, 97, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 99, 111, 110, 116, 101, 120, 116, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 34, 44, 32, 123, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 105, 115, 70, 114, 111, 122, 101, 110, 34, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 99, 97, 110, 118, 97, 115, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 110, 101, 119, 32, 69, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 110, 101, 119, 32, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 58, 32, 40, 40, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 41, 32, 124, 124, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 47, 47, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 105, 115, 32, 116, 114, 117, 101, 32, 98, 121, 32, 100, 101, 102, 97, 117, 108, 116, 32, 116, 111, 32, 112, 114, 101, 118, 101, 110, 116, 32, 117, 110, 110, 101, 99, 101, 115, 115, 97, 114, 121, 32, 114, 101, 110, 100, 101, 114, 105, 110, 103, 32, 119, 104, 101, 110, 32, 116, 104, 101, 32, 99, 97, 110, 118, 97, 115, 32, 105, 115, 32, 111, 102, 102, 115, 99, 114, 101, 101, 110, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 58, 32, 40, 95, 99, 32, 61, 32, 40, 95, 98, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 32, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 46, 108, 111, 97, 100, 40, 41, 46, 116, 104, 101, 110, 40, 40, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 44, 32, 95, 98, 50, 44, 32, 95, 99, 50, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 44, 32, 95, 103, 44, 32, 95, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 32, 109, 111, 100, 117, 108, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 101, 109, 101, 73, 100, 58, 32, 40, 95, 97, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 116, 104, 101, 109, 101, 73, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 50, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 40, 95, 98, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 50, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 48, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 95, 99, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 108, 111, 111, 112, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 50, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 40, 95, 100, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 111, 100, 101, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 40, 95, 101, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 101, 103, 109, 101, 110, 116, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 101, 32, 58, 32, 91, 93, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 40, 95, 102, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 102, 32, 58, 32, 49, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 95, 103, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 103, 32, 58, 32, 116, 114, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 40, 95, 104, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 97, 114, 107, 101, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 104, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 76, 97, 121, 111, 117, 116, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 97, 100, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 46, 99, 97, 116, 99, 104, 40, 40, 101, 114, 114, 111, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 119, 97, 115, 109, 32, 109, 111, 100, 117, 108, 101, 58, 32, 36, 123, 101, 114, 114, 111, 114, 125, 96, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 85, 112, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 76, 101, 97, 118, 101, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 102, 101, 116, 99, 104, 68, 97, 116, 97, 40, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 121, 105, 101, 108, 100, 32, 102, 101, 116, 99, 104, 40, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 114, 101, 115, 112, 111, 110, 115, 101, 46, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 102, 101, 116, 99, 104, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 32, 102, 114, 111, 109, 32, 85, 82, 76, 58, 32, 36, 123, 115, 114, 99, 125, 46, 32, 36, 123, 114, 101, 115, 112, 111, 110, 115, 101, 46, 115, 116, 97, 116, 117, 115, 125, 58, 32, 36, 123, 114, 101, 115, 112, 111, 110, 115, 101, 46, 115, 116, 97, 116, 117, 115, 84, 101, 120, 116, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 97, 116, 97, 32, 61, 32, 121, 105, 101, 108, 100, 32, 114, 101, 115, 112, 111, 110, 115, 101, 46, 97, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 41, 46, 100, 101, 99, 111, 100, 101, 40, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 32, 61, 61, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 115, 116, 114, 105, 110, 103, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 115, 116, 114, 105, 110, 103, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 68, 97, 116, 97, 40, 100, 97, 116, 97, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 100, 97, 116, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 68, 111, 116, 76, 111, 116, 116, 105, 101, 68, 97, 116, 97, 40, 100, 97, 116, 97, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 32, 61, 61, 61, 32, 34, 111, 98, 106, 101, 99, 116, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 111, 98, 106, 101, 99, 116, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 68, 97, 116, 97, 40, 74, 83, 79, 78, 46, 115, 116, 114, 105, 110, 103, 105, 102, 121, 40, 100, 97, 116, 97, 41, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 85, 110, 115, 117, 112, 112, 111, 114, 116, 101, 100, 32, 100, 97, 116, 97, 32, 116, 121, 112, 101, 32, 102, 111, 114, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 46, 32, 69, 120, 112, 101, 99, 116, 101, 100, 58, 32, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 115, 116, 114, 105, 110, 103, 32, 40, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 40, 100, 111, 116, 76, 111, 116, 116, 105, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 111, 98, 106, 101, 99, 116, 32, 40, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 41, 46, 32, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 101, 99, 101, 105, 118, 101, 100, 58, 32, 36, 123, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 108, 97, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 34, 115, 111, 109, 101, 116, 104, 105, 110, 103, 32, 119, 101, 110, 116, 32, 119, 114, 111, 110, 103, 44, 32, 116, 104, 101, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 119, 97, 115, 32, 115, 117, 112, 112, 111, 115, 101, 32, 116, 111, 32, 97, 117, 116, 111, 112, 108, 97, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 82, 101, 115, 105, 122, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 34, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 101, 116, 99, 104, 68, 97, 116, 97, 40, 115, 114, 99, 41, 46, 116, 104, 101, 110, 40, 40, 100, 97, 116, 97, 41, 32, 61, 62, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 100, 97, 116, 97, 41, 41, 46, 99, 97, 116, 99, 104, 40, 40, 101, 114, 114, 111, 114, 41, 32, 61, 62, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 32, 102, 114, 111, 109, 32, 85, 82, 76, 58, 32, 36, 123, 115, 114, 99, 125, 46, 32, 36, 123, 101, 114, 114, 111, 114, 125, 96, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 98, 117, 102, 102, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 98, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 97, 121, 111, 117, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 97, 121, 111, 117, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 97, 121, 111, 117, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 91, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 46, 103, 101, 116, 40, 48, 41, 44, 32, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 46, 103, 101, 116, 40, 49, 41, 93, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 97, 50, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 70, 105, 116, 46, 67, 111, 110, 116, 97, 105, 110, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 98, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 70, 105, 116, 46, 67, 111, 118, 101, 114, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 118, 101, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 99, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 70, 105, 116, 46, 70, 105, 108, 108, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 108, 108, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 100, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 100, 46, 70, 105, 116, 46, 70, 105, 116, 72, 101, 105, 103, 104, 116, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 116, 45, 104, 101, 105, 103, 104, 116, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 101, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 101, 46, 70, 105, 116, 46, 70, 105, 116, 87, 105, 100, 116, 104, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 116, 45, 119, 105, 100, 116, 104, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 102, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 102, 46, 70, 105, 116, 46, 78, 111, 110, 101, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 110, 111, 110, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 97, 114, 107, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 109, 97, 110, 105, 102, 101, 115, 116, 83, 116, 114, 105, 110, 103, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 33, 109, 97, 110, 105, 102, 101, 115, 116, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 32, 61, 32, 74, 83, 79, 78, 46, 112, 97, 114, 115, 101, 40, 109, 97, 110, 105, 102, 101, 115, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 41, 46, 108, 101, 110, 103, 116, 104, 32, 61, 61, 61, 32, 48, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 95, 101, 114, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 101, 103, 109, 101, 110, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 101, 103, 109, 101, 110, 116, 32, 38, 38, 32, 115, 101, 103, 109, 101, 110, 116, 46, 115, 105, 122, 101, 40, 41, 32, 61, 61, 61, 32, 50, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 115, 101, 103, 109, 101, 110, 116, 46, 103, 101, 116, 40, 48, 41, 44, 32, 115, 101, 103, 109, 101, 110, 116, 46, 103, 101, 116, 40, 49, 41, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 111, 111, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 111, 100, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 101, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 109, 111, 100, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 98, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 114, 101, 118, 101, 114, 115, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 99, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 77, 111, 100, 101, 46, 66, 111, 117, 110, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 98, 111, 117, 110, 99, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 100, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 100, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 66, 111, 117, 110, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 114, 101, 118, 101, 114, 115, 101, 45, 98, 111, 117, 110, 99, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 70, 114, 111, 122, 101, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 32, 58, 32, 34, 34, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 117, 116, 111, 112, 108, 97, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 112, 101, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 82, 101, 97, 100, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 33, 61, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 76, 111, 97, 100, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 76, 111, 97, 100, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 83, 116, 111, 112, 112, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 83, 116, 111, 112, 112, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 77, 97, 116, 104, 46, 114, 111, 117, 110, 100, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 42, 32, 49, 48, 48, 41, 32, 47, 32, 49, 48, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 100, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 117, 114, 97, 116, 105, 111, 110, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 99, 97, 110, 118, 97, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 44, 32, 95, 103, 44, 32, 95, 104, 44, 32, 95, 105, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 101, 109, 101, 73, 100, 58, 32, 40, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 116, 104, 101, 109, 101, 73, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 40, 95, 98, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 48, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 95, 99, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 108, 111, 111, 112, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 40, 95, 100, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 111, 100, 101, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 40, 95, 101, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 101, 103, 109, 101, 110, 116, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 101, 32, 58, 32, 91, 93, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 40, 95, 102, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 102, 32, 58, 32, 49, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 95, 103, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 103, 32, 58, 32, 116, 114, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 40, 95, 104, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 97, 114, 107, 101, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 104, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 76, 97, 121, 111, 117, 116, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 40, 95, 105, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 105, 32, 58, 32, 34, 34, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 114, 101, 110, 100, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 38, 38, 32, 34, 103, 101, 116, 67, 111, 110, 116, 101, 120, 116, 34, 32, 105, 110, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 38, 38, 32, 116, 121, 112, 101, 111, 102, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 67, 111, 110, 116, 101, 120, 116, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 67, 111, 110, 116, 101, 120, 116, 40, 34, 50, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 114, 101, 110, 100, 101, 114, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 117, 102, 102, 101, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 98, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 67, 108, 97, 109, 112, 101, 100, 65, 114, 114, 97, 121, 40, 98, 117, 102, 102, 101, 114, 44, 32, 48, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 42, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 42, 32, 52, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 73, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 46, 99, 114, 101, 97, 116, 101, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 46, 100, 97, 116, 97, 46, 115, 101, 116, 40, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 110, 101, 119, 32, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 46, 112, 117, 116, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 105, 109, 97, 103, 101, 68, 97, 116, 97, 44, 32, 48, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 100, 114, 97, 119, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 110, 101, 120, 116, 70, 114, 97, 109, 101, 32, 61, 32, 77, 97, 116, 104, 46, 114, 111, 117, 110, 100, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 113, 117, 101, 115, 116, 70, 114, 97, 109, 101, 40, 41, 32, 42, 32, 49, 101, 51, 41, 32, 47, 32, 49, 101, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 112, 100, 97, 116, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 70, 114, 97, 109, 101, 40, 110, 101, 120, 116, 70, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 117, 112, 100, 97, 116, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 114, 101, 110, 100, 101, 114, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 67, 111, 109, 112, 108, 101, 116, 101, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 99, 111, 109, 112, 108, 101, 116, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 34, 69, 114, 114, 111, 114, 32, 105, 110, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 102, 114, 97, 109, 101, 58, 34, 44, 32, 101, 114, 114, 111, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 34, 44, 32, 101, 114, 114, 111, 114, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 114, 114, 111, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 82, 117, 110, 116, 105, 109, 101, 69, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 100, 101, 115, 116, 114, 111, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 108, 97, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 108, 97, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 38, 38, 32, 33, 105, 115, 69, 108, 101, 109, 101, 110, 116, 73, 110, 86, 105, 101, 119, 112, 111, 114, 116, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 97, 117, 115, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 97, 117, 115, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 111, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 115, 116, 111, 112, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 70, 114, 97, 109, 101, 40, 102, 114, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 114, 97, 109, 101, 32, 60, 32, 48, 32, 124, 124, 32, 102, 114, 97, 109, 101, 32, 62, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 101, 107, 40, 102, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 112, 101, 101, 100, 40, 115, 112, 101, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 115, 116, 121, 108, 101, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 99, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 104, 101, 120, 83, 116, 114, 105, 110, 103, 84, 111, 82, 71, 66, 65, 73, 110, 116, 40, 99, 111, 108, 111, 114, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 99, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 76, 111, 111, 112, 40, 108, 111, 111, 112, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 108, 111, 111, 112, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 101, 108, 101, 116, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 100, 101, 115, 116, 114, 111, 121, 34, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 109, 111, 118, 101, 65, 108, 108, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 101, 101, 122, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 117, 110, 102, 114, 101, 101, 122, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 115, 105, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 124, 124, 32, 33, 116, 104, 105, 115, 46, 105, 115, 76, 111, 97, 100, 101, 100, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 112, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 104, 101, 105, 103, 104, 116, 58, 32, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 44, 32, 119, 105, 100, 116, 104, 58, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 32, 33, 61, 61, 32, 48, 32, 38, 38, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 33, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 42, 32, 100, 112, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 32, 42, 32, 100, 112, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 115, 105, 122, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 40, 115, 116, 97, 114, 116, 70, 114, 97, 109, 101, 44, 32, 101, 110, 100, 70, 114, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 91, 115, 116, 97, 114, 116, 70, 114, 97, 109, 101, 44, 32, 101, 110, 100, 70, 114, 97, 109, 101, 93, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 77, 111, 100, 101, 40, 109, 111, 100, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 109, 111, 100, 101, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 44, 32, 123, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 44, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 125, 32, 61, 32, 95, 97, 44, 32, 114, 101, 115, 116, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 111, 98, 106, 82, 101, 115, 116, 40, 95, 97, 44, 32, 91, 34, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 34, 44, 32, 34, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 34, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 44, 32, 114, 101, 115, 116, 67, 111, 110, 102, 105, 103, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 47, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 105, 115, 32, 97, 32, 115, 112, 101, 99, 105, 97, 108, 32, 99, 97, 115, 101, 44, 32, 105, 116, 32, 115, 104, 111, 117, 108, 100, 32, 98, 101, 32, 115, 101, 116, 32, 116, 111, 32, 116, 104, 101, 32, 100, 101, 102, 97, 117, 108, 116, 32, 118, 97, 108, 117, 101, 32, 105, 102, 32, 105, 116, 39, 115, 32, 110, 111, 116, 32, 112, 114, 111, 118, 105, 100, 101, 100, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 58, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 58, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 82, 101, 115, 105, 122, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 32, 61, 61, 61, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 58, 36, 123, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 125, 96, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 109, 97, 114, 107, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 115, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 109, 97, 114, 107, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 97, 114, 107, 101, 114, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 117, 108, 116, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 109, 97, 114, 107, 101, 114, 115, 46, 115, 105, 122, 101, 40, 41, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 109, 97, 114, 107, 101, 114, 115, 46, 103, 101, 116, 40, 105, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 46, 112, 117, 115, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 109, 97, 114, 107, 101, 114, 46, 110, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 105, 109, 101, 58, 32, 109, 97, 114, 107, 101, 114, 46, 116, 105, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 117, 114, 97, 116, 105, 111, 110, 58, 32, 109, 97, 114, 107, 101, 114, 46, 100, 117, 114, 97, 116, 105, 111, 110, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 115, 117, 108, 116, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 111, 97, 100, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 115, 101, 116, 84, 104, 101, 109, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 115, 101, 116, 84, 104, 101, 109, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 111, 97, 100, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 108, 111, 116, 115, 40, 115, 108, 111, 116, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 83, 108, 111, 116, 115, 40, 115, 108, 111, 116, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 46, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 111, 97, 100, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 112, 101, 110, 85, 114, 108, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 46, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 79, 112, 101, 110, 85, 82, 76, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 114, 116, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 97, 114, 116, 40, 111, 112, 101, 110, 85, 114, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 116, 97, 114, 116, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 101, 116, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 116, 97, 114, 116, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 111, 112, 112, 101, 100, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 111, 112, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 116, 111, 112, 112, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 116, 111, 112, 112, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 99, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 99, 97, 108, 101, 88, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 47, 32, 114, 101, 99, 116, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 99, 97, 108, 101, 89, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 47, 32, 114, 101, 99, 116, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 40, 101, 118, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 88, 32, 45, 32, 114, 101, 99, 116, 46, 108, 101, 102, 116, 41, 32, 42, 32, 115, 99, 97, 108, 101, 88, 32, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 40, 101, 118, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 89, 32, 45, 32, 114, 101, 99, 116, 46, 116, 111, 112, 41, 32, 42, 32, 115, 99, 97, 108, 101, 89, 32, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 85, 112, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 76, 101, 97, 118, 101, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 80, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 80, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 80, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 80, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 80, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 70, 114, 97, 109, 101, 119, 111, 114, 107, 83, 101, 116, 117, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 46, 115, 105, 122, 101, 40, 41, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 112, 117, 115, 104, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 46, 103, 101, 116, 40, 105, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 115, 101, 116, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 33, 61, 61, 32, 110, 117, 108, 108, 32, 38, 38, 32, 116, 104, 105, 115, 46, 105, 115, 76, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 85, 112, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 117, 112, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 100, 111, 119, 110, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 109, 111, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 101, 110, 116, 101, 114, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 108, 101, 97, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 117, 112, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 100, 111, 119, 110, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 109, 111, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 101, 110, 116, 101, 114, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 108, 101, 97, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 111, 97, 100, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 46, 103, 101, 116, 40, 48, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 40, 95, 100, 32, 61, 32, 40, 95, 99, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 46, 103, 101, 116, 40, 49, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 105, 100, 116, 104, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 101, 105, 103, 104, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 66, 111, 111, 108, 101, 97, 110, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 101, 116, 66, 111, 111, 108, 101, 97, 110, 73, 110, 112, 117, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 78, 117, 109, 101, 114, 105, 99, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 101, 116, 78, 117, 109, 101, 114, 105, 99, 73, 110, 112, 117, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 114, 105, 110, 103, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 101, 116, 83, 116, 114, 105, 110, 103, 73, 110, 112, 117, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 71, 101, 116, 32, 116, 104, 101, 32, 79, 114, 105, 101, 110, 116, 101, 100, 32, 66, 111, 117, 110, 100, 105, 110, 103, 32, 66, 111, 120, 32, 40, 79, 66, 66, 41, 32, 112, 111, 105, 110, 116, 115, 32, 111, 102, 32, 97, 32, 108, 97, 121, 101, 114, 32, 98, 121, 32, 105, 116, 115, 32, 110, 97, 109, 101, 10, 32, 32, 32, 32, 32, 42, 32, 64, 112, 97, 114, 97, 109, 32, 108, 97, 121, 101, 114, 78, 97, 109, 101, 32, 45, 32, 84, 104, 101, 32, 110, 97, 109, 101, 32, 111, 102, 32, 116, 104, 101, 32, 108, 97, 121, 101, 114, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 65, 110, 32, 97, 114, 114, 97, 121, 32, 111, 102, 32, 56, 32, 110, 117, 109, 98, 101, 114, 115, 32, 114, 101, 112, 114, 101, 115, 101, 110, 116, 105, 110, 103, 32, 52, 32, 112, 111, 105, 110, 116, 115, 32, 40, 120, 44, 121, 41, 32, 111, 102, 32, 116, 104, 101, 32, 79, 66, 66, 32, 105, 110, 32, 99, 108, 111, 99, 107, 119, 105, 115, 101, 32, 111, 114, 100, 101, 114, 32, 115, 116, 97, 114, 116, 105, 110, 103, 32, 102, 114, 111, 109, 32, 116, 111, 112, 45, 108, 101, 102, 116, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 91, 120, 48, 44, 32, 121, 48, 44, 32, 120, 49, 44, 32, 121, 49, 44, 32, 120, 50, 44, 32, 121, 50, 44, 32, 120, 51, 44, 32, 121, 51, 93, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 64, 101, 120, 97, 109, 112, 108, 101, 10, 32, 32, 32, 32, 32, 42, 32, 96, 96, 96, 116, 121, 112, 101, 115, 99, 114, 105, 112, 116, 10, 32, 32, 32, 32, 32, 42, 32, 47, 47, 32, 68, 114, 97, 119, 32, 97, 32, 112, 111, 108, 121, 103, 111, 110, 32, 97, 114, 111, 117, 110, 100, 32, 116, 104, 101, 32, 108, 97, 121, 101, 114, 32, 39, 76, 97, 121, 101, 114, 32, 49, 39, 10, 32, 32, 32, 32, 32, 42, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 39, 114, 101, 110, 100, 101, 114, 39, 44, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 98, 98, 80, 111, 105, 110, 116, 115, 32, 61, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 46, 103, 101, 116, 76, 97, 121, 101, 114, 66, 111, 117, 110, 100, 105, 110, 103, 66, 111, 120, 40, 39, 76, 97, 121, 101, 114, 32, 49, 39, 41, 59, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 105, 102, 32, 40, 111, 98, 98, 80, 111, 105, 110, 116, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 98, 101, 103, 105, 110, 80, 97, 116, 104, 40, 41, 59, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 109, 111, 118, 101, 84, 111, 40, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 48, 93, 44, 32, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 49, 93, 41, 59, 32, 47, 47, 32, 70, 105, 114, 115, 116, 32, 112, 111, 105, 110, 116, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 108, 105, 110, 101, 84, 111, 40, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 50, 93, 44, 32, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 51, 93, 41, 59, 32, 47, 47, 32, 83, 101, 99, 111, 110, 100, 32, 112, 111, 105, 110, 116, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 108, 105, 110, 101, 84, 111, 40, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 52, 93, 44, 32, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 53, 93, 41, 59, 32, 47, 47, 32, 84, 104, 105, 114, 100, 32, 112, 111, 105, 110, 116, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 108, 105, 110, 101, 84, 111, 40, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 54, 93, 44, 32, 111, 98, 98, 80, 111, 105, 110, 116, 115, 91, 55, 93, 41, 59, 32, 47, 47, 32, 70, 111, 117, 114, 116, 104, 32, 112, 111, 105, 110, 116, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 99, 108, 111, 115, 101, 80, 97, 116, 104, 40, 41, 59, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 115, 116, 114, 111, 107, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 42, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 42, 32, 96, 96, 96, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 103, 101, 116, 76, 97, 121, 101, 114, 66, 111, 117, 110, 100, 105, 110, 103, 66, 111, 120, 40, 108, 97, 121, 101, 114, 78, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 111, 117, 110, 100, 115, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 103, 101, 116, 76, 97, 121, 101, 114, 66, 111, 117, 110, 100, 115, 40, 108, 97, 121, 101, 114, 78, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 111, 117, 110, 100, 115, 41, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 111, 117, 110, 100, 115, 46, 115, 105, 122, 101, 40, 41, 32, 33, 61, 61, 32, 56, 41, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 111, 105, 110, 116, 115, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 56, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 112, 111, 105, 110, 116, 115, 46, 112, 117, 115, 104, 40, 98, 111, 117, 110, 100, 115, 46, 103, 101, 116, 40, 105, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 112, 111, 105, 110, 116, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 116, 114, 97, 110, 115, 102, 111, 114, 109, 84, 104, 101, 109, 101, 84, 111, 76, 111, 116, 116, 105, 101, 83, 108, 111, 116, 115, 40, 116, 104, 101, 109, 101, 44, 32, 115, 108, 111, 116, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 116, 114, 97, 110, 115, 102, 111, 114, 109, 84, 104, 101, 109, 101, 84, 111, 76, 111, 116, 116, 105, 101, 83, 108, 111, 116, 115, 40, 116, 104, 101, 109, 101, 44, 32, 115, 108, 111, 116, 115, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 34, 34, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 44, 32, 34, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 118, 97, 114, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 119, 111, 114, 107, 101, 114, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 46, 119, 111, 114, 107, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 32, 61, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 59, 10, 32, 32, 118, 97, 114, 32, 101, 118, 101, 110, 116, 72, 97, 110, 100, 108, 101, 114, 77, 97, 112, 32, 61, 32, 123, 10, 32, 32, 32, 32, 114, 101, 97, 100, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 97, 100, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 99, 111, 109, 112, 108, 101, 116, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 67, 111, 109, 112, 108, 101, 116, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 97, 100, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 97, 100, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 114, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 111, 112, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 111, 112, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 111, 112, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 108, 97, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 108, 97, 121, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 80, 108, 97, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 112, 108, 97, 121, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 97, 117, 115, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 80, 97, 117, 115, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 112, 97, 117, 115, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 111, 112, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 83, 116, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 115, 116, 111, 112, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 97, 109, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 97, 109, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 70, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 102, 114, 97, 109, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 114, 101, 110, 100, 101, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 70, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 110, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 85, 110, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 117, 110, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 101, 115, 116, 114, 111, 121, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 68, 101, 115, 116, 114, 111, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 100, 101, 115, 116, 114, 111, 121, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 111, 109, 109, 97, 110, 100, 115, 32, 61, 32, 123, 10, 32, 32, 32, 32, 103, 101, 116, 68, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 83, 116, 97, 116, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 76, 111, 97, 100, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 76, 111, 97, 100, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 80, 97, 117, 115, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 80, 97, 117, 115, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 80, 108, 97, 121, 105, 110, 103, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 83, 116, 111, 112, 112, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 83, 116, 111, 112, 112, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 70, 114, 111, 122, 101, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 70, 114, 111, 122, 101, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 111, 112, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 111, 100, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 112, 101, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 117, 114, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 100, 117, 114, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 114, 107, 101, 114, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 115, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 114, 107, 101, 114, 115, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 117, 116, 111, 112, 108, 97, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 103, 109, 101, 110, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 97, 121, 111, 117, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 82, 101, 97, 100, 121, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 82, 101, 97, 100, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 110, 105, 102, 101, 115, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 110, 105, 102, 101, 115, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 97, 116, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 97, 121, 111, 117, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 108, 97, 121, 111, 117, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 99, 114, 101, 97, 116, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 104, 97, 115, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 97, 108, 114, 101, 97, 100, 121, 32, 101, 120, 105, 115, 116, 115, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 110, 101, 119, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 99, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 115, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 32, 105, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 118, 101, 110, 116, 115, 32, 61, 32, 91, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 99, 111, 109, 112, 108, 101, 116, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 97, 100, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 110, 100, 101, 114, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 112, 97, 117, 115, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 112, 108, 97, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 115, 116, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 100, 101, 115, 116, 114, 111, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 117, 110, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 97, 100, 121, 34, 10, 32, 32, 32, 32, 32, 32, 93, 59, 10, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 101, 118, 101, 110, 116, 44, 32, 101, 118, 101, 110, 116, 72, 97, 110, 100, 108, 101, 114, 77, 97, 112, 91, 101, 118, 101, 110, 116, 93, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 100, 101, 115, 116, 114, 111, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 100, 101, 108, 101, 116, 101, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 40, 99, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 104, 101, 109, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 116, 104, 101, 109, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 104, 101, 109, 101, 68, 97, 116, 97, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 116, 104, 101, 109, 101, 68, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 97, 117, 115, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 108, 97, 121, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 115, 105, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 70, 114, 97, 109, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 97, 109, 101, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 102, 114, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 70, 114, 97, 109, 101, 40, 102, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 77, 111, 100, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 101, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 109, 111, 100, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 77, 111, 100, 101, 40, 109, 111, 100, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 40, 115, 101, 103, 109, 101, 110, 116, 91, 48, 93, 44, 32, 115, 101, 103, 109, 101, 110, 116, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 83, 112, 101, 101, 100, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 112, 101, 101, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 112, 101, 101, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 83, 112, 101, 101, 100, 40, 115, 112, 101, 101, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 109, 97, 114, 107, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 76, 111, 111, 112, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 111, 112, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 108, 111, 111, 112, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 76, 111, 111, 112, 40, 108, 111, 111, 112, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 120, 101, 99, 117, 116, 101, 67, 111, 109, 109, 97, 110, 100, 40, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 101, 116, 104, 111, 100, 32, 61, 32, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 46, 109, 101, 116, 104, 111, 100, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 99, 111, 109, 109, 97, 110, 100, 115, 91, 109, 101, 116, 104, 111, 100, 93, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 109, 109, 97, 110, 100, 115, 91, 109, 101, 116, 104, 111, 100, 93, 40, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 41, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 77, 101, 116, 104, 111, 100, 32, 36, 123, 109, 101, 116, 104, 111, 100, 125, 32, 105, 115, 32, 110, 111, 116, 32, 105, 109, 112, 108, 101, 109, 101, 110, 116, 101, 100, 32, 105, 110, 32, 99, 111, 109, 109, 97, 110, 100, 115, 46, 96, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 10, 32, 32, 115, 101, 108, 102, 46, 111, 110, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 117, 108, 116, 32, 61, 32, 101, 120, 101, 99, 117, 116, 101, 67, 111, 109, 109, 97, 110, 100, 40, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 105, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 109, 101, 116, 104, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 114, 114, 111, 114, 82, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 105, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 109, 101, 116, 104, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 101, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 101, 114, 114, 111, 114, 82, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 100, 117, 109, 109, 121, 32, 61, 32, 34, 34, 59, 10, 32, 32, 118, 97, 114, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 119, 111, 114, 107, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 32, 61, 32, 100, 117, 109, 109, 121, 59, 10, 125, 41, 40, 41, 59, 10])], { type: "application/javascript" }), a = URL.createObjectURL(r), h2 = new Worker(a);
    return URL.revokeObjectURL(a), h2;
  }
}, q3 = I2;
var Y1 = class {
  constructor() {
    b(this, "_workers", /* @__PURE__ */ new Map());
    b(this, "_animationWorkerMap", /* @__PURE__ */ new Map());
  }
  getWorker(r) {
    return this._workers.has(r) || this._workers.set(r, new q3()), this._workers.get(r);
  }
  assignAnimationToWorker(r, a) {
    this._animationWorkerMap.set(r, a);
  }
  unassignAnimationFromWorker(r) {
    this._animationWorkerMap.delete(r);
  }
  sendMessage(r, a, h2) {
    this.getWorker(r).postMessage(a, h2 || []);
  }
  terminateWorker(r) {
    let a = this._workers.get(r);
    a && (a.terminate(), this._workers.delete(r));
  }
};
function J3(v, r) {
  if (v instanceof HTMLCanvasElement) {
    let { height: a, width: h2 } = v.getBoundingClientRect();
    if (a !== 0 && h2 !== 0) return { width: h2 * r, height: a * r };
  }
  return { width: v.width, height: v.height };
}
function G3() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var Y = class Y2 {
  constructor(r) {
    b(this, "_eventManager", new h1());
    b(this, "_id");
    b(this, "_worker");
    b(this, "_canvas");
    b(this, "_dotLottieInstanceState", { loopCount: 0, markers: [], autoplay: false, backgroundColor: "", currentFrame: 0, duration: 0, loop: false, mode: "forward", segment: [0, 0], segmentDuration: 0, speed: 1, totalFrames: 0, isLoaded: false, isPlaying: false, isPaused: false, isStopped: true, isFrozen: false, useFrameInterpolation: false, renderConfig: { devicePixelRatio: e1() }, activeAnimationId: "", activeThemeId: "", layout: void 0, marker: void 0, isReady: false, manifest: null });
    b(this, "_created", false);
    b(this, "_pointerUpMethod");
    b(this, "_pointerDownMethod");
    b(this, "_pointerMoveMethod");
    b(this, "_pointerEnterMethod");
    b(this, "_pointerExitMethod");
    var h2, d, g;
    this._canvas = r.canvas, this._id = `dotlottie-${G3()}`;
    let a = r.workerId || "defaultWorker";
    this._worker = Y2._workerManager.getWorker(a), Y2._workerManager.assignAnimationToWorker(this._id, a), Y2._wasmUrl && this._sendMessage("setWasmUrl", { url: Y2._wasmUrl }), this._create(z(D({}, r), { renderConfig: z(D({}, r.renderConfig), { devicePixelRatio: ((h2 = r.renderConfig) == null ? void 0 : h2.devicePixelRatio) || e1(), freezeOnOffscreen: (g = (d = r.renderConfig) == null ? void 0 : d.freezeOnOffscreen) != null ? g : true }) })), this._worker.addEventListener("message", this._handleWorkerEvent.bind(this)), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
  }
  _handleWorkerEvent(r) {
    return E(this, null, function* () {
      let a = r.data;
      a.id || (a.method === "onLoad" && a.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event), O && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && H.observe(this._canvas, this), this._dotLottieInstanceState.renderConfig.autoResize && N.observe(this._canvas, this))), a.method === "onComplete" && a.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onDestroy" && a.result.instanceId === this._id && this._eventManager.dispatch(a.result.event), a.method === "onUnfreeze" && a.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._dotLottieInstanceState.isFrozen = false, this._eventManager.dispatch(a.result.event)), a.method === "onFrame" && a.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = a.result.event.currentFrame, this._eventManager.dispatch(a.result.event)), a.method === "onRender" && a.result.instanceId === this._id && this._eventManager.dispatch(a.result.event), a.method === "onFreeze" && a.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onPause" && a.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onPlay" && a.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onStop" && a.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onLoadError" && a.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onRenderError" && a.result.instanceId === this._id && this._eventManager.dispatch(a.result.event), a.method === "onReady" && a.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onLoop" && a.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)));
    });
  }
  _create(r) {
    return E(this, null, function* () {
      var d;
      let a;
      this._canvas instanceof HTMLCanvasElement ? a = this._canvas.transferControlToOffscreen() : a = this._canvas;
      let { instanceId: h2 } = yield this._sendMessage("create", D({ instanceId: this._id, config: z(D({}, r), { canvas: a }) }, J3(this._canvas, ((d = r.renderConfig) == null ? void 0 : d.devicePixelRatio) || e1())), [a]);
      if (h2 !== this._id) throw new Error("Instance ID mismatch");
      this._created = true, yield this._updateDotLottieInstanceState();
    });
  }
  get loopCount() {
    return this._dotLottieInstanceState.loopCount;
  }
  get isLoaded() {
    return this._dotLottieInstanceState.isLoaded;
  }
  get isPlaying() {
    return this._dotLottieInstanceState.isPlaying;
  }
  get isPaused() {
    return this._dotLottieInstanceState.isPaused;
  }
  get isStopped() {
    return this._dotLottieInstanceState.isStopped;
  }
  get currentFrame() {
    return this._dotLottieInstanceState.currentFrame;
  }
  get isFrozen() {
    return this._dotLottieInstanceState.isFrozen;
  }
  get segmentDuration() {
    return this._dotLottieInstanceState.segmentDuration;
  }
  get totalFrames() {
    return this._dotLottieInstanceState.totalFrames;
  }
  get segment() {
    return this._dotLottieInstanceState.segment;
  }
  get speed() {
    return this._dotLottieInstanceState.speed;
  }
  get duration() {
    return this._dotLottieInstanceState.duration;
  }
  get isReady() {
    return this._dotLottieInstanceState.isReady;
  }
  get mode() {
    return this._dotLottieInstanceState.mode;
  }
  get canvas() {
    return this._canvas;
  }
  get autoplay() {
    return this._dotLottieInstanceState.autoplay;
  }
  get backgroundColor() {
    return this._dotLottieInstanceState.backgroundColor;
  }
  get loop() {
    return this._dotLottieInstanceState.loop;
  }
  get useFrameInterpolation() {
    return this._dotLottieInstanceState.useFrameInterpolation;
  }
  get renderConfig() {
    return this._dotLottieInstanceState.renderConfig;
  }
  get manifest() {
    return this._dotLottieInstanceState.manifest;
  }
  get activeAnimationId() {
    return this._dotLottieInstanceState.activeAnimationId;
  }
  get marker() {
    return this._dotLottieInstanceState.marker;
  }
  get activeThemeId() {
    return this._dotLottieInstanceState.activeThemeId;
  }
  get layout() {
    return this._dotLottieInstanceState.layout;
  }
  play() {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("play", { instanceId: this._id }), yield this._updateDotLottieInstanceState(), O && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !G1(this._canvas) && (yield this.freeze()));
    });
  }
  pause() {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("pause", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  stop() {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("stop", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setSpeed(r) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("setSpeed", { instanceId: this._id, speed: r }), yield this._updateDotLottieInstanceState());
    });
  }
  setMode(r) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("setMode", { instanceId: this._id, mode: r }), yield this._updateDotLottieInstanceState());
    });
  }
  setFrame(r) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("setFrame", { frame: r, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setSegment(r, a) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("setSegment", { instanceId: this._id, segment: [r, a] }), yield this._updateDotLottieInstanceState());
    });
  }
  setRenderConfig(r) {
    return E(this, null, function* () {
      if (!this._created) return;
      let g = r, { devicePixelRatio: a, freezeOnOffscreen: h2 } = g, d = V1(g, ["devicePixelRatio", "freezeOnOffscreen"]);
      yield this._sendMessage("setRenderConfig", { instanceId: this._id, renderConfig: z(D(D({}, this._dotLottieInstanceState.renderConfig), d), { devicePixelRatio: a || e1(), freezeOnOffscreen: h2 != null ? h2 : true }) }), yield this._updateDotLottieInstanceState(), O && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.autoResize ? N.observe(this._canvas, this) : N.unobserve(this._canvas), this._dotLottieInstanceState.renderConfig.freezeOnOffscreen ? H.observe(this._canvas, this) : (H.unobserve(this._canvas), this._dotLottieInstanceState.isFrozen && (yield this.unfreeze())));
    });
  }
  setUseFrameInterpolation(r) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("setUseFrameInterpolation", { instanceId: this._id, useFrameInterpolation: r }), yield this._updateDotLottieInstanceState());
    });
  }
  setTheme(r) {
    return E(this, null, function* () {
      if (!this._created) return false;
      let a = this._sendMessage("setTheme", { instanceId: this._id, themeId: r });
      return yield this._updateDotLottieInstanceState(), a;
    });
  }
  load(r) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("load", { config: r, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setLoop(r) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("setLoop", { instanceId: this._id, loop: r }), yield this._updateDotLottieInstanceState());
    });
  }
  resize() {
    return E(this, null, function* () {
      if (!this._created) return;
      let { height: r, width: a } = J3(this._canvas, this._dotLottieInstanceState.renderConfig.devicePixelRatio || e1());
      yield this._sendMessage("resize", { height: r, instanceId: this._id, width: a }), yield this._updateDotLottieInstanceState();
    });
  }
  destroy() {
    return E(this, null, function* () {
      this._created && (this._created = false, yield this._sendMessage("destroy", { instanceId: this._id }), this._cleanupStateMachineListeners(), Y2._workerManager.unassignAnimationFromWorker(this._id), this._eventManager.removeAllEventListeners(), O && this._canvas instanceof HTMLCanvasElement && (H.unobserve(this._canvas), N.unobserve(this._canvas)));
    });
  }
  freeze() {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("freeze", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  unfreeze() {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("unfreeze", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setBackgroundColor(r) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("setBackgroundColor", { instanceId: this._id, backgroundColor: r }), yield this._updateDotLottieInstanceState());
    });
  }
  loadAnimation(r) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("loadAnimation", { animationId: r, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setLayout(r) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("setLayout", { instanceId: this._id, layout: r }), yield this._updateDotLottieInstanceState());
    });
  }
  _updateDotLottieInstanceState() {
    return E(this, null, function* () {
      if (!this._created) return;
      let r = yield this._sendMessage("getDotLottieInstanceState", { instanceId: this._id });
      this._dotLottieInstanceState = r.state;
    });
  }
  markers() {
    return this._dotLottieInstanceState.markers;
  }
  setMarker(r) {
    return E(this, null, function* () {
      this._created && (yield this._sendMessage("setMarker", { instanceId: this._id, marker: r }), yield this._updateDotLottieInstanceState());
    });
  }
  setThemeData(r) {
    return E(this, null, function* () {
      if (!this._created) return false;
      let a = yield this._sendMessage("setThemeData", { instanceId: this._id, themeData: r });
      return yield this._updateDotLottieInstanceState(), a;
    });
  }
  setViewport(r, a, h2, d) {
    return E(this, null, function* () {
      return this._created ? this._sendMessage("setViewport", { x: r, y: a, width: h2, height: d, instanceId: this._id }) : false;
    });
  }
  _sendMessage(r, a, h2) {
    return E(this, null, function* () {
      let d = { id: `dotlottie-request-${G3()}`, method: r, params: a };
      return this._worker.postMessage(d, h2 || []), new Promise((g, T) => {
        let R = (j) => {
          let $ = j.data;
          $.id === d.id && (this._worker.removeEventListener("message", R), $.error ? T(new Error(`Failed to execute method ${r}: ${$.error}`)) : g($.result));
        };
        this._worker.addEventListener("message", R);
      });
    });
  }
  addEventListener(r, a) {
    this._eventManager.addEventListener(r, a);
  }
  removeEventListener(r, a) {
    this._eventManager.removeEventListener(r, a);
  }
  static setWasmUrl(r) {
    Y2._wasmUrl = r;
  }
  loadStateMachine(r) {
    return E(this, null, function* () {
      if (!this._created) return false;
      let a = yield this._sendMessage("loadStateMachine", { instanceId: this._id, stateMachineId: r });
      return yield this._updateDotLottieInstanceState(), a;
    });
  }
  loadStateMachineData(r) {
    return E(this, null, function* () {
      if (!this._created) return false;
      let a = yield this._sendMessage("loadStateMachineData", { instanceId: this._id, stateMachineData: r });
      return yield this._updateDotLottieInstanceState(), a;
    });
  }
  startStateMachine() {
    return E(this, null, function* () {
      if (!this._created) return false;
      this._setupStateMachineListeners();
      let r = yield this._sendMessage("startStateMachine", { instanceId: this._id });
      return yield this._updateDotLottieInstanceState(), r;
    });
  }
  stopStateMachine() {
    return E(this, null, function* () {
      return this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stopStateMachine", { instanceId: this._id })) : false;
    });
  }
  getStateMachineListeners() {
    return E(this, null, function* () {
      return this._created ? this._sendMessage("getStateMachineListeners", { instanceId: this._id }) : [];
    });
  }
  _getPointerPosition(r) {
    let a = this._canvas.getBoundingClientRect(), h2 = this._canvas.width / a.width, d = this._canvas.height / a.height, g = this._dotLottieInstanceState.renderConfig.devicePixelRatio || window.devicePixelRatio || 1, T = (r.clientX - a.left) * h2 / g, R = (r.clientY - a.top) * d / g;
    return { x: T, y: R };
  }
  _onPointerUp(r) {
    let { x: a, y: h2 } = this._getPointerPosition(r);
    this._sendMessage("postPointerUpEvent", { instanceId: this._id, x: a, y: h2 });
  }
  _onPointerDown(r) {
    let { x: a, y: h2 } = this._getPointerPosition(r);
    this._sendMessage("postPointerDownEvent", { instanceId: this._id, x: a, y: h2 });
  }
  _onPointerMove(r) {
    let { x: a, y: h2 } = this._getPointerPosition(r);
    this._sendMessage("postPointerMoveEvent", { instanceId: this._id, x: a, y: h2 });
  }
  _onPointerEnter(r) {
    let { x: a, y: h2 } = this._getPointerPosition(r);
    this._sendMessage("postPointerEnterEvent", { instanceId: this._id, x: a, y: h2 });
  }
  _onPointerLeave(r) {
    let { x: a, y: h2 } = this._getPointerPosition(r);
    this._sendMessage("postPointerExitEvent", { instanceId: this._id, x: a, y: h2 });
  }
  _setupStateMachineListeners() {
    return E(this, null, function* () {
      if (O && this._canvas instanceof HTMLCanvasElement && this.isLoaded) {
        let r = yield this._sendMessage("getStateMachineListeners", { instanceId: this._id });
        r.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), r.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), r.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), r.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), r.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
      }
    });
  }
  _cleanupStateMachineListeners() {
    O && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
  }
};
b(Y, "_workerManager", new Y1()), b(Y, "_wasmUrl", "");
function initDsHowToSyrup() {
  const sections = document.querySelectorAll(".ds-how-to-syrup");
  if (!sections.length) return;
  const TRUSTED_LOTTIE_HOST = "cdn.shopify.com";
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  sections.forEach(function(section) {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;
    const poster = section.querySelector(".ds-how-to-syrup__video-poster");
    const videoTemplate = document.getElementById("hts-video-template-" + sectionId);
    const videoContainer = section.querySelector(".ds-how-to-syrup__video");
    if (poster && videoTemplate && videoContainer) {
      poster.addEventListener("click", function() {
        const content = videoTemplate.content.cloneNode(true);
        const video = content.querySelector("video");
        if (video) {
          video.style.width = "100%";
          video.style.height = "100%";
          video.style.objectFit = "cover";
          video.style.borderRadius = "inherit";
          video.muted = false;
          video.removeAttribute("muted");
        }
        poster.remove();
        videoContainer.appendChild(content);
        if (video) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(function() {
              video.muted = true;
              video.play().catch(function() {
              });
            });
          }
        }
      });
    }
    if (prefersReducedMotion) return;
    const steps = section.querySelectorAll(".ds-how-to-syrup__step");
    const stepsScrollContainer = section.querySelector(".ds-how-to-syrup__scroll");
    const isMobile = window.matchMedia("(max-width: 999px)");
    let activeStep = null;
    let mobileObserver = null;
    let mobileScrollTarget = null;
    let onMobileScroll = null;
    let hasMobileUserScrolled = false;
    const lottieInstances = /* @__PURE__ */ new Map();
    steps.forEach(function(step) {
      const lottieContainer = step.querySelector(".ds-how-to-syrup__step-lottie");
      if (!lottieContainer) return;
      const url = lottieContainer.dataset.lottieUrl;
      if (!url) return;
      let parsedUrl = null;
      try {
        parsedUrl = new URL(url, window.location.origin);
      } catch (error2) {
        return;
      }
      if (parsedUrl.hostname !== TRUSTED_LOTTIE_HOST) {
        return;
      }
      const canvas = document.createElement("canvas");
      canvas.style.width = "100%";
      canvas.style.height = "100%";
      canvas.style.display = "block";
      lottieContainer.innerHTML = "";
      lottieContainer.appendChild(canvas);
      const anim = new V3({
        canvas,
        autoplay: false,
        loop: true,
        src: parsedUrl.href,
        renderConfig: {
          autoResize: true
        },
        layout: {
          fit: "contain",
          align: [0.5, 0.5]
        }
      });
      anim.addEventListener("load", function() {
        requestAnimationFrame(function() {
          anim.resize();
        });
        anim.stop();
        const staticImg = step.querySelector(".ds-how-to-syrup__step-static");
        lottieContainer.style.opacity = "1";
        if (staticImg) staticImg.style.opacity = "0";
        if (isMobile.matches && !hasMobileUserScrolled && step === steps[0]) {
          playStep(step);
        }
      });
      lottieInstances.set(step, anim);
    });
    function playStep(step) {
      const lottieAnim = lottieInstances.get(step);
      const video = step.querySelector(".ds-how-to-syrup__step-video");
      const staticImg = step.querySelector(".ds-how-to-syrup__step-static");
      const hasGif = staticImg && staticImg.dataset.gifUrl;
      if (!lottieAnim && !video && !hasGif) return;
      if (activeStep && activeStep !== step) {
        resetStep(activeStep);
      }
      activeStep = step;
      step.classList.add("is-active");
      if (lottieAnim) {
        if (staticImg) staticImg.style.opacity = "0";
        const lottieEl = step.querySelector(".ds-how-to-syrup__step-lottie");
        if (lottieEl) lottieEl.style.opacity = "1";
        lottieAnim.stop();
        lottieAnim.play();
      } else if (video) {
        if (staticImg) staticImg.style.opacity = "0";
        video.style.opacity = "1";
        video.currentTime = 0;
        video.play().catch(function() {
        });
      } else if (hasGif) {
        staticImg.src = staticImg.dataset.gifUrl;
      }
    }
    function resetStep(step) {
      step.classList.remove("is-active");
      const lottieAnim = lottieInstances.get(step);
      const video = step.querySelector(".ds-how-to-syrup__step-video");
      const staticImg = step.querySelector(".ds-how-to-syrup__step-static");
      const lottieEl = step.querySelector(".ds-how-to-syrup__step-lottie");
      if (lottieAnim) {
        lottieAnim.stop();
        if (lottieEl) {
          lottieEl.style.opacity = "1";
        }
      }
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.style.opacity = "0";
      }
      if (staticImg) {
        if (staticImg.dataset.staticSrc) {
          staticImg.src = staticImg.dataset.staticSrc;
        }
        staticImg.style.opacity = lottieAnim ? "0" : "1";
      }
    }
    function setActiveStep(step) {
      if (!step || activeStep === step) return;
      playStep(step);
    }
    function resetAllSteps() {
      steps.forEach(function(step) {
        resetStep(step);
      });
      activeStep = null;
    }
    function getMostVisibleStep() {
      if (!steps.length) return null;
      if (stepsScrollContainer) {
        const maxScrollLeft = stepsScrollContainer.scrollWidth - stepsScrollContainer.clientWidth;
        const atStart = stepsScrollContainer.scrollLeft <= 4;
        const atEnd = maxScrollLeft - stepsScrollContainer.scrollLeft <= 4;
        if (atStart) return steps[0];
        if (atEnd) return steps[steps.length - 1];
      }
      let bestStep = null;
      let bestRatio = 0;
      steps.forEach(function(step) {
        const rect = step.getBoundingClientRect();
        const rootRect = stepsScrollContainer ? stepsScrollContainer.getBoundingClientRect() : { left: 0, right: window.innerWidth || document.documentElement.clientWidth };
        const visibleLeft = Math.max(rect.left, rootRect.left);
        const visibleRight = Math.min(rect.right, rootRect.right);
        const visibleWidth = Math.max(0, visibleRight - visibleLeft);
        const ratio = rect.width > 0 ? visibleWidth / rect.width : 0;
        if (ratio > bestRatio) {
          bestRatio = ratio;
          bestStep = step;
        }
      });
      return bestStep;
    }
    function handleMobileFocusStep() {
      if (!isMobile.matches) return;
      if (!hasMobileUserScrolled) {
        setActiveStep(steps[0]);
        return;
      }
      const focusedStep = getMostVisibleStep();
      if (focusedStep) {
        setActiveStep(focusedStep);
      } else if (activeStep) {
        resetStep(activeStep);
        activeStep = null;
      }
    }
    function setupMobileBehavior() {
      if (!isMobile.matches || !steps.length) return;
      if (mobileObserver) {
        mobileObserver.disconnect();
      }
      if (mobileScrollTarget) {
        if (onMobileScroll) {
          mobileScrollTarget.removeEventListener("scroll", onMobileScroll);
        }
      }
      mobileObserver = new IntersectionObserver(function(entries) {
        if (!isMobile.matches) return;
        const hasVisibleEntries = entries.some(function(entry) {
          return entry.isIntersecting;
        });
        if (hasVisibleEntries) {
          handleMobileFocusStep();
        }
      }, {
        root: stepsScrollContainer || null,
        threshold: [0.55, 0.7, 0.85]
      });
      steps.forEach(function(step) {
        mobileObserver.observe(step);
      });
      hasMobileUserScrolled = false;
      setActiveStep(steps[0]);
      mobileScrollTarget = stepsScrollContainer || window;
      onMobileScroll = function() {
        hasMobileUserScrolled = true;
        handleMobileFocusStep();
      };
      mobileScrollTarget.addEventListener("scroll", onMobileScroll, { passive: true });
    }
    setupMobileBehavior();
    isMobile.addEventListener("change", function(event) {
      if (event.matches) {
        setupMobileBehavior();
        return;
      }
      if (mobileObserver) {
        mobileObserver.disconnect();
        mobileObserver = null;
      }
      if (mobileScrollTarget) {
        if (onMobileScroll) {
          mobileScrollTarget.removeEventListener("scroll", onMobileScroll);
          onMobileScroll = null;
        }
        mobileScrollTarget = null;
      }
      resetAllSteps();
    });
    steps.forEach(function(step) {
      step.addEventListener("mouseenter", function() {
        if (!isMobile.matches) playStep(step);
      });
      step.addEventListener("mouseleave", function() {
        if (!isMobile.matches) resetStep(step);
      });
      step.setAttribute("tabindex", "0");
      step.setAttribute("role", "button");
      step.addEventListener("keydown", function(e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          playStep(step);
        }
        if (e.key === "Escape") {
          resetStep(step);
        }
      });
      step.addEventListener("blur", function() {
        resetStep(step);
      });
    });
  });
}
initDsHowToSyrup();
function showFloatingTooltip(section, flavour) {
  var floating = section.querySelector(".ds-pods__floating-tooltip");
  if (!floating) return;
  var name = flavour.dataset.flavourName || flavour.getAttribute("aria-label") || "";
  var desc = flavour.dataset.flavourDesc || "";
  var titleEl = floating.querySelector(".ds-pods__tooltip-title");
  var descOutEl = floating.querySelector(".ds-pods__tooltip-desc");
  if (titleEl) titleEl.textContent = name;
  if (descOutEl) descOutEl.textContent = desc;
  var card = section.querySelector(".ds-pods__card");
  var flavourRect = flavour.getBoundingClientRect();
  var cardRect = card.getBoundingClientRect();
  var centerX = flavourRect.left - cardRect.left + flavourRect.width / 2;
  var top = flavourRect.top - cardRect.top - 8;
  floating.classList.add("is-visible");
  var tooltipBox = floating.querySelector(".ds-pods__tooltip-box");
  var boxWidth = tooltipBox ? tooltipBox.offsetWidth : 120;
  var cardWidth = card.offsetWidth;
  var padding = 12;
  var boxLeft = centerX - boxWidth / 2;
  if (boxLeft < padding) boxLeft = padding;
  if (boxLeft + boxWidth > cardWidth - padding) boxLeft = cardWidth - padding - boxWidth;
  if (tooltipBox) {
    tooltipBox.style.position = "absolute";
    tooltipBox.style.left = boxLeft + "px";
    tooltipBox.style.top = top - 4 + "px";
    tooltipBox.style.transform = "translateY(-100%)";
  }
}
function hideFloatingTooltip(section) {
  var floating = section.querySelector(".ds-pods__floating-tooltip");
  if (floating) floating.classList.remove("is-visible");
}
function initDsPods() {
  const sections = document.querySelectorAll(".ds-pods");
  if (!sections.length) return;
  const isMobile = window.matchMedia("(max-width: 999px)");
  sections.forEach(function(section) {
    const flavours = section.querySelectorAll(".ds-pods__flavour");
    if (!flavours.length) return;
    var firstFlavour = flavours[0];
    if (firstFlavour) {
      firstFlavour.classList.add("is-active");
      var firstColor = firstFlavour.dataset.flavourColor;
      if (firstColor) section.style.setProperty("--pods-active-color", firstColor);
    }
    flavours.forEach(function(flavour) {
      flavour.addEventListener("click", function() {
        var color = flavour.dataset.flavourColor;
        if (!color) return;
        if (flavour.classList.contains("is-active")) {
          var floating = section.querySelector(".ds-pods__floating-tooltip");
          if (floating && floating.classList.contains("is-visible")) {
            hideFloatingTooltip(section);
            return;
          }
        }
        flavours.forEach(function(f) {
          f.classList.remove("is-active");
        });
        flavour.classList.add("is-active");
        section.style.setProperty("--pods-active-color", color);
        if (isMobile.matches) {
          showFloatingTooltip(section, flavour);
        }
      });
      flavour.addEventListener("mouseenter", function() {
        if (!isMobile.matches) {
          showFloatingTooltip(section, flavour);
        }
      });
      flavour.addEventListener("mouseleave", function() {
        if (!isMobile.matches) {
          hideFloatingTooltip(section);
        }
      });
      flavour.addEventListener("keydown", function(e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          flavour.click();
        }
        if (e.key === "Escape") {
          flavour.classList.remove("is-tooltip-visible");
        }
      });
    });
    document.addEventListener("click", function(e) {
      if (!e.target.closest(".ds-pods__flavour")) {
        hideFloatingTooltip(section);
      }
    });
    var scrollContainer = section.querySelector(".ds-pods__flavours-scroll");
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", function() {
        hideFloatingTooltip(section);
      }, { passive: true });
      scrollContainer.addEventListener("wheel", function(e) {
        var hasOverflow = scrollContainer.scrollWidth > scrollContainer.clientWidth;
        if (!hasOverflow) return;
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          var maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
          var atStart = scrollContainer.scrollLeft <= 0;
          var atEnd = scrollContainer.scrollLeft >= maxScroll - 1;
          var scrollingRight = e.deltaY > 0;
          if (atEnd && scrollingRight || atStart && !scrollingRight) return;
          e.preventDefault();
          scrollContainer.scrollLeft += e.deltaY;
        }
      }, { passive: false });
      var isDragging = false;
      var startX = 0;
      var scrollStart = 0;
      scrollContainer.addEventListener("mousedown", function(e) {
        if (e.target.closest(".ds-pods__flavour")) return;
        isDragging = true;
        startX = e.pageX;
        scrollStart = scrollContainer.scrollLeft;
        scrollContainer.style.cursor = "grabbing";
      });
      window.addEventListener("mousemove", function(e) {
        if (!isDragging) return;
        e.preventDefault();
        scrollContainer.scrollLeft = scrollStart - (e.pageX - startX);
      });
      window.addEventListener("mouseup", function() {
        if (!isDragging) return;
        isDragging = false;
        scrollContainer.style.cursor = "";
      });
    }
    var podImage = section.querySelector(".ds-pods__pod-image");
    var scrollHandler = null;
    var podTravelDesktop = 153;
    var podTravelMobile = 60;
    function enableScrollAnimation() {
      if (scrollHandler) return;
      if (!podImage) return;
      scrollHandler = function() {
        var rect = section.getBoundingClientRect();
        var viewH = window.innerHeight;
        var startRatio = isMobile.matches ? 0.65 : 0.5;
        var start = viewH - rect.height * startRatio;
        var end = viewH - rect.height;
        var progress = (start - rect.top) / (start - end);
        progress = Math.max(0, Math.min(1, progress));
        var eased = 1 - Math.pow(1 - progress, 3);
        var travel = isMobile.matches ? podTravelMobile : podTravelDesktop;
        var podY = eased * travel;
        podImage.style.transform = "translateX(-50%) translateY(" + podY + "px)";
      };
      window.addEventListener("scroll", scrollHandler, { passive: true });
      scrollHandler();
    }
    enableScrollAnimation();
    isMobile.addEventListener("change", function() {
      if (scrollHandler) scrollHandler();
    });
  });
}
initDsPods();
function initDsSocial() {
  var sections = document.querySelectorAll(".ds-social");
  if (!sections.length) return;
  sections.forEach(function(section) {
    var videoCards = section.querySelectorAll(".ds-social__video-card");
    videoCards.forEach(function(card) {
      var video = card.querySelector(".ds-social__video");
      if (!video) return;
      var muteBtn = card.querySelector(".ds-social__mute-btn");
      var fullscreenBtn = card.querySelector(".ds-social__fullscreen-btn");
      var loaderShownAt = 0;
      var loaderHideTimer = null;
      var MIN_LOADER_MS = 400;
      function hideLoader() {
        if (loaderHideTimer) {
          clearTimeout(loaderHideTimer);
          loaderHideTimer = null;
        }
        var elapsed = Date.now() - loaderShownAt;
        if (loaderShownAt && elapsed < MIN_LOADER_MS) {
          loaderHideTimer = setTimeout(function() {
            card.classList.remove("is-loading");
            loaderHideTimer = null;
          }, MIN_LOADER_MS - elapsed);
        } else {
          card.classList.remove("is-loading");
        }
      }
      video.addEventListener("canplay", hideLoader);
      video.addEventListener("playing", hideLoader);
      function playVideo() {
        videoCards.forEach(function(otherCard) {
          if (otherCard === card) return;
          var otherVideo = otherCard.querySelector(".ds-social__video");
          if (otherVideo && !otherVideo.paused) {
            otherVideo.pause();
            otherCard.classList.remove("is-playing");
            otherCard.classList.remove("is-loading");
          }
        });
        card.classList.add("is-loading");
        loaderShownAt = Date.now();
        var playPromise = video.play();
        card.classList.add("is-playing");
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function() {
            videoCards.forEach(function(c) {
              var v = c.querySelector(".ds-social__video");
              if (v) v.muted = true;
              c.classList.add("is-muted");
            });
            video.play().catch(function() {
              card.classList.remove("is-playing");
              hideLoader();
            });
          });
        }
      }
      function pauseVideo() {
        video.pause();
        card.classList.remove("is-playing");
        hideLoader();
      }
      card.addEventListener("click", function(e) {
        if (muteBtn && muteBtn.contains(e.target)) return;
        if (fullscreenBtn && fullscreenBtn.contains(e.target)) return;
        if (video.paused) {
          playVideo();
        } else {
          pauseVideo();
        }
      });
      if (fullscreenBtn) {
        fullscreenBtn.addEventListener("click", function(e) {
          e.stopPropagation();
          if (document.fullscreenElement || document.webkitFullscreenElement) {
            (document.exitFullscreen || document.webkitExitFullscreen).call(document);
            return;
          }
          if (typeof video.webkitEnterFullscreen === "function") {
            try {
              video.webkitEnterFullscreen();
              return;
            } catch (err) {
            }
          }
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
      if (muteBtn) {
        muteBtn.addEventListener("click", function(e) {
          e.stopPropagation();
          var newMuted = !video.muted;
          videoCards.forEach(function(c) {
            var v = c.querySelector(".ds-social__video");
            if (v) v.muted = newMuted;
            c.classList.toggle("is-muted", newMuted);
          });
        });
      }
    });
    var videosScroll = section.querySelector(".ds-social__videos-scroll");
    var videosTrack = section.querySelector(".ds-social__videos");
    var videosPrev = section.querySelector(".ds-social__videos-btn--prev");
    var videosNext = section.querySelector(".ds-social__videos-btn--next");
    if (videosScroll && videosTrack && videosPrev && videosNext) {
      let getVideoStep2 = function() {
        var card = videosTrack.querySelector(".ds-social__video-card");
        if (!card) return 0;
        var gap = parseFloat(getComputedStyle(videosTrack).columnGap || getComputedStyle(videosTrack).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }, updateVideoBtnState2 = function() {
        var max = videosScroll.scrollWidth - videosScroll.clientWidth - 1;
        var hasOverflow = max > 0;
        videosPrev.hidden = !hasOverflow;
        videosNext.hidden = !hasOverflow;
        videosPrev.toggleAttribute("disabled", videosScroll.scrollLeft <= 0);
        videosNext.toggleAttribute("disabled", videosScroll.scrollLeft >= max);
      };
      var getVideoStep = getVideoStep2, updateVideoBtnState = updateVideoBtnState2;
      videosPrev.addEventListener("click", function() {
        videosScroll.scrollBy({ left: -getVideoStep2(), behavior: "smooth" });
      });
      videosNext.addEventListener("click", function() {
        videosScroll.scrollBy({ left: getVideoStep2(), behavior: "smooth" });
      });
      videosScroll.addEventListener("scroll", updateVideoBtnState2, { passive: true });
      window.addEventListener("resize", updateVideoBtnState2);
      updateVideoBtnState2();
    }
    var quotes = section.querySelectorAll(".ds-social__quote");
    var pagination = section.querySelector(".ds-social__pagination");
    if (quotes.length <= 1 || !pagination) return;
    var isMobile = window.matchMedia("(max-width: 999px)");
    var quotesContainer = section.querySelector(".ds-social__quotes");
    var currentIndex = 0;
    var swipeStartX = 0;
    var isSwiping = false;
    var desktopPerPage = 3;
    function getPageCount() {
      if (isMobile.matches) return quotes.length;
      return Math.ceil(quotes.length / desktopPerPage);
    }
    function buildDots() {
      var pageCount = getPageCount();
      pagination.innerHTML = "";
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement("button");
        dot.className = "ds-social__pagination-dot" + (i === 0 ? " is-active" : "");
        dot.dataset.dotIndex = i;
        dot.setAttribute("aria-label", "Show page " + (i + 1));
        dot.addEventListener("click", function() {
          goToPage(parseInt(this.dataset.dotIndex, 10));
        });
        pagination.appendChild(dot);
      }
      if (!isMobile.matches) {
        pagination.classList.toggle("has-desktop-pages", quotes.length > desktopPerPage);
      } else {
        pagination.classList.remove("has-desktop-pages");
      }
    }
    function updateDots(index) {
      var dots = pagination.querySelectorAll(".ds-social__pagination-dot");
      dots.forEach(function(dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
    }
    function goToPage(index) {
      var maxIndex = getPageCount() - 1;
      if (index < 0) index = 0;
      if (index > maxIndex) index = maxIndex;
      currentIndex = index;
      if (isMobile.matches) {
        quotes.forEach(function(q) {
          q.style.transform = "translateX(" + -currentIndex * 100 + "%)";
          q.style.transition = "transform 0.3s ease";
        });
      } else {
        var targetQuote = quotes[currentIndex * desktopPerPage];
        if (targetQuote) {
          var containerRect = quotesContainer.getBoundingClientRect();
          var quoteRect = targetQuote.getBoundingClientRect();
          var scrollTarget = quotesContainer.scrollLeft + (quoteRect.left - containerRect.left);
          quotesContainer.scrollTo({ left: scrollTarget, behavior: "smooth" });
        }
      }
      updateDots(currentIndex);
    }
    if (quotesContainer) {
      var scrollTimeout;
      quotesContainer.addEventListener("scroll", function() {
        if (isMobile.matches) return;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          var scrollLeft = quotesContainer.scrollLeft;
          var maxScroll = quotesContainer.scrollWidth - quotesContainer.clientWidth;
          var pageCount = getPageCount();
          var newIndex = maxScroll > 0 ? Math.round(scrollLeft / maxScroll * (pageCount - 1)) : 0;
          if (newIndex !== currentIndex) {
            currentIndex = newIndex;
            updateDots(currentIndex);
          }
        }, 50);
      }, { passive: true });
      var dragStartX = 0;
      var dragScrollLeft = 0;
      var isDragging = false;
      quotesContainer.addEventListener("mousedown", function(e) {
        if (isMobile.matches) return;
        isDragging = true;
        dragStartX = e.pageX;
        dragScrollLeft = quotesContainer.scrollLeft;
        quotesContainer.style.cursor = "grabbing";
        quotesContainer.style.scrollBehavior = "auto";
      });
      window.addEventListener("mousemove", function(e) {
        if (!isDragging) {
          if (!isSwiping) return;
          e.preventDefault();
          return;
        }
        e.preventDefault();
        var diff = e.pageX - dragStartX;
        quotesContainer.scrollLeft = dragScrollLeft - diff;
      });
      window.addEventListener("mouseup", function(e) {
        if (isDragging) {
          isDragging = false;
          quotesContainer.style.cursor = "";
          quotesContainer.style.scrollBehavior = "";
          return;
        }
        if (!isSwiping) return;
        isSwiping = false;
        quotesContainer.style.cursor = "";
        var diffX = swipeStartX - e.clientX;
        if (Math.abs(diffX) > 50) {
          goToPage(currentIndex + (diffX > 0 ? 1 : -1));
        }
      });
      quotesContainer.addEventListener("touchstart", function(e) {
        if (!isMobile.matches) return;
        swipeStartX = e.touches[0].clientX;
        isSwiping = true;
      }, { passive: true });
      quotesContainer.addEventListener("touchend", function(e) {
        if (!isSwiping) return;
        isSwiping = false;
        var diffX = swipeStartX - e.changedTouches[0].clientX;
        if (Math.abs(diffX) > 50) {
          goToPage(currentIndex + (diffX > 0 ? 1 : -1));
        }
      }, { passive: true });
      quotesContainer.addEventListener("mousedown", function(e) {
        if (!isMobile.matches) return;
        swipeStartX = e.clientX;
        isSwiping = true;
        quotesContainer.style.cursor = "grabbing";
      });
    }
    buildDots();
    isMobile.addEventListener("change", function() {
      currentIndex = 0;
      quotes.forEach(function(q) {
        q.style.transform = "";
      });
      if (quotesContainer) {
        quotesContainer.scrollLeft = 0;
        quotesContainer.style.transform = "";
      }
      buildDots();
    });
  });
}
initDsSocial();
function isObject$1(obj) {
  return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend$1(target = {}, src = {}) {
  const noExtend = ["__proto__", "constructor", "prototype"];
  Object.keys(src).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
    if (typeof target[key] === "undefined") target[key] = src[key];
    else if (isObject$1(src[key]) && isObject$1(target[key]) && Object.keys(src[key]).length > 0) {
      extend$1(target[key], src[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const doc2 = typeof document !== "undefined" ? document : {};
  extend$1(doc2, ssrDocument);
  return doc2;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function CustomEvent2() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === "undefined") {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === "undefined") {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== "undefined" ? window : {};
  extend$1(win, ssrWindow);
  return win;
}
function classesToTokens(classes2 = "") {
  return classes2.trim().split(" ").filter((c) => !!c.trim());
}
function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach((key) => {
    try {
      object[key] = null;
    } catch (e) {
    }
    try {
      delete object[key];
    } catch (e) {
    }
  });
}
function nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(el) {
  const window2 = getWindow();
  let style;
  if (window2.getComputedStyle) {
    style = window2.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis = "x") {
  const window2 = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$1(el);
  if (window2.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(",").length > 6) {
      curTransform = curTransform.split(", ").map((a) => a.replace(",", ".")).join(", ");
    }
    transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
    matrix = transformMatrix.toString().split(",");
  }
  if (axis === "x") {
    if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m41;
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
    else curTransform = parseFloat(matrix[4]);
  }
  if (axis === "y") {
    if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m42;
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
    else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject(o) {
  return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function isNode(node) {
  if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend(...args) {
  const to = Object(args[0]);
  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];
    if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter((key) => key !== "__proto__" && key !== "constructor" && key !== "prototype");
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== void 0 && desc.enumerable) {
          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window2 = getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = "none";
  window2.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? "next" : "prev";
  const isOutOfBound = (current, target) => {
    return dir === "next" && current >= target || dir === "prev" && current <= target;
  };
  const animate2 = () => {
    time = (/* @__PURE__ */ new Date()).getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = "hidden";
      swiper.wrapperEl.style.scrollSnapType = "";
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = "";
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window2.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window2.requestAnimationFrame(animate2);
  };
  animate2();
}
function getSlideTransformEl(slideEl) {
  return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function elementChildren(element, selector = "") {
  const window2 = getWindow();
  const children = [...element.children];
  if (window2.HTMLSlotElement && element instanceof HTMLSlotElement) {
    children.push(...element.assignedElements());
  }
  if (!selector) {
    return children;
  }
  return children.filter((el) => el.matches(selector));
}
function elementIsChildOfSlot(el, slot) {
  const elementsQueue = [slot];
  while (elementsQueue.length > 0) {
    const elementToCheck = elementsQueue.shift();
    if (el === elementToCheck) {
      return true;
    }
    elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
  }
}
function elementIsChildOf(el, parent) {
  const window2 = getWindow();
  let isChild = parent.contains(el);
  if (!isChild && window2.HTMLSlotElement && parent instanceof HTMLSlotElement) {
    const children = [...parent.assignedElements()];
    isChild = children.includes(el);
    if (!isChild) {
      isChild = elementIsChildOfSlot(el, parent);
    }
  }
  return isChild;
}
function showWarning(text) {
  try {
    console.warn(text);
    return;
  } catch (err) {
  }
}
function createElement(tag, classes2 = []) {
  const el = document.createElement(tag);
  el.classList.add(...Array.isArray(classes2) ? classes2 : classesToTokens(classes2));
  return el;
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling;
    if (selector) {
      if (prev.matches(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling;
    if (selector) {
      if (next.matches(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window2 = getWindow();
  return window2.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i;
  if (child) {
    i = 0;
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return void 0;
}
function elementParents(el, selector) {
  const parents = [];
  let parent = el.parentElement;
  while (parent) {
    if (selector) {
      if (parent.matches(selector)) parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el) return;
    callback.call(el, e);
    el.removeEventListener("transitionend", fireCallBack);
  }
  if (callback) {
    el.addEventListener("transitionend", fireCallBack);
  }
}
function elementOuterSize(el, size, includeMargins) {
  const window2 = getWindow();
  {
    return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
  }
}
function makeElementsArray(el) {
  return (Array.isArray(el) ? el : [el]).filter((e) => !!e);
}
function setInnerHTML(el, html = "") {
  if (typeof trustedTypes !== "undefined") {
    el.innerHTML = trustedTypes.createPolicy("html", {
      createHTML: (s) => s
    }).createHTML(html);
  } else {
    el.innerHTML = html;
  }
}
let support;
function calcSupport() {
  const window2 = getWindow();
  const document2 = getDocument();
  return {
    smoothScroll: document2.documentElement && document2.documentElement.style && "scrollBehavior" in document2.documentElement.style,
    touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}
let deviceCached;
function calcDevice({
  userAgent
} = {}) {
  const support2 = getSupport();
  const window2 = getWindow();
  const platform = window2.navigator.platform;
  const ua2 = userAgent || window2.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window2.screen.width;
  const screenHeight = window2.screen.height;
  const android = ua2.match(/(Android);?[\s\/]+([\d.]+)?/);
  let ipad = ua2.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
  const ipod = ua2.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua2.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === "Win32";
  let macos = platform === "MacIntel";
  const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua2.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, "13_0_0"];
    macos = false;
  }
  if (android && !windows) {
    device.os = "android";
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = "ios";
    device.ios = true;
  }
  return device;
}
function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}
let browser;
function calcBrowser() {
  const window2 = getWindow();
  const device = getDevice();
  let needPerspectiveFix = false;
  function isSafari2() {
    const ua2 = window2.navigator.userAgent.toLowerCase();
    return ua2.indexOf("safari") >= 0 && ua2.indexOf("chrome") < 0 && ua2.indexOf("android") < 0;
  }
  if (isSafari2()) {
    const ua2 = String(window2.navigator.userAgent);
    if (ua2.includes("Version/")) {
      const [major, minor] = ua2.split("Version/")[1].split(" ")[0].split(".").map((num) => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent);
  const isSafariBrowser = isSafari2();
  const need3dFix = isSafariBrowser || isWebView && device.ios;
  return {
    isSafari: needPerspectiveFix || isSafariBrowser,
    needPerspectiveFix,
    need3dFix,
    isWebView
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}
function Resize({
  swiper,
  on,
  emit: emit2
}) {
  const window2 = getWindow();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit2("beforeResize");
    emit2("resize");
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver((entries) => {
      animationFrame = window2.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window2.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit2("orientationchange");
  };
  on("init", () => {
    if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
      createObserver();
      return;
    }
    window2.addEventListener("resize", resizeHandler);
    window2.addEventListener("orientationchange", orientationChangeHandler);
  });
  on("destroy", () => {
    removeObserver();
    window2.removeEventListener("resize", resizeHandler);
    window2.removeEventListener("orientationchange", orientationChangeHandler);
  });
}
function Observer({
  swiper,
  extendParams,
  on,
  emit: emit2
}) {
  const observers = [];
  const window2 = getWindow();
  const attach = (target, options = {}) => {
    const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
    const observer = new ObserverFunc((mutations) => {
      if (swiper.__preventObserver__) return;
      if (mutations.length === 1) {
        emit2("observerUpdate", mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate2() {
        emit2("observerUpdate", mutations[0]);
      };
      if (window2.requestAnimationFrame) {
        window2.requestAnimationFrame(observerUpdate);
      } else {
        window2.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === "undefined" ? true : options.attributes,
      childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
      characterData: typeof options.characterData === "undefined" ? true : options.characterData
    });
    observers.push(observer);
  };
  const init2 = () => {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      const containerParents = elementParents(swiper.hostEl);
      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach((observer) => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on("init", init2);
  on("destroy", destroy);
}
var eventsEmitter = {
  on(events2, handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (typeof handler !== "function") return self2;
    const method = priority ? "unshift" : "push";
    events2.split(" ").forEach((event) => {
      if (!self2.eventsListeners[event]) self2.eventsListeners[event] = [];
      self2.eventsListeners[event][method](handler);
    });
    return self2;
  },
  once(events2, handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (typeof handler !== "function") return self2;
    function onceHandler(...args) {
      self2.off(events2, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      handler.apply(self2, args);
    }
    onceHandler.__emitterProxy = handler;
    return self2.on(events2, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (typeof handler !== "function") return self2;
    const method = priority ? "unshift" : "push";
    if (self2.eventsAnyListeners.indexOf(handler) < 0) {
      self2.eventsAnyListeners[method](handler);
    }
    return self2;
  },
  offAny(handler) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (!self2.eventsAnyListeners) return self2;
    const index = self2.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self2.eventsAnyListeners.splice(index, 1);
    }
    return self2;
  },
  off(events2, handler) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (!self2.eventsListeners) return self2;
    events2.split(" ").forEach((event) => {
      if (typeof handler === "undefined") {
        self2.eventsListeners[event] = [];
      } else if (self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self2.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self2;
  },
  emit(...args) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (!self2.eventsListeners) return self2;
    let events2;
    let data;
    let context;
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
      events2 = args[0];
      data = args.slice(1, args.length);
      context = self2;
    } else {
      events2 = args[0].events;
      data = args[0].data;
      context = args[0].context || self2;
    }
    data.unshift(context);
    const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
    eventsArray.forEach((event) => {
      if (self2.eventsAnyListeners && self2.eventsAnyListeners.length) {
        self2.eventsAnyListeners.forEach((eventHandler) => {
          eventHandler.apply(context, [event, ...data]);
        });
      }
      if (self2.eventsListeners && self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler) => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self2;
  }
};
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const el = swiper.el;
  if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }
  width = width - parseInt(elementStyle(el, "padding-left") || 0, 10) - parseInt(elementStyle(el, "padding-right") || 0, 10);
  height = height - parseInt(elementStyle(el, "padding-top") || 0, 10) - parseInt(elementStyle(el, "padding-bottom") || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
function updateSlides() {
  const swiper = this;
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    wrapperEl,
    slidesEl,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === "function") {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === "function") {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  const swiperSize = swiper.size - offsetBefore - offsetAfter;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === "undefined") {
    return;
  }
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
  } else if (typeof spaceBetween === "string") {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
  slides.forEach((slideEl) => {
    if (rtl) {
      slideEl.style.marginLeft = "";
    } else {
      slideEl.style.marginRight = "";
    }
    slideEl.style.marginBottom = "";
    slideEl.style.marginTop = "";
  });
  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", "");
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", "");
  }
  if (params.cssMode) {
    setCSSProperty(wrapperEl, "--swiper-slides-offset-before", `${offsetBefore}px`);
    setCSSProperty(wrapperEl, "--swiper-slides-offset-after", `${offsetAfter}px`);
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slides);
  } else if (swiper.grid) {
    swiper.grid.unsetSlides();
  }
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
    return typeof params.breakpoints[key].slidesPerView !== "undefined";
  }).length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide2 = slides[i];
    if (slide2) {
      if (gridEnabled) {
        swiper.grid.updateSlide(i, slide2, slides);
      }
      if (elementStyle(slide2, "display") === "none") continue;
    }
    if (isVirtual && params.slidesPerView === "auto") {
      if (params.virtual.slidesPerViewAutoSlideSize) {
        slideSize = params.virtual.slidesPerViewAutoSlideSize;
      }
      if (slideSize && slide2) {
        if (params.roundLengths) slideSize = Math.floor(slideSize);
        slide2.style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
      }
    } else if (params.slidesPerView === "auto") {
      if (shouldResetSlideSize) {
        slide2.style[swiper.getDirectionLabel("width")] = ``;
      }
      const slideStyles = getComputedStyle(slide2);
      const currentTransform = slide2.style.transform;
      const currentWebKitTransform = slide2.style.webkitTransform;
      if (currentTransform) {
        slide2.style.transform = "none";
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = "none";
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? elementOuterSize(slide2, "width") : elementOuterSize(slide2, "height");
      } else {
        const width = getDirectionPropertyValue(slideStyles, "width");
        const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
        const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
        const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
        const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
        const boxSizing = slideStyles.getPropertyValue("box-sizing");
        if (boxSizing && boxSizing === "border-box") {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide2;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide2.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slide2) {
        slide2.style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
      }
    }
    if (slide2) {
      slide2.swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1e3) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
    wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid);
  }
  if (!params.centeredSlides) {
    const isFractionalSlidesPerView = params.slidesPerView !== "auto" && params.slidesPerView % 1 !== 0;
    const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === "auto" || isFractionalSlidesPerView);
    let lastAllowedSnapIndex = snapGrid.length;
    if (shouldSnapToSlideEdge) {
      let minVisibleSlides;
      if (params.slidesPerView === "auto") {
        minVisibleSlides = 1;
        let accumulatedSize = 0;
        for (let i = slidesSizesGrid.length - 1; i >= 0; i -= 1) {
          accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
          if (accumulatedSize <= swiperSize) {
            minVisibleSlides = slidesSizesGrid.length - i;
          } else {
            break;
          }
        }
      } else {
        minVisibleSlides = Math.floor(params.slidesPerView);
      }
      lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
    }
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (shouldSnapToSlideEdge) {
        if (i <= lastAllowedSnapIndex) {
          newSlidesGrid.push(slidesGridItem);
        }
      } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      if (!shouldSnapToSlideEdge) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i = 0; i < groups; i += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
    slides.filter((_, slideIndex) => {
      if (!params.cssMode || params.loop) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach((slideEl) => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
    snapGrid = snapGrid.map((snap) => {
      if (snap <= 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map((v) => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit("slidesLengthChange");
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit("snapGridLengthChange");
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit("slidesGridLengthChange");
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  swiper.emit("slidesUpdated");
  if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}
function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;
  if (typeof speed === "number") {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = (index) => {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index)];
    }
    return swiper.slides[index];
  };
  if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach((slide2) => {
        activeSlides.push(slide2);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== "undefined") {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }
  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}
const toggleSlideClasses$1 = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesProgress(translate2 = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
  let offsetCenter = -translate2;
  if (rtl) offsetCenter = translate2;
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  let spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
  } else if (typeof spaceBetween === "string") {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (let i = 0; i < slides.length; i += 1) {
    const slide2 = slides[i];
    let slideOffset = slide2.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide2);
      swiper.visibleSlidesIndexes.push(i);
    }
    toggleSlideClasses$1(slide2, isVisible, params.slideVisibleClass);
    toggleSlideClasses$1(slide2, isFullyVisible, params.slideFullyVisibleClass);
    slide2.progress = rtl ? -slideProgress : slideProgress;
    slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}
function updateProgress(translate2) {
  const swiper = this;
  if (typeof translate2 === "undefined") {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate2 - swiper.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate2 - swiper.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate2 - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded) progress = 0;
    if (isEndRounded) progress = 1;
  }
  if (params.loop) {
    const firstSlideIndex = swiper.getSlideIndexByData(0);
    const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate2);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1) progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate2);
  if (isBeginning && !wasBeginning) {
    swiper.emit("reachBeginning toEdge");
  }
  if (isEnd && !wasEnd) {
    swiper.emit("reachEnd toEdge");
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit("fromEdge");
  }
  swiper.emit("progress", progress);
}
const toggleSlideClasses = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const getFilteredSlide = (selector) => {
    return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  let activeSlide;
  let prevSlide;
  let nextSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    if (gridEnabled) {
      activeSlide = slides.find((slideEl) => slideEl.column === activeIndex);
      nextSlide = slides.find((slideEl) => slideEl.column === activeIndex + 1);
      prevSlide = slides.find((slideEl) => slideEl.column === activeIndex - 1);
    } else {
      activeSlide = slides[activeIndex];
    }
  }
  if (activeSlide) {
    if (!gridEnabled) {
      nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !nextSlide) {
        nextSlide = slides[0];
      }
      prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !prevSlide === 0) {
        prevSlide = slides[slides.length - 1];
      }
    }
  }
  slides.forEach((slideEl) => {
    toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
    toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
    toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
  });
  swiper.emitSlidesClasses();
}
const processLazyPreloader = (swiper, imageEl) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      } else {
        requestAnimationFrame(() => {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
          }
        });
      }
    }
    if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
  }
};
const unlazy = (swiper, index) => {
  if (!swiper.slides[index]) return;
  const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
  if (imageEl) imageEl.removeAttribute("loading");
};
const preload = (swiper) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  let amount = swiper.params.lazyPreloadPrevNext;
  const len = swiper.slides.length;
  if (!len || !amount || amount < 0) return;
  amount = Math.min(amount, len);
  const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  const activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    const activeColumn = activeIndex;
    const preloadColumns = [activeColumn - amount];
    preloadColumns.push(...Array.from({
      length: amount
    }).map((_, i) => {
      return activeColumn + slidesPerView + i;
    }));
    swiper.slides.forEach((slideEl, i) => {
      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
    });
    return;
  }
  const slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      const realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
  } else {
    for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
      if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
        unlazy(swiper, i);
      }
    }
  }
};
function getActiveIndexByTranslate(swiper) {
  const {
    slidesGrid,
    params
  } = swiper;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  let activeIndex;
  for (let i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== "undefined") {
      if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate2 >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = (aIndex) => {
    let realIndex2 = aIndex - swiper.virtual.slidesBefore;
    if (realIndex2 < 0) {
      realIndex2 = swiper.virtual.slides.length + realIndex2;
    }
    if (realIndex2 >= swiper.virtual.slides.length) {
      realIndex2 -= swiper.virtual.slides.length;
    }
    return realIndex2;
  };
  if (typeof activeIndex === "undefined") {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate2) >= 0) {
    snapIndex = snapGrid.indexOf(translate2);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex && !swiper.params.loop) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit("snapIndexChange");
    }
    return;
  }
  if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
    swiper.realIndex = getVirtualRealIndex(activeIndex);
    return;
  }
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  let realIndex;
  if (swiper.virtual && params.virtual.enabled) {
    if (params.loop) {
      realIndex = getVirtualRealIndex(activeIndex);
    } else {
      realIndex = activeIndex;
    }
  } else if (gridEnabled) {
    const firstSlideInColumn = swiper.slides.find((slideEl) => slideEl.column === activeIndex);
    let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
    if (Number.isNaN(activeSlideIndex)) {
      activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
    }
    realIndex = Math.floor(activeSlideIndex / params.grid.rows);
  } else if (swiper.slides[activeIndex]) {
    const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
    if (slideIndex) {
      realIndex = parseInt(slideIndex, 10);
    } else {
      realIndex = activeIndex;
    }
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex,
    snapIndex,
    previousRealIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit("activeIndexChange");
  swiper.emit("snapIndexChange");
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit("realIndexChange");
    }
    swiper.emit("slideChange");
  }
}
function updateClickedSlide(el, path) {
  const swiper = this;
  const params = swiper.params;
  let slide2 = el.closest(`.${params.slideClass}, swiper-slide`);
  if (!slide2 && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [...path.slice(path.indexOf(el) + 1, path.length)].forEach((pathEl) => {
      if (!slide2 && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
        slide2 = pathEl;
      }
    });
  }
  let slideFound = false;
  let slideIndex;
  if (slide2) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide2) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide2 && slideFound) {
    swiper.clickedSlide = slide2;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide2.getAttribute("data-swiper-slide-index"), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = void 0;
    swiper.clickedIndex = void 0;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
var update3 = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(axis = this.isHorizontal() ? "x" : "y") {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate: translate2,
    wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate2 : translate2;
  }
  if (params.cssMode) {
    return translate2;
  }
  let currentTranslate = getTranslate(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
function setTranslate(translate2, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress
  } = swiper;
  let x3 = 0;
  let y = 0;
  const z2 = 0;
  if (swiper.isHorizontal()) {
    x3 = rtl ? -translate2 : translate2;
  } else {
    y = translate2;
  }
  if (params.roundLengths) {
    x3 = Math.floor(x3);
    y = Math.floor(y);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x3 : y;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x3 : -y;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x3 -= swiper.cssOverflowAdjustment();
    } else {
      y -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = `translate3d(${x3}px, ${y}px, ${z2}px)`;
  }
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate2 - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate2);
  }
  swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate2 = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate2 = swiper.minTranslate();
  const maxTranslate2 = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate2 > minTranslate2) newTranslate = minTranslate2;
  else if (translateBounds && translate2 < maxTranslate2) newTranslate = maxTranslate2;
  else newTranslate = translate2;
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: -newTranslate,
        behavior: "smooth"
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionEnd");
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionStart");
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd2(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          swiper.animating = false;
          if (runCallbacks) {
            swiper.emit("transitionEnd");
          }
        };
      }
      swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}
var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
  }
  swiper.emit("setTransition", duration, byController);
}
function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = "next";
    else if (activeIndex < previousIndex) dir = "prev";
    else dir = "reset";
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && dir === "reset") {
    swiper.emit(`slideResetTransition${step}`);
  } else if (runCallbacks && activeIndex !== previousIndex) {
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === "next") {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
function transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "Start"
  });
}
function transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "End"
  });
}
var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
  if (typeof index === "string") {
    index = parseInt(index, 10);
  }
  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate2 = -snapGrid[snapIndex];
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate2 * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== "undefined") {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate2 > swiper.translate && translate2 > swiper.minTranslate() : translate2 < swiper.translate && translate2 < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit("beforeSlideChangeStart");
  }
  swiper.updateProgress(translate2);
  let direction;
  if (slideIndex > activeIndex) direction = "next";
  else if (slideIndex < activeIndex) direction = "prev";
  else direction = "reset";
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  const isInitialVirtual = isVirtual && initial;
  if (!isInitialVirtual && (rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate)) {
    swiper.updateActiveIndex(slideIndex);
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== "slide") {
      swiper.setTranslate(translate2);
    }
    if (direction !== "reset") {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate2 : -translate2;
    if (speed === 0) {
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = "none";
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
        });
      } else {
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = "";
          swiper._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: t,
        behavior: "smooth"
      });
    }
    return true;
  }
  const browser2 = getBrowser();
  const isSafari2 = browser2.isSafari;
  if (isVirtual && !initial && isSafari2 && swiper.isElement) {
    swiper.virtual.update(false, false, slideIndex);
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate2);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit("beforeTransitionStart", speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd2(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}
function slideToLoop(index = 0, speed, runCallbacks = true, internal) {
  if (typeof index === "string") {
    const indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  let newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      let targetSlideIndex;
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        targetSlideIndex = swiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
      } else {
        targetSlideIndex = swiper.getSlideIndexByData(newIndex);
      }
      const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
      const {
        centeredSlides,
        slidesOffsetBefore,
        slidesOffsetAfter
      } = swiper.params;
      const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
      let slidesPerView = swiper.params.slidesPerView;
      if (slidesPerView === "auto") {
        slidesPerView = swiper.slidesPerViewDynamic();
      } else {
        slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (bothDirections && slidesPerView % 2 === 0) {
          slidesPerView = slidesPerView + 1;
        }
      }
      let needLoopFix = cols - targetSlideIndex < slidesPerView;
      if (bothDirections) {
        needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
      }
      if (internal && bothDirections && swiper.params.slidesPerView !== "auto" && !gridEnabled) {
        needLoopFix = false;
      }
      if (needLoopFix) {
        const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
        swiper.loopFix({
          direction,
          slideTo: true,
          activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
          slideRealIndex: direction === "next" ? swiper.realIndex : void 0
        });
      }
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        newIndex = swiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
      } else {
        newIndex = swiper.getSlideIndexByData(newIndex);
      }
    }
  }
  requestAnimationFrame(() => {
    swiper.slideTo(newIndex, speed, runCallbacks, internal);
  });
  return swiper;
}
function slideNext(speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    enabled,
    params,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: "next"
    });
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function slidePrev(speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: "prev"
    });
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize2(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize2(translate2);
  const normalizedSnapGrid = snapGrid.map((val) => normalize2(val));
  const isFreeMode = params.freeMode && params.freeMode.enabled;
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === "undefined" && (params.cssMode || isFreeMode)) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== "undefined") {
      prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== "undefined") {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(() => {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function slideReset(speed, runCallbacks = true, internal) {
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate2 >= swiper.snapGrid[snapIndex]) {
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
  const swiper = this;
  if (swiper.destroyed) return;
  const {
    params,
    slidesEl
  } = swiper;
  const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
  let realIndex;
  const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
  const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
    if (params.centeredSlides) {
      swiper.slideToLoop(realIndex);
    } else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate(slideRealIndex, initial) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  const initSlides = () => {
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index) => {
      el.setAttribute("data-swiper-slide-index", index);
    });
  };
  const clearBlankSlides = () => {
    const slides = elementChildren(slidesEl, `.${params.slideBlankClass}`);
    slides.forEach((el) => {
      el.remove();
    });
    if (slides.length > 0) {
      swiper.recalcSlides();
      swiper.updateSlides();
    }
  };
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) {
    clearBlankSlides();
  }
  const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
  const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
  const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
  const addBlankSlides = (amountOfSlides) => {
    for (let i = 0; i < amountOfSlides; i += 1) {
      const slideEl = swiper.isElement ? createElement("swiper-slide", [params.slideBlankClass]) : createElement("div", [params.slideClass, params.slideBlankClass]);
      swiper.slidesEl.append(slideEl);
    }
  };
  if (shouldFillGroup) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      showWarning("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    }
    initSlides();
  } else if (shouldFillGrid) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      showWarning("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    }
    initSlides();
  } else {
    initSlides();
  }
  const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
  swiper.loopFix({
    slideRealIndex,
    direction: bothDirections ? void 0 : "next",
    initial
  });
}
function loopFix({
  slideRealIndex,
  slideTo: slideTo2 = true,
  direction,
  setTranslate: setTranslate2,
  activeSlideIndex,
  initial,
  byController,
  byMousewheel
} = {}) {
  const swiper = this;
  if (!swiper.params.loop) return;
  swiper.emit("beforeLoopFix");
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper;
  const {
    centeredSlides,
    slidesOffsetBefore,
    slidesOffsetAfter,
    initialSlide
  } = params;
  const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo2) {
      if (!bothDirections && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (bothDirections && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
    return;
  }
  let slidesPerView = params.slidesPerView;
  if (slidesPerView === "auto") {
    slidesPerView = swiper.slidesPerViewDynamic();
  } else {
    slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
    if (bothDirections && slidesPerView % 2 === 0) {
      slidesPerView = slidesPerView + 1;
    }
  }
  const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
  let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
  if (loopedSlides % slidesPerGroup !== 0) {
    loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
  }
  loopedSlides += params.loopAdditionalSlides;
  swiper.loopedSlides = loopedSlides;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
    showWarning("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
  } else if (gridEnabled && params.grid.fill === "row") {
    showWarning("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  }
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
  const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
  let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
  if (typeof activeSlideIndex === "undefined") {
    activeSlideIndex = swiper.getSlideIndex(slides.find((el) => el.classList.contains(params.slideActiveClass)));
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === "next" || !direction;
  const isPrev = direction === "prev" || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
  const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate2 === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
  if (activeColIndexWithShift < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
    for (let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
      const index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        const colIndexToPrepend = cols - index - 1;
        for (let i2 = slides.length - 1; i2 >= 0; i2 -= 1) {
          if (slides[i2].column === colIndexToPrepend) prependSlidesIndexes.push(i2);
        }
      } else {
        prependSlidesIndexes.push(cols - index - 1);
      }
    }
  } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
    slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
    if (isInitialOverflow) {
      slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
    }
    for (let i = 0; i < slidesAppended; i += 1) {
      const index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        slides.forEach((slide2, slideIndex) => {
          if (slide2.column === index) appendSlidesIndexes.push(slideIndex);
        });
      } else {
        appendSlidesIndexes.push(index);
      }
    }
  }
  swiper.__preventObserver__ = true;
  requestAnimationFrame(() => {
    swiper.__preventObserver__ = false;
  });
  if (swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
    if (appendSlidesIndexes.includes(activeSlideIndex)) {
      appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (prependSlidesIndexes.includes(activeSlideIndex)) {
      prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
  }
  if (isPrev) {
    prependSlidesIndexes.forEach((index) => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach((index) => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === "auto") {
    swiper.updateSlides();
  } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
    swiper.slides.forEach((slide2, slideIndex) => {
      swiper.grid.updateSlide(slideIndex, slide2, swiper.slides);
    });
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo2) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
          if (setTranslate2) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        if (setTranslate2) {
          const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate2) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
        swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      direction,
      setTranslate: setTranslate2,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach((c) => {
        if (!c.destroyed && c.params.loop) c.loopFix({
          ...loopParams,
          slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo2 : false
        });
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix({
        ...loopParams,
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo2 : false
      });
    }
  }
  swiper.emit("loopFix");
}
function loopDestroy() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
  swiper.recalcSlides();
  const newSlidesOrder = [];
  swiper.slides.forEach((slideEl) => {
    const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper.slides.forEach((slideEl) => {
    slideEl.removeAttribute("data-swiper-slide-index");
  });
  newSlidesOrder.forEach((slideEl) => {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}
var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(moving) {
  const swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = "move";
  el.style.cursor = moving ? "grabbing" : "grab";
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}
function unsetGrabCursor() {
  const swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}
var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
  const window2 = getWindow();
  const {
    params
  } = swiper;
  const edgeSwipeDetection = params.edgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === "prevent") {
      event.preventDefault();
      return true;
    }
    return false;
  }
  return true;
}
function onTouchStart(event) {
  const swiper = this;
  if (swiper.destroyed) return;
  const document2 = getDocument();
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  const data = swiper.touchEventsData;
  if (e.type === "pointerdown") {
    if (data.pointerId !== null && data.pointerId !== e.pointerId) {
      return;
    }
    data.pointerId = e.pointerId;
  } else if (e.type === "touchstart" && e.targetTouches.length === 1) {
    data.touchId = e.targetTouches[0].identifier;
  }
  if (e.type === "touchstart") {
    preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
    return;
  }
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === "mouse") return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let targetEl = e.target;
  if (params.touchEventsTarget === "wrapper") {
    if (!elementIsChildOf(targetEl, swiper.wrapperEl)) return;
  }
  if ("which" in e && e.which === 3) return;
  if ("button" in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
  const eventPath = e.composedPath ? e.composedPath() : e.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot);
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler)) return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;
  if (!preventEdgeSwipe(swiper, e, startX)) {
    return;
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: void 0,
    startMoving: void 0
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = void 0;
  if (params.threshold > 0) data.allowThresholdMove = false;
  let preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === "SELECT") {
      data.isTouched = false;
    }
  }
  if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== targetEl && (e.pointerType === "mouse" || e.pointerType !== "mouse" && !targetEl.matches(data.focusableElements))) {
    document2.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit("touchStart", e);
}
function onTouchMove(event) {
  const document2 = getDocument();
  const swiper = this;
  if (swiper.destroyed) return;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === "mouse") return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (e.type === "pointermove") {
    if (data.touchId !== null) return;
    const id = e.pointerId;
    if (id !== data.pointerId) return;
  }
  let targetTouch;
  if (e.type === "touchmove") {
    targetTouch = [...e.changedTouches].find((t) => t.identifier === data.touchId);
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  } else {
    targetTouch = e;
  }
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit("touchMoveOpposite", e);
    }
    return;
  }
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) {
      return;
    } else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) {
      return;
    }
  }
  if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== e.target && e.pointerType !== "mouse") {
    document2.activeElement.blur();
  }
  if (document2.activeElement) {
    if (e.target === document2.activeElement && e.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit("touchMove", e);
  }
  touches.previousX = touches.currentX;
  touches.previousY = touches.currentY;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
  if (typeof data.isScrolling === "undefined") {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit("touchMoveOpposite", e);
  }
  if (typeof data.startMoving === "undefined") {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  let diff = swiper.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? "prev" : "next";
  swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
  const isLoop = swiper.params.loop && !params.cssMode;
  const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      const evt = new window.CustomEvent("transitionend", {
        bubbles: true,
        cancelable: true,
        detail: {
          bySwiperTouchMove: true
        }
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit("sliderFirstMove", e);
  }
  (/* @__PURE__ */ new Date()).getTime();
  if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    Object.assign(touches, {
      startX: pageX,
      startY: pageY,
      currentX: pageX,
      currentY: pageY,
      startTranslate: data.currentTranslate
    });
    data.loopSwapReset = true;
    data.startTranslate = data.currentTranslate;
    return;
  }
  swiper.emit("sliderMove", e);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) {
      swiper.loopFix({
        direction: "prev",
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: "next",
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }
  if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return;
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  swiper.updateProgress(data.currentTranslate);
  swiper.setTranslate(data.currentTranslate);
}
function onTouchEnd(event) {
  const swiper = this;
  if (swiper.destroyed) return;
  const data = swiper.touchEventsData;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let targetTouch;
  const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
  if (!isTouchEvent) {
    if (data.touchId !== null) return;
    if (e.pointerId !== data.pointerId) return;
    targetTouch = e;
  } else {
    targetTouch = [...e.changedTouches].find((t) => t.identifier === data.touchId);
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(e.type)) {
    const proceed = ["pointercancel", "contextmenu"].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  data.pointerId = null;
  data.touchId = null;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === "mouse") return;
  if (data.allowTouchCallbacks) {
    swiper.emit("touchEnd", e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }
  const touchEndTime = now();
  const timeDiff = touchEndTime - data.touchStartTime;
  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
    swiper.emit("tap click", e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit("doubleTap doubleClick", e);
    }
  }
  data.lastClickTime = now();
  nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }
  const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment2 = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + increment2] !== "undefined") {
      if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment2]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment2] - slidesGrid[i];
      }
    } else if (swipeToLast || currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === "next") {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
      else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === "prev") {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === "next") {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === "prev") {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return;
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    const slides = isVirtual ? swiper.virtual.slides : swiper.slides;
    swiper.slideTo(slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(() => {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
function onClick(e) {
  const swiper = this;
  if (swiper.destroyed) return;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
function onScroll() {
  const swiper = this;
  if (swiper.destroyed) return;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit("setTranslate", swiper.translate, false);
}
function onLoad(e) {
  const swiper = this;
  if (swiper.destroyed) return;
  processLazyPreloader(swiper, e.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}
function onDocumentTouchStart() {
  const swiper = this;
  if (swiper.destroyed) return;
  if (swiper.documentTouchHandlerProceeded) return;
  swiper.documentTouchHandlerProceeded = true;
  if (swiper.params.touchReleaseOnEdges) {
    swiper.el.style.touchAction = "auto";
  }
}
const events = (swiper, method) => {
  const document2 = getDocument();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
  const swiperMethod = method;
  if (!el || typeof el === "string") return;
  document2[domMethod]("touchstart", swiper.onDocumentTouchStart, {
    passive: false,
    capture
  });
  el[domMethod]("touchstart", swiper.onTouchStart, {
    passive: false
  });
  el[domMethod]("pointerdown", swiper.onTouchStart, {
    passive: false
  });
  document2[domMethod]("touchmove", swiper.onTouchMove, {
    passive: false,
    capture
  });
  document2[domMethod]("pointermove", swiper.onTouchMove, {
    passive: false,
    capture
  });
  document2[domMethod]("touchend", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerup", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointercancel", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("touchcancel", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerout", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerleave", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("contextmenu", swiper.onTouchEnd, {
    passive: true
  });
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]("click", swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]("scroll", swiper.onScroll);
  }
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
  } else {
    swiper[swiperMethod]("observerUpdate", onResize, true);
  }
  el[domMethod]("load", swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  events(swiper, "on");
}
function detachEvents() {
  const swiper = this;
  events(swiper, "off");
}
var events$1 = {
  attachEvents,
  detachEvents
};
const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper;
  const breakpoints2 = params.breakpoints;
  if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0) return;
  const document2 = getDocument();
  const breakpointsBase = params.breakpointsBase === "window" || !params.breakpointsBase ? params.breakpointsBase : "container";
  const breakpointContainer = ["window", "container"].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document2.querySelector(params.breakpointsBase);
  const breakpoint = swiper.getBreakpoint(breakpoints2, breakpointsBase, breakpointContainer);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasGrabCursor = swiper.params.grabCursor;
  const isGrabCursor = breakpointParams.grabCursor;
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  if (wasGrabCursor && !isGrabCursor) {
    swiper.unsetGrabCursor();
  } else if (!wasGrabCursor && isGrabCursor) {
    swiper.setGrabCursor();
  }
  ["navigation", "pagination", "scrollbar"].forEach((prop) => {
    if (typeof breakpointParams[prop] === "undefined") return;
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  const wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  extend(swiper.params, breakpointParams);
  const isEnabled2 = swiper.params.enabled;
  const hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled2) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled2) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit("_beforeBreakpoint", breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints2, base = "window", containerEl) {
  if (!breakpoints2 || base === "container" && !containerEl) return void 0;
  let breakpoint = false;
  const window2 = getWindow();
  const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints2).map((point) => {
    if (typeof point === "string" && point.indexOf("@") === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b3) => parseInt(a.value, 10) - parseInt(b3.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];
    if (base === "window") {
      if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || "max";
}
var breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach((item) => {
    if (typeof item === "object") {
      Object.keys(item).forEach((classNames) => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === "string") {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    el,
    device
  } = swiper;
  const suffixes = prepareClasses(["initialized", params.direction, {
    "free-mode": swiper.params.freeMode && params.freeMode.enabled
  }, {
    "autoheight": params.autoHeight
  }, {
    "rtl": rtl
  }, {
    "grid": params.grid && params.grid.rows > 1
  }, {
    "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
  }, {
    "android": device.android
  }, {
    "ios": device.ios
  }, {
    "css-mode": params.cssMode
  }, {
    "centered": params.cssMode && params.centeredSlides
  }, {
    "watch-progress": params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  el.classList.add(...classNames);
  swiper.emitContainerClasses();
}
function removeClasses() {
  const swiper = this;
  const {
    el,
    classNames
  } = swiper;
  if (!el || typeof el === "string") return;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}
var classes = {
  addClasses,
  removeClasses
};
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? "lock" : "unlock");
  }
}
var checkOverflow$1 = {
  checkOverflow
};
var defaults = {
  init: true,
  direction: "horizontal",
  oneWayMovement: false,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  eventsPrefix: "swiper",
  enabled: true,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  snapToSlideEdge: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopAddBlankSlides: true,
  loopAdditionalSlides: 0,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== "object" || moduleParams === null) {
      extend(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (["pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && "enabled" in moduleParams)) {
      extend(allModulesParams, obj);
      return;
    }
    if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    extend(allModulesParams, obj);
  };
}
const prototypes = {
  eventsEmitter,
  update: update3,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
const extendedDefaults = {};
class Swiper {
  constructor(...args) {
    let el;
    let params;
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params) params = {};
    params = extend({}, params);
    if (el && !params.el) params.el = el;
    const document2 = getDocument();
    if (params.el && typeof params.el === "string" && document2.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document2.querySelectorAll(params.el).forEach((containerEl) => {
        const newParams = extend({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    }
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      params.modules.forEach((mod) => {
        if (typeof mod === "function" && swiper.modules.indexOf(mod) < 0) {
          swiper.modules.push(mod);
        }
      });
    }
    const allModulesParams = {};
    swiper.modules.forEach((mod) => {
      mod({
        params,
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });
    const swiperParams = extend({}, defaults, allModulesParams);
    swiper.params = extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend({}, swiper.params);
    swiper.passedParams = extend({}, params);
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach((eventName) => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === "horizontal";
      },
      isVertical() {
        return swiper.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit("_swiper");
    if (swiper.params.init) {
      swiper.init();
    }
    return swiper;
  }
  getDirectionLabel(property) {
    if (this.isHorizontal()) {
      return property;
    }
    return {
      "width": "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      "marginRight": "marginBottom"
    }[property];
  }
  getSlideIndex(slideEl) {
    const {
      slidesEl,
      params
    } = this;
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    const firstSlideIndex = elementIndex(slides[0]);
    return elementIndex(slideEl) - firstSlideIndex;
  }
  getSlideIndexByData(index) {
    return this.getSlideIndex(this.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === index));
  }
  getSlideIndexWhenGrid(index) {
    if (this.grid && this.params.grid && this.params.grid.rows > 1) {
      if (this.params.grid.fill === "column") {
        index = Math.floor(index / this.params.grid.rows);
      } else if (this.params.grid.fill === "row") {
        index = index % Math.ceil(this.slides.length / this.params.grid.rows);
      }
    }
    return index;
  }
  recalcSlides() {
    const swiper = this;
    const {
      slidesEl,
      params
    } = swiper;
    swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit("enable");
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit("disable");
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(" ").filter((className) => {
      return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit("_containerClasses", cls.join(" "));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return "";
    return slideEl.className.split(" ").filter((className) => {
      return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(" ");
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.forEach((slideEl) => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit("_slideClass", slideEl, classNames);
    });
    swiper.emit("_slideClasses", updates);
  }
  slidesPerViewDynamic(view = "current", exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (typeof params.slidesPerView === "number") return params.slidesPerView;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += Math.ceil(slides[i].swiperSlideSize);
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      if (view === "current") {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      }
    });
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate2() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
      setTranslate2();
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
        const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
        translated = swiper.slideTo(slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate2();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit("update");
  }
  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
    }
    if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
      return swiper;
    }
    swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
    swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.forEach((slideEl) => {
      if (newDirection === "vertical") {
        slideEl.style.width = "";
      } else {
        slideEl.style.height = "";
      }
    });
    swiper.emit("changeDirection");
    if (needUpdate) swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
    swiper.rtl = direction === "rtl";
    swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
    if (swiper.rtl) {
      swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "rtl";
    } else {
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "ltr";
    }
    swiper.update();
  }
  mount(element) {
    const swiper = this;
    if (swiper.mounted) return true;
    let el = element || swiper.params.el;
    if (typeof el === "string") {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
      swiper.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        return res;
      }
      return elementChildren(el, getWrapperSelector())[0];
    };
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper.params.createElements) {
      wrapperEl = createElement("div", swiper.params.wrapperClass);
      el.append(wrapperEl);
      elementChildren(el, `.${swiper.params.slideClass}`).forEach((slideEl) => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      el,
      wrapperEl,
      slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
      hostEl: swiper.isElement ? el.parentNode.host : el,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl",
      rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl"),
      wrongRTL: elementStyle(wrapperEl, "display") === "-webkit-box"
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit("beforeInit");
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.addClasses();
    swiper.updateSize();
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }
    if (swiper.params.loop) {
      swiper.loopCreate(void 0, true);
    }
    swiper.attachEvents();
    const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
    if (swiper.isElement) {
      lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
    }
    lazyElements.forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      } else {
        imageEl.addEventListener("load", (e) => {
          processLazyPreloader(swiper, e.target);
        });
      }
    });
    preload(swiper);
    swiper.initialized = true;
    preload(swiper);
    swiper.emit("init");
    swiper.emit("afterInit");
    return swiper;
  }
  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === "undefined" || swiper.destroyed) {
      return null;
    }
    swiper.emit("beforeDestroy");
    swiper.initialized = false;
    swiper.detachEvents();
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (cleanStyles) {
      swiper.removeClasses();
      if (el && typeof el !== "string") {
        el.removeAttribute("style");
      }
      if (wrapperEl) {
        wrapperEl.removeAttribute("style");
      }
      if (slides && slides.length) {
        slides.forEach((slideEl) => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute("style");
          slideEl.removeAttribute("data-swiper-slide-index");
        });
      }
    }
    swiper.emit("destroy");
    Object.keys(swiper.eventsListeners).forEach((eventName) => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      if (swiper.el && typeof swiper.el !== "string") {
        swiper.el.swiper = null;
      }
      deleteProps(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    extend(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;
    if (typeof mod === "function" && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach((m) => Swiper.installModule(m));
      return Swiper;
    }
    Swiper.installModule(module);
    return Swiper;
  }
}
Object.keys(prototypes).forEach((prototypeGroup) => {
  Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach((key) => {
      if (!params[key] && params.auto === true) {
        let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
        if (!element) {
          element = createElement("div", checkProps[key]);
          element.className = checkProps[key];
          swiper.el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}
function classesToSelector(classes2 = "") {
  return `.${classes2.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, "\\$1").replace(/ /g, ".")}`;
}
function Pagination({
  swiper,
  extendParams,
  on,
  emit: emit2
}) {
  const pfx = "swiper-pagination";
  extendParams({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: (number) => number,
      formatFractionTotal: (number) => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
  }
  function setSideBullets(bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    if (!bulletEl) return;
    bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
    if (bulletEl) {
      bulletEl.classList.add(`${bulletActiveClass}-${position}`);
      bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
      }
    }
  }
  function getMoveDirection(prevIndex, nextIndex, length) {
    prevIndex = prevIndex % length;
    nextIndex = nextIndex % length;
    if (nextIndex === prevIndex + 1) {
      return "next";
    } else if (nextIndex === prevIndex - 1) {
      return "previous";
    }
    return;
  }
  function onBulletClick(e) {
    const bulletEl = e.target.closest(classesToSelector(swiper.params.pagination.bulletClass));
    if (!bulletEl) {
      return;
    }
    e.preventDefault();
    const index = elementIndex(bulletEl) * swiper.params.slidesPerGroup;
    if (swiper.params.loop) {
      if (swiper.realIndex === index) return;
      const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
      if (moveDirection === "next") {
        swiper.slideNext();
      } else if (moveDirection === "previous") {
        swiper.slidePrev();
      } else {
        swiper.slideToLoop(index);
      }
    } else {
      swiper.slideTo(index);
    }
  }
  function update4() {
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    let current;
    let previousIndex;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      previousIndex = swiper.previousRealIndex || 0;
      current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
    } else if (typeof swiper.snapIndex !== "undefined") {
      current = swiper.snapIndex;
      previousIndex = swiper.previousSnapIndex;
    } else {
      previousIndex = swiper.previousIndex || 0;
      current = swiper.activeIndex || 0;
    }
    if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = elementOuterSize(bullets[0], swiper.isHorizontal() ? "width" : "height");
        el.forEach((subEl) => {
          subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
        });
        if (params.dynamicMainBullets > 1 && previousIndex !== void 0) {
          dynamicBulletIndex += current - (previousIndex || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.forEach((bulletEl) => {
        const classesToRemove = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((suffix) => `${params.bulletActiveClass}${suffix}`)].map((s) => typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
        bulletEl.classList.remove(...classesToRemove);
      });
      if (el.length > 1) {
        bullets.forEach((bullet) => {
          const bulletIndex = elementIndex(bullet);
          if (bulletIndex === current) {
            bullet.classList.add(...params.bulletActiveClass.split(" "));
          } else if (swiper.isElement) {
            bullet.setAttribute("part", "bullet");
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
            }
            if (bulletIndex === firstIndex) {
              setSideBullets(bullet, "prev");
            }
            if (bulletIndex === lastIndex) {
              setSideBullets(bullet, "next");
            }
          }
        });
      } else {
        const bullet = bullets[current];
        if (bullet) {
          bullet.classList.add(...params.bulletActiveClass.split(" "));
        }
        if (swiper.isElement) {
          bullets.forEach((bulletEl, bulletIndex) => {
            bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
          });
        }
        if (params.dynamicBullets) {
          const firstDisplayedBullet = bullets[firstIndex];
          const lastDisplayedBullet = bullets[lastIndex];
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            if (bullets[i]) {
              bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
            }
          }
          setSideBullets(firstDisplayedBullet, "prev");
          setSideBullets(lastDisplayedBullet, "next");
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? "right" : "left";
        bullets.forEach((bullet) => {
          bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
        });
      }
    }
    el.forEach((subEl, subElIndex) => {
      if (params.type === "fraction") {
        subEl.querySelectorAll(classesToSelector(params.currentClass)).forEach((fractionEl) => {
          fractionEl.textContent = params.formatFractionCurrent(current + 1);
        });
        subEl.querySelectorAll(classesToSelector(params.totalClass)).forEach((totalEl) => {
          totalEl.textContent = params.formatFractionTotal(total);
        });
      }
      if (params.type === "progressbar") {
        let progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
        } else {
          progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
        }
        const scale = (current + 1) / total;
        let scaleX = 1;
        let scaleY = 1;
        if (progressbarDirection === "horizontal") {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        subEl.querySelectorAll(classesToSelector(params.progressbarFillClass)).forEach((progressEl) => {
          progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
          progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
        });
      }
      if (params.type === "custom" && params.renderCustom) {
        setInnerHTML(subEl, params.renderCustom(swiper, current + 1, total));
        if (subElIndex === 0) emit2("paginationRender", subEl);
      } else {
        if (subElIndex === 0) emit2("paginationRender", subEl);
        emit2("paginationUpdate", subEl);
      }
      if (swiper.params.watchOverflow && swiper.enabled) {
        subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
      }
    });
  }
  function render() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    let paginationHTML = "";
    if (params.type === "bullets") {
      let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
    }
    if (params.type === "fraction") {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span> / <span class="${params.totalClass}"></span>`;
      }
    }
    if (params.type === "progressbar") {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
    }
    swiper.pagination.bullets = [];
    el.forEach((subEl) => {
      if (params.type !== "custom") {
        setInnerHTML(subEl, paginationHTML || "");
      }
      if (params.type === "bullets") {
        swiper.pagination.bullets.push(...subEl.querySelectorAll(classesToSelector(params.bulletClass)));
      }
    });
    if (params.type !== "custom") {
      emit2("paginationRender", el[0]);
    }
  }
  function init2() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: "swiper-pagination"
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let el;
    if (typeof params.el === "string" && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === "string") {
      el = [...document.querySelectorAll(params.el)];
    }
    if (!el) {
      el = params.el;
    }
    if (!el || el.length === 0) return;
    if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
      el = [...swiper.el.querySelectorAll(params.el)];
      if (el.length > 1) {
        el = el.find((subEl) => {
          if (elementParents(subEl, ".swiper")[0] !== swiper.el) return false;
          return true;
        });
      }
    }
    if (Array.isArray(el) && el.length === 1) el = el[0];
    Object.assign(swiper.pagination, {
      el
    });
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      if (params.type === "bullets" && params.clickable) {
        subEl.classList.add(...(params.clickableClass || "").split(" "));
      }
      subEl.classList.add(params.modifierClass + params.type);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      if (params.type === "bullets" && params.dynamicBullets) {
        subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
        dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === "progressbar" && params.progressbarOpposite) {
        subEl.classList.add(params.progressbarOppositeClass);
      }
      if (params.clickable) {
        subEl.addEventListener("click", onBulletClick);
      }
      if (!swiper.enabled) {
        subEl.classList.add(params.lockClass);
      }
    });
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        subEl.classList.remove(params.hiddenClass);
        subEl.classList.remove(params.modifierClass + params.type);
        subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.clickable) {
          subEl.classList.remove(...(params.clickableClass || "").split(" "));
          subEl.removeEventListener("click", onBulletClick);
        }
      });
    }
    if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl) => subEl.classList.remove(...params.bulletActiveClass.split(" ")));
  }
  on("changeDirection", () => {
    if (!swiper.pagination || !swiper.pagination.el) return;
    const params = swiper.params.pagination;
    let {
      el
    } = swiper.pagination;
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on("init", () => {
    if (swiper.params.pagination.enabled === false) {
      disable2();
    } else {
      init2();
      render();
      update4();
    }
  });
  on("activeIndexChange", () => {
    if (typeof swiper.snapIndex === "undefined") {
      update4();
    }
  });
  on("snapIndexChange", () => {
    update4();
  });
  on("snapGridLengthChange", () => {
    render();
    update4();
  });
  on("destroy", () => {
    destroy();
  });
  on("enable disable", () => {
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
    }
  });
  on("lock unlock", () => {
    update4();
  });
  on("click", (_s, e) => {
    const targetEl = e.target;
    const el = makeElementsArray(swiper.pagination.el);
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit2("paginationShow");
      } else {
        emit2("paginationHide");
      }
      el.forEach((subEl) => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
    }
  });
  const enable2 = () => {
    swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
    }
    init2();
    render();
    update4();
  };
  const disable2 = () => {
    swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable: enable2,
    disable: disable2,
    render,
    update: update4,
    init: init2,
    destroy
  });
}
function Autoplay({
  swiper,
  extendParams,
  on,
  emit: emit2,
  params
}) {
  swiper.autoplay = {
    running: false,
    paused: false,
    timeLeft: 0
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3e3,
      waitForTransition: true,
      disableOnInteraction: false,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });
  let timeout;
  let raf;
  let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3e3;
  let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3e3;
  let autoplayTimeLeft;
  let autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
  let wasPaused;
  let isTouched;
  let pausedByTouch;
  let touchStartTimeout;
  let pausedByInteraction;
  let pausedByPointerEnter;
  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
    if (e.target !== swiper.wrapperEl) return;
    swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
    if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) {
      return;
    }
    resume();
  }
  const calcTimeLeft = () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.autoplay.paused) {
      wasPaused = true;
    } else if (wasPaused) {
      autoplayDelayCurrent = autoplayTimeLeft;
      wasPaused = false;
    }
    const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - (/* @__PURE__ */ new Date()).getTime();
    swiper.autoplay.timeLeft = timeLeft;
    emit2("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
    raf = requestAnimationFrame(() => {
      calcTimeLeft();
    });
  };
  const getSlideDelay = () => {
    let activeSlideEl;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      activeSlideEl = swiper.slides.find((slideEl) => slideEl.classList.contains("swiper-slide-active"));
    } else {
      activeSlideEl = swiper.slides[swiper.activeIndex];
    }
    if (!activeSlideEl) return void 0;
    const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
    return currentSlideDelay;
  };
  const getTotalDelay = () => {
    let totalDelay = swiper.params.autoplay.delay;
    const currentSlideDelay = getSlideDelay();
    if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) {
      totalDelay = currentSlideDelay;
    }
    return totalDelay;
  };
  const run = (delayForce) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    cancelAnimationFrame(raf);
    calcTimeLeft();
    let delay = delayForce;
    if (typeof delay === "undefined") {
      delay = getTotalDelay();
      autoplayDelayTotal = delay;
      autoplayDelayCurrent = delay;
    }
    autoplayTimeLeft = delay;
    const speed = swiper.params.speed;
    const proceed = () => {
      if (!swiper || swiper.destroyed) return;
      if (swiper.params.autoplay.reverseDirection) {
        if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
          swiper.slidePrev(speed, true, true);
          emit2("autoplay");
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, speed, true, true);
          emit2("autoplay");
        }
      } else {
        if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
          swiper.slideNext(speed, true, true);
          emit2("autoplay");
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, speed, true, true);
          emit2("autoplay");
        }
      }
      if (swiper.params.cssMode) {
        autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
        requestAnimationFrame(() => {
          run();
        });
      }
    };
    if (delay > 0) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        proceed();
      }, delay);
    } else {
      requestAnimationFrame(() => {
        proceed();
      });
    }
    return delay;
  };
  const start = () => {
    autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
    swiper.autoplay.running = true;
    run();
    emit2("autoplayStart");
  };
  const stop = () => {
    swiper.autoplay.running = false;
    clearTimeout(timeout);
    cancelAnimationFrame(raf);
    emit2("autoplayStop");
  };
  const pause = (internal, reset) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    clearTimeout(timeout);
    if (!internal) {
      pausedByInteraction = true;
    }
    const proceed = () => {
      emit2("autoplayPause");
      if (swiper.params.autoplay.waitForTransition) {
        swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
      } else {
        resume();
      }
    };
    swiper.autoplay.paused = true;
    if (reset) {
      proceed();
      return;
    }
    const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
    autoplayTimeLeft = delay - ((/* @__PURE__ */ new Date()).getTime() - autoplayStartTime);
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
    if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
    proceed();
  };
  const resume = () => {
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
    autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
    if (pausedByInteraction) {
      pausedByInteraction = false;
      run(autoplayTimeLeft);
    } else {
      run();
    }
    swiper.autoplay.paused = false;
    emit2("autoplayResume");
  };
  const onVisibilityChange = () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    const document2 = getDocument();
    if (document2.visibilityState === "hidden") {
      pausedByInteraction = true;
      pause(true);
    }
    if (document2.visibilityState === "visible") {
      resume();
    }
  };
  const onPointerEnter = (e) => {
    if (e.pointerType !== "mouse") return;
    pausedByInteraction = true;
    pausedByPointerEnter = true;
    if (swiper.animating || swiper.autoplay.paused) return;
    pause(true);
  };
  const onPointerLeave = (e) => {
    if (e.pointerType !== "mouse") return;
    pausedByPointerEnter = false;
    if (swiper.autoplay.paused) {
      resume();
    }
  };
  const attachMouseEvents = () => {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.el.addEventListener("pointerenter", onPointerEnter);
      swiper.el.addEventListener("pointerleave", onPointerLeave);
    }
  };
  const detachMouseEvents = () => {
    if (swiper.el && typeof swiper.el !== "string") {
      swiper.el.removeEventListener("pointerenter", onPointerEnter);
      swiper.el.removeEventListener("pointerleave", onPointerLeave);
    }
  };
  const attachDocumentEvents = () => {
    const document2 = getDocument();
    document2.addEventListener("visibilitychange", onVisibilityChange);
  };
  const detachDocumentEvents = () => {
    const document2 = getDocument();
    document2.removeEventListener("visibilitychange", onVisibilityChange);
  };
  on("init", () => {
    if (swiper.params.autoplay.enabled) {
      attachMouseEvents();
      attachDocumentEvents();
      start();
    }
  });
  on("destroy", () => {
    detachMouseEvents();
    detachDocumentEvents();
    if (swiper.autoplay.running) {
      stop();
    }
  });
  on("_freeModeStaticRelease", () => {
    if (pausedByTouch || pausedByInteraction) {
      resume();
    }
  });
  on("_freeModeNoMomentumRelease", () => {
    if (!swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on("beforeTransitionStart", (_s, speed, internal) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (internal || !swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on("sliderFirstMove", () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
      return;
    }
    isTouched = true;
    pausedByTouch = false;
    pausedByInteraction = false;
    touchStartTimeout = setTimeout(() => {
      pausedByInteraction = true;
      pausedByTouch = true;
      pause(true);
    }, 200);
  });
  on("touchEnd", () => {
    if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
    clearTimeout(touchStartTimeout);
    clearTimeout(timeout);
    if (swiper.params.autoplay.disableOnInteraction) {
      pausedByTouch = false;
      isTouched = false;
      return;
    }
    if (pausedByTouch && swiper.params.cssMode) resume();
    pausedByTouch = false;
    isTouched = false;
  });
  on("slideChange", () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.autoplay.paused) {
      autoplayTimeLeft = getTotalDelay();
      autoplayDelayTotal = getTotalDelay();
    }
  });
  Object.assign(swiper.autoplay, {
    start,
    stop,
    pause,
    resume
  });
}
function effectInit(params) {
  const {
    effect,
    swiper,
    on,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    overwriteParams,
    perspective,
    recreateShadows,
    getEffectParams
  } = params;
  on("beforeInit", () => {
    if (swiper.params.effect !== effect) return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
    if (perspective && perspective()) {
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
    }
    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on("setTranslate _virtualUpdated", () => {
    if (swiper.params.effect !== effect) return;
    setTranslate2();
  });
  on("setTransition", (_s, duration) => {
    if (swiper.params.effect !== effect) return;
    setTransition2(duration);
  });
  on("transitionEnd", () => {
    if (swiper.params.effect !== effect) return;
    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows) return;
      swiper.slides.forEach((slideEl) => {
        slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl) => shadowEl.remove());
      });
      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on("virtualUpdate", () => {
    if (swiper.params.effect !== effect) return;
    if (!swiper.slides.length) {
      requireUpdateOnVirtual = true;
    }
    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
        setTranslate2();
        requireUpdateOnVirtual = false;
      }
    });
  });
}
function effectTarget(effectParams, slideEl) {
  const transformEl = getSlideTransformEl(slideEl);
  if (transformEl !== slideEl) {
    transformEl.style.backfaceVisibility = "hidden";
    transformEl.style["-webkit-backface-visibility"] = "hidden";
  }
  return transformEl;
}
function effectVirtualTransitionEnd({
  swiper,
  duration,
  transformElements,
  allSlides
}) {
  const {
    activeIndex
  } = swiper;
  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let transitionEndTarget;
    {
      transitionEndTarget = transformElements;
    }
    transitionEndTarget.forEach((el) => {
      elementTransitionEnd(el, () => {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        const evt = new window.CustomEvent("transitionend", {
          bubbles: true,
          cancelable: true
        });
        swiper.wrapperEl.dispatchEvent(evt);
      });
    });
  }
}
function EffectFade({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    fadeEffect: {
      crossFade: false
    }
  });
  const setTranslate2 = () => {
    const {
      slides
    } = swiper;
    const params = swiper.params.fadeEffect;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = swiper.slides[i];
      const offset = slideEl.swiperSlideOffset;
      let tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.opacity = slideOpacity;
      targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
    }
  };
  const setTransition2 = (duration) => {
    const transformElements = swiper.slides.map((slideEl) => getSlideTransformEl(slideEl));
    transformElements.forEach((el) => {
      el.style.transitionDuration = `${duration}ms`;
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements,
      allSlides: true
    });
  };
  effectInit({
    effect: "fade",
    swiper,
    on,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
const BOTTOM_SWIPER_SELECTOR = "[data-syrup-hero-bottom-swiper]";
const SYRUP_DESKTOP_MQ = "(min-width: 740px)";
const AUTOPLAY_MS = 5e3;
const REVEAL_DELAY_MS = 1e3;
const swiperInstances = /* @__PURE__ */ new WeakMap();
function syrupIsDesktop() {
  return window.matchMedia(SYRUP_DESKTOP_MQ).matches;
}
function buildBottomSwiperConfig(swiperEl) {
  var _a;
  const paginationEl = ((_a = swiperEl.closest(".ds-syrup-hero__bottom")) == null ? void 0 : _a.querySelector(".ds-syrup-hero__bottom-pagination")) ?? void 0;
  const desktop = syrupIsDesktop();
  return {
    modules: [Pagination, EffectFade, Autoplay],
    loop: false,
    speed: 350,
    autoHeight: false,
    watchOverflow: true,
    pagination: paginationEl ? {
      el: paginationEl,
      clickable: true
    } : void 0,
    effect: desktop ? "fade" : "slide",
    fadeEffect: desktop ? { crossFade: true } : void 0,
    slidesPerView: desktop ? 1 : 1.15,
    spaceBetween: desktop ? 0 : 12,
    centeredSlides: false,
    allowTouchMove: !desktop,
    autoplay: desktop ? { delay: AUTOPLAY_MS, disableOnInteraction: false, pauseOnMouseEnter: true } : false
  };
}
function setRevealed(swiperEl) {
  const bottomEl = swiperEl.closest(".ds-syrup-hero__bottom");
  if (!bottomEl) return;
  bottomEl.classList.remove("ds-syrup-hero__bottom--revealed");
  if (syrupIsDesktop()) {
    window.setTimeout(() => bottomEl.classList.add("ds-syrup-hero__bottom--revealed"), REVEAL_DELAY_MS);
  } else {
    bottomEl.classList.add("ds-syrup-hero__bottom--revealed");
  }
}
function destroyBottomSwiper(swiperEl) {
  const inst = swiperInstances.get(swiperEl);
  if (inst) {
    inst.destroy(true, true);
    swiperInstances.delete(swiperEl);
  }
}
function initBottomSwiper(swiperEl) {
  destroyBottomSwiper(swiperEl);
  const inst = new Swiper(swiperEl, buildBottomSwiperConfig(swiperEl));
  swiperInstances.set(swiperEl, inst);
  setRevealed(swiperEl);
}
function initAllBottomSwipers(root = document) {
  root.querySelectorAll(BOTTOM_SWIPER_SELECTOR).forEach((el) => initBottomSwiper(el));
}
let syrupResizeTimer = null;
window.addEventListener("resize", () => {
  window.clearTimeout(syrupResizeTimer);
  syrupResizeTimer = window.setTimeout(() => initAllBottomSwipers(), 200);
});
document.addEventListener("DOMContentLoaded", () => initAllBottomSwipers());
document.addEventListener("shopify:section:load", (event) => {
  if (event == null ? void 0 : event.target) initAllBottomSwipers(event.target);
});
(() => {
  const SECTION_SELECTOR = ".ds-syrup-hero";
  const MEDIA_SELECTOR = ".ds-syrup-hero__media--desktop";
  const DESKTOP_MQ = "(min-width: 740px)";
  const prefersReducedMotion = () => window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }
  function setupParallaxForSection(sectionEl) {
    if (!sectionEl) return;
    const mediaEl = sectionEl.querySelector(MEDIA_SELECTOR);
    if (!mediaEl) return;
    if (mediaEl.dataset.parallaxInitialized === "true") return;
    mediaEl.dataset.parallaxInitialized = "true";
    if (prefersReducedMotion()) return;
    let rafId = null;
    let isActive = false;
    let isEnabled2 = window.matchMedia(DESKTOP_MQ).matches;
    const update4 = () => {
      rafId = null;
      if (!isEnabled2 || !isActive) return;
      const rect = sectionEl.getBoundingClientRect();
      window.innerHeight || document.documentElement.clientHeight;
      const total = rect.height || 1;
      const progress = clamp((0 - rect.top) / total, 0, 1);
      const maxTranslate2 = 300;
      const translateY = Math.round(progress * maxTranslate2 * -1);
      mediaEl.style.transform = `translate3d(0, ${translateY}px, 0)`;
    };
    const requestUpdate = () => {
      if (rafId != null) return;
      rafId = window.requestAnimationFrame(update4);
    };
    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        isActive = Boolean(entry && entry.isIntersecting);
        if (isActive && isEnabled2) requestUpdate();
      },
      { root: null, threshold: 0 }
    );
    io.observe(sectionEl);
    const mq = window.matchMedia(DESKTOP_MQ);
    const onMqChange = () => {
      isEnabled2 = mq.matches;
      if (!isEnabled2) {
        mediaEl.style.transform = "";
      } else if (isActive) {
        requestUpdate();
      }
    };
    if (mq.addEventListener) {
      mq.addEventListener("change", onMqChange);
    } else {
      mq.addListener(onMqChange);
    }
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);
    if (isEnabled2) requestUpdate();
    else mediaEl.style.transform = "";
  }
  function initParallax(root = document) {
    root.querySelectorAll(SECTION_SELECTOR).forEach(setupParallaxForSection);
  }
  document.addEventListener("DOMContentLoaded", () => initParallax());
  document.addEventListener("shopify:section:load", (event) => {
    if (event == null ? void 0 : event.target) initParallax(event.target);
  });
})();
const SYRUP_PICKER_ROOT = ".syrup-picker";
function formatMoney(cents, format) {
  var _a, _b, _c;
  const fmt = format || ((_b = (_a = window.themeVariables) == null ? void 0 : _a.settings) == null ? void 0 : _b.moneyFormat) || "{{amount}}";
  if (typeof ((_c = window.themeVariables) == null ? void 0 : _c.formatMoney) === "function") {
    return window.themeVariables.formatMoney(cents, fmt);
  }
  return (cents / 100).toFixed(2);
}
function logSyrupDebug(message) {
  if (typeof console !== "undefined" && console.debug) {
    console.debug(`[syrup-picker] ${message}`);
  }
}
function convertDiscountAmountToClientCents(amount) {
  var _a, _b;
  const parsedAmount = Number(amount) || 0;
  const currencyRate = Number((_b = (_a = window == null ? void 0 : window.Shopify) == null ? void 0 : _a.currency) == null ? void 0 : _b.rate) || 1;
  return Math.round(parsedAmount * currencyRate * 100);
}
function computePriceBreakdown(config, selectedBottleVariantId, podQuantitiesByLineKey) {
  const bottle = config.bottleVariants.find(
    (v) => String(v.variantId) === String(selectedBottleVariantId)
  );
  let grossTotalCents = bottle ? bottle.price : 0;
  let totalDiscountCents = 0;
  for (const pod of config.podLines) {
    const qty = podQuantitiesByLineKey[pod.lineKey] ?? 0;
    grossTotalCents += (pod.price || 0) * qty;
    const defaultDiscount = Number(pod.defaultDiscount) || 0;
    const stepDiscount = Number(pod.stepDiscount) || 0;
    const stepDiscountCurrent = qty > 1 ? (qty - 1) * stepDiscount : 0;
    const totalDiscountAmount = defaultDiscount + stepDiscountCurrent;
    totalDiscountCents += convertDiscountAmountToClientCents(totalDiscountAmount);
  }
  const finalTotalCents = Math.max(0, grossTotalCents - totalDiscountCents);
  return { grossTotalCents, totalDiscountCents, finalTotalCents };
}
function readConfig(scriptEl) {
  var _a;
  const raw = (_a = scriptEl.textContent) == null ? void 0 : _a.trim();
  if (!raw) {
    throw new Error("Syrup picker config script is empty");
  }
  return JSON.parse(raw);
}
function initOnePicker(pickerRoot, config) {
  var _a;
  const stickyAtcRoots = pickerRoot.querySelectorAll(".syrup-picker__sticky-atc");
  const featuredProductSection = pickerRoot.closest(".ds-main-product") || document.querySelector(".ds-main-product");
  let stickyScrollTicking = false;
  const setStickyAtcVisibilityByScroll = () => {
    if (!stickyAtcRoots.length || !featuredProductSection) return;
    const sectionRect = featuredProductSection.getBoundingClientRect();
    const sectionHeight = sectionRect.height || 0;
    const hiddenSectionPart = Math.max(0, -sectionRect.top);
    const shouldShowStickyAtc = sectionHeight > 0 && hiddenSectionPart >= sectionHeight / 2;
    stickyAtcRoots.forEach((stickyRoot) => {
      stickyRoot.classList.add("is-scroll-controlled");
      const hadVisibleClass = stickyRoot.classList.contains("is-visible");
      stickyRoot.classList.toggle("is-visible", shouldShowStickyAtc);
      const hasVisibleClass = stickyRoot.classList.contains("is-visible");
      if (hadVisibleClass !== hasVisibleClass) {
        stickyRoot.classList.remove("expanded");
        stickyRoot.classList.add("collapsed");
      }
    });
  };
  const onStickyAtcScroll = () => {
    if (stickyScrollTicking) return;
    stickyScrollTicking = true;
    window.requestAnimationFrame(() => {
      setStickyAtcVisibilityByScroll();
      stickyScrollTicking = false;
    });
  };
  const priceEls = pickerRoot.querySelectorAll("[data-syrup-price]");
  const priceCompareEls = pickerRoot.querySelectorAll("[data-syrup-price-compare]");
  const stickyPriceEls = pickerRoot.querySelectorAll(
    "[data-syrup-sticky-price][data-syrup-price]"
  );
  const stickyPriceCompareEls = pickerRoot.querySelectorAll(
    "[data-syrup-sticky-price][data-syrup-price-compare]"
  );
  const atcButtons = pickerRoot.querySelectorAll("[data-syrup-atc]");
  const stickyBottleButtons = pickerRoot.querySelectorAll(
    "[data-syrup-select-variant]"
  );
  const stickyToggleButtons = pickerRoot.querySelectorAll(
    "[data-syrup-sticky-toggle]"
  );
  const bottleInputs = pickerRoot.querySelectorAll(
    ".syrup-bottle-option-input"
  );
  const deliveryNoticesScript = pickerRoot.querySelector(
    "script.syrup-picker-delivery-notices"
  );
  const deliveryNoticeBlock = pickerRoot.querySelector(
    ".syrup-picker__delivery-notice"
  );
  const deliveryNoticeTextEl = pickerRoot.querySelector(
    ".syrup-picker__delivery-notice_text"
  );
  let deliveryNoticeByVariantId = {};
  if ((_a = deliveryNoticesScript == null ? void 0 : deliveryNoticesScript.textContent) == null ? void 0 : _a.trim()) {
    try {
      deliveryNoticeByVariantId = JSON.parse(
        deliveryNoticesScript.textContent
      );
    } catch (err) {
      console.warn("[syrup-picker] Failed to parse delivery notices JSON:", err);
      deliveryNoticeByVariantId = {};
    }
  }
  const sectionScope = pickerRoot.closest(".shopify-section") ?? pickerRoot.closest("section");
  let isStickyAwaitingVariantSelection = false;
  let stickySelectedVariantId = "";
  const podQuantitiesByLineKey = {};
  const syncBottleRadiosFromVariantId = (rawVariantId) => {
    if (rawVariantId == null || rawVariantId === "") return false;
    const vid = String(rawVariantId);
    const input = Array.from(bottleInputs).find(
      (el) => String(el.dataset.variantId) === vid
    );
    if (!input) return false;
    input.checked = true;
    stickySelectedVariantId = "";
    return true;
  };
  const syncSelectedBottleToPdpVariant = (selectedVariantId, attempt = 0) => {
    var _a2;
    if (!selectedVariantId) return;
    const root = pickerRoot.closest("section") || pickerRoot.closest(".shopify-section") || document;
    const productMedia = root.querySelector("product-media[form-id]");
    const formId = (productMedia == null ? void 0 : productMedia.getAttribute("form-id")) || "";
    const carousel = productMedia == null ? void 0 : productMedia.querySelector("flickity-carousel");
    const slide2 = (_a2 = carousel == null ? void 0 : carousel.querySelector) == null ? void 0 : _a2.call(
      carousel,
      `[variant_Id="${CSS.escape(String(selectedVariantId))}"]`
    );
    if (carousel && slide2 && typeof carousel.select === "function") {
      carousel.select(`#${slide2.id}`);
    }
    const variantsEl = formId && root.querySelector(
      `product-variants[form-id="${CSS.escape(formId)}"]`
    ) || root.querySelector("product-variants");
    if (!variantsEl || typeof variantsEl.selectVariant !== "function") return;
    if (!variantsEl.product || !variantsEl.masterSelector) {
      if (attempt < 3) {
        window.setTimeout(
          () => syncSelectedBottleToPdpVariant(selectedVariantId, attempt + 1),
          50
        );
      }
      return;
    }
    try {
      variantsEl.selectVariant(Number.parseInt(selectedVariantId, 10));
    } catch (err) {
      if (attempt < 10) {
        window.setTimeout(
          () => syncSelectedBottleToPdpVariant(selectedVariantId, attempt + 1),
          50
        );
      } else {
        console.warn("[syrup-picker] Failed to sync variant after retries:", err);
      }
    }
  };
  for (const pod of config.podLines) {
    const input = pickerRoot.querySelector(
      `.syrup-picker-pods__quantity-input[data-syrup-pod-line-key="${CSS.escape(pod.lineKey)}"]`
    );
    const raw = input ? parseInt(input.value, 10) : 1;
    podQuantitiesByLineKey[pod.lineKey] = Number.isFinite(raw) && raw > 0 ? raw : 1;
  }
  const getSelectedBottleVariantId = () => {
    const checked = pickerRoot.querySelector(
      ".syrup-bottle-option-input:checked"
    );
    if (checked == null ? void 0 : checked.dataset.variantId) {
      return String(checked.dataset.variantId);
    }
    const first = bottleInputs[0];
    return (first == null ? void 0 : first.dataset.variantId) ? String(first.dataset.variantId) : "";
  };
  const getEffectiveBottleVariantId = () => String(stickySelectedVariantId || "") || getSelectedBottleVariantId();
  const syncDeliveryNoticeDom = () => {
    if (!deliveryNoticeBlock || !deliveryNoticeTextEl) return;
    if (!Object.keys(deliveryNoticeByVariantId).length) return;
    const vid = getEffectiveBottleVariantId();
    if (!vid) {
      deliveryNoticeTextEl.innerHTML = "";
      deliveryNoticeBlock.hidden = true;
      return;
    }
    const html = deliveryNoticeByVariantId[vid] ?? deliveryNoticeByVariantId[String(vid)];
    const trimmed = typeof html === "string" ? html.trim() : "";
    if (trimmed) {
      deliveryNoticeTextEl.innerHTML = html;
      deliveryNoticeBlock.hidden = false;
    } else {
      deliveryNoticeTextEl.innerHTML = "";
      deliveryNoticeBlock.hidden = true;
    }
  };
  const syncStickyBottleButtonsState = () => {
    const selectedId = String(stickySelectedVariantId || "") || getSelectedBottleVariantId();
    stickyBottleButtons.forEach((btn) => {
      const buttonVariantId = btn.getAttribute("data-syrup-select-variant") || "";
      const isSelected = String(buttonVariantId) === String(selectedId);
      btn.classList.toggle("is-selected", isSelected);
      btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });
  };
  const syncStickyPriceDom = (selectedVariantIdOverride = "") => {
    if (!stickyPriceEls.length && !stickyPriceCompareEls.length) return;
    const selectedId = String(
      selectedVariantIdOverride || stickySelectedVariantId || getSelectedBottleVariantId()
    );
    const stickyPodQuantitiesByLineKey = {};
    config.podLines.forEach((pod) => {
      stickyPodQuantitiesByLineKey[pod.lineKey] = 1;
    });
    const { grossTotalCents, finalTotalCents } = computePriceBreakdown(
      config,
      selectedId,
      stickyPodQuantitiesByLineKey
    );
    stickyPriceEls.forEach((priceEl) => {
      priceEl.textContent = formatMoney(finalTotalCents, config.moneyFormat);
      priceEl.setAttribute("data-syrup-total-cents", String(finalTotalCents));
    });
    stickyPriceCompareEls.forEach((priceCompareEl) => {
      priceCompareEl.textContent = formatMoney(grossTotalCents, config.moneyFormat);
      priceCompareEl.setAttribute(
        "data-syrup-compare-total-cents",
        String(grossTotalCents)
      );
    });
  };
  const syncPortionsPriceInlineDom = (selectedVariantIdOverride = "") => {
    const selectedId = String(
      selectedVariantIdOverride || stickySelectedVariantId || getSelectedBottleVariantId()
    );
    if (!selectedId) return;
    const variantData = pickerRoot.querySelector(
      `.portions-price-inline--variant-${CSS.escape(selectedId)}`
    );
    if (!variantData) return;
    const dataPortions = variantData.getAttribute("data-portions");
    const dataPortionsLabel = variantData.getAttribute("data-portions-label");
    const dataPricePerServing = variantData.getAttribute("data-price-per-serving");
    const dataOnly = variantData.getAttribute("data-only");
    const dataPerServing = variantData.getAttribute("data-per-serving");
    pickerRoot.querySelectorAll(".portions-price-inline__portions").forEach((el) => {
      if (dataPortions != null) {
        el.setAttribute("data-portions", dataPortions);
      }
      if (dataPortionsLabel != null) {
        el.setAttribute("data-portions-label", dataPortionsLabel);
        el.textContent = dataPortionsLabel;
      }
    });
    pickerRoot.querySelectorAll(".portions-price-inline__price").forEach((el) => {
      if (dataPricePerServing != null) {
        el.setAttribute("data-price-per-serving", dataPricePerServing);
      }
      el.setAttribute("data-only", dataOnly);
      el.setAttribute("data-per-serving", dataPerServing);
      el.textContent = `${dataOnly} ${dataPricePerServing} ${dataPerServing}`;
    });
  };
  const isPodsAvailableForQuantities = () => config.podLines.every((pod) => {
    const qty = podQuantitiesByLineKey[pod.lineKey] ?? 0;
    if (qty < 1) return true;
    return pod.available !== false;
  });
  const hasAnyAvailableBottleVariant = () => config.bottleVariants.some((variant) => variant.available !== false);
  const setStickyAtcFixedText = () => {
    atcButtons.forEach((btn) => {
      const atcFull = btn.querySelector(".syrup-picker__atc-text--full");
      const atcShort = btn.querySelector(".syrup-picker__atc-text--short");
      const bis = btn.querySelector(".syrup-picker__atc-text--bis");
      const soldout = btn.querySelector(".syrup-picker__atc-text--soldout");
      const isStickyButton = !!atcFull || !!atcShort;
      if (!isStickyButton) return;
      const showAddToCart = hasAnyAvailableBottleVariant() && isPodsAvailableForQuantities();
      const showSoldOut = !showAddToCart;
      if (atcFull) {
        atcFull.classList.toggle("is-hidden", !showAddToCart);
        atcFull.style.display = showAddToCart ? "" : "none";
      }
      if (atcShort) {
        atcShort.classList.toggle("is-hidden", !showAddToCart);
        atcShort.style.display = showAddToCart ? "" : "none";
      }
      if (bis) {
        bis.classList.add("is-hidden");
        bis.style.display = "none";
      }
      if (soldout) {
        soldout.classList.toggle("is-hidden", !showSoldOut);
        soldout.style.display = showSoldOut ? "" : "none";
      }
      btn.dataset.syrupAtcMode = showSoldOut ? "soldout" : "atc";
      btn.disabled = showSoldOut;
      if (showSoldOut) {
        btn.setAttribute("aria-disabled", "true");
      } else {
        btn.removeAttribute("aria-disabled");
      }
    });
  };
  const setAtcVisualState = (mode) => {
    atcButtons.forEach((btn) => {
      const atc = btn.querySelector(".syrup-picker__atc-text--atc");
      const atcFull = btn.querySelector(".syrup-picker__atc-text--full");
      const atcShort = btn.querySelector(".syrup-picker__atc-text--short");
      const bis = btn.querySelector(".syrup-picker__atc-text--bis");
      const soldout = btn.querySelector(".syrup-picker__atc-text--soldout");
      const isStickyButton = !!atcFull || !!atcShort;
      const showAtc = mode === "atc";
      const showBis = mode === "bis";
      const showSoldout = mode === "soldout";
      if (atc) {
        atc.classList.toggle("is-hidden", !showAtc);
        atc.style.display = showAtc ? "" : "none";
      }
      if (bis) {
        const showBisText = !isStickyButton && showBis;
        bis.classList.toggle("is-hidden", !showBisText);
        bis.style.display = showBisText ? "" : "none";
      }
      if (soldout) {
        const showSoldoutText = !isStickyButton && showSoldout;
        soldout.classList.toggle("is-hidden", !showSoldoutText);
        soldout.style.display = showSoldoutText ? "" : "none";
      }
      btn.dataset.syrupAtcMode = mode;
    });
  };
  const isKlaviyoBisAllowedForVariant = (variantId) => {
    const hiddenInput = document.querySelector("[data-hidden-klaviyo]");
    const hiddenRaw = (hiddenInput == null ? void 0 : hiddenInput.getAttribute("value")) || "";
    if (hiddenRaw) {
      const hiddenIds = String(hiddenRaw).split(",").map((s) => s.trim()).filter(Boolean);
      if (hiddenIds.includes(String(variantId))) return false;
    }
    const bottle = config.bottleVariants.find(
      (v) => String(v.variantId) === String(variantId)
    );
    if (bottle) {
      const bisRaw = bottle.showKlaviyoBis;
      const bisEnabled = bisRaw === true || bisRaw === "true" || bisRaw === 1 || bisRaw === "1";
      if (!bisEnabled) return false;
    }
    return true;
  };
  const openKlaviyoBackInStock = (selectedVariantId) => {
    syncSelectedBottleToPdpVariant(selectedVariantId);
    const clickTrigger = () => {
      var _a2, _b, _c;
      const root = document.getElementById("Klaviyo_BIS_notify_me");
      const trigger2 = (
        // PDP anchor (some templates inject the trigger inside the anchor)
        ((_a2 = root == null ? void 0 : root.querySelector) == null ? void 0 : _a2.call(root, ".klaviyo-bis-trigger")) || // Syrup picker scope (collection pages may inject outside the anchor)
        ((_b = pickerRoot == null ? void 0 : pickerRoot.querySelector) == null ? void 0 : _b.call(pickerRoot, ".klaviyo-bis-trigger")) || // Global fallback (used elsewhere in the theme)
        document.querySelector(".klaviyo-bis-trigger") || // Last resort: any actionable element inside the anchor
        ((_c = root == null ? void 0 : root.querySelector) == null ? void 0 : _c.call(root, "button, a"))
      );
      if (trigger2 && typeof trigger2.click === "function") {
        trigger2.click();
        return true;
      }
      return false;
    };
    if (clickTrigger()) return;
    window.setTimeout(() => {
      if (clickTrigger()) return;
      window.setTimeout(() => {
        if (clickTrigger()) return;
        window.setTimeout(() => clickTrigger(), 600);
      }, 250);
    }, 50);
  };
  const syncStateToDom = () => {
    const selectedId = getSelectedBottleVariantId();
    const { grossTotalCents, finalTotalCents } = computePriceBreakdown(
      config,
      selectedId,
      podQuantitiesByLineKey
    );
    priceEls.forEach((priceEl) => {
      if (priceEl.hasAttribute("data-syrup-sticky-price")) return;
      priceEl.textContent = formatMoney(finalTotalCents, config.moneyFormat);
      priceEl.setAttribute("data-syrup-total-cents", String(finalTotalCents));
    });
    priceCompareEls.forEach((priceCompareEl) => {
      if (priceCompareEl.hasAttribute("data-syrup-sticky-price")) return;
      priceCompareEl.textContent = formatMoney(
        grossTotalCents,
        config.moneyFormat
      );
      priceCompareEl.setAttribute(
        "data-syrup-compare-total-cents",
        String(grossTotalCents)
      );
    });
    syncPortionsPriceInlineDom(selectedId);
    syncDeliveryNoticeDom();
    const bottle = config.bottleVariants.find(
      (v) => String(v.variantId) === String(selectedId)
    );
    const isBottleAvailable = bottle ? bottle.available !== false : true;
    const arePodsAvailable = isPodsAvailableForQuantities();
    const isAvailable = isBottleAvailable && arePodsAvailable;
    const canUseBis = !isBottleAvailable && isKlaviyoBisAllowedForVariant(selectedId) && (!!document.getElementById("Klaviyo_BIS_notify_me") || !!pickerRoot.querySelector(".klaviyo-bis-trigger") || !!document.querySelector(".klaviyo-bis-trigger"));
    const setNonStickyButtonsDisabled = (isDisabled) => {
      atcButtons.forEach((btn) => {
        const isStickyButton = !!btn.closest(".syrup-picker__sticky-atc");
        if (isStickyButton) return;
        btn.disabled = isDisabled;
        if (isDisabled) {
          btn.setAttribute("aria-disabled", "true");
        } else {
          btn.removeAttribute("aria-disabled");
        }
      });
    };
    const mode = isAvailable ? "atc" : canUseBis ? "bis" : "soldout";
    pickerRoot.setAttribute("data-syrup-atc-state", mode);
    setAtcVisualState(mode);
    setNonStickyButtonsDisabled(mode === "soldout");
    setStickyAtcFixedText();
    syncStickyBottleButtonsState();
    syncStickyPriceDom();
  };
  const onBottleChange = () => {
    const selectedId = getSelectedBottleVariantId();
    syncStateToDom();
    syncSelectedBottleToPdpVariant(selectedId);
  };
  const onPodQtyChange = (lineKey, nextValue) => {
    const clamped = Math.min(99, Math.max(1, nextValue));
    podQuantitiesByLineKey[lineKey] = clamped;
    const input = pickerRoot.querySelector(
      `.syrup-picker-pods__quantity-input[data-syrup-pod-line-key="${CSS.escape(lineKey)}"]`
    );
    if (input) {
      input.value = String(clamped);
    }
    syncStateToDom();
  };
  bottleInputs.forEach((input) => {
    input.addEventListener("change", onBottleChange);
  });
  stickyBottleButtons.forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      const variantId = btn.getAttribute("data-syrup-select-variant");
      if (!variantId) return;
      stickySelectedVariantId = String(variantId);
      syncStickyBottleButtonsState();
      syncStickyPriceDom(stickySelectedVariantId);
      syncDeliveryNoticeDom();
      setStickyAtcFixedText();
      btn.focus();
      if (isStickyAwaitingVariantSelection) {
        isStickyAwaitingVariantSelection = false;
        await addCurrentSelectionToCart(btn.closest(".syrup-picker__sticky-atc"));
      }
    });
  });
  pickerRoot.querySelectorAll(".syrup-picker-pods__quantity-selector_button").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      var _a2;
      const action = btn.getAttribute("data-action");
      const lineKey = (_a2 = btn.closest("[data-syrup-pod-line-key]")) == null ? void 0 : _a2.getAttribute("data-syrup-pod-line-key");
      if (!lineKey || action !== "decrease" && action !== "increase")
        return;
      e.preventDefault();
      const current = podQuantitiesByLineKey[lineKey] ?? 1;
      const delta = action === "increase" ? 1 : -1;
      onPodQtyChange(lineKey, current + delta);
    });
  });
  pickerRoot.querySelectorAll(".syrup-picker-pods__quantity-input").forEach((input) => {
    input.addEventListener("change", () => {
      const lineKey = input.getAttribute("data-syrup-pod-line-key");
      if (!lineKey) return;
      const parsed = parseInt(input.value, 10);
      onPodQtyChange(lineKey, Number.isFinite(parsed) ? parsed : 1);
    });
  });
  const addCurrentSelectionToCart = async (stickyAtcRoot = null) => {
    var _a2, _b, _c, _d, _e;
    const selectedVariantId = stickyAtcRoot ? String(stickySelectedVariantId || "") : getSelectedBottleVariantId();
    const parentVariantId = parseInt(selectedVariantId, 10);
    if (!parentVariantId) {
      logSyrupDebug("Add to cart aborted: no bottle variant selected");
      return;
    }
    const bottle = config.bottleVariants.find(
      (v) => String(v.variantId) === String(parentVariantId)
    );
    const isBottleAvailable = bottle ? bottle.available !== false : true;
    const isStickyAtcAdd = !!stickyAtcRoot;
    const arePodsAvailable = config.podLines.every((pod) => {
      const qty = isStickyAtcAdd ? 1 : podQuantitiesByLineKey[pod.lineKey] ?? 0;
      if (qty < 1) return true;
      return pod.available !== false;
    });
    if (!isBottleAvailable || !arePodsAvailable) {
      logSyrupDebug(
        `Add to cart aborted: availability mismatch (bottle=${isBottleAvailable}, pods=${arePodsAvailable})`
      );
      syncStateToDom();
      return;
    }
    const syrupBundleId = String(Date.now());
    const items = [
      {
        id: parentVariantId,
        quantity: 1,
        properties: {
          _syrup_bundle_id: syrupBundleId,
          _syrup_parent: "true",
          _shopify_bundle_type: "starter_syrup"
        }
      }
    ];
    for (const pod of config.podLines) {
      const qty = isStickyAtcAdd ? 1 : podQuantitiesByLineKey[pod.lineKey] ?? 1;
      if (qty < 1) continue;
      items.push({
        id: pod.variantId,
        quantity: qty,
        parent_id: parentVariantId,
        properties: {
          _syrup_bundle_id: syrupBundleId,
          _shopify_bundle_type: "starter_syrup"
        }
      });
    }
    const cartAddUrl = `${((_b = (_a2 = window.Shopify) == null ? void 0 : _a2.routes) == null ? void 0 : _b.root) || "/"}cart/add.js`;
    atcButtons.forEach((btn) => {
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
    });
    try {
      const res = await fetch(cartAddUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
        credentials: "same-origin"
      });
      const responseJson = await res.json().catch(() => ({}));
      if (!res.ok) {
        const msg = (responseJson == null ? void 0 : responseJson.description) || (responseJson == null ? void 0 : responseJson.message) || res.statusText;
        console.error("[syrup-picker] cart/add.js error:", msg, responseJson);
        document.documentElement.dispatchEvent(
          new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: { status: "error", error: String(msg) }
          })
        );
        return;
      }
      const firstItem = ((_c = responseJson == null ? void 0 : responseJson.items) == null ? void 0 : _c[0]) ?? ((responseJson == null ? void 0 : responseJson.variant_id) ? responseJson : null);
      document.documentElement.dispatchEvent(
        new CustomEvent("variant:added", {
          bubbles: true,
          detail: { variant: firstItem }
        })
      );
      const cartBase = ((_e = (_d = window.themeVariables) == null ? void 0 : _d.routes) == null ? void 0 : _e.cartUrl) || "/cart";
      const cartUrl = cartBase.endsWith(".js") ? cartBase : `${cartBase}.js`;
      const cartRes = await fetch(cartUrl, { credentials: "same-origin" });
      const cartContent = await cartRes.json();
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: { cart: cartContent }
        })
      );
      const refreshDetail = {
        cart: cartContent,
        openMiniCart: true
      };
      if (responseJson == null ? void 0 : responseJson.sections) {
        cartContent.sections = responseJson.sections;
      }
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: refreshDetail
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: { status: "success", error: "" }
        })
      );
      logSyrupDebug(
        `Added nested bundle: parent variant ${parentVariantId}, ${items.length} line(s)`
      );
      if (stickyAtcRoot) {
        stickyAtcRoot.classList.remove("expanded");
        stickyAtcRoot.classList.add("collapsed");
        stickySelectedVariantId = "";
        syncStickyBottleButtonsState();
        syncStickyPriceDom();
        syncDeliveryNoticeDom();
      }
    } catch (err) {
      console.error("[syrup-picker] Add to cart failed:", err);
      document.documentElement.dispatchEvent(
        new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: { status: "error", error: (err == null ? void 0 : err.message) || "Network error" }
        })
      );
    } finally {
      atcButtons.forEach((btn) => {
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
      });
    }
  };
  const onAtcClick = async (e) => {
    var _a2, _b;
    e.preventDefault();
    const clickedButton = e.currentTarget;
    if (clickedButton instanceof HTMLElement && (clickedButton.dataset.syrupAtcMode === "bis" || clickedButton.getAttribute("data-syrup-atc-mode") === "bis")) {
      const selectedVariantId = ((_b = (_a2 = clickedButton.closest(SYRUP_PICKER_ROOT)) == null ? void 0 : _a2.querySelector(".syrup-bottle-option-input:checked")) == null ? void 0 : _b.getAttribute("data-variant-id")) || getSelectedBottleVariantId();
      if (selectedVariantId && isKlaviyoBisAllowedForVariant(selectedVariantId)) {
        openKlaviyoBackInStock(String(selectedVariantId));
      }
      return;
    }
    const stickyAtcRoot = clickedButton instanceof HTMLElement ? clickedButton.closest(".syrup-picker__sticky-atc") : null;
    if (stickyAtcRoot && stickyAtcRoot.classList.contains("collapsed") && !stickyAtcRoot.classList.contains("expanded")) {
      stickyAtcRoot.classList.remove("collapsed");
      stickyAtcRoot.classList.add("expanded");
      isStickyAwaitingVariantSelection = true;
      stickySelectedVariantId = "";
      syncStickyBottleButtonsState();
      return;
    }
    isStickyAwaitingVariantSelection = false;
    await addCurrentSelectionToCart(stickyAtcRoot);
  };
  atcButtons.forEach((atcButton) => {
    atcButton.addEventListener("click", onAtcClick);
  });
  stickyToggleButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const stickyAtcRoot = btn instanceof HTMLElement ? btn.closest(".syrup-picker__sticky-atc") : null;
      if (!stickyAtcRoot) return;
      const isExpanded = stickyAtcRoot.classList.contains("expanded");
      stickyAtcRoot.classList.toggle("expanded", !isExpanded);
      stickyAtcRoot.classList.toggle("collapsed", isExpanded);
    });
  });
  const scheduleSyncStateToDom = () => {
    window.setTimeout(() => syncStateToDom(), 0);
  };
  window.addEventListener("flickity:slide-changed-element-selected", (e) => {
    var _a2;
    if (!(sectionScope == null ? void 0 : sectionScope.contains(e.target))) return;
    const slide2 = (_a2 = e.detail) == null ? void 0 : _a2.selectedElement;
    const vid = (slide2 == null ? void 0 : slide2.getAttribute("variant_id")) || (slide2 == null ? void 0 : slide2.getAttribute("variant_Id"));
    if (!vid || !syncBottleRadiosFromVariantId(vid)) return;
    scheduleSyncStateToDom();
  });
  document.addEventListener("variant:changed", (e) => {
    var _a2, _b;
    const id = (_b = (_a2 = e.detail) == null ? void 0 : _a2.variant) == null ? void 0 : _b.id;
    if (id != null) syncBottleRadiosFromVariantId(id);
    scheduleSyncStateToDom();
  });
  setStickyAtcVisibilityByScroll();
  if (stickyAtcRoots.length && featuredProductSection) {
    window.addEventListener("scroll", onStickyAtcScroll, { passive: true });
    window.addEventListener("resize", onStickyAtcScroll);
  }
  syncStateToDom();
}
function initSyrupPickers() {
  const roots = document.querySelectorAll(SYRUP_PICKER_ROOT);
  roots.forEach((root) => {
    const pickerId = root.getAttribute("data-syrup-picker-id");
    if (!pickerId) {
      console.warn("[syrup-picker] Missing data-syrup-picker-id on", root);
      return;
    }
    const configEl = root.querySelector("script.syrup-picker-data");
    if (!configEl) {
      console.warn("[syrup-picker] No config script for picker", pickerId);
      return;
    }
    try {
      const config = readConfig(configEl);
      initOnePicker(root, config);
    } catch (err) {
      console.error("[syrup-picker] Init failed:", err);
    }
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSyrupPickers);
} else {
  initSyrupPickers();
}
(function initDeliveryPromise() {
  const ROOT_SELECTOR = ".custom-delivery-promise";
  const DATA_ID = "product-delivery-data";
  const HIDE_HIVE_STYLE_ID = "dpw-hide-hive-style";
  function parseProductDeliveryData() {
    const script = document.getElementById(DATA_ID);
    if (!script || !script.textContent) {
      return null;
    }
    try {
      return JSON.parse(script.textContent);
    } catch (error2) {
      return null;
    }
  }
  function getVariantDeliveryNotice(productData, variantId) {
    if (!productData || !variantId) {
      return null;
    }
    const numericVariantId = Number(variantId);
    const variant = (productData.variants || []).find((item) => Number(item.id) === numericVariantId);
    if (variant && variant.deliveryNotice) {
      return String(variant.deliveryNotice);
    }
    return productData.deliveryNotice ? String(productData.deliveryNotice) : null;
  }
  function renderPromiseText(element, noticeHtml) {
    const textNode = element.querySelector(".custom-delivery-promise__text");
    console.log("✌️textNode --->", textNode);
    if (!textNode) {
      return;
    }
    if (!noticeHtml) {
      element.setAttribute("hidden", "hidden");
      textNode.innerHTML = "";
      return;
    }
    textNode.innerHTML = noticeHtml;
    console.log("✌️noticeHtml --->", noticeHtml);
    element.removeAttribute("hidden");
  }
  function ensureHideHiveStyle() {
    if (document.getElementById(HIDE_HIVE_STYLE_ID)) {
      return;
    }
    const styleElement = document.createElement("style");
    styleElement.id = HIDE_HIVE_STYLE_ID;
    styleElement.textContent = "delivery-promise-widget { display: none !important; }";
    document.head.appendChild(styleElement);
  }
  function removeHideHiveStyle() {
    const styleElement = document.getElementById(HIDE_HIVE_STYLE_ID);
    if (styleElement) {
      styleElement.remove();
    }
  }
  function toggleHiveWidget(hasNotice) {
    if (hasNotice) {
      ensureHideHiveStyle();
      return;
    }
    removeHideHiveStyle();
  }
  function updateAllElements(nextVariantId) {
    const productData = parseProductDeliveryData();
    if (!productData) {
      return;
    }
    let hasNotice = false;
    document.querySelectorAll(ROOT_SELECTOR).forEach((element) => {
      const fallbackVariantId = element.getAttribute("data-current-variant-id");
      const variantId = nextVariantId || fallbackVariantId;
      const notice = getVariantDeliveryNotice(productData, variantId);
      if (notice) {
        hasNotice = true;
      }
      renderPromiseText(element, notice);
    });
    toggleHiveWidget(hasNotice);
  }
  document.addEventListener("variant:changed", (event) => {
    var _a, _b;
    const nextVariantId = ((_b = (_a = event == null ? void 0 : event.detail) == null ? void 0 : _a.variant) == null ? void 0 : _b.id) || null;
    updateAllElements(nextVariantId);
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      updateAllElements(null);
    });
  } else {
    updateAllElements(null);
  }
})();
function setStarterBundleCookie(key, value, daysToExpire = 1) {
  const expirationDate = /* @__PURE__ */ new Date();
  expirationDate.setTime(expirationDate.getTime() + daysToExpire * 24 * 60 * 60 * 1e3);
  document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)};expires=${expirationDate.toUTCString()};path=/`;
}
async function setStarterBundleIndexesForLineItems() {
  try {
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();
    const starterBundleItems = (cart.items || []).filter(
      (item) => item.properties && item.properties._bundle_type === "starter_powder"
    );
    for (let index = 0; index < starterBundleItems.length; index += 1) {
      const item = starterBundleItems[index];
      const newProperties = {
        ...item.properties,
        _bundle_index: index + 1
      };
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: item.key,
          properties: newProperties,
          quantity: item.quantity
        })
      });
    }
    console.log(`[Starter Bundle Quick ATC] Updated bundle indexes for ${starterBundleItems.length} item(s).`);
  } catch (error2) {
    console.error("[Starter Bundle Quick ATC] Failed to update bundle indexes:", error2);
  }
}
async function dispatchStarterBundleCartEvents(responseJson) {
  document.documentElement.dispatchEvent(
    new CustomEvent("variant:added", {
      bubbles: true,
      detail: {
        variant: responseJson.hasOwnProperty("items") ? responseJson.items[0] : responseJson
      }
    })
  );
  const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
  const cartContent = await cartResponse.json();
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:updated", {
      bubbles: true,
      detail: { cart: cartContent }
    })
  );
  cartContent.sections = responseJson.sections;
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        cart: cartContent,
        openMiniCart: true
      }
    })
  );
}
function parseStarterBundlePayload(button) {
  const mainVariantId = (button.dataset.bundleMainVariantId || "").trim();
  const rootId = (button.dataset.bundleRootId || "").trim();
  const nestedItemsTotalPriceCents = Number(button.dataset.bundleNestedTotalPrice || 0);
  let nestedVariants = [];
  try {
    nestedVariants = JSON.parse(button.dataset.bundleNestedVariants || "[]");
  } catch (error2) {
    console.error("[Starter Bundle Quick ATC] Failed to parse nested variants payload:", error2);
  }
  return {
    mainVariantId,
    nestedVariants: Array.isArray(nestedVariants) ? nestedVariants : [],
    nestedItemsTotalPriceCents: Number.isFinite(nestedItemsTotalPriceCents) ? nestedItemsTotalPriceCents : 0,
    rootId
  };
}
function buildStarterBundleCartPayload(payload) {
  const orderTimestamp = Date.now();
  const itemProperties = {
    _nestedVariantsIds: JSON.stringify(payload.nestedVariants),
    _nested_items_total_price: payload.nestedItemsTotalPriceCents,
    _bundle_type: "starter_powder",
    _bundleBuilderTimestamp: orderTimestamp
  };
  if (payload.rootId) {
    itemProperties._root_id = payload.rootId;
  }
  return {
    items: [
      {
        id: payload.mainVariantId,
        quantity: 1,
        properties: itemProperties
      }
    ]
  };
}
async function addStarterBundleViaQuickAtc(button) {
  const payload = parseStarterBundlePayload(button);
  if (!payload.mainVariantId || !payload.nestedVariants.length) {
    console.warn("[Starter Bundle Quick ATC] Missing required payload. Add to cart cancelled.");
    return;
  }
  const formData = buildStarterBundleCartPayload(payload);
  let responseJson = {};
  let requestSucceeded = false;
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    });
    responseJson = await response.json();
    requestSucceeded = response.ok;
    if (response.ok) {
      setStarterBundleCookie("bundle_added", "true", 1);
      await dispatchStarterBundleCartEvents(responseJson);
      await setStarterBundleIndexesForLineItems();
    }
    document.documentElement.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: response.ok ? "success" : "error",
          error: responseJson.description || ""
        }
      })
    );
  } catch (error2) {
    console.error("[Starter Bundle Quick ATC] Add to cart failed:", error2);
    document.documentElement.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: "error",
          error: "Failed to add starter bundle to cart."
        }
      })
    );
  } finally {
    button.removeAttribute("disabled");
    button.removeAttribute("aria-busy");
    button.classList.remove("is-loading");
    if (requestSucceeded) {
      console.log("[Starter Bundle Quick ATC] Bundle added successfully.");
    }
  }
}
function initStarterBundleQuickAtc() {
  if (window.__starterBundleQuickAtcBound) {
    return;
  }
  window.__starterBundleQuickAtcBound = true;
  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }
    const button = target.closest("[data-starter-bundle-quick-atc]");
    if (!(button instanceof HTMLElement)) {
      return;
    }
    event.preventDefault();
    if (button.hasAttribute("disabled") || button.dataset.busy === "true") {
      return;
    }
    button.dataset.busy = "true";
    button.setAttribute("disabled", "disabled");
    button.setAttribute("aria-busy", "true");
    button.classList.add("is-loading");
    addStarterBundleViaQuickAtc(button).finally(() => {
      delete button.dataset.busy;
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initStarterBundleQuickAtc);
} else {
  initStarterBundleQuickAtc();
}
(function() {
  const OPEN_DELAY = 60;
  const CLOSE_DELAY = 120;
  function init2(wrap2) {
    const trigger2 = wrap2.querySelector("[data-shop-mit-dropdown-trigger]");
    const panel = wrap2.querySelector("[data-shop-mit-dropdown-panel]");
    if (!trigger2 || !panel) return;
    let openTimer = null;
    let closeTimer = null;
    const clearTimers = () => {
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = null;
      }
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };
    let isOpen = false;
    const open = () => {
      clearTimers();
      if (isOpen) return;
      isOpen = true;
      panel.hidden = false;
    };
    const close = () => {
      clearTimers();
      if (!isOpen) return;
      isOpen = false;
      panel.hidden = true;
    };
    const supportsHover = window.matchMedia("(hover: hover)").matches;
    if (supportsHover) {
      wrap2.addEventListener("mouseenter", () => {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        openTimer = setTimeout(open, OPEN_DELAY);
      });
      wrap2.addEventListener("mouseleave", () => {
        if (openTimer) {
          clearTimeout(openTimer);
          openTimer = null;
        }
        closeTimer = setTimeout(close, CLOSE_DELAY);
      });
    }
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && isOpen) close();
    });
  }
  const start = () => {
    document.querySelectorAll("[data-shop-mit-dropdown]").forEach(init2);
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
(function() {
  function update4(variantId) {
    if (variantId == null) return;
    const blocks = document.querySelectorAll("[data-delivery-promise]");
    if (!blocks.length) return;
    blocks.forEach((block) => {
      const mapEl = block.querySelector("[data-delivery-promise-map]");
      const textEl = block.querySelector("[data-delivery-promise-text]");
      if (!mapEl || !textEl) return;
      let map;
      try {
        map = JSON.parse(mapEl.textContent);
      } catch (e) {
        return;
      }
      const idKey = String(variantId);
      const text = map[idKey] ?? map[variantId];
      if (text) {
        textEl.innerHTML = text;
        block.hidden = false;
      } else {
        block.hidden = true;
      }
    });
  }
  document.addEventListener("variant:changed", (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;
    update4(variant.id);
  });
  document.addEventListener("variant:changed:cdp", (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;
    update4(variant.id);
  });
  document.addEventListener("change", (event) => {
    const input = event.target;
    if (!input || !input.classList || !input.classList.contains("syrup-bottle-option-input")) return;
    if (!input.checked) return;
    const id = input.dataset.variantId;
    if (id) update4(id);
  });
})();
function initBundleScrollControls() {
  const inputs = document.querySelectorAll(".scroll-custom-id");
  if (!inputs.length) return;
  inputs.forEach((customInput) => {
    var _a;
    const SCROLL_AREA_ID = customInput.value;
    const scroller = document.getElementById(SCROLL_AREA_ID);
    if (!scroller) return;
    const prevBtn = document.querySelector(
      `[data-scroll-prev][aria-controls="${SCROLL_AREA_ID}"]`
    );
    const nextBtn = document.querySelector(
      `[data-scroll-next][aria-controls="${SCROLL_AREA_ID}"]`
    );
    const dotsNav = (_a = prevBtn == null ? void 0 : prevBtn.parentElement) == null ? void 0 : _a.querySelector(".dots-nav");
    const dots = dotsNav ? Array.from(dotsNav.querySelectorAll("button")) : [];
    if (!prevBtn || !nextBtn) return;
    if (scroller.__scrollInit) return;
    scroller.__scrollInit = true;
    const getItems = () => Array.from(scroller.querySelectorAll(".multi-column__item--redesign"));
    const scrollToItem = (el, index) => {
      if (!el) return;
      const targetLeft = el.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
      scroller.scrollTo({ left: targetLeft, behavior: "smooth" });
      if (dots[index]) setActiveDot(index);
    };
    const getCurrentIndex = () => {
      const items = getItems();
      let currentIndex = 0;
      let minDelta = Infinity;
      items.forEach((el, i) => {
        const delta = Math.abs(el.getBoundingClientRect().left - scroller.getBoundingClientRect().left);
        if (delta < minDelta) {
          minDelta = delta;
          currentIndex = i;
        }
      });
      return currentIndex;
    };
    const setActiveDot = (index) => {
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };
    const getNextItem = () => {
      const items = getItems();
      if (!items.length) return null;
      const leftEdge = scroller.scrollLeft + 1;
      for (let i = 0; i < items.length; i++) {
        if (items[i].offsetLeft > leftEdge) return { el: items[i], index: i };
      }
      return { el: items[items.length - 1], index: items.length - 1 };
    };
    const getPrevItem = () => {
      const items = getItems();
      if (!items.length) return null;
      const leftEdge = scroller.scrollLeft - 1;
      for (let i = items.length - 1; i >= 0; i--) {
        if (items[i].offsetLeft < leftEdge) return { el: items[i], index: i };
      }
      return { el: items[0], index: 0 };
    };
    const updateButtonsAndDots = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const left = scroller.scrollLeft;
      const eps = 2;
      prevBtn.disabled = left <= eps;
      nextBtn.disabled = left >= maxScroll - eps;
      if (dots.length) {
        const idx = getCurrentIndex();
        setActiveDot(idx);
      }
    };
    prevBtn.addEventListener("click", () => {
      const prev = getPrevItem();
      if (prev) scrollToItem(prev.el, prev.index);
    });
    nextBtn.addEventListener("click", () => {
      const next = getNextItem();
      if (next) scrollToItem(next.el, next.index);
    });
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        const items = getItems();
        if (items[i]) scrollToItem(items[i], i);
      });
    });
    scroller.addEventListener("scroll", updateButtonsAndDots, { passive: true });
    const ro = new ResizeObserver(updateButtonsAndDots);
    ro.observe(scroller);
    updateButtonsAndDots();
  });
}
document.addEventListener("DOMContentLoaded", initBundleScrollControls);
if (window.location.href.includes("holyfrance")) {
  window.location.href = "https://holyenergyfr.myshopify.com/";
}
window.theme.customEvents = customEvents;
const template = window.theme ? window.theme.template : null;
const pageType = window.theme ? window.theme.pageType : null;
const isCheckout = Shopify ? Shopify.Checkout : null;
console.log({
  template,
  pageType,
  isCheckout
});
if (template.includes("bundle-builder")) {
  const selectors2 = {
    json: "#bundle-builder-json",
    app: "#bundle-builder-app"
  };
  bundleBuilderInit(selectors2);
}
const selectors = {
  json: "#box-builder-json",
  app: "#box-builder"
};
boxBuilderMain(selectors);
